'use strict';

angular.module('workTypeList', ['ui.router', 'list-controls', 'dropdowns', 'panels', 'dudeApi', 'translate', 'dudeLog']);

/**
 * @ngdoc directive
 * @name workTypeList.work-type-form-panel
 * @restrict E
 * @description
 * Handles the sliding panel and logic for work type create/edit
 *
 * @param {object} workType a work type object to perform actions against
 * @param {boolean} panelOpen A boolean stating whether or not the sliding panel is open
 * @param {boolean} updated A boolean stating whether or not the list data should be updated
 *
 * <work-type-form panel-open="true" work-type="someWorkType" updated="false"></work-order-bulk-action>
 */

'use strict';

angular.module('workTypeList')
    .component('workTypeForm', {
        templateUrl: 'app/components/workTypeList/workTypeFormPanel/workTypeFormPanel.html',
        bindings: {
            panelOpen: '=',
            workType: '<',
            updated: '='
        },
        controller: 'WorkTypeFormPanelComponent',
        controllerAs: 'workTypeForm'
    });

angular.module('workTypeList')
    .controller('WorkTypeFormPanelComponent', function ($q, $scope, $uibModal, $translate, DudeApi, log, pmAssociationsService) {
        var self = this;

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/workTypeList/workTypeFormPanel/workTypeDeleteConfirmModal.html',
                controller: 'WorkTypeDeleteModalController',
                controllerAs: 'deleteModal',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return '';
                    },
                    workOrderTemplateCount: function () {
                        return '';
                    }
                }
            });

            return modalInstance.result.then(function () {
                return self.workType.$delete({ id: self.workType.id });
            });
        };

        var deleteWarning = function (count, templateCount) {
            $uibModal.open({
                templateUrl: 'app/components/workTypeList/workTypeFormPanel/workTypeDeleteWarningModal.html',
                controller: 'WorkTypeDeleteModalController',
                controllerAs: 'deleteModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return count;
                    },
                    workOrderTemplateCount: function () {
                        return templateCount;
                    }
                }
            });
        };

        self.$onInit = function () {
            self.panelFunctions = {
                saveFunction: function () {
                    var promise = self.workType.id ? self.workType.$update({ id: self.workType.id }) : self.workType.$save();

                    return promise.then(function () {
                        log.notify({
                            title: $translate.instant('workTypeList.notify.success.title'),
                            type: 'success',
                            message: $translate.instant('workTypeList.notify.success.message')
                        });
                        self.updated = true;
                    });
                }
            };

            $scope.$watch('workTypeForm.panelOpen', function (newVal) {
                if (!newVal) {
                    return;
                }

                var title = 'workTypeList.newWorkType';

                if (self.workType.id) {
                    title = 'workTypeList.editWorkType';

                    pmAssociationsService.isAssociated({ workType: self.workType.id }).then(function (result) {
                        self.associations = result.total;
                        self.associationsValidation = pmAssociationsService.validationMessage($translate.instant('workTypeList.workType'), self.associations);
                    });

                    self.panelFunctions.deleteFunction = function () {
                        var filter = { workType: self.workType.id, pageSize: 1 };
                        var promises = [DudeApi.WorkOrderEntity.query(filter).$promise, DudeApi.WorkOrderTemplateEntity.query(filter).$promise];

                        return $q.all(promises).then(function (results) {
                            if (results[0].total === 0 && results[1].total === 0) {
                                return $q(function (resolve, reject) {
                                    confirmDelete().then(function () {
                                        log.notify({
                                            title: $translate.instant('workTypePanel.notify.delete.title'),
                                            type: 'success',
                                            message: $translate.instant('workTypePanel.notify.delete.message')
                                        });
                                        self.updated = true;
                                        resolve();
                                    }).catch(function () {
                                        reject();
                                    });
                                });
                            }
                            return $q(function (resolve, reject) {
                                deleteWarning(results[0], results[1]);
                                reject();
                            });
                        });
                    };
                } else {
                    self.associations = null;
                    self.associationsValidation = null;
                    delete self.panelFunctions.deleteFunction;
                }
                self.panelTitles = {
                    title: $translate.instant(title)
                };
            });
        };
    });

'use strict';

angular.module('workTypeList')
    .controller('WorkTypeDeleteModalController', function ($uibModalInstance, workOrderCount, workOrderTemplateCount) {
        var self = this;

        self.workOrderCount = workOrderCount.total;
        self.workOrderTemplateCount = workOrderTemplateCount.total;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('history', ['dudeApi', 'dudeControls', 'filterHelpers', 'translate', 'helpers', 'marketizr', 'maintenanceFilters']);

/**
 * @ngdoc directive
 * @name history.workOrderHistorySummary
 * @restrict E
 * @description
 *
 * Displays the work order history summary card in the work order history list
 *
 * @param {object} activeChange The history event that is being interacted with
 * @param {object} workOrder The work order associated with the activeChange
 * @requires $state
 *
 */

'use strict';

angular.module('history')
    .component('workOrderHistorySummary', {
        templateUrl: 'app/components/workOrderHistoryList/workOrderHistorySummary/workOrderHistorySummary.html',
        bindings: {
            activeChange: '<',
            workOrder: '<'
        },
        controller: 'WorkOrderHistorySummaryController',
        controllerAs: 'workOrderHistorySummary'
    })
    .controller('WorkOrderHistorySummaryController', function ($state) {
        var self = this;

        self.goToWorkOrder = function () {
            $state.go('secure.workOrderFormEdit', { id: self.workOrder.id });
        };
    });

'use strict';

angular.module('workOrderForm', ['ui.router', 'dudeControls', 'dudeControlsFile', 'inventory-controls', 'dudeApi', 'dudeAuth', 'translate', 'workOrderInventory', 'workOrderComments', 'settingsForm', 'meterReading', 'webLinkSection', 'helpers', 'history', 'maintenanceConstants']);

/**
 * @ngdoc directive
 * @name workOrderForm.work-order-planning
 * @restrict E
 * @description
 *
 * Renders the planning section of the work order form
 *
 * @param {object} workOrder The work order object
 * @param {array} spies The array of spies used by the scroll spy
 * @param {boolean} isNew Declares whether or not this is a new work order
 * @param {boolean} isTechnician Declares whether or not the logged in user is a technician
 * @param {boolean} saveAttempt Declares whether or not an attempt to save has been made
 *
 * <work-order-planning work-order="someWorkOrder" save-attempt="false"
 *                      spies="someSpies" is-new="true" is-technician="false"></work-order-planning>
 */

'use strict';

angular.module('workOrderForm')
    .component('workOrderPlanning', {
        bindings: {
            workOrder: '=',
            spies: '=',
            isNew: '<',
            isTechnician: '<',
            saveAttempt: '<'
        },
        templateUrl: 'app/components/workOrderForm/planning/workOrderPlanning.html',
        controller: 'WorkOrderPlanningComponent',
        controllerAs: 'workOrderPlanning'
    })
    .controller('WorkOrderPlanningComponent', function ($scope, market, marketizr, permissionsHelper, permission) {
        var self = this;
        self.canAddDueDate = permissionsHelper.userAllowed(permission.users.update);

        self.$onInit = function () {
            if (self.isNew && marketizr.hasMarkets([market.k12, market.ips, market.he])) {
                $scope.$watch('workOrderPlanning.workOrder.requestDateTime', function (newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    self.workOrder.scheduledStartDate = angular.copy(self.workOrder.requestDateTime);
                });
            }
        };
    });

/**
 * @ngdoc directive
 * @name workOrderForm.work-order-details
 * @restrict E
 * @description
 *
 * Renders the detail section of the work order form
 *
 * @param {object} workOrder The work order object
 * @param {boolean} isNew Declares whether or not this is a new work order
 * @param {boolean} saveAttempt Declares whether or not an attempt to save has been made
 *
 */

'use strict';

angular.module('workOrderForm')
    .component('workOrderDetails', {
        bindings: {
            workOrder: '=',
            isNew: '<',
            saveAttempt: '<'
        },
        templateUrl: 'app/components/workOrderForm/details/workOrderDetails.html',
        controller: 'WorkOrderDetailsComponent',
        controllerAs: 'workOrderDetails'
    })
    .controller('WorkOrderDetailsComponent', function ($scope, $filter, $uibModal, DudeApi, userContext, applyAdditionalFilters, workOrderEnums, market, moment, workOrderFormHelpers, roles) {
        var self = this;
        self.allRoles = [roles.admin, roles.technician, roles.requester];
        self.rolesNoRequester = [roles.admin, roles.technician];
        self.modalType = 'repairable';
        self.applyAdditionalFiltersTo = applyAdditionalFilters;
        self.market = market;
        self.warranty = false;
        self.assetMeterPanelOpen = false;
        self.country = userContext.account.location.country;

        // priority and status values
        self.priority = workOrderEnums.priority;
        self.status = workOrderEnums.status;

        self.assetBrowseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                }
            }
        };

        self.openAssetMeterPanel = function () {
            self.assetMeterPanelOpen = !!self.workOrder.businessAsset;
        };

        var confirmChange = function (oldStatus) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/workOrderForm/details/statusChangeConfirmModal.html',
                controller: 'StatusChangeModalController',
                controllerAs: 'statusChangeModalController',
                size: 'md',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                self.workOrder.completionDateTime = null;
            }, function () {
                self.workOrder.status = oldStatus;
            });
        };

        var getAttributeEntity = function (asset, attributeTypeKey) {
            return DudeApi.BusinessAssetAttributeEntity.query({
                businessAssetId: asset.id,
                attributeTypeKey: attributeTypeKey
            });
        };

        var checkAssetAttributes = function (asset) {
            self.warranty = false;

            if (!asset) {
                return;
            }

            self.workOrder.businessAsset.businessAssetAttributeCount = 0;
            self.workOrder.businessAsset.businessAssetAttributes = [];

            // check if asset is under warranty
            getAttributeEntity(asset, 'warranty_expiration')
                .$promise.then(function (result) {
                    if (result.data.length) {
                        var warrantyAttribute = result.data;
                        var warrantyDate = warrantyAttribute[0].value;
                        if (warrantyDate && moment(warrantyDate).isSameOrAfter(new Date(), 'day')) {
                            self.warranty = true;
                        }
                    }
                });
        };

        self.$onInit = function () {
            if (!self.isNew) {
                if (self.workOrder.businessAsset) {
                    checkAssetAttributes(self.workOrder.businessAsset);
                }

                if (self.workOrder.createdByUser) {
                    self.createdBy = self.workOrder.createdByUser.firstName + ' ' + self.workOrder.createdByUser.lastName;
                }
                self.createdTime = $filter('date')(self.workOrder.createdDateTime, 'MM/dd/yyyy h:mm a');
            }

            $scope.$watch('workOrderDetails.workOrder.businessAsset', function (newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }

                checkAssetAttributes(newVal);
            });

            $scope.$watch('workOrderDetails.workOrder.status', function (newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }

                if (newVal === self.status.complete && !self.workOrder.completionDateTime) {
                    // zero out the time component if not manufacturing
                    self.workOrder.completionDateTime = workOrderFormHelpers.setToday(false);
                } else if (oldVal === self.status.complete && newVal !== self.status.complete) {
                    confirmChange(oldVal);
                }
            });
        };
    });

'use strict';

angular.module('workOrderForm')
    .controller('StatusChangeModalController', function ($uibModalInstance) {
        var self = this;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };
    });

/**
 * @ngdoc directive
 * @name workOrderForm.work-order-completion
 * @restrict E
 * @description
 *
 * Renders the completion section of the work order form
 *
 * @param {object} workOrder The work order object
 * @param {boolean} saveAttempt Declares whether or not an attempt to save has been made
 * @param {array} spies The array of spies used by the scroll spy
 *
 * <work-order-completion work-order="someWorkOrder" save-attempt="false" spies="someSpies"></work-order-completion>
 */

'use strict';

angular.module('workOrderForm')
    .component('workOrderCompletion', {
        bindings: {
            workOrder: '=',
            saveAttempt: '<',
            spies: '='
        },
        templateUrl: 'app/components/workOrderForm/completion/workOrderCompletion.html',
        controller: 'WorkOrderCompletionComponent',
        controllerAs: 'workOrderCompletion'
    })
    .controller('WorkOrderCompletionComponent', function ($scope, market, workOrderEnums) {
        var self = this;
        self.status = workOrderEnums.status;
        self.market = market;

        self.$onInit = function () {
            $scope.$watch('workOrderCompletion.workOrder.completionDateTime', function (newVal, oldVal) {
                if (newVal === oldVal || (self.workOrder.status !== self.status.complete && oldVal)) {
                    return;
                }

                self.workOrder.status = self.status.complete;
            });
        };
    });

'use strict';

angular.module('webLinkSection', ['ui.bootstrap', 'translate', 'dudeApi', 'dudeControlsConstants']);

/**
 * @ngdoc directive
 * @name webLinkSection.webLinkSlidingPanel
 * @restrict E
 * @description
 *
 * The panel will let the user add additional link items to the form
 *
 * @param {boolean} openWhen Boolean for opening and closing the panel.
 * @param {array} links Array of link objects on the form. (Optional)
 * @param {int} objectId The id of the entity the user is currently editing. Must be passed through
 *              for non-new entities, as it is used to determine if the entity is new. (Optional)
 * @param {int} linkIndex The index (in the links array) of the link that we are editing, if we
 *              are not creating a new one. Must be passed through for non-new links. (Optional)
 * @param {string} entity The entity type the link belongs to i.e workOrder, businessAsset, or pmSchedule
 *
 */

'use strict';

angular.module('webLinkSection')
    .component('webLinkSlidingPanel', {
        templateUrl: 'app/components/webLinkSection/webLinkSlidingPanel/webLinkSlidingPanel.html',
        bindings: {
            openWhen: '=',
            links: '=',
            objectId: '<?',
            linkIndex: '<?',
            entity: '@'
        },
        controller: 'WebLinkSlidingPanelController',
        controllerAs: 'webLinkSlidingPanel'
    })
    .controller('WebLinkSlidingPanelController', function ($q, $scope, $translate, $timeout, $interval, $uibModal, $element, log, DudeApi, webLinkSectionService, webLinkObjectTypeIds) {
        var self = this;
        var linkExists;
        var resetLink = function () {
            $timeout(function () {
                self.link = {};
                self.invalidUrl = false;
                self.focusOnName = false;
                self.focusOnUrl = true;
            }, 500);
        };
        var REFRESH_INTERVAL = 200;

        self.form = 'webLinkSlidingPanelForm';
        self.focusOnUrl = true;
        self.focusOnName = false;
        self.invalidUrl = false;
        self.noDataFromUrl = false;
        self.refreshingMetadata = false;

        var saveSuccessful = function () {
            log.notify({
                type: 'success',
                title: $translate.instant('webLinkSlidingPanel.notify.saved.title'),
                message: $translate.instant('webLinkSlidingPanel.notify.saved.message')
            });
        };

        var deleteSuccessful = function () {
            log.notify({
                type: 'success',
                title: $translate.instant('webLinkSection.notify.deleted.title'),
                message: $translate.instant('webLinkSection.notify.deleted.message')
            });
        };

        var errorMessage = function (title, message) {
            log.notify({
                type: 'error',
                title: title,
                message: message
            });
        };

        self.titles = { title: $translate.instant('webLinkSlidingPanel.title') };

        self.updatedUrl = function () {
            if (self.link.url && self.link.url.trim()) {
                self.form.url.$error = {};
                self.form.url.$invalid = false;
                self.invalidUrl = false;
                self.noDataFromUrl = false;
            }
        };

        self.refreshMetadata = function (fromButton) {
            if (!!self.link.url && (fromButton || self.linkIndex == null)) {
                self.focusOnName = false;
                self.focusOnUrl = false;
                self.refreshingMetadata = true;
                self.invalidUrl = false;

                DudeApi.WebLinksMetadataEntity.query({ url: self.link.url }).$promise.then(function (response) {
                    if (!response) {
                        self.noDataFromUrl = true;
                        self.link.url = null;
                        self.link.title = null;
                        self.link.description = null;
                        self.link.thumbnail = null;
                    } else {
                        response.description = response.description || '';
                        self.noDataFromUrl = !response.isFound;
                        self.link.url = response.url;
                        self.link.title = response.title;
                        self.link.description = response.description.slice(0, 512);
                        self.link.thumbnail = response.thumbnail;
                    }

                    self.focusOnName = true;
                    self.focusOnUrl = false;
                    self.refreshingMetadata = false;
                }).catch(function () {
                    self.form.url.$error.urlValidationError = true;
                    self.form.url.$invalid = true;
                    self.invalidUrl = true;
                    self.focusOnName = false;
                    self.focusOnUrl = true;
                    self.link.title = null;
                    self.link.description = null;
                    self.link.thumbnail = null;
                    self.refreshingMetadata = false;
                });
            }
        };

        self.clearThumbnail = function () {
            if (self.link) {
                self.link.thumbnail = null;
                self.form.$setDirty();
            }
        };

        self.$onInit = function () {
            var interval = null;
            self.translatedEntity = $translate.instant('webLinkSlidingPanel.' + self.entity);
            self.buttonFunctions = {
                saveFunction: function () {
                    self.link.objectType = {
                        id: webLinkObjectTypeIds[self.entity]
                    };

                    var refreshPromise = new $q(function (resolve) {
                        if (!self.refreshingMetadata) {
                            resolve();
                        } else {
                            interval = $interval(function () {
                                if (!self.refreshingMetadata) {
                                    resolve();
                                }
                            }, REFRESH_INTERVAL);
                        }
                    });

                    return refreshPromise.then(function () {
                        var exists = self.links.filter(function (link, index) {
                            return index !== self.linkIndex && link.url.toLowerCase() === self.link.url.toLowerCase();
                        }).length > 0;

                        if (exists) {
                            errorMessage($translate.instant('webLinkSlidingPanel.notify.couldNotSave'),
                                $translate.instant('webLinkSlidingPanel.notify.duplicate.message')
                            );

                            return $q.reject();
                        }

                        if (self.form.url.$invalid) {
                            return $q.reject();
                        }

                        if (interval) {
                            $interval.cancel(interval);
                        }

                        if (self.objectId) {
                            self.link.objectId = self.objectId;
                            self.link = new DudeApi.WebLinksEntity(self.link);
                            if (linkExists) {
                                return self.link.$update({ id: self.link.id }).then(function () {
                                    saveSuccessful();
                                    return webLinkSectionService.getWebLinks(self.objectId, webLinkObjectTypeIds[self.entity]).then(function (response) {
                                        self.links = response.data;
                                        resetLink();
                                        return null;
                                    });
                                });
                            }

                            return self.link.$save().then(function () {
                                saveSuccessful();
                                return webLinkSectionService.getWebLinks(self.objectId, webLinkObjectTypeIds[self.entity]).then(function (response) {
                                    self.links = response.data;
                                    resetLink();
                                    return null;
                                });
                            });
                        }

                        if (self.linkIndex != null) {
                            self.links[self.linkIndex] = angular.copy(self.link);
                            resetLink();
                            return $q.resolve();
                        }

                        self.links.push(angular.copy(self.link));
                        resetLink();
                        return $q.resolve();
                    }).catch(function () {
                        if (interval) {
                            $interval.cancel(interval);
                        }
                        return $q.reject();
                    });
                },
                saveButtonText: self.objectId ? $translate.instant('general.actions.save') : $translate.instant('general.actions.done'),
                cancelFunction: resetLink
            };

            $scope.$watch('webLinkSlidingPanel.openWhen', function (newVal) {
                if (!newVal) {
                    return;
                }

                self.noDataFromUrl = false;
                self.refreshingMetadata = false;

                if (self.linkIndex != null) {
                    self.link = angular.copy(self.links[self.linkIndex]);
                    self.buttonFunctions.deleteFunction = function () {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'app/components/webLinkSection/deleteConfirmModal.html',
                            controller: 'DeleteConfirmModalController',
                            controllerAs: 'deleteConfirmModalController',
                            size: 'sm',
                            backdrop: 'static'
                        });

                        return modalInstance.result.then(function () {
                            if (self.link.id && self.objectId) {
                                self.link = new DudeApi.WebLinksEntity(self.link);
                                return self.link.$delete({ id: self.link.id }).then(function () {
                                    deleteSuccessful();
                                    return webLinkSectionService.getWebLinks(self.objectId, webLinkObjectTypeIds[self.entity]).then(function (response) {
                                        self.links = response.data;
                                        resetLink();

                                        return null;
                                    });
                                });
                            }
                            self.links.splice(self.linkIndex, 1);

                            return null;
                        });
                    };
                } else {
                    self.link = {};
                }

                linkExists = !!self.link.id;
            });

            $element.on('$destroy', function () {
                if (interval) {
                    $interval.cancel(interval);
                }
            });
        };
    });

'use strict';

angular.module('settingsForm', ['ui.router', 'ui.bootstrap', 'ngclipboard', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog']);

/**
 * @ngdoc directive
 * @name settingsForm.registration-link
 * @restrict E
 * @description
 *
 * The form card that allows an admin to generate a new registration link and send it to their requesters
 *
 */

'use strict';

angular.module('settingsForm')
    .component('registrationLink', {
        templateUrl: 'app/components/settingsForm/registrationLink/registrationLink.html',
        bindings: {
        },
        controllerAs: 'registrationLink',
        controller: 'RegistrationLinkController'
    }).controller('RegistrationLinkController', function ($uibModal, $translate, log, DudeApi, appConfig, emailRegex) {
        var self = this;
        var securityUri = appConfig.api.security;
        self.guid = '';
        self.emails = '';
        self.badEmails = [];
        var emailRegEx = new RegExp(emailRegex);

        var buildRegistrationUrl = function (guid) {
            return securityUri + '/register/' + guid;
        };

        self.$onInit = function () {
            DudeApi.RegistrationLinkEntity.get({}).$promise
                .then(function (result) {
                    self.guid = result.registrationGuid ? buildRegistrationUrl(result.registrationGuid) : '';
                });
        };

        self.generateGuid = function () {
            DudeApi.RegistrationLinkEntity.save({}).$promise
                .then(function (result) {
                    self.guid = result.registrationGuid ? buildRegistrationUrl(result.registrationGuid) : '';
                    log.notify({
                        type: 'success',
                        title: $translate.instant('registrationLink.requesterRegistration.regenerateModal.notifyTitle'),
                        message: $translate.instant('registrationLink.requesterRegistration.regenerateModal.notifyMessage')
                    });
                });
        };

        self.regenerateGuid = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/settingsForm/registrationLink/generateNewConfirmModal.html',
                controller: 'ConfirmModalController',
                controllerAs: 'confirmModalController',
                size: 'md',
                backdrop: 'static'
            });

            return modalInstance.result.then(function () {
                self.generateGuid();
            });
        };

        self.deleteGuid = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/settingsForm/registrationLink/deleteConfirmModal.html',
                controller: 'ConfirmModalController',
                controllerAs: 'confirmModalController',
                size: 'md',
                backdrop: 'static'
            });

            return modalInstance.result.then(function () {
                DudeApi.RegistrationLinkEntity.delete({}).$promise
                    .then(function () {
                        self.guid = '';
                        log.notify({
                            type: 'success',
                            title: $translate.instant('registrationLink.requesterRegistration.deleteModal.notifyTitle'),
                            message: $translate.instant('registrationLink.requesterRegistration.deleteModal.notifyMessage')
                        });
                    });
            });
        };

        self.copyLink = function () {
            log.notify({
                type: 'success',
                title: $translate.instant('registrationLink.requesterRegistration.copyTitle'),
                message: $translate.instant('registrationLink.requesterRegistration.copyMessage')
            });
        };

        var isValidEmail = function (email) {
            return emailRegEx.test(email);
        };

        self.sendEmail = function () {
            self.badEmails = [];
            var clone = angular.copy(self.emails);
            clone = clone.replace(/ /g, ''); // remove whitespace

            var emailArray = clone.split(new RegExp('/|,|;|\n|\r/g')); // eslint-disable-line no-control-regex

            emailArray.forEach(function (email) {
                if (email.length > 0 && !isValidEmail(email)) {
                    self.badEmails.push(email);
                }
            });

            if (self.badEmails.length > 0) {
                log.notify({
                    type: 'error',
                    title: $translate.instant('registrationLink.requesterRegistration.send.notify.error.title'),
                    message: $translate.instant('registrationLink.requesterRegistration.send.notify.error.message')
                });
            } else {
                DudeApi.InviteUsersEntity.save({ emails: emailArray }).$promise
                    .then(function () {
                        log.notify({
                            type: 'success',
                            title: $translate.instant('registrationLink.requesterRegistration.send.notify.success.title'),
                            message: $translate.instant('registrationLink.requesterRegistration.send.notify.success.message')
                        });
                    });
            }
        };
    });

'use strict';

angular.module('settingsForm')
    .controller('ConfirmModalController', function ($uibModalInstance) {
        var self = this;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };
    });

/**
 * @ngdoc directive
 * @name settingsForm.account-alert-settings
 * @restrict E
 * @description
 * @requires $uibModal
 * @requires $translate
 * @requires log
 * @requires DudeApi
 * @requires userContext
 *
 * The form card that allows an admin to set alerts for different roles
 * @param {object} spies The scroll spies object to add this component's scroll spy to
 * @param {number} spyPosition The scroll spy position
 * @param {object} accountAlert The account alert retrieved from the server
 */

'use strict';

angular.module('settingsForm')
    .component('accountAlertSettings', {
        templateUrl: 'app/components/settingsForm/accountAlertSettings/accountAlertSettings.html',
        bindings: {
            spies: '=',
            spyPosition: '@',
            accountAlert: '='
        },
        controllerAs: 'accountAlertSettings',
        controller: 'AccountAlertSettingsController'
    }).controller('AccountAlertSettingsController', function ($uibModal, $translate, log, DudeApi, userContext) {
        var self = this;

        var originalAlert = {};

        self.alertIsActive = false;
        self.isEditing = false;

        self.excludeItems = { property: 'roleName', items: ['CSC'] };

        self.postText = $translate.instant('accountAlertSettings.buttons.post');

        self.post = function () {
            DudeApi.AccountAlertsEntity.save(self.accountAlert).$promise
            .then(function (alert) {
                self.isEditing = false;
                self.alertIsActive = true;
                self.accountAlert = alert;
                log.notify({
                    type: 'success',
                    title: $translate.instant('accountAlertSettings.notifications.post.success.title'),
                    message: $translate.instant('accountAlertSettings.notifications.post.success.message')
                });
            }, function (error) {
                log.notify({
                    type: 'error',
                    title: $translate.instant('accountAlertSettings.notifications.post.failure.title'),
                    message: error
                });
            });
        };

        self.delete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/settingsForm/accountAlertSettings/deleteConfirmModal.html',
                controller: 'ConfirmModalController',
                controllerAs: 'confirmModalController',
                size: 'md',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                DudeApi.AccountAlertsEntity.delete(self.accountAlert).$promise
                .then(function () {
                    self.alertIsActive = false;
                    self.accountAlert = {
                        message: '',
                        roles: []
                    };
                    log.notify({
                        type: 'success',
                        title: $translate.instant('accountAlertSettings.notifications.delete.success.title'),
                        message: $translate.instant('accountAlertSettings.notifications.delete.success.message')
                    });
                }, function (error) {
                    log.notify({
                        type: 'error',
                        title: $translate.instant('accountAlertSettings.notifications.delete.failure.title'),
                        message: error
                    });
                });
            });
        };

        self.mapJoinRoles = function () {
            return self.accountAlert.roles.map(function (role) {
                return role.roleName;
            }).join(', ');
        };

        self.edit = function () {
            originalAlert = angular.copy(self.accountAlert);
            self.isEditing = true;
        };

        self.cancelEdit = function () {
            self.accountAlert = angular.copy(originalAlert);
            self.isEditing = false;
        };

        self.$onInit = function () {
            self.alertIsActive = self.accountAlert.message !== '';

            var currentProduct = Object.keys(userContext.products).filter(function (product) {
                return userContext.products[product].currentProduct;
            })[0];

            self.productId = userContext.products[currentProduct].id;
        };
    });

'use strict';

angular.module('filterBar', ['translate', 'dudeControls', 'helpers']);

/**
 * @ngdoc directive
 * @name filterBar.sliding-filter-panel
 * @restrict E
 * @description
 *
 * Wraps the sliding and filter panels
 *
 * @param {object} filters stores the value of all defined filters
 * @param {function} setFunction function reference to set the filters
 * @param {boolean} openWhen Determines when sliding panel should open
 * @param {function} clearFunction function reference to handle the clear action
 * @param {boolean} disableMyFilters disables the ability to save custom filters (optional)
 */

'use strict';

angular.module('filterBar')
    .component('slidingFilterPanel', {
        templateUrl: 'app/components/filter-bar/sliding-filter-panel/sliding-filter-panel.html',
        transclude: true,
        bindings: {
            filters: '=',
            setFunction: '&',
            openWhen: '=',
            clearFunction: '&',
            disableMyFilters: '<?'
        },
        controller: 'SlidingFilterPanelController',
        controllerAs: 'slidingFilterPanel'
    })
    .controller('SlidingFilterPanelController', function ($filter, $scope, $q, $translate, $uibModal, filterStateService, log, slidingPanelSaveVariables, savedFiltersService, slidingPanelCloseService) {
        var self = this;

        var setFiltersTemp = function () {
            self.filtersTemp = {
                name: (self.filterState.activeSavedFilter) ? self.filterState.activeSavedFilter.name : '',
                query: angular.copy(self.filters)
            };
        };

        var setFiltersBack = function () {
            if (self.filtersTemp) {
                self.setFunction({
                    value: self.filtersTemp,
                    save: false
                });
            }
        };

        var closePanel = function () {
            slidingPanelCloseService.closeSinglePanel(self.randomPanelName, true);
        };

        var openReviewPanelNew = function () {
            self.savedFiltersReviewNew = true;
            self.savedFiltersReviewOpen = true;
        };

        var openReviewPanelUpdate = function () {
            self.savedFiltersReviewNew = false;
            self.savedFiltersReviewOpen = true;
        };

        var applyNoSave = function () {
            var newFilters = angular.copy(self.filters);
            delete newFilters.filterId;
            self.setFunction({
                value: { query: newFilters },
                save: false
            });
            closePanel();
        };

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/filter-bar/saved-filters/saved-filter-delete-confirmation-modal.html',
                controller: 'savedFilterDeleteModalController',
                size: 'sm',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                savedFiltersService.deleteSavedFilter().then(function () {
                    log.notify({
                        title: $translate.instant('slidingFilterPanel.notify.delete.title'),
                        type: 'success',
                        message: $translate.instant('slidingFilterPanel.notify.delete.message')
                    });
                    self.clearFunction({ removeMyFilter: true });
                    closePanel();
                });
            });
        };

        self.$onInit = function () {
            self.filterState = filterStateService.state;

            var noAppliedSavedFilterButtons = {
                primary: {
                    label: $translate.instant('slidingFilterPanel.apply'),
                    handler: closePanel
                },
                secondary: [
                    {
                        label: $translate.instant('slidingFilterPanel.saveAsNewFilter'),
                        handler: openReviewPanelNew,
                        separator: false
                    }
                ]
            };
            var appliedSavedFilterButtons = {
                primary: {
                    label: $translate.instant('slidingFilterPanel.saveAndApply'),
                    handler: openReviewPanelUpdate
                },
                secondary: [
                    {
                        label: $translate.instant('slidingFilterPanel.applyFilterWithoutSaving'),
                        handler: applyNoSave,
                        separator: false
                    },
                    {
                        label: $translate.instant('slidingFilterPanel.saveAsNewFilter'),
                        handler: openReviewPanelNew,
                        separator: false
                    },
                    {
                        label: $translate.instant('slidingFilterPanel.deleteFilter'),
                        handler: confirmDelete,
                        separator: true
                    }
                ]
            };

            setFiltersTemp();

            self.slidingButtons = self.disableMyFilters ? {
                saveFunction: function () {
                    return $q.resolve();
                },
                saveButtonText: $translate.instant('slidingFilterPanel.apply'),
                cancelFunction: setFiltersBack
            } : {
                forceTransclude: true,
                cancelFunction: setFiltersBack
            };

            self.myFiltersSlidingButtons = {
                panelOne: {
                    splitButtons: self.filtersTemp.query.filterId ? appliedSavedFilterButtons : noAppliedSavedFilterButtons,
                    cancelButton: {
                        label: $translate.instant('slidingFilterPanel.cancel'),
                        handler: function () {
                            setFiltersBack();
                            closePanel();
                        }
                    }
                },
                panelTwo: {
                    saveButton: {
                        label: $translate.instant('slidingFilterPanel.saveAndApply'),
                        handler: function (filtersToSave) {
                            return savedFiltersService.setSavedFilter(filtersToSave.name, filtersToSave.query).then(function (result) {
                                log.notify({
                                    title: $translate.instant('slidingFilterPanel.notify.success.title'),
                                    type: 'success',
                                    message: $translate.instant('slidingFilterPanel.notify.success.message')
                                });
                                self.setFunction({
                                    value: result.value,
                                    save: true
                                });
                                return slidingPanelSaveVariables.closeAll;
                            });
                        }
                    },
                    backButton: {
                        label: $translate.instant('slidingFilterPanel.back'),
                        handler: function () {
                            return true;
                        }
                    }
                }
            };

            self.displayResultsCount = typeof self.filterState.totalCount !== 'undefined';

            $scope.$watch('slidingFilterPanel', function (newVal, oldVal) {
                if (!self.disableMyFilters && newVal.filters.filterId !== oldVal.filters.filterId) {
                    self.myFiltersSlidingButtons.panelOne.splitButtons = newVal.filters.filterId ? appliedSavedFilterButtons : noAppliedSavedFilterButtons;
                }
                if (newVal.openWhen !== oldVal.openWhen && newVal.openWhen) {
                    setFiltersTemp();
                }
            }, true);
        };
    });

/**
 * @ngdoc directive
 * @name filterBar.savedFiltersReview
 * @restrict E
 * @description
 *
 * provides form for saving or updating a saved filter
 *
 * @param {object} filters the filters
 * @param {object} buttons the object used to construct the buttons for sliding panel
 * @param {boolean} isNewFilter indicates whether or not a new saved filter should be created
 * @param {boolean} openWhen Determines when sliding panel should open
 **/

'use strict';

angular.module('filterBar')
    .component('savedFiltersReview', {
        templateUrl: 'app/components/filter-bar/saved-filters/saved-filters-review.html',
        bindings: {
            filters: '=',
            buttons: '<',
            isNewFilter: '<',
            openWhen: '='
        },
        controller: 'savedFiltersReviewController',
        controllerAs: 'savedFiltersReview'
    })
    .controller('savedFiltersReviewController', function ($scope, $translate, filterStateService) {
        var self = this;

        self.titles = {
            title: $translate.instant('savedFilters.review.title')
        };

        self.filtersToSave = {};

        self.$onInit = function () {
            self.filterState = filterStateService.state;
            self.buttonFunctions = {
                saveFunction: function () {
                    return self.buttons.saveButton.handler(self.filtersToSave);
                },
                saveButtonText: self.buttons.saveButton.label,
                cancelFunction: self.buttons.backButton.handler,
                cancelButtonText: self.buttons.backButton.label
            };

            $scope.$watch('savedFiltersReview.openWhen', function (newVal) {
                if (!newVal) {
                    return;
                }

                self.filtersToSave = {
                    name: (self.filterState.activeSavedFilter) ? self.filterState.activeSavedFilter.name : '',
                    query: angular.copy(self.filters)
                };

                if (self.isNewFilter) {
                    delete self.filtersToSave.query.filterId;
                    delete self.filtersToSave.name;
                }
            });
        };
    });

'use strict';

angular.module('filterBar')
    .controller('savedFilterDeleteModalController', function ($uibModalInstance, $scope) {
        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

/**
* @ngdoc directive
* @name filterBar.myFiltersButton
* @restrict E
* @description
*
* Displays a list of saved filters for a user
*
* @param {string} name of the button component - no visual manifestation (optional)
* @param {string} title of the button component - no visual manifestation (optional)
* @param {object} filters the filters
* @param {function} filterHandler function reference to handle the filter application (optional)
* @param {function} clearFunction function reference to handle the close action (optional)
* @param {function} toggleFiltersFunction function reference to toggle the edit current filters view (optional)
* @param {string} popBoxName text which is applied to the menu container
**/

'use strict';

angular.module('filterBar')
.component('myFiltersButton', {
    templateUrl: 'app/components/filter-bar/my-filters-button/my-filters-button.html',
    bindings: {
        name: '@?',
        title: '@?',
        filters: '<',
        filterHandler: '&?',
        clearFunction: '&?',
        toggleFiltersFunction: '&?',
        popBoxName: '@'
    },
    controller: 'myFiltersButtonController',
    controllerAs: 'myFiltersButton'
})
.controller('myFiltersButtonController', function ($scope, filterStateService, popBoxService) {
    var self = this;
    self.POPBOX_ELEMENT = null;

    var setPopBox = function () {
        self.POPBOX_ELEMENT = self.POPBOX_ELEMENT || angular.element('[name="' + self.popBoxName + '"]');
    };

    self.popBoxToggle = function () {
        setPopBox();
        if (angular.element(self.POPBOX_ELEMENT).hasClass('pop-box-open')) {
            popBoxService.close(self.popBoxName);
            return;
        }
        popBoxService.open(self.popBoxName);
    };

    self.setActiveFilter = function (value) {
        self.filterHandler({ activeSavedFilter: value });
        popBoxService.close(self.popBoxName);
    };

    self.setEditingFilter = function (value) {
        self.setActiveFilter(value);
        self.toggleFiltersFunction();
    };

    self.clearFilters = function () {
        self.clearFunction();
        popBoxService.close(self.popBoxName);
    };

    self.isActiveFilter = function (id) {
        return self.filters.filterId && self.filters.filterId === id;
    };

    self.$onInit = function () {
        self.filterState = filterStateService.state;
        self.POPBOX_ELEMENT = self.POPBOX_ELEMENT || setPopBox();
    };
});

/**
* @ngdoc directive
* @name filterBar.filter-actions-button
* @restrict E
* @description
*
* Displays a menu element which provides actions available for a given view
*
* @param {string} name of the filter-actions-button element - does not manifest visually (optional)
* @param {string} title of the filter-actions-button element - does not manifest visually (optional)
* @param {function} clearFunction function reference to handle the clear action (optional)
* @param {function} toggleFiltersFunction function reference to toggle the edit current filters view (optional)
**/

'use strict';

angular.module('filterBar')
.component('filterActionsButton', {
    templateUrl: 'app/components/filter-bar/filter-actions-button/filter-actions-button.html',
    bindings: {
        name: '@?',
        title: '@?',
        clearFunction: '&?',
        toggleFiltersFunction: '&?'
    },
    transclude: true,
    controller: 'filterActionsButtonController',
    controllerAs: 'filterActionsButton'
})
.controller('filterActionsButtonController', function () {
});

'use strict';

angular.module('dashboard', ['ui.router', 'dudeAuth', 'dudeControls', 'dudeControlsCharts', 'dudeApi', 'translate', 'workOrderFilters', 'purposeReport', 'assetReport', 'maintenanceConstants']);

/**
 * @ngdoc directive
 * @restrict E
 * @name dashboard.mfg-admin-dashboard
 * @description
 *
 * The mfg admin dashboard
 *
 *
 * <mfg-admin-dashboard></mfg-admin-dashboard>
 *
 */

'use strict';

angular.module('dashboard')
    .component('mfgAdminDashboard', {
        templateUrl: 'app/components/dashboard/mfgAdmin/mfgAdminDashboard.html',
        controller: 'MfgAdminDashboardController',
        controllerAs: 'mfgAdminDashboard',
        bindings: {}
    })
    .controller('MfgAdminDashboardController', function ($state, $translate, workOrderEnums, userContext, workOrderFilters, dashboardService, purposeReportService) {
        var self = this;
        var endOfDayYesterday = workOrderFilters.setEndOfDayYesterday();

        var range = dashboardService.last30Days();
        var purposeChartFilters = {
            requestDateFrom: range.startDate.toISOString(),
            requestDateTo: range.endDate.toISOString(),
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete, workOrderEnums.status.onHold]
        };

        self.assigneeListRoute = function (id) {
            $state.go('secure.workOrderList', { assignees: id });
        };

        self.$onInit = function () {
            self.completedChart = true;

            self.queries = {
                newRequest: {
                    status: workOrderEnums.status.newRequest
                },
                unassigned: {
                    status: workOrderEnums.status.newRequest,
                    unassigned: workOrderEnums.assignees.unassigned
                },
                assignedToMe: {
                    status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.onHold],
                    assignees: userContext.user.id
                },
                overdue: {
                    status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.onHold],
                    dueDateTo: endOfDayYesterday,
                    scheduledEndDateTo: endOfDayYesterday,
                    orderBy: 'DueDateTime asc'
                }
            };

            self.purposeChartLabels = {
                title: $translate.instant('purposeReports.workOrdersBy'),
                yAxis: $translate.instant('reports.byWorkOrders.numberOf')
            };

            self.purposeChartData = {
                dataArray: [['', ''], ['', { v: 0 }]]
            };

            self.purposeChartData = purposeReportService.workOrderChartData(purposeChartFilters, [], self.purposeChartLabels);

            self.purposeFunctionObject = {
                chartFunction: function (id) {
                    var filtersCopy = angular.copy(purposeChartFilters);
                    delete filtersCopy.orderBy;
                    filtersCopy.purpose = id;
                    $state.go('secure.workOrderList', filtersCopy);
                }
            };

            self.compliance = {};

            dashboardService.getOnTimeRatio().$promise.then(function (entity) {
                if ((entity.onTime + entity.overDue) > 0) {
                    self.compliance = {
                        dataArray: [
                            ['', '', '', ''],
                            ['On time', { v: entity.onTime }, '', { v: entity.overDue }]
                        ],
                        idArray: [
                            1
                        ]
                    };
                } else {
                    self.completedChart = false;
                }
            });

            dashboardService.getAssigneesSummary().$promise.then(function (results) {
                self.assigneesSummary = results.data;
            });
        };
    });

/**
 * @ngdoc directive
 * @restrict E
 * @name dashboard.k12-tech-dashboard
 * @description
 *
 * The k12 tech dashboard
 *
 *
 * <k12-tech-dashboard></k12-tech-dashboard>
 *
 */

'use strict';

angular.module('dashboard')
    .component('k12TechDashboard', {
        templateUrl: 'app/components/dashboard/k12Tech/k12TechDashboard.html',
        controller: 'K12TechDashboardController',
        controllerAs: 'k12TechDashboard'
    })
    .controller('K12TechDashboardController', function ($translate, $q, $state, userContext, workOrderEnums, dashboardService, purposeReportService, assetReportService, assetWorkTypeReportService) {
        var self = this;
        var todaysDate = new Date().toISOString();
        var TOP_RESULTS = 5; // Number of top results that come back from the API.
        var STATUSES = [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.onHold];
        var purposeChartFilters = {
            status: STATUSES,
            assignees: userContext.user.id
        };
        // 0th element of the graph arrays.
        var dataArrayZero = [$translate.instant('dashboard.workType'), $translate.instant('dashboard.count')];
        var setupWorkTypeCharts = function () {
            self.assetReports.forEach(function (assetReport) {
                var assetId = assetReport.asset.id;
                self.assetTotals[assetId] = assetReport.count.workOrders;
                var dataArray = [dataArrayZero];
                var idArray = [];

                assetReport.workTypeReports.forEach(function (workTypeReport, index) {
                    dataArray.push([workTypeReport.workType.name, { v: workTypeReport.count, id: workTypeReport.workType.id }]);
                    idArray.push(index + 1); // element 0 is the title of the graph, so we're starting at 1
                    self.workTypeClickFunctions[assetId] = {
                        chartFunction: function (id) {
                            $state.go('secure.workOrderList', { businessAsset: assetId, workType: self.workTypeChartData[assetId].dataArray[id][1].id, status: STATUSES });
                        }
                    };
                });

                self.workTypeChartData[assetId] = {
                    idArray: idArray,
                    dataArray: dataArray,
                    resolved: true
                };
            });
        };

        self.moreThanFive = false;

        self.$onInit = function () {
            self.assetTotals = {};
            self.workTypeChartData = {};
            self.workTypeClickFunctions = {};
            self.assetReports = [];

            var assetReportQuery = {
                assetRollUp: null,
                pageSize: TOP_RESULTS,
                orderBy: 'Count/WorkOrders desc',
                assignees: userContext.user.id,
                status: STATUSES
            };
            var workTypeReportQuery = {
                orderBy: 'Count desc',
                status: STATUSES,
                assignees: userContext.user.id
            };
            var promises = [];

            assetReportService.getData(assetReportQuery).then(function (response) {
                self.assetReports = response.data;
                self.moreThanFive = response.total > 5;
                self.assetReports.forEach(function (assetReport) {
                    promises.push(assetWorkTypeReportService.getData(workTypeReportQuery, assetReport.asset.id));
                });

                $q.all(promises).then(function (results) {
                    // $q.all will keep the promises array in the order it was created and not
                    // necessarily in the order that the promises were resolved.
                    self.assetReports.forEach(function (assetReport, index) {
                        assetReport.workTypeReports = results[index].data;
                    });

                    setupWorkTypeCharts();
                });
            });
        };

        self.queries = {
            emergenciesAssignedToMe: {
                status: STATUSES,
                assignees: userContext.user.id,
                priority: workOrderEnums.priority.emergency
            },
            emergenciesUnassigned: {
                status: STATUSES,
                priority: workOrderEnums.priority.emergency,
                assignees: 'all',
                unassigned: workOrderEnums.assignees.unassigned
            },
            assignedToMe: {
                status: STATUSES,
                assignees: userContext.user.id
            },
            allWorkOrders: {
                status: STATUSES,
                assignees: 'all'
            },
            dueNextSevenDays: {
                status: STATUSES,
                assignees: userContext.user.id,
                dueDateFrom: todaysDate,
                dueDateTo: dashboardService.getSevenDaysFromNow()
            },
            overdue: {
                status: STATUSES,
                assignees: userContext.user.id,
                dueDateTo: todaysDate,
                orderBy: 'DueDateTime asc'
            }
        };

        self.purposeChartLabels = {
            title: $translate.instant('purposeReports.workOrdersBy'),
            yAxis: $translate.instant('reports.byWorkOrders.numberOf')
        };

        self.purposeChartData = {
            dataArray: [['', ''], ['', { v: 0 }]]
        };

        self.purposeChartData = purposeReportService.workOrderChartData(purposeChartFilters, [], self.purposeChartLabels);

        self.purposeFunctionObject = {
            chartFunction: function (id) {
                var filtersCopy = angular.copy(purposeChartFilters);
                delete filtersCopy.orderBy;
                filtersCopy.purpose = id;
                $state.go('secure.workOrderList', filtersCopy);
            }
        };
    });

/**
 * @ngdoc directive
 * @restrict E
 * @name dashboard.k12-admin-dashboard
 * @description
 *
 * The k12 admin dashboard
 *
 *
 * <k12-admin-dashboard></k12-admin-dashboard>
 *
 */

'use strict';

angular.module('dashboard')
    .component('k12AdminDashboard', {
        templateUrl: 'app/components/dashboard/k12Admin/k12AdminDashboard.html',
        controller: 'K12AdminDashboardController',
        controllerAs: 'k12AdminDashboard'
    })
    .controller('K12AdminDashboardController', function ($translate, $q, $state, userContext, workOrderEnums, workOrderFilters, dashboardService, statusReportService, assetReportService, assetWorkTypeReportService) {
        var self = this;
        var STATUSES = [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.onHold];
        var TOP_RESULTS = 5; // Number of top results that come back from the API.

        self.newRequests = $translate.instant('dashboard.newRequests');
        self.inProgress = $translate.instant('dashboard.inProgress');
        self.onHold = $translate.instant('dashboard.onHold');

        var dataArrayZero = [$translate.instant('dashboard.workType'), $translate.instant('dashboard.count')];
        var setupWorkTypeCharts = function () {
            self.assetReports.forEach(function (assetReport) {
                var assetId = assetReport.asset.id;
                self.assetTotals[assetId] = assetReport.count.workOrders;
                var dataArray = [dataArrayZero];
                var idArray = [];

                assetReport.workTypeReports.forEach(function (workTypeReport, index) {
                    dataArray.push([workTypeReport.workType.name, { v: workTypeReport.count, id: workTypeReport.workType.id }]);
                    idArray.push(index + 1); // element 0 is the title of the graph, so we're starting at 1
                    self.workTypeClickFunctions[assetId] = {
                        chartFunction: function (id) {
                            $state.go('secure.workOrderList', { businessAsset: assetId, workType: self.workTypeChartData[assetId].dataArray[id][1].id, status: STATUSES });
                        }
                    };
                });

                self.workTypeChartData[assetId] = {
                    idArray: idArray,
                    dataArray: dataArray,
                    resolved: true
                };
            });
        };

        var setupStatusPieChart = function () {
            var dataArray = [[$translate.instant('dashboard.status'), $translate.instant('dashboard.count')]];

            self.totalWorkOrders = 0;
            Object.keys(self.statusCounts).forEach(function (key) {
                self.totalWorkOrders += self.statusCounts[key];
                dataArray.push([key, { v: self.statusCounts[key] }]);
            });

            self.chartData = {
                // element 0 is the title of the graph, so we're starting at 1
                idArray: [1, 2, 3],
                dataArray: dataArray,
                resolved: true
            };

            self.clickFunction = {
                chartFunction: function (id) {
                    var status = null;
                    switch (self.chartData.dataArray[id][0]) {
                    case self.newRequests:
                        status = workOrderEnums.status.newRequest;
                        break;
                    case self.inProgress:
                        status = workOrderEnums.status.workInProgress;
                        break;
                    case self.onHold:
                        status = workOrderEnums.status.onHold;
                        break;
                    default:
                        status = STATUSES;
                    }

                    $state.go('secure.workOrderList', { status: status });
                }
            };
        };

        self.moreThanFive = false;

        self.$onInit = function () {
            self.assetTotals = {};
            self.workTypeChartData = {};
            self.workTypeClickFunctions = {};

            var statusReportQuery = {
                status: STATUSES
            };

            var assetReportQuery = {
                assetRollUp: null,
                pageSize: TOP_RESULTS,
                orderBy: 'Count/WorkOrders desc',
                status: STATUSES
            };
            var workTypeReportQuery = {
                orderBy: 'Count desc',
                status: STATUSES
            };
            var promises = [];

            statusReportService.getData(statusReportQuery).then(function (response) {
                self.statusCounts = {};
                self.statusCounts[self.newRequests] = 0;
                self.statusCounts[self.inProgress] = 0;
                self.statusCounts[self.onHold] = 0;

                response.data.forEach(function (status) {
                    if (status.status === workOrderEnums.status.onHold) {
                        self.statusCounts[self.onHold] = status.count;
                    } else if (status.status === workOrderEnums.status.newRequest) {
                        self.statusCounts[self.newRequests] = status.count;
                    } else if (status.status === workOrderEnums.status.workInProgress) {
                        self.statusCounts[self.inProgress] = status.count;
                    }
                });

                setupStatusPieChart();
            });

            assetReportService.getData(assetReportQuery).then(function (response) {
                self.assetReports = response.data;
                self.moreThanFive = response.total > 5;
                self.assetReports.forEach(function (assetReport) {
                    promises.push(assetWorkTypeReportService.getData(workTypeReportQuery, assetReport.asset.id));
                });
                $q.all(promises).then(function (results) {
                    // $q.all will keep the promises array in the order it was created and not
                    // necessarily in the order that the promises were resolved.
                    self.assetReports.forEach(function (assetReport, index) {
                        assetReport.workTypeReports = results[index].data;
                    });

                    setupWorkTypeCharts();
                });
            });
        };

        self.goToTotal = function () {
            $state.go('secure.workOrderList', { status: STATUSES });
        };

        self.queries = {
            assignedToMe: {
                status: STATUSES,
                assignees: userContext.user.id
            },
            unassigned: {
                status: STATUSES,
                unassigned: workOrderEnums.assignees.unassigned
            },
            dueNextSevenDays: {
                status: STATUSES,
                dueDateFrom: new Date().toISOString(),
                dueDateTo: dashboardService.getSevenDaysFromNow(),
                orderBy: 'DueDateTime asc'
            },
            overdue: {
                status: STATUSES,
                dueDateTo: workOrderFilters.setEndOfDayYesterday(),
                orderBy: 'DueDateTime asc'
            },
            emergenciesUnassigned: {
                status: STATUSES,
                priority: workOrderEnums.priority.emergency,
                unassigned: workOrderEnums.assignees.unassigned
            },
            emergencies: {
                status: STATUSES,
                priority: workOrderEnums.priority.emergency
            }
        };
    });

'use strict';

angular.module('assetReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report', 'workTypeReport']);

/**
 * @ngdoc directive
 * @name assetReport.assetReportDrilldownList
 * @restrict E
 * @description
 *
 * Displays a drill down list from a specified entity corresponding to asset
 *
 * @param {string} entity The entity to query against for drill down data.
 * @param {object} filters The filters object to query with
 * @param {array} listData The list of assets summary data
 *
 */

'use strict';

angular.module('assetReport')
    .component('assetReportDrilldownList', {
        templateUrl: 'app/components/assetReport/assetReportDrilldownList/assetReportDrilldownList.html',
        bindings: {
            entity: '<',
            filters: '<',
            listData: '<'
        },
        controller: 'AssetReportDrilldownListController',
        controllerAs: 'drilldownList'
    })
    .controller('AssetReportDrilldownListController', function ($scope, $translate, $state, DudeApi) {
        var self = this;

        var openSummaries = [];

        self.viewDetails = function (assetSummary, preserveArray) {
            var showSubList = !assetSummary.showSubList;

            if (showSubList && !assetSummary.subList) {
                var filtersCopy = angular.copy(self.filters);
                filtersCopy.businessAsset = assetSummary.asset.id;
                filtersCopy.orderBy = angular.copy(self.subListOrderBy);

                DudeApi[self.entity].query(filtersCopy).$promise.then(function (result) {
                    assetSummary.subList = result.data;
                    assetSummary.showSubList = showSubList;
                });
            } else {
                assetSummary.showSubList = showSubList;
            }

            var index = openSummaries.indexOf(assetSummary.asset.id);
            if (showSubList && index === -1) {
                openSummaries.push(assetSummary.asset.id);
            } else if (index > -1 && !preserveArray) {
                openSummaries.splice(index, 1);
            }
        };

        self.viewDrilldownWorkOrders = function (workTypeId, assetId) {
            var filtersCopy = angular.copy(self.filters);
            filtersCopy.businessAsset = assetId;
            filtersCopy.workType = workTypeId;
            filtersCopy.includeDescendants = 'true';
            delete filtersCopy.orderBy;
            delete filtersCopy.page;
            $state.go('secure.workOrderList', filtersCopy);
        };

        self.$onInit = function () {
            if (self.entity === 'WorkTypesSummaryEntity') {
                self.subListOrderBy = 'Count/WorkOrders desc,WorkType/Name asc';
                self.subListTitle = $translate.instant('reports.workType');
            } else {
                self.subListOrderBy = 'Count/WorkOrders desc,Purpose/Name asc';
                self.subListTitle = $translate.instant('reports.purposes');
            }

            $scope.$watch('drilldownList.listData', function (newVal, oldVal) {
                if (angular.equals(newVal, oldVal)) {
                    return;
                }

                newVal.forEach(function (assetSummary) {
                    if (openSummaries.indexOf(assetSummary.asset.id) > -1 && !assetSummary.subList) {
                        self.viewDetails(assetSummary, true);
                    }
                });
            }, true);
        };
    });

/**
 * @ngdoc directive
 * @name report.report-drill-down-chart
 * @restrict E
 * @description
 *
 * Displays the drill down chart
 *
 * @param {boolean} isLocation The value to determine if it is a location report or equipment report. (Optional)
 * @param {object} filters An object that contains the initial filters.
 * @param {string} chartType A string containing the type of chart it is.
 * @param {object} drillDownData An object that contains the data to be used by the parent component. (Optional)
 */

'use strict';

angular.module('assetReport')
    .component('reportDrillDownChart', {
        bindings: {
            isLocation: '<?',
            filters: '<',
            chartType: '<',
            drillDownData: '=?'
        },
        templateUrl: 'app/components/assetReport/assetReportDrillDown/reportDrillDownChart.html',
        controller: 'ReportDrillDownChartController',
        controllerAs: 'reportDrillDownChart'
    })
    .controller('ReportDrillDownChartController', function ($scope, $state, $translate, popBoxService, clientHelperService, workTypeReportService, reportFiltersService, assetReportService, assetReportCategory, responsiveBreakpoints, queryHelpers) {
        var self = this;
        self.screenSize = clientHelperService.getCurrentScreenSize();
        self.chartCategories = assetReportCategory;

        var queryDefaults = reportFiltersService.getFilters({});
        var emptyData = {
            dataArray: [['', ''], ['', { v: 0 }]]
        };
        var emptyCostData = [['', '', '', '', '', ''], ['', { v: 0 }, '', { v: 0 }, '', { v: 0 }]];
        self.drillDownCostChartData = angular.copy(emptyCostData);
        self.drillDownChartData = angular.copy(emptyData);

        var updateFilters = function () {
            var filtersCopy = angular.copy(self.filters);
            assetReportService.loadAssets(self.filters).then(function (assets) {
                if (self.chartType === self.chartCategories.cost) {
                    self.chartLabels = self.costLabels;
                    self.chartClass = 'cost-chart';
                    self.chartDisplayType = 'stacked-bar';
                    self.costLegend = [
                        $translate.instant('reports.byCost.purchase'),
                        $translate.instant('reports.byCost.service'),
                        $translate.instant('reports.byCost.labor')
                    ];
                    self.chartData = assetReportService.costChartData(filtersCopy, assets, self.costLabels);
                } else {
                    self.chartLabels = self[self.chartType + 'Labels'];
                    self.chartData = assetReportService[self.chartType + 'ChartData'](filtersCopy, assets, self.chartLabels);
                    self.chartClass = self.chartType === self.chartCategories.workOrder ? 'work-order-chart' : 'labor-hours-chart';
                }
            });
            popBoxService.close(self.drillDownPopBox);
            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.clickFunctionObject = {
            chartFunction: function (id) {
                var filtersCopy = angular.copy(self.filters);
                delete filtersCopy.orderBy;
                filtersCopy.businessAsset = [id];
                filtersCopy.includeDescendants = 'true';

                var index;
                self.activeAsset = {
                    id: id,
                    filters: angular.copy(filtersCopy)
                };

                if (self.screenSize.breakpoint <= responsiveBreakpoints.xs && angular.element('.cost-chart .active-bar')) {
                    angular.element('.cost-chart .active-bar').removeClass('active-bar');
                }

                if (self.screenSize.breakpoint <= responsiveBreakpoints.xs && angular.element('.cost-chart .mobile-bar-' + id)) {
                    angular.element('.cost-chart .mobile-bar-' + id).addClass('active-bar');
                }

                index = self.chartData.idArray.indexOf(id);
                self.activeAsset.name = self.chartData.dataArray[index + 1][0] + ' ' + $translate.instant('assetReport.workTypes');
                self.activeAsset.value = self.chartData.dataArray[index + 1][1].v;

                if (!id) {
                    popBoxService.close(self.drillDownPopBox);
                    return;
                }

                workTypeReportService.loadWorkTypes(filtersCopy).then(function (workTypes) {
                    if (self.chartType === self.chartCategories.cost) {
                        self.costLegend = [
                            $translate.instant('reports.byCost.purchase'),
                            $translate.instant('reports.byCost.service'),
                            $translate.instant('reports.byCost.labor')
                        ];
                        self.drillDownCostChartData = workTypeReportService.costChartData(filtersCopy, workTypes, self.workOrderLabels, true);
                        self.drillDownChartLabels.xAxis = $translate.instant('reports.byCost.cost');
                        self.drillDownData = self.drillDownCostChartData;
                    } else {
                        self.drillDownChartData = workTypeReportService[self.chartType + 'ChartData'](filtersCopy, workTypes, self.workOrderLabels, true);
                        self.drillDownChartLabels.xAxis = self.chartType === self.chartCategories.workOrder ? $translate.instant('reports.byWorkOrders.workOrders') : $translate.instant('reports.byCost.hours');
                        self.drillDownChartClass = self.chartType === self.chartCategories.workOrder ? 'work-order-drill-down-chart' : 'labor-drill-down-chart';
                        self.drillDownData = self.drillDownChartData;
                    }
                    self.drillDownData.name = self.activeAsset.name;
                    popBoxService.open(self.drillDownPopBox);
                });
            }
        };

        self.subChartClickObject = {
            chartFunction: function (id) {
                if (self.chartType !== self.chartCategories.workOrder) {
                    return;
                }
                var filtersCopy = angular.copy(self.filters);
                delete filtersCopy.orderBy;

                filtersCopy.businessAsset = self.activeAsset.id;
                filtersCopy.workType = id;
                filtersCopy.includeDescendants = 'true';

                $state.go('secure.workOrderList', filtersCopy);
            }
        };

        self.clearSelection = function () {
            self.chartData.clearSelection = true;
            self.drillDownChartData = angular.copy(emptyData);
            self.activeAsset = {};
            if (self.screenSize.breakpoint <= responsiveBreakpoints.xs && angular.element('.cost-chart .active-bar')) {
                angular.element('.cost-chart .active-bar').removeClass('active-bar');
            }
        };

        self.$onInit = function () {
            self.id = self.chartType + '-pop-box-' + Date.now();
            self.drillDownPopBox = 'report-drill-down-chart-' + self.chartType;

            self.filters.isLocation = self.isLocation;
            queryDefaults.isLocation = self.isLocation;

            if (self.chartType === self.chartCategories.cost) {
                self.chartData = angular.copy(emptyCostData);
                self.chartDisplayType = 'stacked-bar';
            } else {
                self.chartData = angular.copy(emptyData);
                self.chartDisplayType = 'bar';
            }

            self.costLegend = null;

            self.workOrderLabels = {
                title: $translate.instant('locationReports.workOrdersBy'),
                yAxis: $translate.instant('reports.byWorkOrders.numberOf')
            };

            self.costLabels = {
                title: $translate.instant('locationReports.costBy'),
                yAxis: $translate.instant('reports.byCost.cost')
            };

            self.laborLabels = {
                title: $translate.instant('locationReports.laborHoursBy'),
                yAxis: $translate.instant('reports.byLaborHours.hours')
            };

            self.drillDownChartLabels = {
                title: ''
            };

            $scope.$watch('reportDrillDownChart.filters', updateFilters, true);
        };
    });

'use strict';

angular.module('asset-attribute', ['dudeApi', 'ui.bootstrap', 'ngSanitize', 'quantity']);

'use strict';

angular.module('asset-attribute')
    .controller('assetStopTrackingModalController', function ($uibModalInstance, businessAssetId, pmScheduleType) {
        var self = this;

        self.pmScheduleFilter = {
            businessAssets: [businessAssetId],
            pmScheduleTypes: [pmScheduleType.METERED, pmScheduleType.MIXED]
        };

        self.close = function () {
            $uibModalInstance.dismiss('ok');
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-usage
 * @restrict E
 * @description
 *
 * Display the asset metered usage
 *
 * @param {object} asset The asset that this attribute is attached to
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 * @param {boolean} saveAttempt A flag to show if the save button has been clicked (optional)
 * @param {boolean} disableActions A flag that will hide the start/stop/cancel buttons (optional)
 * @param {boolean} showTitle A flag that will show/hide the title for the directive defaults to true (optional)
 * @param {boolean} shouldValidate A flag that indicates whether or not the field should trigger validation. defaults to false (optional)
 * @param {boolean} showPreviousValue A flag that indicates whether or not to show the previous value defaults to false (optional)
 */

'use strict';

angular.module('asset-attribute')
    .component('assetUsage', {
        templateUrl: 'app/components/assetAttributeEngine/asset-usage/asset-usage.html',
        bindings: {
            asset: '=',
            assetAttribute: '=',
            country: '@',
            saveAttempt: '=?',
            disableActions: '=?',
            showTitle: '=?',
            shouldValidate: '<?',
            showPreviousValue: '<?'
        },
        controller: 'AssetUsageController',
        controllerAs: 'assetUsage'
    })
    .controller('AssetUsageController', function ($scope, $translate, $uibModal, DudeApi, quantityCache, pmScheduleType) {
        var self = this;
        self.showTitle = self.showTitle || true;
        self.isMakingApiCall = false;

        var setTranslation = function (uom) {
            self.uom = uom && uom.unitKey ? $translate.instant('unitsOfMeasure.' + uom.unitKey) : '';
        };

        var isValidValue = function (val) {
            var arr = String(val).split('');

            if (arr.length === 1 && (arr[0] === '-' || arr[0] === '.')) {
                return false;
            }

            if (arr.length === 2 && val === '-.') {
                return false;
            }

            return true;
        };

        var loadWatchers = function () {
            $scope.$watch('assetUsage.assetAttribute.unitOfMeasure', function (newVal, oldVal) {
                if (angular.equals(newVal, oldVal) || !self.quantities) {
                    return;
                }

                var filtered = self.quantities.filter(function (val) {
                    return val.id === newVal.id;
                });
                var selected = filtered.length > 0 ? filtered[0] : null;

                setTranslation(selected);
            }, true);

            $scope.$watch('assetUsage.assetAttribute.value', function (newValue, oldValue) {
                if (!isValidValue(newValue)) {
                    return;
                }

                if (newValue.length !== 0 && isNaN(newValue)) {
                    self.assetAttribute.value = oldValue;
                }
            });
        };

        var stopTrackingWarning = function () {
            $uibModal.open({
                templateUrl: 'app/components/assetAttributeEngine/asset-usage/assetStopTrackingWarningModal.html',
                controller: 'assetStopTrackingModalController',
                controllerAs: 'assetStopTrackingModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    businessAssetId: self.asset.id
                }
            });
        };

        self.cancel = function () {
            self.assetAttribute.value = '';
            self.assetAttribute.isMetered = false;
            self.assetAttribute.unitOfMeasure = null;
        };

        self.stopTracking = function () {
            self.isMakingApiCall = true;
            DudeApi.PmScheduleEntity.query({
                businessAssets: [self.asset.id],
                pmScheduleTypes: [pmScheduleType.MIXED, pmScheduleType.METERED]
            }).$promise.then(function (result) {
                var canStopTracking = result.total === 0;

                // if there are associated PMs, ensure they are all inactive
                if (!canStopTracking) {
                    canStopTracking = result.data.filter(function (pm) {
                        return pm.isActive;
                    }).length === 0;
                }

                if (canStopTracking) {
                    self.assetAttribute.value = '';
                    self.assetAttribute.isMetered = false;
                } else {
                    stopTrackingWarning();
                }

                self.isMakingApiCall = false;
            });
        };

        self.resumeTracking = function () {
            self.assetAttribute.isMetered = true;
        };

        self.hasTransactions = function () {
            return self.assetAttribute.transactionCount > 0;
        };

        self.$onInit = function () {
            // remove the value that is on the metered asset
            if (!self.showPreviousValue) {
                self.assetAttribute.value = '';
            }

            var uom = angular.copy(self.assetAttribute.unitOfMeasure);
            setTranslation(uom);

            self.isDisplay = !self.asset.id || !(uom && uom.id);

            if (self.isDisplay) {
                quantityCache.get(self.assetAttribute.businessAssetAttributeType.quantityType.id, self.country).then(function (result) {
                    self.quantities = result;
                });
            }

            loadWatchers();

            if (self.asset.id && self.assetAttribute.id) {
                // Query for asset transactions here and set self.lastReading;
                DudeApi.BusinessAssetAttributeTransactionEntity.query({
                    businessAssetId: self.asset.id,
                    id: self.assetAttribute.id,
                    includeAudit: true,
                    pageSize: 1,
                    orderby: 'Id desc'
                }).$promise.then(function (result) {
                    self.transactions = result.data;
                });
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-integer
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of string data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 * @param {string} nullOptionText string showing the default text for the dropdown null option
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeString', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-string/asset-attribute-string.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope, element, attrs) {
                scope.nullOptionText = attrs.nullOptionText || '';
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;
                scope.hasAttributeTypeCodes = scope.attributeType.businessAssetAttributeTypeCodes.length > 0;
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-money
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of integer data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeMoney', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-money/asset-attribute-money.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope) {
                scope.assetAttribute.value = scope.assetAttribute.value.length > 0 ? parseFloat(scope.assetAttribute.value.replace(/,/g, '')) : '';
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-integer
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of integer data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeInteger', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-integer/asset-attribute-integer.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope) {
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;
                scope.$watch('assetAttribute.value', function (newValue, oldValue) {
                    var arr = String(newValue).split('');
                    if (arr.length === 0) {
                        return;
                    }
                    if (arr[arr.length - 1] === '.') {
                        scope.assetAttribute.value = oldValue;
                    }

                    // Fixes the case where a double is pasted in
                    newValue = parseInt(newValue, 10);

                    if (angular.isDefined(scope.assetAttribute) && isNaN(newValue)) {
                        scope.assetAttribute.value = oldValue;
                    }
                });
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-engine
 * @restrict E
 * @description
 *
 * Find and display correct asset attribute input type based on attribute type value type code
 *
 * @param {object} assetCategory object which drives the retrieval of base attribute types
 * @param {array} baseAttributeTypes list of types that defines the base attribute view based on the asset category
 * @param {object} assetType object which drives retrieval of extension attribute types
 * @param {array} extensionAttributeTypes list of types that defines the extension attribute view view based on the asset type
 * @param {array} assetAttributes The list of attribute instances based on the category + type pairing
 * @param {string} country string with the account's country code
 * @param {string} confirmReload callback method to parent scope
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeEngine', function ($compile, $translate, $q, DudeApi) {
        return {
            restrict: 'E',
            scope: {
                assetCategory: '=',
                baseAttributeTypes: '=',
                assetType: '=',
                extensionAttributeTypes: '=',
                assetAttributes: '=',
                country: '@',
                confirmReload: '&onChange'
            },
            link: function (scope, element) {
                scope.assetAttributeCache = {};
                var baseCacheKeyPrefix = 'base-';
                var extensionCacheKeyPrefix = 'extension-';

                var ELEMENT_PREFIX = 'asset-attribute-';
                var DEFAULT_ATTRIBUTE = {
                    value: '',
                    businessAssetAttributeType: null, // this needs to be populated when the directive renders
                    unitOfMeasure: null // this should be filled in by the directive with the first value in the list of available u of m
                };
                // Called count is used to determine if we need to create a new row in the ui
                var calledCount = 0;
                var childScope;

                var rowBegining = function (count) {
                    if (count % 2 === 0) {
                        return '<div class="row">';
                    }

                    return '';
                };

                var rowEnding = function (count) {
                    if (count % 2 !== 0) {
                        return '</div>';
                    }
                    return '';
                };

                var insertDivider = function () {
                    var appendRowEnd = rowEnding(calledCount); // checking if the row should end
                    calledCount = 0; // reseting called count to 0 to render extension attributes
                    return appendRowEnd + '<hr>'; // passing 0 to force row begin and 1 to force row end
                };

                var createDomElement = function (attribute, assetAttributeIndex) {
                    var html = '';
                    var valueType = attribute.businessAssetAttributeType.valueType.toLowerCase();
                    if (valueType === 'databound') {
                        valueType += '-' + attribute.businessAssetAttributeType.key.toLowerCase();
                    }

                    var elementName = ELEMENT_PREFIX + valueType; // Might need sanitize naming conventions.

                    html += rowBegining(calledCount);
                    html += '<' + elementName;
                    html += ' asset-attribute="assetAttributes[' + assetAttributeIndex + ']"';
                    html += ' country="' + scope.country + '"';
                    html += '></' + elementName + '>';
                    html += rowEnding(calledCount);
                    calledCount++;

                    // if there are base and extension attrs and the current item is the last base item
                    if (scope.baseAttributeCount > 0 && scope.extensionAttributeCount > 0 && (assetAttributeIndex + 1) === scope.baseAttributeCount) {
                        html += insertDivider();
                    }
                    return html;
                };

                // Compiles the html elements with angular.

                var compile = function (html) {
                    childScope = scope.$new();
                    childScope.assetAttributes = angular.copy(scope.assetAttributes);
                    childScope.country = scope.country;
                    var directives = angular.element(html);
                    element.append(directives);
                    $compile(directives)(childScope);
                    childScope.$watch('assetAttributes', function () {
                        scope.assetAttributes = childScope.assetAttributes;
                    }, true);
                };

                var sortAssetAttributeTypesByTranslatedKey = function (a, b) {
                    if (a.businessAssetAttributeType._translatedKey < b.businessAssetAttributeType._translatedKey) {
                        return -1;
                    }
                    if (a.businessAssetAttributeType._translatedKey > b.businessAssetAttributeType._translatedKey) {
                        return 1;
                    }
                    return 0;
                };

                var sortAssetAttributeTypesByOrder = function (a, b) {
                    return a.businessAssetAttributeType.order - b.businessAssetAttributeType.order;
                };

                var getByAttributeTypeKey = function (assetAttributes, value) {
                    var result = assetAttributes.filter(function (attribute) {
                        return attribute.businessAssetAttributeType.key === value;
                    });
                    return result.length > 0 ? result[0] : angular.copy(DEFAULT_ATTRIBUTE);
                };

                var setUpAttribute = function (attributeType) {
                    attributeType._translatedKey = $translate.instant('assetForm.attributeTypes.' + attributeType.key);

                    var matchingAttribute = getByAttributeTypeKey(scope.originalAttributes, attributeType.key);
                    matchingAttribute.businessAssetAttributeType = attributeType;
                    // the above filter is returning an object.  We need to ensure that the matching attribute is a Resource, so we new it.
                    return new DudeApi.BusinessAssetAttributeEntity(matchingAttribute);
                };

                var init = function () {
                    scope.originalAttributes = angular.copy(scope.assetAttributes);
                    var baseAttributes = [];
                    var extensionAttributes = [];

                    // translate keys, merge attribute instance with its type, separate base and extension attributes
                    if (angular.isDefined(scope.baseAttributeTypes)) {
                        scope.assetAttributes = [];
                        var meterable = 0;
                        angular.forEach(scope.baseAttributeTypes, function (attributeType) {
                            if (attributeType.isMeterable) {
                                meterable++;
                            }
                            attributeType.isBaseAttribute = true;
                            baseAttributes.push(setUpAttribute(attributeType));
                        });

                        if (angular.isDefined(scope.extensionAttributeTypes)) {
                            angular.forEach(scope.extensionAttributeTypes, function (attributeType) {
                                extensionAttributes.push(setUpAttribute(attributeType));
                            });
                        }
                        baseAttributes.sort(sortAssetAttributeTypesByOrder);
                        extensionAttributes.sort(sortAssetAttributeTypesByTranslatedKey);

                        scope.assetAttributes = baseAttributes.concat(extensionAttributes);
                        scope.baseAttributeCount = baseAttributes.length - meterable;
                        scope.extensionAttributeCount = extensionAttributes.length;
                    }

                    var directivesHtml = '';

                    angular.forEach(scope.assetAttributes, function (attribute, attributeIndex) {
                        // skip meterable attribute types
                        if (attribute.businessAssetAttributeType.isMeterable) {
                            return;
                        }

                        directivesHtml += createDomElement(attribute, attributeIndex);
                    });

                    // Clean up incase needed
                    directivesHtml += rowEnding(calledCount);

                    compile(directivesHtml);
                };

                var isValid = function (object) {
                    return angular.isDefined(object) && angular.isObject(object) && object !== null && object.id;
                };

                var resetChildScope = function () {
                    if (childScope) {
                        childScope.$destroy();
                    }
                    element.empty();
                    calledCount = 0;
                    init();
                };

                var filterAttributes = function (isCategory) {
                    return scope.assetAttributes.filter(function (attr) {
                        return isCategory === attr.businessAssetAttributeType.isBaseAttribute;
                    });
                };

                var cacheAttributes = function (cacheItem, isCategory) {
                    var cachePrefix = isCategory ? baseCacheKeyPrefix : extensionCacheKeyPrefix;
                    scope.assetAttributeCache[cachePrefix + cacheItem.id] = {
                        attributeCount: angular.copy(cacheItem.businessAssetAttributeTypes.length),
                        attributeTypes: angular.copy(cacheItem.businessAssetAttributeTypes),
                        assetAttributes: angular.copy(filterAttributes(isCategory))
                    };
                };

                var getCachedAttributes = function (isCategory) {
                    if (isCategory) {
                        return isValid(scope.assetCategory) ? scope.assetAttributeCache[baseCacheKeyPrefix + scope.assetCategory.id] : null;
                    }
                    return isValid(scope.assetType) ? scope.assetAttributeCache[extensionCacheKeyPrefix + scope.assetType.id] : null;
                };

                var retrieveAttributes = function (isCategory) {
                    var attrs = getCachedAttributes(isCategory);
                    if (angular.isDefined(attrs) && attrs !== null) {
                        var deferred = $q.defer();
                        deferred.resolve(attrs);
                        return deferred.promise;
                    }
                    return isCategory
                        ? DudeApi.BusinessAssetCategoryAttributeTypeEntity.query({ id: scope.assetCategory.id }).$promise
                        : DudeApi.BusinessAssetAttributeTypeEntity.query({ businessAssetTypeId: scope.assetType.id }).$promise;
                };

                var resetAttributes = function (isCategory) {
                    if ((isValid(scope.assetCategory) && isCategory) || (isValid(scope.assetType) && !isCategory)) {
                        retrieveAttributes(isCategory).then(function (result) {
                            if (!angular.isDefined(result) || result === null) {
                                scope.assetAttributes = [];
                            } else {
                                // if the result is from the api, we need to retrieve the data from the paged object before setting scope vals
                                if (result.data) {
                                    result.attributeTypes = result.data;
                                    result.attributeCount = result.data.filter(function (attr) { return !attr.isMetered; }).length;
                                    result.assetAttributes = [];
                                }
                                if (isCategory) {
                                    scope.baseAttributeTypes = result.attributeTypes;
                                    scope.baseAttributeCount = result.attributeCount;
                                    // filter scope attributes to retrieve extension. Then add base
                                    scope.assetAttributes = filterAttributes(!isCategory).concat(result.assetAttributes);
                                } else {
                                    scope.extensionAttributeTypes = result.attributeTypes;
                                    scope.extensionAttributeCount = result.attributeCount;
                                    // filter scope attributes to retrieve base. Then add extension
                                    scope.assetAttributes = filterAttributes(!isCategory).concat(result.assetAttributes);
                                }
                            }
                            resetChildScope();
                        });
                    } else {
                        // remove base or extension attrs if there is no category or no type
                        scope.assetAttributes = filterAttributes(!isCategory);
                        resetChildScope();
                    }
                };

                scope.$watch('assetCategory', function (newVal, oldVal) {
                    if (isValid(oldVal)) {
                        cacheAttributes(oldVal, true);
                        if (oldVal === newVal) {
                            return;
                        }
                    }
                    resetAttributes(true);
                });

                scope.$watch('assetType', function (newVal, oldVal) {
                    if (isValid(oldVal)) {
                        cacheAttributes(oldVal, false);
                        if (oldVal === newVal) {
                            return;
                        }
                    }
                    resetAttributes(false);
                });

                init();
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-double
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of double data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeDouble', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-double/asset-attribute-double.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope) {
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;

                // Taken from here: http://stackoverflow.com/questions/19036443/how-to-allow-only-a-number-digits-and-decimal-point-to-be-typed-in-an-input
                scope.$watch('assetAttribute.value', function (newValue, oldValue) {
                    var arr = String(newValue).split('');

                    if (arr.length === 0) {
                        return;
                    }

                    if (arr.length === 1 && (arr[0] === '-' || arr[0] === '.')) {
                        return;
                    }

                    if (arr.length === 2 && newValue === '-.') {
                        return;
                    }

                    if (angular.isDefined(scope.assetAttribute) && isNaN(newValue)) {
                        scope.assetAttribute.value = oldValue;
                    }
                });
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-date
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of date data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeDate', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-date/asset-attribute-date.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope) {
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-boolean
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of boolean data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeBoolean', function ($translate) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-boolean/asset-attribute-boolean.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope) {
                var stringValue = scope.assetAttribute.value.toString();
                scope.assetAttribute.value = (stringValue.toLowerCase() === 'true');
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;
                scope.checkboxLabel = $translate.instant('assetForm.attributeTypeOptions.checkbox');
            }
        };
    });

/**
 * @ngdoc directive
 * @name asset-attribute.asset-attribute-databound-manufacturer
 * @restrict E
 * @description
 *
 * Display input field for asset attributes type of date data type
 *
 * @param {object} assetAttribute The model to set
 * @param {string} country string detailing current user's country on file
 *
 */

'use strict';

angular.module('asset-attribute')
    .directive('assetAttributeDataboundManufacturer', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assetAttributeEngine/asset-attribute-databound-manufacturer/asset-attribute-databound-manufacturer.html',
            scope: {
                assetAttribute: '=',
                country: '@'
            },
            link: function (scope) {
                if (angular.isObject(scope.assetAttribute.value)) {
                    scope.assetAttribute.value = scope.assetAttribute.value.id;
                }
                scope.attributeType = scope.assetAttribute.businessAssetAttributeType;
            }
        };
    });

'use strict';

angular.module('workTypeReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report']);

'use strict';

angular.module('workTypeReport')
    .controller('WorkTypeReportListController', function ($scope, $state, initData, reportFiltersService, workTypeReportService, queryHelpers, orderByHelpers, filterStateService) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var pageChanging = false;

        var filtersCopy = angular.copy(self.filters);

        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'isLocation', 'filterId', 'requestDateRange', 'completionDateRange'];

        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.listData = initData.initResponse.data;
        self.totalListData = initData.totals;
        self.totalCount = initData.initResponse.total;
        self.filters = initData.filters;

        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        filtersCopy = angular.copy(self.filters);
        queryDefaults = reportFiltersService.getFilters({});

        self.viewWorkOrders = function (id) {
            filtersCopy = angular.copy(self.filters);
            delete filtersCopy.orderBy;
            delete filtersCopy.page;
            delete filtersCopy.pageSize;
            filtersCopy.workType = id;
            filtersCopy.includeDescendants = filtersCopy.assetRollUp;
            $state.go('secure.workOrderList', filtersCopy);
        };

        var setData = function (response) {
            self.listData = response.data;
            self.filterState.totalCount = response.total;
        };

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'workType', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'assetRollUp', 'page', 'orderBy', 'returnAverages'];
            if (reportFiltersService.compareFilters(self.filters, filtersCopy, filtersToCheck)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            filtersCopy = angular.copy(self.filters);
            pageChanging = false;

            workTypeReportService.loadWorkTypes(filtersCopy).then(function (workTypes) {
                workTypeReportService.getListData(filtersCopy, workTypes).then(setData);
            });

            workTypeReportService.getTotalData(filtersCopy).then(function (totals) {
                self.totalListData = totals;
            });

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.workTypeReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters(
                {
                    orderBy: self.filters.orderBy,
                    assetRollUp: self.filters.includeDescendants
                });
            filterStateService.clearFilters(removeMyFilter);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.isFilterApplied = function () {
            return reportFiltersService.isFilterApplied(self.filters);
        };

        self.chartRoute = function () {
            $state.go('secure.report.workTypeChart', self.filters);
        };

        self.export = function () {
            workTypeReportService.exportWorkTypeReport(self.filters);
        };

        $scope.$watch('workTypeReport.filters', updateFilters, true);
    });

'use strict';

angular.module('workTypeReport')
    .controller('WorkTypeReportChartController', function ($scope, $state, $translate, $element, initData, workTypeReportService, reportChartPrintService, reportFiltersService, queryHelpers, filterStateService) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var filtersCopy = {};
        var emptyData = {
            dataArray: [['', ''], ['', { v: 0 }]]
        };
        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'isLocation', 'filterId', 'requestDateRange', 'completionDateRange'];

        self.filters = initData.filters;
        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        self.workOrderLabels = {
            title: $translate.instant('workTypeReports.workOrdersBy'),
            yAxis: $translate.instant('reports.byWorkOrders.numberOf')
        };

        self.laborHoursLabels = {
            title: $translate.instant('workTypeReports.laborHoursBy'),
            yAxis: $translate.instant('reports.byLaborHours.hours')
        };

        self.costLabels = {
            title: $translate.instant('workTypeReports.costBy'),
            yAxis: $translate.instant('reports.byCost.cost')
        };

        self.costLegend = [
            $translate.instant('reports.byCost.purchase'),
            $translate.instant('reports.byCost.service'),
            $translate.instant('reports.byCost.labor')
        ];

        self.workOrderChartData = angular.copy(emptyData);
        self.laborChartData = angular.copy(emptyData);
        self.costChartData = angular.copy([['', '', ''], ['', { v: 0 }, { v: 0 }]]);

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'workType', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'assetRollUp'];
            if (reportFiltersService.compareFilters(self.filters, filtersCopy, filtersToCheck)) {
                return;
            }

            filtersCopy = angular.copy(self.filters);

            self.workOrderLabels.title = $translate.instant('workTypeReports.workOrdersBy');
            self.laborHoursLabels.title = $translate.instant('workTypeReports.laborHoursBy');
            self.costLabels.title = $translate.instant('workTypeReports.costBy');

            workTypeReportService.loadWorkTypes(self.filters).then(function (workTypes) {
                self.workOrderChartData = workTypeReportService.workOrderChartData(filtersCopy, workTypes, self.workOrderLabels);
                self.laborChartData = workTypeReportService.laborChartData(filtersCopy, workTypes, self.laborHoursLabels);
                self.costChartData = workTypeReportService.costChartData(filtersCopy, workTypes, self.costLabels);
            });

            delete (filtersCopy.orderBy);
            queryHelpers.updateState(filtersCopy, queryDefaults);
        };

        self.isFilterApplied = function () {
            return reportFiltersService.isFilterApplied(self.filters);
        };

        self.clickFunctionObject = {
            chartFunction: function (id) {
                filtersCopy = angular.copy(self.filters);
                delete filtersCopy.orderBy;
                delete filtersCopy.page;
                delete filtersCopy.pageSize;
                filtersCopy.workType = id;
                filtersCopy.includeDescendants = filtersCopy.assetRollUp;
                $state.go('secure.workOrderList', filtersCopy);
            }
        };

        self.listRoute = function () {
            var filterCopy = angular.copy(self.filters);
            delete (filterCopy.orderBy);
            $state.go('secure.report.workTypeList', filterCopy);
        };

        self.printCharts = function () {
            var chartOne = angular.element($element.find('.work-order-chart svg'))[0].parentNode.innerHTML;
            var chartTwo = angular.element($element.find('.cost-chart svg'))[0].parentNode.innerHTML;
            var chartThree = angular.element($element.find('.labor-hours-chart svg'))[0].parentNode.innerHTML;

            var costLegend = $element.find('.cost-chart .chart-legend')[0] && angular.element($element.find('.cost-chart .chart-legend'))[0].parentNode.innerHTML;
            costLegend = costLegend || '';
            chartTwo = costLegend + chartTwo;

            if (!chartOne || !chartTwo || !chartThree) {
                return;
            }
            var html = [chartOne, chartTwo, chartThree];
            reportChartPrintService.printCharts(html, self.filters, {
                workOrderChartData: self.workOrderChartData,
                laborHoursChartData: self.laborChartData,
                costChartData: self.costChartData
            }, 'workType');
        };

        self.workTypeReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters({
                orderBy: self.filters.orderBy,
                assetRollUp: self.filters.includeDescendants
            });
            filterStateService.clearFilters(removeMyFilter);
        };

        $scope.$watch('workTypeReport.filters', updateFilters, true);
    });

/**
 * @ngdoc service
 * @name workTypeReport.workTypeReportService
 * @requires $q - {@link https://docs.angularjs.org/api/ng/service/$q read the docs}
 * @requires $filter - {@link https://docs.angularjs.org/api/ng/service/$filter read the docs}
 * @requires $translate - {@link https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate read the docs}
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires report.reportFiltersService
 * @requires report.reportTooltipService
 * @requires report.reportDataService
 *
 * @description
 * Service for supporting the gathering and parsing of data for the Work Type Report
 *
 */
'use strict';

angular.module('workTypeReport')
    .service('workTypeReportService', function ($q, $filter, $translate, DudeApi, reportFiltersService, reportTooltipService, reportDataService) {
        var CHART_ITEMS_TO_SHOW = 5;
        var pageSize;

        /**
         * @ngdoc method
         * @name loadWorkTypes
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Get the list of work types.
         *
         * @param {object} filter The object containing the current filters
         */
        var loadWorkTypes = function (filter) {
            var deferred = $q.defer();
            var workTypes = [];
            if (filter.workType && filter.workType.length) {
                filter.workType.forEach(function (workTypeId) {
                    workTypes.push(DudeApi.WorkTypeEntity.get({ id: workTypeId }).$promise);
                });
                $q.all(workTypes).then(deferred.resolve, deferred.reject);
            } else {
                deferred.resolve(workTypes);
            }
            return deferred.promise;
        };

        var getFilters = function (query) {
            return reportFiltersService.toApiFilter(query);
        };

        var getData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.WorkTypesSummaryEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name getTotalData
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Gets the totals data for the list view of work orders by work types
         *
         * @param {object} query An object containing the filters to query with
         */
        var getTotalData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.WorkTypesTotalEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name getListData
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Gets the data for the list view of work orders by work type
         *
         * @param {object} query An object containing the filters to query with
         * @param {array} workTypes Array of Work Types to return data for
         */
        var getListData = function (query, workTypes) {
            return getData(query).then(function (pagedWorkType) {
                workTypes.forEach(function (workType) {
                    var matches = $filter('filter')(pagedWorkType.data, function (value) {
                        return value.workType.id === workType.id;
                    }).length;

                    if (matches) {
                        return;
                    }

                    pagedWorkType.count++;
                    pagedWorkType.data.push({
                        workType: workType,
                        count: {
                            workOrders: 0,
                            laborHours: 0
                        },
                        cost: {
                            labor: 0,
                            purchase: 0,
                            total: 0
                        }
                    });
                });
                return pagedWorkType;
            });
        };

        var fetchStandardChartData = function (filter, workTypes, endPoint, textPlural, textSingular, labels) {
            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = workTypes.length || pageSize || CHART_ITEMS_TO_SHOW;

            var dataObject = {
                idArray: [],
                dataArray: [[$translate.instant('workTypeReports.workTypes'), '', {
                    type: 'string',
                    role: 'tooltip',
                    p: { html: true }
                }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                results.data.forEach(function (summary) {
                    var text = summary.count[endPoint] === 1 ? textSingular : textPlural;
                    if (summary.count[endPoint] > 0) {
                        dataObject.dataArray.push([
                            summary.workType.name,
                            { v: summary.count[endPoint], f: $filter('number')(summary.count[endPoint]) + ' ' + text },
                            reportTooltipService.standardTooltip(summary.workType, $filter('number')(summary.count[endPoint]) + ' ' + text)
                        ]);
                        dataObject.idArray.push(summary.workType.id);
                    }
                });

                reportDataService.topLabel(workTypes, results, dataObject, labels, 5);

                workTypes.forEach(function (workType) {
                    if (dataObject.idArray.indexOf(workType.id) > -1 || dataObject.idArray.length >= filter.pageSize) {
                        return;
                    }

                    dataObject.dataArray.push([
                        workType.name,
                        { v: 0, f: '0' + textPlural },
                        ''
                    ]);
                    dataObject.idArray.push(workType.id);
                });
                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name workOrderChartData
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Returns the number of work orders broken down by Work Type.
         *
         * @param {object} filter The object containing the current filters
         * @param {array} workTypes Array of Work Types to return data for
         * @param {object} labels The object that contains the labels for the chart
         * @param {boolean} isDrillDown Defines if the data is for a drill down chart
         */
        var workOrderChartData = function (filter, workTypes, labels, isDrillDown) {
            isDrillDown = isDrillDown || false;
            pageSize = isDrillDown ? 1000 : CHART_ITEMS_TO_SHOW;
            filter.orderBy = 'Count/WorkOrders desc,WorkType/Name asc';

            return fetchStandardChartData(filter, workTypes, 'workOrders', $translate.instant('reports.byWorkOrders.workOrders'), $translate.instant('reports.byWorkOrders.workOrder'), labels);
        };

        /**
         * @ngdoc method
         * @name laborChartData
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Returns the work order labor hours broken down by Work Type.
         *
         * @param {object} filter The object containing the current filters
         * @param {object} workTypes Array of Work Types to return data for
         * @param {object} labels The object that contains the labels for the chart
         * @param {boolean} isDrillDown Defines if the data is for a drill down chart
         */
        var laborChartData = function (filter, workTypes, labels, isDrillDown) {
            isDrillDown = isDrillDown || false;
            pageSize = isDrillDown ? 1000 : CHART_ITEMS_TO_SHOW;
            filter.orderBy = 'Count/LaborHours desc,WorkType/Name asc';

            return fetchStandardChartData(filter, workTypes, 'laborHours', $translate.instant('reports.byLaborHours.hours'), $translate.instant('reports.byLaborHours.hour'), labels);
        };

        /**
         * @ngdoc method
         * @name costChartData
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Returns the work order cost data broken down by Work Type.
         *
         * @param {object} filter The object containing the current filters
         * @param {array} workTypes Array of Work Types to return data for
         * @param {object} labels The object that contains the labels for the chart
         * @param {boolean} isDrillDown Defines if the data is for a drill down chart
         */
        var costChartData = function (filter, workTypes, labels, isDrillDown) {
            isDrillDown = isDrillDown || false;
            pageSize = isDrillDown ? 1000 : CHART_ITEMS_TO_SHOW;

            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = workTypes.length || pageSize;
            filter.orderBy = 'Cost/Total desc,WorkType/Name asc';

            var dataObject = {
                idArray: [],
                dataArray: [[$translate.instant('workTypeReports.workTypes'),
                    '', { type: 'string', role: 'tooltip', p: { html: true } },
                    '', { type: 'string', role: 'tooltip', p: { html: true } },
                    '', { type: 'string', role: 'tooltip', p: { html: true } }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                results.data.forEach(function (summary) {
                    if (!summary.cost) {
                        return;
                    }

                    var laborCost = $filter('currency')(summary.cost.labor) + ' ' + $translate.instant('reports.byCost.labor');
                    var purchaseCost = $filter('currency')(summary.cost.purchase) + ' ' + $translate.instant('reports.byCost.purchase');
                    var serviceCost = $filter('currency')(summary.cost.service) + ' ' + $translate.instant('reports.byCost.service');
                    var totalCost = $filter('currency')(summary.cost.total) + ' ' + $translate.instant('reports.byCost.total');

                    var tooltip = reportTooltipService.costChartTooltip(summary.workType, laborCost, purchaseCost, serviceCost, totalCost);

                    if (summary.cost.total > 0) {
                        dataObject.dataArray.push([
                            summary.workType.name,
                            { v: summary.cost.purchase, f: laborCost },
                            tooltip,
                            { v: summary.cost.service, f: serviceCost },
                            tooltip,
                            { v: summary.cost.labor, f: purchaseCost },
                            tooltip
                        ]);
                        dataObject.idArray.push(summary.workType.id);
                    }
                });

                reportDataService.topLabel(workTypes, results, dataObject, labels, 5);

                workTypes.forEach(function (workType) {
                    if (dataObject.idArray.indexOf(workType.id) > -1 || dataObject.idArray.length >= filter.pageSize) {
                        return;
                    }

                    dataObject.dataArray.push([
                        workType.name,
                        { v: 0, f: '0' + $translate.instant('reports.byLaborHours.hours') },
                        '',
                        { v: 0, f: '0' + $translate.instant('reports.byLaborHours.hours') },
                        ''
                    ]);
                    dataObject.idArray.push(workType.id);
                });

                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name exportWorkTypeReport
         * @methodOf workTypeReport.workTypeReportService
         *
         * @description
         * Exports a csv of work orders by work type
         *
         * @param {object} query An object containing the filters to query with
         */
        var exportWorkTypeReport = function (query) {
            var filters = getFilters(query);
            reportDataService.exportReport(filters, 'workordersbyworktype');
        };

        return {
            loadWorkTypes: loadWorkTypes,
            getListData: getListData,
            workOrderChartData: workOrderChartData,
            laborChartData: laborChartData,
            costChartData: costChartData,
            exportWorkTypeReport: exportWorkTypeReport,
            getTotalData: getTotalData
        };
    });

'use strict';

angular.module('workTypeReport')
    .config(function ($stateProvider, permission, moment, workOrderEnums, dateHelperProvider, market) {
        var routeParams = 'status&workType&purpose&requestDateTo&requestDateFrom&requestDateRange&completionDateTo&completionDateFrom&completionDateRange&dateRange&businessAsset&includeDescendants&assetRollUp&orderBy&returnAverages&filterId';
        var defaults = {
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete, workOrderEnums.status.onHold],
            toDate: dateHelperProvider.getEndOfDay(moment().subtract(1, 'month').endOf('month')).toISOString(),
            fromDate: dateHelperProvider.getStartOfDay(moment().subtract(1, 'month').startOf('month')).toISOString()
        };

        var getActiveSavedFilter = function ($stateParams, myFilters, savedFiltersService) {
            var queryParams = $stateParams;
            if (queryParams.filterId) {
                return savedFiltersService.getFilterIfExistsForUser(queryParams.filterId, myFilters);
            }
            return null;
        };

        var getQueryParams = function ($location, $stateParams, activeSavedFilter) {
            var defaultCopy = angular.copy(defaults);
            var queryParams = $stateParams;
            queryParams.status = (queryParams.status || defaultCopy.status);
            queryParams.assetRollUp = queryParams.includeDescendants || queryParams.assetRollUp || null;
            queryParams.includeDescendants = null;
            if (!queryParams.requestDateTo && !queryParams.requestDateFrom && !queryParams.completionDateFrom && !queryParams.completionDateTo && !queryParams.dateRange) {
                queryParams.requestDateTo = defaultCopy.toDate;
                queryParams.requestDateFrom = defaultCopy.fromDate;
            }

            if (!queryParams.filterId) {
                queryParams.status = queryParams.status || defaultCopy.status;
            }
            // If requesting a saved filter created for a different page or by a different user, remove the filter id
            if (queryParams.filterId && !activeSavedFilter) {
                delete queryParams.filterId;
                $location.search('filterId', null);
            }
            return queryParams;
        };

        $stateProvider
            .state('secure.report.workTypeList', {
                url: 'workType/list?page&pageSize&' + routeParams,
                templateUrl: 'app/components/workTypeReport/workTypeReportList.html',
                controller: 'WorkTypeReportListController',
                controllerAs: 'workTypeReport',
                permissions: [permission.workTypes.create, permission.workTypes.update, permission.workTypes.delete],
                markets: [market.he, market.k12, market.ips],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/workType/list');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $q, $stateParams, myFilters, activeSavedFilter, workTypeReportService, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter);
                        if (!queryParams.orderBy || (queryParams.orderBy && queryParams.orderBy.indexOf('TotalsWithDescendants') > -1)) {
                            queryParams.orderBy = 'Count/WorkOrders desc,WorkType/Name asc';
                        }
                        var filters = reportFiltersService.toApiFilter(queryParams);

                        return $q.all({
                            initResponse: workTypeReportService.loadWorkTypes(filters).then(function (workTypes) {
                                return workTypeReportService.getListData(filters, workTypes);
                            }),
                            filters: filters,
                            totals: workTypeReportService.getTotalData(filters),
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        });
                    }
                }
            })
            .state('secure.report.workTypeChart', {
                url: 'workType/chart?' + routeParams,
                templateUrl: 'app/components/workTypeReport/workTypeReportChart.html',
                controller: 'WorkTypeReportChartController',
                controllerAs: 'workTypeReport',
                permissions: [permission.workTypes.create, permission.workTypes.update, permission.workTypes.delete],
                markets: [market.he, market.k12, market.ips],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/workType/chart');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $stateParams, activeSavedFilter, marketizr, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter);
                        var filters = reportFiltersService.getFilters(queryParams);

                        return {
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        };
                    }
                }
            });
    });

'use strict';

angular.module('workTypeList')
    .factory('workTypeListFilterService', function ($location, pagingHelpers) {
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Parent/Name asc,Name asc',
                q: params.q || null,
                isActive: params.isActive || null,
                hasParent: params.hasParent || true
            };

            return currentFilter;
        };

        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

'use strict';

angular.module('workTypeList')
    .service('workTypeListService', function (DudeApi, workTypeListFilterService) {
        var getListData = function (query) {
            var filters = workTypeListFilterService.toApiFilter(query);

            return DudeApi.WorkTypeEntity.query(filters);
        };

        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('workTypeList')
    .config(function ($stateProvider, market, permission) {
        $stateProvider
            .state('secure.workTypeList', {
                url: 'workTypes?page&pageSize&q&isActive',
                templateUrl: 'app/components/workTypeList/workTypeList.html',
                controller: 'WorkTypeListController',
                controllerAs: 'workTypeList',
                permissions: [permission.workTypes.create, permission.workTypes.update, permission.workTypes.delete],
                markets: [market.k12, market.ips, market.he],
                resolve: {
                    initData: function ($q, $stateParams, workTypeListService, workTypeListFilterService) {
                        var queryParams = $stateParams;
                        var filters = workTypeListFilterService.getFilters(queryParams);

                        return $q.all({
                            initResponse: workTypeListService.getListData(filters).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('workTypeList')
    .controller('WorkTypeListController', function ($scope, $state, DudeApi, workTypeListService, workTypeListFilterService, queryHelpers, orderByHelpers, initData) {
        var self = this;
        var queryDefaults = workTypeListFilterService.getFilters({});
        var pageChanging = false;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            workTypeListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        // view model
        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;
        self.panelOpen = false;
        self.updated = false;

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, workTypeListFilterService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.openPanel = function (workType) {
            if (!workType) {
                workType = new DudeApi.WorkTypeEntity({});
            }
            self.workType = workType;
            self.panelOpen = true;
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.clearFilters = function () {
            self.filters = workTypeListFilterService.getFilters({});
        };

        $scope.$watch('workTypeList.filters', updateFilters, true);

        $scope.$watch('workTypeList.updated', function (newVal) {
            if (!newVal) {
                return;
            }
            workTypeListService.getListData(self.filters).$promise.then(setData);
            self.updated = false;
        });
    });

'use strict';

angular.module('workOrderTransactions', ['translate', 'dudeAuth', 'dudeControls', 'sumFilter', 'helpers']);

/**
 * @ngdoc directive
 * @name workOrderTransactions.work-order-transactions
 * @restrict E
 * @description
 *
 * Renders the transactions section of the work order form
 *
 * @param {array} transactions The work order transactions
 * @param {array} spies The array of spies used by the scroll spy
 * @param {number} workOrderId  The Id of the work order the transactions are attached to
 *
 * <work-order-transactions transactions="someTransactions" spies="someSpies" work-order-id="5"></work-order-transactions>
 */

'use strict';

angular.module('workOrderTransactions')
    .component('workOrderTransactions', {
        bindings: {
            transactions: '=',
            spies: '=',
            workOrderId: '<'
        },
        templateUrl: 'app/components/workOrderTransactions/workOrderTransactions.html',
        controller: 'WorkOrderTransactionsComponent',
        controllerAs: 'transactions'
    })
    .controller('WorkOrderTransactionsComponent', function ($filter, $uibModal, $q, $translate, userContext, log, transactionHelpers, permission, TRANSACTIONS_CONSTANTS) {
        var self = this;
        var readonly;
        var READ_ONLY = 'ReadOnly';

        var removeTransaction = function (transactionId) {
            self.transactions = $filter('filter')(self.transactions, function (returnedTransaction) {
                return returnedTransaction.id !== transactionId;
            });
        };

        var deleteTransaction = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/workOrderTransactions/deleteConfirmModal.html',
                controller: 'DeleteConfirmModalController',
                controllerAs: 'deleteConfirmModalController',
                size: 'sm',
                backdrop: 'static'
            });

            return modalInstance.result.then(function () {
                var transactionToDelete = transactionHelpers.transactionReference(self.transaction);
                return transactionToDelete.$delete({ id: transactionToDelete.id, workorderId: self.workOrderId }).then(function () {
                    removeTransaction(transactionToDelete.id);
                    log.notify({
                        type: 'success',
                        title: $translate.instant('transactions.notify.deleteTransaction.title'),
                        message: $translate.instant('transactions.notify.deleteTransaction.message')
                    });
                });
            });
        };

        var saveTransaction = function () {
            var newTransaction = transactionHelpers.transactionReference(self.transaction);
            if (self.transaction.delete) {
                deleteTransaction(newTransaction);
                return $q.resolve();
            } else if (readonly === READ_ONLY) {
                return $q.resolve();
            }

            var promise = newTransaction.id ? newTransaction.$update({
                id: newTransaction.id,
                workorderId: self.workOrderId
            }) : newTransaction.$save({ workorderId: self.workOrderId });
            return promise.then(function () {
                log.notify({
                    type: 'success',
                    title: $translate.instant('transactions.notify.saveTransaction.title'),
                    message: $translate.instant('transactions.notify.saveTransaction.message')
                });
                transactionHelpers.getTransactions(self.workOrderId).$promise.then(function (results) {
                    self.transactions = transactionHelpers.parseTransactions(results.data, userContext);
                });
            });
        };

        self.permission = permission.transactions.updateAny;
        self.serviceTypes = TRANSACTIONS_CONSTANTS.serviceType;
        self.panelObject = {};

        self.addTransaction = function (value, type) {
            readonly = '';
            self.transaction = angular.copy(value) || transactionHelpers.defaultTransaction[type](userContext.user);

            if (self.transaction.id && !self.transaction.isEditable) {
                readonly = READ_ONLY;
            }

            var buttonFunctions = {
                saveFunction: saveTransaction,
                saveButtonText: readonly === READ_ONLY ? $translate.instant('general.actions.ok') : $translate.instant('general.actions.save')
            };

            if (self.transaction.id && readonly !== READ_ONLY) {
                buttonFunctions.deleteFunction = deleteTransaction;
            }

            var translationType;
            switch (type) {
            default:
                translationType = 'transactionsPanel';
                break;
            case 'purchase':
                translationType = 'purchaseTransactionsPanel';
                break;
            case 'service':
                translationType = 'serviceTransactionsPanel';
                break;
            }

            var panelTitle;
            if (self.transaction && self.transaction.id && readonly !== READ_ONLY) {
                panelTitle = $translate.instant('transactions.' + translationType + '.edit');
            } else if (readonly === READ_ONLY) {
                panelTitle = $translate.instant('transactions.' + translationType + '.view');
            } else {
                panelTitle = $translate.instant('transactions.' + translationType + '.new');
            }

            self.panelObject = {
                titles: {
                    title: panelTitle,
                    subtitle: self.transaction && self.transaction.id ? '(' + self.transaction.id + ')' : ''
                },
                buttonFunctions: buttonFunctions,
                readOnly: readonly === READ_ONLY,
                open: true,
                template: 'app/components/workOrderTransactions/' + type + 'Transactions' + readonly + '.html',
                transaction: self.transaction
            };
        };
    });

/**
 * @ngdoc directive
 * @name workOrderTransactions.transactionsPanel
 * @restrict E
 * @description
 *
 * Renders the labor transactions sliding panel
 *
 */

'use strict';

angular.module('workOrderTransactions')
    .component('transactionsPanel', {
        bindings: {
            saveAttempt: '<',
            templateUrl: '@',
            transaction: '='
        },
        template: '<div ng-include="transactionsPanel.templateUrl">',
        controller: 'TransactionsPanelComponent',
        controllerAs: 'transactionsPanel'
    })
    .controller('TransactionsPanelComponent', function ($scope, $translate, $filter, TRANSACTIONS_CONSTANTS, roles) {
        var self = this;
        self.roles = [roles.admin, roles.technician];
        self.laborTypes = [
            {
                value: 'regular',
                name: $translate.instant('transactions.transactionsPanel.labor.regular')
            },
            {
                value: 'overtime',
                name: $translate.instant('transactions.transactionsPanel.labor.overtime')
            },
            {
                value: 'doubletime',
                name: $translate.instant('transactions.transactionsPanel.labor.doubletime')
            }
        ];
        self.serviceTypes = TRANSACTIONS_CONSTANTS.serviceType;

        var parseStringNumber = function (number) {
            if (typeof number === 'string') {
                return parseFloat(number.replace(/,/g, ''));
            }
            return number;
        };

        var setTotalCost = function () {
            var cost;
            var quantity = parseStringNumber(self.transaction.typeAttributes.quantity);
            var itemCost = Math.round(parseStringNumber(self.transaction.typeAttributes.unitCost) * 100) / 100;
            cost = quantity * itemCost;
            self.transaction.typeAttributes.totalCost = cost;
        };

        self.$onInit = function () {
            if (self.transaction.typeAttributes.type === 'purchase') {
                if (self.transaction.typeAttributes.unitCost && self.transaction.typeAttributes.quantity) {
                    setTotalCost();
                }
                $scope.$watch('transactionsPanel.transaction.typeAttributes.quantity', function (newVal) {
                    if (newVal && self.transaction.typeAttributes.unitCost) {
                        setTotalCost();
                    } else {
                        self.transaction.typeAttributes.totalCost = '';
                    }
                });

                $scope.$watch('transactionsPanel.transaction.typeAttributes.unitCost', function (newVal) {
                    if (newVal && self.transaction.typeAttributes.quantity) {
                        setTotalCost();
                    } else {
                        self.transaction.typeAttributes.totalCost = '';
                    }
                });
            }
        };
    });

'use strict';

angular.module('workOrderTransactions')
    .service('transactionHelpers', function (DudeApi, permissionsHelper, TRANSACTIONS_CONSTANTS) {
        var defaultQuery = {
            orderBy: 'TransactionDate desc,CreatedDateTime desc',
            includeAudit: true
        };

        var parseTransactions = function (transactions, userContext) {
            var parsedTransactions = [];
            transactions.forEach(function (transaction) {
                if (permissionsHelper.userAllowed('Transactions-UpdateAny')) {
                    transaction.isEditable = true;
                } else {
                    transaction.isEditable = (transaction.typeAttributes.user !== null && transaction.typeAttributes.user.id === userContext.user.id) ||
                        transaction.createdByUser.id === userContext.user.id;
                }

                parsedTransactions.push(transaction);
            });
            return parsedTransactions;
        };

        var transactionReference = function (transaction) {
            return new DudeApi.WorkOrderTransactionEntity(transaction);
        };

        var defaultTransaction = {
            labor: function (user) {
                return {
                    transactionDate: new Date(),
                    typeAttributes: {
                        type: TRANSACTIONS_CONSTANTS.type.labor,
                        laborType: TRANSACTIONS_CONSTANTS.laborType.regular,
                        user: user
                    }
                };
            },
            purchase: function (user) {
                return {
                    transactionDate: new Date(),
                    typeAttributes: {
                        type: TRANSACTIONS_CONSTANTS.type.purchase,
                        user: user,
                        quantity: '1',
                        unitCost: '0.00'
                    }
                };
            },
            service: function () {
                return {
                    transactionDate: new Date(),
                    typeAttributes: {
                        type: TRANSACTIONS_CONSTANTS.type.service,
                        cost: '0.00',
                        serviceType: TRANSACTIONS_CONSTANTS.serviceType.contract
                    }
                };
            }
        };

        var getTransactions = function (workOrderId) {
            defaultQuery.workorderId = workOrderId;
            return DudeApi.WorkOrderTransactionEntity.query(defaultQuery);
        };

        return {
            transactionReference: transactionReference,
            defaultTransaction: defaultTransaction,
            getTransactions: getTransactions,
            parseTransactions: parseTransactions
        };
    });

'use strict';

angular.module('workOrderTransactions')
    .constant('TRANSACTIONS_CONSTANTS', {
        type: {
            labor: 'labor',
            purchase: 'purchase',
            service: 'service'
        },
        laborType: {
            regular: 'regular',
            overTime: 'overTime',
            doubleTime: 'doubleTime'
        },
        serviceType: {
            contract: 'Contract',
            rental: 'EquipmentRental',
            other: 'Other'
        }
    });

'use strict';

angular.module('workOrderTransactions')
    .filter('transactionTypeSum', function () {
        return function (array, type) {
            var total = 0;

            array.forEach(function (value) {
                var itemResult = value;

                if (itemResult.typeAttributes.type === type) {
                    total += parseFloat(itemResult.typeAttributes.cost);
                }
            });
            return total;
        };
    });

'use strict';

angular.module('workOrderTransactions')
    .filter('transactionHours', function () {
        return function (array) {
            var total = 0;

            array.forEach(function (value) {
                var itemResult = value;

                if (itemResult.typeAttributes.type === 'labor') {
                    total += parseFloat(itemResult.typeAttributes.hours);
                }
            });
            return total;
        };
    });

'use strict';

angular.module('workOrderTransactions')
    .filter('serviceTypeFilter', function ($translate, TRANSACTIONS_CONSTANTS) {
        var statuses = [];
        statuses[TRANSACTIONS_CONSTANTS.serviceType.contract] = $translate.instant('transactions.serviceTypes.contract');
        statuses[TRANSACTIONS_CONSTANTS.serviceType.rental] = $translate.instant('transactions.serviceTypes.rental');
        statuses[TRANSACTIONS_CONSTANTS.serviceType.other] = $translate.instant('transactions.serviceTypes.other');

        return function (input) {
            var value = statuses[input];
            if (!value) {
                return 'Unknown';
            }
            return value;
        };
    });

'use strict';

angular.module('workOrderTransactions')
    .controller('DeleteConfirmModalController', function ($uibModalInstance) {
        var self = this;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('workOrderTasks', ['translate', 'dudeControls', 'taskBook']);

'use strict';

angular.module('workOrderTasks')
    .directive('workOrderTasks', function (taskBookService) {
        return {
            templateUrl: 'app/components/workOrderTasks/workOrderTasks.html',
            scope: {
                tasks: '=',
                spies: '=',
                editMode: '=',
                tasksToDelete: '='
            },
            link: function (scope) {
                scope.mode = scope.editMode ? 'completed_edit' : 'completed_readonly';

                // Create a task book out of the tasks for the task book directive.
                scope.taskBook = {
                    tasks: scope.tasks
                };

                scope.addTasks = function (numberOfTasksToAdd) {
                    taskBookService.addTasks(scope.taskBook.tasks, numberOfTasksToAdd);
                };

                scope.hideButton = true;

                scope.$watch('tasks', function (newVal) {
                    scope.taskBook.tasks = newVal;
                }, true);
            }
        };
    });

'use strict';

angular.module('workOrderQuickActions', ['dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'helpers', 'maintenanceConstants']);

/**
 * @ngdoc service
 * @name workOrderQuickActions.workOrderQuickActionsService
 * @requires DudeApi
 * @requires moment
 *
 * @description
 * Service for supporting work order quick actions
 *
 */

'use strict';

angular.module('workOrderQuickActions')
    .factory('workOrderQuickActionsService', function (DudeApi, moment) {
        /**
         * @ngdoc method
         * @name print
         * @methodOf workOrderQuickActions.workOrderQuickActionsService
         *
         * @description
         * Prints the work order
         *
         * @param {number} id The id of the work order
         */
        var print = function (id) {
            DudeApi.workOrderPrintService.print({ id: id, timezone: moment.tz.guess() });
        };

        return {
            print: print
        };
    });

/**
 * @ngdoc directive
 * @name workOrderQuickActions.status-quick-action
 * @restrict E
 * @description
 * Handles the quick action for starting or completing a work order
 *
 * @param {object} workOrder A work order resource object
 * @param {object} panelOptions An object containing sliding panel options
 * @param {object} editingObject An object containing the work order and transaction being edited
 * @param {boolean} ngDisabled Sets the buttons to disabled or enabled (optional)
 *
 * <status-quick-action work-order="someWorkOrder"></status-quick-action>
 */

'use strict';

angular.module('workOrderQuickActions')
    .component('statusQuickAction', {
        templateUrl: 'app/components/workOrderQuickActions/statusQuickAction.html',
        bindings: {
            workOrder: '=',
            editingObject: '=',
            panelOptions: '=',
            ngDisabled: '=?'
        },
        controller: 'StatusQuickActionComponent',
        controllerAs: 'quickAction'
    });

angular.module('workOrderQuickActions')
    .controller('StatusQuickActionComponent', function ($q, $scope, workOrderEnums, log, $translate, userContext, roleHelpers, transactionHelpers) {
        var self = this;
        var isTechnician = roleHelpers.isTechnician();
        self.status = workOrderEnums.status;

        var addTechnicianAsAssignee = function (workOrder) {
            if (!isTechnician) {
                return;
            }
            var alreadyAssigned = false;
            workOrder.assignees.forEach(function (assignee) {
                alreadyAssigned = assignee.id === userContext.user.id || alreadyAssigned;
            });
            if (!alreadyAssigned) {
                workOrder.assignees.push(userContext.user);
            }
        };

        var startWorkOrder = function (workOrder) {
            workOrder.status = self.status.workInProgress;
            addTechnicianAsAssignee(workOrder);
            workOrder.$update({ id: workOrder.id }).then(function () {
                log.notify({
                    type: 'success',
                    title: $translate.instant('workOrderForm.notificationTitle'),
                    message: $translate.instant('workOrderForm.notification')
                });
            });
        };

        var completeWorkOrder = function (workOrder) {
            self.editingObject.workOrder = angular.copy(workOrder);
            self.editingObject.workOrder.status = self.status.complete;
            self.editingObject.workOrder.completionDateTime = new Date();
            self.editingObject.transaction = transactionHelpers.defaultTransaction.labor(userContext.user);
            var completionWatcher = $scope.$watch('quickAction.editingObject.workOrder.completionDateTime', function (newVal) {
                if (!newVal) {
                    return;
                }
                self.editingObject.transaction.transactionDate = angular.copy(newVal);
            });
            self.panelOptions.functions.saveFunction = function () {
                var promises = [];
                completionWatcher();

                workOrder.status = self.editingObject.workOrder.status;
                workOrder.completionDateTime = self.editingObject.workOrder.completionDateTime;
                workOrder.actionTaken = self.editingObject.workOrder.actionTaken;
                promises.push(workOrder.$update({ id: workOrder.id }));

                if (self.editingObject.transaction.transactionDate && self.editingObject.transaction.typeAttributes.hours) {
                    self.editingObject.transaction = transactionHelpers.transactionReference(self.editingObject.transaction);
                    promises.push(self.editingObject.transaction.$save({ workorderId: workOrder.id }));
                }
                return $q.all(promises).then(function () {
                    self.editingObject.workOrder = {};
                    self.editingObject.transaction = {};
                    log.notify({
                        type: 'success',
                        title: $translate.instant('workOrderForm.notificationTitle'),
                        message: $translate.instant('workOrderForm.notification')
                    });
                });
            };
            self.panelOptions.titles.title = $translate.instant('workOrderList.complete');
            self.panelOptions.titles.subtitle = '(' + $translate.instant('workOrderList.wo') + ' ' + self.editingObject.workOrder.displayId + ')';
            self.panelOptions.open = true;
        };

        self.quickStatusChange = function (workOrder) {
            switch (workOrder.status) {
            case self.status.newRequest:
                startWorkOrder(workOrder);
                break;
            case self.status.workInProgress:
                completeWorkOrder(workOrder);
                break;
            default:
                break;
            }
        };
    });

/**
 * @ngdoc directive
 * @name workOrderQuickActions.schedule-quick-action
 * @restrict E
 * @description
 *
 * Displays the quick action form elements for schedule
 *
 * @param {date} dueDate The date the work is due
 * @param {date} requestDate The date the work is requested
 * @param {date} startDate  The date the work is scheduled to start
 *
 * <schedule-quick-action start-date="scheduledDate" request-date="requestedDate" due-date="endDate"></schedule-quick-action>
 */

'use strict';

angular.module('workOrderQuickActions')
    .component('scheduleQuickAction', {
        templateUrl: 'app/components/workOrderQuickActions/scheduleQuickAction.html',
        bindings: {
            dueDate: '=',
            requestDate: '=',
            startDate: '='
        },
        controller: function ($timeout) {
            // This time out is necessary in order to focus after the ng-if is triggered
            $timeout(function () {
                angular.element('#scheduledStart input').focus();
            });
        },
        controllerAs: 'quickAction'
    });

/**
 * @ngdoc directive
 * @name workOrderQuickActions.assignee-quick-action
 * @restrict E
 * @description
 *
 * Displays the quick action form elements for assignees
 *
 * @param {array} assignees The list of user objects to display
 *
 * <assignee-quick-action assignees="assigneesArray"></assignee-quick-action>
 */

'use strict';

angular.module('workOrderQuickActions')
    .component('assigneeQuickAction', {
        templateUrl: 'app/components/workOrderQuickActions/assigneeQuickAction.html',
        bindings: {
            assignees: '='
        },
        controller: function ($timeout, roles) {
            var self = this;

            self.roles = [roles.admin, roles.technician];

            // This time out is necessary in order to focus after the ng-if is triggered
            $timeout(function () {
                // We have to use angular element to focus like this because of how the typeahead is structured
                angular.element('.work-order-quick-actions .dude-rxtypeahead input')[0].focus();
            });
        },
        controllerAs: 'quickAction'
    });

'use strict';

angular.module('workOrderList', ['ui.router', 'dudeAuth', 'dudeControls', 'dudeApi', 'marketizr', 'workOrderForm', 'workOrderFilters', 'translate', 'workOrderQuickActions', 'helpers', 'maintenanceConstants']);

/**
 * @ngdoc service
 * @name workOrderList.workOrderListService
 * @requires DudeApi
 * @requires workOrderFilters.workOrderFilters
 * @requires moment
 *
 * @description
 * Service for supporting the work order list with retrieving updating and exporting data
 *
 */

'use strict';

angular.module('workOrderList')
    .factory('workOrderListService', function (DudeApi, marketizr, market, workOrderFilters, moment) {
        var getFilters = function (query, isMap) {
            var filters = workOrderFilters.toApiFilter(query, isMap);
            return filters;
        };

        /**
         * @ngdoc method
         * @name getListData
         * @methodOf workOrderList.workOrderListService
         *
         * @description
         * Gets the data for the work order list
         *
         * @param {object} query An object containing the filters to query with
         * @param {boolean} isMap A boolean which states whether or not the data is for the work order map
         * @returns {promise} A promise containing the page wrapped work order list data
         */
        var getListData = function (query, isMap) {
            var filters = getFilters(query, isMap);
            return DudeApi.WorkOrderEntity.query(filters);
        };

        /**
         * @ngdoc method
         * @name exportSpreadsheet
         * @methodOf workOrderList.workOrderListService
         *
         * @description
         * Exports a csv of work orders
         *
         * @param {object} query An object containing the filters to query with
         */
        var exportSpreadsheet = function (query) {
            var filters = getFilters(query, false);
            delete filters.page;
            delete filters.pageSize;

            if (marketizr.hasMarkets([market.he, market.ips, market.k12])) {
                filters.template = 'Public';
            }

            if (filters.orderBy && filters.orderBy.indexOf('DueDate') > -1) {
                filters.orderBy = 'DueDate';
            }

            filters.includeTransactions = true;
            filters.includeTasks = true;
            filters.timezone = moment.tz.guess();

            DudeApi.workOrderExportService.download(filters);
        };

        return {
            getListData: getListData,
            exportSpreadsheet: exportSpreadsheet
        };
    });

'use strict';

angular.module('workOrderList')
    .config(function ($stateProvider, workOrderEnums) {
        var queryParams = [
            'q',
            'status',
            'priority',
            'assignees',
            'requestDateTo',
            'requestDateFrom',
            'pageSize',
            'page',
            'orderBy',
            'unassigned',
            'businessAsset',
            'includeDescendants',
            'purpose',
            'completionDateTo',
            'completionDateFrom',
            'dueDateFrom',
            'dueDateTo',
            'scheduledStartDateFrom',
            'scheduledStartDateTo',
            'hasScheduledStartDate',
            'pmSchedule',
            'failureReason',
            'woid',
            'project',
            'workType'
        ].join('&');
        $stateProvider
            .state('secure.workOrderList', {
                url: 'workorders?' + queryParams,
                templateUrl: 'app/components/workOrderList/workOrderList.html',
                controller: 'WorkOrderListController',
                controllerAs: 'workOrderList',
                resolve: {
                    initData: function ($q, $stateParams, workOrderListService, workOrderFilters, marketizr, market, roleHelpers, userContext) {
                        queryParams = $stateParams;

                        // Requester Role Check
                        if (roleHelpers.isRequester()) {
                            queryParams = {
                                requestedBy: userContext.user.id
                            };
                        // Admin/Technician Role Check
                        } else {
                            queryParams.status = (queryParams.status || [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress]);
                            queryParams.includeDescendants = queryParams.businessAsset ? queryParams.includeDescendants : 'true';
                            if (queryParams.assignees === 'none') {
                                queryParams.assignees = null;
                            } else if (queryParams.assignees !== null && roleHelpers.isTechnician() && queryParams.assignees !== 'all') {
                                queryParams.assignees = queryParams.assignees || userContext.user.id;
                            } else if (queryParams.assignees === 'all' && marketizr.hasMarkets(market.k12, market.ips, market.he)) {
                                delete queryParams.assignees;
                            }
                        }

                        var filters = workOrderFilters.getFilters(queryParams);

                        return $q.all({
                            initResponse: workOrderListService.getListData(filters).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('workOrderList')
    .controller('WorkOrderListController', function ($scope, $state, $location, $timeout, $stateParams, $q, moment, DudeApi, bulkPrintHelperService, userContext, clientHelperService, responsiveBreakpoints, log, $translate, workOrderListService, initData, workOrderFilters, queryHelpers, orderByHelpers, roleHelpers, workOrderEnums, market) {
        var self = this;

        var queryDefaults = workOrderFilters.getFilters({});
        var pageChanging = false;
        var quickAssigneeWatcher;
        var quickScheduleWatcher;

        var quickUpdates = {
            assignee: 'UpdateAssignee',
            scheduled: 'UpdateSchedule'
        };

        var lastQuickActionIndex;
        var lastQuickActionName;

        self.screenSize = clientHelperService.getCurrentScreenSize();
        self.breakpoints = responsiveBreakpoints;

        self.panelOptions = {};
        self.editing = {};

        self.market = market;

        // view model
        self.listData = initData.initResponse.data;
        self.filters = initData.filters;
        self.totalCount = initData.initResponse.total;
        self.sortable = orderByHelpers.initSort(self.filters.orderBy);
        $scope.sortFieldList = '';
        $scope.sortDirectionList = '';
        self.bulkWorkOrders = [];

        self.panelOptions.functions = {
            saveFunction: function () {
                return $q.resolve();
            },
            cancelFunction: function () {
                self.editing.workOrder = {};
            }
        };
        self.panelOptions.open = false;
        self.panelOptions.titles = {};
        self.editing.workOrder = {};
        self.editing.transaction = {};

        // priority and status values
        self.priority = workOrderEnums.priority;
        self.status = workOrderEnums.status;

        self.isRequester = roleHelpers.isRequester();
        self.isTechnician = roleHelpers.isTechnician();

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.status = cloned.status === 'all' ? [] : cloned.status;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, workOrderFilters.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (items) {
            self.filters.orderBy = items;
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.export = function () {
            workOrderListService.exportSpreadsheet(self.filters);
        };

        var updateFilters = function (newVal, oldVal) {
            if (workOrderFilters.checkFilterDifferences(newVal, oldVal)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                newVal.page = 1;
            }

            pageChanging = false;

            workOrderListService.getListData(newVal).$promise.then(setData);

            var stateVal = workOrderFilters.getFilters(angular.copy(newVal));
            stateVal.requestedBy = null;

            queryHelpers.updateState(stateVal, queryDefaults);

            // reset these so that the quick actions open properly
            lastQuickActionIndex = null;
            lastQuickActionName = null;
        };

        var updateWorkOrder = function (index) {
            self.listData[index].$update({ id: self.listData[index].id }).then(function () {
                switch (lastQuickActionName) {
                case quickUpdates.assignee:
                    self.listData[index].quickActionsUpdateAssignee = true;
                    break;
                case quickUpdates.scheduled:
                    self.listData[index].quickActionsUpdateSchedule = true;
                    break;
                default:
                    break;
                }

                log.notify({
                    type: 'success',
                    title: $translate.instant('workOrderForm.notificationTitle'),
                    message: $translate.instant('workOrderForm.notification')
                });
            });
        };

        self.closeLastQuickAction = function () {
            if (lastQuickActionIndex !== null && lastQuickActionName !== null) {
                switch (lastQuickActionName) {
                case quickUpdates.assignee: {
                    quickAssigneeWatcher();
                    self.listData[lastQuickActionIndex].quickActionsUpdateAssignee = false;
                    delete self.listData[lastQuickActionIndex].assigneesCopy;
                    break;
                }
                case quickUpdates.scheduled: {
                    quickScheduleWatcher();
                    self.listData[lastQuickActionIndex].quickActionsUpdateSchedule = false;
                    break;
                }
                default:
                    break;
                }
            }
            lastQuickActionIndex = null;
            lastQuickActionName = null;
        };

        self.updateAssignees = function (index) {
            var workOrder = self.listData[index];
            workOrder.quickActionsUpdateAssignee = true;

            self.closeLastQuickAction();

            if (workOrder.quickActionsUpdateAssignee) {
                lastQuickActionIndex = index;
                lastQuickActionName = quickUpdates.assignee;

                quickAssigneeWatcher = $scope.$watchCollection(function () {
                    return workOrder.assignees;
                }, function (newVal, oldVal) {
                    if (angular.equals(newVal, oldVal)) {
                        return;
                    }
                    updateWorkOrder(index);
                }, true);
            } else {
                lastQuickActionIndex = null;
                lastQuickActionName = null;
            }
        };

        self.updateSchedule = function (index) {
            var workOrder = self.listData[index];
            workOrder.quickActionsUpdateSchedule = true;

            self.closeLastQuickAction();

            if (workOrder.quickActionsUpdateSchedule) {
                lastQuickActionIndex = index;
                lastQuickActionName = quickUpdates.scheduled;

                quickScheduleWatcher = $scope.$watch(function () {
                    return workOrder;
                }, function (newVal, oldVal) {
                    var oldSchedStartDate;
                    var newSchedStartDate;
                    var oldDueDate;
                    var newDueDate;

                    oldSchedStartDate = oldVal.scheduledStartDate === null ? oldVal.scheduledStartDate : moment(oldVal.scheduledStartDate).format('YYYY-MM-DD');
                    newSchedStartDate = newVal.scheduledStartDate === null ? newVal.scheduledStartDate : moment(newVal.scheduledStartDate).format('YYYY-MM-DD');
                    oldDueDate = oldVal.dueDateTime === null ? oldVal.dueDateTime : moment(oldVal.dueDateTime).format('YYYY-MM-DD');
                    newDueDate = newVal.dueDateTime === null ? newVal.dueDateTime : moment(newVal.dueDateTime).format('YYYY-MM-DD');

                    if ((oldSchedStartDate !== newSchedStartDate) || (oldDueDate !== newDueDate)) {
                        updateWorkOrder(index);
                    }
                }, true);
            } else {
                lastQuickActionIndex = null;
                lastQuickActionName = null;
            }
        };

        var getInitialBulk = function () {
            var idArray = angular.copy($stateParams.woid);
            if (!idArray) {
                return;
            } else if (!Array.isArray(idArray)) {
                idArray = [idArray];
            }

            self.listData.forEach(function (workOrder) {
                if (idArray.indexOf(workOrder.id + '') > -1) {
                    workOrder.bulk = true;
                    self.bulkWorkOrders.push(workOrder);
                }
            });

            self.allBulk = self.listData.length > 0 && self.bulkWorkOrders.length === self.listData.length;
        };

        getInitialBulk();

        self.updateBulk = function (event, workOrder) {
            event.stopPropagation();
            if (!self.bulkWorkOrders.length) {
                self.closeLastQuickAction();
                workOrder.bulk = true;
                self.bulkWorkOrders.push(workOrder);
            } else {
                var bulkCopy = angular.copy(self.bulkWorkOrders);
                var alreadyExists = bulkCopy.some(function (bulkWorkOrder, index) {
                    var match = bulkWorkOrder.id === workOrder.id;
                    if (match) {
                        workOrder.bulk = false;
                        self.bulkWorkOrders.splice(index, 1);
                    }
                    return match;
                });

                if (!alreadyExists) {
                    workOrder.bulk = true;
                    self.bulkWorkOrders.push(workOrder);
                }
            }
        };

        $scope.$watchCollection('workOrderList.bulkWorkOrders', function () {
            var params = workOrderFilters.getFilters(angular.copy(self.filters));

            params.woid = self.bulkWorkOrders.map(function (workOrder) {
                return workOrder.id;
            });

            self.allBulk = self.listData.length > 0 && self.bulkWorkOrders.length === self.listData.length;
            queryHelpers.updateState(params, queryDefaults);
        });

        self.bulkAction = function (actionType) {
            self.bulkPanelOpen = true;
            self.bulkActionType = actionType;
        };

        self.bulkPrint = function (isSummary) {
            var entity = isSummary ? 'WorkOrderBulkPrintSummaryEntity' : 'WorkOrderBulkPrintEntity';
            var labels = {
                title: $translate.instant('workOrderList.title'),
                display: $translate.instant('workOrderList.bulkActions.printLabels.display'),
                loading: $translate.instant('workOrderList.bulkActions.printLabels.loading')
            };
            var bulkPrintBody = { workOrderId: [], timeZone: moment.tz.guess(), orderBy: self.filters.orderBy };
            self.bulkWorkOrders.forEach(function (workOrder) {
                bulkPrintBody.workOrderId.push(workOrder.id);
            });

            bulkPrintHelperService.bulkPrint(entity, bulkPrintBody, labels);
            self.clearAll();
        };

        self.selectAllBulk = function () {
            var bulkState = self.bulkWorkOrders.length < self.listData.length;
            self.bulkWorkOrders = [];

            self.listData.forEach(function (workOrder) {
                workOrder.bulk = bulkState;
                if (bulkState) {
                    self.bulkWorkOrders.push(workOrder);
                }
            });
        };

        self.clearAll = function () {
            self.allBulk = false;
            self.bulkWorkOrders.forEach(function (workOrder) {
                workOrder.bulk = false;
            });
            self.bulkWorkOrders = [];
        };

        self.edit = function (id) {
            if (self.bulkWorkOrders.length) {
                return;
            }

            $state.go('secure.workOrderFormEdit', { id: id });
        };

        self.viewWorkOrderReadOnly = function (id) {
            $state.go('secure.workOrderFormReadOnly', { id: id });
        };

        $scope.$watch('workOrderList.filters', updateFilters, true);
    });

/**
 * @ngdoc directive
 * @name workOrderList.work-order-bulk-action
 * @restrict E
 * @description
 * Handles the sliding panel and logic for bulk actions
 *
 * @param {array} workOrders An array of work orders to perform actions against
 * @param {boolean} panelOpen A boolean stating whether or not the sliding panel is open
 * @param {string} action The bulk action to perform
 *
 * <work-order-bulk-action work-orders="someWorkOrders" panel-open="true"></work-order-bulk-action>
 */

'use strict';

angular.module('workOrderList')
    .component('workOrderBulkAction', {
        templateUrl: 'app/components/workOrderList/workOrderBulkAction.html',
        bindings: {
            panelOpen: '=',
            workOrders: '=',
            action: '='
        },
        controller: 'WorkOrderBulkActionComponent',
        controllerAs: 'bulkAction'
    });

angular.module('workOrderList')
    .controller('WorkOrderBulkActionComponent', function ($q, $scope, $translate, log, roles) {
        var self = this;
        self.assignees = [];
        self.roles = [roles.admin, roles.technician];

        self.assignmentTypes = {
            replace: 'replace',
            add: 'add'
        };

        var addAssignees = function (workOrder) {
            var workOrderAssignees = angular.copy(workOrder.assignees);
            self.assignees.forEach(function (assignee) {
                var isPresent = workOrderAssignees.some(function (workOrderAssignee) {
                    return assignee.id === workOrderAssignee.id;
                });

                if (!isPresent) {
                    workOrder.assignees.push(assignee);
                }
            });
        };

        self.panelFunctions = {
            saveFunction: function () {
                var promises = [];
                self.workOrders.forEach(function (workOrder) {
                    if (self.assignmentType === self.assignmentTypes.replace) {
                        workOrder.assignees = angular.copy(self.assignees);
                    } else {
                        addAssignees(workOrder);
                    }

                    promises.push(workOrder.$update({ id: workOrder.id }));
                });

                return $q.all(promises).then(function (results) {
                    self.workOrders = [];
                    self.assignees = [];
                    log.notify({
                        type: 'success',
                        title: $translate.instant('workOrderForm.notificationTitle'),
                        message: results.length + ' ' + $translate.instant('workOrderList.bulkActions.updatedSuccessfully')
                    });
                });
            },
            cancelFunction: function () {
                self.assignees = [];
            }
        };

        $scope.$watch('bulkAction.panelOpen', function (newVal) {
            if (newVal) {
                self.assignmentType = angular.copy(self.assignmentTypes.add);
                self.panelTitles = {
                    title: $translate.instant('workOrderList.assign'),
                    subtitle: '(' + self.workOrders.length + ' ' + $translate.instant('workOrderList.selected') + ')'
                };
            }
        });
    });

/**
 * @ngdoc directive
 * @name workOrderList.multiple-assignees
 * @restrict E
 * @description
 *
 * Displays a list of users
 *
 * @param {array} assignees The list of user objects to display
 *
 * <multiple-assignees assignees="assigneesArray"></multiple-assignees>
 */

'use strict';

angular.module('workOrderList')
    .component('multipleAssignees', {
        templateUrl: 'app/components/workOrderList/multipleAssignees.html',
        bindings: {
            assignees: '='
        },
        controller: 'MultipleAssigneesComponent',
        controllerAs: 'multipleAssignees'
    });

angular.module('workOrderList')
    .controller('MultipleAssigneesComponent', function () {
    });

'use strict';

angular.module('workOrderInventory', ['ui.bootstrap', 'page-controls', 'inventory-controls']);

/**
 * @ngdoc service
 * @name workOrderInventory.workOrderInventoryService
 * @requires $q
 * @requires DudeApi
 * @requires userContext
 *
 * @description
 * Service for supporting the work order inventory section
 *
 */

'use strict';

angular.module('workOrderInventory')
    .service('workOrderInventoryService', function ($q, DudeApi, userContext) {
        /**
         * @ngdoc method
         * @name getInventoryTransactions
         * @methodOf workOrderInventory.workOrderInventoryService
         *
         * @description
         * Gets the inventory transactions associated to the work order.
         *
         * @param {int} displayId The work order display ID.
         */
        var getInventoryTransactions = function (displayId) {
            if (userContext && userContext.products && userContext.products.InventoryManager) {
                var inventoryTransactions;
                var query = {
                    workOrderDisplayIds: [displayId]
                };

                return $q(function (resolve) {
                    DudeApi.InventoryTransactionEntity.query(query).$promise
                        .then(function (transactions) {
                            inventoryTransactions = transactions.data;

                            var promises = inventoryTransactions.map(function (inventoryTransaction) {
                                return DudeApi.BusinessAssetEntity.get({ id: inventoryTransaction.inventoryTransactionDetails[0].businessAssetId }).$promise;
                            });

                            $q.all(promises).then(function (assets) {
                                inventoryTransactions.forEach(function (inventoryTransaction, index) {
                                    inventoryTransaction.asset = assets[index];
                                });

                                resolve(inventoryTransactions);
                            });
                        });
                });
            }

            return $q(function (resolve) {
                resolve([]);
            });
        };

        return {
            getInventoryTransactions: getInventoryTransactions
        };
    });

/**
 * @ngdoc directive
 * @name workOrderInventory.workOrderInventory
 * @restrict E
 * @description
 * @requires workOrderInventoryService
 *
 * Displays a work order's inventory-specific information on the work order form.
 *
 * @param {Array} inventoryTransactions Array of Inventory Transactions associated to work order.
 * @param {boolean} openWhen The value to watch for when to open the sliding panel.
 * @param {Object} spies Scroll spy object.
 *
 * <work-order-inventory></work-order-inventory>
 */

'use strict';

angular.module('workOrderInventory')
    .component('workOrderInventory', {
        templateUrl: 'app/components/workOrderInventory/workOrderInventory.html',
        bindings: {
            inventoryTransactions: '=',
            openWhen: '=',
            spies: '=',
            workOrder: '<'
        },
        controller: 'WorkOrderInventoryController',
        controllerAs: 'workOrderInventory'
    })
    .controller('WorkOrderInventoryController', function (workOrderInventoryService) {
        var self = this;

        self.$onInit = function () {
            workOrderInventoryService.getInventoryTransactions(self.workOrder.displayId).then(function (inventoryTransactions) {
                self.inventoryTransactions = inventoryTransactions;
            });
        };
    });

/**
 * @ngdoc service
 * @name history.workOrderHistoryListService
 *
 * @description
 * Service for the work order history list page.
 *
 * @requires $q
 * @requires DudeApi
 * @requires historyService
 *
 */

'use strict';

angular.module('history')
    .service('workOrderHistoryListService', function ($q, DudeApi, historyService) {
        /**
         * @ngdoc method
         * @name convertToHistoryFilter
         * @methodOf history.workOrderHistoryListService
         *
         * @description
         * Takes Core filters and converts them to a history filter for the results
         * from Core.
         *
         * @param {object} filters Object containing the filters for Core.
         * @param {string} objectType The type of change object to query for
         *
         * @returns {Promise} currentFilter The filter object updated to have all of the
         *                   desired filters plus all of the default ones.
         */
        var convertToHistoryFilter = function (filters, objectType) {
            return $q(function (resolve) {
                var newFilters = angular.copy(filters);
                newFilters.includeSubCollections = true;
                newFilters.objectType = objectType;

                var workOrderFilters = {};

                if (filters.q != null && typeof filters.q === 'string' && filters.q.trim().length > 0) {
                    workOrderFilters.q = filters.q;
                    workOrderFilters.includeDisplayIds = true;
                } else if (typeof filters.q === 'string') {
                    delete filters.q;
                }

                if ((filters.businessAsset != null && !Array.isArray(filters.businessAsset)) || (Array.isArray(filters.businessAsset) && filters.businessAsset.length > 0)) {
                    workOrderFilters.businessAsset = filters.businessAsset;
                    // TODO Uncomment line below when new filter is ready
                    // workOrderFilters.includeDescendants = filters.includeDescendants;
                }

                if (Object.keys(workOrderFilters).length > 0) {
                    DudeApi.WorkOrderEntity.query(workOrderFilters).$promise
                        .then(function (response) {
                            newFilters.q = null;
                            // TODO Uncomment line below when new filter is ready
                            // newFilters.includeDescendants = null;
                            newFilters.businessAsset = [];
                            newFilters.objectIds = response.data.map(function (workOrder) {
                                return workOrder.id;
                            });
                            if (response.total > 0) {
                                historyService.queryHistory(newFilters).then(resolve);
                            } else {
                                resolve({ data: [], total: 0 });
                            }
                        });
                } else {
                    historyService.queryHistory(filters).then(resolve);
                }
            });
        };

        /**
         * @ngdoc method
         * @name getWorkOrdersForHistory
         * @methodOf history.workOrderHistoryListService
         *
         * @description
         * Gets all of the work orders for the history records brought in
         *
         * @param {Array} workOrderChanges The work order changes
         *
         * @returns {Promise} A promise containing the result from getting the work orders associated with the work order changes
         */
        var getWorkOrdersForHistory = function (workOrderChanges) {
            var woIds = workOrderChanges.map(function (change) {
                if (change.parent) {
                    return change.parent.objectId;
                }
                return change.self.objectId;
            }).filter(function (value, index, arr) {
                return arr.indexOf(value) === index;
            });
            return DudeApi.WorkOrderEntity.query({ ids: woIds }).$promise;
        };

        return {
            convertToHistoryFilter: convertToHistoryFilter,
            getWorkOrdersForHistory: getWorkOrdersForHistory
        };
    });

'use strict';

angular.module('history')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.history.workorders', {
                url: 'workorders?orderBy&page&pageSize&q&businessAsset&includeDescendants&changeDateTimeTo&changeDateTimeFrom&userIds&fields&objectId',
                templateUrl: 'app/components/workOrderHistoryList/workOrderHistoryList.html',
                controller: 'WorkOrderHistoryListController',
                controllerAs: 'workOrderHistoryList',
                permissions: [permission.history.read],
                resolve: {
                    initialState: function ($stateParams, $q, DudeApi, historyService, workOrderHistoryListService, historyChangeTypes) {
                        var queryParams = $stateParams;
                        // TODO Uncomment line below when new filter is ready
                        // queryParams.includeDescendants = queryParams.businessAsset ? queryParams.includeDescendants : 'true';
                        var filters = historyService.toApiFilter(queryParams);
                        var workOrderHistory = workOrderHistoryListService.convertToHistoryFilter(filters, historyChangeTypes.workOrder);

                        return $q.all({
                            filters: filters,
                            workOrderHistory: workOrderHistory
                        });
                    },
                    workOrders: function (initialState, workOrderHistoryListService) {
                        return workOrderHistoryListService.getWorkOrdersForHistory(initialState.workOrderHistory.data);
                    }
                }
            });
    });

'use strict';

angular.module('history')
    .controller('WorkOrderHistoryListController', function ($q, $scope, $translate, moment, queryHelpers, clientHelperService, responsiveBreakpoints, historyService, initialState, workOrders, workOrderHistoryListService, historyChangeTypes, filterStateService) {
        var self = this;
        var pageChanging = false;
        var queryDefaults = historyService.getFilters({});
        // TODO Uncomment line below when new filter is ready
        // var isEduMarket = marketizr.hasMarkets([market.k12, market.ips, market.he]);
        var ignoreBadges = ['page', 'pageSize', 'orderBy', 'includeDescendants'];
        var lastUpdated = new Date().getTime();

        var changesIds = function (changes) {
            return changes.map(function (change) {
                change.workOrderId = change.parent != null ? change.parent.objectId : change.self.objectId;
                return change;
            });
        };

        var setWorkOrders = function (wos, now) {
            if (now < lastUpdated) {
                return;
            }
            self.workOrders = wos.data.reduce(function (map, val) {
                map[val.id] = val;
                return map;
            }, {});
        };

        var setData = function (response, now) {
            if (now < lastUpdated) {
                return;
            }
            lastUpdated = now;
            self.changes = changesIds(response.data);
            var existsInList = false;
            self.changes.forEach(function (change) {
                if (self.activeChange && change.key === self.activeChange.key) {
                    existsInList = true;
                }
            });

            if (!existsInList && self.changes.length > 0) {
                self.activeChange = self.changes[0];
            } else if (self.changes.length === 0) {
                self.activeChange = null;
            }
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            var now = new Date().getTime();
            if (now > lastUpdated) {
                lastUpdated = now;
            }
            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;
            var changesResponse;
            workOrderHistoryListService.convertToHistoryFilter(self.filters, historyChangeTypes.workOrder)
                .then(function (response) {
                    changesResponse = response;
                    return workOrderHistoryListService.getWorkOrdersForHistory(response.data);
                })
                .then(function (wos) {
                    setWorkOrders(wos, now);
                    return changesResponse;
                })
                .then(function (response) {
                    setData(response, now);
                });
            queryHelpers.updateState(newVal, queryDefaults);
        };

        self.filters = initialState.filters;
        filterStateService.setState({}, ignoreBadges);
        self.totalCount = initialState.workOrderHistory.total;

        self.changes = changesIds(initialState.workOrderHistory.data);
        self.activeChange = (self.changes && self.changes[0]) || null;

        $scope.$watch('workOrderHistoryList.filters', updateFilters, true);

        setWorkOrders(workOrders, lastUpdated);

        self.setActiveChange = function (change) {
            self.activeChange = change;
        };

        self.openFilters = function () {
            self.filterOpen = true;
        };

        self.clearFilters = function () {
            self.filters = historyService.toApiFilter({});
            // TODO Uncomment line below when new filter is ready
            // if (isEduMarket) {
            //     self.filters.includeDescendants = 'true';
            // }
        };

        self.openPanel = function () {
            if (clientHelperService.getCurrentScreenSize().breakpoint === responsiveBreakpoints.xs) {
                self.panelOptions = {
                    buttonFunctions: {
                        saveFunction: function () {
                            return $q.resolve();
                        },
                        saveButtonText: $translate.instant('general.actions.close')
                    },
                    titles: {
                        title: moment(self.activeChange.changeDateTime).format('MM/DD/YYYY') + ' | ' + moment(self.activeChange.changeDateTime).format('hh:mm:ss a'),
                        subtitle: '( ID ' + self.workOrders[self.activeChange.workOrderId].displayId + ' )'
                    }
                };
                self.panelOpen = true;
            }
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        queryHelpers.updateState(self.filters, queryDefaults);
    });

/**
 * @ngdoc service
 * @name history.workOrderHistoryFiltersService
 *
 * @description
 * Service for the work order history filters component.
 *
 * @require historyService
 */

'use strict';

angular.module('history')
    .service('workOrderHistoryFiltersService', function (historyService) {
        var fields = {
            details: [
                {
                    name: historyService.translateFallback('history.changeFields.description'),
                    value: 'workorder-description'
                },
                {
                    name: historyService.translateFallback('history.changeFields.businessAsset'),
                    value: 'workorder-businessAsset'
                },
                {
                    name: historyService.translateFallback('history.changeFields.locationDescription'),
                    value: 'workorder-locationDescription'
                },
                {
                    name: historyService.translateFallback('history.changeFields.status'),
                    value: 'workorder-status'
                },
                {
                    name: historyService.translateFallback('history.changeFields.priority'),
                    value: 'workorder-priority'
                },
                {
                    name: historyService.translateFallback('history.changeFields.workType'),
                    value: 'workorder-workType'
                },
                {
                    name: historyService.translateFallback('history.changeFields.purpose'),
                    value: 'workorder-purpose'
                },
                {
                    name: historyService.translateFallback('history.changeFields.assignees'),
                    value: 'workorder-assignees'
                },
                {
                    name: historyService.translateFallback('history.changeFields.requestDateTime'),
                    value: 'workorder-requestDateTime'
                },
                {
                    name: historyService.translateFallback('history.changeFields.requestedBy'),
                    value: 'workorder-requestedBy'
                }
            ],
            planning: [
                {
                    name: historyService.translateFallback('history.changeFields.estimatedHours'),
                    value: 'workorder-estimatedHours'
                },
                {
                    name: historyService.translateFallback('history.changeFields.estimatedCost'),
                    value: 'workorder-estimatedCost'
                },
                {
                    name: historyService.translateFallback('history.changeFields.scheduledStartDate'),
                    value: 'workorder-scheduledStartDate'
                },
                {
                    name: historyService.translateFallback('history.changeFields.dueDateTime'),
                    value: 'workorder-dueDateTime'
                }
            ],
            tasks: [
                {
                    name: historyService.translateFallback('history.changeFields.notes'),
                    value: 'task-notes'
                },
                {
                    name: historyService.translateFallback('history.changeFields.order'),
                    value: 'task-order'
                },
                {
                    name: historyService.translateFallback('history.changeFields.status'),
                    value: 'task-status'
                },
                {
                    name: historyService.translateFallback('history.changeFields.title'),
                    value: 'task-title'
                },
                {
                    name: historyService.translateFallback('history.changeFields.procedure'),
                    value: 'task-procedure'
                }
            ],
            completion: [
                {
                    name: historyService.translateFallback('history.changeFields.actionTaken'),
                    value: 'workorder-actionTaken'
                },
                {
                    name: historyService.translateFallback('history.changeFields.completionDateTime'),
                    value: 'workorder-completionDateTime'
                }
            ],
            attachments: [
                {
                    name: historyService.translateFallback('history.changeFields.name'),
                    value: 'attachment-name'
                }
            ],
            laborTransactions: [
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.hours'),
                    value: 'labortransaction-typeAttributes.hours'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.laborType'),
                    value: 'labortransaction-typeAttributes.laborType'
                },
                {
                    name: historyService.translateFallback('history.changeFields.name'),
                    value: 'labortransaction-typeAttributes.user'
                },
                {
                    name: historyService.translateFallback('history.changeFields.transactionDate'),
                    value: 'labortransaction-transactionDate'
                }
            ],
            purchaseTransactions: [
                {
                    name: historyService.translateFallback('history.changeFields.itemPurchased'),
                    value: 'purchasetransaction-description'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.quantity'),
                    value: 'purchasetransaction-typeAttributes.quantity'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.unitCost'),
                    value: 'purchasetransaction-typeAttributes.unitCost'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.cost'),
                    value: 'purchasetransaction-typeAttributes.cost'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.purchaseOrder'),
                    value: 'purchasetransaction-typeAttributes.purchaseOrder'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.supplierName'),
                    value: 'purchasetransaction-typeAttributes.supplierName'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.user'),
                    value: 'purchasetransaction-typeAttributes.user'
                },
                {
                    name: historyService.translateFallback('history.changeFields.transactionDate'),
                    value: 'purchasetransaction-transactionDate'
                }
            ],
            serviceTransactions: [
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.serviceType'),
                    value: 'servicetransaction-typeAttributes.serviceType'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.vendor'),
                    value: 'servicetransaction-typeAttributes.supplierName'
                },
                {
                    name: historyService.translateFallback('history.changeFields.transactionDate'),
                    value: 'servicetransaction-transactionDate'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.cost'),
                    value: 'servicetransaction-typeAttributes.cost'
                },
                {
                    name: historyService.translateFallback('history.changeFields.typeAttributes.purchaseOrder'),
                    value: 'servicetransaction-typeAttributes.purchaseOrder'
                },
                {
                    name: historyService.translateFallback('history.changeFields.notes'),
                    value: 'servicetransaction-description'
                }
            ],
            links: [
                {
                    name: historyService.translateFallback('history.changeFields.description'),
                    value: 'weblink-description'
                },
                {
                    name: historyService.translateFallback('history.changeFields.title'),
                    value: 'weblink-title'
                },
                {
                    name: historyService.translateFallback('history.changeFields.url'),
                    value: 'weblink-url'
                }
            ]
        };

        /**
         * @ngdoc method
         * @name getFields
         * @methodOf history.workOrderHistoryFiltersService
         *
         * @description
         * Returns the list of field filters we wish to provide to the checkbox filter component
         *
         * @returns {object} Contains the different field sections with each field for filtering
         */
        var getFields = function () {
            return fields;
        };

        return {
            getFields: getFields
        };
    });

/**
 * @ngdoc directive
 * @restrict E
 * @name history.workOrderHistoryFilters
 * @description
 *
 * The work order history filter
 *
 * @param {any} filters The items to filter on.
 * @param {boolean} openWhen Determines when sliding panel should open
 * @param {function} clearFunction function reference to handle the clear action
 *
 */

'use strict';

angular.module('history')
    .component('workOrderHistoryFilters', {
        templateUrl: 'app/components/workOrderHistoryFilters/workOrderHistoryFilters.html',
        bindings: {
            filters: '=',
            openWhen: '=',
            clearFunction: '&'
        },
        controller: 'WorkOrderHistoryFiltersController',
        controllerAs: 'workOrderHistoryFilters'
    })
    .controller('WorkOrderHistoryFiltersController', function ($q, $scope, $translate, moment, marketizr, market, roles, workOrderHistoryFiltersService) {
        var self = this;
        var filtersTemp;

        var now = moment();
        var thisWeekStart = moment(now.startOf('week'));
        var thisWeekEnd = moment(now.endOf('week'));

        var lastWeek = moment().subtract(1, 'weeks');
        var lastWeekStart = moment(lastWeek.startOf('week'));
        var lastWeekEnd = moment(lastWeek.endOf('week'));

        var thisMonthStart = moment(moment().startOf('month'));
        var thisMonthEnd = moment(moment().endOf('month'));

        var lastMonth = moment().subtract(1, 'months');
        var lastMonthStart = moment(lastMonth.startOf('month'));
        var lastMonthEnd = moment(lastMonth.endOf('month'));

        self.roles = [roles.admin, roles.technician, roles.requester];

        self.usersTitle = $translate.instant('workOrderHistoryFilters.usersTitle');

        self.fields = workOrderHistoryFiltersService.getFields();
        self.fieldTitles = [
            'details',
            'planning',
            'tasks',
            'completion',
            'laborTransactions',
            'purchaseTransactions',
            'serviceTransactions',
            'attachments',
            'links'
        ];

        self.dateIncrements = [
            {
                text: $translate.instant('workOrderHistoryFilters.dateIncrements.thisWeek'),
                startDate: thisWeekStart,
                endDate: thisWeekEnd
            },
            {
                text: $translate.instant('workOrderHistoryFilters.dateIncrements.lastWeek'),
                startDate: lastWeekStart,
                endDate: lastWeekEnd
            },
            {
                text: $translate.instant('workOrderHistoryFilters.dateIncrements.thisMonth'),
                startDate: thisMonthStart,
                endDate: thisMonthEnd
            },
            {
                text: $translate.instant('workOrderHistoryFilters.dateIncrements.lastMonth'),
                startDate: lastMonthStart,
                endDate: lastMonthEnd
            }
        ];

        var setFiltersBack = function () {
            if (filtersTemp) {
                self.filters = filtersTemp;
            }
        };

        self.isEduMarket = marketizr.hasMarkets([market.k12, market.he, market.ips]);

        self.browseOptions = {
            type: 'slidingPanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                }
            }
        };

        self.$onInit = function () {
            self.placeHolder = $translate.instant('workOrderHistoryFilters.searchPlaceholder');
            self.titles = { title: $translate.instant('workOrderHistoryFilters.title') };
            self.filters.changeDateTimeTo = self.filters.changeDateTimeTo ? moment(self.filters.changeDateTimeTo).toISOString() : null;
            self.filters.changeDateTimeFrom = self.filters.changeDateTimeFrom ? moment(self.filters.changeDateTimeFrom).toISOString() : null;
            self.filters.userIds = self.filters.userIds ? self.filters.userIds : [];
            self.filters.fields = self.filters.fields ? self.filters.fields : [];

            self.buttonFunctions = {
                saveFunction: function () {
                    return $q.resolve();
                },
                saveButtonText: $translate.instant('workOrderHistoryFilters.actions.apply'),
                cancelFunction: function () {
                    setFiltersBack();
                }
            };

            $scope.$watch('workOrderHistoryFilters.openWhen', function (newVal) {
                if (!newVal) {
                    return;
                }
                filtersTemp = angular.copy(self.filters);
            });
        };
    });

'use strict';

angular.module('workOrderFormReadOnly', ['ui.router', 'dudeControls', 'dudeControlsFile', 'dudeApi', 'dudeAuth', 'translate', 'helpers']);

'use strict';

angular.module('workOrderFormReadOnly')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.workOrderFormReadOnly', {
                url: 'workordersreadonly/:id',
                templateUrl: 'app/components/workOrderFormReadOnly/requesterFormReadOnly.html',
                controller: 'WorkOrderFormReadOnlyController',
                controllerAs: 'workOrderForm',
                resolve: {
                    workOrder: function ($stateParams, DudeApi) {
                        return DudeApi.WorkOrderEntity.get({ id: $stateParams.id, includeAudit: true }).$promise;
                    },
                    attachments: function ($stateParams, DudeApi) {
                        return DudeApi.WorkOrderAttachmentEntity.query({ workorderId: $stateParams.id }).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('workOrderFormReadOnly')
    .controller('WorkOrderFormReadOnlyController', function ($scope, $state, $translate, attachments, attachmentHelpers, DudeApi, fileHelpers, market, marketizr, workOrder, workOrderEnums, log) {
        var self = this;
        self.attachments = attachments.data;
        self.isEduMarket = marketizr.hasMarkets([market.k12, market.he, market.ips]);
        self.workOrder = workOrder.result ? workOrder.result : workOrder;
        self.status = workOrderEnums.status;
        self.spies = [];
        self.files = fileHelpers.populateFiles(self.attachments);
        var offsetPadding = 50;
        self.headerOffset = angular.element('.main-nav').outerHeight(true) + angular.element('.header-container').outerHeight(true) + offsetPadding;

        var saveUploadedAttachment = function (file) {
            var attachment = attachmentHelpers.saveAttachmentReference(file, new DudeApi.WorkOrderAttachmentEntity());
            attachment.$save({ workorderId: workOrder.id }).then(function () {
                self.attachments.push(attachment);
                file.saved = true;
                log.notify({
                    type: 'success',
                    title: $translate.instant('attachments.notify.upload.success'),
                    message: file.filename + ' ' + $translate.instant('workOrderForm.notify.upload.successBody')
                });
            });
        };

        var uploadSuccessHandler = function (file) {
            return function (response) {
                response.uploading = false;
                var fileToExtend = self.files[self.files.indexOf(file)];
                angular.extend(fileToExtend, response);
                saveUploadedAttachment(fileToExtend);
            };
        };

        var uploadErrorHandler = function (file) {
            return function (error) {
                var fileToExtend = self.files[self.files.indexOf(file)];
                angular.extend(fileToExtend, {
                    uploading: false,
                    error: true,
                    errorMessage: fileHelpers.errorMessage(error.data.message)
                });

                log.notify({
                    type: 'error',
                    title: $translate.instant('attachments.notify.upload.error'),
                    message: error.data.message
                });
            };
        };

        var addToList = function (file) {
            // if they have set the file, and then cancel on the next one
            // the file comes back as undefined, this check makes sure we
            // do nothing in this case
            if (!angular.isDefined(file)) {
                return null;
            }

            var object = {
                name: file.name
            };

            self.files.push(object);
            return object;
        };

        self.upload = function () {
            var transformedFile = addToList(self.file);
            var upload = fileHelpers.uploadFile(self.file);
            upload.then(uploadSuccessHandler(transformedFile), uploadErrorHandler(transformedFile));
        };

        $scope.$watch('workOrderForm.file', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) {
                return;
            }
            self.upload();
        });
    });

/**
 * @ngdoc service
 * @name workOrderForm.workOrderFormHelpers
 * @requires $state
 * @requires userContext
 * @requires helpers.roleHelpers
 * @requires workOrderEnums
 * @requires helpers.defaultPurposesService
 * @requires $q
 * @requires DudeApi
 *
 * @description
 * Service for supporting the work order form by setting up the form for various roles along with useful functionality
 *
 */

'use strict';

angular.module('workOrderForm')
    .factory('workOrderFormHelpers', function ($state, $q, DudeApi, marketizr, market, userContext, roleHelpers, workOrderEnums, defaultPurposesService) {
        /**
         * @ngdoc method
         * @name setToday
         * @methodOf workOrderForm.workOrderFormHelpers
         *
         * @description
         * Sets the date to today's date zeroing out seconds and milliseconds
         *
         * @param {boolean} zeroOutTime A boolean which will cause all time to be set to zero if set to true
         * @returns {date} Today's date
         */
        var setToday = function (zeroOutTime) {
            var date = new Date();
            date.setSeconds(0);
            date.setMilliseconds(0);

            if (zeroOutTime) {
                date.setHours(0);
                date.setMinutes(0);
            }

            return date;
        };

        /**
         * @ngdoc method
         * @name setDefaults
         * @methodOf workOrderForm.workOrderFormHelpers
         *
         * @description
         * Sets the defaults for a work order for set roles
         *
         * @param {object} workOrder An object containing the current work order information
         */
        var setDefaults = function (workOrder) {
            workOrder.status = workOrderEnums.status.newRequest;
            workOrder.priority = workOrderEnums.priority.medium;

            workOrder.requestedBy = angular.copy(userContext.user);

            defaultPurposesService.getPurpose(defaultPurposesService.purposeKeys.reactivePurpose).then(function (purpose) {
                workOrder.purpose = purpose;
            });

            if (!Array.isArray(workOrder.assignees)) {
                workOrder.assignees = [];
            }

            workOrder.downtimeTracking = {};
            workOrder.requestDateTime = setToday();
            if (marketizr.hasMarkets([market.k12, market.ips, market.he])) {
                workOrder.scheduledStartDate = setToday();
            }
            if (roleHelpers.isTechnician()) {
                workOrder.assignees = [userContext.user];
            }
        };

        /**
         * @ngdoc method
         * @name saveRoute
         * @methodOf workOrderForm.workOrderFormHelpers
         *
         * @description
         * Navigates from the new work order on save to different routes depending on the users role
         *
         * @param {number} id The id of the saved work order
         */
        var saveRoute = function (id) {
            if (roleHelpers.isRequester()) {
                $state.go('secure.workOrderList');
            } else {
                $state.go('secure.workOrderFormEdit', { id: id });
            }
        };

        /**
         * @ngdoc method
         * @name setDowntimeTrackingDuration
         * @methodOf workOrderForm.workOrderFormHelpers
         *
         * @description
         * Sets the downtime tracking in terms of milliseconds to save to the api
         *
         * @param {object} workOrder The work order object for the current work order
         */
        var setDowntimeTrackingDuration = function (workOrder) {
            workOrder.downtimeTracking.duration = 0;

            if (workOrder.downtimeTracking.hours) {
                workOrder.downtimeTracking.hours = (typeof workOrder.downtimeTracking.hours) === 'number' ? workOrder.downtimeTracking.hours : parseInt(workOrder.downtimeTracking.hours.replace(/,/g, ''), 10);
                workOrder.downtimeTracking.duration = parseFloat(workOrder.downtimeTracking.hours) * 60 * 60 * 1000;
            }

            if (workOrder.downtimeTracking.minutes) {
                workOrder.downtimeTracking.duration += (parseFloat(workOrder.downtimeTracking.minutes) * 60 * 1000);
            }
        };

        /**
         * @ngdoc method
         * @name readDowntimeTrackingDuration
         * @methodOf workOrderForm.workOrderFormHelpers
         *
         * @description
         * Reads the downtime tracking in terms of milliseconds and converts it to the form's hours and minute fields
         *
         * @param {object} workOrder The work order object for the current work order
         */
        var readDowntimeTrackingDuration = function (workOrder) {
            if (!workOrder.downtimeTracking) {
                return;
            }

            if (workOrder.downtimeTracking.duration) {
                workOrder.downtimeTracking.hours = Math.floor(workOrder.downtimeTracking.duration / (1000 * 60 * 60));
                workOrder.downtimeTracking.minutes = Math.floor((workOrder.downtimeTracking.duration / (1000 * 60)) % 60);
            }
        };

        return {
            setDefaults: setDefaults,
            setToday: setToday,
            saveRoute: saveRoute,
            setDowntimeTrackingDuration: setDowntimeTrackingDuration,
            readDowntimeTrackingDuration: readDowntimeTrackingDuration
        };
    });

'use strict';

angular.module('workOrderForm')
    .config(function ($stateProvider, permission) {
        // secure. base route in dudeAuth
        $stateProvider
            .state('secure.workOrderFormNew', {
                url: 'workorders/new?businessAsset&project',
                templateUrl: 'app/components/workOrderForm/workOrderForm.html',
                controller: 'WorkOrderFormController',
                controllerAs: 'workOrderForm',
                resolve: {
                    workOrder: function ($stateParams, DudeApi, workOrderFormHelpers) {
                        var entity = new DudeApi.WorkOrderEntity({});
                        workOrderFormHelpers.setDefaults(entity);
                        if (angular.isDefined($stateParams.businessAsset)) {
                            return DudeApi.BusinessAssetEntity.get({ id: $stateParams.businessAsset }).$promise.then(function (asset) {
                                entity.businessAsset = asset;
                                return entity;
                            });
                        } else if (angular.isDefined($stateParams.project)) {
                            return DudeApi.ProjectEntity.get({ id: $stateParams.project }).$promise.then(function (project) {
                                entity.project = project;
                                return entity;
                            });
                        }
                        return entity;
                    },
                    attachments: function () {
                        return [];
                    },
                    transactions: function () {
                        return [];
                    },
                    tasks: function () {
                        return [];
                    },
                    hasInventory: function () {
                        return false;
                    },
                    areaRoomNumberHelper: function (roleHelpers, settingsHelpers) {
                        if (!roleHelpers.isRequester()) {
                            return false;
                        }
                        return settingsHelpers.getLocationDescription();
                    }
                }
            })
            .state('secure.workOrderFormEdit', {
                url: 'workorders/:id',
                templateUrl: 'app/components/workOrderForm/workOrderForm.html',
                controller: 'WorkOrderFormController',
                controllerAs: 'workOrderForm',
                permissions: [permission.workOrders.update],
                resolve: {
                    workOrder: function ($stateParams, DudeApi) {
                        return DudeApi.WorkOrderEntity.get({ id: $stateParams.id, includeAudit: true }).$promise;
                    },
                    attachments: function ($stateParams, DudeApi) {
                        return DudeApi.WorkOrderAttachmentEntity.query({ workorderId: $stateParams.id }).$promise;
                    },
                    transactions: function ($stateParams, DudeApi) {
                        var query = {
                            workorderId: $stateParams.id,
                            orderBy: 'TransactionDate desc,CreatedDateTime desc',
                            includeAudit: true
                        };
                        return DudeApi.WorkOrderTransactionEntity.query(query).$promise;
                    },
                    tasks: function ($stateParams, DudeApi) {
                        var query = {
                            workorderId: $stateParams.id,
                            orderBy: 'Order asc'
                        };
                        return DudeApi.WorkOrderTaskEntity.query(query).$promise;
                    },
                    hasInventory: function (userContext) {
                        return userContext && userContext.products && userContext.products.InventoryManager != null;
                    },
                    areaRoomNumberHelper: function () {
                        return false;
                    }
                }
            });
    });

'use strict';

angular.module('workOrderForm')
    .controller('WorkOrderFormController', function ($scope, $state, $filter, $q, $document, $translate, $uibModal, DudeApi, slidingPanelSelectStorageAreaService, userContext, log, permissionsHelper, permission, moment, market, marketizr, roleHelpers, workOrderFormHelpers, workOrder, transactions, attachments, tasks, hasInventory, fileHelpers, attachmentHelpers, transactionHelpers, historyChangeTypes, areaRoomNumberHelper) {
        var self = this;
        var filesUploadingCount = 0;
        var canAddInventoryTransactionIssue = permissionsHelper.userAllowed(permission.inventoryTransactions.issue);
        var isEduMarket = marketizr.hasMarkets([market.k12, market.ips, market.he]);
        self.workOrder = workOrder.result ? workOrder.result : workOrder;
        self.market = market;
        self.files = [];
        self.links = [];
        self.userContext = userContext;
        self.attachments = attachments.data;
        self.isNew = !workOrder.id;
        self.canAddTasks = permissionsHelper.userAllowed(permission.workOrders.createTasks);
        self.isTechnician = roleHelpers.isTechnician();
        self.isRequester = roleHelpers.isRequester();
        self.storageAreas = [];
        self.openStoragePanel = false;
        self.openIssueToWorkOrder = false;
        self.openHistoryPanel = false;
        self.areaRoomNumberHelper = areaRoomNumberHelper;
        self.inventory = {
            hasInventory: hasInventory,
            inventoryTransactions: []
        };
        self.historyEntity = {
            objectId: self.workOrder.id,
            objectType: historyChangeTypes.workOrder,
            parentId: null,
            parentType: null,
            includeSubCollections: true
        };

        self.tasks = angular.isDefined(tasks.data) ? tasks.data : [];
        var originalTasks = angular.copy(self.tasks);
        self.tasksToDelete = [];

        self.spies = [];
        var offsetPadding = 50;
        self.headerOffset = angular.element('.main-nav').outerHeight(true) + angular.element('.header-container').outerHeight(true) + offsetPadding;

        if (!self.isNew) {
            self.files = fileHelpers.populateFiles(self.attachments);
            self.transactions = transactionHelpers.parseTransactions(transactions.data, userContext);
        }

        workOrderFormHelpers.readDowntimeTrackingDuration(workOrder);
        // Private methods

        var removeAttachmentErrors = function () {
            self.files = $filter('filter')(self.files, function (file) {
                return file.id;
            });
        };

        var workOrderSaveSuccess = function (id) {
            log.notify({
                type: 'success',
                title: $translate.instant('workOrderForm.notificationTitle'),
                message: $translate.instant('workOrderForm.notification')
            });

            workOrderFormHelpers.saveRoute(id);

            if (!self.isNew) {
                self.disableSave = false;
            }
        };

        var newWorkOrderAttachmentHandler = function (id) {
            var promises = [];
            for (var i = 0; i < self.files.length; i++) {
                if (self.files[i].mime) {
                    var attachment = attachmentHelpers.saveAttachmentReference(self.files[i], new DudeApi.WorkOrderAttachmentEntity());
                    promises.push(attachment.$save({ workorderId: id }));
                }
            }

            return $q.all(promises);
        };

        var removeFromList = function (fileIndex) {
            self.files.splice(fileIndex, 1);
        };

        var deleteFile = function (file) {
            // calls file api to remove file but doesn't handle result since user doesn't care if this succeeds for fails
            fileHelpers.deleteFile(file).$promise.then(angular.noop, angular.noop);
        };

        var deleteWarning = function (index, file) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/attachments/attachmentDeleteWarningModal.html',
                controller: 'AttachmentDeleteWarningModalController',
                size: 'sm',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                var attachment = attachmentHelpers.deleteAttachmentReference(file, self.attachments, new DudeApi.WorkOrderAttachmentEntity(), 'workOrder');
                attachment.$delete({ workorderId: workOrder.id, id: attachment.workOrderAttachmentId }).then(function () {
                    removeFromList(index);
                    deleteFile(file);
                    log.notify({
                        type: 'success',
                        title: $translate.instant('attachments.notify.deleteAttachment.title'),
                        message: attachment.name + ' ' + $translate.instant('attachments.notify.deleteAttachment.message')
                    });
                });
            });
        };

        var setUploadCheckInvalid = function () {
            $scope.form.uploadCheck.$setValidity('uploadInProgress', false);
        };

        var setUploadCheckValid = function () {
            $scope.form.uploadCheck.$setValidity('uploadInProgress', true);
        };

        var performUploadCheckValidation = function () {
            if (filesUploadingCount > 0) {
                setUploadCheckInvalid();
            } else {
                setUploadCheckValid();
            }
        };

        var addToList = function (file) {
            // if they have set the file, and then cancel on the next one
            // the file comes back as undefined, this check makes sure we
            // do nothing in this case
            if (!angular.isDefined(file)) {
                return null;
            }

            filesUploadingCount++;
            performUploadCheckValidation();
            var object = {
                name: file.name
            };

            self.files.push(object);
            return object;
        };

        var saveUploadedAttachment = function (file) {
            var attachment = attachmentHelpers.saveAttachmentReference(file, new DudeApi.WorkOrderAttachmentEntity());
            attachment.$save({ workorderId: workOrder.id }).then(function () {
                self.attachments.push(attachment);
                file.saved = true;
                log.notify({
                    type: 'success',
                    title: $translate.instant('attachments.notify.upload.success'),
                    message: file.filename + ' ' + $translate.instant('workOrderForm.notify.upload.successBody')
                });
            });
        };

        var uploadSuccessHandler = function (file) {
            return function (response) {
                filesUploadingCount--;
                performUploadCheckValidation();
                response.uploading = false;
                var fileToExtend = self.files[self.files.indexOf(file)];
                angular.extend(fileToExtend, response);

                if (!self.isNew) {
                    saveUploadedAttachment(fileToExtend);
                }
            };
        };

        var uploadErrorHandler = function (file) {
            return function (error) {
                filesUploadingCount--;
                performUploadCheckValidation();
                var fileToExtend = self.files[self.files.indexOf(file)];
                angular.extend(fileToExtend, {
                    uploading: false,
                    error: true,
                    errorMessage: fileHelpers.errorMessage(error.data.message)
                });

                log.notify({
                    type: 'error',
                    title: $translate.instant('attachments.notify.upload.error'),
                    message: error.data.message
                });
            };
        };

        var skipNavigationWarningModal = function () {
            self.skipNavigationWarning = true;
        };

        var saveTasksPromises = function () {
            var promises = [];
            var i;

            // delete tasks
            for (i = 0; i < self.tasksToDelete.length; i++) {
                var deleteTask = self.tasksToDelete[i];
                if (deleteTask.id) {
                    var deleteTaskPromise = DudeApi.WorkOrderTaskEntity.delete({
                        workorderId: self.workOrder.id,
                        id: deleteTask.id
                    }).$promise;

                    promises.push(deleteTaskPromise);
                }
            }
            // add tasks
            for (i = 0; i < self.tasks.length; i++) {
                var task = self.tasks[i];
                task.order = i + 1; // Make sure this is correct in the future

                // Check to see if the task has changed and if not then don't make the call
                if (!angular.equals(originalTasks[i], task) && task.title) {
                    var addTasksPromise = task.id ? DudeApi.WorkOrderTaskEntity.update({
                        workorderId: self.workOrder.id,
                        id: task.id
                    },
                        task).$promise : DudeApi.WorkOrderTaskEntity.save({
                            workorderId: self.workOrder.id
                        },
                        task).$promise;

                    promises.push(addTasksPromise);
                }
            }

            return promises;
        };

        self.showHistoryPanel = function () {
            self.openHistoryPanel = true;
        };

        self.canInventory = function () {
            return !self.isNew && self.inventory && self.inventory.hasInventory && canAddInventoryTransactionIssue;
        };

        self.saveWorkOrder = function () {
            self.disableSave = true;

            if (!isEduMarket && workOrder.downtimeTracking) {
                workOrderFormHelpers.setDowntimeTrackingDuration(workOrder);
            }

            var promise = !self.isNew ? workOrder.$update({
                id: workOrder.id,
                includeAudit: true
            }) : workOrder.$save({ includeAudit: true });
            var workOrderId;
            promise.then(function (data) {
                workOrderId = data.id;
                skipNavigationWarningModal();
                if (self.isNew) {
                    self.workOrder.updatedDateTime = data.updatedDateTime;
                    return newWorkOrderAttachmentHandler(data.id);
                }
                removeAttachmentErrors();

                if (data.downtimeTracking) {
                    workOrderFormHelpers.readDowntimeTrackingDuration(data);
                    // Display the hours with commas if needed
                    data.downtimeTracking.hours = data.downtimeTracking.hours ? $filter('number')(data.downtimeTracking.hours) : null;
                    data.downtimeTracking.cost = data.downtimeTracking.cost ? $filter('number')(data.downtimeTracking.cost, 2) : null;
                }
                self.workOrder.updatedDateTime = data.updatedDateTime;
                return $q.resolve();
            }).then(function () {
                var promises = [];
                self.links.forEach(function (link) {
                    // Links without IDs haven't been saved.
                    if (!link.id) {
                        link.objectId = workOrderId;
                        promises.push(DudeApi.WebLinksEntity.save(link).$promise);
                    }
                });

                if (promises.length > 0) {
                    return $q.all(promises);
                }

                return $q.resolve();
            }).then(function () {
                return $q.all(saveTasksPromises()).then(function () {
                    DudeApi.WorkOrderTaskEntity.query({
                        workorderId: self.workOrder.id,
                        orderBy: 'Order asc'
                    })
                        .$promise.then(function (response) {
                            self.tasks = response.data;
                            originalTasks = angular.copy(self.tasks);
                            self.tasksToDelete.length = 0;
                        });
                });
            }).then(function () {
                workOrderSaveSuccess(workOrderId);
                // Scroll to the top on save for edit
                $document.scrollTop(0);
            }, function () {
                self.disableSave = false;
            });
        };

        self.upload = function () {
            var transformedFile = addToList(self.file);
            var upload = fileHelpers.uploadFile(self.file);
            upload.then(uploadSuccessHandler(transformedFile), uploadErrorHandler(transformedFile));
        };

        self.deleteAttachment = function (index, file) {
            if (self.isNew) {
                removeFromList(index);
                deleteFile(file);
            } else {
                deleteWarning(index, file);
            }
        };

        self.printWorkOrder = function () {
            DudeApi.workOrderPrintService.print({ id: workOrder.id, timezone: moment.tz.guess() });
        };

        self.assetBrowseOptions = {
            type: 'slidingPanel',
            keepFiltersOpen: true,
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                }
            }
        };

        $scope.$watch('workOrderForm.tasksToDelete', function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (newVal.length > 0) {
                $scope.form.$dirty = true;
            }
        }, true);

        $scope.$watch('workOrderForm.file', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) {
                return;
            }
            self.upload();
        });
    });

'use strict';

angular.module('workOrderFilters', ['translate', 'dudeAuth', 'dudeControls', 'helpers', 'maintenanceConstants']);

/**
 * @ngdoc service
 * @name workOrderFilters.workOrderFilters
 * @requires pagingHelpers {@link http://frontend.dudesoln.com/ng-docs/DudeControls/#/api/filterHelpers.pagingHelpersService read the docs}
 * @requires helpers.roleHelpers
 * @requires userContext {@link http://frontend.dudesoln.com/ng-docs/DudeBase/#/api/dudeAuth.userContext read the docs}
 * @requires workOrderEnums {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApiConstants.workOrderEnums read the docs}
 *
 * @description
 * Service for supporting the work order list by handling filter logic
 *
 */

'use strict';

angular.module('workOrderFilters')
    .factory('workOrderFilters', function (pagingHelpers, roleHelpers, userContext, workOrderEnums, moment) {
        var filterKeys = ['page', 'pageSize', 'q', 'orderBy', 'priority', 'status', 'purpose', 'project', 'trade', 'requestDateFrom', 'requestDateTo', 'completionDateFrom', 'completionDateTo', 'assignees', 'businessAsset', 'unassigned', 'pmSchedule', 'includeDescendants', 'failureReason', 'hasScheduledStartDate', 'scheduledStartDateTo', 'scheduledStartDateFrom', 'dueDateFrom', 'dueDateTo', 'workType'];

        var checkArray = function (value) {
            if (!Array.isArray(value)) {
                var array = [];
                array.push(value);
                return array;
            }
            return value;
        };

        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf workOrderFilters.workOrderFilters
         *
         * @description
         * Returns a filter object parsed and formatted ready to use with the api
         *
         * @param {object} params An object containing the filter params to use
         * @param {boolean} isMap A boolean that states whether or not to use sorting and paging with the param object
         * @returns {object} Filter object
         */
        var getFilters = function (params, isMap) {
            var filters = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'RequestDateTime desc',
                q: params.q || null,
                priority: params.priority || [],
                status: params.status || [],
                workType: params.workType || [],
                purpose: params.purpose || [],
                project: params.project || [],
                trade: params.trade || [],
                requestDateFrom: params.requestDateFrom || null,
                requestDateTo: params.requestDateTo || null,
                completionDateFrom: params.completionDateFrom || null,
                completionDateTo: params.completionDateTo || null,
                assignees: params.assignees || null,
                businessAsset: params.businessAsset || [],
                unassigned: params.unassigned || null,
                pmSchedule: params.pmSchedule || null,
                includeDescendants: params.includeDescendants || null,
                failureReason: params.failureReason || [],
                scheduledStartDateFrom: params.scheduledStartDateFrom ? new Date(params.scheduledStartDateFrom).toISOString() : null,
                scheduledStartDateTo: params.scheduledStartDateTo ? new Date(params.scheduledStartDateTo).toISOString() : null,
                hasScheduledStartDate: params.hasScheduledStartDate || null,
                dueDateFrom: params.dueDateFrom || null,
                dueDateTo: params.dueDateTo || null
            };

            if (roleHelpers.isRequester()) {
                filters.requestedBy = userContext.user.id;
            }

            filters.priority = checkArray(filters.priority);
            filters.status = checkArray(filters.status);
            filters.workType = checkArray(filters.workType);
            filters.purpose = checkArray(filters.purpose);
            filters.project = checkArray(filters.project);
            filters.trade = checkArray(filters.trade);
            filters.businessAsset = checkArray(filters.businessAsset);
            filters.failureReason = checkArray(filters.failureReason);

            if (angular.isDefined(isMap) && isMap === true) {
                delete filters.page;
                delete filters.pageSize;
                delete filters.orderBy;
            }

            return filters;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf workOrderFilters.workOrderFilters
         *
         * @description
         * Converts a filter object to a useable state by the api
         *
         * @param {object} currentFilter An object containing the filter params to use
         * @param {boolean} isMap A boolean that states whether or not to use sorting and paging with the param object
         * @returns {object} Filter object
         */
        var toApiFilter = function (currentFilter, isMap) {
            var filter = getFilters(angular.copy(currentFilter), isMap);

            if (filter.unassigned === 'unassigned' && filter.assignees) {
                filter.unassigned = null;
            }

            if (filter.unassigned && filter.unassigned === 'unassigned') {
                filter.assignees = 'null';
            }

            if (filter.includeDescendants === 'false') {
                filter.includeDescendants = null;
            }

            if (filter.hasScheduledStartDate === 'false') {
                filter.scheduledStartDateFrom = null;
                filter.scheduledStartDateTo = null;
            }

            if (filter.status && (filter.status === 'all' || filter.status[0] === 'all')) {
                delete filter.status;
            }

            if (filter.priority && (filter.priority === 'all' || filter.priority[0] === 'all')) {
                delete filter.priority;
            }

            if (filter.orderBy && filter.orderBy.indexOf('DueDateTime') > -1) {
                filter.hasDueDate = true;
            } else {
                delete filter.hasDueDate;
            }

            return filter;
        };

        /**
         * @ngdoc method
         * @name setEndOfDayYesterday
         * @methodOf workOrderFilters.workOrderFilters
         *
         * @description
         * Returns a ISO string date set to the end of the day of the day before today
         *
         * @returns {string} Date ISO string
         */
        var setEndOfDayYesterday = function () {
            var date = new Date();
            date = new Date(date.setDate(date.getDate() - 1));
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            date.setMilliseconds(0);
            date = date.toISOString();
            return date;
        };

        /**
         * @ngdoc method
         * @name setOverdueFilter
         * @methodOf workOrderFilters.workOrderFilters
         *
         * @description
         * Returns a filter object used to show the overdue work orders
         *
         * @returns {object} Filter object
         */
        var setOverdueFilter = function () {
            var filter = {};
            var dueDateParam = 'dueDateTo';
            filter[dueDateParam] = setEndOfDayYesterday();
            filter.status = [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress];
            filter.orderBy = 'DueDateTime asc';
            return filter;
        };

        /**
         * @ngdoc method
         * @name setUnscheduledFilter
         * @methodOf workOrderFilters.workOrderFilters
         *
         * @description
         * Returns a filter object used to show the unscheduled work orders
         *
         * @returns {object} Filter object
         */
        var setUnscheduledFilter = function () {
            var filter = {};
            filter.hasScheduledStartDate = 'false';
            filter.status = [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress];
            return filter;
        };

        var dateComparison = function (oldDate, newDate) {
            if (!oldDate && !newDate) {
                return true;
            } else if ((oldDate && !newDate) || (newDate && !oldDate)) {
                return false;
            }
            return moment(new Date(newDate)).isSame(new Date(oldDate), 'days');
        };

        /**
         * @ngdoc method
         * @name checkFilterDifferences
         * @methodOf workOrderFilters.workOrderFilters
         *
         * @description
         * Checks to see if there are any differences in filters
         *
         * @param {object} oldVal An object containing the new version of the filters
         * @param {object} newVal An object containing the prior version of the filters
         * @returns {boolean} A boolean stating whether or not the filters have changed
         */
        var checkFilterDifferences = function (oldVal, newVal) {
            var unchanged = true;
            filterKeys.forEach(function (key) {
                var status;
                if (key.indexOf('Date') > -1) {
                    status = dateComparison(oldVal[key], newVal[key]);
                } else if (key.indexOf('assignees') > -1) {
                    var assignee1 = Array.isArray(oldVal[key]) ? oldVal[key][0] : oldVal[key];
                    var assignee2 = Array.isArray(newVal[key]) ? newVal[key][0] : newVal[key];
                    status = angular.equals(assignee1, assignee2);
                } else {
                    status = angular.equals(oldVal[key], newVal[key]);
                }

                unchanged = unchanged && status;
            });
            return unchanged;
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            setOverdueFilter: setOverdueFilter,
            setEndOfDayYesterday: setEndOfDayYesterday,
            checkFilterDifferences: checkFilterDifferences,
            setUnscheduledFilter: setUnscheduledFilter
        };
    });

/**
 * @ngdoc directive
 * @name workOrderFilters.work-order-filters
 * @description
 *
 * Displays the filter section for the work order list or map
 *
 * @param {object} filters stores the value of all defined filters
 * @param {boolean} hideFilters stores whether or not the filters are hidden so that they may be toggled
 * @param {boolean} isDisabled states whether or not to disable filters (optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('workOrderFilters', {
        templateUrl: 'app/components/workOrderFilters/workOrderFilters.html',
        bindings: {
            filters: '=',
            hideFilters: '=',
            isDisabled: '=?'
        },
        controller: 'WorkOrderFiltersController',
        controllerAs: 'workOrderFilters'
    })
    .controller('WorkOrderFiltersController', function ($scope, $window, $timeout, marketizr, market, moment, workOrderEnums, $translate, workOrderFilters, roleHelpers, roles) {
        var self = this;
        var isEduMarket = marketizr.hasMarkets([market.k12, market.he, market.ips]);
        var mobileWidth = 768;
        var openDefault = {
            open: true
        };

        self.roles = [roles.admin, roles.technician];
        self.market = market;
        self.sorting = {};
        self.isRequester = roleHelpers.isRequester();
        self.isTechnician = roleHelpers.isTechnician();
        self.overdueFilter = workOrderFilters.getFilters(workOrderFilters.setOverdueFilter());
        self.unscheduledFilter = workOrderFilters.getFilters(workOrderFilters.setUnscheduledFilter());
        self.dueDateFilterName = 'dueDate';
        self.workType = {};
        self.assigneeTitle = $translate.instant('workOrderFilters.assignee');

        self.assetBrowseOptions = {
            type: 'slidingPanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                }
            }
        };

        if (isEduMarket) {
            self.assetHideCheckBox = true;
        }

        if (self.isRequester) {
            self.additionalFilters = {
                isLocation: true
            };
            self.assetBrowseOptions.keepFiltersOpen = true;
        } else {
            self.assetBrowseOptions.filterPanel['asset-category'] = {
                filter: 'isLocation'
            };
        }

        var hasDateFunction = function (string) {
            string = string.slice(3);
            var firstCharacter = string[0].toLowerCase();
            return firstCharacter + string.slice(1);
        };

        var parseKeys = function (key) {
            // IMPORTANT the objects used to track open or closed on the component must be named the same as the corresponding filter keys

            var modifiedKey;
            var dateIndex = key.indexOf('Date');
            if (key === 'unassigned') {
                // Apply unassigned filter changes to the assignees accordion
                modifiedKey = 'assignees';
            } else if (dateIndex > -1) {
                // Since date filters have an additional to and from extension strip that to find the right accordion
                modifiedKey = key.indexOf('has') > -1 ? hasDateFunction(key) : key.slice(0, dateIndex + 4);
            } else {
                modifiedKey = key;
            }
            return modifiedKey;
        };

        // priority defaults to open.
        self.priority = angular.copy(openDefault);

        self.assignedToVisible = function () {
            return !roleHelpers.isRequester();
        };

        self.unassignedFilter = function () {
            if (self.filters.unassigned === 'unassigned') {
                self.filters.unassigned = null;
            } else {
                self.filters.unassigned = 'unassigned';
                self.assignees.filter = null;
                self.filters.assignees = null;
            }
        };

        self.dueDateSort = function () {
            self.filters.orderBy = 'DueDateTime asc';
            self.filters.status = ['NewRequest', 'WorkInProgress'];
        };

        self.setScheduled = function () {
            self.filters.hasScheduledStartDate = null;
            self.scheduledDatesDisabled = false;
            self.currentScheduledRange = $translate.instant('workOrderFilters.dateRanges.all');
        };

        var setUnscheduled = function () {
            self.filters.hasScheduledStartDate = 'false';
            self.scheduledDatesDisabled = true;
            self.currentScheduledRange = $translate.instant('workOrderFilters.dateRanges.unscheduled');
        };

        var now = moment();
        var todayStart = new Date(now.startOf('day'));
        var todayEnd = new Date(now.endOf('day'));
        var thisWeekStart = new Date(now.startOf('week'));
        var thisWeekEnd = new Date(now.endOf('week'));

        var yesterday = moment().subtract(1, 'day');
        var yesterdayStart = new Date(yesterday.startOf('day'));
        var yesterdayEnd = new Date(yesterday.endOf('day'));

        var lastWeek = moment().subtract(1, 'weeks');
        var lastWeekStart = new Date(lastWeek.startOf('week'));
        var lastWeekEnd = new Date(lastWeek.endOf('week'));

        var nextWeek = moment().add(1, 'weeks');
        var nextWeekStart = new Date(nextWeek.startOf('week'));
        var nextWeekEnd = new Date(nextWeek.endOf('week'));

        var thisMonthStart = new Date(moment().startOf('month'));
        var thisMonthEnd = new Date(moment().endOf('month'));

        var nextMonth = moment().add(1, 'months');
        var nextMonthStart = new Date(nextMonth.startOf('month'));
        var nextMonthEnd = new Date(nextMonth.endOf('month'));

        var eduScheduledStartRanges = [
            {
                text: $translate.instant('workOrderFilters.dateIncrements.thisWeek'),
                startDate: thisWeekStart,
                endDate: thisWeekEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.nextWeek'),
                startDate: nextWeekStart,
                endDate: nextWeekEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.thisMonth'),
                startDate: thisMonthStart,
                endDate: thisMonthEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.nextMonth'),
                startDate: nextMonthStart,
                endDate: nextMonthEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateRanges.unscheduled'),
                startDate: -2,
                endDate: -2,
                activeFunction: setUnscheduled
            }
        ];

        var mfgScheduledStartRanges = [
            {
                text: $translate.instant('workOrderFilters.dateRanges.next7'),
                startDate: moment().hours(0).minutes(0).seconds(0),
                endDate: moment().add(7, 'days').hours(23).minutes(59).seconds(59)
            },
            {
                text: $translate.instant('workOrderFilters.dateRanges.next30'),
                startDate: moment().hours(0).minutes(0).seconds(0),
                endDate: moment().add(30, 'days').hours(23).minutes(59).seconds(59)
            },
            {
                text: $translate.instant('workOrderFilters.dateRanges.unscheduled'),
                startDate: -2,
                endDate: -2,
                activeFunction: setUnscheduled
            }
        ];

        self.scheduledStartRanges = isEduMarket ? eduScheduledStartRanges : mfgScheduledStartRanges;

        self.dueDateIncrements = [
            {
                text: $translate.instant('workOrderFilters.dateIncrements.today'),
                startDate: todayStart,
                endDate: todayEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.thisWeek'),
                startDate: thisWeekStart,
                endDate: thisWeekEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.nextWeek'),
                startDate: nextWeekStart,
                endDate: nextWeekEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.thisMonth'),
                startDate: thisMonthStart,
                endDate: thisMonthEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.nextMonth'),
                startDate: nextMonthStart,
                endDate: nextMonthEnd
            }
        ];

        self.requestDateIncrements = [
            {
                text: $translate.instant('workOrderFilters.dateIncrements.today'),
                startDate: todayStart,
                endDate: todayEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.thisWeek'),
                startDate: thisWeekStart,
                endDate: thisWeekEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.lastWeek'),
                startDate: lastWeekStart,
                endDate: lastWeekEnd
            }
        ];

        self.completedDateIncrements = [
            {
                text: $translate.instant('workOrderFilters.dateIncrements.today'),
                startDate: todayStart,
                endDate: todayEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.yesterday'),
                startDate: yesterdayStart,
                endDate: yesterdayEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.thisWeek'),
                startDate: thisWeekStart,
                endDate: thisWeekEnd
            },
            {
                text: $translate.instant('workOrderFilters.dateIncrements.lastWeek'),
                startDate: lastWeekStart,
                endDate: lastWeekEnd
            }
        ];

        self.clearFilters = function (avoidUpdates) {
            if (self.isDisabled) {
                return;
            }
            self.workType.filter = null;
            self.purpose.filter = null;
            self.project.filter = null;
            self.trade.filter = null;
            self.assignees.filter = null;
            self.businessAsset.filter = null;
            self.failureReason.filter = null;
            if (!avoidUpdates) {
                self.filters = workOrderFilters.getFilters({});
                self.scheduledDatesDisabled = false;
                self.currentScheduledRange = 3;
                self.currentScheduledIncrement = 5;
            }

            if (isEduMarket) {
                self.filters.includeDescendants = 'true';
            }
        };

        self.openQuickFilters = function (openArray) {
            if ($window.innerWidth < mobileWidth) {
                // On mobile hide the filters after using a quick filter
                self.hideFilters = true;
            } else {
                openArray.forEach(function (param) {
                    // open all of the filters on the passed in array that are affected by this quick filter
                    self[param].open = true;
                });
            }
        };

        self.quickFilters = [
            {
                name: 'Overdue',
                filters: self.overdueFilter,
                callback: self.setScheduled,
                openList: ['status', 'dueDate']
            }, {
                name: 'Unscheduled',
                filters: self.unscheduledFilter,
                callback: setUnscheduled,
                openList: ['scheduledStartDate', 'status']
            }
        ];

        self.$onInit = function () {
            Object.keys(self.filters).forEach(function (key) {
                var keyToUse = parseKeys(key);
                if (Array.isArray(self.filters[key])) {
                    // if the value is an array and it is not empty then open the accordion
                    self[key] = self.filters[key].length > 0 ? angular.copy(openDefault) : {};
                } else if (self.filters[key]) {
                    // If the filter has value open the accordion
                    self[keyToUse] = angular.copy(openDefault);
                } else if (!self[keyToUse]) {
                    // If the filter does not have value and the accordion has not been opened then set the accordion closed
                    self[keyToUse] = {};
                }
            });

            $scope.$watch('filters.scheduledStartDateTo', function () {
                if (self.filters.hasScheduledStartDate === 'false') {
                    setUnscheduled();
                } else {
                    self.setScheduled();
                }
            });

            $scope.$watch('filters.scheduledStartDateFrom', function () {
                if (self.filters.hasScheduledStartDate === 'false') {
                    setUnscheduled();
                } else {
                    self.setScheduled();
                }
            });

            $scope.$watch('assignees.filter', function (newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }

                if (newVal !== null) {
                    self.filters.unassigned = null;
                }
            });
        };
    });

'use strict';

angular.module('workOrderComments', ['translate', 'dudeAuth', 'dudeControls']);

'use strict';

angular.module('workOrderComments')
    .controller('workOrderCommentsDeleteModalController', function ($uibModalInstance, $scope) {
        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

/**
 * @ngdoc service
 * @name workOrderComments.workOrderCommentsService
 * @requires DudeApi
 *
 * @description
 * Service for supporting work order comments
 *
 */

'use strict';

angular.module('workOrderComments')
    .service('workOrderCommentsService', function (DudeApi) {
        var COMMENT_PAGE_SIZE = 1000;
        /**
         * @ngdoc method
         * @name getCommentData
         * @methodOf workOrderComments.workOrderCommentsService
         *
         * @description
         * Gets the data for the work order comments
         *
         * @param {int} workOrderId the work order id to query with
         * @returns {promise} A promise containing the page wrapped work order comment data
         */

        var getCommentData = function (workOrderId) {
            var filters = {
                ownerId: workOrderId,
                ownerType: 'workorder',
                pageSize: COMMENT_PAGE_SIZE,
                includeAudit: true
            };

            return DudeApi.CommentEntity.query(filters).$promise;
        };

        return {
            getCommentData: getCommentData
        };
    });

/**
 * @ngdoc directive
 * @name workOrderComments.work-order-comments
 * @restrict E
 * @description
 *
 * Renders the comments section of the work order form
 *
 * @param {int} workOrderId The work order id
 * @param {boolean} saveAttempt Declares whether or not an attempt to save has been made
 * @param {array} spies The array of spies used by the scroll spy
 *
 */

'use strict';

angular.module('workOrderComments')
    .component('workOrderComments', {
        bindings: {
            workOrderId: '<',
            saveAttempt: '<',
            spies: '='
        },
        templateUrl: 'app/components/workOrderComments/workOrderComments.html',
        controller: 'WorkOrderCommentsComponent',
        controllerAs: 'workOrderComments'
    })
    .controller('WorkOrderCommentsComponent', function ($translate, $uibModal, DudeApi, log, workOrderCommentsService, permissionsHelper, permission, roleHelpers, userContext) {
        var self = this;

        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('workOrderComments.notify.delete.title'),
                type: 'success',
                message: $translate.instant('workOrderComments.notify.delete.message')
            });
        };

        var showSaveMessage = function () {
            log.notify({
                type: 'success',
                title: $translate.instant('workOrderComments.notify.save.title'),
                message: $translate.instant('workOrderComments.notify.save.message')
            });
        };

        var parseComments = function (comments, userId) {
            var parsedComments = [];
            comments.forEach(function (comment) {
                comment.isEditable = false;
                if (permissionsHelper.userAllowed(permission.users.create) || (comment.postedBy.id !== null && comment.postedBy.id === userId)) {
                    comment.isEditable = true;
                }
                if (comment.audit.updatedDateTime > comment.audit.createdDateTime) {
                    comment.edited = true;
                }
                // boolean value and checkbox value are flipped
                comment.isInternalCheckbox = !comment.isInternal;
                parsedComments.push(comment);
            });
            return parsedComments;
        };

        self.saveComment = function () {
            var newComment = new DudeApi.CommentEntity({
                text: self.comment.text,
                owner: {
                    id: self.workOrderId,
                    type: 'workorder'
                },
                isInternal: !self.comment.isInternalCheckbox
            });

            newComment.$save().then(function () {
                showSaveMessage();
                self.comment.text = null;
                self.comment.isInternalCheckbox = true;
                return workOrderCommentsService.getCommentData(self.workOrderId);
            }).then(function (response) {
                self.comments = parseComments(response.data, self.currentUserId);
            });
        };

        self.updateComment = function (comment) {
            comment.isInternal = !self.editingComment.isInternalCheckbox;
            comment.$update({
                id: comment.id
            }).then(function () {
                showSaveMessage();
                return workOrderCommentsService.getCommentData(self.workOrderId);
            }).then(function (response) {
                self.comments = parseComments(response.data, self.currentUserId);
                self.editingComment = null;
            });
        };

        self.setEditComment = function (comment) {
            if (self.editingComment && comment.id === self.editingComment.id) {
                comment.isInternal = self.editingComment.isInternal;
                self.editingComment = null;
                return;
            }
            self.editingComment = angular.copy(comment);
        };

        self.deleteComment = function (comment) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/workOrderComments/workOrderCommentsDeleteConfirmModal.html',
                controller: 'workOrderCommentsDeleteModalController',
                size: 'sm',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                comment.$delete({
                    id: comment.id
                }).then(function () {
                    showDeleteMessage();
                    return workOrderCommentsService.getCommentData(self.workOrderId);
                }).then(function (response) {
                    self.comments = parseComments(response.data, self.currentUserId);
                });
            });
        };

        self.$onInit = function () {
            self.currentUserId = userContext.user.id;

            workOrderCommentsService.getCommentData(self.workOrderId).then(function (response) {
                self.comments = parseComments(response.data, self.currentUserId);
            });

            self.isRequester = roleHelpers.isRequester();

            self.comment = {
                text: '',
                isInternalCheckbox: true
            };
        };
    });

'use strict';

angular.module('workOrderCalendarMonth', ['ui.router', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'workOrderCalendar']);

'use strict';

angular.module('workOrderCalendarMonth')
    .config(function ($stateProvider, permission) {
        // secure. base route in dudeAuth
        $stateProvider
            .state('secure.workOrderCalendar.month', {
                url: 'month?year&month&day&status&assignees&unassigned&purpose&businessAsset&includeDescendants&workType',
                templateUrl: 'app/components/workOrderCalendarMonth/workOrderCalendarMonth.html',
                controller: 'WorkOrderCalendarMonthController',
                controllerAs: 'workOrderCalendar',
                permissions: permission.calendarEvents.read,
                resolve: {
                    initData: function ($q, $stateParams, moment, clientHelperService, responsiveBreakpoints, workOrderEnums, workOrderCalendarService, workOrderFilters) {
                        var isMobile = clientHelperService.getCurrentScreenSize().breakpoint === responsiveBreakpoints.xs;
                        var queryParams = $stateParams;
                        var targetDate = new Date();

                        queryParams.status = (queryParams.status || [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.onHold]);
                        queryParams.includeDescendants = queryParams.businessAsset ? queryParams.includeDescendants === 'true' : true;

                        if (queryParams.month && queryParams.year && queryParams.day) {
                            targetDate = new Date(queryParams.month + '/' + queryParams.day + '/' + queryParams.year);
                            var dates = workOrderCalendarService.getDateRange(targetDate);
                            queryParams.scheduledStartDateFrom = dates.startDate;
                            queryParams.scheduledStartDateTo = dates.endDate;
                        }

                        var filters = workOrderFilters.getFilters(queryParams);

                        if (isMobile) {
                            filters.scheduledStartDateFrom = moment(targetDate).hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
                            filters.scheduledStartDateTo = moment(targetDate).hours(23).minutes(59).seconds(59).milliseconds(999).toISOString();
                        }

                        var projectionFilter = angular.copy(filters);
                        if (moment(new Date()).isSame(new Date(projectionFilter.scheduledStartDateFrom), 'month') || moment(new Date()).isAfter(new Date(projectionFilter.scheduledStartDateFrom), 'month')) {
                            projectionFilter.scheduledStartDateFrom = moment(new Date()).add(1, 'days').set('hour', 0).set('minute', 0).toISOString();
                        }

                        return $q.all({
                            filters: filters,
                            calendarEvents: workOrderCalendarService.getCalendarData('CalendarEventsEntity', filters).then(function (results) {
                                return isMobile ? results : workOrderCalendarService.parseCalendarData(results, targetDate, 'secure.workOrderFormEdit');
                            }),
                            calendarProjections: ((queryParams.status.indexOf(workOrderEnums.status.newRequest) > -1 || queryParams.status.indexOf('all') > -1) && !moment(targetDate).isBefore(new Date(), 'month')) ? workOrderCalendarService.getCalendarData('CalendarProjectionEntity', projectionFilter).then(function (results) {
                                return isMobile ? results : workOrderCalendarService.parseCalendarData(results, targetDate);
                            }) : null,
                            targetDate: targetDate,
                            isMobile: isMobile
                        });
                    }
                }
            });
    });

'use strict';

angular.module('workOrderCalendarMonth')
    .controller('WorkOrderCalendarMonthController', function ($scope, $filter, $q, $state, $translate, roles, moment, clientHelperService, responsiveBreakpoints, workOrderEnums, queryHelpers, marketizr, market, workOrderFilters, initData, workOrderCalendarService) {
        var self = this;

        self.clearFilters = function () {
            self.filters = workOrderFilters.getFilters({});
            if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                self.filters.includeDescendants = true;
            }
        };

        var queryDefaults = workOrderFilters.getFilters({});
        self.isMobile = initData.isMobile;
        self.screenSize = clientHelperService.getCurrentScreenSize();
        self.isMobilePhone = clientHelperService.isMobile();
        self.priority = workOrderEnums.priority;
        self.market = market;

        self.assigneeTitle = $translate.instant('workOrderCalendar.assignee');
        self.assigneeRoles = [roles.admin, roles.technician];

        if (self.isMobile) {
            self.mobileEvents = initData.calendarEvents.data;
            if (initData.calendarProjections) {
                self.mobileEvents = self.mobileEvents.concat(initData.calendarProjections.data);
            }
            self.counts = $filter('workOrderType')(self.mobileEvents);
            self.events = [[], []];
        } else {
            self.events = [angular.copy(initData.calendarEvents)];
            if (initData.calendarProjections) {
                self.events.push(angular.copy(initData.calendarProjections));
            }
        }

        self.filters = initData.filters;
        self.targetDate = initData.targetDate;
        self.targetDateCopy = new Date(angular.copy(self.targetDate));
        self.updatedEvent = {};
        self.isToday = moment(initData.targetDate).isSame(new Date(), 'day');

        self.filters.month = moment(self.targetDate).month() + 1;
        self.filters.year = moment(self.targetDate).year();
        self.filters.day = moment(self.targetDate).date();

        if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
            self.assetHideCheckBox = true;
            self.filters.includeDescendants = true;
        }

        self.assetBrowseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                }
            }
        };

        var maximumForwardMonth = 5;
        var lastMonthTarget = self.isMobile ? null : angular.copy(self.targetDate);
        var lastDayTarget = self.isMobile ? angular.copy(self.targetDate) : null;
        var ignoreWatcher = true;

        workOrderCalendarService.getDateRange(self.targetDate);

        var monthDifference = function (newTargetDate) {
            var yearDiff = moment(newTargetDate).year() - moment().year();
            return yearDiff * 12 + moment(newTargetDate).month() - moment().month(); // eslint-disable-line no-mixed-operators
        };

        self.monthLimit = monthDifference(self.targetDate) > maximumForwardMonth;

        self.setMonth = function (increment) {
            var newTargetDate = increment === 0 ? angular.copy(self.targetDate) : new Date(moment(self.targetDate).add(increment, 'months').date(1));

            if (moment(newTargetDate).isSame(new Date(), 'months') && !moment(self.targetDate).isSame(new Date(), 'months')) {
                newTargetDate = new Date();
            }

            if (lastMonthTarget && moment(lastMonthTarget).isSame(newTargetDate, 'months') && (self.events[0].length || self.events[1].length)) {
                return;
            }

            self.monthLimit = monthDifference(newTargetDate) > maximumForwardMonth;

            self.targetDate = newTargetDate;
            var dates = workOrderCalendarService.getDateRange(self.targetDate);
            self.filters.scheduledStartDateFrom = dates.startDate;
            self.filters.scheduledStartDateTo = dates.endDate;
            var promises = [];
            var projectionFilter = angular.copy(self.filters);
            if (moment(new Date()).isSame(new Date(self.filters.scheduledStartDateFrom), 'month') || moment(new Date()).isAfter(new Date(projectionFilter.scheduledStartDateFrom), 'month')) {
                projectionFilter.scheduledStartDateFrom = moment(new Date()).add(1, 'days').set('hour', 0).set('minute', 0).toISOString();
            }

            promises.push(workOrderCalendarService.getCalendarData('CalendarEventsEntity', self.filters).then(function (results) {
                self.events[0] = workOrderCalendarService.parseCalendarData(results, self.targetDate, 'secure.workOrderFormEdit');
            }));

            if ((self.filters.status.indexOf(workOrderEnums.status.newRequest) > -1 || self.filters.status.indexOf('all') > -1) && monthDifference(newTargetDate) > -1) {
                promises.push(workOrderCalendarService.getCalendarData('CalendarProjectionEntity', projectionFilter).then(function (results) {
                    self.events[1] = workOrderCalendarService.parseCalendarData(results, self.targetDate);
                }));
            } else if (self.events[1]) {
                self.events[1] = [];
            }

            $q.all(promises).then(function () {
                var query = angular.copy(self.filters);
                query.month = moment(self.targetDate).month() + 1;
                query.year = moment(self.targetDate).year();
                query.day = moment(self.targetDate).date();
                self.filters.month = angular.copy(query.month);
                self.filters.year = angular.copy(query.year);
                self.filters.day = angular.copy(query.day);
                delete query.scheduledStartDateFrom;
                delete query.scheduledStartDateTo;
                delete query.pageSize;
                queryHelpers.updateState(query, queryDefaults);
                lastMonthTarget = angular.copy(self.targetDate);
            });
        };

        self.setDay = function (targetDate) {
            var newTargetDate = new Date(targetDate);
            var mobileEvents;
            var mobileProjections = [];
            self.monthLimit = monthDifference(newTargetDate) > maximumForwardMonth;

            if (lastDayTarget && moment(lastDayTarget).isSame(newTargetDate, 'days') && self.mobileEvents.length) {
                return;
            }

            self.isToday = moment(newTargetDate).isSame(new Date(), 'day');
            self.targetDate = newTargetDate;
            self.filters.scheduledStartDateFrom = moment(newTargetDate).hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
            self.filters.scheduledStartDateTo = moment(newTargetDate).hours(23).minutes(59).seconds(59).milliseconds(999).toISOString();
            var promises = [];

            var queryForProjections = (self.filters.status.indexOf(workOrderEnums.status.newRequest) > -1 || self.filters.status.indexOf('all') > -1) && moment(new Date()).isBefore(new Date(self.filters.scheduledStartDateFrom), 'day');

            promises.push(workOrderCalendarService.getCalendarData('CalendarEventsEntity', self.filters).then(function (results) {
                mobileEvents = results.data;
            }));

            if (queryForProjections) {
                promises.push(workOrderCalendarService.getCalendarData('CalendarProjectionEntity', self.filters).then(function (results) {
                    mobileProjections = results.data;
                }));
            }

            $q.all(promises).then(function () {
                self.mobileEvents = angular.copy(mobileEvents);
                self.mobileEvents = self.mobileEvents.concat(mobileProjections);
                self.counts = $filter('workOrderType')(self.mobileEvents);
                var query = angular.copy(self.filters);
                query.month = moment(self.targetDate).month() + 1;
                query.year = moment(self.targetDate).year();
                query.day = moment(self.targetDate).date();
                self.filters.month = angular.copy(query.month);
                self.filters.year = angular.copy(query.year);
                self.filters.day = angular.copy(query.day);
                delete query.scheduledStartDateFrom;
                delete query.scheduledStartDateTo;
                delete query.pageSize;
                queryHelpers.updateState(query, queryDefaults);
                lastDayTarget = angular.copy(self.targetDate);
            });
        };

        self.dropFunction = function (event) {
            workOrderCalendarService.updateWorkOrder(event);
        };

        self.dayFunction = function (date, id) {
            var routeParams = angular.copy(self.filters);
            routeParams.year = date.year();
            routeParams.month = date.month() + 1;
            routeParams.day = date.date();
            routeParams.id = id;

            $state.go('secure.workOrderCalendar.day', routeParams);
        };

        self.isFilterApplied = function () {
            return workOrderCalendarService.isFilterApplied(self.filters);
        };

        $scope.$watch('workOrderCalendar.targetDateCopy', function (newVal) {
            if (ignoreWatcher) {
                ignoreWatcher = false;
                return;
            }

            if (self.isMobile) {
                self.setDay(newVal);
            } else {
                self.setMonth(0);
            }
        });

        $scope.$watch('workOrderCalendar.screenSize', function (newVal, oldVal) {
            if (angular.equals(newVal, oldVal)) {
                return;
            }

            var isMobile = newVal.breakpoint === responsiveBreakpoints.xs;

            if (isMobile === self.isMobile) {
                return;
            }

            self.isMobile = isMobile;

            if (self.isMobile) {
                self.targetDateCopy = angular.copy(self.targetDate);
            } else {
                self.setMonth(0);
            }
        }, true);

        $scope.$watch('workOrderCalendar.filters', function (newVal, oldVal) {
            var unchanged = angular.equals(newVal.purpose, oldVal.purpose);
            unchanged = unchanged && angular.equals(newVal.status, oldVal.status);
            unchanged = unchanged && angular.equals(newVal.businessAsset, oldVal.businessAsset);
            unchanged = unchanged && angular.equals(newVal.assignees, oldVal.assignees);
            unchanged = unchanged && angular.equals(newVal.unassigned, oldVal.unassigned);
            unchanged = unchanged && angular.equals(newVal.includeDescendants, oldVal.includeDescendants);
            unchanged = unchanged && angular.equals(newVal.workType, oldVal.workType);
            if (unchanged) {
                return;
            }

            lastDayTarget = null;
            lastMonthTarget = null;
            if (self.isMobile) {
                self.setDay(self.targetDate);
            } else {
                self.setMonth(0);
            }
        }, true);
    });

'use strict';

angular.module('workOrderCalendarDay', ['ui.router', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'workOrderCalendar']);

'use strict';

angular.module('workOrderCalendarDay')
    .config(function ($stateProvider, permission) {
        // secure. base route in dudeAuth
        $stateProvider
            .state('secure.workOrderCalendar.day', {
                url: 'day?year&month&day&status&assignees&unassigned&purpose&businessAsset&includeDescendants&id&workType',
                templateUrl: 'app/components/workOrderCalendarDay/workOrderCalendarDay.html',
                controller: 'WorkOrderCalendarDayController',
                controllerAs: 'workOrderCalendar',
                permissions: permission.calendarEvents.read,
                resolve: {
                    initData: function ($q, $stateParams, moment, clientHelperService, responsiveBreakpoints, workOrderEnums, workOrderCalendarService, workOrderFilters) {
                        var queryParams = $stateParams;
                        var targetDate = new Date();

                        queryParams.status = (queryParams.status || [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.onHold]);
                        queryParams.includeDescendants = queryParams.businessAsset ? queryParams.includeDescendants === 'true' : true;

                        if (queryParams.month && queryParams.year && queryParams.day) {
                            targetDate = new Date(queryParams.month + '/' + queryParams.day + '/' + queryParams.year);
                        }

                        var filters = workOrderFilters.getFilters(queryParams);

                        filters.scheduledStartDateFrom = moment(targetDate).hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
                        filters.scheduledStartDateTo = moment(targetDate).hours(23).minutes(59).seconds(59).milliseconds(999).toISOString();

                        return $q.all({
                            filters: filters,
                            calendarEvents: workOrderCalendarService.getCalendarData('CalendarEventsEntity', filters).then(function (results) {
                                return results;
                            }),
                            calendarProjections: moment(targetDate).isSameOrAfter(new Date(), 'day') ? workOrderCalendarService.getCalendarData('CalendarProjectionEntity', filters).then(function (results) {
                                return results;
                            }) : null,
                            targetDate: targetDate,
                            id: queryParams.id
                        });
                    }
                }
            });
    });

'use strict';

angular.module('workOrderCalendarDay')
    .controller('WorkOrderCalendarDayController', function ($scope, $filter, $q, $translate, roles, moment, clientHelperService, responsiveBreakpoints, workOrderEnums, queryHelpers, marketizr, market, workOrderFilters, initData, workOrderCalendarService) {
        var self = this;

        self.clearFilters = function () {
            self.filters = workOrderFilters.getFilters({});
            if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                self.filters.includeDescendants = true;
            }
        };

        var queryDefaults = workOrderFilters.getFilters({});
        self.isMobilePhone = clientHelperService.isMobile();
        self.priority = workOrderEnums.priority;
        self.market = market;

        self.assigneeTitle = $translate.instant('workOrderCalendar.assignee');
        self.assigneeRoles = [roles.admin, roles.technician];

        self.mobileEvents = initData.calendarEvents.data;
        if (initData.calendarProjections) {
            self.mobileEvents = self.mobileEvents.concat(initData.calendarProjections.data);
        }

        self.counts = $filter('workOrderType')(self.mobileEvents);
        self.filters = initData.filters;
        self.targetDate = initData.targetDate;
        self.targetDateCopy = new Date(angular.copy(self.targetDate));
        self.updatedEvent = {};
        self.targetId = initData.id;
        self.isToday = moment(initData.targetDate).isSame(new Date(), 'day');

        self.filters.month = moment(self.targetDate).month() + 1;
        self.filters.year = moment(self.targetDate).year();
        self.filters.day = moment(self.targetDate).date();

        if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
            self.assetHideCheckBox = true;
            self.filters.includeDescendants = true;
        }

        self.assetBrowseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                }
            }
        };

        var ignoreWatcher = true;

        workOrderCalendarService.getDateRange(self.targetDate);

        self.maxDay = moment(new Date()).add(6, 'months').endOf('month');
        self.maxDayLimit = moment(self.targetDate).isSameOrAfter(self.maxDay, 'day');

        self.setDay = function (targetDate, filterChange) {
            var newTargetDate = new Date(targetDate);
            var mobileEvents;
            var mobileProjections = [];
            self.maxDayLimit = moment(self.targetDate).isSameOrAfter(self.maxDay, 'day');

            if (moment(self.targetDate).isSame(newTargetDate, 'days') && !filterChange) {
                return;
            }

            self.isToday = moment(newTargetDate).isSame(new Date(), 'day');
            self.targetDate = newTargetDate;
            self.filters.scheduledStartDateFrom = moment(newTargetDate).hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
            self.filters.scheduledStartDateTo = moment(newTargetDate).hours(23).minutes(59).seconds(59).milliseconds(999).toISOString();
            var promises = [];

            var queryForProjections = (self.filters.status.indexOf(workOrderEnums.status.newRequest) > -1 || self.filters.status.indexOf('all') > -1) && moment(new Date()).isBefore(new Date(self.filters.scheduledStartDateFrom), 'day');

            promises.push(workOrderCalendarService.getCalendarData('CalendarEventsEntity', self.filters).then(function (results) {
                mobileEvents = results.data;
            }));

            if (queryForProjections) {
                promises.push(workOrderCalendarService.getCalendarData('CalendarProjectionEntity', self.filters).then(function (results) {
                    mobileProjections = results.data;
                }));
            }

            $q.all(promises).then(function () {
                self.mobileEvents = angular.copy(mobileEvents);
                self.mobileEvents = self.mobileEvents.concat(mobileProjections);
                self.counts = $filter('workOrderType')(self.mobileEvents);
                var query = angular.copy(self.filters);
                query.month = moment(self.targetDate).month() + 1;
                query.year = moment(self.targetDate).year();
                query.day = moment(self.targetDate).date();
                self.filters.month = angular.copy(query.month);
                self.filters.year = angular.copy(query.year);
                self.filters.day = angular.copy(query.day);
                delete query.scheduledStartDateFrom;
                delete query.scheduledStartDateTo;
                delete query.pageSize;
                queryHelpers.updateState(query, queryDefaults);
            });
        };

        self.isFilterApplied = function () {
            return workOrderCalendarService.isFilterApplied(self.filters);
        };

        self.updateDate = function (increment) {
            self.targetDateCopy = moment(self.targetDateCopy).add(increment, 'day');
        };

        $scope.$watch('workOrderCalendar.targetDateCopy', function (newVal) {
            if (ignoreWatcher) {
                ignoreWatcher = false;
                return;
            }

            self.setDay(newVal);
        });

        $scope.$watch('workOrderCalendar.filters', function (newVal, oldVal) {
            var unchanged = angular.equals(newVal.purpose, oldVal.purpose);
            unchanged = unchanged && angular.equals(newVal.status, oldVal.status);
            unchanged = unchanged && angular.equals(newVal.businessAsset, oldVal.businessAsset);
            unchanged = unchanged && angular.equals(newVal.assignees, oldVal.assignees);
            unchanged = unchanged && angular.equals(newVal.unassigned, oldVal.unassigned);
            unchanged = unchanged && angular.equals(newVal.includeDescendants, oldVal.includeDescendants);
            unchanged = unchanged && angular.equals(newVal.workType, oldVal.workType);
            if (unchanged) {
                return;
            }

            self.setDay(self.targetDate, true);
        }, true);
    });

'use strict';

angular.module('workOrderCalendar', ['ui.router', 'dudeControls', 'dudeControlsCalendar', 'dudeApi', 'dudeAuth', 'translate', 'workOrderQuickActions', 'maintenanceConstants']);

'use strict';

angular.module('workOrderCalendar')
    .filter('workOrderType', function () {
        return function (workOrders) {
            var typeCounts = {
                reactive: 0,
                planned: 0
            };
            workOrders = workOrders || [];
            workOrders.forEach(function (workOrder) {
                if (workOrder.workOrderType.toLowerCase() === 'reactive') {
                    typeCounts.reactive++;
                } else {
                    typeCounts.planned++;
                }
            });

            return typeCounts;
        };
    });

/**
 * @ngdoc service
 * @name workOrderCalendar.workOrderCalendarService
 * @requires DudeApi
 * @requires dataHelperService
 * @requires workOrderFilters.workOrderFilters
 * @requires moment
 * @requires log
 * @requires $translate
 *
 * @description
 * Service for supporting the gathering and parsing of data for the work order calendar module
 *
 */

'use strict';

angular.module('workOrderCalendar')
    .factory('workOrderCalendarService', function ($translate, DudeApi, dataHelperService, moment, marketizr, market, log, workOrderFilters) {
        var workOrderCategories = {
            reactive: 'Reactive',
            pmGenerated: 'PM Generated',
            scheduled: 'Scheduled'
        };

        var calendarIcons = {
            reactive: 'fa-briefcase',
            scheduled: 'fa-refresh'
        };

        // The max number of weeks shown by the calendar
        var maxWeeks = 6;

        /**
         * @ngdoc method
         * @name getDateRange
         * @methodOf workOrderCalendar.workOrderCalendarService
         *
         * @description
         * Gets the start and end date of a visible month view of a calendar
         *
         * @param {date} date The target date of the month to use to find the start and end of the month
         * @returns {object} An object that contains the startDate and endDate to that defined the bounds of the visible month view
         */
        var getDateRange = function (date) {
            date = date || new Date();
            var startDate = moment(date).startOf('month').startOf('week');
            var endDate = moment(date).endOf('month').endOf('week');
            var weekDiff = moment(endDate).isoWeek() - moment(startDate).isoWeek();
            if (weekDiff < maxWeeks) {
                endDate = moment(endDate).add(7, 'days');
            }
            return {
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            };
        };

        var getFilters = function (query) {
            query.pageSize = 1000;
            query.scheduledStartDateFrom = query.scheduledStartDateFrom || moment().startOf('month').startOf('week').toISOString();
            query.scheduledStartDateTo = query.scheduledStartDateTo || moment().endOf('month').endOf('week').toISOString();
            var filters = workOrderFilters.toApiFilter(query);
            delete filters.orderBy;
            return filters;
        };

        /**
         * @ngdoc method
         * @name getCalendarData
         * @methodOf workOrderCalendar.workOrderCalendarService
         *
         * @description
         * Gets all of the calendar data from the Calendar Events Entity
         *
         * @param {object} entity The entity to query on.
         * @param {object} query The filters object to query with.  This will get parsed internally to add calendar defaults
         * @returns {Promise} A promise that returns with all of the data returned in the page wrapper format
         */
        var getCalendarData = function (entity, query) {
            var filters = getFilters(query);
            return dataHelperService.queryAll(entity, filters);
        };

        /**
         * @ngdoc method
         * @name generateCalendarId
         * @methodOf workOrderCalendar.workOrderCalendarService
         *
         * @description
         * A function for generating a unique id for calendar events
         *
         * @param {object} data The object containing event data
         * @returns {string} id The id string to use
         */
        var generateCalendarId = function (data) {
            var id;
            if (data.workOrderId) {
                id = 'wo-' + data.workOrderId;
            } else {
                id = 'pm-' + data.pmScheduleId;
                id += data.businessAsset ? '-' + data.businessAsset.id : '';
            }
            return id;
        };

        /**
         * @ngdoc method
         * @name parseCalendarData
         * @methodOf workOrderCalendar.workOrderCalendarService
         *
         * @description
         * Parses an object containing a data array of work orders into a useable format for the event calendar component
         *
         * @param {object} workOrders The object containing the data array of work orders
         * @param {date} targetDate This date is used to determine whether events are inside or outside of the month when mapping them to the event calendar object. It defaults to today's date (optional)
         * @param {string} route The route for the calendar object
         * @returns {array} An array of event objects
         */
        var parseCalendarData = function (workOrders, targetDate) {
            targetDate = targetDate || new Date();

            return workOrders.data.map(function (data) {
                var calendarObject;
                var id = generateCalendarId(data);
                var title;
                var assetName = data.businessAsset !== null ? data.businessAsset.name : '';

                var classes = [data.priority.toLowerCase()];
                classes.push(data.displayId ? 'woid-' + data.displayId : 'pmid-' + data.pmScheduleId);
                classes.push(data.workOrderType.split(' ').join('').toLowerCase());

                var date = moment(new Date(data.scheduledStartDate)).hours(23).minutes(59).seconds(59).millisecond(0);
                var requestDate = moment(data.requestDate);

                // Full calendar needs both a start and end date when creating constraints for drag and drop, so creating one a couple years out
                var endDate = moment(date).add(2, 'y');
                if (date < moment(targetDate).startOf('month').toDate() || date > moment(targetDate).endOf('month').toDate()) {
                    classes.push('other-month-event');
                }

                var priorityOrder = '1';
                switch (data.priority) {
                case 'High':
                    priorityOrder = '2';
                    break;
                case 'Medium':
                    priorityOrder = '3';
                    break;
                case 'Low':
                    priorityOrder = '4';
                    break;
                default:
                    break;
                }

                if (data.workOrderId) {
                    title = priorityOrder + data.workOrderId;
                } else {
                    // the highest number a work order can be is 4, 5 forces pm's to the bottom.
                    title = '5' + data.pmScheduleId + assetName;
                }

                calendarObject = {
                    title: title,
                    icon: data.workOrderType === workOrderCategories.reactive ? calendarIcons.reactive : calendarIcons.scheduled,
                    startEditable: classes.indexOf('projected') === -1,
                    assetName: assetName,
                    description: marketizr.hasMarkets([market.k12, market.he, market.ips]) ? data.workType.name : data.eventDescription,
                    workOrderId: data.workOrderId,
                    start: date,
                    pmScheduleId: data.pmScheduleId,
                    priority: data.priority.toLowerCase(),
                    id: id,
                    className: classes,
                    constraint: {
                        start: requestDate,
                        end: endDate
                    }
                };

                return calendarObject;
            });
        };

        /**
         * @ngdoc method
         * @name updateWorkOrder
         * @methodOf workOrderCalendar.workOrderCalendarService
         *
         * @description
         * A function for handling the update of a work order post drag and drop
         *
         * @param {object} event The object containing event data
         */
        var updateWorkOrder = function (event) {
            if (event.id) {
                DudeApi.WorkOrderEntity.get({ id: event.workOrderId }).$promise.then(function (workOrder) {
                    var newDate = new Date(event.start);
                    var dayChange = Math.ceil(moment(workOrder.scheduledStartDate).hours(0).minutes(0).diff(moment(newDate).hours(0).minutes(0), 'days', true));

                    if (dayChange === 0) {
                        return;
                    }

                    if (workOrder.dueDateTime) {
                        workOrder.dueDateTime = moment(workOrder.dueDateTime).subtract(dayChange, 'days').hours(23).minutes(59).seconds(59).toISOString();
                    }

                    workOrder.scheduledStartDate = moment(new Date(event.start)).hours(23).minutes(59).seconds(59).millisecond(0).toISOString();
                    workOrder.$update({ id: workOrder.id }).then(function () {
                        log.notify({
                            type: 'success',
                            title: $translate.instant('workOrderForm.notificationTitle'),
                            message: $translate.instant('workOrderForm.notification')
                        });
                    });
                });
            }
        };

        /**
         * @ngdoc method
         * @name isFilterApplied
         * @methodOf workOrderCalendar.workOrderCalendarService
         *
         * @description
         * Checks against relevant values to see if a calendar filter is applied
         *
         * @param {object} filters The object containing the current filters
         * @returns {Boolean} A boolean stating whether or not filters are applied
         */
        var isFilterApplied = function (filters) {
            var cloned = angular.copy(filters);
            cloned.status = cloned.status === 'all' || cloned.status[0] === 'all' ? [] : cloned.status;
            cloned.scheduledStartDateFrom = null;
            cloned.scheduledStartDateTo = null;
            var defaultValue = workOrderFilters.getFilters({});
            var equalValue = angular.equals(cloned.status, defaultValue.status);
            equalValue = equalValue && angular.equals(cloned.assignees, defaultValue.assignees);
            equalValue = equalValue && angular.equals(cloned.purpose, defaultValue.purpose);
            equalValue = equalValue && angular.equals(cloned.businessAsset, defaultValue.businessAsset);
            return !equalValue;
        };

        return {
            getCalendarData: getCalendarData,
            parseCalendarData: parseCalendarData,
            generateCalendarId: generateCalendarId,
            getDateRange: getDateRange,
            updateWorkOrder: updateWorkOrder,
            isFilterApplied: isFilterApplied
        };
    });

'use strict';

angular.module('workOrderCalendar')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.workOrderCalendar',
            {
                abstract: true,
                url: 'workOrderCalendar/',
                template: '<div ui-view></div>',
                controllerAs: 'workOrderCalendar'
            });
    });

/**
 * @ngdoc directive
 * @name workOrderCalendar.work-order-calendar-navigation
 * @description
 *
 * Displays the navigation tabs for the month and day
 *
 * @param {object} filters the filter object to pass through on route
 *
 * <work-order-calendar-navigation filters="filterObject"></work-order-calendar-navigation>
 */

'use strict';

angular.module('workOrderCalendar')
    .component('workOrderCalendarNavigation', {
        bindings: {
            filters: '='
        },
        templateUrl: 'app/components/workOrderCalendar/calendarNavigation.html',
        controller: function ($state) {
            var self = this;
            self.isActiveRoute = function (parameter) {
                return $state.current.url.indexOf(parameter) === 0;
            };
        },
        controllerAs: 'calendarNavigation'
    });

/**
 * @ngdoc directive
 * @name workOrderCalendar.mobile-calendar
 * @restrict E
 * @description
 *
 * Renders a mobile day view of the calendar
 *
 * @param {array} events The array of events to render
 * @param {string} targetId The target id of an event to highlight
 * @param {date} targetDate The date displayed
 *
 * <calendar-day-view events="calendarEvents"></calendar-day-view>
 */

'use strict';

angular.module('workOrderCalendar')
    .component('calendarDayView', {
        bindings: {
            events: '=',
            targetId: '=?',
            targetDate: '=?'
        },
        templateUrl: 'app/components/workOrderCalendar/calendarDayView.html',
        controller: function ($timeout, $scope, $document, $state, DudeApi, moment, log, workOrderEnums, $translate, workOrderCalendarService, workOrderQuickActionsService) {
            var self = this;

            var quickAssigneeWatcher;
            var quickScheduleWatcher;

            var quickUpdates = {
                assignee: 'UpdateAssignee',
                scheduled: 'UpdateSchedule'
            };

            var lastQuickActionIndex;
            var lastQuickActionName;

            $scope.$watchCollection('calendarDayView.events', function () {
                self.workOrders = [];
                self.projections = [];
                self.events.forEach(function (event) {
                    if (event.workOrderId) {
                        self.workOrders.push(event);
                    } else {
                        self.projections.push(event);
                    }
                });
            });

            self.compareIds = function (event) {
                var eventId = workOrderCalendarService.generateCalendarId(event);
                return eventId === self.targetId;
            };

            if (self.targetId) {
                $timeout(function () {
                    var targetElement = angular.element('.selected-day')[0];
                    $document.scrollToElement(targetElement, 150);
                });
            }

            $timeout(function () {
                self.targetId = null;
            }, 3000);

            self.status = workOrderEnums.status;
            self.priority = workOrderEnums.priority;

            self.printWorkOrder = function (id) {
                workOrderQuickActionsService.print(id);
            };

            self.edit = function (event) {
                if (event.workOrderId) {
                    $state.go('secure.workOrderFormEdit', { id: event.workOrderId });
                } else {
                    DudeApi.PmScheduleEntity.get({ id: event.pmScheduleId }).$promise.then(function (result) {
                        $state.go('secure.pmScheduleEdit', {
                            id: result.workOrderTemplateId
                        });
                    });
                }
            };

            var updateWorkOrder = function (workOrder, event) {
                workOrder.$update({ id: workOrder.id }).then(function () {
                    switch (lastQuickActionName) {
                    case quickUpdates.assignee:
                        event.quickActionsUpdateAssignee = true;
                        break;
                    case quickUpdates.scheduled:
                        event.quickActionsUpdateSchedule = true;
                        break;
                    default:
                        break;
                    }

                    log.notify({
                        type: 'success',
                        title: $translate.instant('workOrderForm.notificationTitle'),
                        message: $translate.instant('workOrderForm.notification')
                    });
                });
            };

            self.closeLastQuickAction = function () {
                if (lastQuickActionIndex !== null && lastQuickActionName !== null) {
                    switch (lastQuickActionName) {
                    case quickUpdates.assignee: {
                        quickAssigneeWatcher();
                        self.workOrders[lastQuickActionIndex].quickActionsUpdateAssignee = false;
                        delete self.workOrders[lastQuickActionIndex].assigneesCopy;
                        break;
                    }
                    case quickUpdates.scheduled: {
                        quickScheduleWatcher();
                        var event = self.workOrders[lastQuickActionIndex];
                        event.quickActionsUpdateSchedule = false;
                        break;
                    }
                    default:
                        break;
                    }
                }
                lastQuickActionIndex = null;
                lastQuickActionName = null;
            };

            self.updateAssignees = function (index) {
                var event = self.workOrders[index];
                event.quickActionsUpdateAssignee = true;
                var workOrder = DudeApi.WorkOrderEntity.get({ id: event.workOrderId });

                self.closeLastQuickAction();

                if (event.quickActionsUpdateAssignee) {
                    lastQuickActionIndex = index;
                    lastQuickActionName = quickUpdates.assignee;

                    quickAssigneeWatcher = $scope.$watchCollection(function () {
                        return event.assignees;
                    }, function (newVal, oldVal) {
                        if (angular.equals(newVal, oldVal)) {
                            return;
                        }

                        workOrder.assignees = angular.copy(event.assignees);
                        updateWorkOrder(workOrder, event);
                    }, true);
                } else {
                    lastQuickActionIndex = null;
                    lastQuickActionName = null;
                }
            };

            self.updateSchedule = function (index) {
                var event = self.workOrders[index];
                event.quickActionsUpdateSchedule = true;
                var workOrder = DudeApi.WorkOrderEntity.get({ id: event.workOrderId });

                self.closeLastQuickAction();

                if (event.quickActionsUpdateSchedule) {
                    lastQuickActionIndex = index;
                    lastQuickActionName = quickUpdates.scheduled;

                    quickScheduleWatcher = $scope.$watch(function () {
                        return event;
                    }, function (newVal, oldVal) {
                        var oldSchedStartDate;
                        var newSchedStartDate;
                        var oldDueDate;
                        var newDueDate;

                        oldSchedStartDate = oldVal.scheduledStartDate === null ? oldVal.scheduledStartDate : moment(oldVal.scheduledStartDate).format('YYYY-MM-DD');
                        newSchedStartDate = newVal.scheduledStartDate === null ? newVal.scheduledStartDate : moment(newVal.scheduledStartDate).format('YYYY-MM-DD');
                        oldDueDate = oldVal.dueDate === null ? oldVal.dueDateTime : moment(oldVal.dueDateTime).format('YYYY-MM-DD');
                        newDueDate = newVal.dueDate === null ? newVal.dueDateTime : moment(newVal.dueDateTime).format('YYYY-MM-DD');

                        if ((oldSchedStartDate !== newSchedStartDate) || (oldDueDate !== newDueDate)) {
                            workOrder.scheduledStartDate = angular.copy(event.scheduledStartDate);
                            event.faded = !moment(event.scheduledStartDate).isSame(self.targetDate, 'day');
                            workOrder.dueDateTime = angular.copy(event.dueDate);
                            updateWorkOrder(workOrder, event);
                        }
                    }, true);
                } else {
                    lastQuickActionIndex = null;
                    lastQuickActionName = null;
                }
            };
        },
        controllerAs: 'calendarDayView'
    });

/**
 * @ngdoc service
 * @name webLinkSection.webLinkSectionService
 * @requires DudeApi
 *
 * @description
 * Service for supporting the web link section
 *
 * @requires DudeApi
 *
 */

'use strict';

angular.module('webLinkSection')
    .service('webLinkSectionService', function (DudeApi) {
        /**
         * @ngdoc method
         * @name getWorkOrderWebLinks
         * @methodOf webLinkSection.webLinkSectionService
         *
         * @description Gets the web links from the back end
         *
         * @param {int} id The id of the entity
         * @param {int} objectTypeId for the entity
         */
        var getWebLinks = function (id, objectTypeId) {
            // 1 is the ID for a weblink WorkOrder object type. It will be 1 across all environments.
            return DudeApi.WebLinksEntity.query({ objectId: id, objectTypeId: objectTypeId }).$promise;
        };

        return {
            getWebLinks: getWebLinks
        };
    });

/**
 * @ngdoc directive
 * @name webLinkSection.webLinkSection
 * @restrict E
 * @description
 *
 * Displays div containing link
 *
 * @param {Array} links the array of links
 * @param {Array} spies array of objects with properties containing the id and name of the anchors to be updated from this element
 * @param {int} spyPosition the position of the scroll spy
 * @param {int} objectId The id of the entity the user is currently editing. Must be passed through
 *              for non-new entities, as it is used to determine if the entity is new. (Optional)
 * @param {string} entity The type of entity you are retrieving links for i.e workOrder, businessAsset, or pmSchedule
 *
 */

'use strict';

angular.module('webLinkSection')
    .component('webLinkSection', {
        templateUrl: 'app/components/webLinkSection/webLinkSection.html',
        bindings: {
            links: '=',
            spies: '=',
            spyPosition: '<',
            objectId: '<?',
            entity: '@'
        },
        controller: 'WebLinkSectionController',
        controllerAs: 'webLinkSection'
    })
    .controller('WebLinkSectionController', function ($uibModal, $translate, log, DudeApi, webLinkSectionService, webLinkObjectTypeIds) {
        var self = this;

        self.openPanel = function (index) {
            self.linkIndex = index;
            self.openWhen = true;
        };

        var deleteSuccessful = function () {
            log.notify({
                type: 'success',
                title: $translate.instant('webLinkSection.notify.deleted.title'),
                message: $translate.instant('webLinkSection.notify.deleted.message')
            });
        };

        self.deleteLink = function (index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/webLinkSection/deleteConfirmModal.html',
                controller: 'DeleteConfirmModalController',
                controllerAs: 'deleteConfirmModalController',
                size: 'sm',
                backdrop: 'static'
            });

            return modalInstance.result.then(function () {
                if (self.links[index].id && self.objectId) {
                    self.links[index] = new DudeApi.WebLinksEntity(self.links[index]);
                    return self.links[index].$delete({ id: self.links[index].id }).then(function () {
                        deleteSuccessful();
                        return webLinkSectionService.getWebLinks(self.objectId, webLinkObjectTypeIds[self.entity]).then(function (response) {
                            self.links = response.data;

                            return null;
                        });
                    });
                }
                self.links.splice(index, 1);

                return null;
            });
        };

        self.$onInit = function () {
            if (self.objectId && (!self.links || !self.links.length)) {
                webLinkSectionService.getWebLinks(self.objectId, webLinkObjectTypeIds[self.entity]).then(function (response) {
                    self.links = response.data;
                });
            } else if (!self.objectId && (!self.links || !self.links.length)) {
                self.links = self.links && self.links.length > 0 ? self.links : [];
            }
        };
    });

'use strict';

angular.module('webLinkSection')
    .constant('webLinkObjectTypes', {
        workOrder: 'workOrder',
        businessAsset: 'businessAsset'
    });

'use strict';

angular.module('webLinkSection')
    .constant('webLinkObjectTypeIds', {
        workOrder: 1,
        businessAsset: 2
    });

'use strict';

angular.module('webLinkSection')
    .controller('DeleteConfirmModalController', function ($uibModalInstance) {
        var self = this;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };
    });

/**
 * @ngdoc directive
 * @name webLinkSection.webLinkCard
 * @restrict E
 * @description
 *
 * Creates a web link card that displays a link and its thumbnail.
 *
 * @param {object} link The link in string form.
 * @param {function} openPanel The function used to open the webLinkSlidingPanel.
 * @param {function} deleteLink The function used to delete the link.
 *
 * Usage: <web-link-card link={link}></web-link-card>
 */

'use strict';

angular.module('webLinkSection')
    .component('webLinkCard', {
        templateUrl: 'app/components/webLinkCard/webLinkCard.html',
        bindings: {
            link: '<',
            openPanel: '&',
            deleteLink: '&'
        },
        controller: 'WebLinkCardController',
        controllerAs: 'webLinkCard'
    })
    .controller('WebLinkCardController', function () {
        var self = this;

        var setListDescription = function () {
            if (self.link && self.link.description && self.link.description.length > 300) {
                self.listDescription = self.link.description.substr(0, 300) + '...';
            } else if (self.link && self.link.description) {
                self.listDescription = self.link.description;
            } else {
                self.listDescription = null;
            }
        };

        self.$onInit = function () {
            setListDescription();
        };
    });

'use strict';

angular.module('userList', ['ui.router', 'dudeAuth', 'dudeControls', 'dudeApi', 'translate', 'filterHelpers', 'userForm']);

'use strict';

angular.module('userList')
    .factory('userListFilterService', function (pagingHelpers) {
        var getFilters = function (params) {
            var filters = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'FirstName asc,LastName asc',
                q: params.q || null,
                roles: params.roles || null,
                isEnabled: params.isEnabled || null,
                products: params.products || null,
                notInProducts: params.notInProducts || null
            };
            return filters;
        };

        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

'use strict';

angular.module('userList')
    .service('userListService', function (DudeApi, pagingHelpers, userListFilterService, usersTypeaheadQuery) {
        var products = usersTypeaheadQuery.defaultQuery().products;

        var getUsers = function (query) {
            var filters = userListFilterService.toApiFilter(query);
            return DudeApi.UserEntity.query(filters);
        };

        var getListData = function (query) {
            query.products = products;
            return getUsers(query);
        };

        var getModalData = function (query) {
            query.notInProducts = products;
            return getUsers(query);
        };

        return {
            getListData: getListData,
            getModalData: getModalData
        };
    });

'use strict';

angular.module('userList')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.userList', {
                url: 'users?roles&isEnabled&q&pageSize&page&orderBy',
                templateUrl: 'app/components/userList/userList.html',
                controller: 'UserListController',
                controllerAs: 'userList',
                permissions: [permission.users.create, permission.users.update],
                resolve: {
                    initData: function ($stateParams, $q, userListService, userListFilterService) {
                        var queryParams = $stateParams;
                        var filters = userListFilterService.getFilters(queryParams);

                        return $q.all({
                            initResponse: userListService.getListData(filters).$promise,
                            imports: userListService.getModalData({}).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('userList')
    .controller('UserListController', function ($scope, $state, $uibModal, $translate, initData, userListService, userListFilterService, queryHelpers, orderByHelpers) {
        var self = this;

        var queryDefaults = userListFilterService.getFilters({});
        var pageChanging = false;

        // view model
        self.listData = initData.initResponse.data;
        self.importList = initData.imports;
        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.totalCount = initData.initResponse.total;

        self.roles = [
            {
                value: '',
                name: $translate.instant('filterRole.roles.all')
            },
            {
                value: '1',
                name: $translate.instant('filterRole.roles.admin')
            },
            {
                value: '2',
                name: $translate.instant('filterRole.roles.tech')
            },
            {
                value: '5',
                name: $translate.instant('filterRole.roles.requester')
            }
        ];

        self.importUsers = function () {
            $uibModal.open({
                templateUrl: 'app/components/userList/importUserModal.html',
                controller: 'ImportUserModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    users: function () {
                        return self.importList;
                    }
                }
            });
        };

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (angular.equals(oldVal, newVal)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                newVal.page = 1;
            }

            pageChanging = false;

            userListService.getListData(newVal).$promise.then(setData);

            queryHelpers.updateState(newVal, queryDefaults);
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.roles = cloned.roles !== '' ? cloned.roles : null;
            cloned.isEnabled = cloned.isEnabled !== '' ? cloned.isEnabled : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, userListFilterService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (items) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, items);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.editUser = function (id) {
            $state.go('secure.userEdit', { id: id });
        };

        self.clearFilters = function () {
            self.filters = userListFilterService.getFilters({});
        };

        $scope.$watch('userList.filters', updateFilters, true);
    });

'use strict';

angular.module('userList')
    .controller('ImportUserModalController', function ($uibModalInstance, $scope, $state, userListService, userListFilterService, users) {
        $scope.deleteModal = false;
        $scope.users = users;
        $scope.filters = userListFilterService.getFilters({});

        $scope.pageChanged = function () {
            userListService.getModalData($scope.filters).$promise.then(function (results) {
                $scope.users = results;
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.importUser = function (user) {
            $uibModalInstance.dismiss('cancel');
            $state.go('secure.userImport', { id: user.id });
        };
    });

'use strict';

angular.module('userForm', ['ui.router', 'dudeAuth', 'dudeControls', 'dudeApi', 'translate', 'dudeLog']);

'use strict';

angular.module('userForm')
    .service('userRoleService', function ($translate) {
        // set up requester information
        var REQUESTER_ID = 5;

        var roleTypes = [{
            id: 1,
            roleName: $translate.instant('userForm.roles.admin')
        }, {
            id: 2,
            roleName: $translate.instant('userForm.roles.tech')
        }, {
            id: REQUESTER_ID,
            roleName: $translate.instant('userForm.roles.requester')
        }];

        var setRole = function (user) {
            if (!user.id || user.roles.length < 1) {
                user.roles = [
                    roleTypes[1]
                ];
            }
        };

        return {
            roleTypes: roleTypes,
            setRole: setRole,
            requesterId: REQUESTER_ID
        };
    });

'use strict';

angular.module('userForm')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.userCreate', {
                url: 'users/new',
                templateUrl: 'app/components/userForm/userForm.html',
                controller: 'UserFormController',
                controllerAs: 'userForm',
                permissions: [permission.users.create],
                resolve: {
                    user: function (DudeApi) {
                        return new DudeApi.UserEntity({});
                    },
                    myProfile: function () {
                        return false;
                    }
                }
            })
            .state('secure.userMe', {
                url: 'users/me',
                templateUrl: 'app/components/userForm/userForm.html',
                controller: 'UserFormController',
                controllerAs: 'userForm',
                resolve: {
                    user: function (DudeApi) {
                        return DudeApi.MeEntity.get().$promise;
                    },
                    myProfile: function () {
                        return true;
                    }
                }
            })
            .state('secure.userEdit', {
                url: 'users/:id',
                templateUrl: 'app/components/userForm/userForm.html',
                controller: 'UserFormController',
                controllerAs: 'userForm',
                permissions: [permission.users.update],
                resolve: {
                    user: function ($stateParams, DudeApi) {
                        return DudeApi.UserEntity.get({ id: $stateParams.id }).$promise;
                    },
                    myProfile: function () {
                        return false;
                    }
                }
            })
            .state('secure.userImport', {
                url: 'users/import/:id',
                templateUrl: 'app/components/userForm/userForm.html',
                controller: 'UserFormController',
                controllerAs: 'userForm',
                permissions: [permission.users.update],
                resolve: {
                    user: function ($stateParams, DudeApi) {
                        return DudeApi.UserEntity.get({ id: $stateParams.id }).$promise;
                    },
                    myProfile: function () {
                        return false;
                    }
                }
            });
    });

'use strict';

angular.module('userForm')
    .controller('UserFormController', function ($scope, $filter, $state, DudeApi, $translate, log, roleHelpers, user, myProfile, permissionsHelper, userRoleService, emailRegex, userContext, pmAssociationsService) {
        var self = this;
        self.user = user;
        self.emailRegex = emailRegex;
        self.activationSent = false;
        self.myProfile = myProfile;
        self.editUserRole = permissionsHelper.userAllowed('Users-Create');
        self.isCsc = user.roles && user.roles.length ? user.roles[0].roleName === roleHelpers.roles.CSC : false;
        // value needs to be flipped so if isEnabled is true, then the checkbox is not checked
        self.disableLogin = user.id ? !user.isEnabled : false;
        self.myId = userContext.user.id === user.id;
        var badEmails = [];
        var messageTitle = $translate.instant('userForm.notify.success.saveTitle');
        var messagePrefix = $translate.instant('userForm.notify.success.saveMessage');

        self.title = function () {
            if ($state.current.name === 'secure.userImport' || !user.id) {
                return $translate.instant('userForm.createTitle');
            } else if (self.myProfile) {
                return $translate.instant('userForm.myProfile');
            }
            return $translate.instant('userForm.editTitle');
        };

        // set up requester information
        self.requester = false;

        self.roleTypes = userRoleService.roleTypes;

        var defaultPhoneNumber = function () {
            return { id: '', type: 1, number: '', extension: '' };
        };

        if (self.user.id && !myProfile) {
            pmAssociationsService.isAssociated({ assignees: self.user.id }).then(function (result) {
                self.associations = result.total;
                self.associationsValidation = pmAssociationsService.validationMessage($translate.instant('userForm.user'), self.associations);
            });
        }

        self.saveUser = function () {
            var clone = angular.copy(user);

            clone.phones = $filter('filter')(clone.phones, function (phone) {
                return self.phoneHasValue(phone);
            });

            // flips the value in the checkbox so when the box is checked, isEnabled is false
            clone.isEnabled = !self.disableLogin;

            var promise = clone.id ? clone.$update({ id: clone.id }) : clone.$save();

            promise.then(function () {
                log.notify({
                    title: messageTitle,
                    type: 'success',
                    message: clone.firstName + ' ' + clone.lastName + messagePrefix
                });
                if (!myProfile) {
                    $state.go('secure.userList');
                }
            }, function (response) {
                var isEmailPlatformUnique = true;
                for (var i = 0; i < response.data.validationErrors.length; i++) {
                    if (response.data.validationErrors[i].field === 'email' && response.data.validationErrors[i].code === 'V1005') {
                        // if validation message == V1005 then email already exists
                        badEmails.push(user.email);
                        isEmailPlatformUnique = false;
                        break;
                    }
                }

                $scope.form.email.$setValidity('uniqueEmail', isEmailPlatformUnique);
            });
        };

        self.resendActivation = function () {
            DudeApi.ResendActivationEntity.save({ id: user.id }, { userId: user.id }).$promise
                .then(function () {
                    log.notify({
                        title: 'Sent Successfully',
                        type: 'success',
                        message: 'Activation link sent to ' + user.firstName + ' ' + user.lastName
                    });
                });
            self.activationSent = true;
        };

        self.addPhone = function () {
            user.phones.push(defaultPhoneNumber());
        };

        self.removePhone = function (index) {
            if (user.phones.length > 1) {
                user.phones.splice(index, 1);
            } else {
                user.phones[index] = defaultPhoneNumber();
            }
        };

        self.phoneHasValue = function (phone) {
            return phone ? (phone.number || phone.extension) : false;
        };

        var init = function () {
            user.phones = !user.phones || user.phones.length === 0 ? user.phones = [defaultPhoneNumber()] : user.phones;

            userRoleService.setRole(user);

            // The returned roles must be an array so when creating a user it is necessary to create this array and stuff the default role id inside an object
            if (!user.id) {
                user.hourlyRate = 0;
            }
        };

        init();

        $scope.$watch('userForm.user.email', function (newVal, oldVal) {
            if (newVal === oldVal || !badEmails.length) {
                return;
            }

            var validity = badEmails.indexOf(newVal) < 0;
            $scope.form.email.$setValidity('uniqueEmail', validity);
        });

        $scope.$watchCollection('userForm.user.roles', function (newVal) {
            if (newVal.length && newVal[0].id === userRoleService.requesterId) {
                self.user.hourlyRate = '0.00';
                self.requester = true;
            } else {
                self.requester = false;
            }
        });
    });


'use strict';

angular.module('tradeList', ['ui.router', 'dudeControls', 'dudeApi', 'translate', 'dudeLog']);

'use strict';

angular.module('tradeList')
    .factory('tradeListFilterService', function ($location, pagingHelpers) {
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Name asc',
                q: params.q || null,
                isActive: params.isActive || null
            };

            return currentFilter;
        };

        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

'use strict';

angular.module('tradeList')
    .service('tradeListService', function (DudeApi, tradeListFilterService) {
        var getListData = function (query) {
            var filters = tradeListFilterService.toApiFilter(query);
            return DudeApi.TradeEntity.query(filters);
        };

        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('tradeList')
    .config(function ($stateProvider, permission, market) {
        $stateProvider
            .state('secure.tradeList', {
                url: 'trades?page&pageSize&q&isActive',
                templateUrl: 'app/components/tradeList/tradeList.html',
                controller: 'TradeListController',
                controllerAs: 'tradeList',
                permissions: [permission.trades.create, permission.trades.update, permission.trades.delete],
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    initData: function ($q, $stateParams, tradeListService, tradeListFilterService) {
                        var queryParams = $stateParams;
                        var filters = tradeListFilterService.getFilters(queryParams);

                        return $q.all({
                            initResponse: tradeListService.getListData(filters).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('tradeList')
    .controller('TradeListController', function ($scope, $state, tradeListService, tradeListFilterService, queryHelpers, orderByHelpers, initData) {
        var self = this;
        var queryDefaults = tradeListFilterService.getFilters({});
        var pageChanging = false;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            tradeListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        // view model
        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, tradeListFilterService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.editTrade = function (id) {
            $state.go('secure.tradeEdit', {
                id: id
            });
        };

        self.clearFilters = function () {
            self.filters = tradeListFilterService.getFilters({});
        };

        $scope.$watch('tradeList.filters', updateFilters, true);
    });

'use strict';

angular.module('tradeForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'helpers', 'dudeLog']);

'use strict';

angular.module('tradeForm')
    .config(function ($stateProvider, permission, market) {
        $stateProvider
            .state('secure.tradeCreate', {
                url: 'trades/new',
                templateUrl: 'app/components/tradeForm/tradeForm.html',
                controller: 'TradeFormController',
                controllerAs: 'tradeForm',
                permissions: permission.trades.create,
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    trade: function (DudeApi) {
                        return new DudeApi.TradeEntity({ isActive: true });
                    },
                    workOrderCount: function () {
                        return 0;
                    },
                    workOrderTemplateCount: function () {
                        return 0;
                    }
                }
            })
            .state('secure.tradeEdit', {
                url: 'trades/:id',
                templateUrl: 'app/components/tradeForm/tradeForm.html',
                controller: 'TradeFormController',
                controllerAs: 'tradeForm',
                permissions: permission.trades.update,
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    trade: function ($stateParams, DudeApi) {
                        return DudeApi.TradeEntity.get({ id: $stateParams.id }).$promise;
                    },
                    workOrderCount: function ($stateParams, DudeApi, tradeDeleteFilterService) {
                        var filter = tradeDeleteFilterService.toApiFilter({ id: $stateParams.id });
                        return DudeApi.WorkOrderEntity.query(filter).$promise;
                    },
                    workOrderTemplateCount: function ($stateParams, DudeApi, tradeDeleteFilterService) {
                        var filter = tradeDeleteFilterService.toApiFilter({ id: $stateParams.id });
                        return DudeApi.WorkOrderTemplateEntity.query(filter).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('tradeForm')
    .controller('TradeFormController', function ($state, log, $uibModal, $translate, trade, workOrderCount, workOrderTemplateCount, pmAssociationsService) {
        var self = this;

        self.trade = trade;

        if (self.trade.id) {
            pmAssociationsService.isAssociated({ trade: self.trade.id }).then(function (result) {
                self.associations = result.total;
                self.associationsValidation = pmAssociationsService.validationMessage($translate.instant('tradeForm.trade'), self.associations);
            });
        }

        // private
        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('tradeForm.notify.delete.title'),
                type: 'success',
                message: $translate.instant('tradeForm.notify.delete.message')
            });
        };

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/tradeForm/tradeDeleteConfirmModal.html',
                controller: 'TradeDeleteModalController',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return '';
                    },
                    workOrderTemplateCount: function () {
                        return '';
                    }
                }
            });

            modalInstance.result.then(function () {
                trade.$delete({ id: trade.id }).then(function () {
                    showDeleteMessage();
                    $state.go('secure.tradeList');
                });
            });
        };

        var deleteWarning = function (count, templateCount) {
            $uibModal.open({
                templateUrl: 'app/components/tradeForm/tradeDeleteWarningModal.html',
                controller: 'TradeDeleteModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return count;
                    },
                    workOrderTemplateCount: function () {
                        return templateCount;
                    }
                }
            });
        };

        // public
        self.deleteTrade = function () {
            if (workOrderCount.total === 0 && workOrderTemplateCount.total === 0) {
                confirmDelete();
            } else {
                deleteWarning(workOrderCount.total, workOrderTemplateCount.total);
            }
        };

        self.saveTrade = function () {
            var promise = trade.id ? trade.$update({ id: trade.id }) : trade.$save();

            promise.then(function () {
                log.notify({
                    title: $translate.instant('tradeForm.notify.success.title'),
                    type: 'success',
                    message: $translate.instant('tradeForm.notify.success.message')
                });

                $state.go('secure.tradeList');
            });
        };
    });


'use strict';

angular.module('tradeForm')
    .controller('TradeDeleteModalController', function ($uibModalInstance, $scope, workOrderCount, workOrderTemplateCount) {
        $scope.workOrderCount = workOrderCount;
        $scope.workOrderTemplateCount = workOrderTemplateCount;

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('tradeForm')
    .service('tradeDeleteFilterService', function () {
        var toApiFilter = function (filter) {
            var filters = {
                trade: filter.id
            };
            return filters;
        };

        return {
            toApiFilter: toApiFilter
        };
    });

'use strict';

angular.module('taskBook', ['translate', 'dudeApi', 'dudeControls', 'dudeLog']);

'use strict';

angular.module('taskBook')
    .factory('taskBookService', function (DudeApi) {
        var addTasks = function (array, numberOfTasksToAdd) {
            if (!angular.isArray(array)) {
                array = [];
            }

            for (var i = 0; i < numberOfTasksToAdd; i++) {
                array.push(new DudeApi.TaskBookTaskEntity({ status: 'Incomplete' }));
            }
            return array;
        };

        var removeTask = function (array, index) {
            array.splice(index, 1);
            return array;
        };

        var removeEmptyTasks = function (array) {
            for (var i = array.length - 1; i >= 0; i--) {
                var item = array[i];
                if (!item.title && !item.procedure) {
                    array.splice(i, 1);
                }
            }
        };

        return {
            addTasks: addTasks,
            removeTask: removeTask,
            removeEmptyTasks: removeEmptyTasks
        };
    });

/**
 * @ngdoc directive
 * @name pmScheduleTasksForm.task-book
 * @restrict E
 * @description
 *
 * Creates a repeatable list for showing and editing task and procedures for a task book.
 *
 * @param {object} taskBook The task book object.  Must include an array of tasks
 * @param {object} tasksToDelete An array of tasks that were removed.  This array is used by the calling service to call the api DELETE
 * @param {number} seedTasks Default: 5 Automatically start with blank tasks
 * @param {string} mode Default create Mode to set the view to
 * @param {boolean} hideButton Hides the add button
 *
 * Usage:   <task-book task-book="TaskBook" tasks-to-delete="array"></task-book>
 */

'use strict';

angular.module('taskBook')
    .component('taskBook', {
        templateUrl: 'app/components/taskbook/taskBook.html',
        bindings: {
            taskBook: '=',
            tasksToDelete: '=?',
            mode: '=?',
            focusFirst: '=?',
            hideButton: '<?'
        },
        controllerAs: 'taskBook',
        controller: 'TaskBookController'
    });

angular.module('taskBook')
    .controller('TaskBookController', function ($scope, taskBookService) {
        var self = this;
        var unbindAddTaskWatcher = angular.noop;

        self.MODES = {
            COMPLETED_EDIT: 'completed_edit', // Status, notes, tasks, and procedures are editable
            COMPLETED_READONLY: 'completed_readonly', // show status and notes (editable) but tasks and procedures are readonly
            READONLY: 'readonly',  // Show readonly tasks and procedures
            EDIT: 'edit' // Shows editable tasks and procedures
        };

        self.status = {
            INCOMPLETE: 'Incomplete',
            NOT_APPLICABLE: 'NotApplicable',
            COMPLETE: 'Complete'
        };

        // traverse and disable all task inputs after current if title is missing
        var disableInput = function (index) {
            var hasTitle = true;

            for (var i = 0; i < index; i++) {
                if (!self.taskBook.tasks[i].title) {
                    hasTitle = false;
                    break;
                }
            }

            return index !== 0 && !hasTitle;
        };

        self.disableTitle = function (index) {
            return disableInput(index);
        };

        self.disableFields = function (index) {
            return disableInput(index) || !self.taskBook.tasks[index].title;
        };

        self.addTasks = function (numberOfTasksToAdd) {
            taskBookService.addTasks(self.taskBook.tasks, numberOfTasksToAdd);
        };

        self.removeTask = function (index) {
            if (angular.isUndefined(index)) {
                throw new Error('Task Book directive: No index specified to remove.');
            }

            if (self.taskBook.tasks[index].id) {
                self.tasksToDelete.push(angular.copy(self.taskBook.tasks[index]));
            }

            taskBookService.removeTask(self.taskBook.tasks, index);
        };

        var addTaskWatcher = function () {
            unbindAddTaskWatcher = $scope.$watch('taskBook.taskBook.tasks', function (newVal) {
                if (!angular.isArray(newVal)) {
                    return;
                }

                if (newVal[newVal.length - 1] && newVal[newVal.length - 1].title) {
                    taskBookService.addTasks(self.taskBook.tasks, 1);
                }
            }, true);
        };

        var editMode = function () {
            self.mode = self.MODES.EDIT;
            addTaskWatcher();
        };

        var completedReadonlyMode = function () {
            self.mode = self.MODES.COMPLETED_READONLY;
            unbindAddTaskWatcher();
            taskBookService.removeEmptyTasks(self.taskBook.tasks);
        };

        var completedEditMode = function () {
            self.mode = self.MODES.COMPLETED_EDIT;
            addTaskWatcher();
        };

        var readonlyMode = function () {
            self.mode = self.MODES.READONLY;
            unbindAddTaskWatcher();
            taskBookService.removeEmptyTasks(self.taskBook.tasks);
        };

        var init = function () {
            var mode = angular.isDefined(self.mode) ? self.mode.toLowerCase() : self.MODES.EDIT;
            self.tasksToDelete = self.tasksToDelete || [];

            switch (mode) {
            case self.MODES.COMPLETED_EDIT:
                completedEditMode();
                break;
            case self.MODES.COMPLETED_READONLY:
                completedReadonlyMode();
                break;
            case self.MODES.READONLY:
                readonlyMode();
                break;
            default: // create or other
                editMode();
                break;
            }
        };

        init();

        $scope.$watch('taskBook.mode', function () {
            init();
        });
    });

'use strict';

angular.module('taskBookSelect', ['dudeApi', 'taskBook']);

/**
 * @ngdoc directive
 * @name taskBookSelect.task-book-select
 * @restrict E
 * @description
 *
 * Displays a button to open the task book copy and link pop box
 *
 * @param {object} taskBook REQUIRED A task book with a list of tasks
 * @param {int} linkId The id of a linked task book.  This id is can be used to update a schedule/workorder/etc. with the taskbook id.
 * @param {array} tasksToDelete An array of tasks that were removed.  This array is used by the calling service to call the api DELETE
 * @param {bool} showLink A boolean indicating whether the link option should be displayed on the select directive.
 *
 * Usage:
 * <task-book-select task-book={object} linkId={int} tasks-to-delete={array} show-link={bool}></task-book-select>
 *
 */

'use strict';

angular.module('taskBookSelect')
    .directive('taskBookSelect', function (DudeApi, popBoxService, taskBookService) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/taskBookSelect/taskBookSelect.html',
            scope: {
                taskBook: '=',
                linkId: '=',
                tasksToDelete: '=?',
                showLink: '=?'
            },
            link: function (scope) {
                scope.ACTIONS = {
                    COPY: 'copy',
                    LINK: 'link',
                    REPLACE: 'replace',
                    ADD: 'add'
                };
                var popBoxName = 'pm-schedule-tasks-pop-box';
                scope.tasksToDelete = scope.tasksToDelete || [];

                var isPopBoxOpen = false;

                var linkTaskBook = function (taskBook, tasks) {
                    scope.linkId = scope.popbox.taskBookTypeahead.id; // Set this id to a var so we can save it to the schedule later
                    scope.taskBook.isMaster = taskBook.isMaster; // should always be true
                    scope.taskBook.title = taskBook.title;
                    scope.taskBook.tasks = tasks.data;
                    taskBookService.removeEmptyTasks(scope.taskBook.tasks);
                };

                var setDefaults = function () {
                    // defaults
                    scope.popbox = {
                        taskBookTypeahead: null,
                        action: scope.ACTIONS.COPY,
                        copy: {
                            action: scope.ACTIONS.ADD
                        },
                        showLink: angular.isUndefined(scope.showLink) || (scope.showLink === 'true')
                    };
                };

                var removeIds = function (tasks) {
                    for (var i = 0; i < tasks.length; i++) {
                        delete tasks[i].id;
                    }
                };

                var removeTasks = function () {
                    for (var i = (scope.taskBook.tasks.length - 1); i > -1; i--) {
                        taskBookService.removeTask(scope.taskBook.tasks, i);
                    }
                };

                var copyTaskbook = function (copiedTaskBook) {
                    // if the current taskBook isMaster, we need to remove its Ids before copying to properly save the new copied TaskBook.
                    if (scope.taskBook.isMaster) {
                        removeIds(scope.taskBook.tasks);
                    }
                    taskBookService.removeEmptyTasks(scope.taskBook.tasks);
                    removeIds(copiedTaskBook.data);

                    if (scope.popbox.copy.action === scope.ACTIONS.REPLACE) {
                        // if replace, move current scope to deleteTasks. Then remove all tasks from scope
                        if (!scope.taskBook.isMaster) {
                            [].push.apply(scope.tasksToDelete, scope.taskBook.tasks);
                        }
                        removeTasks();
                    }

                    for (var i = 0; i < copiedTaskBook.data.length; i++) {
                        copiedTaskBook.data[i].status = 'Incomplete';
                    }

                    // Removed direct assignment of taskBook.tasks http://jimhoskins.com/2012/12/14/nested-scopes-in-angularjs.html
                    [].push.apply(scope.taskBook.tasks, copiedTaskBook.data);

                    scope.taskBook.id = scope.taskBook.isMaster ? null : scope.taskBook.id;
                    scope.linkId = null; // need to remove consumer to know how to save
                    scope.taskBook.isMaster = false;
                    scope.taskBook.title = null;
                };

                scope.openPopBox = function (event) {
                    setDefaults();
                    popBoxService.open(event, popBoxName);
                    isPopBoxOpen = true;
                };

                scope.closePopBox = function () {
                    popBoxService.close(null, popBoxName);
                    isPopBoxOpen = false;
                };

                scope.togglePopBox = function (event) {
                    if (isPopBoxOpen) {
                        scope.closePopBox();
                    } else {
                        scope.openPopBox(event);
                    }
                };

                scope.popBoxOk = function () {
                    var query = {
                        taskBookId: scope.popbox.taskBookTypeahead.id,
                        orderby: 'Order asc'
                    };
                    DudeApi.TaskBookTaskEntity.query(query).$promise.then(function (response) {
                        if (scope.popbox.action === scope.ACTIONS.COPY) {
                            copyTaskbook(response);
                        } else if (scope.popbox.action === scope.ACTIONS.LINK) {
                            linkTaskBook(scope.popbox.taskBookTypeahead, response);
                        }
                        scope.popbox.taskBookTypeahead = null;
                        setDefaults();
                        scope.closePopBox();
                    });
                };

                scope.areThereTaskOrProceduresFilledOut = function () {
                    if (!angular.isArray(scope.taskBook.tasks)) {
                        return;
                    }

                    for (var i = 0; i < scope.taskBook.tasks.length; i++) {
                        var task = scope.taskBook.tasks[i];
                        if (task.title || task.procedure) {
                            return true; // eslint-disable-line consistent-return
                        }
                    }
                };

                var init = function () {
                    setDefaults();
                };

                init();
            }
        };
    });

'use strict';

angular.module('taskBookList', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate']);

'use strict';

angular.module('taskBookList')
    .factory('taskBookListFilterService', function (pagingHelpers) {
        var getFilters = function (params) {
            // if Adding a new search filter make sure to add it to the
            // isSearching() function below.
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Title asc',
                q: params.q || null,
                isMaster: true
            };

            return currentFilter;
        };

        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        // Checks to see if you are in search mode.
        var isSearching = function (filters) {
            return (filters.q !== null && filters.q !== '');
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            isSearching: isSearching
        };
    });

'use strict';

angular.module('taskBookList')
    .service('taskBookListService', function (DudeApi, taskBookListFilterService) {
        var getListData = function (query) {
            var filters = taskBookListFilterService.toApiFilter(query);
            return DudeApi.TaskBookEntity.query(filters);
        };

        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('taskBookList')
  .config(function ($stateProvider, permission) {
      $stateProvider
      .state('secure.taskBookList', {
          url: 'taskbooks?page&pageSize&q',
          templateUrl: 'app/components/taskBookList/taskBookList.html',
          controller: 'TaskBookListController',
          controllerAs: 'taskBookList',
          permissions: [permission.taskBooks.create, permission.taskBooks.update, permission.taskBooks.delete],
          resolve: {
              initData: function ($q, $stateParams, taskBookListService, taskBookListFilterService) {
                  var queryParams = $stateParams;
                  var filters = taskBookListFilterService.getFilters(queryParams);

                  return $q.all({
                      initResponse: taskBookListService.getListData(filters).$promise,
                      filters: filters
                  });
              }
          }
      });
  });

'use strict';

angular.module('taskBookList')
    .controller('TaskBookListController', function ($scope, $location, $state, taskBookListService, taskBookListFilterService, queryHelpers, orderByHelpers, initData) {
        var self = this;
        var queryDefaults = taskBookListFilterService.getFilters({});
        var pageChanging = false;

        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(self.filters.orderBy);
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (angular.equals(oldVal, newVal)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                newVal.page = 1;
            }

            pageChanging = false;

            taskBookListService.getListData(newVal).$promise.then(setData);
            queryHelpers.updateState(newVal, queryDefaults);
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            // Reset a cleared search to null not empty string
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, taskBookListFilterService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.showSearchResults = function () {
            // List out possible filters and if one is set then we show search
            return taskBookListFilterService.isSearching(self.filters);
        };

        self.clearFilters = function () {
            self.filters = taskBookListFilterService.getFilters({});
        };

        self.editTaskBook = function (id) {
            $state.go('secure.taskBookEdit', {
                id: id
            });
        };

        $scope.$watch('taskBookList.filters', updateFilters, true);
    });

'use strict';

angular.module('taskBookForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog', 'taskBook']);

'use strict';

angular.module('taskBookForm')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.taskBookCreate', {
                url: 'taskbooks/new',
                templateUrl: 'app/components/taskBookForm/taskBookForm.html',
                controller: 'TaskBookFormController',
                controllerAs: 'taskBookForm',
                permissions: permission.taskBooks.create,
                resolve: {
                    taskBook: function (DudeApi) {
                        return new DudeApi.TaskBookEntity({
                            tasks: [],
                            isMaster: true
                        });
                    },
                    pmScheduleCount: function () {
                        return { total: 0 };
                    }
                }
            })
            .state('secure.taskBookEdit', {
                url: 'taskbooks/:id',
                templateUrl: 'app/components/taskBookForm/taskBookForm.html',
                controller: 'TaskBookFormController',
                controllerAs: 'taskBookForm',
                permissions: permission.taskBooks.update,
                resolve: {
                    taskBook: function ($stateParams, DudeApi) {
                        var taskBook;
                        return DudeApi.TaskBookEntity.get({ id: $stateParams.id, includeAudit: true }).$promise
                            .then(function (_taskBook) {
                                taskBook = _taskBook;
                                return DudeApi.TaskBookTaskEntity.query({
                                    taskBookId: _taskBook.id,
                                    orderBy: 'Order asc'
                                }).$promise;
                            })
                            .then(function (_taskBookSummary) {
                                taskBook.tasks = _taskBookSummary.data;
                                return taskBook;
                            });
                    },
                    pmScheduleCount: function ($stateParams, DudeApi) {
                        return DudeApi.PmScheduleEntity.query({
                            taskBookId: $stateParams.id,
                            pagesize: 1
                        }).$promise.then(function (response) {
                            return response.total;
                        });
                    }
                }
            });
    });

'use strict';

angular.module('taskBookForm')
    .controller('TaskBookFormController', function ($q, $state, $scope, $timeout, $translate, $filter, $uibModal, log, taskBook, taskBookService, pmScheduleCount) {
        var self = this;
        self.taskBook = taskBook;
        var startingTaskBook = angular.copy(taskBook); // used to compare if we need to PUT
        self.tasksToDelete = [];
        self.updatedTime = $filter('date')(self.taskBook.updatedDateTime, 'MM/dd/yyyy h:mm a');

        var goToTaskBookList = function () {
            $state.go('secure.taskBookList');
        };

        var errorFn = function () {
            log.notify({
                title: $translate.instant('taskBookForm.notify.failure.title'),
                type: 'error',
                message: $translate.instant('taskBookForm.notify.failure.message')
            });
        };

        var successToast = function () {
            log.notify({
                title: $translate.instant('taskBookForm.notify.success.title'),
                type: 'success',
                message: $translate.instant('taskBookForm.notify.success.message')
            });
        };
        var skipNavigationWarningModal = function () {
            self.skipNavigationWarning = true;
        };

        var init = function () {
            // If there are no tasks then add some
            if (!angular.isArray(self.taskBook.tasks) || self.taskBook.tasks.length === 0) {
                taskBookService.addTasks(self.taskBook.tasks, 5);
            }

            // Wait til the form is loaded and set it to not dirty
            $timeout(function () {
                $scope.form.$dirty = false;
            }, 100);
        };

        self.saveTaskBook = function () {
            skipNavigationWarningModal();

            var _taskBook = angular.copy(taskBook);
            var taskBookPromise = _taskBook.id ? _taskBook.$update({ id: taskBook.id }) : _taskBook.$save();

            taskBookPromise.then(function (_savedTaskBook) {
                var promises = [];
                var i;

                // delete tasks
                for (i = 0; i < self.tasksToDelete.length; i++) {
                    var deleteTask = self.tasksToDelete[i];
                    var deleteTaskPromise = deleteTask.$delete({
                        id: deleteTask.id,
                        taskBookId: _savedTaskBook.id
                    });

                    promises.push(deleteTaskPromise);
                }

                // add tasks
                for (i = 0; i < taskBook.tasks.length; i++) {
                    var task = taskBook.tasks[i];
                    task.order = i + 1; // Make sure this is correct in the future

                    // Check to see if the task has changed and if not then dont make the call
                    if (!angular.equals(task, startingTaskBook.tasks[i]) && task.title) {
                        var addTasksPromise = task.id ? task.$update({
                            taskBookId: _savedTaskBook.id,
                            id: task.id
                        }) : task.$save({ taskBookId: _savedTaskBook.id });

                        promises.push(addTasksPromise);
                    }
                }

                $q.all(promises).then(function () {
                    successToast();
                    goToTaskBookList();
                }, errorFn);
            });
        };

        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('taskBookForm.notify.delete.title'),
                type: 'success',
                message: $translate.instant('taskBookForm.notify.delete.message')
            });
        };

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/taskBookForm/taskBookDeleteConfirmModal.html',
                controller: 'TaskBookDeleteModalController',
                size: 'sm',
                resolve: {
                    pmScheduleCount: function () {
                        return pmScheduleCount;
                    }
                },
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                taskBook.$delete({ id: taskBook.id }).then(function () {
                    showDeleteMessage();
                    $state.go('secure.taskBookList');
                });
            });
        };

        var deleteWarning = function () {
            $uibModal.open({
                templateUrl: 'app/components/taskBookForm/taskBookDeleteWarningModal.html',
                controller: 'TaskBookDeleteModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    pmScheduleCount: function () {
                        return pmScheduleCount;
                    }
                }
            });
        };

        self.deleteTaskBook = function () {
            if (pmScheduleCount > 0) {
                deleteWarning();
            } else {
                confirmDelete();
            }
        };

        init();
    });


'use strict';

angular.module('taskBookForm')
    .controller('TaskBookDeleteModalController', function ($uibModalInstance, $scope, pmScheduleCount) {
        $scope.pmScheduleCount = pmScheduleCount;

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

/**
 * @ngdoc service
 * @name dashboard.statusReportService
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires pagingHelpers {@link http://frontend.dudesoln.com/ng-docs/DudeControls/#/api/filterHelpers.pagingHelpersService read the docs}
 *
 * @description
 * Service for getting status reports from the Report API.
 *
 */

'use strict';

angular.module('dashboard')
    .service('statusReportService', function (DudeApi, pagingHelpers) {
        var checkArray = function (value) {
            return !Array.isArray(value) ? [value] : value;
        };

        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf dashboard.statusReportService
         *
         * @description
         * Returns a filter object parsed and formatted
         *
         * @param {object} params An object containing the filter params to use
         * @returns {object} Filter object
         */
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: parseInt(params.pageSize, 10) || parseInt(pagingHelpers.defaults.pageSize, 10),
                orderBy: params.orderBy || null,
                status: params.status || []
            };

            currentFilter.status = checkArray(currentFilter.status);

            return currentFilter;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf dashboard.statusReportService
         *
         * @description
         * Converts a filter object to a useable state by the api
         *
         * @param {object} currentFilter An object containing the filter params to use
         * @returns {object} Filter object
         */
        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        /**
         * @ngdoc method
         * @name getData
         * @methodOf dashboard.statusReportService
         *
         * @description
         * Returns status based on the query passed in.
         *
         * @param {object} query query An object containing the query to pass to the API.
         * @returns {object} The results from the API as an object.
         */
        var getData = function (query) {
            var filters = toApiFilter(query);

            return DudeApi.StatusesSummaryEntity.query(filters).$promise;
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            getData: getData
        };
    });

'use strict';

angular.module('helpers', ['marketizr', 'maintenanceConstants']);

'use strict';

angular.module('helpers')
    .filter('status', function ($translate, workOrderEnums) {
        var statuses = [];
        statuses[workOrderEnums.status.newRequest] = $translate.instant('statuses.newRequest');
        statuses[workOrderEnums.status.workInProgress] = $translate.instant('statuses.workInProgress');
        statuses[workOrderEnums.status.complete] = $translate.instant('statuses.complete');
        statuses[workOrderEnums.status.void] = $translate.instant('statuses.void');
        statuses[workOrderEnums.status.onHold] = $translate.instant('statuses.onHold');

        return function (input) {
            var value = statuses[input];
            if (!value) {
                return 'Unknown';
            }
            return value;
        };
    });

/**
 * @ngdoc service
 * @name settingsForm.settingsHelpers
 * @requires DudeApi
 *
 * @description
 * Service for handling the default purpose values
 *
 */

'use strict';

angular.module('settingsForm')
    .service('settingsHelpers', function ($filter, $translate, DudeApi, LABOR_HOUR_TYPE) {
        var KEYS = {
            LOCATION_DESCRIPTION: 'MM-helpers-locationDescription'
        };

        var defaultLocationDescription = {
            text: $translate.instant('settingsForm.areaRoomNumber.defaultText'),
            isRequired: false
        };

        /**
         * @ngdoc method
         * @name saveSetting
         * @methodOf settingsForm.settingsHelpers
         *
         * @description
         * Sets a default setting to the key provided
         *
         * @param {string} key The storage key for this setting
         * @param {object} value The value to store
         * @param {boolean} isNew A boolean that tells if this needs to be a new save or an update to an existing
         * @returns {Promise} A promise that resolves to the saved default
         */
        var saveSetting = function (key, value, isNew) {
            var defaultSetting = {
                key: key,
                value: value || {}
            };

            return isNew ? DudeApi.AccountSettingsEntity.save(defaultSetting).$promise : DudeApi.AccountSettingsEntity.update({ id: key }, defaultSetting).$promise;
        };

        /**
         * @ngdoc method
         * @name overtimeRateTypeReference
         * @methodOf settingsForm.settingsHelpers
         *
         * @description
         * Sets a default setting to the key provided
         *
         * @param {array} laborHourTypes The array labor hour types to filter through
         * @returns {array} An array of labor hour types that have type overtime
         */
        var overtimeRateTypeReference = function (laborHourTypes) {
            return $filter('filter')(laborHourTypes, function (laborHourType) {
                return laborHourType.type === LABOR_HOUR_TYPE.overtime;
            })[0];
        };

        /**
         * @ngdoc method
         * @name getLocationDescription
         * @methodOf settingsForm.settingsHelpers
         *
         * @description
         * returns a location description object
         *
         * @returns {object} An object containing the location description text and required boolean
         */
        var getLocationDescription = function () {
            return DudeApi.AccountSettingsEntity.get({ id: KEYS.LOCATION_DESCRIPTION }).$promise.then(function (result) {
                var locationDescriptionObject = result.value.text ? result.value : defaultLocationDescription;
                locationDescriptionObject.exists = true;
                return locationDescriptionObject;
            }, function () {
                return defaultLocationDescription;
            });
        };

        /**
         * @ngdoc method
         * @name doubletimeRateTypeReference
         * @methodOf settingsForm.settingsHelpers
         *
         * @description
         * Sets a default setting to the key provided
         *
         * @param {array} laborHourTypes The array labor hour types to filter through
         * @returns {array} An array of labor hour types that have type doubletime
         */
        var doubletimeRateTypeReference = function (laborHourTypes) {
            return $filter('filter')(laborHourTypes, function (laborHourType) {
                return laborHourType.type === LABOR_HOUR_TYPE.doubletime;
            })[0];
        };

        return {
            overtimeRateTypeReference: overtimeRateTypeReference,
            doubletimeRateTypeReference: doubletimeRateTypeReference,
            saveSetting: saveSetting,
            getLocationDescription: getLocationDescription,
            keys: KEYS
        };
    });

'use strict';

angular.module('settingsForm')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.settingsEdit', {
                url: 'settings',
                templateUrl: 'app/components/settingsForm/settingsForm.html',
                controller: 'SettingsFormController',
                controllerAs: 'settingsForm',
                permissions: permission.laborHourTypes.update,
                resolve: {
                    initData: function ($q, $stateParams, laborHourTypesService) {
                        return $q.all({
                            laborHourTypes: laborHourTypesService.getLaborHourTypes().$promise
                        });
                    },
                    requesterPurpose: function (defaultPurposesService) {
                        return defaultPurposesService.getPurpose(defaultPurposesService.purposeKeys.reactivePurpose);
                    },
                    plannedPurpose: function (defaultPurposesService) {
                        return defaultPurposesService.getPurpose(defaultPurposesService.purposeKeys.plannedPurpose);
                    },
                    areaRoomNumber: function (settingsHelpers) {
                        return settingsHelpers.getLocationDescription();
                    },
                    accountAlert: function (DudeApi) {
                        var alert = {
                            message: '',
                            roles: []
                        };

                        return DudeApi.AccountAlertsEntity.query().$promise
                            .then(function (result) {
                                if (result.data.length > 0) {
                                    alert = result.data[0];
                                }

                                return alert;
                            });
                    }
                }
            });
    });

'use strict';

angular.module('settingsForm')
    .controller('SettingsFormController', function ($scope, $q, $translate, $filter, $state, log, settingsHelpers, defaultPurposesService, initData, requesterPurpose, plannedPurpose, areaRoomNumber, accountAlert, market, marketizr) {
        var self = this;
        var laborHourTypes = initData.laborHourTypes.data;

        self.market = market;

        self.otRateMultiplier = settingsHelpers.overtimeRateTypeReference(laborHourTypes);
        self.dtRateMultiplier = settingsHelpers.doubletimeRateTypeReference(laborHourTypes);

        self.defaultReactivePurpose = requesterPurpose;
        self.defaultPlannedPurpose = plannedPurpose;

        self.areaRoomNumber = areaRoomNumber;

        self.accountAlert = accountAlert;

        self.spies = [];
        var offsetPadding = 50;
        self.headerOffset = angular.element('.main-nav').outerHeight(true) + angular.element('.header-container').outerHeight(true) + offsetPadding;

        var addLaborHourTypeUpdates = function (promises) {
            if ($scope.form.otRateMultiplier.$dirty) {
                promises.push(self.otRateMultiplier.$update({ id: self.otRateMultiplier.id }));
            }

            if ($scope.form.dtRateMultiplier.$dirty) {
                promises.push(self.dtRateMultiplier.$update({ id: self.dtRateMultiplier.id }));
            }

            return promises;
        };

        var settingsaveSuccess = function () {
            self.areaRoomNumber.exists = true;
            log.notify({
                type: 'success',
                message: $translate.instant('settingsForm.saveSuccess')
            });
        };

        var queuePromises = function (formSectionUpdates) {
            var promises = [];

            for (var i = 0; i < formSectionUpdates.length; i++) {
                promises = formSectionUpdates[i](promises);
            }

            return promises;
        };

        self.save = function () {
            var promises = queuePromises([addLaborHourTypeUpdates]);
            promises.push(settingsHelpers.saveSetting(defaultPurposesService.purposeKeys.reactivePurpose, self.defaultReactivePurpose, false));
            promises.push(settingsHelpers.saveSetting(defaultPurposesService.purposeKeys.plannedPurpose, self.defaultPlannedPurpose, false));
            if (marketizr.hasMarkets([self.market.k12, self.market.he, self.market.ips])) {
                promises.push(settingsHelpers.saveSetting(settingsHelpers.keys.LOCATION_DESCRIPTION, self.areaRoomNumber, !self.areaRoomNumber.exists));
            }
            return $q.all(promises).then(settingsaveSuccess);
        };
    });

'use strict';

angular.module('settingsForm')
    .service('laborHourTypesService', function (DudeApi) {
        var getLaborHourTypes = function () {
            return DudeApi.LaborHourTypeEntity.query({});
        };
        return {
            getLaborHourTypes: getLaborHourTypes
        };
    });

'use strict';

angular.module('settingsForm')
    .constant('LABOR_HOUR_TYPE', {
        overtime: 'Overtime',
        doubletime: 'Doubletime'
    });

'use strict';

angular.module('routeInterceptor', ['ui.router', 'dudeAuth', 'dudeApi']);

'use strict';

angular.module('routeInterceptor')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.interceptor', {
                url: 'landing',
                controller: 'RouteInterceptorController'
            });
    });

'use strict';

angular.module('routeInterceptor')
    .controller('RouteInterceptorController', function ($state, marketizr, market, roleHelpers) {
        if (roleHelpers.isRequester()) {
            $state.go('secure.workOrderFormNew');
        } else if (roleHelpers.isTechnician() && !marketizr.hasMarkets([market.k12, market.he, market.ips])) {
            $state.go('secure.workOrderList');
        } else {
            $state.go('secure.dashboard');
        }
    });

'use strict';

angular.module('report', ['dudeAuth', 'reportFilters', 'dudeControlsCharts', 'maintenanceConstants']);

/**
 * @ngdoc service
 * @name report.reportTooltipService
 *
 * @description
 * Service for generating tooltip text for the reporting charts
 *
 */

'use strict';

angular.module('report')
    .service('reportTooltipService', function () {
        var getAncestorPath = function (object) {
            var string = '';
            if (object.ancestorIdPath) {
                string += '<ol class="breadcrumb text-muted text-center" >';
                var hierarchy = object.ancestorNamePath.split('|');
                hierarchy.forEach(function (parent) {
                    if (parent.length) {
                        string += '<li>' + parent + '</li>';
                    }
                });
                string += '</ol>';
            }
            return string;
        };

        /**
         * @ngdoc method
         * @name standardTooltip
         * @methodOf report.reportTooltipService
         *
         * @description
         * Returns a string to use in the tooltip for a chart segment
         *
         * @param {object} object The data object containing the name and asset data
         * @param {string} displayValue The user friendly display of the data value of a segment of a chart
         * @returns {string} The string to use in the tooltip
         */
        var standardTooltip = function (object, displayValue) {
            var text = object.value || object.name;
            var string = '<div class="chart-tooltip"><div class="text-center tooltip-name"><strong>' + text + '</strong></div>';
            string += getAncestorPath(object);
            string += '<div class="text-center tooltip-count">' + displayValue + '</div></div>';
            return string;
        };

        /**
         * @ngdoc method
         * @name costChartTooltip
         * @methodOf report.reportTooltipService
         *
         * @description
         * Returns a string to use in the tooltip for a cost chart segment
         *
         * @param {object} object The data object containing the name and asset data
         * @param {string} laborCost The user friendly display of the labor cost of a segment of a chart
         * @param {string} purchaseCost The user friendly display of the purchase cost of a segment of a chart
         * @param {string} serviceCost The user friendly display of the service cost of a segment of a chart
         * @param {string} totalCost The user friendly display of the total cost of a segment of a chart
         * @returns {string} The string to use in the tooltip
         */
        var costChartTooltip = function (object, laborCost, purchaseCost, serviceCost, totalCost) {
            var text = object.value || object.name;
            var string = '<div class="chart-tooltip"><div class="text-center tooltip-name"><strong>' + text + '</strong></div>';
            string += getAncestorPath(object);
            string += '<div class="text-center tooltip-labor">' + laborCost + '</div>';
            string += '<div class="text-center tooltip-service">' + serviceCost + '</div>';
            string += '<div class="text-center tooltip-purchase">' + purchaseCost + '</div>';
            string += '<div class="text-center tooltip-total">' + totalCost + '</div></div>';
            return string;
        };

        return {
            standardTooltip: standardTooltip,
            costChartTooltip: costChartTooltip
        };
    });

/**
 * @ngdoc directive
 * @name report.report-navigation
 * @restrict E
 * @description
 *
 * Displays the navigation tabs and sets the current one active for the reports pages
 *
 * @param {object} filters the filter object to pass through on route
 *
 * <report-navigation filters="filterObject"></report-navigation>
 */

'use strict';

angular.module('report')
    .component('reportNavigation', {
        bindings: {
            filters: '='
        },
        templateUrl: 'app/components/reports/reportNavigation.html',
        controller: 'ReportNavigationComponent',
        controllerAs: 'reportNavigation'
    })
    .controller('ReportNavigationComponent', function ($state, market) {
        var self = this;

        self.isActiveRoute = function (parameter) {
            return $state.current.url.indexOf(parameter + '/') === 0;
        };

        self.isChartView = $state.current.url.indexOf('chart') !== -1;

        self.market = market;

        self.routeTo = function (routeParam, ignoreChartCheck) {
            var reportType = self.isChartView && !ignoreChartCheck ? 'Chart' : 'List';
            var route = 'secure.report.' + routeParam + reportType;
            var filterCopy = angular.copy(self.filters);
            delete filterCopy.orderBy;
            delete filterCopy.filterId;

            if (routeParam === 'locations' || routeParam === 'equipment') {
                delete filterCopy.businessAsset;
            }

            $state.go(route, filterCopy);
        };
    });

/**
 * @ngdoc directive
 * @name report.report-list-totals
 * @restrict E
 * @description
 *
 * Displays the totals for the current report list
 *
 * @param {object} data the data object containing the fields to display for totals
 *
 * <report-list-totals data="dataObject"></report-list-totals>
 */

'use strict';

angular.module('report')
    .component('reportListTotals', {
        bindings: {
            data: '='
        },
        templateUrl: 'app/components/reports/reportListTotals.html',
        controller: 'ReportListTotalsController',
        controllerAs: 'reportListTotals'
    })
    .controller('ReportListTotalsController', function () {
    });

/**
 * @ngdoc service
 * @name report.reportDataService
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires moment - {@link http://momentjs.com/docs/ read the docs}
 * @requires $translate - {@link https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate read the docs}
 *
 * @description
 * Service for supporting and working with data from the report pages
 *
 */

'use strict';

angular.module('report')
    .service('reportDataService', function (DudeApi, moment, $translate) {
        var top = $translate.instant('reports.top');

        /**
         * @ngdoc method
         * @name topLabel
         * @methodOf report.reportDataService
         *
         * @description
         * Expands the chart title to include the top count if needed
         *
         * @param {array} filterArray An array of filters
         * @param {object} results The returned results object from the api in its paging wrapper
         * @param {object} dataObject The data object to be passed to the charting service
         * @param {object} labels An object of labels to be used with the chart
         * @param {number} count The maximum count of items to be shown
         */
        var topLabel = function (filterArray, results, dataObject, labels, count) {
            if (filterArray.length === 0 && results.total > 5 && dataObject.idArray.length === count && labels.title.indexOf(('(' + top)) < 0) {
                labels.title += ' (' + top + ' ' + count + ')';
            }
        };

        /**
         * @ngdoc method
         * @name exportReport
         * @methodOf report.reportDataService
         *
         * @description
         * Downloads a specified work order reports exported report
         *
         * @param {object} query The filters to query with
         * @param {string} target The target endpoint to export from
         */
        var exportReport = function (query, target) {
            delete query.page;
            delete query.pageSize;
            query.timezone = moment.tz.guess();

            DudeApi.workOrderExportService.download(query, target);
        };

        return {
            topLabel: topLabel,
            exportReport: exportReport
        };
    });

/**
 * @ngdoc service
 * @name report.reportChartPrintService
 * @requires $q - {@link https://docs.angularjs.org/api/ng/service/$q read the docs}
 * @requires $filter - {@link https://docs.angularjs.org/api/ng/service/$filter read the docs}
 * @requires $translate - {@link https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate read the docs}
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires bulkPrintHelperService
 *
 * @description
 * Service for printing the report charts to pdf
 *
 */
'use strict';

angular.module('report')
    .service('reportChartPrintService', function ($q, $filter, $translate, DudeApi, bulkPrintHelperService) {
        var chartContentDivTag = '<div style="margin-left: 110px; page-break-after: always; width: 835px;">';
        var chartContentNoPageBreak = '<div style="margin-left: 110px; width: 835px;">';

        // Opening tag for each summary table
        var summaryTableTag = '<table class="summary-table" style="border-spacing: 0 3px; font-size: 14px; padding-left: 25px; width: 100%;">';

        var getNamesFromIds = function (id, entity) {
            return DudeApi[entity].get({ id: id }).$promise.then(function (response) {
                return response.name || response.value;
            });
        };

        var buildDrillDownHtml = function (chart, title, filterSection, drillDownData) {
            var drillDownSummary = '';
            var optimalSize = 9;
            var workOrderChart = chart.includes('Work Orders');
            var costChart = chart.includes('pop-box-report-drill-down-chart-cost');
            var laborChart = chart.includes('pop-box-report-drill-down-chart-labor');

            if (!workOrderChart && !costChart && !laborChart) {
                return '';
            }

            if ((drillDownData.dataArray.length > optimalSize) && !laborChart) {
                drillDownSummary += '</div></div>' +
                title +
                filterSection +
                '<br><br>' +
                chartContentDivTag +
                '<div style="position: relative;">';
            } else if ((drillDownData.dataArray.length > optimalSize) && laborChart) {
                drillDownSummary += '</div></div>' +
                title +
                filterSection +
                '<br><br>' +
                chartContentNoPageBreak +
                '<div style="position: relative;">';
            }

            if (workOrderChart) {
                drillDownSummary += summaryTableTag +
                    '<tr style="text-align: left;">' +
                    '<th style="border-bottom: 1px solid black; text-align: left; width: 80%;">' +
                    drillDownData.name + '</th>' +
                    '<th style="border-bottom: 1px solid black; text-align: right;">' +
                    $translate.instant('reports.byWorkOrders.workOrders') +
                    '</th></tr>';
            } else if (costChart) {
                drillDownSummary += summaryTableTag +
                '<tr>' +
                '<th style="width: 40%; border-bottom: 1px solid black; text-align: left;">' + drillDownData.name + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byCost.purchase') + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byCost.service') + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byCost.labor') + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('general.total') + '</th>' +
                '</tr>';
            } else if (laborChart) {
                drillDownSummary += summaryTableTag +
                    '<tr style="text-align: left;">' +
                    '<th style="border-bottom: 1px solid black; text-align: left; width: 80%;">' +
                    drillDownData.name + '</th>' +
                    '<th style="border-bottom: 1px solid black; text-align: right;">' +
                    $translate.instant('reports.byCost.hours') +
                    '</th></tr>';
            }

            if (!costChart) {
                for (var i = 1; i < drillDownData.dataArray.length; i++) {
                    drillDownSummary += '<tr style="margin-bottom: 20px;">' +
                        '<td style="width: 80%;">' + drillDownData.dataArray[i][0] + '</td>' +
                        '<td style="text-align: right;">' + drillDownData.dataArray[i][1].v + '</td>' +
                        '</tr>';
                }
            } else {
                for (var j = 1; j < drillDownData.dataArray.length; j++) {
                    var totalCost = drillDownData.dataArray[j][1].v + drillDownData.dataArray[j][3].v + drillDownData.dataArray[j][5].v;
                    drillDownSummary += '<tr style="margin-bottom: 20px;">' +
                        '<td style="width: 40%;">' + drillDownData.dataArray[j][0] + '</td>' +
                        '<td style="width: 15%; text-align: right;">' + $filter('currency')(drillDownData.dataArray[j][1].v) + '</td>' +
                        '<td style="width: 15%; text-align: right;">' + $filter('currency')(drillDownData.dataArray[j][3].v) + '</td>' +
                        '<td style="width: 15%; text-align: right;">' + $filter('currency')(drillDownData.dataArray[j][5].v) + '</td>' +
                        '<td style="width: 15%; text-align: right;">' + $filter('currency')(totalCost) + '</td>' +
                        '</tr>';
                }
            }

            drillDownSummary += '</table>';

            if (workOrderChart) {
                return '' +
                    title +
                    filterSection +
                    chartContentDivTag +
                    '<div id="workOrdersChartDrillDown" style="position: relative;">' +
                    '<div class="col-xs-12"><h6><strong>' + drillDownData.name + '</strong></h6></div>' +
                    chart +
                    '<br>' +
                    drillDownSummary +
                    '</div>' +
                    '</div>';
            } else if (costChart) {
                return '' +
                    title +
                    filterSection +
                    chartContentDivTag +
                    '<div id="costChartDrillDown" style="position: relative;">' +
                    chart +
                    drillDownSummary +
                    '</div>' +
                    '</div>';
            } else if (laborChart) {
                return '' +
                    title +
                    filterSection +
                    (drillDownData.dataArray.length > optimalSize ? chartContentDivTag : chartContentNoPageBreak) +
                    '<div id="laborChartDrillDown" style="position: relative;">' +
                    chart +
                    drillDownSummary +
                    '</div>' +
                    '</div>';
            }
            return '';
        };

        var buildChartHtml = function (html, labels, summary, filter, type) {
            // The report title, displayed on each page
            var reportTitle = '<span style="border-bottom: 1px solid black; display: block; font-size: 16px; margin-left: 15px; padding-top: 15px; width 100%;"><strong>' + $translate.instant('reports.reportTitle.' + type) + '</strong></span>';

            // Displays the filter information under the report title on each page
            var ignoredFilters = ['page', 'pageSize', 'orderBy', 'returnAverages', 'dateRange', 'isLocation', 'assetRollUp'];
            var filtersMessage = '<div style="padding: 10px 0 0 15px;">';

            var drillDownWorkOrders = '';
            var drillDownCost = '';
            var drillDownLabor = '';
            var includesDrillDowns = (html.length > 3) && (html[3].workOrder !== '' || html[3].cost !== '' || html[3].labor !== '');

            Object.keys(filter).forEach(function (key) {
                if (filter[key] == null || ignoredFilters.indexOf(key) !== -1 || (Array.isArray(filter[key]) && filter[key].length === 0)) {
                    return;
                }
                var value;
                if (key === 'status') {
                    value = [];
                    filter[key].forEach(function (val) {
                        value.push($translate.instant('reports.statuses.' + val));
                    });
                    value = value.join(', ');
                } else {
                    value = Array.isArray(filter[key]) ? filter[key].join(', ') : filter[key].toString();
                    value = key.indexOf('completionDate') !== -1 || key.indexOf('requestDate') !== -1 ? new Date(value).toLocaleString() : value;
                }
                filtersMessage += '<div style="margin: 0; padding: 0 0 5px 0; float: left; width: 20%;">' + $translate.instant('reports.filters.' + key) + ':</div>' +
                    '<div style="margin: 0; padding: 0 0 5px 0;display: table-cell;">' + value + '</div>';
            });
            filtersMessage += '</div>';

            if (includesDrillDowns) {
                drillDownWorkOrders = buildDrillDownHtml(html[3].workOrder, reportTitle, filtersMessage, summary.drillDownData);
                drillDownCost = buildDrillDownHtml(html[3].cost, reportTitle, filtersMessage, summary.drillDownData);
                drillDownLabor = buildDrillDownHtml(html[3].labor, reportTitle, filtersMessage, summary.drillDownData);
            }

            // Warning to put over graph if no data
            var noDataWarning = '<div class="no-data-warning" style="background: #fff; box-shadow: 2px 2px 9px rgba(0,0,0,.3); font-size: 20px; left: calc(50% - 100px); padding: 5px; position: absolute; text-align: center; top: calc(50% - 32px); width: 250px;">' +
                '<h6 class="ng-binding">' + $translate.instant('reports.noDataMessage') + '</h6>' +
                '</div>';

            // Work order summary chart
            var workOrdersChartSummary = summaryTableTag +
                '<tr style="text-align: left;">' +
                '<th style="border-bottom: 1px solid black; text-align: left; width: 80%;">' + $translate.instant('reports.' + type) + '</th>' +
                '<th style="border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byWorkOrders.workOrders') + '</th>' +
                '</tr>';

            for (var i = 1; i < summary.workOrderChartData.dataArray.length; i++) {
                workOrdersChartSummary += '<tr style="margin-bottom: 20px;">' +
                    '<td style="width: 80%;">' + summary.workOrderChartData.dataArray[i][0] + '</td>' +
                    '<td style="text-align: right;">' + summary.workOrderChartData.dataArray[i][1].v + '</td>' +
                    '</tr>';
            }
            workOrdersChartSummary += '</table>';
            workOrdersChartSummary = summary.workOrderChartData.dataArray.length > 1 ? workOrdersChartSummary : '';

            // Cost summary chart
            var costChartSummary = summaryTableTag +
                '<tr>' +
                '<th style="width: 40%; border-bottom: 1px solid black; text-align: left;">' + $translate.instant('reports.' + type) + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byCost.purchase') + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byCost.service') + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byCost.labor') + '</th>' +
                '<th style="width: 15%; border-bottom: 1px solid black; text-align: right;">' + $translate.instant('general.total') + '</th>' +
                '</tr>';

            for (var j = 1; j < summary.costChartData.dataArray.length; j++) {
                var totalCost = summary.costChartData.dataArray[j][1].v + summary.costChartData.dataArray[j][3].v + summary.costChartData.dataArray[j][5].v;
                costChartSummary += '<tr style="margin-bottom: 20px;">' +
                    '<td style="width: 40%;">' + summary.costChartData.dataArray[j][0] + '</td>' +
                    '<td style="width: 15%; text-align: right;">' + $filter('currency')(summary.costChartData.dataArray[j][1].v) + '</td>' +
                    '<td style="width: 15%; text-align: right;">' + $filter('currency')(summary.costChartData.dataArray[j][3].v) + '</td>' +
                    '<td style="width: 15%; text-align: right;">' + $filter('currency')(summary.costChartData.dataArray[j][5].v) + '</td>' +
                    '<td style="width: 15%; text-align: right;">' + $filter('currency')(totalCost) + '</td>' +
                    '</tr>';
            }
            costChartSummary += '</table>';
            costChartSummary = summary.costChartData.dataArray.length > 1 ? costChartSummary : '';

            // Labor hours summary chart
            var laborHoursChartSummary = summaryTableTag +
                '<tr>' +
                '<th style="border-bottom: 1px solid black; text-align: left; width: 80%;">' + $translate.instant('reports.' + type) + '</th>' +
                '<th style="border-bottom: 1px solid black; text-align: right;">' + $translate.instant('reports.byLaborHours.hours') + '</th>' +
                '</tr>';

            for (var k = 1; k < summary.laborHoursChartData.dataArray.length; k++) {
                laborHoursChartSummary += '<tr style="margin-bottom: 20px;">' +
                    '<td style="width: 80%;">' + summary.laborHoursChartData.dataArray[k][0] + '</td>' +
                    '<td style="text-align: right;">' + summary.laborHoursChartData.dataArray[k][1].v + '</td>' +
                    '</tr>';
            }
            laborHoursChartSummary += '</table>';
            laborHoursChartSummary = summary.laborHoursChartData.dataArray.length > 1 ? laborHoursChartSummary : '';

            // Choose whether or not to show the no data warning
            var noWorkOrderData = summary.workOrderChartData.dataArray.length > 1 ? '' : noDataWarning;
            var noCostData = summary.costChartData.dataArray.length > 1 ? '' : noDataWarning;
            var noLaborHoursData = summary.laborHoursChartData.dataArray.length > 1 ? '' : noDataWarning;

            return '<html>' +
                '<head><title>' + labels.title + '</title>' +
                '<style>' +
                    '.chart-legend { background: #ffffff; padding-left: 10px; position: absolute; right: 0; top: 80px; z-index: 10;} ' +
                    '.legend-entry {margin-top: 8px;}' +
                    '.legend-0 {background-color: #ff8a65;} ' +
                    '.legend-1 {background-color: #af46ae;} ' +
                    '.legend-2 {background-color: #5cb7ad;} ' +
                    '.fa {display: inline-block; font: normal normal normal 14px/1 FontAwesome; font-size: inherit; text-rendering: auto; -webkit-font-smoothing: antialiased;}' +
                    '.fa-square:before { content: ""; display: inline-block; width: 5px; height: 10px; margin-right: 5px;}' +
                    'h6 {font-size: 14px}' +
                    '.drill-down-chart .chart-legend {top: -31px;}' +
                    '.drill-down-chart .legend-entry {display: inline-block; margin-left: 15px;}' +
                    '.drill-down-chart .legend-0 {background-color: #00a7ab;}' +
                    '.drill-down-chart .legend-1 {background-color: #3eb9c5;}' +
                    '.drill-down-chart .legend-2 {background-color: #71cdd6;}' +
                '</style>' +
                '</head>' +
                '<body style="font-family: Helvetica, Arial, sans-serif; font-size: 14px; width: 1092px;">' +
                reportTitle +
                filtersMessage +
                chartContentDivTag +
                '<div id="workOrders" style="margin-left: 30px;">' +
                '<div id="workOrdersChart" style="position: relative;">' +
                html[0] +
                noWorkOrderData +
                workOrdersChartSummary +
                '</div>' +
                '</div>' +
                '</div>' +
                drillDownWorkOrders +
                reportTitle +
                filtersMessage +
                chartContentDivTag +
                '<div id="cost" style="margin-left: 30px;">' +
                '<div id="costChart" style="position: relative;">' +
                html[1] +
                noCostData +
                costChartSummary +
                '</div>' +
                '</div>' +
                '</div>' +
                drillDownCost +
                reportTitle +
                filtersMessage +
                (includesDrillDowns && html[3].labor.includes('pop-box-report-drill-down-chart-labor') ? chartContentDivTag : chartContentNoPageBreak) +
                '<div id="laborHours" style="margin-left: 30px;">' +
                '<div id="laborHoursChart" style="position: relative;">' +
                html[2] +
                noLaborHoursData +
                laborHoursChartSummary +
                '</div>' +
                '</div>' +
                '</div>' +
                drillDownLabor +
                '</body>' +
                '</html>';
        };

        /**
         * @ngdoc method
         * @name printCharts
         * @methodOf report.reportChartPrintService
         *
         * @description
         * Requests a URL from the report api containing the charts
         *
         * @param {Array} html The markup to be printed to pdf
         * @param {object} filterBody The filters used to generate the chart
         * @param {object} summary The summary data to be printed below the chart
         * @param {string} type The type of chart to be printed
         */
        var printCharts = function (html, filterBody, summary, type) {
            var promises = [];
            var filters = angular.copy(filterBody);
            if (filters.businessAsset && filters.businessAsset.length) {
                filters.businessAsset.forEach(function (asset) {
                    promises.push(getNamesFromIds(asset, 'BusinessAssetEntity'));
                });
            } else {
                filters.businessAsset = [];
            }
            if (filters.workType && filters.workType.length) {
                filters.workType.forEach(function (workType) {
                    promises.push(getNamesFromIds(workType, 'WorkTypeEntity'));
                });
            } else {
                filters.workType = [];
            }
            if (filters.purpose && filters.purpose.length) {
                filters.purpose.forEach(function (purpose) {
                    promises.push(getNamesFromIds(purpose, 'PurposeEntity'));
                });
            } else {
                filters.purpose = [];
            }

            return $q.all(promises).then(function (namesData) {
                filters.businessAsset = !filters.businessAsset.length ? [] : namesData.slice(0, filters.businessAsset.length);
                filters.workType = !filters.workType.length ? [] : namesData.slice(filters.businessAsset.length, filters.workType.length + filters.businessAsset.length);
                filters.purpose = !filters.purpose.length ? [] : namesData.slice(filters.workType.length + filters.businessAsset.length, filters.purpose.length + filters.workType.length + filters.businessAsset.length);
                var renderedHtml = buildChartHtml(html, {
                    title: $translate.instant('reports.reportTitle.' + type)
                }, summary, filters, type);
                return bulkPrintHelperService.bulkPrint('ReportChartPdfEntity',
                    {
                        fileName: type + 'ReportCharts.pdf',
                        title: $translate.instant('reports.reportTitle.' + type),
                        html: renderedHtml,
                        orientation: 'landscape'
                    },
                    {
                        title: $translate.instant('reports.reportTitle.' + type),
                        display: $translate.instant('reports.loadingReport.' + type),
                        loading: $translate.instant('reports.loadingReport.' + type)
                    });
            });
        };

        return {
            printCharts: printCharts
        };
    });

'use strict';

angular.module('report')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.report',
            {
                abstract: true,
                url: 'report/',
                template: '<div ui-view></div>',
                controllerAs: 'report'
            });
    });

'use strict';

angular.module('reportFilters', ['translate', 'dudeAuth', 'dudeControls']);

/**
 * @ngdoc service
 * @name report.reportFiltersService
 * @requires $location - {@link https://docs.angularjs.org/api/ng/service/$location read the docs}
 * @requires pagingHelpers - {@link http://frontend.dudesoln.com/ng-docs/DudeControls/#/api/filterHelpers.pagingHelpersService read the docs}
 *
 * @description
 * Service for supporting the filtering of the report pages
 *
 */

'use strict';

angular.module('reportFilters')
    .factory('reportFiltersService', function ($location, $translate, marketizr, market, moment, pagingHelpers, userContext) {
        var isEdu = marketizr.hasMarkets([market.k12, market.he, market.ips]);

        var currentYear = moment().year();
        var lastMonth = moment().subtract(1, 'months');
        var lastYear = moment().subtract(1, 'year');
        var fiscalStartDate = moment(userContext.account.fiscalStartDate).year(currentYear);
        var fiscalEndDate = moment(fiscalStartDate).add(1, 'year').subtract(1, 'day');

        if (moment().isBefore(fiscalStartDate, 'day')) {
            fiscalStartDate = moment(fiscalStartDate).subtract(1, 'year');
            fiscalEndDate = moment(fiscalEndDate).subtract(1, 'year');
        }

        var lastFiscalStart = moment(fiscalStartDate).subtract(1, 'year');
        var lastFiscalEnd = moment(fiscalEndDate).subtract(1, 'year');

        // Presently used for edu markets
        var dateIncrements = [
            {
                text: $translate.instant('reportFilters.dateRange.thisMonth'),
                startDate: moment().startOf('month'),
                endDate: moment().endOf('month')
            },
            {
                text: $translate.instant('reportFilters.dateRange.lastMonth'),
                startDate: moment(lastMonth).startOf('month'),
                endDate: moment(lastMonth).endOf('month')
            },
            {
                text: $translate.instant('reportFilters.dateRange.thisFiscalYear'),
                startDate: fiscalStartDate,
                endDate: fiscalEndDate
            },
            {
                text: $translate.instant('reportFilters.dateRange.lastFiscalYear'),
                startDate: lastFiscalStart,
                endDate: lastFiscalEnd
            },
            {
                text: $translate.instant('reportFilters.dateRange.thisCalendarYear'),
                startDate: moment().startOf('year'),
                endDate: moment().endOf('year')
            },
            {
                text: $translate.instant('reportFilters.dateRange.lastCalendarYear'),
                startDate: moment(lastYear).startOf('year'),
                endDate: moment(lastYear).endOf('year')
            }
        ];

        // Presently used for non-edu markets
        var dateRanges = [
            {
                text: $translate.instant('reportFilters.dateRange.last7'),
                startDate: moment().subtract(7, 'days').hours(0).minutes(0).seconds(0),
                endDate: moment().hours(23).minutes(59).seconds(59)
            },
            {
                text: $translate.instant('reportFilters.dateRange.last30'),
                startDate: moment().subtract(30, 'days').hours(0).minutes(0).seconds(0),
                endDate: moment().hours(23).minutes(59).seconds(59)
            },
            {
                text: $translate.instant('reportFilters.dateRange.last90'),
                startDate: moment().subtract(90, 'days').hours(0).minutes(0).seconds(0),
                endDate: moment().hours(23).minutes(59).seconds(59)
            }
        ];

        var checkArray = function (value) {
            if (!Array.isArray(value)) {
                var array = [];
                array.push(value);
                return array;
            }
            return value;
        };

        var getDateRanges = function () {
            return (isEdu) ? dateIncrements : dateRanges;
        };

        var interpretDateRanges = function (filters, ranges) {
            var dates = ranges || getDateRanges();
            var dateIntervals = dates.reduce(function (pv, cv) {
                pv[cv.text] = {
                    from: cv.startDate,
                    to: cv.endDate
                };
                return pv;
            }, {});

            var dateTypes = [
                {
                    from: 'requestDateFrom',
                    to: 'requestDateTo',
                    range: 'requestDateRange'
                },
                {
                    from: 'completionDateFrom',
                    to: 'completionDateTo',
                    range: 'completionDateRange'
                },
                {
                    from: 'dateFrom',
                    to: 'dateTo',
                    range: 'dateRange'
                }
            ];

            return dateTypes.reduce(function (pv, cv) {
                if (pv[cv.range] && pv[cv.range].toLowerCase() !== 'custom' && pv[cv.range].toLowerCase() !== 'all') {
                    pv[cv.from] = new Date(dateIntervals[pv[cv.range]].from).toISOString();
                    pv[cv.to] = new Date(dateIntervals[pv[cv.range]].to).toISOString();
                }
                return pv;
            }, filters);
        };

        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf report.reportFiltersService
         *
         * @description
         * Returns a filter object parsed and formatted
         *
         * @param {object} params An object containing the filter params to use
         * @param {array} ranges An array containing date ranges
         * @returns {object} Filter object
         */
        var getFilters = function (params, ranges) {
            var isAssetReport = params.isLocation === true || params.isLocation === false;
            var defaultOrderBy = 'Count/WorkOrders desc';
            if (isAssetReport && ((isEdu && params.returnAverages === 'true') || params.assetRollUp)) {
                defaultOrderBy = 'TotalsWithDescendants/Count/WorkOrders desc';
            }
            if (!isAssetReport && params.orderBy && params.orderBy.indexOf('TotalsWithDescendants') > -1) {
                params.orderBy = null;
            }
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: parseInt(params.pageSize, 10) || parseInt(pagingHelpers.defaults.pageSize, 10),
                orderBy: params.orderBy || defaultOrderBy,
                status: params.status || [],
                purpose: params.purpose || [],
                requestDateFrom: params.requestDateFrom || null,
                requestDateTo: params.requestDateTo || null,
                requestDateRange: params.requestDateRange || null,
                completionDateFrom: params.completionDateFrom || null,
                completionDateTo: params.completionDateTo || null,
                completionDateRange: params.completionDateRange || null,
                dateFrom: params.dateFrom || null,
                dateTo: params.dateTo || null,
                dateRange: params.dateRange || null,
                businessAsset: params.businessAsset || [],
                includeDescendants: params.includeDescendants || null,
                assetRollUp: params.assetRollUp || null,
                workType: params.workType || [],
                assignees: params.assignees || null,
                returnAverages: params.returnAverages === 'true' ? 'true' : 'false',
                isLocation: (params.isLocation === true || params.isLocation === false) ? params.isLocation : null,
                filterId: params.filterId || null
            };

            if (isEdu && currentFilter.assetRollUp === null) {
                currentFilter.assetRollUp = 'true';
            }
            currentFilter.status = checkArray(currentFilter.status);
            currentFilter.purpose = checkArray(currentFilter.purpose);
            currentFilter.businessAsset = checkArray(currentFilter.businessAsset);
            currentFilter.workType = checkArray(currentFilter.workType);
            currentFilter = interpretDateRanges(currentFilter, ranges);
            return currentFilter;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf report.reportFiltersService
         *
         * @description
         * Converts a filter object to a useable state by the api
         *
         * @param {object} currentFilter An object containing the filter params to use
         * @param {array} ranges An array containing date ranges
         * @returns {object} Filter object
         */
        var toApiFilter = function (currentFilter, ranges) {
            var filter = getFilters(currentFilter, ranges);

            if (filter.status && (filter.status === 'all' || filter.status[0] === 'all')) {
                delete filter.status;
            }

            return filter;
        };

        /**
         * @ngdoc method
         * @name isFilterApplied
         * @methodOf report.reportFiltersService
         *
         * @description
         * Checks to see if a filter is applied
         *
         * @param {object} filters An object containing the current filters
         * @returns {boolean} A boolean stating whether or not filters are applied
         */
        var isFilterApplied = function (filters) {
            var cloned = angular.copy(filters);
            cloned.status = cloned.status === 'all' ? [] : cloned.status;
            cloned.dateRange = cloned.dateRange === 'all' ? null : cloned.dateRange;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, getFilters({}));
        };

        /**
         * @ngdoc method
         * @name compareFilters
         * @methodOf report.reportFiltersService
         *
         * @description
         * Loops through the filters and verifies if any of them have changed
         *
         * @param {object} newFilter An object containing the new filters
         * @param {object} originalFilter An object containing the prior filters
         * @param {array} filtersToCheck An array of filters to check
         * @returns {boolean} A boolean stating whether or not filters have changed
         */
        var compareFilters = function (newFilter, originalFilter, filtersToCheck) {
            var equals = true;
            filtersToCheck.forEach(function (param) {
                equals = equals && angular.equals(newFilter[param], originalFilter[param]);
            });
            return equals;
        };

        return {
            getDateRanges: getDateRanges,
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            isFilterApplied: isFilterApplied,
            compareFilters: compareFilters
        };
    });

/**
 * @ngdoc directive
 * @name reportFilters.report-filters
 * @restrict E
 * @description
 *
 * Displays the filter section for the reports
 *
 * @param {object} filters stores the value of all defined filters
 * @param {function} setFunction function reference to set the filters
 * @param {object} openWhen Determines when sliding panel should open
 * @param {function} clearFunction function reference to handle the clear action
 *
 */

'use strict';

angular.module('reportFilters')
    .directive('reportFilters', function ($state, marketizr, market, reportFiltersService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                filters: '=',
                setFunction: '&',
                openWhen: '=',
                clearFunction: '&'
            },
            templateUrl: 'app/components/reportFilters/reportFilters.html',
            link: function (scope, element, attrs) {
                var assetToggle = attrs.assetToggle || 'includeDescendants';

                scope.market = market;
                scope.dateValues = reportFiltersService.getDateRanges();

                // This is setting the correct query parameter name for the report.
                scope.checkbox = {
                    state: scope.filters[assetToggle]
                };

                scope.assetBrowseOptions = {
                    type: 'slidingpanel',
                    filterPanel: {
                        search: {
                            filter: 'q'
                        },
                        'asset-node-search': {
                            filters: ''
                        }
                    }
                };

                if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                    scope.assetBrowseOptions.filterPanel['asset-category'] = {
                        filter: 'isLocation'
                    };
                    scope.assetHideCheckBox = true;
                    scope.filters.assetRollUp = 'true';
                }

                if ($state.current.url.indexOf('locations/') !== -1) {
                    scope.assetAdditionalFilters = {
                        isLocation: true,
                        includeDescendants: true
                    };
                    delete scope.assetBrowseOptions.filterPanel['asset-category'];
                }

                if ($state.current.url.indexOf('equipment/') !== -1) {
                    scope.assetAdditionalFilters = {
                        isLocation: false,
                        includeDescendants: true
                    };
                    scope.assetBrowseOptions.filterPanel['equipment-location'] = { filter: 'parentId' };
                    delete scope.assetBrowseOptions.filterPanel['asset-category'];
                }

                scope.clearFilters = function (removeMyFilter) {
                    scope.cleared = { value: true };
                    scope.clearFunction(removeMyFilter);
                };

                scope.setFilters = function (value, save) {
                    scope.cleared = { value: false };
                    scope.setFunction(value, save);
                };

                scope.$watch('checkbox.state', function (newVal, oldVal) {
                    if (oldVal === newVal) {
                        return;
                    }

                    scope.filters[assetToggle] = newVal;
                });
            }
        };
    });

'use strict';

angular.module('purposeReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report']);

'use strict';

angular.module('purposeReport')
    .controller('PurposeReportListController', function ($scope, $state, filterStateService, initData, reportFiltersService, purposeReportService, queryHelpers, orderByHelpers) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var pageChanging = false;
        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'filterId', 'requestDateRange', 'completionDateRange'];

        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.listData = initData.initResponse.data;
        self.totalListData = initData.totals;
        self.filters = initData.filters;
        var filtersCopy = angular.copy(self.filters);

        self.viewWorkOrders = function (id) {
            filtersCopy = angular.copy(self.filters);
            delete filtersCopy.orderBy;
            delete filtersCopy.page;
            delete filtersCopy.pageSize;
            filtersCopy.purpose = id;
            filtersCopy.includeDescendants = filtersCopy.assetRollUp;
            $state.go('secure.workOrderList', filtersCopy);
        };

        var setData = function (response) {
            self.listData = response.data;
            self.filterState.totalCount = response.total;
        };

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'workType', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'assetRollUp', 'page', 'orderBy', 'returnAverages'];
            if (reportFiltersService.compareFilters(self.filters, filtersCopy, filtersToCheck)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            filtersCopy = angular.copy(self.filters);
            pageChanging = false;

            purposeReportService.loadPurposes(filtersCopy).then(function (purposes) {
                purposeReportService.getListData(filtersCopy, purposes).then(setData);
            });

            purposeReportService.getTotalData(filtersCopy).then(function (totals) {
                self.totalListData = totals;
            });

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.purposeReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters(
                {
                    orderBy: self.filters.orderBy,
                    assetRollUp: self.filters.includeDescendants
                });
            filterStateService.clearFilters(removeMyFilter);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.isFilterApplied = function () {
            return reportFiltersService.isFilterApplied(self.filters);
        };

        self.chartRoute = function () {
            $state.go('secure.report.purposeChart', self.filters);
        };

        self.export = function () {
            purposeReportService.exportPurposeReport(self.filters);
        };

        $scope.$watch('purposeReport.filters', updateFilters, true);
    });

'use strict';

angular.module('purposeReport')
    .controller('PurposeReportChartController', function ($element, $scope, $state, $translate, filterStateService, initData, market, reportChartPrintService, purposeReportService, reportFiltersService, queryHelpers) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var filtersCopy = {};
        var emptyData = {
            dataArray: [['', ''], ['', { v: 0 }]]
        };
        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'filterId', 'requestDateRange', 'completionDateRange'];

        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        self.market = market;

        self.filters = initData.filters;

        self.workOrderLabels = {
            title: $translate.instant('purposeReports.workOrdersBy'),
            yAxis: $translate.instant('reports.byWorkOrders.numberOf')
        };

        self.laborHoursLabels = {
            title: $translate.instant('purposeReports.laborHoursBy'),
            yAxis: $translate.instant('reports.byLaborHours.hours')
        };

        self.costLabels = {
            title: $translate.instant('purposeReports.costBy'),
            yAxis: $translate.instant('reports.byCost.cost')
        };

        self.costLegend = [
            $translate.instant('reports.byCost.purchase'),
            $translate.instant('reports.byCost.service'),
            $translate.instant('reports.byCost.labor')
        ];

        self.workOrderChartData = angular.copy(emptyData);
        self.laborChartData = angular.copy(emptyData);
        self.costChartData = angular.copy([['', '', ''], ['', { v: 0 }, { v: 0 }]]);

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'workType', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'assetRollUp'];
            if (reportFiltersService.compareFilters(self.filters, filtersCopy, filtersToCheck)) {
                return;
            }

            filtersCopy = angular.copy(self.filters);

            self.workOrderLabels.title = $translate.instant('purposeReports.workOrdersBy');
            self.laborHoursLabels.title = $translate.instant('purposeReports.laborHoursBy');
            self.costLabels.title = $translate.instant('purposeReports.costBy');

            purposeReportService.loadPurposes(self.filters).then(function (purposes) {
                self.workOrderChartData = purposeReportService.workOrderChartData(filtersCopy, purposes, self.workOrderLabels);
                self.laborChartData = purposeReportService.laborChartData(filtersCopy, purposes, self.laborHoursLabels);
                self.costChartData = purposeReportService.costChartData(filtersCopy, purposes, self.costLabels);
            });

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.purposeReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters(
                {
                    orderBy: self.filters.orderBy,
                    assetRollUp: self.filters.includeDescendants
                });
            filterStateService.clearFilters(removeMyFilter);
        };

        self.isFilterApplied = function () {
            return reportFiltersService.isFilterApplied(self.filters);
        };

        self.clickFunctionObject = {
            chartFunction: function (id) {
                filtersCopy = angular.copy(self.filters);
                delete filtersCopy.orderBy;
                delete filtersCopy.page;
                delete filtersCopy.pageSize;
                filtersCopy.purpose = id;
                filtersCopy.includeDescendants = filtersCopy.assetRollUp;
                $state.go('secure.workOrderList', filtersCopy);
            }
        };

        self.listRoute = function () {
            $state.go('secure.report.purposeList', self.filters);
        };

        self.printCharts = function () {
            var chartOne = angular.element($element.find('.work-order-chart svg'))[0].parentNode.innerHTML;
            var chartTwo = angular.element($element.find('.cost-chart svg'))[0].parentNode.innerHTML;
            var chartThree = angular.element($element.find('.labor-hours-chart svg'))[0].parentNode.innerHTML;

            var costLegend = $element.find('.cost-chart .chart-legend')[0] && angular.element($element.find('.cost-chart .chart-legend'))[0].parentNode.innerHTML;
            costLegend = costLegend || '';
            chartTwo = costLegend + chartTwo;

            if (!chartOne || !chartTwo || !chartThree) {
                return;
            }
            var html = [chartOne, chartTwo, chartThree];
            reportChartPrintService.printCharts(html, self.filters, {
                workOrderChartData: self.workOrderChartData,
                laborHoursChartData: self.laborChartData,
                costChartData: self.costChartData
            }, 'purpose');
        };

        $scope.$watch('purposeReport.filters', updateFilters, true);
    });

/**
 * @ngdoc service
 * @name purposeReport.purposeReportService
 * @requires $q - {@link https://docs.angularjs.org/api/ng/service/$q read the docs}
 * @requires $filter - {@link https://docs.angularjs.org/api/ng/service/$filter read the docs}
 * @requires $translate - {@link https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate read the docs}
 * @requires $log - {@link https://docs.angularjs.org/api/ng/service/$log read the docs}
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires report.reportFiltersService
 * @requires report.reportTooltipService
 * @requires report.reportDataService
 *
 * @description
 * Service for supporting the gathering and parsing of data for the Purpose Report
 *
 */
'use strict';

angular.module('purposeReport')
    .service('purposeReportService', function ($q, $filter, $translate, DudeApi, reportFiltersService, reportTooltipService, reportDataService) {
        var CHART_ITEMS_TO_SHOW = 5;

        /**
         * @ngdoc method
         * @name loadPurposes
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Get the list of purposes.
         *
         * @param {object} filter The object containing the current filters
         */
        var loadPurposes = function (filter) {
            var deferred = $q.defer();
            var purposes = [];
            if (filter.purpose && filter.purpose.length) {
                filter.purpose.forEach(function (purposeId) {
                    purposes.push(DudeApi.PurposeEntity.get({ id: purposeId }).$promise);
                });
                $q.all(purposes).then(deferred.resolve, deferred.reject);
            } else {
                deferred.resolve(purposes);
            }
            return deferred.promise;
        };

        var getFilters = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return filters;
        };

        var getData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.PurposesSummaryEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name getTotalData
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Gets the totals data for the list view of work orders by purpose
         *
         * @param {object} query An object containing the filters to query with
         */

        var getTotalData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.PurposesTotalEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name getListData
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Gets the data for the list view of work orders by purpose
         *
         * @param {object} query An object containing the filters to query with
         * @param {array} purposes Array of Purposes to return data for
         */
        var getListData = function (query, purposes) {
            return getData(query).then(function (pagedPurposes) {
                purposes.forEach(function (purpose) {
                    var matches = $filter('filter')(pagedPurposes.data, function (value) {
                        return value.purpose.id === purpose.id;
                    }).length;

                    if (matches) {
                        return;
                    }

                    pagedPurposes.count++;
                    pagedPurposes.data.push({
                        purpose: purpose,
                        count: {
                            workOrders: 0,
                            laborHours: 0
                        },
                        cost: {
                            labor: 0,
                            purchase: 0,
                            total: 0
                        }
                    });
                });
                return pagedPurposes;
            });
        };

        var fetchStandardChartData = function (filter, purposes, endPoint, textPlural, textSingular, labels) {
            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = purposes.length || CHART_ITEMS_TO_SHOW;

            var dataObject = {
                idArray: [],
                dataArray: [[$translate.instant('purposeReports.purposes'),
                    '', { type: 'string', role: 'tooltip', p: { html: true } }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                results.data.forEach(function (summary) {
                    var text = summary.count[endPoint] === 1 ? textSingular : textPlural;
                    if (summary.count[endPoint] > 0) {
                        dataObject.dataArray.push([
                            summary.purpose.value,
                            { v: summary.count[endPoint], f: $filter('number')(summary.count[endPoint]) + ' ' + text },
                            reportTooltipService.standardTooltip(summary.purpose, $filter('number')(summary.count[endPoint]) + ' ' + text)
                        ]);
                        dataObject.idArray.push(summary.purpose.id);
                    }
                });

                reportDataService.topLabel(purposes, results, dataObject, labels, 5);

                purposes.forEach(function (purpose) {
                    if (dataObject.idArray.indexOf(purpose.id) > -1 || dataObject.idArray.length >= filter.pageSize) {
                        return;
                    }

                    dataObject.dataArray.push([
                        purpose.value,
                        { v: 0, f: '0' + textPlural },
                        ''
                    ]);
                    dataObject.idArray.push(purpose.id);
                });
                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name workOrderChartData
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Returns the number of work order broken down by Purpose.
         *
         * @param {object} filter The object containing the current filters
         * @param {array} purposes Array of Purposes to return data for
         * @param {object} labels The object that contains the labels for the chart
         */
        var workOrderChartData = function (filter, purposes, labels) {
            filter.orderBy = 'Count/WorkOrders desc,Purpose/Value asc';

            return fetchStandardChartData(filter, purposes, 'workOrders', $translate.instant('reports.byWorkOrders.workOrders'), $translate.instant('reports.byWorkOrders.workOrder'), labels);
        };

        /**
         * @ngdoc method
         * @name laborChartData
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Returns the work order labor hours broken down by Purpose.
         *
         * @param {object} filter The object containing the current filters
         * @param {object} purposes Array of Purposes to return data for
         * @param {object} labels The object that contains the labels for the chart
         */
        var laborChartData = function (filter, purposes, labels) {
            filter.orderBy = 'Count/LaborHours desc,Purpose/Value asc';

            return fetchStandardChartData(filter, purposes, 'laborHours', $translate.instant('reports.byLaborHours.hours'), $translate.instant('reports.byLaborHours.hour'), labels);
        };

        /**
         * @ngdoc method
         * @name costChartData
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Returns the work order cost data broken down by Purpose.
         *
         * @param {object} filter The object containing the current filters
         * @param {array} purposes Array of Purposes to return data for
         * @param {object} labels The object that contains the labels for the chart
         */
        var costChartData = function (filter, purposes, labels) {
            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = purposes.length || CHART_ITEMS_TO_SHOW;
            filter.orderBy = 'Cost/Total desc,Purpose/Value asc';

            var dataObject = {
                idArray: [],
                dataArray: [[$translate.instant('purposeReports.purposes'),
                    '', { type: 'string', role: 'tooltip', p: { html: true } },
                    '', { type: 'string', role: 'tooltip', p: { html: true } },
                    '', { type: 'string', role: 'tooltip', p: { html: true } }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                results.data.forEach(function (summary) {
                    if (!summary.cost) {
                        return;
                    }

                    var laborCost = $filter('currency')(summary.cost.labor) + ' ' + $translate.instant('reports.byCost.labor');
                    var purchaseCost = $filter('currency')(summary.cost.purchase) + ' ' + $translate.instant('reports.byCost.purchase');
                    var serviceCost = $filter('currency')(summary.cost.service) + ' ' + $translate.instant('reports.byCost.service');
                    var totalCost = $filter('currency')(summary.cost.total) + ' ' + $translate.instant('reports.byCost.total');

                    var tooltip = reportTooltipService.costChartTooltip(summary.purpose, laborCost, purchaseCost, serviceCost, totalCost);

                    if (summary.cost.total > 0) {
                        dataObject.dataArray.push([
                            summary.purpose.value,
                            { v: summary.cost.purchase, f: laborCost },
                            tooltip,
                            { v: summary.cost.service, f: serviceCost },
                            tooltip,
                            { v: summary.cost.labor, f: purchaseCost },
                            tooltip
                        ]);
                        dataObject.idArray.push(summary.purpose.id);
                    }
                });

                reportDataService.topLabel(purposes, results, dataObject, labels, 5);

                purposes.forEach(function (purpose) {
                    if (dataObject.idArray.indexOf(purpose.id) > -1 || dataObject.idArray.length >= filter.pageSize) {
                        return;
                    }

                    dataObject.dataArray.push([
                        purpose.value,
                        { v: 0, f: '0' + $translate.instant('reports.byLaborHours.hours') },
                        '',
                        { v: 0, f: '0' + $translate.instant('reports.byLaborHours.hours') },
                        ''
                    ]);
                    dataObject.idArray.push(purpose.id);
                });

                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name exportPurposeReport
         * @methodOf purposeReport.purposeReportService
         *
         * @description
         * Exports a csv of work orders by purpose
         *
         * @param {object} query An object containing the filters to query with
         */
        var exportPurposeReport = function (query) {
            var filters = getFilters(query, false);
            reportDataService.exportReport(filters, 'workordersbypurpose');
        };

        return {
            loadPurposes: loadPurposes,
            getListData: getListData,
            workOrderChartData: workOrderChartData,
            laborChartData: laborChartData,
            costChartData: costChartData,
            exportPurposeReport: exportPurposeReport,
            getTotalData: getTotalData
        };
    });

'use strict';

angular.module('purposeReport')
    .config(function ($stateProvider, permission, moment, workOrderEnums, dateHelperProvider) {
        var routeParams = 'status&workType&purpose&requestDateTo&requestDateFrom&requestDateRange&completionDateTo&completionDateFrom&completionDateRange&dateRange&businessAsset&includeDescendants&assetRollUp&orderBy&returnAverages&filterId';
        var defaults = {
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete, workOrderEnums.status.onHold],
            toDate: dateHelperProvider.getEndOfDay(new Date()).toISOString(),
            // The default from date is 7 days in the past so we subtract 7 days worth of milliseconds from now to get the correct date
            fromDate: dateHelperProvider.getStartOfDay(moment().subtract(7, 'days')).toISOString()
        };
        var getActiveSavedFilter = function ($stateParams, myFilters, savedFiltersService) {
            var queryParams = $stateParams;
            if (queryParams.filterId) {
                return savedFiltersService.getFilterIfExistsForUser(queryParams.filterId, myFilters);
            }
            return null;
        };
        var getQueryParams = function ($location, $stateParams, activeSavedFilter, marketizr, market) {
            var defaultCopy = angular.copy(defaults);
            var queryParams = $stateParams;
            queryParams.assetRollUp = queryParams.includeDescendants || queryParams.assetRollUp || null;
            queryParams.includeDescendants = null;
            if (!queryParams.requestDateTo && !queryParams.requestDateFrom && !queryParams.completionDateFrom && !queryParams.completionDateTo && !queryParams.dateRange) {
                queryParams.requestDateTo = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.toDate : dateHelperProvider.getEndOfDay(moment().subtract(1, 'month').endOf('month')).toISOString();
                queryParams.requestDateFrom = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.fromDate : dateHelperProvider.getStartOfDay(moment().subtract(1, 'month').startOf('month')).toISOString();
            }
            if (!queryParams.filterId) {
                queryParams.status = queryParams.status || defaultCopy.status;
            }
            // If requesting a saved filter created for a different page or by a different user, remove the filter id
            if (queryParams.filterId && !activeSavedFilter) {
                delete queryParams.filterId;
                $location.search('filterId', null);
            }
            return queryParams;
        };

        $stateProvider
            .state('secure.report.purposeList', {
                url: 'purpose/list?page&pageSize&' + routeParams,
                templateUrl: 'app/components/purposeReport/purposeReportList.html',
                controller: 'PurposeReportListController',
                controllerAs: 'purposeReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/purpose/list');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $q, $stateParams, activeSavedFilter, marketizr, market, myFilters, purposeReportService, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        queryParams.returnAverages = queryParams.returnAverages || null;

                        if (!queryParams.orderBy || (queryParams.orderBy && queryParams.orderBy.indexOf('TotalsWithDescendants') > -1)) {
                            queryParams.orderBy = 'Count/WorkOrders desc,Purpose/Value asc';
                        }

                        var filters = reportFiltersService.toApiFilter(queryParams);

                        return $q.all({
                            initResponse: purposeReportService.loadPurposes(filters).then(function (purposes) {
                                return purposeReportService.getListData(filters, purposes);
                            }),
                            filters: filters,
                            totals: purposeReportService.getTotalData(filters),
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        });
                    }
                }
            })
            .state('secure.report.purposeChart', {
                url: 'purpose/chart?' + routeParams,
                templateUrl: 'app/components/purposeReport/purposeReportChart.html',
                controller: 'PurposeReportChartController',
                controllerAs: 'purposeReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/purpose/chart');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $stateParams, activeSavedFilter, marketizr, market, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        var filters = reportFiltersService.getFilters(queryParams);

                        return {
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        };
                    }
                }
            });
    });

'use strict';

angular.module('purposePanel', ['ui.router', 'dudeControls', 'dudeApi', 'maintenanceSlidingPanels']);

angular.module('purposePanel')
    .constant('purposePanelVariables', {
        panelName: 'purposePanel'
    });

/**
 * @ngdoc service
 * @name purposePanel.purposePanelService
 * @requires DudeApi
 * @requires purposeDeleteFilterService
 *
 * @description
 * Service for supporting the purposePanel component.
 *
 */

'use strict';

angular.module('purposePanel')
    .service('purposePanelService', function (DudeApi, purposeDeleteFilterService) {
        /**
         * @ngdoc method
         * @name deletePurpose
         * @methodOf purposePanel.purposePanelService
         *
         * @description
         * Deletes the purpose by the passed-in purpose ID.
         *
         * @param {int} purposeId The ID of the purpose that is in need of deleting.
         * @returns {object} The result from the API.
         */
        var deletePurpose = function (purposeId) {
            return DudeApi.PurposeEntity.delete({ id: purposeId });
        };

        /**
         * @ngdoc method
         * @name addPurpose
         * @methodOf purposePanel.purposePanelService
         *
         * @description
         * Adds the purpose that is passed in.
         *
         * @param {object} purpose The purpose being added.
         * @returns {object} The result from the API.
         */
        var addPurpose = function (purpose) {
            return DudeApi.PurposeEntity.save(purpose);
        };

        /**
         * @ngdoc method
         * @name updatePurpose
         * @methodOf purposePanel.purposePanelService
         *
         * @description
         * Updates the purpose that is passed in.
         *
         * @param {object} purpose The purpose being updated.
         * @returns {object} The result from the API.
         */
        var updatePurpose = function (purpose) {
            return DudeApi.PurposeEntity.update({ id: purpose.id }, purpose);
        };

        /**
         * @ngdoc method
         * @name workOrderCount
         * @methodOf purposePanel.purposePanelService
         *
         * @description
         * Grabs all work orders associated to the purpose that is passed in.
         *
         * @param {int} purposeId The ID of the purpose being checked.
         * @returns {object} The result from the API.
         */
        var workOrderCount = function (purposeId) {
            var filter = purposeDeleteFilterService.toApiFilter({ id: purposeId });

            return DudeApi.WorkOrderEntity.query(filter).$promise.then(function (workOrders) {
                return workOrders.total;
            });
        };

        /**
         * @ngdoc method
         * @name workOrderTemplateCount
         * @methodOf purposePanel.purposePanelService
         *
         * @description
         * Grabs all work order templates associated to the purpose that is passed in.
         *
         * @param {int} purposeId The ID of the purpose being checked.
         * @returns {object} The result from the API.
         */
        var workOrderTemplateCount = function (purposeId) {
            var filter = purposeDeleteFilterService.toApiFilter({ id: purposeId });

            return DudeApi.WorkOrderTemplateEntity.query(filter).$promise.then(function (workOrderTemplates) {
                return workOrderTemplates.total;
            });
        };

        /**
         * @ngdoc method
         * @name getPurposeTypes
         * @methodOf purposeList.purposeListService
         *
         * @description
         * Queries the purpose type entity for a list of purposes
         *
         * @returns {Promise} A promise that resolves to the list of purpose types
         */
        var getPurposeTypes = function () {
            return DudeApi.PurposeTypeEntity.query().$promise;
        };

        return {
            deletePurpose: deletePurpose,
            addPurpose: addPurpose,
            updatePurpose: updatePurpose,
            workOrderCount: workOrderCount,
            workOrderTemplateCount: workOrderTemplateCount,
            getPurposeTypes: getPurposeTypes

        };
    });

/**
 * @ngdoc directive
 * @name purposePanel.purposePanel
 * @restrict E
 * @description
 *
 * The panel that allows the user to edit/create/delete purposes.
 *
 * @param {array} purposes Array of purposes.
 * @param {int} totalCount The total number of purposes
 */

'use strict';

angular.module('purposePanel')
    .component('purposePanel', {
        templateUrl: 'app/components/purposePanel/purposePanel.html',
        bindings: {
            purposes: '=',
            totalCount: '='
        },
        controllerAs: 'purposePanel',
        controller: 'PurposePanelController'
    }).controller('PurposePanelController', function ($q, $stateParams, $uibModal, $translate, $timeout, log, maintenanceSlidingPanelsService, purposePanelService, purposePanelVariables, purposeListService, pmAssociationsService) {
        var self = this;
        var workOrderCount;
        var workOrderTemplateCount;

        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('purposePanel.notify.delete.title'),
                type: 'success',
                message: $translate.instant('purposePanel.notify.delete.message')
            });
        };

        var confirmDelete = function (fromSaveInactive) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/purposePanel/purposeDeleteConfirmModal.html',
                controller: 'PurposeDeleteModalController',
                controllerAs: 'purposeDeleteModalController',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return '';
                    },
                    workOrderTemplateCount: function () {
                        return '';
                    },
                    purpose: function () {
                        return self.purpose;
                    },
                    fromSaveInactive: function () {
                        return fromSaveInactive;
                    }
                }
            });

            return $q(function (resolve) {
                modalInstance.result.then(function () {
                    return purposePanelService.deletePurpose(self.purpose.id).$promise.then(function () {
                        resolve();
                    });
                });
            });
        };

        var deleteWarning = function (count, templateCount, fromSaveInactive) {
            $uibModal.open({
                templateUrl: 'app/components/purposePanel/purposeDeleteWarningModal.html',
                controller: 'PurposeDeleteModalController',
                controllerAs: 'purposeDeleteModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return count;
                    },
                    workOrderTemplateCount: function () {
                        return templateCount;
                    },
                    purpose: function () {
                        return self.purpose;
                    },
                    fromSaveInactive: function () {
                        return fromSaveInactive;
                    }
                }
            });
        };

        var setSelectedNull = function () {
            // Waits for panel to close
            $timeout(function () {
                self.selected = null;
            }, 500);
        };

        var setUpEditPanel = function () {
            self.titles = { title: $translate.instant('purposePanel.editTitle') };

            self.purposeTypes.some(function (purposeType, index) {
                if (self.purpose.purposeType && purposeType.id === self.purpose.purposeType.id) {
                    self.selected = self.purposeTypes[index];

                    return true;
                }

                return false;
            });
            self.buttonFunctions.deleteFunction = function () {
                if (workOrderCount === 0 && workOrderTemplateCount === 0 && !self.purpose.isDefault) {
                    return $q(function (resolve, reject) {
                        confirmDelete().then(function () {
                            purposeListService.getListData($stateParams).$promise.then(function (purposes) {
                                self.purposes = purposes.data;
                                self.totalCount = purposes.total;
                                showDeleteMessage();
                                setSelectedNull();
                                resolve();
                            });
                        }).catch(function () {
                            reject();
                        });
                    });
                }

                return $q(function (resolve, reject) {
                    deleteWarning(workOrderCount, workOrderTemplateCount, false);
                    reject();
                });
            };
        };

        self.$onInit = function () {
            maintenanceSlidingPanelsService.initializeService();
            $timeout(function () {
                purposePanelService.getPurposeTypes().then(function (purposeTypes) {
                    self.purposeTypes = purposeTypes.data;
                });

                self.setPurposeType = function () {
                    self.purpose.purposeType = self.selected;
                };

                self.buttonFunctions = {
                    saveFunction: function () {
                        return $q(function (resolve, reject) {
                            if (self.isNew) {
                                purposePanelService.addPurpose(self.purpose).$promise.then(function () {
                                    purposeListService.getListData($stateParams).$promise.then(function (purposes) {
                                        self.purposes = purposes.data;
                                        self.totalCount = purposes.total;
                                        log.notify({
                                            title: $translate.instant('purposePanel.notify.success.title'),
                                            type: 'success',
                                            message: $translate.instant('purposePanel.notify.success.message')
                                        });
                                        setSelectedNull();
                                        resolve();
                                    });
                                }).catch(function () {
                                    reject();
                                });
                            } else if (!self.isNew && self.purpose.isDefault && !self.purpose.isActive) {
                                deleteWarning(null, null, true);
                                reject();
                            } else {
                                purposePanelService.updatePurpose(self.purpose).$promise.then(function () {
                                    purposeListService.getListData($stateParams).$promise.then(function (purposes) {
                                        self.purposes = purposes.data;
                                        self.totalCount = purposes.total;
                                        log.notify({
                                            title: $translate.instant('purposePanel.notify.success.title'),
                                            type: 'success',
                                            message: $translate.instant('purposePanel.notify.success.message')
                                        });
                                        setSelectedNull();
                                        resolve();
                                    });
                                }).catch(function () {
                                    reject();
                                });
                            }
                        });
                    },
                    cancelFunction: function () {
                        setSelectedNull();
                        self.saveAttempt = false;
                    }
                };

                maintenanceSlidingPanelsService.subscribe(purposePanelVariables.panelName, function (options) {
                    self.purpose = angular.copy(options.purpose);
                    self.isNew = !self.purpose.id;
                    if (!self.isNew) {
                        var promises = [];
                        promises.push(purposePanelService.workOrderCount(self.purpose.id).then(function (workOrders) {
                            workOrderCount = workOrders;
                        }));
                        promises.push(purposePanelService.workOrderTemplateCount(self.purpose.id).then(function (workOrderTemplates) {
                            workOrderTemplateCount = workOrderTemplates;
                        }));
                        $q.all(promises).then(function () {
                            self.openWhen = true;
                            setUpEditPanel();
                        });

                        pmAssociationsService.isAssociated({ purpose: self.purpose.id }).then(function (result) {
                            self.associations = result.total;
                            self.associationsValidation = pmAssociationsService.validationMessage($translate.instant('purposePanel.purpose'), self.associations);
                        });
                    } else {
                        self.openWhen = true;
                        self.titles = { title: $translate.instant('purposePanel.newTitle') };
                        self.selected = null;
                        delete self.buttonFunctions.deleteFunction;
                    }
                });
            });
        };
    });

'use strict';

angular.module('purposePanel')
    .controller('PurposeDeleteModalController', function ($uibModalInstance, $translate, workOrderCount, workOrderTemplateCount, purpose, fromSaveInactive) {
        var self = this;

        self.workOrderCount = workOrderCount;
        self.workOrderTemplateCount = workOrderTemplateCount;
        self.purpose = purpose;
        self.fromSaveInactive = fromSaveInactive;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };

        self.getTitle = function () {
            if (self.fromSaveInactive) {
                return $translate.instant('purposePanel.deleteModal.cannotInactivateTitle');
            }
            return $translate.instant('purposePanel.deleteModal.title');
        };
    });

/**
 * @ngdoc service
 * @name purposePanel.purposeDeleteFilterService
 *
 * @description
 * Service for supporting filtering by purpose.
 *
 */

'use strict';

angular.module('purposePanel')
    .service('purposeDeleteFilterService', function () {
        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf purposePanel.purposeDeleteFilterService
         *
         * @description
         * Returns the updated filter.
         *
         * @param {object} filter The untouched filters object.
         * @returns {object} filters The updated filters object.
         */
        var toApiFilter = function (filter) {
            var filters = {
                purpose: filter.id
            };
            return filters;
        };

        return {
            toApiFilter: toApiFilter
        };
    });

'use strict';

angular.module('purposeList', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'helpers', 'translate', 'purposePanel', 'maintenanceSlidingPanels']);

/**
 * @ngdoc service
 * @name purposeList.purposeListFilterService
 *
 * @description
 * Service for supporting filtering by purpose.
 *
 */

'use strict';

angular.module('purposeList')
    .factory('purposeListFilterService', function ($location, DudeApi, pagingHelpers) {
        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf purposeList.purposeListFilterService
         *
         * @description
         * Returns the updated filter.
         *
         * @param {object} params The untouched filters object.
         * @returns {object} The updated filters object.
         */
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Value asc',
                q: params.q || null,
                isActive: params.isActive || null,
                purposeTypeId: params.purposeTypeId || null
            };

            return currentFilter;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf purposeList.purposeListFilterService
         *
         * @description
         * Returns the updated filter.
         *
         * @param {object} currentFilter The untouched filters object.
         * @returns {object} The updated filters object.
         */
        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

/**
 * @ngdoc service
 * @name purposeList.purposeListService
 * @requires DudeApi
 * @requires purposeList.purposeListFilterService
 *
 * @description
 * Service for supporting the purpose list
 *
 */

'use strict';

angular.module('purposeList')
    .service('purposeListService', function (DudeApi, purposeListFilterService) {
        /**
         * @ngdoc method
         * @name getListData
         * @methodOf purposeList.purposeListService
         *
         * @description
         * Queries the purpose entity for a list of purposes
         *
         * @param {object} query The filters object used to query the purpose entity with
         * @returns {Promise} A promise that resolves to the paged wrapper of purposes
         */
        var getListData = function (query) {
            var filters = purposeListFilterService.toApiFilter(query);
            return DudeApi.PurposeEntity.query(filters);
        };

        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('purposeList')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.purposeList', {
                url: 'purposes?page&pageSize&q&isActive&purposeTypeId',
                templateUrl: 'app/components/purposeList/purposeList.html',
                controller: 'PurposeListController',
                controllerAs: 'purposeList',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                resolve: {
                    initData: function ($q, $stateParams, defaultPurposesService, purposeListService, purposeListFilterService) {
                        var queryParams = $stateParams;
                        var filters = purposeListFilterService.getFilters(queryParams);
                        return $q.all({
                            initResponse: purposeListService.getListData(filters).$promise,
                            filters: filters,
                            reactiveDefault: defaultPurposesService.getPurpose(defaultPurposesService.purposeKeys.reactivePurpose),
                            plannedDefault: defaultPurposesService.getPurpose(defaultPurposesService.purposeKeys.plannedPurpose)
                        });
                    }
                }
            });
    });

'use strict';

angular.module('purposeList')
    .controller('PurposeListController', function ($scope, $state, purposeListService, purposeListFilterService, purposePanelVariables, maintenanceSlidingPanelsService, queryHelpers, orderByHelpers, initData) {
        var self = this;
        var queryDefaults = purposeListFilterService.getFilters({});
        var pageChanging = false;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            purposeListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        // view model
        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;
        self.reactiveDefault = initData.reactiveDefault;
        self.plannedDefault = initData.plannedDefault;

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, purposeListFilterService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.openPurposePanel = function (isNew, purpose) {
            if (isNew) {
                purpose = {
                    isActive: true
                };
            } else {
                purpose.isDefault = (purpose.id === self.reactiveDefault.id) || (purpose.id === self.plannedDefault.id);
            }

            maintenanceSlidingPanelsService.openPanel(purposePanelVariables.panelName, { purpose: purpose });
        };

        self.clearFilters = function () {
            self.filters = purposeListFilterService.getFilters({});
        };

        $scope.$watch('purposeList.filters', updateFilters, true);
    });

'use strict';

angular.module('projectList', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'helpers', 'translate']);

/**
 * @ngdoc service
 * @name projectList.projectListFilterService
 * @requires DudeApi
 *
 * @description
 * Service for filtering the project list
 *
 */

'use strict';

angular.module('projectList')
  .factory('projectListFilterService', function ($location, pagingHelpers) {
      /**
       * @ngdoc method
       * @name getFilters
       * @methodOf projectList.projectListFilterService
       *
       * @description
       * Gets the filter object for projects
       *
       * @param {object} params The params to convert into the filters object
       * @returns {object} The filter object to use
       */
      var getFilters = function (params) {
          var currentFilter = {
              page: params.page || pagingHelpers.defaults.page,
              pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
              orderBy: params.orderBy || 'Name asc',
              q: params.q || null
          };

          return currentFilter;
      };

      /**
       * @ngdoc method
       * @name toApiFilter
       * @methodOf projectList.projectListFilterService
       *
       * @description
       * Gets the filter object for projects
       *
       * @param {object} currentFilter The currentFilter to convert into the filters object
       * @returns {object} The filter object to use
       */
      var toApiFilter = function (currentFilter) {
          return getFilters(currentFilter);
      };

      return {
          getFilters: getFilters,
          toApiFilter: toApiFilter
      };
  });

/**
 * @ngdoc service
 * @name projectList.projectListService
 * @requires DudeApi
 *
 * @description
 * Service for supporting the project list
 *
 */

'use strict';

angular.module('projectList')
    .service('projectListService', function (DudeApi) {
        /**
         * @ngdoc method
         * @name getListData
         * @methodOf projectList.projectListService
         *
         * @description
         * Queries the project entity for a list of projects
         *
         * @param {object} query The filters object used to query the project entity with
         * @returns {Promise} A promise that resolves to the paged wrapper of projects
         */
        var getListData = function (query) {
            return DudeApi.ProjectEntity.query(query);
        };

        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('projectList')
    .config(function ($stateProvider, market, permission) {
        $stateProvider
            .state('secure.projectList', {
                url: 'projects?page&pageSize&q&orderBy',
                templateUrl: 'app/components/projectList/projectList.html',
                controller: 'ProjectListController',
                controllerAs: 'projectList',
                permissions: [permission.projects.create, permission.projects.update, permission.projects.delete],
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    initData: function ($q, $stateParams, projectListService, projectListFilterService) {
                        var queryParams = $stateParams;
                        var filters = projectListFilterService.getFilters(queryParams);
                        return $q.all({
                            initResponse: projectListService.getListData(filters).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('projectList')
    .controller('ProjectListController', function ($scope, $state, queryHelpers, projectListService, projectListFilterService, initData) {
        var self = this;
        var queryDefaults = projectListFilterService.getFilters({});
        var pageChanging = false;

        // view model
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;
        self.filters = initData.filters;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            projectListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.clearFilters = function () {
            self.filters = projectListFilterService.getFilters({});
        };

        $scope.$watch('projectList.filters', updateFilters, true);
    });

'use strict';

angular.module('projectForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog', 'maintenanceConstants']);

'use strict';

angular.module('projectForm')
    .config(function ($stateProvider, market, permission) {
        $stateProvider
            .state('secure.projectCreate', {
                url: 'projects/new',
                templateUrl: 'app/components/projectForm/projectForm.html',
                controller: 'ProjectFormController',
                controllerAs: 'projectForm',
                permissions: permission.projects.create,
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    project: function (DudeApi) {
                        return new DudeApi.ProjectEntity({ isActive: true });
                    }
                }
            })
            .state('secure.projectEdit', {
                url: 'projects/:id',
                templateUrl: 'app/components/projectForm/projectForm.html',
                controller: 'ProjectFormController',
                controllerAs: 'projectForm',
                permissions: permission.projects.update,
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    project: function ($stateParams, DudeApi) {
                        return DudeApi.ProjectEntity.get({ id: $stateParams.id, includeDetails: true }).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('projectForm')
    .controller('ProjectFormController', function ($scope, $state, log, workOrderEnums, $translate, project) {
        var self = this;
        var barStates = {
            danger: 'danger',
            warning: 'warning',
            success: 'success'
        };
        self.project = project;
        self.activeProject = angular.copy(project.isActive);
        var emptyCost = {
            purchase: 0,
            labor: 0,
            service: 0,
            total: 0
        };

        var skipNavigationWarningModal = function () {
            self.skipNavigationWarning = true;
        };

        self.totalCost = project.workOrders ? project.workOrders.totalCost : emptyCost;

        self.workOrderCount = project.workOrders ? project.workOrders.workOrderCount : 0;
        self.workOrderFilters = {
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete]
        };

        if (project.id) {
            self.workOrderFilters.project = project.id;
        }

        self.saveProject = function () {
            var promise = project.id ? project.$update({ id: project.id }) : project.$save();

            promise.then(function (result) {
                self.activeProject = angular.copy(project.isActive);
                skipNavigationWarningModal();
                log.notify({
                    title: $translate.instant('projectForm.notify.success.title'),
                    type: 'success',
                    message: $translate.instant('projectForm.notify.success.message')
                });

                $state.go('secure.projectEdit', { id: result.id });
            });
        };

        $scope.$watch('projectForm.project.budgetedAmount', function (newVal) {
            self.budget = angular.copy(newVal) || 0;

            if (typeof self.budget === 'string') {
                self.budget = parseFloat(self.budget.replace(/,/g, ''));
            }

            if (self.totalCost.total > self.budget) {
                self.barState = barStates.danger;
                self.barValue = 100;
            } else if (self.budget === 0) {
                self.barState = barStates.success;
                self.barValue = 0;
            } else if (self.totalCost.total === self.budget) {
                self.barState = barStates.warning;
                self.barValue = 100;
            } else {
                self.barValue = (self.totalCost.total / self.budget) * 100;
                self.barState = self.barValue > 80 ? barStates.warning : barStates.success;
            }
            self.budgetRemainder = self.budget - self.totalCost.total;
        });
    });


'use strict';

angular.module('pmScheduleRecurrence', []);

/**
 * @ngdoc directive
 * @name pmScheduleRecurrence.pmscheduleRecurrence
 * @restrict E
 * @description
 *
 * Generates the sliding panel that houses the recurrence pattern
 *
 * @param {boolean} openWhen Opens the sliding panel when true
 * @param {object} schedule The schedule to add the pattern to
 *
 */

'use strict';

angular.module('pmScheduleRecurrence')
    .component('pmscheduleRecurrence', {
        templateUrl: 'app/components/pmScheduleRecurrence/pmScheduleRecurrence.html',
        controller: 'PmScheduleRecurrenceController',
        controllerAs: 'pmScheduleRecurrence',
        bindings: {
            openWhen: '=',
            schedule: '='
        }
    })
    .controller('PmScheduleRecurrenceController', function ($scope, $q, $translate) {
        var self = this;
        self.titles = { title: $translate.instant('pmScheduleRecurrence.scheduling') };

        self.slidingButtons = {
            saveFunction: function () {
                self.schedule.recurrencePattern = self.scheduleType !== 'metered' ? angular.copy(self.recurrencePatternModel) : null;
                self.schedule.scheduleType = angular.copy(self.scheduleType);
                self.schedule.meterInterval = angular.copy(self.meterInterval);

                return $q(function (resolve) {
                    resolve();
                });
            },
            saveButtonText: $translate.instant('pmScheduleRecurrence.add')
        };

        $scope.$watch('pmScheduleRecurrence.openWhen', function (newVal) {
            if (!newVal) {
                return;
            }

            self.scheduleType = angular.copy(self.schedule.scheduleType);
            self.recurrencePatternModel = angular.copy(self.schedule.recurrencePattern);
            self.meterInterval = angular.copy(self.schedule.meterInterval);
        });
    });

'use strict';

angular.module('pmScheduleMeterReading', ['dudeApi', 'dudeAuth']);

/**
 * @ngdoc directive
 * @name pmScheduleAssets.pmScheduleMeterReading
 * @restrict E
 * @description
 *
 * Generates the sliding panel that houses the Starting Intervals for metered assets
 *
 * @param {boolean} openWhen Opens the sliding panel when true
 * @param {object} schedule The schedule with metered assets on which to add starting thresholds
 *
 */

'use strict';

angular.module('pmScheduleMeterReading')
    .component('pmScheduleMeterReading', {
        templateUrl: 'app/components/pmScheduleMeterReading/pmScheduleMeterReading.html',
        controller: 'pmScheduleMeterReadingController',
        controllerAs: 'pmScheduleMeterReading',
        bindings: {
            openWhen: '=',
            schedule: '='
        }
    })
    .controller('pmScheduleMeterReadingController', function ($scope, $q, $translate, DudeApi, pmScheduleType) {
        var self = this;
        self.scheduleTypes = pmScheduleType;
        self.titles = { title: $translate.instant('pmScheduleMeterReading.panelTitle') };

        self.slidingButtons = {
            saveFunction: function () {
                self.meteredAssets.forEach(function (asset) {
                    asset.startingThreshold = asset.meteredAttribute.value;
                });

                self.schedule.businessAssets = angular.copy(self.meteredAssets);

                return $q(function (resolve) {
                    resolve();
                });
            },
            saveButtonText: $translate.instant('pmScheduleMeterReading.done')
        };

        self.browseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'business-asset-type': {
                    filter: 'businessAssetTypeId'
                }

            }
        };

        $scope.$watch('pmScheduleMeterReading.openWhen', function (newVal) {
            if (!newVal) {
                return;
            }

            self.meteredAssets = angular.copy(self.schedule.businessAssets).filter(function (asset) {
                return asset.isMetered;
            });

            self.notMeteredAssets = angular.copy(self.schedule.businessAssets).filter(function (asset) {
                return !asset.isMetered;
            });

            self.isMetered = self.schedule && (self.schedule.scheduleType === self.scheduleTypes.METERED || self.schedule.scheduleType === self.scheduleTypes.MIXED);

            self.meteredAssets.forEach(function (asset) {
                DudeApi.BusinessAssetAttributeEntity.query({
                    businessAssetId: asset.id,
                    attributeTypeKey: 'meter'
                }).$promise.then(function (result) {
                    asset.meteredAttribute = result.data.filter(function (attribute) { return attribute.isMetered; })[0];
                    asset.meteredAttribute.value = asset.startingThreshold || '';
                });
            });
        });
    });

'use strict';

angular.module('pmScheduleList', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'pmScheduleFilters']);

'use strict';

angular.module('pmScheduleList')
    .service('pmScheduleListService', function (DudeApi, pmScheduleFiltersService) {
        var getListData = function (query) {
            var filters = pmScheduleFiltersService.toApiFilter(query);
            return DudeApi.WorkOrderTemplateEntity.query(filters);
        };
        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('pmScheduleList')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.pmScheduleList', {
                url: 'pmschedules?page&pageSize&q&isActive&businessAssets&pmScheduleTypes&purpose',
                templateUrl: 'app/components/pmScheduleList/pmScheduleList.html',
                controller: 'PmScheduleListController',
                controllerAs: 'pmScheduleList',
                permissions: [permission.pmSchedules.create, permission.pmSchedules.update, permission.pmSchedules.delete],
                resolve: {
                    initData: function ($q, $stateParams, pmScheduleListService, pmScheduleFiltersService) {
                        var queryParams = $stateParams;
                        var filters = pmScheduleFiltersService.getFilters(queryParams);

                        return $q.all({
                            initResponse: pmScheduleListService.getListData(filters).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('pmScheduleList')
    .controller('PmScheduleListController', function ($scope, $state, queryHelpers, orderByHelpers, marketizr, market, pmScheduleListService, pmScheduleFiltersService, initData) {
        var self = this;
        var queryDefaults = pmScheduleFiltersService.getFilters({});
        var pageChanging = false;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            pmScheduleListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        // view model
        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;

        self.assetBrowseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                }
            }
        };

        if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
            self.assetHideCheckBox = true;
            self.filters.includeDescendants = true;
        }

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, pmScheduleFiltersService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.editPmSchedule = function (workOrderTemplate) {
            $state.go('secure.pmScheduleEdit', {
                id: workOrderTemplate.id
            });
        };

        self.clearFilters = function () {
            self.filters = pmScheduleFiltersService.getFilters({});
            if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                self.filters.includeDescendants = true;
            }
        };

        $scope.$watch('pmScheduleList.filters', updateFilters, true);
    });

'use strict';

angular.module('pmScheduleForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog', 'duScroll', 'pmSchedule', 'taskBookSelect']);

'use strict';

angular.module('pmScheduleForm')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.pmScheduleCreate', {
                url: 'pmschedules/new',
                templateUrl: 'app/components/pmScheduleForm/pmScheduleForm.html',
                controller: 'PmScheduleFormController',
                controllerAs: 'pmScheduleForm',
                permissions: permission.pmSchedules.create,
                resolve: {
                    workOrderTemplate: function (DudeApi, defaultPurposesService) {
                        return defaultPurposesService.getPurpose(defaultPurposesService.purposeKeys.plannedPurpose)
                            .then(function (_purpose) {
                                return new DudeApi.WorkOrderTemplateEntity({
                                    priority: 2,
                                    purpose: _purpose,
                                    dueDateOffset: 1
                                });
                            });
                    },
                    schedules: function () {
                        return {
                            data: []
                        };
                    },
                    workOrderCount: function () {
                        return 0;
                    }
                }
            })
            .state('secure.pmScheduleEdit', {
                url: 'pmschedules/:id',
                templateUrl: 'app/components/pmScheduleForm/pmScheduleForm.html',
                controller: 'PmScheduleFormController',
                controllerAs: 'pmScheduleForm',
                permissions: permission.pmSchedules.update,
                resolve: {
                    workOrderTemplate: function ($stateParams, DudeApi) {
                        var taskBook;
                        return DudeApi.WorkOrderTemplateEntity.get({ id: $stateParams.id }).$promise
                            .then(function (template) {
                                if (!template.taskBookId) {
                                    return template;
                                }
                                return DudeApi.TaskBookEntity.get({ id: template.taskBookId }).$promise
                                    .then(function (_taskBook) {
                                        taskBook = _taskBook;
                                        return DudeApi.TaskBookTaskEntity.query({
                                            taskBookId: _taskBook.id,
                                            orderBy: 'Order asc'
                                        }).$promise;
                                    })
                                    .then(function (_taskBookSummary) {
                                        taskBook.tasks = _taskBookSummary.data;
                                        template.taskBook = taskBook;
                                        return template;
                                    });
                            });
                    },
                    schedules: function ($stateParams, DudeApi) {
                        return DudeApi.PmScheduleEntity.query({ workOrderTemplate: $stateParams.id }).$promise;
                    },
                    workOrderCount: function ($stateParams, DudeApi) {
                        return DudeApi.WorkOrderEntity.get({ workOrderTemplate: $stateParams.id, pageSize: 1 }).$promise.then(function (response) {
                            return response.total;
                        });
                    }
                }
            });
    });

'use strict';

angular.module('pmScheduleForm')
    .controller('PmScheduleFormController', function ($scope, $q, $state, log, $uibModal, $translate, $document, DudeApi, workOrderTemplate, workOrderCount, schedules, market, pmScheduleHelper) {
        var self = this;
        var startingTaskBook = angular.copy(workOrderTemplate.taskBook) || [];

        self.market = market;
        self.workOrderTemplate = workOrderTemplate;
        self.skipNavigationWarning = false;
        self.spies = [];
        self.schedules = schedules.data;
        self.schedulesToDelete = [];

        var skipNavigationWarningModal = function () {
            self.skipNavigationWarning = true;
        };

        var saveSuccess = function () {
            skipNavigationWarningModal();

            log.notify({
                title: $translate.instant('pmScheduleForm.notify.success.title'),
                type: 'success',
                message: $translate.instant('pmScheduleForm.notify.success.message')
            });

            $state.go('secure.pmScheduleList');
        };

        var saveTaskBook = function (taskBook, template) {
            // Save Task Book
            if (self.taskBookLinkId) {
                template.taskBookId = self.taskBookLinkId;

                return [template.$update({ id: template.id }).$promise];
            }

            var _taskBook = angular.copy(taskBook);

            if (taskBook && (taskBook.tasks.length === 0 || (taskBook.tasks.length > 0 && (taskBook.tasks[0].title == null || taskBook.tasks[0].title === '')))) {
                // This deletes a task book that is not a master task book and doesnt have any tasks assigned to it
                if (taskBook.id) {
                    template.taskBookId = null;
                    return template.$update({ id: template.id }).then(function () {
                        return taskBook.$delete({ id: _taskBook.id });
                    });
                    // This will stop the saving process so that we dont save a blank taskbook with out tasks
                }
                return undefined; // fix eslint consistent return message
            }

            // Save/update the taskbook and its tasks
            var taskBookPromise = _taskBook.id ? taskBook.$update({ id: _taskBook.id }) : taskBook.$save();

            return taskBookPromise.then(function (_savedTaskBook) {
                var taskBookPromises = [];

                workOrderTemplate.taskBookId = _savedTaskBook.id;
                taskBookPromises.push(template.$update({ id: template.id }).$promise);

                // delete tasks
                self.tasksToDelete.forEach(function (taskToDelete) {
                    if (taskToDelete.id) {
                        var deleteTaskPromise = taskToDelete.$delete({
                            id: taskToDelete.id,
                            taskBookId: _savedTaskBook.id
                        });

                        taskBookPromises.push(deleteTaskPromise);
                    }
                });

                // add tasks
                _taskBook.tasks.forEach(function (task, i) {
                    task.order = i + 1; // Make sure this is correct in the future

                    // Check to see if the task has changed and if not then dont make the call
                    if (!angular.equals(task, startingTaskBook.task) && task.title) {
                        var addTasksPromise = task.id ? task.$update({
                            taskBookId: _savedTaskBook.id,
                            id: task.id
                        }) : task.$save({ taskBookId: _savedTaskBook.id });

                        taskBookPromises.push(addTasksPromise);
                    }
                });

                return taskBookPromises; // $q.all();
            });
        };

        var deleteSchedules = function () {
            if (self.schedulesToDelete.length > 0) {
                return self.schedulesToDelete.map(function (id) {
                    return DudeApi.PmScheduleEntity.delete({ id: id }).$promise;
                });
            }
            return [];
        };

        self.save = function () {
            if (!self.schedules || !pmScheduleHelper.scheduleIsValid(self.schedules[self.schedules.length - 1])) {
                return;
            }

            $q.all(deleteSchedules()).then(function () {
                // save workorder template
                var taskBook = angular.copy(workOrderTemplate.taskBook);
                var workOrderTemplatePromise = workOrderTemplate.id ? workOrderTemplate.$update({ id: workOrderTemplate.id }) : workOrderTemplate.$save();

                workOrderTemplatePromise.then(function (savedWorkOrderTemplate) {
                    // save the schedules
                    var promises = self.schedules.map(function (schedule) {
                        schedule.workOrderTemplateId = schedule.workOrderTemplateId || savedWorkOrderTemplate.id;

                        return schedule.id ? schedule.$update({ id: schedule.id }) : schedule.$save();
                    });

                    if (taskBook) {
                        promises.concat(saveTaskBook(taskBook, savedWorkOrderTemplate));
                    }

                    $q.all(promises).then(function () {
                        saveSuccess();
                    });
                });
            });
        };

        // DELETE
        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('pmScheduleDelete.notify.delete.title'),
                type: 'success',
                message: $translate.instant('pmScheduleDelete.notify.delete.message')
            });
        };

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/pmScheduleForm/pmScheduleDeleteConfirmModal.html',
                controller: 'PmScheduleDeleteModalController',
                size: 'sm',
                resolve: {
                    workOrderCount: function () {
                        return workOrderCount;
                    }
                },
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                $q.all(deleteSchedules()).then(function () {
                    self.workOrderTemplate.$delete({ id: self.workOrderTemplate.id }).then(function () {
                        skipNavigationWarningModal();
                        showDeleteMessage();
                        $state.go('secure.pmScheduleList');
                    });
                });
            });
        };

        var deleteWarning = function () {
            $uibModal.open({
                templateUrl: 'app/components/pmScheduleForm/pmScheduleDeleteWarningModal.html',
                controller: 'PmScheduleDeleteModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    workOrderCount: function () {
                        return workOrderCount;
                    }
                }
            });
        };

        self.deletePmSchedule = function () {
            if (self.schedules.length > 0 || workOrderCount > 0) {
                deleteWarning();
            } else {
                confirmDelete();
            }
        };

        self.addSchedule = function () {
            self.schedules.push(pmScheduleHelper.addSchedule());
            $document.scrollToElement(angular.element('.pmschedule-details'), 100, 300);
        };

        self.addTaskBook = function () {
            self.workOrderTemplate.taskBook = pmScheduleHelper.addTaskBook();
            self.taskBookLinkId = null;
            self.tasksToDelete = [];
        };

        $scope.$watch('pmScheduleForm.workOrderTemplate.taskBook.isMaster', function (newVal) {
            self.taskBookMode = newVal ? 'readonly' : 'edit';
        });

        $scope.$watch('pmScheduleForm.tasksToDelete', function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (newVal.length > 0) {
                $scope.form.$dirty = true;
            }
        }, true);
    });


'use strict';

angular.module('pmScheduleForm')
    .controller('PmScheduleDeleteModalController', function ($uibModalInstance, $scope, workOrderCount) {
        $scope.workOrderCount = workOrderCount;

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('pmScheduleFilters', ['filterHelpers']);

/**
 * @ngdoc service
 * @name pmScheduleFilters.pmScheduleFiltersService
 * @requires pagingHelpers
 *
 * @description
 * Service for handling the pm schedule filters
 *
 */

'use strict';

angular.module('pmScheduleFilters')
    .factory('pmScheduleFiltersService', function ($location, pagingHelpers) {
        var checkArray = function (value) {
            return Array.isArray(value) ? value : [value];
        };

        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf pmScheduleFilters.pmScheduleFiltersService
         *
         * @description
         * Gets the default filters for Pm Schedule
         *
         * @param {object} params The filter params
         * @returns {Promise} A promise that resolves to the default filters
         */
        var getFilters = function (params) {
            var filters = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Description asc',
                q: params.q || null,
                isActive: params.isActive || null,
                businessAssets: checkArray(params.businessAssets || []),
                includeDescendants: params.includeDescendants || null,
                purpose: checkArray(params.purpose || [])
            };

            return filters;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf pmScheduleFilters.pmScheduleFiltersService
         *
         * @description
         * Sets the filters
         *
         * @param {object} currentFilter The current filters
         * @returns {Promise} A promise that resolves to the filters
         */
        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

/**
 * @ngdoc directive
 * @name pmScheduleForm.pmscheduleDetails
 * @restrict E
 * @description
 *
 * Generates the form/list for adding and editing the PM Schedule Recurrence Pattern, Assignees, and Assets.
 *
 * @param {array} schedules The schedules object from the Work Order template
 * @param {array} spies The scroll spy array
 *
 */

'use strict';

angular.module('pmScheduleForm')
    .component('pmscheduleDetails', {
        templateUrl: 'app/components/pmScheduleDetails/pmScheduleDetails.html',
        controller: 'PmScheduleDetailsController',
        controllerAs: 'pmScheduleDetails',
        bindings: {
            schedules: '=',
            schedulesToDelete: '=?',
            workOrderTemplate: '<',
            spies: '=',
            saveAttempt: '='
        }
    })
    .controller('PmScheduleDetailsController', function ($scope, $translate, $uibModal, $state, DudeApi, log, pmScheduleHelper, pmScheduleType) {
        var self = this;
        self.scheduleTypes = pmScheduleType;
        self.defaultScheduleType = self.scheduleTypes.FIXED;
        self.isActive = null;
        self.isValid = true;

        var showValidationToast = function () {
            self.isValid = false;
            log.notify({
                type: 'error',
                title: $translate.instant('pmScheduleDetails.validation.error.title'),
                message: $translate.instant('pmScheduleDetails.validation.error.message')
            });
        };

        var removeScrollSpy = function () {
            if (self.schedules.length === 0) {
                self.spies.forEach(function (spy, index) {
                    if (spy.name === $translate.instant('pmScheduleForm.cards.schedule.title')) {
                        self.spies.splice(index, 1);
                    }
                });
            }
        };

        self.setActive = function (index) {
            if (self.isActive === null) {
                self.isActive = index;
            } else if (self.isActive !== index && !pmScheduleHelper.scheduleIsValid(self.schedules[self.isActive])) {
                showValidationToast();
            }
        };

        self.inActivate = function () {
            self.isActive = null;
            self.isValid = true;
        };

        self.done = function (index) {
            if (!pmScheduleHelper.scheduleIsValid(self.schedules[index])) {
                showValidationToast();
                return false;
            }

            // if the scheduleType is switched, we need to ensure starting threshold is removed from assets.
            if (self.schedules[index].scheduleType !== self.scheduleTypes.METERED && self.schedules[index].scheduleType !== self.scheduleTypes.MIXED) {
                self.schedules[index].businessAssets.forEach(function (asset) {
                    asset.startingThreshold = null;
                });
            }

            // Sets commited flag so we dont show close and show delete for new items w/o an id
            if (!self.schedules[index].id) {
                self.schedules[index].__commited = true;
            }

            self.inActivate();

            return true;
        };

        self.cancel = function (index) {
            self.schedules.splice(index, 1);
            removeScrollSpy();
            self.inActivate();
        };

        self.delete = function (index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/pmScheduleDetails/pmScheduleDeleteConfirmModal.html',
                controller: 'PmScheduleDetailsDeleteModalController',
                controllerAs: 'pmScheduleDetailsDeleteModal',
                size: 'md',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                if (self.schedules[index].id) {
                    self.schedulesToDelete = Array.isArray(self.schedulesToDelete) ? self.schedulesToDelete : [];
                    self.schedulesToDelete.push(self.schedules[index].id);
                }

                self.schedules.splice(index, 1);
                removeScrollSpy();
                self.inActivate();
            });
        };

        self.addRecurrence = function (schedule, index) {
            if (index !== self.isActive) {
                return;
            }

            self.editingSchedule = schedule;
            self.openRecurrenceSlidingPanel = true;
        };

        self.addAssets = function (schedule, index) {
            if (index !== self.isActive) {
                return;
            }

            self.editingSchedule = schedule;
            self.openAssetsSlidingPanel = true;
        };

        self.addAssignees = function (schedule, index) {
            if (index !== self.isActive) {
                return;
            }
            self.editingSchedule = schedule;
            self.openAssigneesSlidingPanel = true;
        };

        self.addReadings = function (schedule, index) {
            if (index !== self.isActive) {
                return;
            }

            self.editingSchedule = schedule;
            self.openReadingsSlidingPanel = true;
        };

        self.addSchedule = function () {
            if (!self.done(self.schedules.length - 1)) {
                return;
            }

            self.schedules.push(pmScheduleHelper.addSchedule());

            // Clone recurrence pattern from previous schedule
            if (self.schedules.length >= 2) {
                var currentIndex = self.schedules.length - 1;
                var previousIndex = self.schedules.length - 2;
                self.schedules[currentIndex].scheduleType = angular.copy(self.schedules[previousIndex].scheduleType);
                self.schedules[currentIndex].recurrencePattern = angular.copy(self.schedules[previousIndex].recurrencePattern);
            }

            self.isValid = true;
        };

        self.hasRecurrencePattern = function (schedule) {
            return schedule.scheduleType === self.scheduleTypes.METERED || (schedule.recurrencePattern != null && schedule.recurrencePattern.pattern !== null);
        };

        self.viewWorkOrders = function (scheduleId) {
            $state.go('secure.workOrderList', { pmSchedule: scheduleId });
        };

        self.getPeriodTranslationKey = function (period) {
            if (!period) {
                return undefined;
            }
            period = period.toLowerCase();

            if (period === 'day') {
                return 'recurrencePattern.daily';
            }
            return 'recurrencePattern.' + period + 'ly';
        };

        self.$onInit = function () {
            $scope.$watch('pmScheduleDetails.schedules.length', function (newVal, oldVal) {
                if (newVal >= oldVal) {
                    var idx = newVal - 1;
                    if (!pmScheduleHelper.scheduleIsValid(self.schedules[idx])) {
                        self.setActive(idx);
                    }
                }
            });

            $scope.$watchGroup([
                'pmScheduleDetails.workOrderTemplate.purpose',
                'pmScheduleDetails.workOrderTemplate.workType',
                'pmScheduleDetails.workOrderTemplate.trade',
                'pmScheduleDetails.editingSchedule.assignees'], function () {
                if ($scope.scheduleForm.active) {
                    $scope.scheduleForm.active.$validate();
                }
            });

            // reset save attempt
            self.saveAttempt = false;
            $scope.$watch('pmScheduleDetails.saveAttempt', function (newVal) {
                if (newVal) {
                    self.done(self.schedules.length - 1);
                    self.saveAttempt = false;
                }
            });
        };
    });


'use strict';

angular.module('pmScheduleForm')
    .controller('PmScheduleDetailsDeleteModalController', function ($uibModalInstance) {
        var self = this;

        self.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('pmScheduleForm')
    .directive('pmInactiveAssociationValidator', function () {
        return {
            scope: {
                workOrderTemplate: '=pmInactiveAssociationValidator',
                schedule: '='
            },
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                if (scope.workOrderTemplate.workType) {
                    ctrl.$validators.pmWorkTypeAssociation = function (modelValue, viewValue) {
                        return !viewValue || scope.workOrderTemplate.workType.isActive;
                    };
                }

                if (scope.schedule.assignees && scope.schedule.assignees.length) {
                    ctrl.$validators.pmAssigneeAssociation = function (modelValue, viewValue) {
                        var inactiveUser = scope.schedule.assignees.some(function (assignee) {
                            return !assignee.isEnabled;
                        });
                        return !viewValue || !inactiveUser;
                    };
                }

                if (scope.workOrderTemplate.purpose) {
                    ctrl.$validators.pmPurposeAssociation = function (modelValue, viewValue) {
                        return !viewValue || scope.workOrderTemplate.purpose.isActive;
                    };
                }

                if (scope.workOrderTemplate.trade) {
                    ctrl.$validators.pmTradeAssociation = function (modelValue, viewValue) {
                        return !viewValue || scope.workOrderTemplate.trade.isActive;
                    };
                }
            }
        };
    });

'use strict';

angular.module('pmScheduleAssignees', ['helpers']);

/**
 * @ngdoc directive
 * @name pmScheduleAssignees.pmscheduleAssignees
 * @restrict E
 * @description
 *
 * Generates the sliding panel that houses the assignees typeahead
 *
 * @param {boolean} openWhen Opens the sliding panel when true
 * @param {object} schedule The schedule to add the assignees to
 *
 */

'use strict';

angular.module('pmScheduleAssignees')
    .component('pmscheduleAssignees', {
        templateUrl: 'app/components/pmScheduleAssignees/pmScheduleAssignees.html',
        controller: 'PmScheduleAssigneesController',
        controllerAs: 'pmScheduleAssignees',
        bindings: {
            openWhen: '=',
            schedule: '='
        }
    })
    .controller('PmScheduleAssigneesController', function ($scope, $q, $translate, roles) {
        var self = this;
        self.titles = { title: $translate.instant('pmScheduleAssignees.select') + ' ' + $translate.instant('pmScheduleAssignees.assignees') };
        self.roles = [roles.admin, roles.technician];

        self.slidingButtons = {
            saveFunction: function () {
                self.schedule.assignees = angular.copy(self.assigneesModel);

                return $q(function (resolve) {
                    resolve();
                });
            },
            saveButtonText: $translate.instant('pmScheduleAssignees.add')
        };

        self.browseOptions = {
            type: 'slidingpanel'
        };

        $scope.$watch('pmScheduleAssignees.openWhen', function (newVal) {
            if (!newVal) {
                return;
            }

            self.assigneesModel = angular.copy(self.schedule.assignees);
        });
    });

'use strict';

angular.module('pmScheduleAssets', []);

/**
 * @ngdoc directive
 * @name pmScheduleAssets.pmscheduleAssets
 * @restrict E
 * @description
 *
 * Generates the sliding panel that houses the Assets typeahead
 *
 * @param {boolean} openWhen Opens the sliding panel when true
 * @param {object} schedule The schedule to add the assets to
 *
 */

'use strict';

angular.module('pmScheduleAssets')
    .component('pmscheduleAssets', {
        templateUrl: 'app/components/pmScheduleAssets/pmScheduleAssets.html',
        controller: 'PmScheduleAssetsController',
        controllerAs: 'pmScheduleAssets',
        bindings: {
            openWhen: '=',
            schedule: '='
        }
    })
    .controller('PmScheduleAssetsController', function ($scope, $q, $translate) {
        var self = this;
        self.titles = { title: $translate.instant('pmScheduleAssets.select') + ' ' + $translate.instant('pmScheduleAssets.locationOrEquipment') };

        self.slidingButtons = {
            saveFunction: function () {
                self.schedule.businessAssets = angular.copy(self.businessAssetsModel);

                return $q(function (resolve) {
                    resolve();
                });
            },
            saveButtonText: $translate.instant('pmScheduleAssets.add')
        };

        self.browseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                },
                'business-asset-type': {
                    filters: ''
                }
            }
        };

        $scope.$watch('pmScheduleAssets.openWhen', function (newVal) {
            if (!newVal) {
                return;
            }

            self.businessAssetsModel = angular.copy(self.schedule.businessAssets);
        });
    });

'use strict';

angular.module('pmSchedule', ['translate', 'pmScheduleForm', 'pmScheduleList', 'pmScheduleAssets', 'pmScheduleAssignees', 'pmScheduleRecurrence', 'pmScheduleMeterReading', 'helpers']);

/**
 * @ngdoc service
 * @name pmSchedule.pmScheduleHelper
 * @requires DudeApi
 *
 * @description
 * Helper service for shared calls of PM Schedules
 *
 */

'use strict';

angular.module('pmSchedule')
    .service('pmScheduleHelper', function (DudeApi, taskBookService, pmScheduleType) {
        /**
         * @ngdoc method
         * @name addSchedule
         * @methodOf pmSchedule.pmScheduleHelper
         *
         * @description
         * Returns a new PMScheduleEntity from DudeAPI
         *
         * @returns {object} A new PMScheduleEntity from Dude Api
         */
        var addSchedule = function () {
            return new DudeApi.PmScheduleEntity({
                isActive: true,
                scheduleType: pmScheduleType.FIXED
            });
        };

        /**
         * @ngdoc method
         * @name addTaskBook
         * @methodOf pmSchedule.pmScheduleHelper
         *
         * @description
         * Returns a new TaskBookEntity from DudeAPI
         *
         * @returns {object} A new TaskBookEntity from Dude Api
         */
        var addTaskBook = function () {
            var taskBook = new DudeApi.TaskBookEntity({
                tasks: [],
                isMaster: false
            });
            if (!angular.isArray(taskBook.tasks) || taskBook.tasks.length === 0) {
                taskBookService.addTasks(taskBook.tasks, 5);
            }
            return taskBook;
        };

        /**
         * @ngdoc method
         * @name hasValidAssets
         * @methodOf pmSchedule.pmScheduleHelper
         *
         * @param {object} schedule The schedule to check the validity of
         *
         * @description
         * Returns whether or not a schedule has valid assets
         *
         * @returns {boolean} true if the assets are valid
         */
        var hasValidAssets = function (schedule) {
            if (!schedule.businessAssets || schedule.businessAssets.length === 0) {
                return false;
            }

            var isValid = true;

            if (schedule.scheduleType === pmScheduleType.METERED || schedule.scheduleType === pmScheduleType.MIXED) {
                schedule.businessAssets.forEach(function (asset) {
                    isValid = isValid && asset.isMetered && asset.startingThreshold;
                });
            }
            return isValid;
        };

        /**
         * @ngdoc method
         * @name isValidSchedule
         * @methodOf pmSchedule.pmScheduleHelper
         *
         * @param {object} schedule The schedule to check the validity of
         *
         * @description
         * Returns whether or not a schedule is valid
         *
         * @returns {boolean} true if the schedule is valid
         */
        var isValidSchedule = function (schedule) {
            // if schedule is not metered, must have recurrence
            // if schedule is metered, must have meter interval
            var scheduleRecurrenceIsValid = (schedule.scheduleType !== pmScheduleType.METERED && schedule.recurrencePattern != null && schedule.recurrencePattern.period != null)
                || ((schedule.scheduleType === pmScheduleType.METERED || schedule.scheduleType === pmScheduleType.MIXED) && schedule.meterInterval !== null);

            return scheduleRecurrenceIsValid && hasValidAssets(schedule);
        };

        return {
            addSchedule: addSchedule,
            addTaskBook: addTaskBook,
            scheduleIsValid: isValidSchedule,
            assetsAreValid: hasValidAssets
        };
    });

'use strict';

angular.module('notifications', ['ui.router', 'dudeAuth', 'dudeControls', 'dudeApi', 'translate', 'dudeLog']);

'use strict';

angular.module('notifications')
  .config(function ($stateProvider, permission) {
      $stateProvider
      .state('secure.notifications', {
          url: 'profile/notifications',
          templateUrl: 'app/components/notifications/notifications.html',
          controller: 'notificationsController',
          controllerAs: 'notifications',
          permissions: permission.users.create,
          resolve: {
              notifications: function ($stateParams, DudeApi) {
                  return DudeApi.MyNotificationSettingEntity.query().$promise;
              }
          }
      });
  });

'use strict';

angular.module('notifications')
    .controller('notificationsController', function ($translate, DudeApi, log, notifications) {
        var self = this;

        self.settings = notifications.data.filter(function (setting) {
            var keepSetting = setting.name.indexOf('WorkOrder') > -1;
            if (keepSetting) {
                setting.disabled = false;
                setting.formLabel = $translate.instant('notifications.' + setting.name + '.email');
            }
            return keepSetting;
        });

        self.updateSetting = function (setting) {
            setting.email = !setting.email;
            setting.disabled = true;
            DudeApi.MyNotificationSettingEntity.update({ id: setting.id }, setting).$promise
                .then(function () {
                    log.notify({
                        title: $translate.instant('notifications.label'),
                        type: 'success',
                        message: $translate.instant('notifications.updated')
                    });
                })
                .finally(function () {
                    setting.disabled = false;
                });
        };
    });

'use strict';

angular.module('navbar', ['dudeAuth', 'dudeControlsShell', 'dudeControls', 'translate', 'dudeLog']);

/**
 * @ngdoc service
 * @name navbar.supportPanelService
 * @requires DudeApi
 *
 * @description
 * Helper service setting up the support panel of the navbar
 *
 */

'use strict';

angular.module('navbar')
    .service('supportPanelService', function (marketizr, market, roleHelpers) {
        var educationMarkets = [market.k12, market.he, market.ips];
        var manufacturingMarkets = [market.mfg, market.gov, market.club, market.other];
        /**
         * @ngdoc method
         * @name helpLink
         * @methodOf navbar.supportPanelService
         *
         * @description
         * Returns the appropriate help link for the given role and market
         *
         * @returns {string} The url for the help link for the given role and market
         */
        var helpLink = function () {
            var link;
            switch (true) {
                // EDU Requester
            case marketizr.hasMarkets(educationMarkets) && roleHelpers.isRequester():
                link = 'http://help.dudesolutions.com/Content/Documentation/Maintenance/Maintenance%20Manager%20Education/User%20Roles/Requester/Maintenance%20Manager%20Requester.htm';
                break;
                // MFG Requester
            case marketizr.hasMarkets(manufacturingMarkets) && roleHelpers.isRequester():
                link = 'http://help.dudesolutions.com/Content/Documentation/Maintenance/Maintenance%20Manager%20Manufacturing/User%20Roles/Requester/Maintenance%20Manager%20Requester.htm';
                break;
                // EDU Technician
            case marketizr.hasMarkets(educationMarkets) && roleHelpers.isTechnician():
                link = 'http://help.dudesolutions.com/Content/Documentation/Maintenance/Maintenance%20Manager%20Education/User%20Roles/Technician/Maintenance%20Manager%20Technician.htm';
                break;
                // MFG Technician
            case marketizr.hasMarkets(manufacturingMarkets) && roleHelpers.isTechnician():
                link = 'http://help.dudesolutions.com/Content/Documentation/Maintenance/Maintenance%20Manager%20Manufacturing/User%20Roles/Technician/Maintenance%20Manager%20Technician.htm';
                break;
                // EDU Administrator
            case marketizr.hasMarkets(educationMarkets) && !roleHelpers.isTechnician() && !roleHelpers.isRequester():
                link = 'http://help.dudesolutions.com/Content/Documentation/Maintenance/Maintenance%20Manager%20Education/Maintenance%20Manager.htm';
                break;
                // MFG Administrator (default)
            default:
                link = 'http://help.dudesolutions.com/Content/Documentation/Maintenance/Maintenance%20Manager%20Manufacturing/Maintenance%20Manager.htm';
                break;
            }

            return link;
        };

        return {
            helpLink: helpLink
        };
    });

'use strict';

angular.module('navbar')
    .controller('NavbarController', function ($rootScope, $state, $translate, authService, featuresHelper, DudeApi, log, marketizr, market, roleHelpers, supportPanelService) {
        var self = this;
        var userName = '';

        self.title = {
            text: $translate.instant('navBar.product'),
            routerPath: 'secure.interceptor'
        };

        self.isRequester = roleHelpers.isRequester();
        self.isTechnician = roleHelpers.isTechnician();

        self.support = {
            phoneText: $translate.instant('helpDropdown.phone.phoneDisplay'),
            phoneHref: $translate.instant('helpDropdown.phone.phoneHref'),
            emailTitle: $translate.instant('helpDropdown.email.title'),
            emailAddress: $translate.instant('helpDropdown.email.address'),
            helpLink: supportPanelService.helpLink(),
            liveChat: true
        };

        self.logout = function (event) {
            event.preventDefault();
            authService.logout();
        };

        var toggleSearch = function () {
            self.search.isSearching = !self.search.isSearching;
        };

        var search = function () {
            if (isNaN(self.search.searchParam)) {
                log.notify({
                    type: 'error',
                    message: $translate.instant('navBar.invalidId')
                });
            } else if (parseInt(self.search.searchParam, 10)) {
                var filter = {
                    displayId: self.search.searchParam
                };
                DudeApi.WorkOrderEntity.query(filter).$promise.then(function (response) {
                    if (response.data.length === 1) {
                        // close the search bar
                        if (self.search.isSearching) {
                            toggleSearch();
                        }
                        self.search.searchParam = '';
                        $state.go('secure.workOrderFormEdit', { id: response.data[0].id });
                    } else {
                        log.notify({
                            type: 'error',
                            message: $translate.instant('navBar.invalidId')
                        });
                    }
                });
            }
        };

        self.search = self.isRequester ? null : {
            searchFunction: search,
            toggleSearch: toggleSearch,
            placeholder: $translate.instant('navBar.WOID')
        };

        var createNavigationArray = function () {
            self.navigationArray = [
                {
                    name: self.isRequester ? $translate.instant('navBar.requester.newWorkOrder') : $translate.instant('workOrderForm.new'),
                    routerPath: 'secure.workOrderFormNew',
                    icon: 'fa-plus',
                    hasPermission: true,
                    type: 'button'
                },
                {
                    name: $translate.instant('dashboard.title'),
                    routerPath: 'secure.dashboard',
                    icon: 'fa-home',
                    hasPermission: !self.isRequester && (!self.isTechnician || marketizr.hasMarkets([market.k12, market.he, market.ips])),
                    type: 'navigation'
                },
                {
                    name: self.isRequester ? $translate.instant('navBar.requester.workOrders') : $translate.instant('workOrderList.workOrders'),
                    routerPath: 'secure.workOrderList',
                    icon: 'fa-list',
                    hasPermission: true,
                    type: 'navigation'
                },
                {
                    name: $translate.instant('navBar.calendar'),
                    routerPath: 'secure.workOrderCalendar.month',
                    icon: 'fa-calendar',
                    hasPermission: !self.isTechnician && !self.isRequester,
                    type: 'navigation'
                },
                {
                    name: $translate.instant('navBar.reports'),
                    routerPath: 'secure.report.locationsChart',
                    icon: 'fa-area-chart',
                    hasPermission: !self.isRequester && !self.isTechnician,
                    type: 'navigation'
                },
                {
                    name: $translate.instant('navBar.locationsOrEquipment'),
                    routerPath: 'secure.assetList',
                    icon: 'fa-briefcase',
                    hasPermission: self.isTechnician,
                    type: 'navigation'
                },
                {
                    name: $translate.instant('navBar.history'),
                    routerPath: 'secure.history.workorders',
                    type: 'navigation',
                    icon: 'fa-header',
                    hasPermission: !self.isRequester
                },
                {
                    name: $translate.instant('navBar.admin'),
                    icon: 'fa-gear',
                    hasPermission: !self.isTechnician && !self.isRequester,
                    type: 'navigation',
                    accordion: [
                        {
                            name: $translate.instant('navBar.locationsOrEquipment'),
                            routerPath: 'secure.assetList',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.floorPlanList'),
                            routerPath: 'secure.floorPlanList',
                            hasPermission: featuresHelper.hasFeature('floorplans')
                        },
                        {
                            name: $translate.instant('navBar.types'),
                            routerPath: 'secure.assetTypeList',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.departments'),
                            routerPath: 'secure.departmentList',
                            hasPermission: featuresHelper.hasFeature('departments')
                        },
                        {
                            name: $translate.instant('navBar.projects'),
                            routerPath: 'secure.projectList',
                            hasPermission: marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov])
                        },
                        {
                            name: $translate.instant('navBar.purposes'),
                            routerPath: 'secure.purposeList',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.schedules'),
                            routerPath: 'secure.pmScheduleList',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.taskBooks'),
                            routerPath: 'secure.taskBookList',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.trades'),
                            routerPath: 'secure.tradeList',
                            hasPermission: marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov])
                        },
                        {
                            name: $translate.instant('navBar.users'),
                            routerPath: 'secure.userList',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.workTypes'),
                            routerPath: 'secure.workTypeList',
                            hasPermission: marketizr.hasMarkets([market.k12, market.ips, market.he])
                        },
                        {
                            name: 'divider',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.settings'),
                            routerPath: 'secure.settingsEdit',
                            hasPermission: true
                        }
                    ]
                },
                {
                    name: $translate.instant('navBar.userSettings'),
                    icon: 'fa-user',
                    hasPermission: true,
                    type: 'iconMenu',
                    accordion: [
                        {
                            name: userName,
                            type: 'text',
                            hasPermission: true
                        },
                        {
                            name: 'divider',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.editProfile'),
                            routerPath: 'secure.userMe',
                            icon: 'fa-pencil',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.changePassword'),
                            routerPath: 'secure.changePassword',
                            icon: 'fa-key',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.notificationSettings'),
                            routerPath: 'secure.notifications',
                            icon: 'fa-envelope',
                            hasPermission: !self.isRequester && !self.isTechnician
                        },
                        {
                            name: 'divider',
                            hasPermission: true
                        },
                        {
                            name: $translate.instant('navBar.logout'),
                            clickFunction: self.logout,
                            icon: 'fa-sign-out',
                            hasPermission: true
                        }
                    ]
                }
            ];
        };

        authService.getContext().then(function (data) {
            self.profile = data;
            self.title.subText = data.user.account.name;

            self.support.accountNumber = data.account.number;
            self.support.profile = data;

            userName = data.user.firstName + ' ' + data.user.lastName;
            createNavigationArray();
        });
    });

'use strict';

angular.module('meterReading', ['dudeControls', 'dudeApi', 'translate', 'assetFilters', 'dudeLog']);

/**
 * @ngdoc directive
 * @name meterReading.meterReading
 * @restrict E
 * @description
 *
 * Generates the sliding panel that houses the Asset's usage tracking
 *
 * @param {boolean} openWhen Opens the sliding panel when true
 * @param {object} asset The asset to update
 *
 */

'use strict';

angular.module('meterReading')
    .component('meterReading', {
        templateUrl: 'app/components/meterReading/meterReading.html',
        controller: 'MeterReadingController',
        controllerAs: 'meterReading',
        bindings: {
            openWhen: '=',
            asset: '='
        }
    })
    .controller('MeterReadingController', function ($scope, $q, $translate, log, DudeApi, assetFormService, userContext) {
        var self = this;

        self.$onInit = function () {
            self.titles = { title: $translate.instant('meterReading.title') };
            self.country = userContext.account.location.country;

            self.slidingButtons = {
                saveFunction: function () {
                    return $q.all(assetFormService.saveAttributes(self.attributes, self.asset)).then(function () {
                        log.notify({
                            title: $translate.instant('meterReading.notify.success.title'),
                            type: 'success',
                            message: $translate.instant('meterReading.notify.success.message')
                        });
                    });
                },
                saveButtonText: $translate.instant('general.actions.save')
            };

            $scope.$watch('meterReading.openWhen', function (newVal) {
                if (!newVal) {
                    self.attributes = [];
                    return;
                }
                DudeApi.BusinessAssetAttributeEntity.query({
                    businessAssetId: self.asset.id,
                    attributeTypeKey: 'meter'
                }).$promise.then(function (attributes) {
                    self.attributes = attributes.data;
                });
            });
        };
    });

'use strict';

angular.module('maintenanceSlidingPanels', []);

/**
 * @ngdoc service
 * @name maintenanceSlidingPanels.maintenanceSlidingPanelsService
 *
 * @description
 * Service for communicating between maintenance sliding panels.
 *
 */

'use strict';

angular.module('maintenanceSlidingPanels')
    .service('maintenanceSlidingPanelsService', function () {
        var openPanelCallbacks = {};

        /**
         * @ngdoc method
         * @name initializeService
         * @methodOf maintenanceSlidingPanels.maintenanceSlidingPanelsService
         *
         * @description
         *   Initializes the variables so they are reset on page load
         *
         */
        var initializeService = function () {
            openPanelCallbacks = {};
        };

        /**
         * @ngdoc method
         * @name openPanel
         * @methodOf maintenanceSlidingPanels.maintenanceSlidingPanelsService
         *
         * @description
         *   Opens the designated panel
         *
         * @param {string} panelName The string identifier for the panel to open
         * @param {object} options Any options to be included when opening the panel
         *
         */
        var openPanel = function (panelName, options) {
            if (openPanelCallbacks[panelName] && typeof openPanelCallbacks[panelName] === 'function') {
                openPanelCallbacks[panelName](options);
            }
        };

        /**
         * @ngdoc method
         * @name subscribe
         * @methodOf maintenanceSlidingPanels.maintenanceSlidingPanelsService
         *
         * @description
         *   Subscribes a callback that should open the component's panel
         *
         * @param {string} panelName The string identifier for the panel to open
         * @param {function} openPanelCallback The callback that contains the function that will open the panel
         *
         */
        var subscribe = function (panelName, openPanelCallback) {
            openPanelCallbacks[panelName] = openPanelCallback;
        };

        return {
            initializeService: initializeService,
            openPanel: openPanel,
            subscribe: subscribe
        };
    });

'use strict';

angular.module('locationReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report', 'assetReport']);

'use strict';

angular.module('locationReport')
    .config(function ($stateProvider, permission, moment, workOrderEnums, dateHelperProvider) {
        var routeParams = 'status&workType&purpose&requestDateTo&requestDateFrom&requestDateRange&completionDateTo&completionDateFrom&completionDateRange&businessAsset&includeDescendants&assetRollUp&orderBy&filterId';
        var defaults = {
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete, workOrderEnums.status.onHold],
            toDate: dateHelperProvider.getEndOfDay(new Date()).toISOString(),
            // The default from date is 7 days in the past so we subtract 7 days worth of milliseconds from now to get the correct date
            fromDate: dateHelperProvider.getStartOfDay(moment().subtract(7, 'days')).toISOString()
        };

        var getActiveSavedFilter = function ($stateParams, myFilters, savedFiltersService) {
            var queryParams = $stateParams;
            if (queryParams.filterId) {
                return savedFiltersService.getFilterIfExistsForUser(queryParams.filterId, myFilters);
            }
            return null;
        };

        var getQueryParams = function ($location, $stateParams, activeSavedFilter, marketizr, market) {
            var defaultCopy = angular.copy(defaults);
            var queryParams = $stateParams;
            queryParams.includeDescendants = null;
            queryParams.isLocation = true;
            if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                queryParams.assetRollUp = 'true';
            } else {
                queryParams.assetRollUp = queryParams.includeDescendants || queryParams.assetRollUp || null;
            }
            if (!queryParams.requestDateTo && !queryParams.requestDateFrom && !queryParams.completionDateFrom && !queryParams.completionDateTo && !queryParams.requestDateRange && !queryParams.completionDateRange) {
                queryParams.requestDateTo = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.toDate : dateHelperProvider.getEndOfDay(moment().subtract(1, 'month').endOf('month')).toISOString();
                queryParams.requestDateFrom = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.fromDate : dateHelperProvider.getStartOfDay(moment().subtract(1, 'month').startOf('month')).toISOString();
            }
            if (!queryParams.filterId) {
                queryParams.status = queryParams.status || defaultCopy.status;
            }
            // If requesting a saved filter created for a different page or by a different user, remove the filter id
            if (queryParams.filterId && !activeSavedFilter) {
                delete queryParams.filterId;
                $location.search('filterId', null);
            }
            return queryParams;
        };

        $stateProvider
            .state('secure.report.locationsList', {
                url: 'locations/list?' + routeParams,
                templateUrl: 'app/components/locationReport/locationList.html',
                controller: 'LocationReportListController',
                controllerAs: 'locationReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/locations/list');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $q, $stateParams, activeSavedFilter, assetReportService, marketizr, market, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        var filters = reportFiltersService.toApiFilter(queryParams);

                        return $q.all({
                            initResponse: assetReportService.loadAssets(filters).then(function (assets) {
                                return assetReportService.getListData(filters, assets);
                            }),
                            filters: filters,
                            totals: assetReportService.getTotalData(filters),
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        });
                    }
                }
            })
            .state('secure.report.locationsChart', {
                url: 'locations/chart?' + routeParams,
                templateUrl: 'app/components/locationReport/locationChart.html',
                controller: 'LocationReportChartController',
                controllerAs: 'locationReport',
                permissions: [permission.businessAssets.create, permission.businessAssets.update, permission.businessAssets.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/locations/chart');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $stateParams, activeSavedFilter, marketizr, market, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        var filters = reportFiltersService.getFilters(queryParams);

                        return {
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        };
                    }
                }
            });
    });

'use strict';

angular.module('locationReport')
    .controller('LocationReportListController', function ($translate, initData) {
        var self = this;

        self.title = $translate.instant('locationReports.location');

        self.initData = angular.copy(initData);
    });

'use strict';

angular.module('locationReport')
    .controller('LocationReportChartController', function (initData) {
        var self = this;

        self.initData = angular.copy(initData);
    });

/**
 * @ngdoc service
 * @name workOrderInventory.issueToWorkOrderService
 * @requires $q
 * @requires DudeApi
 *
 * @description
 * Service for supporting the issueToWorkOrder component.
 *
 */

'use strict';

angular.module('workOrderInventory')
    .service('issueToWorkOrderService', function ($q, DudeApi) {
        /**
         * @ngdoc method
         * @name assignAssets
         * @methodOf workOrderInventory.issueToWorkOrderService
         *
         * @description
         * Assigns assets to all of the storage area objects.
         *
         * @param {object} storageAreas Object containing all of the storage areas.
         * @returns {promise} Promise that will contain all of the storage areas with their associated assets.
         */
        var assignAssets = function (storageAreas) {
            var promises = storageAreas.map(function (storageArea) {
                return DudeApi.BusinessAssetEntity.get({ id: storageArea.businessAssetId }).$promise;
            });

            return $q.all(promises).then(function (assets) {
                return $q(function (resolve) {
                    resolve(storageAreas.map(function (storageArea, index) {
                        storageArea.asset = assets[index];
                        return storageArea;
                    }));
                });
            });
        };

        /**
         * @ngdoc method
         * @name getItemStorageAreas
         * @methodOf workOrderInventory.issueToWorkOrderService
         *
         * @description
         * Gets all storage areas associated to an inventory item and then calls assignAssets() to assign
         * assets to each storage area.
         *
         * @param {int} id The inventory item's ID.
         * @returns {promise} Promise that will contain all of the storage areas with their associated assets.
         */
        var getItemStorageAreas = function (id) {
            return $q(function (resolve) {
                DudeApi.InventoryItemStorageAreaEntity.get({ inventoryItemId: id }).$promise.then(function (storageAreas) {
                    assignAssets(storageAreas.data).then(function (results) {
                        resolve(results);
                    });
                });
            });
        };

        return {
            getItemStorageAreas: getItemStorageAreas
        };
    });

/**
 * @ngdoc directive
 * @name workOrderInventory.issue-to-work-order
 * @restrict E
 * @description
 *
 * The panel that allows the user to assign an Inventory Item from a storage area
 * to a work order.
 *
 * @param {boolean} openWhen The value to watch for when to open the sliding panel.
 * @param {array} storageAreas Array of storage areas being worked with.
 * @param {boolean} openStoragePanel True to open the storage panel.
 * @param {object} inventoryItem The inventory item being added to the work order.
 * @param {array} inventoryTransactions The array of transactions associated to this work order.
 * @param {object} workOrder The work order being looked at.
 *
 */

'use strict';

angular.module('workOrderInventory')
    .component('issueToWorkOrder', {
        templateUrl: 'app/components/issueToWorkOrder/issueToWorkOrder.html',
        bindings: {
            openWhen: '=',
            storageAreas: '=',
            openStoragePanel: '=',
            inventoryItem: '=',
            inventoryTransactions: '=',
            workOrder: '<'
        },
        controllerAs: 'issueToWorkOrder',
        controller: 'IssueToWorkOrderController'
    }).controller('IssueToWorkOrderController', function ($q, $scope, $translate, $timeout, log, DudeApi, issueToWorkOrderService, slidingPanelSaveVariables, slidingPanelSelectStorageAreaService, quantityAdjustmentsService) {
        var self = this;
        var originalStorageAreas;
        var ISSUE_TO_WORK_ORDER_TRANSACTION_ID = 3;
        slidingPanelSelectStorageAreaService.initializeService();

        self.$onInit = function () {
            self.selectedStorageArea = null;
            self.originalSelected = null;
            self.issuedFromOpen = true;
            self.issuedToOpen = false;
            self.quantityToIssue = $translate.instant('issueToWorkOrder.quantityToIssue');
            self.titles = { title: $translate.instant('issueToWorkOrder.title'), subtitle: '(' + $translate.instant('issueToWorkOrder.subtitle') + ' ' + self.workOrder.displayId + ')' };
            self.additionalFilters = { isActive: true, hasQuantityOnHand: true };
            $timeout(function () {
                slidingPanelSelectStorageAreaService.subscribeStorageAreaCallback(function (storageArea) {
                    if (!storageArea) {
                        self.inventoryItem = null;
                    }
                    self.getSelectedStorageArea();
                    originalStorageAreas = angular.copy(self.storageAreas);
                    if (self.selectedStorageArea != null) {
                        self.quantityInfo = quantityAdjustmentsService.instantiateWorkOrderQuantities([self.workOrder]);
                        self.issuedFromOpen = false;
                        self.issuedToOpen = true;
                    }
                });
            });

            self.panelFunctions = {
                saveFunction: function () {
                    var transaction = {
                        inventoryItem: {
                            id: self.inventoryItem.id
                        },
                        inventoryTransactionReason: {
                            id: ISSUE_TO_WORK_ORDER_TRANSACTION_ID
                        },
                        transactionDateTime: new Date().toISOString(),
                        workOrderDisplayId: self.workOrder.displayId,
                        inventoryTransactionDetails: [{
                            businessAssetId: self.selectedStorageArea.asset.id,
                            transactionQuantity: self.quantityInfo[self.workOrder.displayId].newQuantity * -1
                        }]
                    };

                    if (transaction.inventoryTransactionDetails[0].transactionQuantity === 0 ||
                        transaction.inventoryTransactionDetails[0].transactionQuantity === '' ||
                        transaction.inventoryTransactionDetails[0].transactionQuantity == null) {
                        log.notify({
                            title: $translate.instant('issueToWorkOrder.notify.moreThanZeroTitle'),
                            type: 'error',
                            message: $translate.instant('issueToWorkOrder.notify.moreThanZeroMessage')
                        });

                        return $q.reject();
                    }

                    var promises = [];
                    var returnedTransaction;

                    promises.push(DudeApi.InventoryTransactionEntity.save(transaction).$promise);
                    promises.push(DudeApi.BusinessAssetEntity.get({
                        id: transaction.inventoryTransactionDetails[0].businessAssetId
                    }).$promise);

                    return $q.all(promises).then(function (results) {
                        returnedTransaction = results[0];
                        returnedTransaction.asset = results[1];

                        self.inventoryTransactions.push(returnedTransaction);
                        self.panelFunctions.cancelFunction();

                        log.notify({
                            title: $translate.instant('issueToWorkOrder.notify.successTitle'),
                            type: 'success',
                            message: $translate.instant('issueToWorkOrder.notify.successMessage')
                        });

                        return slidingPanelSaveVariables.closeAll;
                    });
                },
                cancelFunction: function () {
                    self.selectedStorageArea = null;
                    self.inventoryItem = null;
                    self.issuedFromOpen = true;
                    self.issuedToOpen = false;
                    slidingPanelSelectStorageAreaService.setStorageArea(null);
                    self.quantityInfo = quantityAdjustmentsService.instantiateWorkOrderQuantities([self.workOrder]);
                    self.storageAreas = angular.copy(originalStorageAreas);
                }
            };

            $scope.$watch('issueToWorkOrder.inventoryItem', function (newVal) {
                self.selectedStorageArea = null;
                if (!newVal || !newVal.id) {
                    return;
                }

                issueToWorkOrderService.getItemStorageAreas(newVal.id).then(function (storageAreas) {
                    self.storageAreas = storageAreas;
                    self.inventoryItem = newVal;
                    self.openStoragePanelFunction();
                });
            });
        };

        self.getSelectedStorageArea = function () {
            self.selectedStorageArea = slidingPanelSelectStorageAreaService.getStorageArea();
        };

        self.openStoragePanelFunction = function () {
            self.openStoragePanel = true;
        };
    });

/**
 * @ngdoc directive
 * @name history.historyListNavigation
 * @restrict E
 * @description
 *
 * The navigation tabs for choosing which type of history you'd like to see
 *
 * @param {object} filters Filters for the history list
 */

'use strict';

angular.module('history')
    .component('historyListNavigation', {
        bindings: {
            filters: '=?'
        },
        controller: 'HistoryListNavigationController',
        controllerAs: 'historyListNavigation',
        templateUrl: 'app/components/historyList/historyListNavigation.html'

    })
    .controller('HistoryListNavigationController', function ($state) {
        var self = this;

        self.isActiveRoute = function (parameter) {
            return $state.current.url.indexOf(parameter) === 0;
        };

        self.routeTo = function (routeParam) {
            var route = 'secure.history.' + routeParam;
            var filterCopy = angular.copy(self.filters);
            delete filterCopy.orderBy;

            $state.go(route, filterCopy);
        };
    });

'use strict';

angular.module('history')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.history',
            {
                abstract: true,
                url: 'history/',
                template: '<div ui-view></div>',
                controllerAs: 'history'
            });
    });

/**
 * @ngdoc directive
 * @name history.historySlidingPanel
 * @requires $scope
 * @requires $q
 * @requires $translate
 * @requires $timeout
 * @requires history.historyService
 *
 * @restrict E
 * @description
 *
 * The panel that allows the user to view history of an object.
 *
 * @param {boolean} openWhen The value to watch for when to open the sliding panel.
 * @param {object} object An object containing the ID, objectType, parent ID, parent type,
 *                       and whether or not to include sub collections for each object that history
 *                       is needed for.
 * @param {string} displayId The display id for the work order
 *
 */

'use strict';

angular.module('history')
    .component('historySlidingPanel', {
        templateUrl: 'app/components/history/historySlidingPanel.html',
        bindings: {
            openWhen: '=',
            object: '<',
            displayId: '<'
        },
        controllerAs: 'historySlidingPanel',
        controller: 'HistorySlidingPanelController'
    }).controller('HistorySlidingPanelController', function ($scope, $state, $q, $translate, $timeout, moment, historyService, slidingPanelCloseService) {
        var self = this;

        self.events = [];

        self.close = function () {
            slidingPanelCloseService.closeSinglePanel(self.randomPanelName, true);
            $timeout(function () {
                self.events = [];
            }, 500);
        };

        self.navigate = function () {
            $state.go('secure.history.workorders', { q: self.displayId });
        };

        self.$onInit = function () {
            self.titles = {
                title: $translate.instant('history.slidingPanelHeader')
            };
            self.panelFunctions = {
                forceTransclude: true,
                cancelFunction: function () {
                    $timeout(function () {
                        self.events = [];
                    }, 500);
                }
            };

            $scope.$watch('historySlidingPanel.openWhen', function (newVal) {
                if (!newVal) {
                    return;
                }
                self.emptyMessage = $translate.instant('history.loading');

                historyService.getFullObjectHistory(self.object).then(function (response) {
                    self.events = response.data;

                    self.emptyMessage = $translate.instant('history.noHistory');
                    self.events.forEach(function (event) {
                        if (!event.impersonatedByUser) {
                            event.userName = event.user ? event.user.firstName + ' ' + event.user.lastName : 'System Generated';
                        } else {
                            event.userName = $translate.instant('general.cscUser');
                        }
                    });
                });
            });
        };
    });

/**
 * @ngdoc service
 * @name history.historyFieldNamesService
 *
 * @description
 * Service for translating each of the field names to be human readable
 *
 * @requires $filter
 * @requires $translate
 * @requires moment
 *
 */

'use strict';

angular.module('history')
    .service('historyFieldNamesService', function ($filter, $translate, moment) {
        /**
         * @ngdoc method
         * @name getFieldStrings
         * @methodOf history.historyFieldNamesService
         *
         * @description Returns the human readable strings for the before and after values of the field
         *
         * @param {object} detail The properties of the change
         */
        var getFieldStrings = function (detail) {
            switch (detail.field) {
            case 'requestDateTime':
            case 'completionDateTime':
            case 'completedDateTime':
                detail.beforeString = detail.before && moment(detail.before).format('MM/DD/YYYY hh:mm:ss A');
                detail.afterString = detail.after && moment(detail.after).format('MM/DD/YYYY hh:mm:ss A');
                break;
            case 'transactionDate':
            case 'dueDateTime':
            case 'scheduledStartDate':
                detail.beforeString = detail.before && moment(detail.before).format('MM/DD/YYYY');
                detail.afterString = detail.after && moment(detail.after).format('MM/DD/YYYY');
                break;
            case 'requestedBy':
            case 'typeAttributes.user':
            case 'completedByUser':
                detail.beforeString = detail.before && detail.before.firstName + ' ' + detail.before.lastName;
                detail.afterString = detail.after && detail.after.firstName + ' ' + detail.after.lastName;
                break;
            case 'purpose':
                detail.beforeString = detail.before && detail.before.value;
                detail.afterString = detail.after && detail.after.value;
                break;
            case 'workType':
            case 'businessAsset':
            case 'trade':
            case 'project':
            case 'downtimeTracking.failureReason':
                detail.beforeString = detail.before && detail.before.name;
                detail.afterString = detail.after && detail.after.name;
                break;
            case 'downtimeTracking.cost':
                detail.beforeString = detail.before && $filter('currency')(detail.before);
                detail.afterString = detail.after && $filter('currency')(detail.after);
                break;
            case 'downtimeTracking.duration':
                detail.beforeString = detail.before && moment.duration(detail.before, 's').hours() + 'h ' + moment.duration(detail.before, 's').minutes() + 'm';
                detail.afterString = detail.after && moment.duration(detail.after, 's').hours() + 'h ' + moment.duration(detail.after, 's').minutes() + 'm';
                break;
            case 'assignees':
                detail.beforeString = '';
                if (detail.before !== null) {
                    detail.before.forEach(function (assignee, index) {
                        detail.beforeString += assignee.firstName + ' ' + assignee.lastName;
                        if (index !== detail.before.length - 1) {
                            detail.beforeString += ', ';
                        }
                    });
                }
                detail.afterString = '';
                if (detail.after !== null) {
                    detail.after.forEach(function (assignee, index) {
                        detail.afterString += assignee.firstName + ' ' + assignee.lastName;
                        if (index !== detail.after.length - 1) {
                            detail.afterString += ', ';
                        }
                    });
                }
                break;
            case 'typeAttributes.rate':
                detail.beforeString = detail.before != null && $filter('currency')(detail.before) + ' ' + $translate.instant('history.perHour');
                detail.afterString = detail.after != null && $filter('currency')(detail.after) + ' ' + $translate.instant('history.perHour');
                break;
            case 'typeAttributes.laborType':
            case 'typeAttributes.serviceType':
                detail.beforeString = detail.before && $translate.instant('history.transactionFields.' + detail.before);
                detail.afterString = detail.after && $translate.instant('history.transactionFields.' + detail.after);
                break;
            case 'status':
                detail.beforeString = detail.before && $translate.instant('history.status.' + detail.before);
                detail.afterString = detail.after && $translate.instant('history.status.' + detail.after);
                break;
            default:
                detail.beforeString = detail.before;
                detail.afterString = detail.after;
                break;
            }

            if (detail.field.toLowerCase().indexOf('cost') !== -1) {
                if (detail.beforeString && typeof detail.beforeString === 'number') {
                    detail.beforeString = $filter('currency')(detail.beforeString) || detail.beforeString;
                }

                if (detail.afterString && typeof detail.afterString === 'number') {
                    detail.afterString = $filter('currency')(detail.afterString) || detail.afterString;
                }
            }
        };

        return {
            getFieldStrings: getFieldStrings
        };
    });

/**
 *  @ngdoc directive
 *  @name history.historyEventCard
 *  @restrict E
 *  @description
 *
 *  Card showing the title of the updated section and changes for all updated fields within the section.
 *
 *  @param {object} changeEvent The history event that contains the changes.
 */

'use strict';

angular.module('history')
    .component('historyEventCard', {
        templateUrl: 'app/components/history/historyEventCard.html',
        bindings: {
            changeEvent: '<'
        },
        controllerAs: 'historyEventCard',
        controller: 'HistoryEventCardController'
    });

angular.module('history')
    .controller('HistoryEventCardController', function ($q, $translate, $scope, roleHelpers, historyBlacklistedFields, historyFieldNamesService, historyService) {
        var self = this;
        self.update = 'Update';
        self.isWorkOrderType = false;

        var objectTypes = [
            'labortransaction',
            'purchasetransaction',
            'servicetransaction',
            'attachment',
            'weblink',
            'task'
        ];
        self.isTechnician = roleHelpers.isTechnician();

        self.translateFallback = function (path) {
            return historyService.translateFallback(path);
        };

        var setNames = function () {
            var changeObject = self.changeEvent.self;
            if (objectTypes.indexOf(changeObject.objectType) !== -1) {
                self.isWorkOrderType = false;
                self.name = $translate.instant('history.objectTypes.' + changeObject.objectType);

                if (changeObject.objectType.indexOf('transaction') !== -1) {
                    self.subname = '(' + changeObject.objectId + ')';
                } else if (changeObject.objectType.indexOf('task') !== -1) {
                    self.subname = self.changeEvent.extraData && self.changeEvent.extraData.order ? '(' + self.changeEvent.extraData.order + ')' : '';
                } else {
                    self.subname = null;
                }
            } else {
                self.isWorkOrderType = true;
                self.name = $translate.instant('history.objectTypes.details');
            }

            for (var i = 0; i < self.changeEvent.details.length; i++) {
                if (historyBlacklistedFields.indexOf(self.changeEvent.details[i].field) !== -1) {
                    self.changeEvent.details.splice(i, 1);
                    i--;
                } else {
                    historyFieldNamesService.getFieldStrings(self.changeEvent.details[i]);
                }
            }

            self.changeEvent.details.sort(function (a, b) {
                var textA = self.translateFallback('history.changeFields.' + a.field).toUpperCase() + ' ' + self.translateFallback('history.changeTypes.' + a.changeType);
                var textB = self.translateFallback('history.changeFields.' + b.field).toUpperCase() + ' ' + self.translateFallback('history.changeTypes.' + b.changeType);
                return (textA < textB) ? -1 : 1;
            });
        };

        self.$onInit = function () {
            setNames();

            $scope.$watch('historyEventCard.changeEvent', function (newVal) {
                if (!newVal) {
                    return;
                }
                setNames();
            });
        };

        self.tracker = function (index) {
            return self.changeEvent.key + '_' + index;
        };
    });

'use strict';

angular.module('history')
    .constant('historyChangeTypes', {
        attachment: 'attachment',
        task: 'task',
        laborTransaction: 'labortransaction',
        serviceTransaction: 'servicetransaction',
        purchaseTransaction: 'purchasetransaction',
        webLink: 'weblink',
        workOrder: 'workorder'
    });

'use strict';

angular.module('history')
    .constant('historyBlacklistedFields', [
        'id',
        'mime',
        'small.shareableUri',
        'small.mime',
        'medium.shareableUri',
        'medium.mime',
        'fileApiId',
        'fileApiViewToken',
        'fileState',
        'fileType',
        'downloadUri',
        'shareableUri',
        'isTemporary',
        'typeAttributes.type',
        'thumbnail',
        'objectId',
        'objectType',
        'pmSchedule',
        'workOrderTemplate',
        'downtimeTracking.id'
    ]);

/**
 * @ngdoc service
 * @name history.historyService
 * @requires $q
 * @requires DudeApi
 * @requires pagingHelpers
 *
 * @description
 * Service for making calls to the history api.
 *
 */

'use strict';

angular.module('history')
    .service('historyService', function ($translate, $q, DudeApi, pagingHelpers) {
        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf history.historyService
         *
         * @description
         * Gets default filters for API calls.
         *
         * @param {object} params Object containing all of the desired filters.
         *
         * @returns {object} currentFilter The filter object updated to have all of the
         *                   desired filters plus all of the default ones.
         */
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'ChangeDateTime desc',
                objectId: params.objectId || null,
                objectIds: params.objectIds || [],
                objectType: params.objectType || null,
                parentId: params.parentId || null,
                parentType: params.parentType || null,
                userIds: params.userIds || [],
                fields: params.fields || [],
                includeSubCollections: params.includeSubCollections || null,
                // TODO Uncomment line below when new filter is ready
                // includeDescendants: params.includeDescendants || null,
                businessAsset: params.businessAsset || [],
                changeDateTimeFrom: params.changeDateTimeFrom || null,
                changeDateTimeTo: params.changeDateTimeTo || null,
                q: params.q || null
            };

            return currentFilter;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf history.historyService
         *
         * @description
         * Updates filters to get them ready for API calls.
         *
         * @param {object} currentFilter Object containing all of the desired filters.
         *
         * @returns {object} The filter object updated to have all of the desired
         *                   filters plus all of the default ones, with all of them
         *                   ready to pass to the API.
         */
        var toApiFilter = function (currentFilter) {
            // TODO Uncomment line below when new filter is ready
            // if (currentFilter.includeDescendants === 'false') {
            //     currentFilter.includeDescendants = null;
            // }

            return getFilters(currentFilter);
        };

        /**
         * @ngdoc method
         * @name queryHistory
         * @methodOf history.historyService
         *
         * @description
         * Queries the history API with the given filter.
         *
         * @param {object} filter Object containing all of the desired filters.
         *
         * @returns {array} A list of history events matching the passed filters.
         */
        var queryHistory = function (filter) {
            filter = toApiFilter(filter);

            return DudeApi.HistoryEntity.query(filter).$promise;
        };

        /**
         * @ngdoc method
         * @name getFullObjectHistory
         * @methodOf history.historyService
         *
         * @description
         * Gets one object's full history.
         *
         * @param {object} object An object containing the objectId, objectType, parentID, parentType,
         *                        and whether or not to include sub collections for each object that history
         *                        is needed for.
         * @param {int} object.objectId The ID of the object in question. Null for a query on a parent.
         * @param {Array} object.objectIds An array of IDs to search for. Null for a query on a parent.
         * @param {string} object.objectType The type of the object in question.
         * @param {int} object.parentId The ID of the object's parent. Null if it doesn't have a parent. Required if id is null.
         * @param {string} object.parentType The type of the object's parent. Null if it doesn't have a parent. Required if id is null.
         * @param {boolean} object.includeSubCollections Whether or not to include the object's sub-collections in the response from
         *                                               the API.
         *
         * @returns {array} Every history event for the given object.
         */
        var getFullObjectHistory = function (object) {
            var filter = toApiFilter({
                objectIds: object.objectIds,
                objectId: object.objectId,
                objectType: object.objectType,
                parentId: object.parentId,
                parentType: object.parentType,
                includeSubCollections: object.includeSubCollections
            });

            return queryHistory(filter);
        };

        /**
         * @ngdoc method
         * @name getHistoryEventByKey
         * @methodOf history.historyService
         *
         * @description
         * Gets one specific history event.
         *
         * @param {object} couchBaseKey Object containing the key for the desired history event.
         *
         * @returns {Promise} The history event with the given key.
         */
        var getHistoryEventByKey = function (couchBaseKey) {
            return DudeApi.HistoryEntity.get(couchBaseKey).$promise;
        };

        /**
         * @ngdoc method
         * @name translateFallback
         * @methodOf history.historyService
         *
         * @description
         * Takes in a binding, checks to see if the binding exists in translation and returns
         * either the translated binding or the last segment of the translation changed from camel
         * case to human readable form.
         *
         * @param {string} jsonPath String representing the path to look for in the translation
         *
         * @returns {string} Translated string or fallback
         */
        var translateFallback = function (jsonPath) {
            var output = $translate.instant(jsonPath);
            if (output === jsonPath) {
                var words = jsonPath.split('.');
                var lastWord = words[words.length - 1];
                output = '';
                for (var i = 0; i < lastWord.length; i++) {
                    var char = lastWord.charAt(i);
                    if (i === 0) {
                        output += char.toUpperCase();
                    } else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
                        output += ' ' + char;
                    } else {
                        output += char;
                    }
                }
            }
            return output;
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            queryHistory: queryHistory,
            getFullObjectHistory: getFullObjectHistory,
            getHistoryEventByKey: getHistoryEventByKey,
            translateFallback: translateFallback
        };
    });

/**
 * @ngdoc directive
 * @name helpers.sticky-element
 * @restrict A
 * @description
 *
 * Adds stickiness to an element causing it to stick to the bottom of the header when scrolling down
 * and return to its initial position when scrolling back up.
 *
 * @requires $window
 * @requires $timeout
 * @requires responsiveBreakpoints
 * @requires clientHelperService
 */

'use strict';

angular.module('helpers')
    .directive('stickyElement', function ($window, $timeout, responsiveBreakpoints, clientHelperService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var HEADER_OFFSET = parseInt(attrs.offset, 10) || 97;
                var MOBILE_OFFSET = parseInt(attrs['mobile-offest'], 10) || 40;
                var $win = angular.element($window);
                if (scope._stickyElements === undefined) {
                    scope._stickyElements = [];

                    var addRemoveStickyClass = function () {
                        var pos = clientHelperService.getCurrentScreenSize().breakpoint === responsiveBreakpoints.xs ? $win.scrollTop() + MOBILE_OFFSET : $win.scrollTop() + HEADER_OFFSET;
                        for (var i = 0; i < scope._stickyElements.length; i++) {
                            var item = scope._stickyElements[i];
                            if (!item.isStuck && pos > item.initialPosition) {
                                item.element.addClass('sticky-element-stuck');
                                item.isStuck = true;
                            } else if (item.isStuck && pos < item.initialPosition) {
                                item.element.removeClass('sticky-element-stuck');
                                item.isStuck = false;
                            }
                        }
                    };

                    var recheckPositions = function () {
                        for (var i = 0; i < scope._stickyElements.length; i++) {
                            var item = scope._stickyElements[i];
                            if (!item.isStuck) {
                                item.initialPosition = item.element.offset().top;
                            }
                        }
                    };
                    $win.on('scroll.sticky', addRemoveStickyClass);
                    $win.on('load.sticky', recheckPositions);
                    $win.on('resize.sticky', recheckPositions);

                    scope.$on('$destroy', function () {
                        $win.off('.sticky');
                    });
                }
                var item;
                $timeout(function () {
                    item = {
                        element: element,
                        isStuck: false,
                        initialPosition: element.offset().top
                    };

                    scope._stickyElements.push(item);
                });
            }
        };
    });

'use strict';

angular.module('helpers')
    .constant('roles', {
        admin: 1,
        technician: 2,
        requester: 5
    });

/**
 * @ngdoc service
 * @name helpers.roleHelpers
 *
 * @description
 * Service for handling roles
 *
 */

'use strict';

angular.module('helpers')
    .service('roleHelpers', function (permissionsHelper, permission) {
        /**
         * @ngdoc method
         * @name isRequester
         * @methodOf helpers.roleHelpers
         *
         * @description
         * Checks if the users role is a requester
         *
         * @returns {boolean} A boolean indicating if the user role is a requester
         */
        var isRequester = function () {
            return !permissionsHelper.userAllowed(permission.workOrders.readAllDetails);
        };

        /**
         * @ngdoc method
         * @name isTechnician
         * @methodOf helpers.roleHelpers
         *
         * @description
         * Checks if the users role is a technician
         *
         * @returns {boolean} A boolean indicating if the user role is a technician
         */
        var isTechnician = function () {
            return !permissionsHelper.userAllowed(permission.users.create) && permissionsHelper.userAllowed(permission.workOrders.readAllDetails);
        };

        /**
         * @ngdoc method
         * @name isCsc
         * @methodOf helpers.roleHelpers
         *
         * @description
         * Checks if the users role is CSC
         *
         * @returns {boolean} A boolean indicating if the user role is CSC
         */
        var isCsc = function () {
            return permissionsHelper.userAllowed(permission.assetTemplate.read);
        };

        var roles = {
            CSC: 'CSC'
        };

        return {
            isRequester: isRequester,
            isTechnician: isTechnician,
            isCsc: isCsc,
            roles: roles
        };
    });

'use strict';

angular.module('helpers')
    .directive('pmAssociationValidator', function () {
        return {
            scope: {
                association: '=pmAssociationValidator',
                invertCheck: '=?'
            },
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.pmAssociation = function (modelValue, viewValue) {
                    if (scope.invertCheck) {
                        return !viewValue || !scope.association;
                    }
                    return viewValue || !scope.association;
                };
            }
        };
    });

/**
 * @ngdoc service
 * @name helpers.pmAssociationsService
 *
 * @description
 * Service for checking pm associations
 *
 */

'use strict';

angular.module('helpers')
    .service('pmAssociationsService', function ($translate, DudeApi) {
        /**
         * @ngdoc method
         * @name isAssociated
         * @methodOf helpers.pmAssociationsService
         *
         * @description
         * Checks if the attribute is associated to pm's
         *
         * @param {object} filters The filter object to pass
         * @returns {Promise} A promise that resolves to the first associated workOrderTemplate
         */
        var isAssociated = function (filters) {
            filters.pageSize = 1;
            filters.isActive = true;

            if (filters.assignees) {
                return DudeApi.PmScheduleEntity.query(filters).$promise;
            }

            return DudeApi.WorkOrderTemplateEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name validationMessage
         * @methodOf helpers.pmAssociationsService
         *
         * @description
         * Returns the validation message for the association to pms for a given attribute and count
         *
         * @param {string} type The attribute name
         * @param {number} number The number of pm associations
         * @returns {string} A string containing the validation message to display
         */
        var validationMessage = function (type, number) {
            var text = '';
            // "Cannot disable this user because they are associated with 1 active PM Schedule. Please reassign the PM Schedule."
            text += type === 'user' ? $translate.instant('helpers.pmAssociations.cannotDisable') : $translate.instant('helpers.pmAssociations.cannotInactivate');
            text += type;
            text += type === 'user' ? $translate.instant('helpers.pmAssociations.theyAreAssociated') : $translate.instant('helpers.pmAssociations.itIsAssociated');
            text += number;
            text += number > 1 ? $translate.instant('helpers.pmAssociations.multiPm') : $translate.instant('helpers.pmAssociations.singlePm');
            return text;
        };

        return {
            isAssociated: isAssociated,
            validationMessage: validationMessage
        };
    });

'use strict';

angular.module('helpers')
    .constant('permission', {
        workOrders: {
            create: 'WorkOrders-Create',
            read: 'WorkOrders-Read',
            update: 'WorkOrders-Update',
            receiveCreatedNotification: 'WorkOrders-ReceiveCreatedNotification',
            readAllDetails: 'WorkOrders-ReadAllDetails',
            createTasks: 'WorkOrders-CreateTasks',
            deleteTasks: 'WorkOrders-DeleteTasks'
        },
        users: {
            create: 'Users-Create',
            read: 'Users-Read',
            update: 'Users-Update'
        },
        purposes: {
            create: 'Purposes-Create',
            read: 'Purposes-Read',
            update: 'Purposes-Update',
            delete: 'Purposes-Delete'
        },
        trades: {
            create: 'Trades-Create',
            read: 'Trades-Read',
            update: 'Trades-Update',
            delete: 'Trades-Delete'
        },
        workTypes: {
            create: 'WorkTypes-Create',
            read: 'WorkTypes-Read',
            update: 'WorkTypes-Update',
            delete: 'WorkTypes-Delete'
        },
        businessAssets: {
            create: 'BusinessAssets-Create',
            read: 'BusinessAssets-Read',
            update: 'BusinessAssets-Update',
            delete: 'BusinessAssets-Delete'
        },
        businessAssetTypes: {
            create: 'BusinessAssetTypes-Create',
            read: 'BusinessAssetTypes-Read',
            update: 'BusinessAssetTypes-Update',
            delete: 'BusinessAssetTypes-Delete'
        },
        laborHourTypes: {
            create: 'LaborHourTypes-Create',
            read: 'LaborHourTypes-Read',
            update: 'LaborHourTypes-Update',
            delete: 'LaborHourTypes-Delete'
        },
        transactions: {
            create: 'Transactions-Create',
            read: 'Transactions-Read',
            updateAny: 'Transactions-UpdateAny',
            deleteAny: 'Transactions-DeleteAny'
        },
        pmSchedules: {
            create: 'PmSchedules-Create',
            read: 'PmSchedules-Read',
            update: 'PmSchedules-Update',
            delete: 'PmSchedules-Delete'
        },
        taskBooks: {
            create: 'TaskBooks-Create',
            read: 'TaskBooks-Read',
            update: 'TaskBooks-Update',
            delete: 'TaskBooks-Delete'
        },
        calendarEvents: {
            create: 'CalendarEvents-Create',
            read: 'CalendarEvents-Read',
            update: 'CalendarEvents-Update'
        },
        inventoryItems: {
            create: 'InventoryItems-Create',
            read: 'InventoryItems-Read',
            update: 'InventoryItems-Update',
            delete: 'InventoryItems-Delete'
        },
        inventoryTransactions: {
            create: 'InventoryTransactions-Create',
            read: 'InventoryTransactions-Read',
            issue: 'InventoryTransactions-CreateIssue'
        },
        inventoryTransactionReasons: {
            read: 'InventoryTransactionReasons-Read'
        },
        accounts: {
            create: 'Accounts-Create',
            read: 'Accounts-Read',
            update: 'Accounts-Update',
            delete: 'Accounts-Delete'
        },
        departments: {
            create: 'Departments-Create',
            read: 'Departments-Read',
            update: 'Departments-Update'
        },
        projects: {
            create: 'Projects-Create',
            read: 'Projects-Read',
            update: 'Projects-Update'
        },
        comments: {
            update: 'Comments-Update',
            delete: 'Comments-Delete'
        },
        history: {
            read: 'History-Read'
        },
        floorPlans: {
            create: 'Floorplans-Create',
            read: 'Floorplans-Read',
            update: 'Floorplans-Update',
            delete: 'Floorplans-Delete'
        }
    });

/**
 * @ngdoc service
 * @name helpers.defaultPurposesService
 * @requires DudeApi
 *
 * @description
 * Service for handling the default purpose values
 *
 */

'use strict';

angular.module('helpers')
    .service('defaultPurposesService', function ($q, DudeApi, marketizr, market, settingsHelpers) {
        var purposeKeys = Object.freeze({
            reactivePurpose: 'MM-defaults-reactivePurpose',
            plannedPurpose: 'MM-defaults-plannedPurpose'
        });

        var defaultPurposes = {
            planned: 'Preventive Maintenance'
        };

        var allPurposes = null;

        var getAllPurposes = function () {
            return $q(function (resolve) {
                if (allPurposes) {
                    resolve(allPurposes);
                } else {
                    DudeApi.PurposeEntity.query({ pageSize: 1000 }).$promise.then(function (purposes) {
                        allPurposes = purposes.data;
                        resolve(allPurposes);
                    });
                }
            });
        };

        var getPurposeByType = function (purposes, key, isNew, purposeToQuery) {
            var valueToSet;
            return DudeApi.PurposeTypeEntity.query().$promise.then(function (purposeTypes) {
                var correctPurposeTypes = purposeTypes.data.filter(function (purposeType) {
                    return purposeType.name === purposeToQuery;
                });
                if (correctPurposeTypes.length > 0) {
                    valueToSet = purposes.filter(function (p) {
                        return p.purposeType && p.purposeType.id === correctPurposeTypes[0].id;
                    });
                    valueToSet = valueToSet.length > 0 ? valueToSet[0] : null;
                    if (!valueToSet) {
                        for (var i = 0; i < purposes.length; i++) {
                            if (purposes[i].purposeType) {
                                valueToSet = purposes[i];
                                break;
                            }
                        }
                        valueToSet = valueToSet || purposes[0];
                        settingsHelpers.saveSetting(key, valueToSet, isNew);
                        return valueToSet;
                    }
                    settingsHelpers.saveSetting(key, valueToSet, isNew);
                    return valueToSet;
                }
                valueToSet = purposes.length > 0 ? purposes[0] : null;
                settingsHelpers.saveSetting(key, valueToSet, isNew);
                return valueToSet;
            });
        };

        var setDefaultPurpose = function (key, isNew, updatedDefault) {
            var purposeToQuery;
            if (marketizr.hasMarkets([market.k12, market.ips, market.he, market.gov, market.other])) {
                defaultPurposes.reactive = 'Reactive Maintenance';
            } else if (marketizr.hasMarkets([market.mfg])) {
                defaultPurposes.reactive = 'Breakdown Maintenance';
            } else {
                defaultPurposes.reactive = 'Corrective Maintenance';
            }
            if (updatedDefault) {
                purposeToQuery = updatedDefault;
            } else {
                purposeToQuery = key === purposeKeys.reactivePurpose ? defaultPurposes.reactive : defaultPurposes.planned;
            }
            return getAllPurposes().then(function (purposes) {
                var valueToSet = purposes.filter(function (p) {
                    return p.value === purposeToQuery;
                });
                valueToSet = valueToSet.length > 0 ? valueToSet[0] : null;
                if (!valueToSet && !isNew && updatedDefault) {
                    return setDefaultPurpose(key, isNew);
                } else if (!valueToSet) {
                    return getPurposeByType(purposes, key, isNew, purposeToQuery);
                }
                settingsHelpers.saveSetting(key, valueToSet, isNew).catch(function () {
                    if (isNew) {
                        settingsHelpers.saveSetting(key, valueToSet, false);
                    }
                });
                return valueToSet;
            });
        };

        /**
         * @ngdoc method
         * @name getPurpose
         * @methodOf helpers.defaultPurposesService
         *
         * @description
         * Gets the purpose object for the default value.  If it finds no value with the provided key it will try to set it to the base default purpose
         *
         * @param {string} key The key for the location of the purpose
         * @returns {Promise} A promise that resolves to the default purpose
         */
        var getPurpose = function (key) {
            allPurposes = null;
            return DudeApi.AccountSettingsEntity.get({ id: key }).$promise.then(function (result) {
                if (result && result.value && result.value.id && result.value.value) {
                    return DudeApi.PurposeEntity.get({ id: result.value.id }).$promise.then(function (purpose) {
                        if (purpose.value !== result.value.value && result.value.purposeType) {
                            return setDefaultPurpose(key, false);
                        } else if (result && result.value.id && !result.value.purposeType) {
                            return setDefaultPurpose(key, false, result.value.value);
                        }
                        return purpose;
                    }, function () {
                        return setDefaultPurpose(key, false);
                    });
                } else if (result) {
                    return setDefaultPurpose(key, false);
                }
                return setDefaultPurpose(key, true);
            }, function () {
                return setDefaultPurpose(key, true);
            });
        };

        return {
            purposeKeys: purposeKeys,
            getPurpose: getPurpose
        };
    });

angular.module('helpers')
    .filter('commaSeparate', function () {
        return function (input, option) {
            if (!option) {
                throw Error('Comma Separate filter requires at least one option');
            }

            if (!input || !Array.isArray(input) || input.length < 1) {
                return '';
            }

            return input.map(function (item) {
                return item[option];
            }).join(', ');
        };
    });

'use strict';

angular.module('floorPlanList', ['dudeControlsFile', 'translate', 'dudeControls', 'ui.router']);

/**
 * @ngdoc directive
 * @name floorPlanList.floorPlanListPanel
 * @restrict E
 * @description
 *
 * Renders the floorPlanPanel sliding panel
 *
 *  @param {object} panelObject The setting for the panel.
 */

'use strict';

angular.module('floorPlanList')
    .component('floorPlanListPanel', {
        templateUrl: 'app/components/floorPlanList/floorPlanListPanel.html',
        bindings: {
            panelObject: '<'
        },
        controller: 'FloorPlanListPanelComponent',
        controllerAs: 'floorPlanListPanel'
    })
    .controller('FloorPlanListPanelComponent', function ($scope, $q, $translate, $state, fileHelpers, log, DudeApi) {
        var self = this;
        var MINIMUM_WIDTH = 850;
        var MINIMUM_HEIGHT = 500;
        var ALLOWED_FILE_TYPE = 'image';
        self.file = '';
        self.asset = '';
        self.entity = null;
        self.minimumSizeError = $translate.instant('attachments.notify.upload.errors.fileMinimumSize');
        self.fileTooLarge = $translate.instant('attachments.notify.upload.errors.fileLargeSize');
        self.saveAttempt = false;

        self.assetBrowseOptions = {
            type: 'slidingPanel',
            keepFiltersOpen: true,
            filterPanel: {
                search: {
                    filter: 'q'
                }
            }
        };

        var uploadErrorHandler = function (file) {
            return function (error) {
                var errorMessage = error.data.message.length ? error.data.message : error.data.validationErrors[0].message;

                angular.extend(file, {
                    uploading: false,
                    error: true,
                    errorMessage: fileHelpers.errorMessage(errorMessage)
                });

                self.isGenericFileError = self.file.errorMessage && (self.file.errorMessage !== self.minimumSizeError && self.file.errorMessage !== self.fileTooLarge);

                if (error.data.message.length) {
                    log.notify({
                        type: 'error',
                        title: $translate.instant('floorPlanList.notify.upload.error'),
                        message: error.data.message
                    });
                }
            };
        };

        var saveErrorHandler = function () {
            self.saveError = true;
            return $q.reject();
        };

        self.buttonFunctions = {
            saveFunction: function () {
                self.saveError = false;

                if (!self.entity) {
                    return $q.reject();
                }

                var floorPlan = new DudeApi.FloorPlanEntity({
                    fileId: self.entity.id,
                    name: self.entity.filename,
                    fileViewToken: fileHelpers.shareableGuid(self.entity),
                    businessAsset: self.asset
                });

                return floorPlan.$save().then(function (response) {
                    log.notify({
                        title: $translate.instant('floorPlanList.notify.upload.success.title'),
                        type: 'success',
                        message: $translate.instant('floorPlanList.notify.upload.success.message') + ' ' + self.asset.name
                    });
                    $state.go('secure.assetFloorPlanView', { id: response.id });
                }, saveErrorHandler);
            },
            cancelFunction: function () {
                self.file = '';
                self.asset = '';
                self.entity = null;
                self.saveAttempt = false;
                self.saveError = false;
            }
        };

        self.upload = function () {
            var options = {
                minWidth: MINIMUM_WIDTH,
                minHeight: MINIMUM_HEIGHT,
                allowedUploadTypes: ALLOWED_FILE_TYPE
            };
            self.uploading = true;
            var upload = fileHelpers.uploadFile(self.file, options);
            upload.then(function (result) {
                self.entity = result;
            }, uploadErrorHandler(self.file));
        };

        self.$onInit = function () {
            $scope.$watch('floorPlanListPanel.file', function (newVal, oldVal) {
                if (!newVal || newVal === oldVal) {
                    return;
                }
                self.upload();
            });
        };
    });

/**
 * @ngdoc service
 * @name floorPlanList.floorPlanListService
 * @requires DudeApi
 *
 * @description
 * Service for supporting the list of floor plans
 *
 */

'use strict';

angular.module('floorPlanList')
    .service('floorPlanListService', function (DudeApi, pagingHelpers) {
        /**
         * @ngdoc method
         * @name getListData
         * @methodOf floorPlanList.floorPlanListService
         *
         * @description
         * Gets a list of floor plans
         *
         * @param {object} filter An object containing the filters to query with
         * @returns {Promise} A promise that resolves to the paged list of floor plans
         */
        var getListData = function (filter) {
            return DudeApi.FloorPlanEntity.query(filter);
        };

        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf floorPlanList.floorPlanListService
         *
         * @description
         * Gets the filter object to query with
         *
         * @param {object} params The params to parse into the floor plan filter object
         * @returns {object} A filter object ready to query against the floor plans entity
         */
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'BusinessAsset/Name asc'
            };

            return currentFilter;
        };

        return {
            getListData: getListData,
            getFilters: getFilters
        };
    });

'use strict';

angular.module('floorPlanList')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.floorPlanList', {
                url: 'floorPlans?page&orderBy',
                templateUrl: 'app/components/floorPlanList/floorPlanList.html',
                controller: 'FloorPlanListController',
                controllerAs: 'floorPlanList',
                feature: 'floorplans',
                permissions: [permission.floorPlans.read],
                resolve: {
                    initData: function ($q, $stateParams, floorPlanListService) {
                        var filters = floorPlanListService.getFilters($stateParams);
                        return $q.all({
                            filters: filters,
                            initResponse: floorPlanListService.getListData(filters).$promise
                        });
                    }
                }
            });
    });

'use strict';

angular.module('floorPlanList')
    .controller('FloorPlanListController', function ($scope, $translate, queryHelpers, floorPlanListService, initData, appConfig) {
        var self = this;
        var queryDefaults = floorPlanListService.getFilters({});
        var pageChanging = false;

        self.listData = initData.initResponse.data;
        self.filters = initData.filters;
        self.totalCount = initData.initResponse.total;
        self.imageUrlPrefix = appConfig.api.file + '/file/public/';

        self.openFloorPlanListPanel = function () {
            self.panelObject = {
                titles: {
                    title: $translate.instant('floorPlanList.newFloorPlan')
                },
                open: true,
                template: 'app/components/floorPlanList/floorPlanListPanel.html'
            };
        };

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            floorPlanListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        $scope.$watch('floorPlanList.filters', updateFilters, true);
    });

/**
 * @ngdoc directive
 * @name filters.filter-workorder-status
 * @restrict E
 * @description
 *
 * The Work Order Status checkbox filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen True to open the filter. (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterWorkorderStatus', {
        templateUrl: 'app/components/filterWorkorderStatus/filterWorkorderStatus.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            isOpen: '=?'
        },
        controller: 'FilterWorkorderStatusController',
        controllerAs: 'filterWorkorderStatus'
    })
    .controller('FilterWorkorderStatusController', function (workOrderEnums) {
        var self = this;

        self.status = workOrderEnums.status;

        self.updateStatuses = function (status) {
            var index = self.filter.indexOf(status);
            if (index > -1) {
                self.filter.splice(index, 1);
            } else {
                self.filter.push(status);
            }

            if (self.filter.length === 0) {
                self.filter.push('all');
            } else {
                var checkedAll = self.filter.indexOf('all');

                if (checkedAll > -1) {
                    self.filter.splice(checkedAll, 1);
                }
            }
        };

        self.showBadge = function () {
            if (self.filter.indexOf('all') > -1) {
                return '';
            }

            return self.filterPanelController.showBadge(self.filter);
        };

        self.$onInit = function () {
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filter);
        };
    });

/**
 * @ngdoc directive
 * @name filters.filter-workorder-priority
 * @restrict E
 * @description
 *
 * The Work Order Priority checkbox filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen True to open the filter. (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterWorkorderPriority', {
        templateUrl: 'app/components/filterWorkorderPriority/filterWorkorderPriority.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            isOpen: '=?'
        },
        controller: 'FilterWorkorderPriorityController',
        controllerAs: 'filterWorkorderPriority'
    })
    .controller('FilterWorkorderPriorityController', function (workOrderEnums) {
        var self = this;

        self.priority = workOrderEnums.priority;

        self.updatePriorities = function (priority) {
            var index = self.filter.indexOf(priority);
            if (index > -1) {
                self.filter.splice(index, 1);
            } else {
                self.filter.push(priority);
            }

            if (self.filter.length === 0) {
                self.filter.push('all');
            } else {
                var checkedAll = self.filter.indexOf('all');

                if (checkedAll > -1) {
                    self.filter.splice(checkedAll, 1);
                }
            }
        };

        self.showBadge = function () {
            if (self.filter.indexOf('all') > -1) {
                return '';
            }

            return self.filterPanelController.showBadge(self.filter);
        };

        self.$onInit = function () {
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filter);
        };
    });

/**
 * @ngdoc directive
 * @name reportFilters.report-date-filter
 * @restrict E
 * @description
 *
 * Displays the report filter for selecting a completion date filter or request date filter
 *
 * @param {object} filters the filter object to check against for completionDate and requestDate filters
 * @param {boolean} cleared the boolean that is watched for when filters are cleared
 * @param {array} dateValues array of objects containing date values (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .directive('workOrderDateFilter', function ($translate, marketizr, market) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                filters: '=',
                cleared: '=?',
                dateValues: '<?'
            },
            templateUrl: 'app/components/filterWorkorderDate/workOrderDateFilter.html',
            link: function (scope) {
                scope.dates = {};
                scope.isEduMarket = marketizr.hasMarkets(market.k12, market.he, market.ips);

                if (scope.filters.completionDateTo || scope.filters.completionDateFrom) {
                    scope.dateType = 'completionDate';
                    scope.dates.to = angular.copy(scope.filters.completionDateTo);
                    scope.dates.from = angular.copy(scope.filters.completionDateFrom);
                    scope.dates.range = angular.copy(scope.filters.completionDateRange);
                } else {
                    scope.dateType = 'requestDate';
                    scope.dates.to = angular.copy(scope.filters.requestDateTo);
                    scope.dates.from = angular.copy(scope.filters.requestDateFrom);
                    scope.dates.range = angular.copy(scope.filters.requestDateRange);
                }

                scope.$watch('dateType', function (newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }

                    scope.filters[newVal + 'To'] = angular.copy(scope.dates.to);
                    scope.filters[oldVal + 'To'] = null;
                    scope.filters[newVal + 'From'] = angular.copy(scope.dates.from);
                    scope.filters[oldVal + 'From'] = null;
                    scope.filters[newVal + 'Range'] = angular.copy(scope.dates.range);
                    scope.filters[oldVal + 'Range'] = null;
                });

                var checkDateObject = function (date) {
                    // Check to make sure both dates are formatted as date strings
                    var validDateObject = (typeof (date.to) === 'object' && date.to !== null) || (typeof (date.from) === 'object' && date.from !== null);

                    // Check to make sure the to date is set with proper milliseconds
                    validDateObject = validDateObject || (typeof (date.to) === 'string' && date.to.indexOf('.000Z') === -1);

                    return validDateObject;
                };

                scope.$watch('dates', function (newVal, oldVal) {
                    if (angular.equals(newVal, oldVal) || checkDateObject(newVal)) {
                        return;
                    }

                    scope.filters[scope.dateType + 'To'] = newVal.to;
                    scope.filters[scope.dateType + 'From'] = newVal.from;
                    scope.filters[scope.dateType + 'Range'] = newVal.range;
                }, true);

                scope.$watch('cleared', function (newVal) {
                    if (newVal && newVal.value) {
                        scope.dates.to = null;
                        scope.dates.from = null;
                        scope.dateType = 'requestDate';
                    }
                });
            }
        };
    });

/**
 * @ngdoc directive
 * @name filters.filter-workorder-date
 * @restrict E
 * @description
 *
 * The Work Order Date Filter
 *
 * @param {object} filters The entire filter object so that we have access to all properties for this directive
 * @param {boolean} isOpen True to open the filter. (Optional)
 * @param {boolean} cleared True when the clear filters is fired. (Optional)
 * @param {array} dateValues array of objects containing date values (Optional)
 * @param {string} title string containing the title
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterWorkorderDate', {
        templateUrl: 'app/components/filterWorkorderDate/filterWorkorderDate.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filters: '=',
            isOpen: '=?',
            cleared: '=?',
            dateValues: '<?',
            title: '<?'
        },
        controller: 'FilterWorkorderDateController',
        controllerAs: 'filterWorkorderDate'
    })
    .controller('FilterWorkorderDateController', function ($scope, $translate) {
        var self = this;

        self.showBadge = function () {
            if (!self.filters) {
                return '';
            }

            if (self.filters.completionDateFrom || self.filters.completionDateTo) {
                if (self.filters.completionDateFrom != null && self.filters.completionDateTo != null) {
                    return '2';
                } else if (self.filters.completionDateFrom != null || self.filters.completionDateTo != null) {
                    return '1';
                }
                return '';
            }

            if (self.filters.requestDateFrom || self.filters.requestDateTo) {
                if (self.filters.requestDateFrom != null && self.filters.requestDateTo != null) {
                    return '2';
                } else if (self.filters.requestDateFrom != null || self.filters.requestDateTo != null) {
                    return '1';
                }
                return '';
            }

            return '';
        };

        self.$onInit = function () {
            self.title = self.title || $translate.instant('filterWorkorderDate.title');
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filters);
        };
    });

/**
 * @ngdoc directive
 * @name workOrderFilters.filter-work-type
 * @restrict E
 * @description
 *
 * The Work Type typeahead filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen True to open the filter. (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterWorkType', {
        templateUrl: 'app/components/filterWorkType/filterWorkType.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            isOpen: '=?'
        },
        controller: 'FilterWorkTypeComponent',
        controllerAs: 'filterWorkType'
    })
    .controller('FilterWorkTypeComponent', function () {
        var self = this;

        self.showBadge = function () {
            return self.filterPanelController.showBadge(self.filter);
        };

        self.$onInit = function () {
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filter);
        };
    });

'use strict';

angular.module('assetFilters', ['filterHelpers', 'filterBar']);

/**
 * @ngdoc directive
 * @restrict E
 * @name filters.filter-storage-area
 * @description
 *
 * The Inventory Storage Area or Work Order Asset filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen True to open the filter. (Optional)
 *
 */

'use strict';

angular.module('assetFilters')
    .component('filterStorageArea', {
        templateUrl: 'app/components/filterStorageArea/filterStorageArea.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '='
        },
        controller: 'FilterStorageAreaController',
        controllerAs: 'filterStorageArea'
    })
    .controller('FilterStorageAreaController', function ($scope) {
        var self = this;

        self.$onInit = function () {
            var setFilterString = function () {
                if (!self.filter.isWorkOrderAsset && !self.filter.isInventoryStorageArea) {
                    self.filterString = 'all';
                } else if (self.filter.isWorkOrderAsset && !self.filter.isInventoryStorageArea) {
                    self.filterString = 'isWorkOrderAsset';
                } else {
                    self.filterString = 'isInventoryStorageArea';
                }
            };

            $scope.$watch('filterStorageArea.filterString', function (newVal, oldVal) {
                if (!newVal || angular.equals(newVal, oldVal)) {
                    return;
                }
                if (self.filterString === 'all') {
                    self.filter = null;
                } else if (self.filterString === 'isWorkOrderAsset') {
                    self.filter = { isWorkOrderAsset: true };
                } else {
                    self.filter = { isInventoryStorageArea: true };
                }
            });

            $scope.$watch('filterStorageArea.filter', function (newVal, oldVal) {
                if (!!newVal && !angular.equals(newVal, oldVal)) {
                    setFilterString();
                }
            });

            setFilterString();
        };
    });

/**
 * @ngdoc directive
 * @name filters.filter-report-date-range
 * @restrict E
 * @description
 *
 * The Report Date Range Filter
 *
 * @param {object} filters The entire filter object so that we have access to all properties for this directive
 * @param {boolean} isOpen True to open the filter. (Optional)
 * @param {boolean} cleared True when the clear filters is fired. (Optional)
 * @param {array} dateValues array of objects containing date values (Optional)
 * @param {string} title string containing the title
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterReportDateRange', {
        templateUrl: 'app/components/filterReportDateRange/filterReportDateRange.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filters: '=',
            isOpen: '=?',
            cleared: '=?',
            dateValues: '<?',
            title: '<?'
        },
        controller: 'FilterReportDateRangeController',
        controllerAs: 'filterReportDateRange'
    })
    .controller('FilterReportDateRangeController', function ($scope, $translate) {
        var self = this;

        self.showBadge = function () {
            if (!self.filters) {
                return '';
            } else if (self.filters.dateFrom != null && self.filters.dateTo != null) {
                return '2';
            } else if (self.filters.dateFrom != null || self.filters.dateTo != null) {
                return '1';
            }

            return '';
        };

        self.$onInit = function () {
            self.title = self.title || $translate.instant('filterReportDateRange.title');
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filters);
        };
    });

/**
 * @ngdoc directive
 * @name purposeList.filterPurposeType
 * @restrict E
 * @description
 *
 * The Status (isActive) filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen True to open the filter. (Optional)
 *
 */

'use strict';

angular.module('purposeList')
    .component('filterPurposeType', {
        templateUrl: 'app/components/filterPurposeType/filterPurposeType.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            isOpen: '=?'
        },
        controller: 'filterPurposeTypeController',
        controllerAs: 'filterPurposeType'
    })
    .controller('filterPurposeTypeController', function ($scope, DudeApi) {
        var self = this;

        self.showBadge = function () {
            return self.filterPanelController.showBadge(self.filter);
        };

        self.setFilter = function () {
            self.filter = self.purposeType && self.purposeType.id;
        };

        self.$onInit = function () {
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filter);
            DudeApi.PurposeTypeEntity.query({ orderBy: 'Name asc' }).$promise.then(function (results) {
                self.purposeTypes = results.data;
                if (self.filter) {
                    self.purposeType = self.purposeTypes.filter(function (type) {
                        return type.id === parseInt(self.filter, 10);
                    })[0] || null;
                }
            });

            $scope.$watch('filterPurposeType.filter', function (newVal, oldVal) {
                if (newVal === null && !!oldVal) {
                    self.purposeType = null;
                }
            });
        };
    });

/**
 * @ngdoc directive
 * @name workOrderFilters.filter-project
 * @restrict E
 * @description
 *
 * The Project typeahead filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen True to open the filter. (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterProject', {
        templateUrl: 'app/components/filterProject/filterProject.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            isOpen: '=?'
        },
        controller: 'FilterProjectComponent',
        controllerAs: 'filterProject'
    })
    .controller('FilterProjectComponent', function () {
        var self = this;

        self.showBadge = function () {
            return self.filterPanelController.showBadge(self.filter);
        };

        self.$onInit = function () {
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filter);
        };
    });

'use strict';

angular.module('maintenanceFilters', []);

/**
 * @ngdoc directive
 * @name maintenanceFilters.filterCheckboxGroup
 * @restrict E
 * @description
 *
 * Filter for a group of fields under a specific section
 *
 * @param {Array} filter The array of fields acting as the filter
 * @param {string} header String containing the title of the section.
 * @param {Array} fields Array of fields to be displayed.
 *
 */

'use strict';

angular.module('maintenanceFilters')
    .component('filterCheckboxGroup', {
        templateUrl: 'app/components/filterCheckboxGroup/filterCheckboxGroup.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            header: '<',
            fields: '='
        },
        controller: 'FilterCheckboxGroupComponent',
        controllerAs: 'filterCheckboxGroup'
    })
    .controller('FilterCheckboxGroupComponent', function ($element, $scope) {
        var self = this;
        var fieldsValuesList;

        var findChanges = function (arr1, arr2) {
            var differences = [];

            arr1.forEach(function (val) {
                if (arr2.indexOf(val) === -1) {
                    differences.push(val);
                }
            });

            arr2.forEach(function (val) {
                if (arr1.indexOf(val) === -1 && differences.indexOf(val) === -1) {
                    differences.push(val);
                }
            });

            return differences;
        };

        var updateSelections = function () {
            self.fields = self.fields.map(function (field) {
                if (self.filter.indexOf(field.value) !== -1) {
                    self.isOpen = true;
                    field.isSelected = true;
                } else {
                    field.isSelected = false;
                }
                return field;
            });

            var someChecked = self.fields.some(function (field) {
                return field.isSelected;
            });
            var someEmpty = self.fields.some(function (field) {
                return !field.isSelected;
            });

            self.parentSelected = someChecked;
            self.parentIndeterminate = self.parentSelected ? someEmpty : false;
            $element[0].querySelector('.checkbox.header input').indeterminate = !!self.parentIndeterminate;
        };

        self.update = function (field) {
            if (field.isSelected) {
                self.filter.splice(self.filter.indexOf(field.value), 1);
            } else {
                self.filter.push(field.value);
            }
        };

        self.updateAll = function () {
            self.isOpen = true;
            self.parentSelected = self.parentIndeterminate ? self.parentIndeterminate : self.parentSelected;
            self.parentIndeterminate = false;
            self.fields.forEach(function (field) {
                if (self.parentSelected && self.filter.indexOf(field.value) === -1) {
                    self.filter.push(field.value);
                } else if (!self.parentSelected && self.filter.indexOf(field.value) !== -1) {
                    self.filter.splice(self.filter.indexOf(field.value), 1);
                }
            });
        };

        self.$onInit = function () {
            self.singleField = self.fields.length === 1;
            fieldsValuesList = self.fields.map(function (field) {
                return field.value;
            });
            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filters);
            self.filter = Array.isArray(self.filter) ? self.filter : [self.filter];
            updateSelections();
            $scope.$watchCollection('filterCheckboxGroup.filter', function (newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }
                var differences = findChanges(newVal, oldVal);
                var update = false;
                fieldsValuesList.forEach(function (val) {
                    if (differences.indexOf(val) !== -1) {
                        update = true;
                    }
                });
                if (update) {
                    updateSelections();
                }
            }, true);
        };
    });

/**
 * @ngdoc directive
 * @name workOrderFilters.filter-asset-node-search
 * @restrict E
 * @description
 *
 * The Asset Node Search Filter
 *
 * @param {object} filters The filter object
 * @param {boolean} isDisabled Determines whether or not to disable the search field (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterAssetNodeSearch', {
        templateUrl: 'app/components/filterAssetNodeSearch/filterAssetNodeSearch.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filters: '=',
            isDisabled: '=?'
        },
        controller: 'FilterAssetNodeSearchController',
        controllerAs: 'filterAssetNodeSearch'
    })
    .controller('FilterAssetNodeSearchController', function ($scope, DudeApi) {
        var self = this;
        self.showToggles = false;
        var parentId;

        self.$onInit = function () {
            self.filterValue = true;
            self.filters.searchFromCurrentNode = true;

            $scope.$watch('filterAssetNodeSearch.filterValue', function (newVal, oldVal) {
                if (oldVal === newVal) {
                    return;
                }

                self.filters.searchFromCurrentNode = angular.copy(self.filterValue);
            });

            self.parent = {};

            $scope.$watch('filterAssetNodeSearch.filters', function (newVal, oldVal) {
                if (!newVal.searchFromCurrentNode && (newVal.q || newVal.isLocation || newVal.businessAssetTypeId)) {
                    parentId = angular.copy(newVal.parentId) || parentId;
                    self.filters.parentId = null;
                } else if (!newVal.parentId && newVal.searchFromCurrentNode) {
                    self.filters.parentId = angular.copy(parentId);
                }

                if (newVal.parentId && (newVal.parentId !== oldVal.parentId)) {
                    var newInt = parseInt(newVal.parentId, 10);
                    self.showToggles = typeof newInt === 'number' && isFinite(newInt);
                    if (self.showToggles) {
                        DudeApi.BusinessAssetEntity.get({ id: newVal.parentId }).$promise.then(function (result) {
                            self.parent = result;
                        });
                    }
                }
            }, true);
        };
    });

/**
 * @ngdoc directive
 * @name workOrderFilters.filter-asset-category
 * @restrict E
 * @description
 *
 * The Asset Category Filter
 *
 * @param {any} filter The item to filter on
 * @param {boolean} isOpen Sets whether or not the accordion is open (optional)
 * @param {boolean} slidingPanelDisplay Sets whether or not the display should be inline
 * @param {boolean} isDisabled Determines whether or not to disable the radio buttons and labels (Optional)
 *
 */

'use strict';

angular.module('workOrderFilters')
    .component('filterAssetCategory', {
        templateUrl: 'app/components/filterAssetCategory/filterAssetCategory.html',
        require: {
            filterPanelController: '^filterPanel'
        },
        bindings: {
            filter: '=',
            isOpen: '=?',
            slidingPanelDisplay: '=?',
            isDisabled: '=?'
        },
        controller: 'FilterAssetCategoryController',
        controllerAs: 'filterAssetCategory'
    })
    .controller('FilterAssetCategoryController', function ($scope) {
        var self = this;
        self.values = {
            all: 'all',
            location: true,
            equipment: false
        };

        self.showBadge = function () {
            if (self.radioValue === self.values.all) {
                return '';
            }
            return '1';
        };

        self.$onInit = function () {
            self.radioValue = angular.copy(self.filter) || 'all';

            self.isOpen = self.isOpen || self.filterPanelController.openOnLoad(self.filter);
            // received nonassign error if attempted to null coalesce slidingPanelDisplay
            if (!angular.isDefined(self.slidingPanelDisplay)) {
                self.slidingPanelDisplay = true;
            }

            $scope.$watch('filterAssetCategory.radioValue', function () {
                if (self.radioValue === self.values.all) {
                    self.filter = null;
                } else {
                    self.filter = angular.copy(self.radioValue);
                }
            });

            $scope.$watch('filterAssetCategory.filter', function (newVal, oldVal) {
                if (newVal === oldVal) {
                    return;
                }

                if (newVal === undefined || newVal === null) {
                    self.radioValue = self.values.all;
                }
            });
        };
    });

/**
 * @ngdoc service
 * @name filterBar.savedFiltersService
 * @requires $location
 * @requires $translate
 * @requires DudeApi
 * @requires dudeGuid
 * @requires userContext
 *
 * @description
 * Service for supporting the setting and retrieving of saved filters
 *
 */

'use strict';

angular.module('filterBar')
    .factory('savedFiltersService', function ($location, $translate, DudeApi, dudeGuid, userContext) {
        var buildPrefix = function (path) {
            var prefixPath = path || $location.path();
            var pathArray = prefixPath.split('/');
            if (pathArray.length > 1) {
                pathArray.pop();
            }
            return 'MM-Filter' + pathArray.join('-');
        };

        var buildKey = function (id) {
            return buildPrefix() + '-' + id;
        };

        var sanitizeDateRanges = function (filters) {
            var dateTypes = [
                {
                    to: 'requestDateTo',
                    from: 'requestDateFrom',
                    range: 'requestDateRange'
                },
                {
                    to: 'completionDateTo',
                    from: 'completionDateFrom',
                    range: 'completionDateRange'
                },
                {
                    to: 'dateTo',
                    from: 'dateFrom',
                    range: 'dateRange'
                }
            ];

            return dateTypes.reduce(function (pv, cv) {
                if (pv[cv.range] && pv[cv.range].toLowerCase() !== 'custom') {
                    delete pv[cv.to];
                    delete pv[cv.from];
                }
                return pv;
            }, filters);
        };

        /**
         * @ngdoc method
         * @name getSavedFilters
         * @methodOf filterBar.savedFiltersService
         *
         * @description
         * Gets a user's saved filters from the User Settings Entity
         *
         * @param {string} path The path to build the saved filters key prefix (optional)
         * @returns {Promise} A promise that returns with all of the data returned in the page wrapper format
         */
        var getSavedFilters = function (path) {
            return DudeApi.UserSettingsEntity.query({
                userId: userContext.user.id,
                prefix: buildPrefix(path)
            }).$promise.then(function (result) {
                return result.data;
            });
        };

        /**
         * @ngdoc method
         * @name getFilterIfExistsForUser
         * @methodOf filterBar.savedFiltersService
         *
         * @description
         * Retrieves the saved filter if it exists for the current user
         *
         * @param {string} id The filter id for the saved filter
         * @param {object} myFilters a user's saved filters
         * @returns {object} The saved filter if it exists for the user
         */
        var getFilterIfExistsForUser = function (id, myFilters) {
            var savedFilter = null;
            myFilters.forEach(function (item) {
                if (item.value && item.value.query && item.value.query.filterId === id) {
                    savedFilter = item.value;
                }
            });
            return savedFilter;
        };

        var saveUserSetting = function (key, value, isNew) {
            var defaultSetting = {
                key: key,
                value: value || {}
            };
            return isNew ? DudeApi.UserSettingsEntity.save({ userId: userContext.user.id }, defaultSetting).$promise : DudeApi.UserSettingsEntity.update({ settingKey: key, userId: userContext.user.id }, defaultSetting).$promise;
        };

        /**
         * @ngdoc method
         * @name setSavedFilter
         * @methodOf filterBar.savedFiltersService
         *
         * @description
         * Sets a user's saved filter via the User Settings Entity
         *
         * @param {string} name the name of the saved filter specified by the user
         * @param {object} filters stores the value of all defined filters
         * @returns {Promise} A promise that returns with the saved filter user setting
         */
        var setSavedFilter = function (name, filters) {
            var isCreate = (!filters.filterId);
            var query = angular.copy(filters);

            if (isCreate) {
                query.filterId = dudeGuid.generate();
            }

            var key = buildKey(query.filterId);
            var value = {
                name: name,
                query: sanitizeDateRanges(query)
            };

            return saveUserSetting(key, value, isCreate)
                .catch(function () {
                    if (isCreate) {
                        saveUserSetting(key, value, false);
                    }
                });
        };

        /**
         * @ngdoc method
         * @name deleteSavedFilter
         * @methodOf filterBar.savedFiltersService
         *
         * @description
         * Deletes a user's saved filter via the User Settings Entity
         *
         * @returns {Promise} A promise that returns an empty object
         */
        var deleteSavedFilter = function () {
            return DudeApi.UserSettingsEntity.delete({
                userId: userContext.user.id,
                settingKey: buildKey($location.search().filterId)
            }).$promise;
        };

        return {
            getSavedFilters: getSavedFilters,
            getFilterIfExistsForUser: getFilterIfExistsForUser,
            setSavedFilter: setSavedFilter,
            deleteSavedFilter: deleteSavedFilter
        };
    });

/**
 * @ngdoc service
 * @name filterBar.filterStateService
 *
 * @description
 * Service for storing the state of applied saved filter, my filters, ignore for badges, and total count
 */

'use strict';

angular.module('filterBar')
    .factory('filterStateService', function () {
        /**
         * @ngdoc property
         * @name state
         * @propertyOf filterBar.filterStateService
         *
         * @description
         * Stores the state of applied saved filter, my filters, ignore for badges, and total count
         */
        var state = {};

        var findSavedFilterIndex = function (id) {
            var savedFilterIndex = -1;
            state.myFilters.some(function (item, index) {
                if (item.value.query.filterId === id) {
                    savedFilterIndex = index;
                    return true;
                }
                return false;
            });
            return savedFilterIndex;
        };

        /**
         * @ngdoc method
         * @name setState
         * @methodOf filterBar.filterStateService
         *
         * @description
         * Updates the state for page load
         *
         * @param {object} data Initial values for filter states coming from the route
         * @param {array} ignoreForBadge List of filters which should not count towards total badge count
         */
        var setState = function (data, ignoreForBadge) {
            state.activeSavedFilter = data.activeSavedFilter;
            state.myFilters = data.myFilters;
            if (data.initResponse) {
                state.totalCount = data.initResponse.total || 0;
            }
            state.ignoreForBadge = ignoreForBadge;
        };

        /**
         * @ngdoc method
         * @name setFilters
         * @methodOf filterBar.filterStateService
         *
         * @description
         * Updates the state of activeSavedFilter and myFilters during an apply
         *
         * @param {object} value The object containing the current filter being applied
         * @param {boolean} save Whether or not the current filter is being saved
         */
        var setFilters = function (value, save) {
            state.activeSavedFilter = value.query.filterId ? value : null;
            if (save) {
                var savedFilterIndex = findSavedFilterIndex(value.query.filterId);
                if (savedFilterIndex > -1) {
                    state.myFilters[savedFilterIndex] = { value: value };
                } else {
                    state.myFilters.push({ value: value });
                }
            }
        };

        /**
         * @ngdoc method
         * @name clearFilters
         * @methodOf filterBar.filterStateService
         *
         * @description
         * Updates the state of activeSavedFilter and myFilters during a clear
         *
         * @param {boolean} removeMyFilter Whether or not the current filter is being deleted
         */
        var clearFilters = function (removeMyFilter) {
            if (removeMyFilter) {
                var savedFilterIndex = findSavedFilterIndex(state.activeSavedFilter.query.filterId);
                if (savedFilterIndex > -1) {
                    state.myFilters.splice(savedFilterIndex, 1);
                }
            }
            state.activeSavedFilter = null;
        };

        return {
            clearFilters: clearFilters,
            setState: setState,
            setFilters: setFilters,
            state: state
        };
    });

/**
 * @ngdoc directive
 * @name filterBar.filter-bar
 * @restrict E
 * @description
 *
 * Displays a horizontal element which contains filter options both adhoc and saved
 *
 * @param {string} name of the filter-bar element (optional)
 * @param {string} title of the filter-bar element - doesn't manifest visually (optional)
 * @param {function} clearFunction function reference to handle the clear action
 * @param {function} toggleFilters function reference to handle the display of filter options
 * @param {Object} filters the filters
 * @param {function} setFunction function reference to set the filters (optional)
 * @param {boolean} disableMyFilters Disables the ability to save custom filters (optional)
 **/

'use strict';

angular.module('filterBar')
    .component('filterBar', {
        templateUrl: 'app/components/filter-bar/filter-bar.html',
        bindings: {
            name: '@?',
            title: '@?',
            clearFunction: '&',
            toggleFilters: '&',
            filters: '<',
            setFunction: '&?',
            disableMyFilters: '<?'
        },
        transclude: true,
        controller: 'filterBarController',
        controllerAs: 'filterBar'
    })
    .controller('filterBarController', function (filterStateService) {
        var self = this;
        self.$onInit = function () {
            self.filterState = filterStateService.state;
        };
    });

'use strict';

angular.module('filterBar')
    .filter('badges', function () {
        return function (filters, ignoreForBadge) {
            var tempFilters = angular.copy(filters);
            var ignore = ignoreForBadge || [];

            // Do not count parentId as an applied filter because searchFromCurrentNode overrides
            if (!tempFilters.searchFromCurrentNode) {
                delete tempFilters.parentId;
            }
            // Do not count dateRange with value of 'all' as applied filter
            if (tempFilters.dateRange === 'all') {
                delete tempFilters.dateRange;
            }
            // Do not count status with value of 'all' as applied filter
            if (tempFilters.status && (tempFilters.status === 'all' || tempFilters.status[0] === 'all')) {
                delete tempFilters.status;
            }

            return Object.keys(tempFilters).filter(function (key) {
                return ignore.indexOf(key) < 0;
            }).reduce(function (pv, key) {
                if (angular.isArray(tempFilters[key]) && tempFilters[key].length > 0) {
                    return pv + tempFilters[key].length;
                } else if (!angular.isArray(tempFilters[key]) && tempFilters[key]) {
                    return pv + 1;
                }
                return pv;
            }, 0);
        };
    });

'use strict';

angular.module('failureReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report']);

'use strict';

angular.module('failureReport')
    .controller('FailureReportListController', function ($scope, $state, filterStateService, initData, reportFiltersService, failureReportService, queryHelpers, orderByHelpers) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var pageChanging = false;

        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.listData = initData.initResponse.data;
        self.filters = initData.filters;

        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'isLocation', 'filterId', 'requestDateRange', 'completionDateRange'];

        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        var setData = function (response) {
            self.listData = response.data;
            self.filterState.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            failureReportService.loadAssets(self.filters).then(function (purposes) {
                failureReportService.getListData(self.filters, purposes).then(setData);
            });

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.failureReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters(
                {
                    orderBy: self.filters.orderBy,
                    assetRollUp: self.filters.includeDescendants
                });
            filterStateService.clearFilters(removeMyFilter);
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.status = cloned.status === 'all' ? [] : cloned.status;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, reportFiltersService.getFilters({}));
        };

        self.getFailures = function (failureReport) {
            failureReport.failureToggle = !failureReport.failureToggle;

            if (failureReport.failureToggle) {
                failureReportService.getAssetFailures(self.filters, failureReport.asset.id).then(function (result) {
                    failureReport.failureSummary = result.data;
                });
            }
        };

        self.routeToWorkOrders = function (failure, asset) {
            var filterCopy = angular.copy(self.filters);
            delete filterCopy.orderBy;
            filterCopy.includeDescendants = angular.copy(filterCopy.assetRollUp);
            delete filterCopy.assetRollUp;
            filterCopy.failureReason = failure;
            filterCopy.businessAsset = asset;
            $state.go('secure.workOrderList', filterCopy);
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.chartRoute = function () {
            $state.go('secure.report.failureChart', self.filters);
        };

        self.export = function () {
            failureReportService.exportFailureReport(self.filters);
        };

        $scope.$watch('failureReport.filters', updateFilters, true);
    });

'use strict';

angular.module('failureReport')
    .controller('FailureReportChartController', function ($log, $scope, $state, $translate, clientHelperService, failureReportService, filterStateService, initData, popBoxService, queryHelpers, reportFiltersService, responsiveBreakpoints) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var emptyData = {
            dataArray: [['', ''], ['', { v: 0 }]]
        };
        var primaryFiltersCopy = {};

        self.screenSize = clientHelperService.getCurrentScreenSize();

        self.DRILLDOWN_POPBOX = 'asset-drill-down-chart';

        self.filters = initData.filters;

        self.assetLabels = {
            title: $translate.instant('failureReports.failuresBy'),
            yAxis: $translate.instant('failureReports.numberOf')
        };

        self.failureLabels = {
            title: $translate.instant('failureReports.title'),
            yAxis: $translate.instant('failureReports.numberOf')
        };

        self.assetChartData = angular.copy(emptyData);
        self.failureReasonChartData = angular.copy(emptyData);

        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'isLocation', 'filterId', 'requestDateRange', 'completionDateRange'];

        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'includeDescendants', 'assetRollUp'];
            if (reportFiltersService.compareFilters(self.filters, primaryFiltersCopy, filtersToCheck)) {
                return;
            }
            primaryFiltersCopy = angular.copy(self.filters);
            self.assetLabels.title = $translate.instant('failureReports.failuresBy');

            failureReportService.loadAssets(primaryFiltersCopy).then(function (purposes) {
                self.assetChartData = failureReportService.workOrderChartData(primaryFiltersCopy, purposes, self.assetLabels);
            });

            queryHelpers.updateState(primaryFiltersCopy, queryDefaults);
            popBoxService.close(self.DRILLDOWN_POPBOX);
        };

        self.failureReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters(
                {
                    orderBy: self.filters.orderBy,
                    assetRollUp: self.filters.includeDescendants
                });
            filterStateService.clearFilters(removeMyFilter);
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.status = cloned.status === 'all' ? [] : cloned.status;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, reportFiltersService.getFilters({}));
        };

        var convertAssetRollUp = function (filter) {
            filter.includeDescendants = angular.copy(filter.assetRollUp);
            delete filter.assetRollUp;
        };

        var desktopFailureReasonChartFunction = function (filterCopy) {
            failureReportService.loadAssets(filterCopy).then(function (assets) {
                self.failureReasonChartData = failureReportService.failureReasonChartData(filterCopy, assets[0], self.failureLabels, self.activeAsset);
            });

            $log.log('Open drill down pop-box');
            popBoxService.open(self.DRILLDOWN_POPBOX);
        };

        self.clickFunctionObject = {
            chartFunction: function (id) {
                $log.log('Asset Failure bar clicked');
                var filterCopy = angular.copy(self.filters);
                delete filterCopy.orderBy;
                filterCopy.businessAsset = [id];

                var index = self.assetChartData.idArray.indexOf(id);

                self.activeAsset = {
                    name: self.assetChartData.dataArray[index + 1][0] + ' ' + $translate.instant('failureReports.failureReasons'),
                    id: id,
                    value: self.assetChartData.dataArray[index + 1][1].v,
                    failures: [],
                    filters: angular.copy(filterCopy)
                };

                convertAssetRollUp(self.activeAsset.filters);

                if (!id) {
                    popBoxService.close(self.DRILLDOWN_POPBOX);
                    return;
                }

                if (self.screenSize.breakpoint > responsiveBreakpoints.xs) {
                    desktopFailureReasonChartFunction(filterCopy);
                } else {
                    failureReportService.getAssetFailures(filterCopy, id).then(function (results) {
                        self.activeAsset.failures = results.data.map(function (summary) {
                            return summary.failureReason.id;
                        });
                        self.routeToWorkOrders(self.activeAsset.id);
                    });
                }
            }
        };

        self.clearSelection = function () {
            self.assetChartData.clearSelection = true;
            self.failureReasonChartData = angular.copy(emptyData);
            self.activeAsset = {};
        };

        self.routeToWorkOrders = function (asset) {
            var filtersCopy = angular.copy(self.filters);
            delete filtersCopy.orderBy;
            convertAssetRollUp(filtersCopy);
            filtersCopy.businessAsset = asset;
            filtersCopy.failureReason = self.activeAsset.failures;

            $state.go('secure.workOrderList', filtersCopy);
        };

        self.subChartClickObject = {
            chartFunction: function (id) {
                var filtersCopy = angular.copy(self.filters);
                delete filtersCopy.orderBy;
                convertAssetRollUp(filtersCopy);
                filtersCopy.businessAsset = self.activeAsset.id;
                filtersCopy.failureReason = id;

                $state.go('secure.workOrderList', filtersCopy);
            }
        };

        self.listRoute = function () {
            $state.go('secure.report.failureList', self.filters);
        };

        $scope.$watch('failureReport.filters', updateFilters, true);
    });

/**
 * @ngdoc service
 * @name failureReport.failureReportService
 * @requires $q - {@link https://docs.angularjs.org/api/ng/service/$q read the docs}
 * @requires $filter - {@link https://docs.angularjs.org/api/ng/service/$filter read the docs}
 * @requires $translate - {@link https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate read the docs}
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires report.reportFiltersService
 * @requires report.reportTooltipService
 * @requires report.reportDataService
 *
 * @description
 * Service for supporting the failure report
 *
 */

'use strict';

angular.module('failureReport')
    .service('failureReportService', function ($q, $filter, $translate, DudeApi, reportFiltersService, reportTooltipService, reportDataService) {
        var CHART_ITEMS_TO_SHOW = 5;

        /**
         * @ngdoc method
         * @name loadAssets
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Returns a promise containing the business assets
         *
         * @param {object} filter An object containing the filter to use
         * @returns {promise} Promise containing the list of business assets
         */
        var loadAssets = function (filter) {
            if (filter.businessAsset && filter.businessAsset.length) {
                var promises = filter.businessAsset.map(function (assetId) {
                    return DudeApi.BusinessAssetEntity.get({ id: assetId }).$promise;
                });

                return $q.all(promises);
            }

            var deferred = $q.defer();

            deferred.resolve([]);
            return deferred.promise;
        };

        var getData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.FailuresSummaryEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name getAssetFailures
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Gets data and parses it into a format to be used with google charts
         *
         * @param {object} filters An object containing the filter to use
         * @param {number} assetId The business asset expected to drill into
         * @returns {Promise} An promise containing the asset failures summary
         */
        var getAssetFailures = function (filters, assetId) {
            var copy = angular.copy(filters);
            copy.orderBy = 'Count desc,FailureReason/Name asc';
            copy.id = assetId;
            return DudeApi.AssetFailuresSummaryEntity.query(copy).$promise;
        };

        /**
         * @ngdoc method
         * @name getListData
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Returns an object containing paged asset report data.  It adds missing assets that are passed in via an array
         *
         * @param {object} query An object containing the filter to use
         * @param {array} assets An array of expected assets
         * @returns {object} Returns a page wrapper containing a list of failure report data
         */
        var getListData = function (query, assets) {
            if (!query.orderBy || !(query.orderBy.indexOf('Asset/') === 0 || query.orderBy.indexOf('Self/') === 0)) {
                query.orderBy = query.assetRollUp === 'true' ? 'Totals/Failures desc' : 'Self/Failures desc';
                query.orderBy += ',Asset/Value asc';
            }

            return getData(query).then(function (pagedAssets) {
                assets.forEach(function (asset) {
                    var matched = pagedAssets.data.some(function (value) {
                        return value.asset.id === asset.id;
                    });

                    if (matched) {
                        return;
                    }

                    pagedAssets.count++;
                    pagedAssets.data.push({
                        asset: {
                            value: asset.name,
                            id: asset.id,
                            ancestorIdPath: asset.ancestorIdPath,
                            ancestorNamePath: asset.ancestorNamePath
                        },
                        self: {
                            failures: 0
                        },
                        descendants: {
                            failures: 0
                        },
                        totals: {
                            failures: 0
                        }
                    });
                });

                if (query.assetRollUp === 'true') {
                    pagedAssets.data.forEach(function (asset) {
                        if (!asset.totals) {
                            return;
                        }
                        asset.self.failures = asset.totals.failures;
                    });
                }
                return pagedAssets;
            });
        };

        var fetchStandardChartData = function (filter, assets, endPoint, textPlural, textSingular, labels) {
            filter.orderBy += ',Asset/Value asc';
            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = assets.length || CHART_ITEMS_TO_SHOW;

            var dataObject = {
                idArray: [],
                hierarchyArray: [],
                dataArray: [[$translate.instant('purposeReports.purposes'), '', {
                    type: 'string',
                    role: 'tooltip',
                    p: { html: true }
                }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                var idHash = {};
                results.data.forEach(function (summary) {
                    var value = summary.self[endPoint];
                    if (filter.assetRollUp === 'true') {
                        value = summary.totals[endPoint];
                    }
                    var text = value === 1 ? textSingular : textPlural;
                    if (value > 0) {
                        dataObject.dataArray.push([
                            summary.asset.value,
                            { v: value, f: $filter('number')(value) + ' ' + text },
                            reportTooltipService.standardTooltip(summary.asset, $filter('number')(value) + ' ' + text)
                        ]);
                        dataObject.hierarchyArray.push(summary.asset.ancestorNamePath);
                        dataObject.idArray.push(summary.asset.id);
                        idHash[summary.asset.id] = true;
                    }
                });

                reportDataService.topLabel(assets, results, dataObject, labels, 5);

                assets.forEach(function (asset) {
                    if (idHash[asset.id]) {
                        return;
                    }

                    dataObject.dataArray.push([
                        asset.name,
                        { v: 0, f: '0' + textPlural },
                        ''
                    ]);
                    dataObject.idArray.push(asset.id);
                });
                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name workOrderChartData
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Gets data and parses it into a format to be used with google charts
         *
         * @param {object} filter An object containing the filter to use
         * @param {array} assets The business assets expected to show up
         * @param {object} labels An object containing the labels to use with the chart
         * @returns {object} An object containing all that is needed to show the work order chart
         */
        var workOrderChartData = function (filter, assets, labels) {
            filter.orderBy = filter.assetRollUp === 'true' ? 'Totals/Failures desc' : 'Self/Failures desc';

            return fetchStandardChartData(filter, assets, 'failures', $translate.instant('failureReports.failures'), $translate.instant('failureReports.failure'), labels);
        };

        /**
         * @ngdoc method
         * @name getWorkOrderFilters
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Parses an object of filters used on the report into a filters object to use with the work order list
         *
         * @param {number} id The business asset id to view on the work order list
         * @param {object} filters An object containing the filters to use
         * @returns {object} An object containing the filters to use on the work order list
         */
        var getWorkOrderFilters = function (id, filters) {
            var filtersCopy = angular.copy(filters);
            delete filtersCopy.orderBy;
            delete filtersCopy.page;
            delete filtersCopy.pageSize;
            filtersCopy.includeDescendants = filtersCopy.assetRollUp;
            delete filtersCopy.assetRollUp;
            filtersCopy.businessAsset = id;
            return filtersCopy;
        };

        /**
         * @ngdoc method
         * @name failureReasonChartData
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Gets data and parses it into a format to be used with google charts
         *
         * @param {object} filters An object containing the filters to use
         * @param {object} asset The business asset to drill into
         * @param {object} labels An object containing the labels to use with the chart
         * @param {object} activeAsset The asset object for the selected asset
         * @returns {object} An object containing all that is needed to show the failure reason chart
         */
        var failureReasonChartData = function (filters, asset, labels, activeAsset) {
            var copy = angular.copy(filters);
            delete copy.businessAsset;
            copy.orderBy = 'Count desc,FailureReason/Name asc';
            copy.id = asset.id;

            var dataObject = {
                idArray: [],
                dataArray: [['', '', {
                    type: 'string',
                    role: 'tooltip',
                    p: { html: true }
                }]],
                resolved: false
            };

            DudeApi.AssetFailuresSummaryEntity.query(copy).$promise.then(function (result) {
                result.data.forEach(function (summary) {
                    var value = summary.count;
                    var text = value === 1 ? $translate.instant('reports.byWorkOrders.workOrder') : $translate.instant('reports.byWorkOrders.workOrders');
                    if (value > 0) {
                        dataObject.dataArray.push([
                            summary.failureReason.name,
                            { v: value, f: $filter('number')(value) + ' ' + text },
                            reportTooltipService.standardTooltip(summary.failureReason, $filter('number')(value) + ' ' + text)
                        ]);
                        dataObject.idArray.push(summary.failureReason.id);
                    }
                });
                activeAsset.failures = dataObject.idArray;
                activeAsset.filters.failureReason = dataObject.idArray;
                reportDataService.topLabel([asset], result, dataObject, labels, 5);

                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name exportFailureReport
         * @methodOf failureReport.failureReportService
         *
         * @description
         * Downloads a spreadsheet of the asset report list
         *
         * @param {object} query An object containing the filter to use
         */
        var exportFailureReport = function (query) {
            var filters = reportFiltersService.toApiFilter(angular.copy(query));
            reportDataService.exportReport(filters, 'failuresbyasset');
        };

        return {
            loadAssets: loadAssets,
            getListData: getListData,
            workOrderChartData: workOrderChartData,
            getWorkOrderFilters: getWorkOrderFilters,
            failureReasonChartData: failureReasonChartData,
            getAssetFailures: getAssetFailures,
            exportFailureReport: exportFailureReport
        };
    });

'use strict';

angular.module('failureReport')
    .config(function ($stateProvider, permission, moment, workOrderEnums, dateHelperProvider, market) {
        var routeParams = 'status&purpose&requestDateTo&requestDateFrom&requestDateRange&completionDateTo&completionDateFrom&completionDateRange&dateRange&businessAsset&includeDescendants&assetRollUp&failureReason&orderBy&filterId';
        var defaults = {
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete, workOrderEnums.status.onHold],
            toDate: dateHelperProvider.getEndOfDay(new Date()).toISOString(),
            // The default from date is 7 days in the past so we subtract 7 days worth of milliseconds from now to get the correct date
            fromDate: dateHelperProvider.getStartOfDay(moment().subtract(7, 'days')).toISOString()
        };

        var getActiveSavedFilter = function ($stateParams, myFilters, savedFiltersService) {
            var queryParams = $stateParams;
            if (queryParams.filterId) {
                return savedFiltersService.getFilterIfExistsForUser(queryParams.filterId, myFilters);
            }
            return null;
        };

        var getQueryParams = function ($location, $stateParams, activeSavedFilter, marketizr) {
            var defaultCopy = angular.copy(defaults);
            var queryParams = $stateParams;
            queryParams.assetRollUp = queryParams.includeDescendants || queryParams.assetRollUp || null;
            queryParams.includeDescendants = null;
            if (!queryParams.requestDateTo && !queryParams.requestDateFrom && !queryParams.completionDateFrom && !queryParams.completionDateTo && !queryParams.dateRange) {
                queryParams.requestDateTo = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.toDate : dateHelperProvider.getEndOfDay(moment().subtract(1, 'month').endOf('month')).toISOString();
                queryParams.requestDateFrom = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.fromDate : dateHelperProvider.getStartOfDay(moment().subtract(1, 'month').startOf('month')).toISOString();
            }
            if (!queryParams.filterId) {
                queryParams.status = queryParams.status || defaultCopy.status;
            }
            // If requesting a saved filter created for a different page or by a different user, remove the filter id
            if (queryParams.filterId && !activeSavedFilter) {
                delete queryParams.filterId;
                $location.search('filterId', null);
            }
            return queryParams;
        };

        $stateProvider
            .state('secure.report.failureList', {
                url: 'failure/list?page&pageSize&' + routeParams,
                templateUrl: 'app/components/failureReport/failureReportList.html',
                controller: 'FailureReportListController',
                controllerAs: 'failureReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/failure/list');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $q, $stateParams, activeSavedFilter, marketizr, myFilters, failureReportService, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        if (!queryParams.orderBy || !(queryParams.orderBy.indexOf('Asset/') === 0 || queryParams.orderBy.indexOf('Self/') === 0)) {
                            queryParams.orderBy = queryParams.assetRollUp === 'true' ? 'Totals/Failures desc' : 'Self/Failures desc';
                            queryParams.orderBy += ',Asset/Value asc';
                        }
                        var filters = reportFiltersService.toApiFilter(queryParams);

                        return $q.all({
                            initResponse: failureReportService.loadAssets(filters).then(function (purposes) {
                                return failureReportService.getListData(filters, purposes);
                            }),
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        });
                    }
                }
            })
            .state('secure.report.failureChart', {
                url: 'failure/chart?' + routeParams,
                templateUrl: 'app/components/failureReport/failureReportChart.html',
                controller: 'FailureReportChartController',
                controllerAs: 'failureReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                markets: [market.mfg, market.club, market.other, market.gov],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/failure/chart');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $stateParams, activeSavedFilter, marketizr, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        var filters = reportFiltersService.getFilters(queryParams);

                        return {
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        };
                    }
                }
            });
    });

'use strict';

angular.module('equipmentReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report', 'assetReport']);

'use strict';

angular.module('equipmentReport')
    .config(function ($stateProvider, permission, moment, workOrderEnums, dateHelperProvider) {
        var routeParams = 'status&workType&purpose&requestDateTo&requestDateFrom&requestDateRange&completionDateTo&completionDateFrom&completionDateRange&dateRange&businessAsset&includeDescendants&assetRollUp&orderBy&filterId';
        var defaults = {
            status: [workOrderEnums.status.newRequest, workOrderEnums.status.workInProgress, workOrderEnums.status.complete, workOrderEnums.status.onHold],
            toDate: dateHelperProvider.getEndOfDay(new Date()).toISOString(),
            // The default from date is 7 days in the past so we subtract 7 days worth of milliseconds from now to get the correct date
            fromDate: dateHelperProvider.getStartOfDay(moment().subtract(7, 'days')).toISOString()
        };
        var getActiveSavedFilter = function ($stateParams, myFilters, savedFiltersService) {
            var queryParams = $stateParams;

            if (queryParams.filterId) {
                return savedFiltersService.getFilterIfExistsForUser(queryParams.filterId, myFilters);
            }
            return null;
        };

        var getQueryParams = function ($location, $stateParams, activeSavedFilter, marketizr, market) {
            var defaultCopy = angular.copy(defaults);
            var queryParams = $stateParams;
            queryParams.includeDescendants = null;
            queryParams.isLocation = false;
            if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                queryParams.assetRollUp = 'true';
            } else {
                queryParams.assetRollUp = queryParams.includeDescendants || queryParams.assetRollUp || null;
            }
            if (!queryParams.requestDateTo && !queryParams.requestDateFrom && !queryParams.completionDateFrom && !queryParams.completionDateTo && !queryParams.dateRange) {
                queryParams.requestDateTo = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.toDate : dateHelperProvider.getEndOfDay(moment().subtract(1, 'month').endOf('month')).toISOString();
                queryParams.requestDateFrom = marketizr.hasMarkets([market.mfg, market.club, market.other, market.gov]) ? defaultCopy.fromDate : dateHelperProvider.getStartOfDay(moment().subtract(1, 'month').startOf('month')).toISOString();
            }
            if (!queryParams.filterId) {
                queryParams.status = queryParams.status || defaultCopy.status;
            }
            // If requesting a saved filter created for a different page or by a different user, remove the filter id
            if (queryParams.filterId && !activeSavedFilter) {
                delete queryParams.filterId;
                $location.search('filterId', null);
            }
            return queryParams;
        };

        $stateProvider
            .state('secure.report.equipmentList', {
                url: 'equipment/list?page&pageSize&' + routeParams,
                templateUrl: 'app/components/equipmentReport/equipmentList.html',
                controller: 'EquipmentReportListController',
                controllerAs: 'equipmentReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/equipment/list');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $q, $stateParams, activeSavedFilter, assetReportService, market, marketizr, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        var filters = reportFiltersService.toApiFilter(queryParams);

                        return $q.all({
                            initResponse: assetReportService.loadAssets(filters).then(function (assets) {
                                return assetReportService.getListData(filters, assets);
                            }),
                            filters: filters,
                            totals: assetReportService.getTotalData(filters),
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        });
                    }
                }
            })
            .state('secure.report.equipmentChart', {
                url: 'equipment/chart?' + routeParams,
                templateUrl: 'app/components/equipmentReport/equipmentChart.html',
                controller: 'EquipmentReportChartController',
                controllerAs: 'equipmentReport',
                permissions: [permission.businessAssets.create, permission.businessAssets.update, permission.businessAssets.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/equipment/chart');
                    },
                    activeSavedFilter: getActiveSavedFilter,
                    initData: function ($location, $stateParams, activeSavedFilter, market, marketizr, myFilters, reportFiltersService) {
                        var queryParams = getQueryParams($location, $stateParams, activeSavedFilter, marketizr, market);
                        var filters = reportFiltersService.getFilters(queryParams);

                        return {
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        };
                    }
                }
            });
    });

'use strict';

angular.module('equipmentReport')
    .controller('EquipmentReportListController', function ($translate, initData) {
        var self = this;

        self.title = $translate.instant('equipmentReports.title');

        self.initData = angular.copy(initData);
    });

'use strict';

angular.module('equipmentReport')
    .controller('EquipmentReportChartController', function (initData) {
        var self = this;

        self.initData = angular.copy(initData);
    });

'use strict';

angular.module('employeeReport', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate', 'report', 'filterBar']);

'use strict';

angular.module('employeeReport')
    .controller('EmployeeReportListController', function ($scope, $state, filterStateService, initData, market, reportFiltersService, queryHelpers, orderByHelpers, workOrderEnums, employeeReportService) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({}, employeeReportService.getDateIncrements());
        var pageChanging = false;
        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'filterId', 'dateRange'];

        self.sortable = orderByHelpers.initSort(initData.filters.orderBy);
        self.listData = initData.initResponse.data;
        self.filters = initData.filters;
        self.complete = workOrderEnums.status.complete;
        self.market = market;

        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        var openSummaries = [];

        var setData = function (response) {
            self.listData = response.data;
            self.filterState.totalCount = response.total;

            self.listData.forEach(function (employee) {
                if (openSummaries.indexOf(employee.assignee.id) > -1) {
                    self.getDrillDownData(employee);
                }
            });
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            employeeReportService.getData(self.filters).then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        var updateOpenList = function (employee) {
            var employeeIndex = openSummaries.indexOf(employee.assignee.id);
            if (employee.showLabor && employeeIndex === -1) {
                openSummaries.push(employee.assignee.id);
            } else if (!employee.showLabor && employeeIndex > -1) {
                openSummaries.splice(employeeIndex, 1);
            }
        };

        self.getDrillDownData = function (employee) {
            if (employee.laborHours === 0 && employee.completedWorkOrders === 0) {
                return;
            }
            var query = angular.copy(self.filters);
            query.orderBy = 'laborHours desc';
            if (employee.laborTransactions) {
                employee.showLabor = !employee.showLabor;
                updateOpenList(employee);
            } else {
                employeeReportService.getDrillDownData(query, employee.assignee.id).then(function (results) {
                    employee.showLabor = true;
                    employee.laborTransactions = results.data;
                    employee.totalTransactions = results.total;
                    updateOpenList(employee);
                });
            }
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            cloned.status = cloned.status === 'all' ? [] : cloned.status;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, reportFiltersService.getFilters({}, employeeReportService.getDateIncrements()));
        };

        self.employeeReportFilter = function () {
            self.openWhen = true;
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters({
                orderBy: 'laborHours desc',
                assetRollUp: self.filters.assetRollUp
            }, employeeReportService.getDateIncrements());
            filterStateService.clearFilters(removeMyFilter);
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query, employeeReportService.getDateIncrements());
            filterStateService.setFilters(value, save);
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.export = function () {
            employeeReportService.exportEmployeeReport(self.filters);
        };

        $scope.$watch('employeeReport.filters', updateFilters, true);
    });

/**
 * @ngdoc directive
 * @name reportFilters.employee-report-filters
 * @restrict E
 * @description
 *
 * Displays the filter section for the reports
 *
 * @param {object} filters stores the value of all defined filters
 * @param {function} setFunction function reference to set the filters
 * @param {string} assetToggle sets the filter to use with the asset checkbox defaults to include descendants (optional)
 * @param {boolean} openWhen Determines when sliding panel should open
 * @param {function} clearFunction function reference to handle the clear action
 */

'use strict';

angular.module('employeeReport')
    .component('employeeReportFilters', {
        templateUrl: 'app/components/employeeReport/employeeReportFilters.html',
        bindings: {
            filters: '=',
            setFunction: '&',
            assetToggle: '<?',
            openWhen: '=',
            clearFunction: '&'
        },
        controller: 'EmployeeReportFiltersController',
        controllerAs: 'employeeReportFilter'
    })
    .controller('EmployeeReportFiltersController', function ($scope, $translate, employeeReportService, marketizr, market, roles) {
        var self = this;

        self.dateFilterTitle = $translate.instant('employeeReports.filters.dateRange');
        self.market = market;
        self.assigneeTitle = $translate.instant('employeeReports.filters.assignee');
        self.assigneeRoles = [roles.admin, roles.technician];

        self.dateRanges = employeeReportService.getDateIncrements();

        self.assetBrowseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                }
            }
        };

        self.$onInit = function () {
            var isEdu = marketizr.hasMarkets([market.k12, market.he, market.ips]);
            var assetToggle = self.assetToggle || (isEdu ? 'assetRollUp' : 'includeDescendants');

            // This is setting the correct query parameter name for the report.
            self.checkbox = {
                state: self.filters[assetToggle]
            };

            if (marketizr.hasMarkets([market.k12, market.he, market.ips])) {
                self.assetBrowseOptions.filterPanel['asset-category'] = {
                    filter: 'isLocation'
                };
                self.assetHideCheckBox = true;
                self.filters.assetRollUp = 'true';
            }

            $scope.$watch('employeeReportFilter.checkbox.state', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    self.filters[assetToggle] = newVal;
                }
            });
        };
    });

/**
 * @ngdoc service
 * @name employeeReport.employeeReportService
 * @requires $filter - {@link https://docs.angularjs.org/api/ng/service/$filter read the docs}
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires report.reportFiltersService
 * @requires report.reportDataService
 *
 * @description
 * Service for supporting the gathering and parsing of data for the Work Type Report
 *
 */
'use strict';

angular.module('employeeReport')
    .service('employeeReportService', function ($filter, $translate, DudeApi, moment, reportFiltersService, reportDataService, userContext) {
        /**
         * @ngdoc method
         * @name getDateIncrements
         * @methodOf employeeReport.employeeReportService
         *
         * @description
         * Provides Employee reports custom date increments
         *
         * @returns {array} Array containing the date increments
         */
        var getDateIncrements = function () {
            var currentYear = moment().year();
            var lastMonth = moment().subtract(1, 'months');
            var lastWeek = moment().subtract(1, 'week');
            var yesterday = moment().subtract(1, 'day');
            var fiscalStartDate = moment(userContext.account.fiscalStartDate).year(currentYear).startOf('day');
            var fiscalEndDate = moment(fiscalStartDate).add(1, 'year').subtract(1, 'day').endOf('day');

            if (moment().isBefore(fiscalStartDate, 'day')) {
                fiscalStartDate = moment(fiscalStartDate).subtract(1, 'year').startOf('day');
                fiscalEndDate = moment(fiscalEndDate).subtract(1, 'year').endOf('day');
            }

            return [
                {
                    text: $translate.instant('employeeReports.filters.dates.today'),
                    startDate: new Date(moment().startOf('day')),
                    endDate: new Date(moment().endOf('day'))
                },
                {
                    text: $translate.instant('employeeReports.filters.dates.yesterday'),
                    startDate: new Date(yesterday.startOf('day')),
                    endDate: new Date(yesterday.endOf('day'))
                },
                {
                    text: $translate.instant('employeeReports.filters.dates.thisWeek'),
                    startDate: new Date(moment().startOf('week').startOf('day')),
                    endDate: new Date(moment().endOf('week').endOf('day'))
                },
                {
                    text: $translate.instant('employeeReports.filters.dates.lastWeek'),
                    startDate: new Date(moment(lastWeek).startOf('week').startOf('day')),
                    endDate: new Date(moment(lastWeek).endOf('week').endOf('day'))
                },
                {
                    text: $translate.instant('employeeReports.filters.dates.thisMonth'),
                    startDate: new Date(moment().startOf('month').startOf('day')),
                    endDate: new Date(moment().endOf('month').endOf('day'))
                },
                {
                    text: $translate.instant('employeeReports.filters.dates.lastMonth'),
                    startDate: new Date(moment(lastMonth).startOf('month').startOf('day')),
                    endDate: new Date(moment(lastMonth).endOf('month').endOf('day'))
                },
                {
                    text: $translate.instant('employeeReports.filters.dates.fiscalYear'),
                    startDate: new Date(fiscalStartDate),
                    endDate: new Date(fiscalEndDate)
                }
            ];
        };

        /**
         * @ngdoc method
         * @name getData
         * @methodOf employeeReport.employeeReportService
         *
         * @description
         * Gets the data for the list view of employee productivity
         *
         * @param {object} query An object containing the filters to query with
         *
         * @returns {promise} Promise containing the summary list of employees
         */
        var getData = function (query) {
            var filters = reportFiltersService.toApiFilter(query, getDateIncrements());

            return DudeApi.EmployeeSummaryEntity.query(filters).$promise;
        };

        var getDrillDownData = function (query, id) {
            var filters = reportFiltersService.toApiFilter(query, getDateIncrements());
            filters.id = id;
            filters.pageSize = 1000;
            return DudeApi.EmployeeLaborSummaryEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name exportEmployeeReport
         * @methodOf employeeReport.employeeReportService
         *
         * @description
         * Exports a csv of employees
         *
         * @param {object} query An object containing the filters to query with
         */
        var exportEmployeeReport = function (query) {
            var filters = reportFiltersService.toApiFilter(query, getDateIncrements());
            reportDataService.exportReport(filters, 'employeeproductivity');
        };

        return {
            getData: getData,
            getDateIncrements: getDateIncrements,
            getDrillDownData: getDrillDownData,
            exportEmployeeReport: exportEmployeeReport
        };
    });

'use strict';

angular.module('employeeReport')
    .config(function ($stateProvider, permission, dateHelperProvider, moment) {
        var defaults = {
            toDate: dateHelperProvider.getEndOfDay(moment().endOf('week')).toISOString(),
            // The default from date is 7 days in the past so we subtract 7 days worth of milliseconds from now to get the correct date
            fromDate: dateHelperProvider.getStartOfDay(moment().startOf('week')).toISOString()
        };

        $stateProvider
            .state('secure.report.employeeList', {
                url: 'employee/list?page&pageSize&purpose&dateTo&dateFrom&dateRange&businessAsset&includeDescendants&assetRollUp&workType&assignees&orderBy&filterId',
                templateUrl: 'app/components/employeeReport/employeeReportList.html',
                controller: 'EmployeeReportListController',
                controllerAs: 'employeeReport',
                permissions: [permission.purposes.create, permission.purposes.update, permission.purposes.delete],
                resolve: {
                    myFilters: function (savedFiltersService) {
                        return savedFiltersService.getSavedFilters('/report/employee/list');
                    },
                    activeSavedFilter: function ($stateParams, myFilters, savedFiltersService) {
                        var queryParams = $stateParams;
                        if (queryParams.filterId) {
                            return savedFiltersService.getFilterIfExistsForUser(queryParams.filterId, myFilters);
                        }
                        return null;
                    },
                    initData: function ($location, $q, $stateParams, activeSavedFilter, employeeReportService, reportFiltersService, myFilters) {
                        var queryParams = $stateParams;

                        if (!queryParams.orderBy || (queryParams.orderBy && queryParams.orderBy.indexOf('laborHours') !== 0 && queryParams.orderBy.indexOf('completedWorkOrders') !== 0)) {
                            queryParams.orderBy = 'laborHours desc';
                        }

                        if (!queryParams.dateTo && !queryParams.dateFrom) {
                            queryParams.dateTo = defaults.toDate;
                            queryParams.dateFrom = defaults.fromDate;
                        }

                        // If requesting a saved filter and current user is not the owner, remove the filter id
                        if (queryParams.filterId && !activeSavedFilter) {
                            delete queryParams.filterId;
                            $location.search('filterId', null);
                        }

                        var filters = reportFiltersService.toApiFilter(queryParams, employeeReportService.getDateIncrements());

                        return $q.all({
                            initResponse: employeeReportService.getData(filters),
                            filters: filters,
                            myFilters: myFilters,
                            activeSavedFilter: activeSavedFilter
                        });
                    }
                }
            });
    });

'use strict';

angular.module('departmentList', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'helpers', 'translate']);

/**
 * @ngdoc service
 * @name departmentList.departmentListFilterService
 * @requires DudeApi
 *
 * @description
 * Service for filtering the department list
 *
 */

'use strict';

angular.module('departmentList')
  .factory('departmentListFilterService', function ($location, pagingHelpers) {
      /**
       * @ngdoc method
       * @name getFilters
       * @methodOf departmentList.departmentListFilterService
       *
       * @description
       * Gets the filter object for departments
       *
       * @param {object} params The params to convert into the filters object
       * @returns {object} The filter object to use
       */
      var getFilters = function (params) {
          var currentFilter = {
              page: params.page || pagingHelpers.defaults.page,
              pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
              orderBy: params.orderBy || 'Name asc',
              q: params.q || null
          };

          return currentFilter;
      };

      /**
       * @ngdoc method
       * @name toApiFilter
       * @methodOf departmentList.departmentListFilterService
       *
       * @description
       * Gets the filter object for departments
       *
       * @param {object} currentFilter The currentFilter to convert into the filters object
       * @returns {object} The filter object to use
       */
      var toApiFilter = function (currentFilter) {
          return getFilters(currentFilter);
      };

      return {
          getFilters: getFilters,
          toApiFilter: toApiFilter
      };
  });

/**
 * @ngdoc service
 * @name departmentList.departmentListService
 * @requires DudeApi
 *
 * @description
 * Service for supporting the department list
 *
 */

'use strict';

angular.module('departmentList')
    .service('departmentListService', function (DudeApi) {
        /**
         * @ngdoc method
         * @name getListData
         * @methodOf departmentList.departmentListService
         *
         * @description
         * Queries the department entity for a list of departments
         *
         * @param {object} query The filters object used to query the department entity with
         * @returns {Promise} A promise that resolves to the paged wrapper of departments
         */
        var getListData = function (query) {
            return DudeApi.DepartmentEntity.query(query);
        };

        return {
            getListData: getListData
        };
    });

'use strict';

angular.module('departmentList')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.departmentList', {
                url: 'departments?page&pageSize&q&orderBy',
                templateUrl: 'app/components/departmentList/departmentList.html',
                controller: 'DepartmentListController',
                controllerAs: 'departmentList',
                feature: 'departments',
                permissions: [permission.departments.create, permission.departments.update, permission.departments.delete],
                resolve: {
                    initData: function ($q, $stateParams, departmentListService, departmentListFilterService) {
                        var queryParams = $stateParams;
                        var filters = departmentListFilterService.getFilters(queryParams);
                        return $q.all({
                            initResponse: departmentListService.getListData(filters).$promise,
                            filters: filters
                        });
                    }
                }
            });
    });

'use strict';

angular.module('departmentList')
    .controller('DepartmentListController', function ($scope, $state, queryHelpers, departmentListService, departmentListFilterService, initData) {
        var self = this;
        var queryDefaults = departmentListFilterService.getFilters({});
        var pageChanging = false;

        // view model
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;
        self.filters = initData.filters;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;

            departmentListService.getListData(self.filters).$promise.then(setData);

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.clearFilters = function () {
            self.filters = departmentListFilterService.getFilters({});
        };

        $scope.$watch('departmentList.filters', updateFilters, true);
    });

'use strict';

angular.module('departmentForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog']);

'use strict';

angular.module('departmentForm')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.departmentCreate', {
                url: 'departments/new',
                templateUrl: 'app/components/departmentForm/departmentForm.html',
                controller: 'DepartmentFormController',
                controllerAs: 'departmentForm',
                feature: 'departments',
                permissions: permission.departments.create,
                resolve: {
                    department: function (DudeApi) {
                        return new DudeApi.DepartmentEntity({ isActive: true });
                    }
                }
            })
            .state('secure.departmentEdit', {
                url: 'departments/:id',
                templateUrl: 'app/components/departmentForm/departmentForm.html',
                controller: 'DepartmentFormController',
                controllerAs: 'departmentForm',
                feature: 'departments',
                permissions: permission.departments.update,
                resolve: {
                    department: function ($stateParams, DudeApi) {
                        return DudeApi.DepartmentEntity.get({ id: $stateParams.id }).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('departmentForm')
    .controller('DepartmentFormController', function ($state, log, $translate, department) {
        var self = this;

        self.department = department;

        self.saveDepartment = function () {
            var promise = department.id ? department.$update({ id: department.id }) : department.$save();

            promise.then(function () {
                log.notify({
                    title: $translate.instant('departmentForm.notify.success.title'),
                    type: 'success',
                    message: $translate.instant('departmentForm.notify.success.message')
                });

                $state.go('secure.departmentList');
            });
        };
    });


/**
 * @ngdoc service
 * @name dashboard.dashboardService
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires moment - {@link http://momentjs.com/docs/ read the docs}
 * @requires dateHelper
 *
 * @description
 * Service for supporting and working with technician and admin dashboards
 *
 */

'use strict';

angular.module('dashboard')
    .service('dashboardService', function (DudeApi, dateHelper, moment) {
        var filter = {
            orderBy: 'WorkOrders desc'
        };
        var todaysDate = new Date();

        /**
         * @ngdoc method
         * @name getAssigneesSummary
         * @methodOf dashboard.dashboardService
         *
         * @description
         * Queries DudeApi to get a summary of assignees from the report - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/reportSummaryApi.AssigneesSummaryEntity read the docs}
         *
         * @returns {Promise} A promise that returns the paged result from the api
         */
        var getAssigneesSummary = function () {
            return DudeApi.AssigneesSummaryEntity.query(filter);
        };

        /**
         * @ngdoc method
         * @name last30Days
         * @methodOf dashboard.dashboardService
         *
         * @description
         * Calculates a date 30 days ago and today's date for use in filters
         *
         * @returns {Object} An object containing a startDate and endDate
         *
         */
        var last30Days = function () {
            var start = new Date();
            start.setDate(start.getDate() - 30);

            return {
                startDate: dateHelper.getStartOfDay(start),
                endDate: dateHelper.getEndOfDay(todaysDate)
            };
        };

        /**
         * @ngdoc method
         * @name getOnTimeRatio
         * @methodOf dashboard.dashboardService
         *
         * @description
         * Queries DudeApi to get all time ratio values of work orders from the report api - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dashboardApi.OnTimeRatioEntity read the docs}
         *
         * @returns {Promise} A promise that returns the paged result from the api
         *
         */
        var getOnTimeRatio = function () {
            var query = last30Days();

            return DudeApi.OnTimeRatioEntity.query(query);
        };

        /**
         * @ngdoc method
         * @name getSevenDaysFromNow
         * @methodOf dashboard.dashboardService
         *
         * @description
         * Calculates a date 7 days from today's date for use in filters
         *
         * @returns {string} Returns a date that is one week from today's date.
         *
         */
        var getSevenDaysFromNow = function () {
            var currentDate = new Date();
            currentDate.setHours(23, 59, 59, 999);
            return moment(currentDate).add(7, 'day').toISOString();
        };

        return {
            getAssigneesSummary: getAssigneesSummary,
            last30Days: last30Days,
            getOnTimeRatio: getOnTimeRatio,
            getSevenDaysFromNow: getSevenDaysFromNow
        };
    });

'use strict';

angular.module('dashboard')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.dashboard', {
                url: 'dashboard',
                templateUrl: 'app/components/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'dashboard'
            });
    });

'use strict';

angular.module('dashboard')
    .controller('DashboardController', function ($rootScope, $state, $translate, roleHelpers, marketizr, market) {
        var self = this;

        self.isTechnician = roleHelpers.isTechnician();
        self.isRequester = roleHelpers.isRequester();
        self.market = market;

        if ((!marketizr.hasMarkets([market.k12, market.he, market.ips]) && self.isTechnician) || self.isRequester) {
            $rootScope.$broadcast('dudeError:403');
        }
    });

/**
 * @ngdoc object
 * @name maintenanceConstants.workOrderEnums
 *
 * @description
 * Constant for maintenance enum references for work orders
 *
 */

'use strict';

angular.module('maintenanceConstants', [])
    .constant('workOrderEnums', {
        status: {
            newRequest: 'NewRequest',
            workInProgress: 'WorkInProgress',
            complete: 'Complete',
            void: 'Void',
            onHold: 'OnHold'
        },
        priority: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            emergency: 'Emergency'
        },
        assignees: {
            unassigned: 'unassigned'
        }
    });

'use strict';

angular.module('changePassword', ['ui.router', 'dudeAuth', 'dudeControls', 'dudeApi', 'translate', 'dudeLog']);

'use strict';

angular.module('changePassword')
    .directive('passwordLengthValidator', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                var PASSWORD_LENGTH = 8;

                ctrl.$validators.validLength = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        // consider empty control valid
                        return true;
                    }

                    if (viewValue.length >= PASSWORD_LENGTH) {
                        return true;
                    }

                    return false;
                };
            }
        };
    });

'use strict';

angular.module('changePassword')
  .directive('passwordValidator', function () {
      return {
          require: 'ngModel',
          link: function (scope, elm, attrs, ctrl) {
        // checks for mixed case, or at least one special character, or at least one number
              var PASSWORD_FORMAT = /(?=.*[a-z])(?=.*[A-Z])|(_|[^\w])|\d/;

              ctrl.$validators.validPassword = function (modelValue, viewValue) {
                  if (ctrl.$isEmpty(modelValue)) {
            // consider empty control valid
                      return true;
                  }

                  if (PASSWORD_FORMAT.test(viewValue)) {
                      return true;
                  }

                  return false;
              };
          }
      };
  });

'use strict';

angular.module('changePassword')
    .directive('matchPasswordValidator', function () {
        return {
            scope: {
                match: '=matchPasswordValidator'
            },
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.matchPassword = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        // consider empty control valid
                        return true;
                    }

                    if (viewValue === scope.match || scope.match === '') {
                        return true;
                    }

                    return false;
                };
            }
        };
    });

'use strict';

angular.module('changePassword')
  .config(function ($stateProvider) {
      $stateProvider
      .state('secure.changePassword', {
          url: 'profile/changePassword',
          templateUrl: 'app/components/changePassword/changePassword.html',
          controller: 'changePasswordController',
          controllerAs: 'changePassword'
      });
  });

'use strict';

angular.module('changePassword')
    .controller('changePasswordController', function ($state, $scope, $translate, DudeApi, log) {
        var self = this;

        self.passwords = {
            oldPassword: '',
            newPassword: '',
            reenterPassword: ''
        };
        var badPasswords = [];
        self.changePassword = function () {
            DudeApi.ChangePasswordEntity.save(self.passwords).$promise
                .then(function () {
                    log.notify({
                        title: $translate.instant('changePassword.toast.success.title'),
                        type: 'success',
                        message: $translate.instant('changePassword.toast.success.body')
                    });
                    $state.go('secure.userMe');
                }, function (response) {
                    var isOldPassword = true;
                    for (var i = 0; i < response.data.validationErrors.length; i++) {
                        if (response.data.validationErrors[i].field === 'oldPassword' && response.data.validationErrors[i].code === 'V1042') {
                            // if validation message == V1005 then email already exists
                            badPasswords.push(self.passwords.oldPassword);
                            isOldPassword = false;
                            break;
                        }
                    }

                    $scope.form.currentPassword.$setValidity('matchesOld', isOldPassword);
                });
        };

        $scope.$watch('changePassword.passwords.oldPassword', function (newVal, oldVal) {
            if (newVal === oldVal || !badPasswords.length) {
                return;
            }

            var validity = badPasswords.indexOf(newVal) < 0;
            $scope.form.currentPassword.$setValidity('matchesOld', validity);
        });
    });

/**
 * @ngdoc service
 * @name dashboard.assetWorkTypeReportService
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires pagingHelpers {@link http://frontend.dudesoln.com/ng-docs/DudeControls/#/api/filterHelpers.pagingHelpersService read the docs}
 *
 * @description
 * Service for getting work type reports from the Report API.
 *
 */

'use strict';

angular.module('dashboard')
    .service('assetWorkTypeReportService', function (DudeApi, pagingHelpers) {
        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf dashboard.assetWorkTypeReportService
         *
         * @description
         * Returns a filter object parsed and formatted
         *
         * @param {object} params An object containing the filter params to use
         * @returns {object} Filter object
         */
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: parseInt(params.pageSize, 10) || parseInt(pagingHelpers.defaults.pageSize, 10),
                orderBy: params.orderBy || null,
                assignees: params.assignees || null,
                status: params.status || null
            };

            return currentFilter;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf dashboard.assetWorkTypeReportService
         *
         * @description
         * Converts a filter object to a useable state by the api
         *
         * @param {object} currentFilter An object containing the filter params to use
         * @returns {object} Filter object
         */
        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        /**
         * @ngdoc method
         * @name getData
         * @methodOf dashboard.assetWorkTypeReportService
         *
         * @description
         * Returns work type based on the query passed in.
         *
         * @param {object} query query An object containing the query to pass to the API.
         * @returns {object} The results from the API as an object.
         */
        var getData = function (query, assetId) {
            var filters = toApiFilter(query);
            filters.id = assetId;

            return DudeApi.AssetWorkTypesSummaryEntity.query(filters).$promise;
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            getData: getData
        };
    });

'use strict';

angular.module('assetTypeList', ['ui.router', 'dudeControls', 'dudeApi', 'marketizr', 'translate']);

'use strict';

angular.module('assetTypeList')
    .factory('assetTypeListFilterService', function ($location, pagingHelpers) {
        var getFilters = function (params) {
            // if Adding a new search filter make sure to add it to the
            // isSearching() function below.
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Name asc',
                q: params.q || null,
                isActive: params.isActive || null
            };

            return currentFilter;
        };

        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        // Checks to see if you are in search mode.
        var isSearching = function (filters) {
            return (filters.q !== null && filters.q !== '') || (filters.isActive !== null && filters.isActive !== '');
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            isSearching: isSearching
        };
    });

'use strict';

angular.module('assetTypeList')
    .service('assetTypeListService', function (DudeApi, assetTypeListFilterService) {
        var getListData = function (query) {
            var filters = assetTypeListFilterService.toApiFilter(query);
            return DudeApi.BusinessAssetTypeEntity.query(filters);
        };

        var get = function (id) {
            return DudeApi.BusinessAssetTypeEntity.get({ id: id });
        };

        return {
            getListData: getListData,
            get: get
        };
    });

'use strict';

angular.module('assetTypeList')
  .config(function ($stateProvider, permission) {
      $stateProvider
      .state('secure.assetTypeList', {
          url: 'assettypes?page&pageSize&q&isActive',
          templateUrl: 'app/components/assetTypeList/assetTypeList.html',
          controller: 'assetTypeListController',
          controllerAs: 'assetTypeList',
          permissions: permission.businessAssetTypes.create,
          resolve: {
              initData: function ($q, $stateParams, assetTypeListService, assetTypeListFilterService) {
                  var queryParams = $stateParams;
                  var filters = assetTypeListFilterService.getFilters(queryParams);

                  return $q.all({
                      initResponse: assetTypeListService.getListData(filters).$promise,
                      filters: filters
                  });
              }
          }
      });
  });

'use strict';

angular.module('assetTypeList')
    .controller('assetTypeListController', function ($rootScope, $scope, $location, $state, assetTypeListService, assetTypeListFilterService, queryHelpers, orderByHelpers, initData) {
        var self = this;
        var queryDefaults = assetTypeListFilterService.getFilters({});
        var pageChanging = false;

        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(self.filters.orderBy);
        self.totalCount = initData.initResponse.total;
        self.listData = initData.initResponse.data;

        var setData = function (response) {
            self.listData = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (angular.equals(oldVal, newVal)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                newVal.page = 1;
            }

            pageChanging = false;

            assetTypeListService.getListData(newVal).$promise.then(setData);
            queryHelpers.updateState(newVal, queryDefaults);
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            // Reset a cleared search to null not empty string
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, assetTypeListFilterService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.showSearchResults = function () {
            // List out possible filters and if one is set then we show search
            return assetTypeListFilterService.isSearching(self.filters);
        };

        self.clearFilters = function () {
            self.filters = assetTypeListFilterService.getFilters({});
        };

        self.editAssetType = function (id) {
            $state.go('secure.assetTypeEdit', {
                id: id
            });
        };

        $scope.$watch('assetTypeList.filters', updateFilters, true);
    });

'use strict';

angular.module('assetTypeForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog']);

'use strict';

angular.module('assetTypeForm')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.assetTypeCreate', {
                url: 'assettypes/new',
                templateUrl: 'app/components/assetTypeForm/assetTypeForm.html',
                controller: 'AssetTypeFormController',
                controllerAs: 'assetTypeForm',
                permissions: permission.businessAssetTypes.create,
                resolve: {
                    assetType: function (DudeApi) {
                        var queryParams = { q: 'Area' };
                        return DudeApi.BusinessAssetCategoryEntity.query(queryParams).$promise.then(function (response) {
                            var assetCategory = null;
                            if (response.data.length > 0 && response.data[0].name === queryParams.q) {
                                assetCategory = response.data[0];
                            }
                            return new DudeApi.BusinessAssetTypeEntity({
                                isActive: true,
                                businessAssetCategories: [assetCategory]
                            });
                        });
                    },
                    assetCount: function () {
                        return 0;
                    },
                    assetCategories: function (DudeApi) {
                        var queryParams = {
                            orderby: 'DisplayOrder asc'
                        };
                        return DudeApi.BusinessAssetCategoryEntity.query(queryParams).$promise.then(function (response) {
                            return response.data;
                        });
                    }
                }
            })
            .state('secure.assetTypeEdit', {
                url: 'assettypes/:id',
                templateUrl: 'app/components/assetTypeForm/assetTypeForm.html',
                controller: 'AssetTypeFormController',
                controllerAs: 'assetTypeForm',
                permissions: permission.businessAssetTypes.update,
                resolve: {
                    assetType: function ($stateParams, DudeApi) {
                        return DudeApi.BusinessAssetTypeEntity.get({ id: $stateParams.id }).$promise;
                    },
                    assetCount: function ($stateParams, DudeApi, assetTypeDeleteFilterService) {
                        var filter = assetTypeDeleteFilterService.toApiFilter({ id: $stateParams.id });
                        return DudeApi.BusinessAssetEntity.query(filter).$promise;
                    },
                    assetCategories: function (DudeApi) {
                        var queryParams = {
                            orderby: 'DisplayOrder asc'
                        };
                        return DudeApi.BusinessAssetCategoryEntity.query(queryParams).$promise.then(function (response) {
                            return response.data;
                        });
                    }
                }
            });
    });

'use strict';

angular.module('assetTypeForm')
    .controller('AssetTypeFormController', function ($scope, $state, log, $uibModal, $translate, DudeApi, assetType, assetCount, assetCategories) {
        var self = this;
        self.assetType = assetType;
        self.attributeTypes = null;
        self.attributeTypeCache = {};
        self.isNew = !self.assetType.id;
        self.assetCategories = assetCategories;
        self.selectedCategories = {};
        assetType.businessAssetCategories.forEach(function (category) {
            self.selectedCategories[category.id] = true;
        });
        var goToAssetList = function () {
            $state.go('secure.assetTypeList');
        };

        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('assetTypeForm.notify.delete.title'),
                type: 'success',
                message: $translate.instant('assetTypeForm.notify.delete.message')
            });
        };

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/assetTypeForm/assetTypeDeleteConfirmModal.html',
                controller: 'assetTypeDeleteModalController',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    count: function () {
                        return '';
                    }
                }
            });

            modalInstance.result.then(function () {
                assetType.$delete({
                    id: assetType.id
                }).then(function () {
                    showDeleteMessage();
                    $state.go('secure.assetTypeList');
                });
            });
        };

        var deleteWarning = function (count) {
            $uibModal.open({
                templateUrl: 'app/components/assetTypeForm/assetTypeDeleteWarningModal.html',
                controller: 'assetTypeDeleteModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    count: function () {
                        return count;
                    }
                }
            });
        };

        self.saveAssetType = function () {
            var promise = assetType.id ? assetType.$update({
                id: assetType.id
            }) : assetType.$save();

            promise.then(function () {
                log.notify({
                    title: $translate.instant('assetTypeForm.notify.success.title'),
                    type: 'success',
                    message: $translate.instant('assetTypeForm.notify.success.message')
                });

                goToAssetList();
            });
        };

        self.deleteAssetType = function () {
            if (assetCount.total === 0) {
                confirmDelete('');
            } else {
                deleteWarning(assetCount.total);
            }
        };

        $scope.$watch('assetTypeForm.selectedCategories', function () {
            var categories = [];
            $scope.form.categoryCheck.$setValidity('categoryRequired', false);
            Object.keys(self.selectedCategories).forEach(function (categoryId) {
                if (self.selectedCategories[categoryId]) {
                    $scope.form.categoryCheck.$setValidity('categoryRequired', true);
                    categories.push({ id: categoryId });
                }
            });
            assetType.businessAssetCategories = categories;
        }, true);
    });

'use strict';

angular.module('assetTypeForm')
    .controller('assetTypeDeleteModalController', function ($uibModalInstance, $scope, count) {
        $scope.count = count;

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('assetTypeForm')
    .service('assetTypeDeleteFilterService', function () {
        var toApiFilter = function (filter) {
            var filters = {
                businessAssetTypeId: filter.id
            };
            return filters;
        };

        return {
            toApiFilter: toApiFilter
        };
    });

/**
 * @ngdoc directive
 * @restrict E
 * @name assetTypeForm.asset-category-attributes
 * @description
 *
 * The asset category attribute type list
 *
 * @param {object} The asset category for which you would like to retrieve attributes
 *
 * <asset-category-attributes category="{any}""></asset-category-attributes>
 *
 */

'use strict';

angular.module('assetTypeForm')
    .component('assetCategoryAttributes', {
        templateUrl: 'app/components/assetTypeForm/assetCategoryAttributes.html',
        bindings: {
            category: '='
        },
        controller: 'AssetCategoryAttributesController',
        controllerAs: 'assetCategoryAttributes'
    })
    .controller('AssetCategoryAttributesController', function ($translate, DudeApi) {
        var self = this;
        self.$onInit = function () {
            self.attributeTypes = [];

            if (!self.attributeTypes.length) {
                DudeApi.BusinessAssetCategoryAttributeTypeEntity.query({
                    id: self.category.id,
                    orderBy: 'order'
                }).$promise.then(function (response) {
                    // need to translate in controller so that we can alphabetize before rendering
                    response.data.forEach(function (attr) {
                        attr._translatedKey = $translate.instant('assetForm.attributeTypes.' + attr.key);
                    });

                    self.attributeTypes = response.data;
                });
            }
        };
    });

/**
 * @ngdoc directive
 * @name assetReport.assetReportList
 * @restrict E
 * @description
 *
 * Displays the equipment list report or location list report based on the boolean passed in
 *
 * @param {boolean} isLocation The value to determine if it is a location report or equipment report.
 * @param {object} initData An object that contains the inital filters, list data, and totals count.
 * @param {string} reportTitle A string that displays the title of the report, used in the list column.
 *
 */

'use strict';

angular.module('assetReport')
    .component('assetReportList', {
        templateUrl: 'app/components/assetReport/assetReportList.html',
        bindings: {
            isLocation: '<?',
            initData: '<?',
            reportTitle: '<?'
        },
        controller: 'AssetReportListController',
        controllerAs: 'assetReport'
    })
    .controller('AssetReportListController', function ($scope, $state, assetReportService, filterStateService, market, marketizr, orderByHelpers, queryHelpers, reportFiltersService) {
        var self = this;
        var pageChanging = false;
        var filtersCopy;
        var queryDefaults;

        self.viewWorkOrders = function (id) {
            var filters = assetReportService.getWorkOrderFilters(id, self.filters);
            $state.go('secure.workOrderList', filters);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.sort = function (item) {
            if (filtersCopy.assetRollUp === 'true' && item.toLowerCase() !== 'asset/value') {
                item = 'TotalsWithDescendants/' + item;
            }
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.export = function () {
            assetReportService.exportAssetReport(self.filters);
        };

        self.chartRoute = function () {
            if (self.isLocation) {
                $state.go('secure.report.locationsChart', self.filters);
            } else {
                $state.go('secure.report.equipmentChart', self.filters);
            }
        };

        self.isFilterApplied = function () {
            return reportFiltersService.isFilterApplied(self.filters);
        };

        var setData = function (response) {
            self.listData = response.data;
            self.filterState.totalCount = response.total;
        };

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'workType', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'includeDescendants', 'assetRollUp', 'page', 'orderBy'];
            if (reportFiltersService.compareFilters(self.filters, filtersCopy, filtersToCheck)) {
                return;
            }

            // reset page if filter item triggered this
            if (!pageChanging) {
                self.filters.page = 1;
            }

            pageChanging = false;
            filtersCopy = angular.copy(self.filters);
            assetReportService.loadAssets(filtersCopy).then(function (assets) {
                assetReportService.getListData(filtersCopy, assets).then(setData);
            });

            assetReportService.getTotalData(filtersCopy).then(function (totals) {
                self.totalListData = totals;
            });

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.assetReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters(
                {
                    orderBy: self.filters.orderBy,
                    isLocation: self.filters.isLocation,
                    assetRollUp: self.filters.includeDescendants
                });
            filterStateService.clearFilters(removeMyFilter);
        };

        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'isLocation', 'filterId', 'requestDateRange', 'completionDateRange'];

        self.$onInit = function () {
            self.sortable = orderByHelpers.initSort(self.initData.filters.orderBy);
            self.listData = self.initData.initResponse.data;
            self.totalListData = self.initData.totals;
            self.filters = self.initData.filters;
            self.filters.isLocation = self.isLocation;
            self.title = self.reportTitle;
            self.showDrilldown = marketizr.hasMarkets([market.k12, market.he, market.ips]) && self.isLocation;

            filterStateService.setState(self.initData, ignoreForBadge);
            self.filterState = filterStateService.state;

            filtersCopy = angular.copy(self.filters);
            queryDefaults = reportFiltersService.getFilters({});
            queryDefaults.isLocation = self.isLocation;

            $scope.$watch('assetReport.filters', updateFilters, true);
        };
    });

/**
 * @ngdoc directive
 * @name assetReport.assetReportChart
 * @restrict E
 * @description
 *
 * Displays the equipment chart report or location chart report based on the boolean passed in
 *
 * @param {boolean} isLocation The value to determine if it is a location report or equipment report.
 * @param {object} initData An object that contains the initial filters, list data, and totals count.
 */
'use strict';

angular.module('assetReport')
    .component('assetReportChart', {
        templateUrl: 'app/components/assetReport/assetReportChart.html',
        bindings: {
            isLocation: '<?',
            initData: '<?'
        },
        controller: 'AssetReportChartController',
        controllerAs: 'assetReport'
    })
    .controller('AssetReportChartController', function ($scope, $state, $element, $translate, assetReportService, filterStateService, market, marketizr, reportChartPrintService, reportFiltersService, queryHelpers) {
        var self = this;
        var queryDefaults = reportFiltersService.getFilters({});
        var emptyData = {
            dataArray: [['', ''], ['', { v: 0 }]]
        };
        self.drillDownData = {};

        self.market = market;

        var filtersCopy = {};

        self.costLegend = [
            $translate.instant('reports.byCost.purchase'),
            $translate.instant('reports.byCost.service'),
            $translate.instant('reports.byCost.labor')
        ];

        self.workOrderChartData = angular.copy(emptyData);
        self.laborChartData = angular.copy(emptyData);
        self.costChartData = angular.copy([['', '', ''], ['', { v: 0 }, { v: 0 }]]);

        var updateFilters = function () {
            var filtersToCheck = ['purpose', 'status', 'workType', 'requestDateTo', 'requestDateFrom', 'requestDateRange', 'completionDateFrom', 'completionDateTo', 'completionDateRange', 'businessAsset', 'includeDescendants', 'assetRollUp'];
            if (reportFiltersService.compareFilters(self.filters, filtersCopy, filtersToCheck)) {
                return;
            }
            filtersCopy = angular.copy(self.filters);

            assetReportService.loadAssets(self.filters).then(function (assets) {
                self.workOrderChartData = assetReportService.workOrderChartData(filtersCopy, assets, self.workOrderLabels);
                self.laborChartData = assetReportService.laborChartData(filtersCopy, assets, self.laborHoursLabels);
                self.costChartData = assetReportService.costChartData(filtersCopy, assets, self.costLabels);
            });

            queryHelpers.updateState(self.filters, queryDefaults);
        };

        self.assetReportFilter = function () {
            self.openWhen = { value: true };
        };

        self.setFilters = function (value, save) {
            self.filters = reportFiltersService.getFilters(value.query);
            filterStateService.setFilters(value, save);
        };

        self.clearFilters = function (removeMyFilter) {
            self.filters = reportFiltersService.getFilters({ orderBy: self.filters.orderBy, isLocation: self.filters.isLocation, assetRollUp: self.filters.includeDescendants });
            filterStateService.clearFilters(removeMyFilter);
        };

        self.clickFunctionObject = {
            chartFunction: function (id) {
                var filters = assetReportService.getWorkOrderFilters(id, self.filters);
                $state.go('secure.workOrderList', filters);
            }
        };

        self.listRoute = function () {
            if (self.isLocation) {
                $state.go('secure.report.locationsList', self.filters);
            } else {
                $state.go('secure.report.equipmentList', self.filters);
            }
        };

        var determineChart = function (chart) {
            return chart.style.display === 'inline';
        };

        self.printCharts = function () {
            var chartOne = angular.element($element.find('.work-order-chart svg'))[0].parentNode.innerHTML;
            var chartTwo = angular.element($element.find('.cost-chart svg'))[0].parentNode.innerHTML;
            var chartThree = angular.element($element.find('.labor-hours-chart svg'))[0].parentNode.innerHTML;
            var drillDownCharts = {};

            if (!chartOne || !chartTwo || !chartThree) {
                return;
            }

            var chartData = {
                workOrderChartData: self.workOrderChartData,
                laborHoursChartData: self.laborChartData,
                costChartData: self.costChartData
            };

            var costLegend = $element.find('.cost-chart .chart-legend')[0] && angular.element($element.find('.cost-chart .chart-legend'))[0].parentNode.innerHTML;
            costLegend = costLegend || '';
            chartTwo = costLegend + chartTwo;
            var html = [chartOne, chartTwo, chartThree];

            if (self.isLocation) {
                drillDownCharts.workOrder = angular.element($element.find('.work-order-drill-down-chart'))[0];
                drillDownCharts.cost = angular.element($element.find('.pop-box-report-drill-down-chart-cost'))[0].parentNode;
                drillDownCharts.labor = angular.element($element.find('.pop-box-report-drill-down-chart-labor'))[0].parentNode;
                drillDownCharts.workOrder = (drillDownCharts.workOrder !== undefined && determineChart(drillDownCharts.workOrder.parentNode.parentNode.parentNode.parentNode)) ? drillDownCharts.workOrder.innerHTML : '';
                drillDownCharts.cost = determineChart(drillDownCharts.cost) ? drillDownCharts.cost.innerHTML : '';
                drillDownCharts.labor = determineChart(drillDownCharts.labor) ? drillDownCharts.labor.innerHTML : '';
                chartData.drillDownData = self.drillDownData;
                html.push(drillDownCharts);
            }

            var type = self.isLocation ? 'locations' : 'equipment';
            reportChartPrintService.printCharts(html, self.filters, chartData, type);
        };

        self.isFilterApplied = function () {
            return reportFiltersService.isFilterApplied(self.filters);
        };

        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'includeDescendants', 'returnAverages', 'assetRollUp', 'isLocation', 'filterId', 'requestDateRange', 'completionDateRange'];

        self.$onInit = function () {
            self.filters = self.initData.filters;
            self.filters.isLocation = self.isLocation;

            queryDefaults.isLocation = self.isLocation;
            self.showDrilldown = marketizr.hasMarkets([market.k12, market.he, market.ips]) && self.isLocation;

            filterStateService.setState(self.initData, ignoreForBadge);
            self.filterState = filterStateService.state;

            self.workOrderLabels = {
                title: $translate.instant('locationReports.workOrdersBy'),
                yAxis: $translate.instant('reports.byWorkOrders.numberOf')
            };

            self.costLabels = {
                title: $translate.instant('locationReports.costBy'),
                yAxis: $translate.instant('reports.byCost.cost')
            };

            self.laborHoursLabels = {
                title: $translate.instant('locationReports.laborHoursBy'),
                yAxis: $translate.instant('reports.byLaborHours.hours')
            };

            if (!self.isLocation) {
                self.workOrderLabels.title = $translate.instant('equipmentReports.workOrdersBy');
                self.costLabels.title = $translate.instant('equipmentReports.costBy');
                self.laborHoursLabels.title = $translate.instant('equipmentReports.laborHoursBy');
            }

            $scope.$watch('assetReport.filters', updateFilters, true);
        };
    });

/**
 * @ngdoc object
 * @name assetReport.assetReportCategoryConstants
 *
 * @description
 * Constant for asset report categories
 *
 */

'use strict';

angular.module('assetReport')
    .constant('assetReportCategory', {
        workOrder: 'workOrder',
        cost: 'cost',
        labor: 'labor'
    });

/**
 * @ngdoc service
 * @name assetReport.assetReportService
 * @requires $q - {@link https://docs.angularjs.org/api/ng/service/$q read the docs}
 * @requires $filter - {@link https://docs.angularjs.org/api/ng/service/$filter read the docs}
 * @requires $translate - {@link https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translate read the docs}
 * @requires $log - {@link https://docs.angularjs.org/api/ng/service/$log read the docs}
 * @requires DudeApi - {@link http://frontend.dudesoln.com/ng-docs/DudeApi/#/api/dudeApi.DudeApi read the docs}
 * @requires report.reportFiltersService
 * @requires report.reportTooltipService
 * @requires report.reportDataService
 *
 * @description
 * Service for supporting the asset report
 *
 */

'use strict';

angular.module('assetReport')
    .service('assetReportService', function ($q, $filter, $translate, $log, DudeApi, reportFiltersService, reportTooltipService, reportDataService) {
        var CHART_ITEMS_TO_SHOW = 5;

        /**
         * @ngdoc method
         * @name loadAssets
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Returns a promise containing the business assets
         *
         * @param {object} filter An object containing the filter to use
         * @returns {promise} Promise containing the list of business assets
         */
        var loadAssets = function (filter) {
            var deferred = $q.defer();
            var assets = [];
            if (filter.businessAsset && filter.businessAsset.length) {
                filter.businessAsset.forEach(function (assetId) {
                    assets.push(DudeApi.BusinessAssetEntity.get({ id: assetId }).$promise);
                });
                $q.all(assets).then(deferred.resolve, deferred.reject);
            } else {
                deferred.resolve(assets);
            }
            return deferred.promise;
        };

        /**
         * @ngdoc method
         * @name getData
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Returns a promise containing that asset report data
         *
         * @param {object} query An object containing the filter to use
         * @returns {promise} Promise containing the list of business assets
         */
        var getData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.BusinessAssetsSummaryEntity.query(filters).$promise;
        };

        /**
         * @ngdoc method
         * @name getTotalData
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Gets the totals data for the list view of work orders by assets
         *
         * @param {object} query An object containing the filters to query with
         */
        var getTotalData = function (query) {
            var filters = reportFiltersService.toApiFilter(query);
            return DudeApi.BusinessAssetsTotalEntity.query(filters).$promise.then(function (result) {
                if (query.assetRollUp === 'true') {
                    return result.totalsWithDescendants;
                }
                return result.asset;
            });
        };

        /**
         * @ngdoc method
         * @name getListData
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Returns an object containing paged asset report data.  It adds missing assets that are passed in via an array
         *
         * @param {object} query An object containing the filter to use
         * @param {array} assets An array of expected assets
         * @returns {object} Returns a page wrapper containing a list of asset report data
         */
        var getListData = function (query, assets) {
            if (!query.orderBy || query.orderBy.indexOf('Self/') === 0) {
                query.orderBy = query.assetRollUp === 'true' ? 'TotalsWithDescendants/Count/WorkOrders desc' : 'Count/WorkOrders desc';
                query.orderBy += ',Asset/Value asc';
            }

            return getData(query).then(function (pagedAssets) {
                assets.forEach(function (asset) {
                    var matches = $filter('filter')(pagedAssets.data, function (value) {
                        return value.asset.id === asset.id;
                    }).length;
                    if (matches) {
                        return;
                    }

                    pagedAssets.count++;
                    pagedAssets.data.push({
                        asset: {
                            value: asset.name,
                            id: asset.id,
                            ancestorIdPath: asset.ancestorIdPath,
                            ancestorNamePath: asset.ancestorNamePath
                        },
                        count: {
                            workOrders: 0,
                            laborHours: 0
                        },
                        cost: {
                            labor: 0,
                            purchase: 0,
                            service: 0,
                            total: 0
                        },
                        totalsWithDescendants: {
                            count: {
                                workOrders: 0,
                                laborHours: 0
                            },
                            cost: {
                                labor: 0,
                                purchase: 0,
                                service: 0,
                                total: 0
                            }
                        }
                    });
                });
                if (query.assetRollUp === 'true') {
                    pagedAssets.data.forEach(function (asset) {
                        asset.count.workOrders = asset.totalsWithDescendants.count.workOrders;
                        asset.count.laborHours = asset.totalsWithDescendants.count.laborHours;
                        asset.cost.labor = asset.totalsWithDescendants.cost.labor;
                        asset.cost.purchase = asset.totalsWithDescendants.cost.purchase;
                        asset.cost.service = asset.totalsWithDescendants.cost.service;
                        asset.cost.total = asset.totalsWithDescendants.cost.total;
                    });
                }
                return pagedAssets;
            });
        };

        var fetchStandardChartData = function (filter, assets, endPoint, textPlural, textSingular, labels) {
            filter.orderBy += ',Asset/Value asc';
            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = assets.length || CHART_ITEMS_TO_SHOW;

            var dataObject = {
                idArray: [],
                hierarchyArray: [],
                dataArray: [[$translate.instant('purposeReports.purposes'), '', {
                    type: 'string',
                    role: 'tooltip',
                    p: { html: true }
                }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                results.data.forEach(function (summary) {
                    var value = summary.count[endPoint];
                    if (filter.assetRollUp === 'true') {
                        value = summary.totalsWithDescendants.count[endPoint];
                    }
                    var text = value === 1 ? textSingular : textPlural;
                    if (value > 0) {
                        dataObject.dataArray.push([
                            summary.asset.value,
                            { v: value, f: $filter('number')(value) + ' ' + text },
                            reportTooltipService.standardTooltip(summary.asset, $filter('number')(value) + ' ' + text)
                        ]);
                        dataObject.hierarchyArray.push(summary.asset.ancestorNamePath);
                        dataObject.idArray.push(summary.asset.id);
                    }
                });

                reportDataService.topLabel(assets, results, dataObject, labels, 5);

                assets.forEach(function (asset) {
                    if (dataObject.idArray.indexOf(asset.id) > -1 || dataObject.idArray.length >= filter.pageSize) {
                        return;
                    }

                    dataObject.dataArray.push([
                        asset.name,
                        { v: 0, f: '0' + textPlural },
                        ''
                    ]);
                    dataObject.idArray.push(asset.id);
                });
                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name workOrderChartData
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Gets data and parses it into a format to be used with google charts
         *
         * @param {object} filter An object containing the filter to use
         * @param {array} assets The business assets expected to show up
         * @param {object} labels An object containing the labels to use with the chart
         * @returns {object} An object containing all that is needed to show the work order chart
         */
        var workOrderChartData = function (filter, assets, labels) {
            filter.orderBy = filter.assetRollUp === 'true' ? 'TotalsWithDescendants/Count/WorkOrders desc' : 'Count/WorkOrders desc';

            return fetchStandardChartData(filter, assets, 'workOrders', $translate.instant('reports.byWorkOrders.workOrders'), $translate.instant('reports.byWorkOrders.workOrder'), labels);
        };

        /**
         * @ngdoc method
         * @name laborChartData
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Gets data and parses it into a format to be used with google charts
         *
         * @param {object} filter An object containing the filter to use
         * @param {array} assets The business assets expected to show up
         * @param {object} labels An object containing the labels to use with the chart
         * @returns {object} An object containing all that is needed to show the labor hours chart
         */
        var laborChartData = function (filter, assets, labels) {
            filter.orderBy = filter.assetRollUp === 'true' ? 'TotalsWithDescendants/Count/LaborHours desc' : 'Count/LaborHours desc';

            return fetchStandardChartData(filter, assets, 'laborHours', $translate.instant('reports.byLaborHours.hours'), $translate.instant('reports.byLaborHours.hour'), labels);
        };

        /**
         * @ngdoc method
         * @name costChartData
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Gets data and parses it into a format to be used with google charts
         *
         * @param {object} filter An object containing the filter to use
         * @param {array} assets The business assets expected to show up
         * @param {object} labels An object containing the labels to use with the chart
         * @returns {object} An object containing all that is needed to show the cost chart
         */
        var costChartData = function (filter, assets, labels) {
            filter = reportFiltersService.toApiFilter(filter);
            filter.pageSize = assets.length || CHART_ITEMS_TO_SHOW;
            filter.orderBy = filter.assetRollUp === 'true' ? 'TotalsWithDescendants/Cost/Total desc' : 'Cost/Total desc';
            filter.orderBy += ',Asset/Value asc';

            var dataObject = {
                idArray: [],
                dataArray: [[$translate.instant('assetReport.assets'), '', {
                    type: 'string',
                    role: 'tooltip',
                    p: { html: true }
                }, '', { type: 'string', role: 'tooltip', p: { html: true } }, '', { type: 'string', role: 'tooltip', p: { html: true } }]],
                resolved: false
            };

            getData(filter).then(function (results) {
                results.data.forEach(function (summary) {
                    if (!summary.cost) {
                        return;
                    }

                    var root = filter.assetRollUp === 'true' ? angular.copy(summary.totalsWithDescendants) : angular.copy(summary);

                    var laborCost = {
                        value: root.cost.labor,
                        display: $filter('currency')(root.cost.labor) + ' ' + $translate.instant('reports.byCost.labor')
                    };
                    var purchaseCost = {
                        value: root.cost.purchase,
                        display: $filter('currency')(root.cost.purchase) + ' ' + $translate.instant('reports.byCost.purchase')
                    };
                    var serviceCost = {
                        value: root.cost.service,
                        display: $filter('currency')(root.cost.service) + ' ' + $translate.instant('reports.byCost.service')
                    };
                    var totalCost = {
                        value: root.cost.total,
                        display: $filter('currency')(root.cost.total) + ' ' + $translate.instant('reports.byCost.total')
                    };

                    var tooltip = reportTooltipService.costChartTooltip(summary.asset, laborCost.display, purchaseCost.display, serviceCost.display, totalCost.display);

                    if (totalCost.value > 0) {
                        dataObject.dataArray.push([
                            summary.asset.value,
                            { v: purchaseCost.value, f: purchaseCost.display },
                            tooltip,
                            { v: serviceCost.value, f: serviceCost.display },
                            tooltip,
                            { v: laborCost.value, f: laborCost.display },
                            tooltip
                        ]);
                        dataObject.idArray.push(summary.asset.id);
                    }
                });

                reportDataService.topLabel(assets, results, dataObject, labels, 5);

                assets.forEach(function (asset) {
                    if (dataObject.idArray.indexOf(asset.id) > -1 || dataObject.idArray.length >= filter.pageSize) {
                        return;
                    }
                    dataObject.dataArray.push([
                        asset.name,
                        { v: 0, f: '0' + $translate.instant('reports.byLaborHours.hours') },
                        '',
                        { v: 0, f: '0' + $translate.instant('reports.byLaborHours.hours') },
                        ''
                    ]);
                    dataObject.idArray.push(asset.id);
                });

                dataObject.resolved = true;
            });
            return dataObject;
        };

        /**
         * @ngdoc method
         * @name exportAssetReport
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Downloads a spreadsheet of the asset report list
         *
         * @param {object} query An object containing the filter to use
         */
        var exportAssetReport = function (query) {
            var filters = reportFiltersService.toApiFilter(angular.copy(query));
            reportDataService.exportReport(filters, 'workordersbyasset');
        };

        /**
         * @ngdoc method
         * @name getWorkOrderFilters
         * @methodOf assetReport.assetReportService
         *
         * @description
         * Parses an object of filters used on the report into a filters object to use with the work order list
         *
         * @param {number} id The business asset id to view on the work order list
         * @param {object} filters An object containing the filters to use
         * @returns {object} An object containing the filters to use on the work order list
         */
        var getWorkOrderFilters = function (id, filters) {
            var filtersCopy = angular.copy(filters);
            delete filtersCopy.orderBy;
            delete filtersCopy.page;
            delete filtersCopy.pageSize;
            filtersCopy.includeDescendants = filtersCopy.assetRollUp;
            delete filtersCopy.assetRollUp;
            filtersCopy.businessAsset = id;
            return filtersCopy;
        };

        return {
            loadAssets: loadAssets,
            getData: getData,
            getListData: getListData,
            workOrderChartData: workOrderChartData,
            laborChartData: laborChartData,
            costChartData: costChartData,
            getWorkOrderFilters: getWorkOrderFilters,
            exportAssetReport: exportAssetReport,
            getTotalData: getTotalData
        };
    });

'use strict';

angular.module('assetList', ['ui.router', 'dudeControls', 'dudeApi', 'filterBar', 'marketizr', 'translate', 'assetFilters', 'meterReading', 'maintenanceConstants']);

'use strict';

angular.module('assetList')
    .service('assetListService', function (DudeApi, assetFiltersService) {
        var getListData = function (query) {
            var filters = assetFiltersService.toApiFilter(query);
            return DudeApi.BusinessAssetEntity.query(filters);
        };

        var get = function (id) {
            return DudeApi.BusinessAssetEntity.get({ id: id });
        };

        return {
            getListData: getListData,
            get: get
        };
    });

'use strict';

angular.module('assetList')
    .config(function ($stateProvider, permission) {
        $stateProvider
            .state('secure.assetList', {
                url: 'assets?page&pageSize&q&isActive&parentId&businessAssetTypeId&isWorkOrderAsset&isInventoryStorageArea&isLocation&isMetered',
                templateUrl: 'app/components/assetList/assetList.html',
                controller: 'AssetListController',
                controllerAs: 'assetList',
                permissions: [permission.businessAssets.create, permission.businessAssets.update, permission.businessAssets.delete],
                resolve: {
                    initData: function ($q, $stateParams, assetListService, assetFiltersService) {
                        var queryParams = $stateParams;
                        var filters = assetFiltersService.getFilters(queryParams);

                        return $q.all({
                            initResponse: assetListService.getListData(filters).$promise,
                            filters: filters
                        });
                    },
                    products: function (DudeApi, permissionsHelper) {
                        if (permissionsHelper.userAllowed('AccountProducts-Read')) {
                            return DudeApi.AccountProductsEntity.query().$promise;
                        }
                        return { data: [] };
                    }
                }
            });
    });

'use strict';

angular.module('assetList')
    .controller('AssetListController', function ($rootScope, $scope, $location, $state, $translate, assetListService, assetFiltersService, filterStateService, queryHelpers, orderByHelpers, initData, workOrderEnums, roleHelpers, products) {
        var self = this;
        var INVENTORY_MANAGER = 'Inventory Manager';
        var queryDefaults = assetFiltersService.getFilters({});
        var pageChanging = false;
        var assetListParentAsset = {
            id: null,
            isActive: true,
            ancestorIdPath: '',
            ancestorNamePath: ''
        };

        self.parentAsset = assetListParentAsset;
        self.filters = initData.filters;
        self.sortable = orderByHelpers.initSort(self.filters.orderBy);
        self.listData = initData.initResponse.data;
        self.isPmSchedule = initData.isPmSchedule;
        self.workOrderStatuses = Object.keys(workOrderEnums.status).map(function (key) { return workOrderEnums.status[key]; });
        self.isTechnician = roleHelpers.isTechnician();
        self.panelOpen = false;
        self.updated = false;
        self.disableMyFilters = true;

        var ignoreForBadge = ['page', 'pageSize', 'orderBy', 'searchFromCurrentNode', 'includeDescendants'];
        filterStateService.setState(initData, ignoreForBadge);
        self.filterState = filterStateService.state;

        // Check permissions on checkboxes
        self.hasInventory = false;
        products.data.forEach(function (product) {
            if (product.name === INVENTORY_MANAGER) {
                self.hasInventory = true;
            }
        });

        self.openPanel = function (asset) {
            if (!asset) {
                self.panelOpen = false;
            }
            self.asset = asset;
            self.panelOpen = true;
        };

        var setBreadCrumbData = function () {
            if (self.parentId !== undefined && self.parentId !== 'null') {
                assetListService.get(self.parentId).$promise.then(
                    function (response) {
                        var parentAsset = response;
                        if (self.filters.searchFromCurrentNode || !self.isFilterApplied()) {
                            parentAsset.ancestorIdPath += '/' + response.id;
                            parentAsset.ancestorNamePath += '|' + response.name;
                        } else {
                            response.ancestorIdPath = '';
                            response.ancestorNamePath = '';
                        }
                        self.parentAsset = parentAsset;
                    }
                );
            } else {
                self.parentAsset = assetListParentAsset;
            }
        };

        var broadcastAssetTotal = function () {
            $rootScope.$broadcast('dude-maintenance:pmschedule-asset-total', { total: self.totalCount });
        };

        var setData = function (response) {
            self.listData = response.data;
            self.filterState.totalCount = response.total;
            setBreadCrumbData();
            broadcastAssetTotal();
        };

        var updateParentIdQueryParameter = function () {
            var queryString = $location.search();
            self.parentId = queryString.parentId;
        };

        var updateFilters = function (newVal, oldVal) {
            if (angular.equals(oldVal, newVal)) {
                return;
            }
            // reset page if filter item triggered this
            if (!pageChanging) {
                newVal.page = 1;
            }

            pageChanging = false;
            assetListService.getListData(newVal).$promise.then(setData);
            queryHelpers.updateState(newVal, queryDefaults);
            updateParentIdQueryParameter();
        };

        self.isFilterApplied = function () {
            var cloned = angular.copy(self.filters);
            // Reset a cleared search to null not empty string
            cloned.q = cloned.q !== '' ? cloned.q : null;
            cloned.isActive = cloned.isActive !== '' ? cloned.isActive : null;
            // Removed parent since its not part of filters
            cloned.parentId = null;
            // Always set this to true when determining if we are filters since it is an internal state.
            cloned.searchFromCurrentNode = true;
            // ignoring orderBy since we only care about applied filters
            return !angular.equals(cloned, assetFiltersService.getFilters({ orderBy: cloned.orderBy }));
        };

        self.sort = function (item) {
            self.filters.orderBy = orderByHelpers.sort(self.sortable, item);
        };

        self.pageChanged = function () {
            // prevent page from changing on filter reload
            pageChanging = true;
        };

        self.getChild = function (asset) {
            if (asset.hasChildren) {
                self.filters.parentId = asset.id;
                self.filters.q = null;
            }
        };

        self.showAssetRowBreadCrumb = function () {
            return self.isFilterApplied();
        };

        self.assetCreate = function () {
            $state.go('secure.assetCreate', {
                parentId: self.parentId
            });
        };

        self.assetFilter = function () {
            self.openAssetFilterSlidingPanel = true;
        };

        self.clearFilters = function () {
            self.filters = assetFiltersService.getFilters({
                pmSchedule: this.isPmSchedule // This will trigger the isActive filter to be true and to set the is searching flag.
            });
            self.storageAreaParams = {
                isWorkOrderAsset: null,
                isInventoryStorageArea: null
            };
        };

        self.setFilters = function (value) {
            self.filters = assetFiltersService.getFilters(value.query);
        };

        self.edit = function (asset) {
            $state.go('secure.assetEdit', { id: asset.id });
        };

        $scope.$watch('assetList.filters', updateFilters, true);

        // start up
        updateParentIdQueryParameter();
        setBreadCrumbData();
    });

'use strict';

angular.module('assetForm', ['ui.router', 'ui.bootstrap', 'dudeControls', 'dudeControlsFile', 'dudeApi', 'dudeAuth', 'translate', 'dudeLog', 'asset-attribute']);

'use strict';

angular.module('assetForm')
    .service('assetFormService', function ($filter, DudeApi) {
        var setExcludeItems = function (asset, property) {
            var excludeItems = [asset[property]];
            return DudeApi.BusinessAssetEntity.query({
                parentId: asset.id,
                includeDescendants: true
            }).$promise
                .then(function (result) {
                    result.data.forEach(function (child) {
                        excludeItems.push(child[property]);
                    });
                    return excludeItems;
                });
        };

        var attributeSaveHandler = function (assetAttributes, asset) {
            var attributePromises = [];
            for (var i = 0; i < assetAttributes.length; i++) {
                if (assetAttributes[i].businessAssetAttributeType.isMeterable && !assetAttributes[i].isMetered && (!assetAttributes[i].unitOfMeasure || !assetAttributes[i].unitOfMeasure.id)) {
                    continue; // eslint-disable-line no-continue
                } else if (!assetAttributes[i].unitOfMeasure || !assetAttributes[i].unitOfMeasure.id) {
                    continue; // eslint-disable-line no-continue
                }

                var attributePromise = assetAttributes[i].id ? assetAttributes[i].$update({
                    businessAssetId: asset.id,
                    id: assetAttributes[i].id
                })
                    : assetAttributes[i].$save({ businessAssetId: asset.id });
                attributePromises.push(attributePromise);
            }

            return attributePromises;
        };

        var saveAttributes = function (assetAttributes, asset) {
            // post new databound attribute value
            var databoundAttributes = assetAttributes.filter(function (attribute) {
                return attribute.businessAssetAttributeType.valueType === 'Databound';
            });

            if (databoundAttributes[0]) {
                if (databoundAttributes[0].businessAssetAttributeType.key === 'manufacturer' && databoundAttributes[0].value !== null &&
                    databoundAttributes[0].value !== undefined && databoundAttributes[0].value._isNew) {
                    return DudeApi.ManufacturerEntity.save(databoundAttributes[0].value).$promise.then(function (result) {
                        databoundAttributes[0].value = result.id;

                        return attributeSaveHandler(assetAttributes, asset);
                    });
                }
                // set databound object value to id
                databoundAttributes[0].value = !databoundAttributes[0].value ? '' : databoundAttributes[0].value.id;
                return attributeSaveHandler(assetAttributes, asset);
            }
            return attributeSaveHandler(assetAttributes, asset);
        };

        return {
            setExcludeItems: setExcludeItems,
            saveAttributes: saveAttributes
        };
    });

'use strict';

angular.module('assetForm')
    .config(function ($stateProvider, permission) {
        var assetNamePathSeparator = '|';
        var assetIdPathSeparator = '/';
        $stateProvider
            .state('secure.assetCreate', {
                url: 'assets/new?parentId',
                templateUrl: 'app/components/assetForm/assetForm.html',
                controller: 'AssetFormController',
                controllerAs: 'assetForm',
                permissions: permission.businessAssets.create,
                resolve: {
                    asset: function ($stateParams, DudeApi) {
                        var asset = new DudeApi.BusinessAssetEntity({
                            isActive: true,
                            ancestorIdPath: '',
                            ancestorNamePath: '',
                            businessAssetCategory: null,
                            businessAssetType: null,
                            businessAssetAttributes: []
                        });
                        if (angular.isUndefined($stateParams.parentId)) {
                            return asset;
                        }
                        return DudeApi.BusinessAssetEntity.get({ id: $stateParams.parentId }).$promise.then(function (parent) {
                            asset.ancestorIdPath += assetIdPathSeparator + parent.id;
                            asset.ancestorNamePath += assetNamePathSeparator + parent.name;
                            asset.parent = parent;
                            return asset;
                        });
                    },
                    inventory: function ($stateParams, DudeApi, userContext) {
                        if (userContext && userContext.products && userContext.products.InventoryManager) {
                            return {
                                hasInventory: true,
                                totalTransactions: 0
                            };
                        }
                        return {
                            hasInventory: false,
                            totalTransactions: 0
                        };
                    },
                    attachments: function () {
                        return [];
                    }
                }
            })
            .state('secure.assetEdit', {
                url: 'assets/:id',
                templateUrl: 'app/components/assetForm/assetForm.html',
                controller: 'AssetFormController',
                controllerAs: 'assetForm',
                permissions: permission.businessAssets.update,
                resolve: {
                    asset: function ($stateParams, DudeApi) {
                        var asset;
                        return DudeApi.BusinessAssetEntity.get({ id: $stateParams.id }).$promise.then(function (_asset) {
                            asset = _asset;
                            if (asset.parent !== null) {
                                asset.parent.ancestorIdPath = asset.ancestorIdPath.replace(assetIdPathSeparator + asset.parent.id, '');
                                asset.parent.ancestorNamePath = asset.ancestorNamePath.replace(assetNamePathSeparator + asset.parent.name, '');
                            }
                            return DudeApi.BusinessAssetCategoryEntity.query({ id: asset.businessAssetCategory.id }).$promise;
                        }).then(function (assetCategory) {
                            asset.businessAssetCategory = assetCategory;
                            return DudeApi.BusinessAssetCategoryAttributeTypeEntity.query({ id: asset.businessAssetCategory.id }).$promise;
                        }).then(function (categoryAttributes) {
                            asset.businessAssetCategory.businessAssetAttributeTypes = categoryAttributes.data;
                            return DudeApi.BusinessAssetTypeEntity.query({ id: asset.businessAssetType.id }).$promise;
                        }).then(function (assetType) {
                            asset.businessAssetType = assetType;
                            return DudeApi.BusinessAssetAttributeTypeEntity.query({ businessAssetTypeId: asset.businessAssetType.id }).$promise;
                        }).then(function (currentAttributeTypes) {
                            asset.businessAssetType.businessAssetAttributeTypes = currentAttributeTypes.data;
                            return DudeApi.BusinessAssetAttributeEntity.query({ businessAssetId: asset.id }).$promise;
                        }).then(function (assetAttributes) {
                            asset.businessAssetAttributes = assetAttributes.data;
                            return asset;
                        });
                    },
                    inventory: function ($stateParams, $q, DudeApi, userContext) {
                        if (userContext && userContext.products && userContext.products.InventoryManager) {
                            var inventoryItemQueryResults = DudeApi.InventoryItemEntity.query({
                                businessAssetIds: [$stateParams.id],
                                hasQuantityOnHand: true,
                                pageSize: 1
                            }).$promise.then(function (result) {
                                return result.total !== 0;
                            });
                            var inventoryTransactionQueryResults = DudeApi.InventoryTransactionEntity.query({
                                businessAssetIds: [$stateParams.id],
                                includeDescendants: true,
                                pageSize: 1
                            }).$promise.then(function (transactions) {
                                return {
                                    hasInventory: true,
                                    totalTransactions: transactions.total
                                };
                            });
                            var promises = {
                                inventoryItemQueryResults: inventoryItemQueryResults,
                                inventoryTransactionQueryResults: inventoryTransactionQueryResults
                            };

                            return $q.all(promises).then(function (results) {
                                return {
                                    hasQuantity: results.inventoryItemQueryResults,
                                    hasInventory: results.inventoryTransactionQueryResults.hasInventory,
                                    totalTransactions: results.inventoryTransactionQueryResults.totalTransactions
                                };
                            });
                        }
                        return {
                            hasQuantity: false,
                            hasInventory: false,
                            totalTransactions: 0
                        };
                    },
                    attachments: function ($stateParams, DudeApi) {
                        return DudeApi.BusinessAssetAttachmentEntity.query({ businessAssetId: $stateParams.id }).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('assetForm')
    .controller('AssetFormController', function ($q, $scope, $state, $filter, $stateParams, $translate, $uibModal, $timeout, DudeApi, log, permissionsHelper, webLinkSectionService, webLinkObjectTypeIds, assetFormService, asset, inventory, userContext, attachments, fileHelpers, attachmentHelpers) {
        var self = this;
        self.regex = '[^|]*';
        var filesUploadingCount = 0;
        self.asset = asset;
        self.filter = '';
        self.country = userContext.account.location.country;
        var parentId = $stateParams.parentId;
        self.url = $state.current.url;
        self.files = [];
        self.excludeItems = {
            property: 'id',
            items: []
        };
        self.attachments = attachments.data;
        self.isNew = !asset.id;
        self.isAdmin = permissionsHelper.userAllowed('BusinessAssets-Delete');
        self.spies = [];
        var offsetPadding = 50;
        self.headerOffset = angular.element('.main-nav').outerHeight(true) + angular.element('.header-container').outerHeight(true) + offsetPadding;
        self.openAttachmentSection = self.attachments && self.attachments.length > 0;
        self.assetTypeFilter = self.asset.businessAssetCategory ? { businessAssetCategoryId: self.asset.businessAssetCategory.id } : {};

        self.hasQuantity = inventory.hasQuantity;

        // Check permissions on checkboxes
        self.hasInventory = inventory.hasInventory;
        self.hasWorkOrderAssetUpdatePermission = permissionsHelper.userAllowed('WorkOrderAsset-Update');
        self.hasInventoryStorageAreaUpdatePermission = permissionsHelper.userAllowed('InventoryStorage-Update');

        self.assetBrowseOptions = {
            type: 'slidingpanel',
            filterPanel: {
                search: {
                    filter: 'q'
                },
                'asset-node-search': {
                    filters: ''
                },
                'asset-category': {
                    filter: 'isLocation'
                }
            }
        };

        if (self.asset.id) {
            webLinkSectionService.getWebLinks(self.asset.id, webLinkObjectTypeIds.businessAsset).then(function (response) {
                self.links = response.data;
            });
        } else {
            self.links = [];
        }

        // Check for the work order asset checkbox, default as true
        if (self.hasInventory && self.hasWorkOrderAssetUpdatePermission) {
            self.asset.isWorkOrderAsset = self.asset.isWorkOrderAsset != null ? self.asset.isWorkOrderAsset : true;
        } else {
            delete self.asset.isWorkOrderAsset;
        }

        // Check for the inventory storage checkbox, default as false
        if (self.hasInventory && self.hasInventoryStorageAreaUpdatePermission) {
            self.asset.isInventoryStorageArea = self.asset.isInventoryStorageArea != null ? self.asset.isInventoryStorageArea : false;
        } else {
            delete self.asset.isInventoryStorageArea;
        }

        // attachments
        if (!self.isNew) {
            self.files = fileHelpers.populateFiles(self.attachments);
            assetFormService.setExcludeItems(self.asset, 'id').then(function (itemList) {
                self.excludeItems.items = itemList;
            });
        }

        if (angular.isDefined(self.asset) && self.asset.parentId !== null) {
            parentId = self.asset.parentId;
        }

        var removeAttachmentErrors = function () {
            self.files = $filter('filter')(self.files, function (file) {
                return file.id;
            });
        };

        var newBusinessAssetAttachmentHandler = function (id) {
            var promises = [];
            for (var i = 0; i < self.files.length; i++) {
                if (self.files[i].mime) {
                    var attachment = attachmentHelpers.saveAttachmentReference(self.files[i], new DudeApi.BusinessAssetAttachmentEntity());
                    promises.push(attachment.$save({
                        businessAssetId: id
                    }));
                }
            }
        };

        var removeFromList = function (fileIndex) {
            self.files.splice(fileIndex, 1);
        };

        var deleteFile = function (file) {
            // calls file api to remove file but doesn't handle result since user doesn't care if this succeeds or fails
            fileHelpers.deleteFile(file).$promise.then(angular.noop, angular.noop);
        };

        var deleteAttachmentWarning = function (index, file) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/attachments/attachmentDeleteWarningModal.html',
                controller: 'AttachmentDeleteWarningModalController',
                size: 'sm',
                backdrop: 'static'
            });

            modalInstance.result.then(function () {
                var attachment = attachmentHelpers.deleteAttachmentReference(file, self.attachments, new DudeApi.BusinessAssetAttachmentEntity(), 'businessAsset');
                attachment.$delete({
                    businessAssetId: asset.id,
                    id: attachment.businessAssetAttachmentId
                }).then(function () {
                    removeFromList(index);
                    deleteFile(file);
                    log.notify({
                        type: 'success',
                        title: $translate.instant('attachments.notify.deleteAttachment.title'),
                        message: attachment.name + ' ' + $translate.instant('attachments.notify.deleteAttachment.message')
                    });
                });
            });
        };

        var performUploadCheckValidation = function () {
            $scope.form.uploadCheck.$setValidity('uploadInProgress', filesUploadingCount <= 0);
        };

        var addToList = function (file) {
            // if they have set the file, and then cancel on the next one
            // the file comes back as undefined, this check makes sure we
            // do nothing in this case
            if (!angular.isDefined(file)) {
                return null;
            }

            filesUploadingCount++;
            performUploadCheckValidation();
            var object = {
                name: file.name
            };

            self.files.push(object);
            return object;
        };

        var saveUploadedAttachment = function (file) {
            var attachment = attachmentHelpers.saveAttachmentReference(file, new DudeApi.BusinessAssetAttachmentEntity());
            attachment.$save({
                businessAssetId: asset.id
            }).then(function () {
                self.attachments.push(attachment);
                file.saved = true;
                log.notify({
                    type: 'success',
                    title: $translate.instant('attachments.notify.upload.success'),
                    message: file.filename + ' ' + $translate.instant('assetForm.notify.upload.successBody')
                });
            });
        };

        var uploadSuccessHandler = function (file) {
            return function (response) {
                filesUploadingCount--;
                performUploadCheckValidation();
                response.uploading = false;
                var fileToExtend = self.files[self.files.indexOf(file)];
                angular.extend(fileToExtend, response);

                if (!self.isNew) {
                    saveUploadedAttachment(fileToExtend);
                }
            };
        };

        var uploadErrorHandler = function (file) {
            return function (error) {
                filesUploadingCount--;
                performUploadCheckValidation();
                var fileToExtend = self.files[self.files.indexOf(file)];
                angular.extend(fileToExtend, {
                    uploading: false,
                    error: true,
                    errorMessage: fileHelpers.errorMessage(error.data.message)
                });

                log.notify({
                    type: 'error',
                    title: $translate.instant('attachments.notify.upload.error'),
                    message: error.data.message
                });
            };
        };

        self.upload = function () {
            var transformedFile = addToList(self.file);
            var upload = fileHelpers.uploadFile(self.file);
            upload.then(uploadSuccessHandler(transformedFile), uploadErrorHandler(transformedFile));
        };

        self.deleteAttachment = function (index, file) {
            if (self.isNew) {
                removeFromList(index);
                deleteFile(file);
            } else {
                deleteAttachmentWarning(index, file);
            }
        };

        var skipNavigationWarningModal = function () {
            self.skipNavigationWarning = true;
        };

        var showDeleteMessage = function () {
            log.notify({
                title: $translate.instant('assetForm.notify.delete.title'),
                type: 'success',
                message: $translate.instant('assetForm.notify.delete.message')
            });
        };

        var confirmDelete = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/components/assetForm/assetDeleteConfirmModal.html',
                controller: 'assetDeleteModalController',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    count: function () {
                        return self.asset.hasChildren;
                    }
                }
            });

            modalInstance.result.then(function () {
                asset.$delete({
                    id: asset.id
                }).then(function () {
                    showDeleteMessage();
                    $state.go('secure.assetList', {
                        parentId: parentId
                    });
                });
            });
        };

        var deleteWarning = function (count) {
            $uibModal.open({
                templateUrl: 'app/components/assetForm/assetDeleteWarningModal.html',
                controller: 'assetDeleteModalController',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    count: function () {
                        return count;
                    }
                }
            });
        };

        var resetParentId = function (assetToReset) {
            return assetToReset.parent !== null ? assetToReset.parent.id : assetToReset.parent;
        };

        var errorFn = function () {
            log.notify({
                title: $translate.instant('assetForm.notify.failure.title'),
                type: 'error',
                message: $translate.instant('assetForm.notify.failure.message')
            });
        };

        self.saveAsset = function () {
            var _asset = angular.copy(asset);
            var assetAttributes = angular.copy(_asset.businessAssetAttributes);
            // clean up dto.  dynamic attribute engine is done with these properties.
            delete _asset.businessAssetType.businessAssetAttributeTypes;
            var promise = _asset.id ? _asset.$update({
                id: _asset.id
            }) : _asset.$save();

            promise.then(function (savedAsset) {
                skipNavigationWarningModal();
                if (self.isNew) {
                    newBusinessAssetAttachmentHandler(savedAsset.id, new DudeApi.BusinessAssetAttachmentEntity());
                } else {
                    removeAttachmentErrors();
                }

                $q.all(assetFormService.saveAttributes(assetAttributes, _asset))
                    .then(function () {
                        log.notify({
                            title: $translate.instant('assetForm.notify.success.title'),
                            type: 'success',
                            message: $translate.instant('assetForm.notify.success.message')
                        });
                        return resetParentId(savedAsset);
                    }, errorFn)
                    .then(function (savedParentId) {
                        var promises = [];

                        self.links.forEach(function (link) {
                            // Links without IDs haven't been saved.
                            if (!link.id) {
                                link.objectId = savedAsset.id;
                                promises.push(DudeApi.WebLinksEntity.save(link).$promise);
                            }
                        });
                        $q.all(promises).then(function () {
                            $state.go('secure.assetList', {
                                parentId: savedParentId
                            });
                        });
                    });
            });
        };

        self.deleteAsset = function () {
            if (inventory.totalTransactions === 0) {
                confirmDelete('');
            } else {
                deleteWarning(inventory.totalTransactions);
            }
        };

        self.addAttachment = function () {
            $timeout(function () {
                attachmentHelpers.openFileSelector();
            });
        };

        $scope.$watch('assetForm.file', function (newVal, oldVal) {
            if (newVal === oldVal || !newVal) {
                return;
            }
            self.upload();
        });

        $scope.$watch('assetForm.asset.businessAssetCategory', function (newVal, oldVal) {
            if (angular.equals(newVal, oldVal)) {
                return;
            }
            self.asset.businessAssetType = null;
            self.assetTypeFilter = newVal === null ? {} : { businessAssetCategoryId: newVal.id };
        });

        var removeScrollSpy = function (spyName) {
            self.spies.forEach(function (spy, index) {
                if (spy.name === $translate.instant(spyName)) {
                    self.spies.splice(index, 1);
                }
            });
        };

        $scope.$watch('assetForm.files.length', function (newVal, oldVal) {
            if (newVal && newVal === oldVal) {
                return;
            }
            if (!newVal) {
                removeScrollSpy('assetForm.attachments.title');
            } else if (oldVal === 0) {
                self.spies.push({
                    id: '#attachmentsSection',
                    name: $translate.instant('assetForm.attachments.title'),
                    position: 3
                });
                self.spies.sort(function (a, b) {
                    if (a.position > b.position) {
                        return 1;
                    }
                    if (a.position < b.position) {
                        return -1;
                    }
                    return 0;
                });
            }
        });

        $scope.$watch('assetForm.links.length', function (newVal, oldVal) {
            if (newVal && newVal === oldVal) {
                return;
            }
            if (!newVal) {
                removeScrollSpy('webLinkSection.title');
            }
        });

        self.meteredAttributes = function () {
            if (!self.asset.businessAssetAttributes) {
                return [];
            }

            var hasMeteredAttributes = self.asset.businessAssetAttributes.filter(function (attribute) {
                return attribute.isMetered === true || attribute.transactionCount > 0;
            });

            if (hasMeteredAttributes.length === 0) {
                removeScrollSpy($translate.instant('assetForm.metering.title'));
            }

            return hasMeteredAttributes;
        };

        self.showAssetUsage = function () {
            self.asset.businessAssetAttributes.forEach(function (attribute) {
                if (attribute.businessAssetAttributeType.isMeterable) {
                    attribute.isMetered = true;
                }
            });
            self.showAssetUsageFlag = true;
        };

        self.hasMeterableAttributes = function () {
            if (!self.asset.businessAssetAttributes) {
                return false;
            }
            var meterableAttributes = self.asset.businessAssetAttributes.filter(function (attribute) {
                return attribute.businessAssetAttributeType.isMeterable === true;
            });

            return meterableAttributes.length > 0;
        };

        self.addLinks = function () {
            self.openWebLinksPanel = true;
        };
    });


'use strict';

angular.module('assetForm')
    .controller('assetDeleteModalController', function ($uibModalInstance, $scope, count) {
        $scope.count = count;

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    });

'use strict';

angular.module('assetFloorPlanView', ['dudeControls', 'ui.router', 'dudeApi']);

/**
 * @ngdoc service
 * @name assetFloorPlanView.assetFloorPlanViewService
 * @requires DudeApi
 *
 * @description
 * Service for supporting the asset view of floor plans
 *
 */

'use strict';

angular.module('assetFloorPlanView')
    .service('assetFloorPlanViewService', function (DudeApi) {
        /**
         * @ngdoc method
         * @name get
         * @methodOf assetFloorPlanView.assetFloorPlanViewService
         *
         * @description
         * Gets a single floor plan
         *
         * @param {number} id The id of the floor plan to get
         * @returns {Promise} A promise that resolves to the specified floor plan
         */
        var get = function (id) {
            return DudeApi.FloorPlanEntity.get({ id: id });
        };

        return {
            get: get
        };
    });

'use strict';

angular.module('assetFloorPlanView')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.assetFloorPlanView', {
                url: 'assetFloorPlanView/:id',
                templateUrl: 'app/components/assetFloorPlanView/assetFloorPlanView.html',
                controller: 'AssetFloorPlanViewController',
                controllerAs: 'assetFloorPlanView',
                feature: 'floorplans',
                resolve: {
                    floorPlan: function ($stateParams, DudeApi, assetFloorPlanViewService) {
                        return assetFloorPlanViewService.get($stateParams.id).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('assetFloorPlanView')
    .controller('AssetFloorPlanViewController', function ($state, floorPlan, appConfig) {
        var self = this;
        self.floorPlan = floorPlan;
        self.imageUrl = appConfig.api.file + '/file/public/' + floorPlan.fileViewToken;

        self.navigateToFloorPlanList = function () {
            $state.go('secure.floorPlanList');
        };
    });

'use strict';

angular.module('assetFilters')
    .factory('assetFiltersService', function ($location, pagingHelpers) {
        // Checks to see if you are in search mode.
        var isSearching = function (filters) {
            return (filters.q !== null && filters.q !== '') ||
                (filters.isActive !== null && filters.isActive !== '' && filters.pmSchedule === null) ||
                (filters.businessAssetTypeId && filters.businessAssetTypeId !== null && filters.businessAssetTypeId.length > 0) ||
                (filters.isMetered !== null && filters.isMetered !== '') ||
                (angular.isDefined(filters.isLocation) && filters.isLocation !== null && filters.isLocation !== '');
        };

        var getFilters = function (params) {
            // if Adding a new search filter make sure to add it to the
            // isSearching() function below.

            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Name asc',
                q: params.q || null,
                isInventoryStorageArea: params.isInventoryStorageArea || null,
                isWorkOrderAsset: params.isWorkOrderAsset || null,
                parentId: params.parentId || null,
                isActive: params.isActive || (params.pmSchedule || null),
                businessAssetTypeId: params.businessAssetTypeId || null,
                searchFromCurrentNode: params.searchFromCurrentNode || true,
                includeDescendants: params.includeDescendants || null,
                isMetered: params.isMetered || null,
                isLocation: params.isLocation || null,
                pmSchedule: params.pmSchedule || null // used to set the isActive to true and fix isSearching()
            };

            return currentFilter;
        };

        var toApiFilter = function (currentFilter) {
            // Need to make a copy other wise back button on
            // page 2+ will not work and a parentID.
            currentFilter = angular.copy(currentFilter);

            if (!currentFilter.searchFromCurrentNode) {
                currentFilter.parentId = null;
            } else if (!isSearching(currentFilter) && (currentFilter.parentId === null || angular.isUndefined(currentFilter.parentId))) {
                currentFilter.parentId = ' ';
            }

            if (isSearching(currentFilter)) {
                currentFilter.includeDescendants = true;
            }

            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter,
            isSearching: isSearching
        };
    });

/**
 * @ngdoc directive
 * @restrict E
 * @name assetFilters.asset-filters
 * @description
 *
 * The Inventory Storage Area or Work Order Asset filter
 *
 * @param {any} filters The item to filter on
 * @param {object} parentAsset The parent asset
 * @param {object} showStorageAreas One way bind on whether or not the storage area filter is shown (optional)
 * @param {boolean} openWhen Determines when sliding panel should open
 * @param {function} setFunction function reference to set the filters
 * @param {function} clearFunction function reference to handle the clear action
 **/

'use strict';

angular.module('assetFilters')
    .component('assetFilters', {
        templateUrl: 'app/components/assetFilters/assetFilters.html',
        bindings: {
            filters: '=',
            parentAsset: '=',
            showStorageAreas: '<?',
            openWhen: '=',
            setFunction: '&',
            clearFunction: '&'
        },
        controller: 'AssetListFiltersController',
        controllerAs: 'assetListFilters'
    })
    .controller('AssetListFiltersController', function ($scope, $q, $translate) {
        var self = this;

        self.$onInit = function () {
            self.titles = { title: $translate.instant('assetFilters.title') };

            self.storageAreaParams = {
                isWorkOrderAsset: self.filters.isWorkOrderAsset,
                isInventoryStorageArea: self.filters.isInventoryStorageArea
            };

            $scope.$watch('assetListFilters.storageAreaParams', function (newVal, oldVal) {
                if (angular.equals(newVal, oldVal)) {
                    return;
                }
                if (self.storageAreaParams && self.storageAreaParams.isWorkOrderAsset) {
                    self.filters.isWorkOrderAsset = true;
                    delete self.filters.isInventoryStorageArea;
                    self.filters.includeDescendants = true;
                } else if (self.storageAreaParams && self.storageAreaParams.isInventoryStorageArea) {
                    self.filters.isInventoryStorageArea = true;
                    delete self.filters.isWorkOrderAsset;
                    self.filters.includeDescendants = true;
                } else {
                    delete self.filters.isInventoryStorageArea;
                    delete self.filters.isWorkOrderAsset;
                }
            });
        };
    });

'use strict';

angular.module('maintenance', [

  // need these 2 for global configuration see. index.config.js
    'ui.router',
    'pascalprecht.translate',

    // DudeBase/DudeControls Global Modules
    'notification', // Toastr
    'dudeErrorPages',
    'dudeError', // DudeBase
    'utils',
    'updateLanguage',

    // Application
    'navbar',
    'workOrder',
    'user',
    'purposeList',
    'purposePanel',
    'filterHelpers',
    'notifications',
    'changePassword',
    'assetList',
    'assetForm',
    'assetTypeList',
    'assetTypeForm',
    'settingsForm',
    'pmSchedule',
    'helpers',
    'routeInterceptor',
    'dashboard',
    'taskBookList',
    'taskBookForm',
    'purposeReport',
    'failureReport',
    'tradeList',
    'tradeForm',
    'filters',
    'departmentList',
    'departmentForm',
    'projectList',
    'projectForm',
    'maintenanceSlidingPanels',
    'workTypeList',
    'workTypeReport',
    'employeeReport',
    'equipmentReport',
    'locationReport',
    'maintenanceFilters',
    'floorPlanList',
    'assetFloorPlanView'
]);

'use strict';

angular.module('maintenance')
    .controller('IndexController', function ($scope) {
        var self = this;

        // This Keeps the navbar and footer from prematurely loading before the user context.
        self.userContextLoaded = false;

        $scope.$on('dudeAuth:user-loaded', function () {
            self.userContextLoaded = true;
        });
    });

'use strict';

angular.module('maintenance')
    .constant('appConfig', {
        api: {
            core: /* DudeApiUri */ 'http://vnext.api.localtest.me' /* DudeApiUri */,
            security: /* DudeOauthUri */ 'http://login.localtest.me' /* DudeOauthUri */,
            file: /* DudeFileUri */ 'http://vnext.file.localtest.me' /* DudeFileUri */,
            report: /* DudeFileUri */ 'http://vnext.report.localtest.me' /* DudeFileUri */,
            settings: /* DudeFileUri */ 'http://vnext.settings.localtest.me' /* DudeFileUri */,
            asset: /* DudeAssetUri */ 'http://vnext.asset.localtest.me' /* DudeAssetUri */,
            history: /* DudeHistoryUri */ 'http://vnext.history.localtest.me' /* DudeHistoryUri */,
            inventory: /* DudeInventoryUri */ 'http://vnext.inventory.localtest.me' /* DudeInventoryUri */,
            comment: /* DudeCommentUri */ 'http://vnext.comment.localtest.me' /* DudeCommentUri */,
            pendo: /* DudePendoUri */ 'http://vnext.pendoagent.localtest.me' /* DudePendoUri */
        },
        analytics: {
            pendo: {
                apiKey: /* PendoApiKey */ '' /* PendoApiKey */,
                productName: /* PendoProductName */ '' /* PendoProductName */
            }
        }
    })
    .config(function ($compileProvider, $urlRouterProvider, $translateProvider, appConfig, dudeApiConfigProvider) {
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy(null);

        // This flag gets set when going to prod only with build scripts
        // https://docs.angularjs.org/guide/production#disabling-debug-data
        // When setting this to false it will disable the ability to run protractor tests
        $compileProvider.debugInfoEnabled(true);

        $urlRouterProvider.otherwise(function ($injector, $location) {
            var path = $location.path();
            // Stops the loop-de loop
            if (path === '/' || path === '') {
                $injector.get('$state').transitionTo('secure.interceptor');
            }
        });

        // set urls
        dudeApiConfigProvider.baseUrl = appConfig.api.core;
        dudeApiConfigProvider.securityUrl = appConfig.api.security;
        dudeApiConfigProvider.fileUrl = appConfig.api.file;
        dudeApiConfigProvider.reportUrl = appConfig.api.report;
        dudeApiConfigProvider.settingsUrl = appConfig.api.settings;
        dudeApiConfigProvider.assetUrl = appConfig.api.asset;
        dudeApiConfigProvider.historyUrl = appConfig.api.history;
        dudeApiConfigProvider.inventoryUrl = appConfig.api.inventory;
        dudeApiConfigProvider.commentUrl = appConfig.api.comment;
        dudeApiConfigProvider.pendoUrl = appConfig.api.pendo;
    })
    .run(function ($rootScope, $log, $window, notification, marketizr, dudeGuid, appConfig) {
        // Configure the notifications service
        // for toastr messages
        notification.init();

        // Listen for the user context to load and create a base remote logger object
        // This will be used to send info to new relic
        var baseLogObj = {};
        $rootScope.$on('dudeAuth:user-loaded', function (event, data) {
            baseLogObj = {
                accountDbId: data.account.id,  // accountId breaks new relic
                accountNumber: data.account.number,
                accountName: data.account.name,
                asset: data.account.assets || 'Maintenance Manager',
                userId: data.user.id,
                userEmail: data.user.email
            };
        });

        // setup listener for `remote` errors that need to be logged to new relic
        $rootScope.$on('dudeLog:remote', function (event, data) {
            if ($window.newrelic) {
                // Check if data coming in is not an object and convert it
                if (!angular.isObject(data)) {
                    data = {
                        message: data
                    };
                }
                // Generate a guid
                baseLogObj.dudeReferenceId = dudeGuid.generate();
                var actionData = angular.extend(baseLogObj, data);
                $window.newrelic.addPageAction('DudeError', actionData);
            }
        });

        $rootScope.$on('$stateChangeSuccess', function () {
            $window.document.body.scrollTop = $window.document.documentElement.scrollTop = 0;
        });

        $rootScope.$on('$stateChangeError', function () {
            $log.log(arguments);
        });

        $rootScope.analytics = appConfig.analytics;

        // Use to checkout marketizr stuff
        // $rootScope.$on('dudeAuth:user-loaded',function(event, data){
        //  data.account.market = 'publicworks';
        //  marketizr.setContext(data);
        //  $rootScope.marketizrThemeUrl = marketizr.getThemeUrl();
        // });
    });

angular.module("translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {
    "assetFloorPlanView": {
        "title": "Manage Floor Plan",
        "floorPlans": "Floor Plans",
        "floorPlanFor": "Floor Plan image for"
    }
}
);

$translateProvider.translations("en", {
    "assetForm": {
        "assets": "Assets",
        "createTitle": "New Location/Equipment",
        "editTitle": "Edit Location/Equipment",
        "name": "Name",
        "parent": "Location/Equipment is at",
        "details": "Details",
        "namePlaceholder": "Enter name",
        "description": "Description",
        "descriptionPlaceholder": "Enter description",
        "workOrderAsset": "Work Order Asset",
        "inventoryStorageArea": "Inventory Storage Area",
        "notes": "Notes",
        "assetType": "Type",
        "assetCategory": "Category",
        "attributes": "Attributes",
        "noAttributesMessage": "Select a Category for additional attributes",
        "isActive": "Active",
        "inactiveWarning": "Inactivating will inactivate all children",
        "hasQuantityWarning": "Asset must remain a storage area until inventory quantities are reduced to zero.",
        "path": "Location",
        "typeahead": {
            "title": "Asset Location"
        },
        "attachments": {
            "title": "Attachments"
        },
        "links": {
            "title": "Links"
        },
        "assetTools": {
            "buttonGroupName": "Asset Tools",
            "addAsset": "Add Asset",
            "deleteLocationOrEquipment": "Delete Location/Equipment"
        },
        "cards": {
            "attachment": {
                "body": "Upload documents and images.",
                "button": "Add Attachments"
            },
            "link": {
                "body": "Add urls/links to websites and online documents.",
                "button": "Add Links"
            }
        },
        "notify": {
            "delete": {
                "title": "Deleted Successfully",
                "message": "Location/Equipment deleted successfully"
            },
            "success": {
                "title": "Saved successfully",
                "message": "Location/Equipment saved successfully"
            },
            "failure": {
                "title": "Could Not Save",
                "message": "An error has occurred"
            },
            "upload": {
                "successBody": "has been attached to the location/equipment successfully"
            }
        },
        "deleteModal": {
            "title": "Cannot Delete Location/Equipment",
            "cannotDeleteMessage": "Cannot delete this Location/Equipment because it, or a child, is associated with ",
            "inventoryTransactions": " Inventory Transaction(s)."
        },
        "deleteConfirm": {
            "title": "Delete Location/Equipment",
            "message": "Are you sure you want to delete this Location/Equipment?",
            "message2": "Deleting this Location/Equipment will also remove its children."
        },
        "assetTypeChange": {
            "title": "Change Type",
            "warning": "Changing the type will remove attributes currently associated with this Location/Equipment.",
            "confirmChange": "Are you sure you want to proceed?"
        },
        "validation": {
            "categoryNullError": "Category is required before selecting a type.",
            "money": {
                "max": " must be less than 999,999,999,999.99 ",
                "min": " cannot be negative",
                "number": " must be a valid currency value"
            },
            "save.required": "Please fill out required fields",
            "save.errors": "Please correct form errors",
            "invalidCharacter": "Invalid character '|'"
        },
        "buildAForm": {
            "assetUsage": {
                "cardHeader": "Track Usage",
                "cardBody": "Track equipment usage data such as mileage, counts, cycles, and more.",
                "buttonText": "Track Usage"
            }
        },
        "metering": {
            "title": "Usage Tracking"
        },
        "attributeTypes": {
            "access_diameter": "Access Diameter",
            "bridge_width": "Bridge Width",
            "depth": "Depth",
            "diameter": "Diameter",
            "discharge_diameter": "Discharge Diameter",
            "distance": "Distance",
            "from_manhole": "From Manhole",
            "height": "Height",
            "impeller_diameter": "Impeller Diameter",
            "impeller_size": "Impeller Size",
            "inlet_diameter": "Inlet Diameter",
            "interior_depth": "Interior Depth",
            "invert_elevation": "Invert Elevation",
            "length": "Length",
            "record_length": "Record Length",
            "sidewalk_width": "Sidewalk Width",
            "size": "Size",
            "tdh": "TDH",
            "width": "Width",
            "access_material": "Access Material",
            "access_type": "Access Type",
            "account_identifier": "Account Identifier",
            "account_number": "Account Number",
            "actuator_type": "Actuator Type",
            "acquisition_date": "Acquisition Date",
            "address": "Address",
            "age": "Age",
            "amp_hours": "Amp Hours",
            "amps": "Amps",
            "approach_direction": "Approach Direction",
            "battery_type": "Battery Type",
            "backplate": "Backplate",
            "blower_type": "Blower Type",
            "breaker_type": "Breaker Type",
            "breaker_volts": "Breaker Volts",
            "bridge_design": "Bridge Design",
            "bridge_type": "Bridge Type",
            "building_type": "Building Type",
            "bulb_type": "Bulb Type",
            "bus_voltage": "Bus Voltage",
            "bypass_valve": "Bypass Valve",
            "cgmp": "Required to follow cGMP Practices",
            "cleanout_type": "Cleanout Type",
            "coating": "Coating",
            "common_tree_name": "Common Tree Name",
            "compressor_type": "Compressor Type",
            "condition": "Condition",
            "cost/uom": "Cost/UOM",
            "cover_type": "Cover Type",
            "critical_customer": "Critical Customer",
            "criticality": "Equipment Risk Ranking",
            "currently_open": "Currently Open",
            "date_opened": "Date Built",
            "date_placed_in_service": "Date Placed in Service",
            "date_purchased": "Date Purchased",
            "date_removed": "Date Removed from Service",
            "dc_voltage": "DC Voltage",
            "deck_type": "Deck Type",
            "design_gpm": "Design GPM",
            "design_load_rating": "Design Load Rating",
            "discharge_pressure": "Discharge Pressure",
            "disposal_date": "Disposal Date",
            "drive_end_rotation": "Drive End Rotation",
            "facing_direction": "Facing Direction",
            "fan_type": "Fan Type",
            "flow_direction": "Flow Direction",
            "flow_rate_gpm": "Flow Rate GPM",
            "frame": "Frame",
            "fuel_type": "Fuel Type",
            "hoist_type": "Hoist Type",
            "hydrant_valve": "Hydrant Valve",
            "inlet_type": "Inlet Type",
            "input_amps": "Input Amps",
            "input_rpm": "Input RPM",
            "input_volts": "Input Volts",
            "install_date": "Install Date",
            "impeller_material": "Impeller Material",
            "lateral_line_type": "Lateral Line Type",
            "license_plate_#": "License Plate #",
            "light_type": "Light Type",
            "lined": "Lined",
            "main_shape": "Main Shape",
            "manhole_condition": "Manhole Condition",
            "manhole_type": "Manhole Type",
            "manufacturer": "Manufacturer",
            "material": "Material",
            "meter": "Meter",
            "metered_service": "Metered Service",
            "meter_type": "Meter Type",
            "model": "Model",
            "model_number": "Model Number",
            "motor_type": "Motor Type",
            "mounted_to": "Mounted To",
            "normally_open": "Normally Open",
            "normal_operating_position": "Normal Operating Position",
            "number_cells": "Number Cells",
            "number_cylinders": "Number Cylinders",
            "official_bridge_number": "Official Bridge Number",
            "open_direction": "Open Direction",
            "operable": "Operable",
            "output_amps": "Output Amps",
            "output_rpm": "Output RPM",
            "output_volts": "Output Volts",
            "packing_type": "Packing Type",
            "phase": "Phase",
            "pipe_type": "Pipe Type",
            "pump_type": "Pump Type",
            "ratio": "Ratio",
            "retroreflectivity": "Retroreflectivity",
            "road_class": "Road Class",
            "rpm": "RPM",
            "safety": "Safety Precautions Necessary",
            "segment_end": "Segment End",
            "segment_start": "Segment Start",
            "serial_number": "Serial Number",
            "service_type": "Service Type",
            "sheeting_type": "Sheeting Type",
            "signal_bulb_type": "Signal Bulb Type",
            "street_bulb_type": "Bulb Type",
            "signal_type": "Signal Type",
            "slope": "Slope",
            "ss_pump_type": "Pump Type",
            "ss_water_type": "Pump Type",
            "street_feature_type": "Street Feature Type",
            "style": "Style",
            "supplier": "Supplier",
            "surface_condition": "Surface Condition",
            "surface_install_date": "Surface Install Date",
            "surface_type": "Surface Type",
            "tag_number": "Financial or Company Asset Tag",
            "tank_dimensions": "Tank Dimensions",
            "tank_material": "Tank Material",
            "to_manhole": "To Manhole",
            "traffic_type": "Traffic Type",
            "transmission_system": "Transmission System",
            "turns_to_close": "Turns To Close",
            "usage_measurement": "Usage Measurement ",
            "valve_type": "Valve Type",
            "valve_material": "Valve Material",
            "valve_mounting": "Valve Mounting",
            "valve_operator": "Valve Operator",
            "valve_seat_material": "Valve Seat Material",
            "vin": "VIN",
            "wall_material": "Wall Material",
            "warranty_expiration": "Warranty Expiration",
            "ww_pump_type": "WW Pump Type",
            "ww_water_type": "WW Water Type",
            "year_lined": "Year Lined",
            "area": "Square Footage",
            "size_of_park": "Size Of Park",
            "discharge_capacity": "Discharge Capacity",
            "flow_size": "Flow Size",
            "discharge_capacity_fluid": "Discharge Capacity Fluid",
            "flow_summary": "Flow Summary",
            "max_flow": "Max Flow",
            "rated_flow": "Rated Flow",
            "dynamic_force": "Dynamic Force",
            "static_force": "Static Force",
            "torque_output": "Torque Output",
            "rated_pressure": "Rated Pressure",
            "horsepower": "Horsepower",
            "wattage": "Wattage",
            "load_capacity": "Load Capacity",
            "lubrication_capacity": "Lubrication Capacity",
            "volume": "Volume",
            "speed": "Speed",
            "original_cost": "Original Cost",
            "identifier": "ID",
            "occupancy": "Occupancy"
        },
        "attributeTypeOptions": {
            "checkbox": "Yes"
        },
        "attributeTypeCodes": {
            "1-high": "1-High",
            "27_diameter": "27 Diameter",
            "2-medium": "2-Medium",
            "3-low": "3-Low ",
            "42_diameter": "42 Diameter",
            "4wd": "4Wd",
            "abs": "ABS Plastic",
            "ac": "AC",
            "airfoil_blade": "Airfoil Blade",
            "asbcem": "Asbestos Cement",
            "asp": "Asphalt",
            "asphalt": "Asphalt",
            "assembly_group_a": "Assembly (Group A)",
            "athletic_track": "Athletic Track",
            "axial_flow": "Axial-Flow",
            "backward_curved_radial": "Backward Curved Radial",
            "backward_inclined": "Backward Inclined",
            "ball": "Ball",
            "baltimore_truss": "Baltimore Truss",
            "banner": "Banner",
            "barricade": "Barricade",
            "bench": "Bench",
            "bike_rack": "Bike Rack",
            "bmp": "Brick Masonry",
            "bollard": "Bollard",
            "box_span": "Box Span",
            "br": "Brick",
            "brickpaver": "Brickpaver",
            "bus_shelter": "Bus Shelter",
            "business_group_b": "Business (Group B)",
            "butterfly": "Butterfly",
            "cable_stayed": "Cable Stayed",
            "cantilever": "Cantilever",
            "cas": "Cast Iron",
            "catchbasin": "Catchbasin",
            "centrifugal": "Centrifugal",
            "chain": "Chain",
            "chip_and_seal": "Chip And Seal",
            "cipp": "Cured In Place",
            "circular": "Circular",
            "cleanout": "Cleanout",
            "closed": "Closed",
            "closed_lid_manhole": "Closed Lid Manhole",
            "cmp": "Corrugated Metal",
            "cobblestone": "Cobblestone",
            "collector": "Collector",
            "colonial": "Colonial",
            "combined": "Combined",
            "commercial": "Commercial",
            "concrete": "Concrete",
            "concrete_box_beam": "Concrete Box Beam",
            "concrete_box_culvert": "Concrete Box Culvert",
            "concrete_cast_in_place": "Concrete Cast In Place",
            "concrete_precast": "Concrete Precast",
            "concrete_precast_prestressed_with_cip": "Concrete Precast Prestressed With Cip",
            "concrete_rigid_frame": "Concrete Rigid Frame",
            "concrete_slab": "Concrete Slab",
            "cone": "Cone",
            "continuous_girder": "Continuous Girder",
            "cop": "Copper",
            "cover": "Cover",
            "cp": "Concrete (Non-Reinforced)",
            "cross_flow": "Cross-Flow",
            "csb": "Concrete Segments (Bolted)",
            "csu": "Concrete Segments (Unbolted)",
            "ct": "Clay Tile",
            "cut_off_flat_glass": "Cut Off Flat Glass",
            "d1_1c": "D1 1C",
            "d7_1": "D7 1",
            "d7_2": "D7 2",
            "d9_14": "D9 14",
            "d9_2": "D9 2",
            "d9_6": "D9 6",
            "dc": "DC",
            "deck_truss": "Deck Truss",
            "diagonal_span": "Diagonal Span",
            "diaphragm": "Diaphragm",
            "dip": "Ductile Iron",
            "domestic": "Domestic",
            "door": "Door",
            "drinking_fountain": "Drinking Fountain",
            "ear": "Earthen",
            "eargeo": "Earth & Geotextile",
            "east": "East",
            "eastbound": "Eastbound",
            "educational_group_e": "Educational (Group E)",
            "effluent": "Effluent",
            "electric": "Electric",
            "esplanade_bracket": "Esplanade Bracket",
            "excellent": "Excellent",
            "factory_group_f": "Factory (Group F)",
            "fair": "Fair",
            "feet": "Feet",
            "ferry": "Ferry",
            "filled_spandrel_arch": "Filled Spandrel Arch",
            "fire": "Fire",
            "fluo": "Fluorescent",
            "flushing_structure": "Flushing Structure",
            "forward_curved_multi_vane": "Forward Curved Multi-vane",
            "fountain": "Fountain",
            "four_way_beacon": "Four way Beacon",
            "four_way_signal": "four Way Signal",
            "freeway": "Freeway",
            "frp": "Fiberglass Reinforced",
            "g20_2": "G20 2",
            "gate": "Gate",
            "gear": "Gear",
            "geo": "Geotextile",
            "girder_floor": "Girder Floor",
            "good": "Good",
            "gp": "Galvanized Pipe",
            "grate": "Grate",
            "gravel": "Gravel",
            "grc": "Glass Reinforced Cement",
            "hand": "Hand",
            "hardcourt": "Hardcourt",
            "hdpe": "High Density Polyethylene",
            "high_voltage": "High Voltage",
            "high-hazard_group_h": "High-Hazard (Group H)",
            "highway": "Highway",
            "horseshoe": "Horseshoe",
            "hours": "Hours",
            "howe_truss": "Howe Truss",
            "hps": "High Pressure Sodium",
            "hydrant": "Hydrant",
            "hydraulic": "Hydraulic",
            "i_5": "I 5",
            "i_beam": "I Beam",
            "inc": "Incandescent",
            "incandescent_wtih_globe": "Incandescent With Globe",
            "industrial": "Industrial",
            "information_sign": "Information Sign",
            "institutional_group_i": "Institutional (Group I)",
            "irrigation": "Irrigation",
            "jet": "Jet",
            "k_truss": "K Truss",
            "kilometers": "Kilometers",
            "kiosk": "Kiosk",
            "lamp_hole": "Lamp Hole",
            "large__water_tight": "Large Water Tight",
            "left": "Left",
            "lid": "Lid",
            "local": "Local",
            "low_voltage": "Low Voltage",
            "lps": "Low Pressure Sodium",
            "m1_4": "M1 4",
            "m1_5": "M1 5",
            "m2_1": "M2 1",
            "m3_1": "M3 1",
            "m3_2": "M3 2",
            "m3_3": "M3 3",
            "m3_4": "M3 4",
            "m4_5": "M4 5",
            "m4_8a": "M4 8A",
            "m4_9l": "M4 9L",
            "m4_9r": "M4 9R",
            "m5_1l": "M5 1L",
            "m5_1r": "M5 1R",
            "m5_2l": "M5 2L",
            "m5_2r": "M5 2R",
            "m6_1l": "M6 1L",
            "m6_1r": "M6 1R",
            "m6_2l": "M6 2L",
            "m6_2r": "M6 2R",
            "m6_3": "M6 3",
            "m6_4": "M6 4",
            "m6_6l": "M6 6L",
            "m6_6r": "M6 6R",
            "m6_7l": "M6 7L",
            "m6_7r": "M6 7R",
            "m6_8": "M6 8",
            "m6_9": "M6 9",
            "magnetic": "Magnetic",
            "major_arterial": "Major Arterial",
            "mechanical": "Mechanical",
            "medium_voltage": "Medium Voltage",
            "mercantile_group_m": "Mercantile (Group M)",
            "meters": "Meters",
            "mh": "Metal Halide",
            "miles": "Miles",
            "minor_arterial": "Minor Arterial",
            "minutes": "Minutes",
            "monument": "Monument",
            "multispan_w_simple_spans": "Multispan W Simple Spans",
            "mv": "Mercury Vapor",
            "newspaper_dispenser": "Newspaper Dispenser",
            "non_district": "Non District",
            "north": "North",
            "northbound": "Northbound",
            "northeast": "Northeast",
            "northwest": "Northwest",
            "ob": "Pitch Fiber (Orangeburg)",
            "oblong": "Oblong",
            "open": "Open",
            "open_lid_manhole": "Open Lid Manhole",
            "open_paddle_wheel": "Open Paddle Wheel",
            "open_radial_blade": "Open Radial Blade",
            "open_spandrel_arch": "Open Spandrel Arch",
            "oth": "Other",
            "other": "Other",
            "pan_girder": "Pan Girder",
            "pccp": "Pre-Stressed Concrete Cylinder",
            "pe": "Polyethylene",
            "pedestrian": "Pedestrian",
            "pedestrian_signal": "Pedestrian Signal",
            "pendant": "Pendant",
            "petit_truss": "Petit Truss",
            "phone_box": "Phone Box",
            "piston": "Piston",
            "planter": "Planter",
            "plug": "Plug",
            "pneumatic": "Pneumatic",
            "pole_mast": "Pole Mast",
            "pony_truss": "Pony Truss",
            "poor": "Poor",
            "post_box": "Post Box",
            "potable": "Potable",
            "pp": "Polypropylene",
            "pratt_truss": "Pratt Truss",
            "prestressed_concrete": "Prestressed Concrete",
            "programmable_visibility": "Programmable Visibility",
            "psc": "Plastic/Steel Composite",
            "pvc": "Polyvinyl Chloride",
            "r1_1": "R1 1",
            "r1_2": "R1 2",
            "r1_3w": "R1 3W",
            "r1_4w": "R1 4W",
            "r10_11": "R10 11",
            "r10_11b": "R10 11B",
            "r10_12": "R10 12",
            "r10_6": "R10 6",
            "r11_2": "R11 2",
            "r11_3a": "R11 3A",
            "r11_4": "R11 4",
            "r12_5": "R12 5",
            "r2_1": "R2 1",
            "r2_5c": "R2 5C",
            "r3_1": "R3 1",
            "r3_16": "R3 16",
            "r3_2": "R3 2",
            "r3_5a": "R3 5A",
            "r3_5l": "R3 5L",
            "r3_5r": "R3 5R",
            "r3_7l": "R3 7L",
            "r3_7r": "R3 7R",
            "r4_7a": "R4 7A",
            "r4_7b": "R4 7B",
            "r5_1": "R5 1",
            "r5_1a": "R5 1A",
            "r5_2": "R5 2",
            "r5_2a": "R5 2A",
            "r6_1_l": "R6 1 L",
            "r6_1_r": "R6 1 R",
            "r6_2_r": "R6 2 R",
            "r8_3": "R8 3",
            "railroad": "Railroad",
            "ramp": "Ramp",
            "raw": "Raw",
            "rcp": "Reinforced Concrete",
            "rear_yard": "Rear Yard",
            "reciprocating": "Reciprocating",
            "reclaimed": "Reclaimed",
            "recreation": "Recreation",
            "rectangular": "Rectangular",
            "rectilinear": "Rectilinear",
            "recycling_receptacle": "Recycling Receptacle",
            "residential_group_r": "Residential (Group R)",
            "resource": "Resource",
            "right": "Right",
            "roof": "Roof",
            "rotary": "Rotary",
            "rotary_screw": "Rotary Screw",
            "roundway": "Roundway",
            "rpm": "Reinforced Plastic (Truss)",
            "salt": "Salt",
            "sb": "Segmented Block",
            "screw": "Screw",
            "sculpture": "Sculpture",
            "service": "Service",
            "sewage": "Sewage",
            "shelter": "Shelter",
            "shrouded_radial_blade": "Shrouded Radial Blade",
            "single_face_signal": "Single Face Signal",
            "south": "South",
            "southbound": "Southbound",
            "southeast": "Southeast",
            "southwest": "Southwest",
            "sp": "Steel",
            "standard": "Standard",
            "standard_w_ears": "Standard W Ears",
            "standard_w_lock": "Standard W Lock",
            "steel_box_beam": "Steel Box Beam",
            "steel_buckle_plate": "Steel Buckle Plate",
            "steel_corrugated": "Steel Corrugated",
            "steel_girder": "Steel Girder",
            "steel_grid_exodermic": "Steel Grid Exodermic",
            "steel_grid_riveted": "Steel Grid Riveted",
            "steel_grid_welded": "Steel Grid Welded",
            "steel_orthotropic": "Steel Orthotropic",
            "steel_rigid_frame": "Steel Rigid Frame",
            "steel_viaduct": "Steel Viaduct",
            "storage_group_s": "Storage (Group S)",
            "storm": "Storm",
            "subdivided_warren_truss": "Subdivided Warren Truss",
            "suspension": "Suspension",
            "t_beam": "T Beam",
            "table": "Table",
            "thermal": "Thermal",
            "thermal_magnetic": "Thermal/Magnetic",
            "through_girder": "Through Girder",
            "through_truss": "Through Truss",
            "tied_arch": "Tied Arch",
            "timber_glued": "Timber Glued",
            "timber_nailed": "Timber Nailed",
            "timber_plank": "Timber Plank",
            "timber_prestressed": "Timber Prestressed",
            "trapezoidal": "Trapezoidal",
            "trash_receptacle": "Trash Receptacle",
            "treated": "Treated",
            "tree_grate": "Tree Grate",
            "tree_guard": "Tree Guard",
            "triangular": "Triangular",
            "tte": "Transite",
            "turbine": "Turbine",
            "type_i_engineer_grade": "Type I Engineer Grade",
            "type_ii_super_engineer_grade": "Type II Super Engineer Grade",
            "type_iii_high_intensity": "Type III High Intensity",
            "type_iv_multi_layer_sheeting": "Type IV Multi Layer Sheeting",
            "type_ix_fine_grain_microprisms": "Type IX Fine Grain Microprisms",
            "type_v_metallized_microprismatic": "Type V Metallized Microprismatic",
            "type_vi_vinyl_backed_microprismatic": "Type VI Vinyl Backed Microprismatic",
            "type_vii_microprismatic": "Type VII Microprismatic",
            "type_viii_microprismatic_distinguishing": "Type VIII Microprismatic Distinguishing",
            "type_x_microprismatic_similar_to_types_vii_ix": "Type X Microprismatic Similar To Types VII IX",
            "unk": "Unknown",
            "unknown": "Unknown",
            "utility_and_miscellaneous_group_u": "Utility And Miscellaneous (Group U)",
            "vane": "Vane",
            "vcp": "Vitrified Clay",
            "vehicle": "Vehicle",
            "very_good": "Very Good",
            "very_poor": "Very Poor",
            "w1_1l": "W1 1L",
            "w1_1r": "W1 1R",
            "w1_2l": "W1 2L",
            "w1_2r": "W1 2R",
            "w1_3l": "W1 3L",
            "w1_3r": "W1 3R",
            "w1_4l": "W1 4L",
            "w1_4r": "W1 4R",
            "w1_5l": "W1 5L",
            "w1_5r": "W1 5R",
            "w1_6l": "W1 6L",
            "w1_6r": "W1 6R",
            "w1_7": "W1 7",
            "w1_8l": "W1 8L",
            "w1_8r": "W1 8R",
            "w10_1": "W10 1",
            "w11_2": "W11 2",
            "w11_8": "W11 8",
            "w13_1": "W13 1",
            "w14_1": "W14 1",
            "w14_2": "W14 2",
            "w17_1": "W17 1",
            "w2_1": "W2 1",
            "w2_2l": "W2 2L",
            "w2_2r": "W2 2R",
            "w2_4": "W2 4",
            "w20_2": "W20 2",
            "w20_3": "W20 3",
            "w21_1a": "W21 1A",
            "w3_1": "W3 1",
            "w3_2": "W3 2",
            "w3_3": "W3 3",
            "w4_5": "W4 5",
            "w6_1": "W6 1",
            "w6_2": "W6 2",
            "w6_3": "W6 3",
            "w8_5": "W8 5",
            "w8_9": "W8 9",
            "w9_1": "W9 1",
            "w9_2": "W9 2",
            "w9_2_alternate": "W9 2 Alternate",
            "warren_truss": "Warren Truss",
            "warren_truss_w_verticals": "Warren Truss W/ Verticals",
            "water_tight": "Water Tight",
            "wd": "Wood",
            "west": "West",
            "westbound": "Westbound",
            "whatley": "Whatley",
            "wire_rope": "Wire Rope",
        }
    }
}
);

$translateProvider.translations("en", {
    "assetList": {
        "title": "Locations and Equipment",
        "name": "Name",
        "category": "Category",
        "addLocationOrEquipment": "Add Location/Equipment",
        "addLocation": "Add Location",
        "createWorkOrder": "Create Work Order",
        "viewWorkOrders": "View Work Orders",
        "viewPmSchedules": "View PM Schedules",
        "assets": "Assets",
        "status": "Status",
        "active": "Active",
        "inactive": "Inactive",
        "location": "Location",
        "searchResultsInLocation": "Search results in Location",
        "assetTypes": "Types",
        "searchFromRoot": "Search All Locations/Equipment",
        "searchFromCurrentNode": "Show results within ",
        "recordUsage": "Record Usage",
        "showing": "Showing",
        "all": "All",
        "sort": "Sort",
        "create": "Create",
        "showChild": "Show Child",
        "actionDropDown": "Actions Dropdown",
        "getAsset": "Select Asset"
    }
}
);

$translateProvider.translations("en", {
    "assetReport": {
        "totalWorkOrders": "Total Work Orders",
        "totalWorkOrder": "Total Work Order",
        "workTypes": "Work Types",
        "listRoute": "List",
        "chartRoute": "Chart"
    }
}
);

$translateProvider.translations("en", {
  "assetTypeForm": {
    "createTitle": "New Type",
    "editTitle": "Edit Type",
    "assetTypeName": "Name",
    "assetTypeNamePlaceholder": "Enter name",
    "assetCategory": "Category",
    "assetCategoryAttributes": "Fields",
    "noGroupAttributes": "None at this time",
    "isActive": "Active",
    "dudeAsset": "Dude Type",
    "categories": {
      "site": "Site",
      "building": "Building",
      "area": "Area",
      "equipment": "Equipment"
    },
    "notify": {
      "delete": {
        "title": "Deleted successfully",
        "message": "Type deleted successfully",
      },
      "success": {
        "title": "Saved successfully",
        "message": "Type saved successfully",
      }
    },
    "deleteModal": {
      "title": "Cannot Delete Type",
      "cannotDeleteMessage": "Cannot delete this Type because it is associated with ",
      "assets": " Location/Equipment.",
      "reassignMessage": "Please reassign the associated Location/Equipment or inactivate this Type to remove it from use."
    },
    "deleteConfirm": {
      "title": "Delete Type",
      "message": "Are you sure you want to delete this Type?"
    }
  }
}
);

$translateProvider.translations("en", {
    "assetTypeList": {
        "title": "Types",
        "name": "Name",
        "status": "Status",
        "active": "Active",
        "inactive": "Inactive",
        "dudeProvided": "Dude Provided",
        "dudeProvidedTrue": "Yes",
        "dudeProvidedFalse": "No",
        "create": "Create"
    }
}
);

$translateProvider.translations("en", {
    "changePassword": {
        "toast" : {
          "success" : {
              "title": "Success",
              "body" : "Password successfully changed"
          }
        },
        "title": "Change Password",
        "currentPassword": "Current Password",
        "newPassword": "New Password",
        "reenterPassword": "Re-enter New Password",
        "validation": {
            "invalid": "New Password must contain a special character, or a number, or a mixed case character",
            "match": "This does not match the new password you entered",
            "length": "New Password must be at least 8 characters",
            "old": "The current password is incorrect"
        }
    }
}
);

$translateProvider.translations("en", {
    "dashboard": {
        "title": "Dashboard",
        "totalWorkOrders": "Total Work Orders",
        "newRequests": "New Requests",
        "onHold": "On Hold",
        "inProgress": "In Progress",
        "assignedToMe": "Assigned To Me",
        "emergencies": "Emergencies",
        "emergenciesAssignedToMe": "Emergencies",
        "emergenciesUnassigned": "Unassigned Emergencies",
        "overdue": "Overdue",
        "completedOnTime": "Completed on Time",
        "noScheduledWork": "No scheduled work in the last 30 days",
        "openByAssignee": "Open Work Orders by Assignee",
        "byPurpose": "Work Orders by Purpose",
        "myByPurpose": "My Work Orders by Purpose",
        "byLocationAndWorkType": "Work Orders by Location and Work Type",
        "myByLocationAndWorkType": "My Work Orders by Location and Work Type",
        "byStatus": "Work Orders by Status",
        "topFive": "Top 5",
        "topSeven": "Top 7",
        "requestedLastThirtyDays": "Requested last 30 days",
        "dueLastThirtyDays": "Due last 30 days",
        "dueNextSevenDays": "Due Next 7 Days",
        "unassigned": "Unassigned",
        "status": "Status",
        "count": "Count",
        "noWorkOrders": "There are no open work orders."
    }
}
);

$translateProvider.translations("en", {
    "departmentForm": {
        "createTitle": "New Department",
        "editTitle": "Edit Department",
        "departmentName": "Name",
        "departmentNamePlaceholder": "Enter name",
        "default": "Default",
        "notify": {
            "success": {
                "title": "Saved successfully",
                "message": "Department saved successfully",
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "departmentList": {
        "title": "Departments",
        "name": "Name",
        "create": "Create"
    }
}
);

$translateProvider.translations("en", {
    "employeeReports": {
        "title": "Assignee",
        "hoursLogged": "Hours Logged",
        "completedWO": "Completed WOs",
        "workOrder": "Work Order",
        "workType": "Work Type",
        "trade": "Trade",
        "export": "Export",
        "noCompletedWorkOrders": "No Completed Work Orders",
        "completedWorkOrder": "Completed Work Order",
        "completedWorkOrders": "Completed Work Orders",
        "noHours": "No hours logged",
        "top1000": "Viewing top 1,000 work orders only. Please limit filter criteria.",
        "filters": {
            "dateRange": "Date Range",
            "assignee": "Assignee",
            "dates": {
                "today": "Today",
                "yesterday": "Yesterday",
                "thisWeek": "This Week",
                "lastWeek": "Last Week",
                "thisMonth": "This Month",
                "lastMonth": "Last Month",
                "fiscalYear": "This Fiscal Year"
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "equipmentReports": {
        "title": "Equipment",
        "workOrdersBy": "Work Orders By Equipment",
        "laborHoursBy": "Labor Hours By Equipment",
        "costBy": "Cost By Equipment"
    }
}
);

$translateProvider.translations("en", {
    "failureReports": {
        "title": "Failure Reasons",
        "failuresBy": "Failures By Location/Equipment",
        "numberOf": "# of Failures",
        "failure": "Failure",
        "failures": "Failures",
        "failureReasons": "Failure Reasons",
        "totalFailures": "Total Failures",
        "listRoute": "List",
        "chartRoute": "Charts"
    }
}
);

$translateProvider.translations("en", {
    "filterBar": {
        "myFilter": "My Filter",
        "filters": "Filters",
        "clearFilters": "Clear Filters",
        "clear": "Clear"
    },
    "savedFilters": {
        "delete": {
            "confirm": {
                "title": "Delete Saved Filter",
                "message": "Are you sure you want to delete this saved filter?"
            },
        },
        "review": {
            "title": "My Filter",
            "instructions": "Name your filter and review your selections.",
            "name": "My Filter Name"
        }
    }
}
);

$translateProvider.translations("en", {
    "filterAssetCategory": {
        "show": "Show",
        "all": "All",
        "locations": "Locations Only",
        "equipment": "Equipment Only"
    }
}
);

$translateProvider.translations("en", {
    "filterAssetNodeSearch": {
        "searchAll": "Search All",
        "searchWithin": "Search within",
        "locations": "Locations",
        "equipment": "Equipment",
        "all": "Locations/Equipment"
    }
}
);

$translateProvider.translations("en", {
    "filterProject":{
        "title": "Project"
    }
}
);

$translateProvider.translations("en", {
    "filterPurposeType":{
        "title": "Category"
    }
}
);

$translateProvider.translations("en", {
    "filterReportDateRange": {
        "title": "Date Range",
        "ranges": {
            "thisMonth": "This Month",
            "lastMonth": "Last Month",
            "thisFiscalYear": "This Fiscal Year",
            "lastFiscalYear": "Last Fiscal Year",
            "thisYear": "This Calendar Year",
            "lastYear": "Last Calendar Year"
        }
    },
    "reportFilters": {
        "workOrderDate": "Work Order Date",
        "requested": "Requested",
        "completed": "Completed"
    }
}
);

$translateProvider.translations("en", {
    "filterStorageArea":{
        "title": "Assets",
        "all": "Show All Assets",
        "inventoryStorageAreas": "Inventory Storage Areas",
        "workOrderAssets": "Work Order Assets"
    }
}
);

$translateProvider.translations("en", {
    "filterWorkType":{
        "title": "Work Type",
    }
}
);

$translateProvider.translations("en", {
    "filterWorkorderDate": {
        "title": "Work Order Date",
        "ranges": {
            "thisMonth": "This Month",
            "lastMonth": "Last Month",
            "thisFiscalYear": "This Fiscal Year",
            "lastFiscalYear": "Last Fiscal Year",
            "thisYear": "This Calendar Year",
            "lastYear": "Last Calendar Year"
        }
    },
    "reportFilters": {
        "workOrderDate": "Work Order Date",
        "requested": "Requested",
        "completed": "Completed"
    }
}
);

$translateProvider.translations("en", {
    "filterWorkorderPriority":{
        "title": "Priority",
        "priority": {
            "emergency": "Emergency",
            "high": "High",
            "medium": "Medium",
            "low": "Low"
        },
    }
});

$translateProvider.translations("en", {
    "filterWorkorderStatus":{
        "title": "Status",
        "statuses" : {
            "newRequest": "New Request",
            "workInProgress": "Work In Progress",
            "complete": "Complete",
            "void": "Void",
            "onHold": "On Hold"
        }
    }
}
);

$translateProvider.translations("en", {
    "floorPlanList": {
        "title": "Floor Plan",
        "addFloorPlan": "Add Floor Plan Image",
        "addImage": "Add Image",
        "floorPlanHelperText": "Add Floor Plan images for your Locations. You can add an image for a single-story building, an individual wing, or each floor.",
        "allowedFileTypes": "JPEG, JPG, and PNG only",
        "assignToLocation": "Assign to a Location",
        "added": "Added",
        "newFloorPlan": "New Floor Plan",
        "floorTypes": "Floor, wing, or single-story building",
        "ariaLabels": {
            "placeholderImage": "Placeholder Image",
            "loadingSpinner": "Loading Spinner",
            "errorImage": "Error Image"
        },
        "notify": {
            "upload": {
                "error": "Cannot save",
                "success": {
                    "title": "Successfully saved Floor Plan",
                    "message": "The Floor Plan image was successfully associated with"
                }
            }
        },
        "minimumSizeError": "This image is too small - it must be at least 850 x 500",
        "maximumSizeError": "This image is too large - it must be less then 100MB's",
        "saveError": "This Location cannot have a Floor Plan. It is either part of an existing Floor Plan, or has a descendant that already has a Floor Plan image associated with it."
    }
}
);

$translateProvider.translations("en", {
    "helpers": {
       "pmAssociations":{
           "cannotInactivate": "Cannot inactivate this ",
           "cannotDisable": "Cannot disable this ",
           "itIsAssociated": " because it is associated with ",
           "theyAreAssociated": "  because they are associated with ",
           "multiPm": " active PM Schedules. Please reassign the PM Schedules.",
           "singlePm": " active PM Schedule. Please reassign the PM Schedule."
       }
    }
}
);

$translateProvider.translations("en", {
    "history": {
        "noHistory": "There is no history for this work order.",
        "viewAllHistory": "View All History",
        "loading": "Loading...",
        "slidingPanelHeader": "Work Order History",
        "from": "From:",
        "to": "To:",
        "value": "Value:",
        "perHour": "Per Hour",
        "changeTypes": {
            "Add": "Added",
            "Update": "Updated",
            "Delete": "Removed"
        },
        "changeFields": {
            "priority": "Priority",
            "description": "Description",
            "requestDateTime": "Request Date / Time",
            "dueDateTime": "Due Date",
            "scheduledStartDate": "Scheduled Start Date",
            "requestedBy": "Requested By",
            "status": "Status",
            "purpose": "Purpose",
            "workType": "Work Type",
            "businessAsset": "Location / Equipment",
            "locationDescription": "Area / Room Number",
            "completionDateTime": "Completed Date / Time",
            "completedByUser": "Completed By",
            "completedDateTime": "Completed Date / Time",
            "assignees": "Assignees",
            "actionTaken": "Action Taken",
            "estimatedCost": "Estimated Cost",
            "estimatedHours": "Estimated Hours",
            "notes": "Notes",
            "title": "Title",
            "trade": "Trade",
            "procedure": "Procedure",
            "downtimeTracking.cost": "Downtime Cost",
            "downtimeTracking.duration": "Downtime Duration",
            "downtimeTracking.failureReason": "Downtime Failure Reason",
            "project": "Project",
            "order": "Order",
            "name": "Name",
            "fileApiId": "The API ID",
            "fileApiViewToken": "The API View Token",
            "size": "Size",
            "transactionDate": "Transaction Date",
            "itemPurchased": "Item Purchased",
            "typeAttributes.laborType": "Labor Type",
            "typeAttributes.hours": "Hours",
            "typeAttributes.rate": "Hourly Rate",
            "typeAttributes.multiplier": "Rate Multiplier",
            "typeAttributes.cost": "Total Cost",
            "typeAttributes.user": "User",
            "typeAttributes.purchaseOrder": "PO #",
            "typeAttributes.quantity": "Quantity",
            "typeAttributes.unitCost": "Unit Cost",
            "typeAttributes.supplierName": "Supplier",
            "typeAttributes.serviceType": "Service Type",
            "typeAttributes.vendor": "Vendor",
            "displayId": "Work Order ID",
            "attachmentCount": "Number of Attachments",
            "url": "URL"
        },
        "objectTypes": {
            "labortransaction": "Labor Transaction",
            "servicetransaction": "Service Transaction",
            "purchasetransaction": "Purchase Transaction",
            "details": "Details",
            "task": "Task",
            "attachment": "Attachment",
            "weblink": "Link"
        },
        "status": {
            "NewRequest": "New Request",
            "OnHold": "On Hold",
            "Complete": "Complete",
            "WorkInProgress": "In Progress",
            "Void": "Void",
            "NotApplicable": "Not Applicable",
            "Incomplete": "Incomplete"
        },
        "transactionFields": {
            "EquipmentRental": "Equipment Rental",
            "Contract": "Contract",
            "Other": "Other",
            "regular": "Regular",
            "overtime": "Overtime",
            "doubletime": "Doubletime"
        }
    }
}
);

$translateProvider.translations("en", {
    "historyList": {
        "id": "ID",
        "title": "History",
        "workOrders": "Work Orders"
    }
}
);

$translateProvider.translations("en", {
    "issueToWorkOrder": {
        "title": "Select an item",
        "subtitle": "Work Order",
        "issuedFrom": "Item",
        "issuedTo": "Quantity",
        "quantityToIssue": "Quantity to Issue",
        "storageArea": "From:",
        "transferableQuantity": "Available Quantity:",
        "selectStorageArea": "Select storage area",
        "selectText": "Select an item and set a quantity to issue to this work order.",
        "selectTextAbove": "Select an item above before setting a quantity to issue to this work order.",
        "unitOfIssue": "Unit of issue:",
        "notify": {
            "moreThanZeroTitle": "Enter quantity",
            "moreThanZeroMessage": "Enter quantity to issue before saving",
            "successTitle": "Item issued successfully",
            "successMessage": "Inventory transaction has been saved to the Work Order"
        }
    }
}
);

$translateProvider.translations("en", {
    "locationReports": {
        "title": "Locations",
        "location": "Location",
        "workOrdersBy": "Work Orders By Location",
        "laborHoursBy": "Labor Hours By Location",
        "costBy": "Cost By Location"
    }
}
);

$translateProvider.translations("en", {
    "meterReading":{
        "title": "Record Usage",
        "helperMessage": "Record the new reading for this asset",
        "notify": {
            "success": {
                "title": "Saved successfully",
                "message": "Meter reading saved successfully",
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "navBar": {
        "history": "History",
        "product": "Maintenance Manager",
        "mainNav": "Main Navigation",
        "toggleNav": "Toggle Navigation",
        "accountSettings": "Account Settings",
        "admin": "Admin",
        "WOID": "Work Order ID",
        "map": "Map",
        "departments": "Departments",
        "purposes": "Purposes",
        "trades": "Trades",
        "users": "Users",
        "workTypes": "Work Types",
        "invalidId": "Invalid Work Order Id",
        "reports": "Reports",
        "calendar": "Calendar",
        "locationsOrEquipment": "Locations/Equipment",
        "floorPlanList": "Floor Plans",
        "types": "Types",
        "settings": "Settings",
        "schedules": "PM Schedules",
        "taskBooks": "Task Books",
        "projects": "Projects",
        "more": "More",
        "userSettings": "User Settings",
        "editProfile": "Edit Profile",
        "changePassword": "Change Password",
        "notificationSettings": "Notification Settings",
        "logout": "Logout",
        "requester": {
            "workOrders": "My Requests",
            "newWorkOrder": "New Request"
        },
        "import": "Import"
    },
    "helpDropdown": {
        "email": {
            "title": "mailto:support@dudesolutions.com?subject=Maintenance Manager",
            "address": "support@dudesolutions.com"
        },
        "phone": {
            "phoneDisplay": "1-877-655-DUDE (3833)",
            "phoneHref": "tel:18776553833"
        }
    }
}
);

$translateProvider.translations("en", {
    "notifications": {
        "title": "Notification Settings",
        "label": "Notifications",
        "updated": "Settings have been updated",
        "WorkOrderCreated": {
            "title": "New Work Order",
            "email": "Receive an email when a new Work Order is created"
        },
        "WorkOrderCompleted": {
            "title": "Work Order Completed",
            "email": "Receive an email when any Work Order is completed"
        },
        "WorkOrderAssigned": {
            "title": "Work Order Assigned",
            "email": "Receive an email when a Work Order is assigned to you"
        }
    }
}
);

$translateProvider.translations("en", {
    "pmScheduleAssets":{
        "select": "Select",
        "locationOrEquipment": "Location/Equipment",
        "helperMessage": "Specify the location/equipment for this schedule",
        "add": "Add"
    }
}
);

$translateProvider.translations("en", {
    "pmScheduleAssignees":{
        "select": "Select",
        "assignees": "Assignees",
        "helperMessage": "Specify the assignees for this schedule",
        "add": "Add"
    }
});

$translateProvider.translations("en", {
    "pmScheduleDetails": {
        "repeats":"Repeats",
        "schedulePattern": "Set Schedule Pattern",
        "locationOrEquipment": "Location/Equipment",
        "select": "Select",
        "nextOccurrence": "Next Occurrence",
        "assign":"Assign",
        "unassigned": "Unassigned",
        "assignees": "Assignees",
        "assignedTo": "Assigned To",
        "readings": "Reading when PM was last performed",
        "setReadings": "Set Reading",
        "startReadings": "Readings",
        "viewWorkOrders": "View Work Orders",
        "addSchedule": "Add Schedule",
        "validation": {
            "error":{
                "title": "Validation Errors",
                "message": "Cannot save please fix form errors"
            },
            "active": {
                "assignee": "This Schedule cannot be activated because the selected assignee is currently disabled. Please enable the selected assignee, or select a different assignee.",
                "workType": "This Schedule cannot be activated because the selected work type is currently inactive. Please make the selected work type active, or select a different work type.",
                "purpose": "This Schedule cannot be activated because the selected purpose is currently inactive. Please make the selected purpose active, or select a different purpose.",
                "trade": "This Schedule cannot be activated because the selected trade is currently inactive. Please make the selected trade active, or select a different trade."
            }
        },
        "deleteConfirm":{
            "title": "Delete Schedule",
            "message1": "Are you sure you want to delete this PM schedule?"
        },
        "floatingRecurrenceMessage": "after completing the previous work order (floating)",
        "meteredMessage": {
            "messagePrefix": "Every",
            "messageSuffix": "units"
        },
        "mixedMessage": {
            "or": "or",
            "every": "every"
        }
    }
}
);

$translateProvider.translations("en", {
    "pmScheduleForm": {
        "createTitle": "New PM Schedule",
        "editTitle": "Edit PM Schedule",
        "settings": "Work Order Settings",
        "estimatedHours": "Estimated Hours",
        "estimatedCost": "Estimated Cost",
        "title": "PM Title",
        "recurrenceTitle": "Repeat",
        "isActive": "Active",
        "isActiveMessage": "Work Orders are not generated for inactive schedules",
        "purpose": "Purpose",
        "assignees": "Assigned To",
        "daysToComplete": "Days to Complete",
        "trade": "Trade",
        "due":"due",
        "workOrdersAre": "Work orders are",
        "workType": "Work Type",
        "daysAfterStartDate": "days after scheduled start date",
        "spies": {
            "template": "PM Template"
        },
        "validation": {
            "estimatedHours": {
                "max": "Estimated hours must be less than 1,000",
                "min": "Hours cannot be negative"
            },
            "estimatedCost": {
                "max": "Estimated cost cannot exceed $100,000,000",
                "min": "Cost cannot be negative"
            },
            "min": "Days to Complete must be greater than 0",
            "max": "Days to Complete must be less than 1000"
        },
        "notify": {
            "success": {
                "title": "Saved Successfully",
                "message": "PM schedule was saved successfully"
            },
            "failure": {
                "title": "Cannot Save",
                "message": "Please fix form errors"
            }
        },
        "cards":{
            "schedule":{
                "title":"Scheduling",
                "body":"Set up when and how work orders are created and the assets that those orders will be associated with.",
                "button":"Add Schedule"
            },
            "task":{
                "title":"Tasks",
                "body":"Associate a list of tasks that must be completed for each work order that is associated with this PM Schedule.",
                "button":"Add Task",
                "isActive": "Active",
                "linkedTo": "Linked to"
            }
        }
    },
    "pmScheduleDelete": {
        "notify": {
            "delete": {
                "title": "Deleted successfully",
                "message": "PM schedule deleted successfully"
            }
        },
        "deleteConfirm": {
            "title": "Delete PM Schedule",
            "message": "Are you sure you want to delete this PM schedule?"
        },
        "deleteWarning": {
            "title": "Cannot Delete PM Schedule",
            "message1": "Cannot delete this PM Schedule because there are schedules associated with it or it has generated 1 or more Work Orders."
        }
    },

}
);

$translateProvider.translations("en", {
  "pmScheduleList": {
    "title": "PM Schedules",
    "schedule": "PM Title",
    "active": "Active",
    "inactive": "Inactive",
    "search": "Search Title",
    "status": "Status",
    "businessAsset": "Asset",
    "create": "Create"
  }
}
);

$translateProvider.translations("en", {
    "pmScheduleMeterReading":{
        "panelTitle": "Set Reading",
        "done": "Done",
        "helperMessage": "Enter the reading for the last time this service was performed",
        "notTrackedHeader": "Items not set for usage tracking",
        "removeWarning": "These items will be removed from this schedule"
    }
}
);

$translateProvider.translations("en", {
    "pmScheduleRecurrence":{
        "scheduling": "Scheduling",
        "frequency": "Frequency",
        "helperMessage": "Specify how often you want this PM work done",
        "add": "Add"
    }
});

$translateProvider.translations("en", {
    "projectForm": {
        "createTitle": "New Project",
        "editTitle": "Edit Project",
        "projectName": "Name",
        "budgetedAmount": "Budgeted Amount",
        "description": "Description",
        "notes": "Notes",
        "startDate": "Start Date",
        "endDate": "End Date",
        "projectNamePlaceholder": "Enter name",
        "default": "Default",
        "tracking": {
            "title": "Project Tracking",
            "purchases": "Purchases",
            "labor": "Labor",
            "services": "Services",
            "total": "Total Spent",
            "remaining": "Remaining"
        },
        "notify": {
            "success": {
                "title": "Saved successfully",
                "message": "Project saved successfully",
            }
        },
        "workOrder": {
            "association": "Project associated with ",
            "create": "Create Work Order",
            "singular": "Work Order",
            "plural": "Work Orders",
            "noAssociation": "No work orders are associated with this project"
        },
        "validation": {
            "budgetedAmount": {
                "max": "Budgeted Amount cannot exceed $999,999,999",
                "min": "Budgeted Amount cannot be negative"
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "projectList": {
        "title": "Projects",
        "name": "Name",
        "description": "Description",
        "create": "Create"
    }
}
);

$translateProvider.translations("en", {
    "purposeList": {
        "title": "Purposes",
        "name": "Name",
        "purposeType": "Category",
        "active": "Active",
        "inactive": "Inactive",
        "search": "Search Name",
        "status": "Status",
        "default": "Default",
        "create": "Create"
    }
}
);

$translateProvider.translations("en", {
    "purposePanel": {
        "editTitle": "Edit Purpose",
        "newTitle": "Create New Purpose",
        "purposeName": "Name",
        "isActive": "Active",
        "purpose": "Purpose",
        "deleteConfirm": {
            "title": "Delete Purpose",
            "message": "Are you sure you want to delete this purpose?"
        },
        "deleteModal": {
            "title": "Cannot Delete Purpose",
            "cannotInactivateTitle": "Cannot Inactivate Purpose",
            "cannotDeleteMessage": "Cannot delete this Purpose because it is associated with ",
            "workOrders": "Work Order(s)",
            "and": "and",
            "pmSchedules": "PM Schedule(s)",
            "reassignMessageWorkOrders": "Please reassign the associated Work Order(s) or inactivate this Purpose to remove it from use",
            "reassignMessagePmSchedules": "Please reassign the associated PM Schedule(s) or inactivate this Purpose to remove it from use",
            "reassignMessage": "Please reassign the associated Work Order(s) and PM Schedule(s) or inactivate this Purpose to remove it from use",
            "defaultedValue": "Cannot delete this Purpose because it is used as a default value.",
            "manageDefaults": "Change default Purpose values",
            "viewPmSchedules": "View PM Schedules",
            "viewWorkOrders": "View Work Orders"
        },
        "defaultModal": {
            "defaultedValue": "Cannot inactivate this Purpose because it is used as a default value."
        },
        "notify": {
            "delete": {
                "title": "Deleted successfully",
                "message": "Purpose deleted successfully"
            },
            "success": {
                "title": "Saved successfully",
                "message": "Purpose saved successfully"
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "purposeReports": {
        "title": "Purpose",
        "workOrdersBy": "Work Orders By Purpose",
        "laborHoursBy": "Labor Hours By Purpose",
        "costBy": "Cost By Purpose",
        "export": "Export",
        "listRoute": "List",
        "chartRoute": "Charts"
    }
}
);

$translateProvider.translations("en", {
    "reportFilters": {
        "dateRange": {
            "today": "Today",
            "yesterday": "Yesterday",
            "thisWeek": "This Week",
            "lastWeek": "Last Week",
            "thisMonth": "This Month",
            "lastMonth": "Last Month",
            "thisFiscalYear": "This Fiscal Year",
            "lastFiscalYear": "Last Fiscal Year",
            "thisCalendarYear": "This Calendar Year",
            "lastCalendarYear": "Last Calendar Year",
            "last7": "Last 7 Days",
            "last30": "Last 30 Days",
            "last90": "Last 90 Days"
        }
    }
}
);

$translateProvider.translations("en", {
    "reports": {
        "title": "Reports",
        "count": "WO Count",
        "purpose": "Purpose",
        "purposes": "Purposes",
        "locations": "Locations",
        "equipment": "Equipment",
        "totalWorkOrders": "Total Work Orders",
        "locationOrEquipment": "Location / Equipment",
        "failures": "Failures",
        "workType": "Work Type",
        "workTypes": "Work Types",
        "employees": "Employees",
        "top": "Top",
        "export": "Export",
        "totals": "Totals",
        "avg": "Avg",
        "averages": "Averages",
        "noDataMessage": "No data to display. Check your filters.",
        "byWorkOrders": {
            "workOrder": "Work Order",
            "workOrders": "Work Orders",
            "numberOf": "# of Work Orders"
        },
        "byLaborHours": {
            "hour": "Labor Hour",
            "hours": "Labor Hours"
        },
        "byCost": {
            "cost": "Cost",
            "labor": "Labor",
            "purchase": "Purchases",
            "service": "Services",
            "hours": "Hours",
            "total": "Total Costs"
        },
        "filters": {
            "completionDateFrom": "Completion Date From",
            "completionDateTo": "Completion Date To",
            "purpose": "Purposes",
            "requestDateFrom": "Requested Date From",
            "requestDateTo": "Requested Date To",
            "status": "Statuses",
            "workType": "Work Types",
            "businessAsset": "Asset",
            "assetRollUp": "Sub-Assets Included"
        },
        "statuses": {
            "OnHold": "On Hold",
            "NewRequest": "New Request",
            "WorkInProgress": "Work in Progress",
            "Complete" : "Complete",
            "Void": "Void"
        },
        "reportTitle": {
            "purpose": "Purposes Report",
            "workType": "Work Types Report",
            "locations": "Locations Report",
            "equipment": "Equipment Report"
        },
        "loadingReport": {
            "asset": "Loading Assets Report. Please wait...",
            "purpose": "Loading Purposes Report. Please wait...",
            "workType": "Loading Work Types Report. Please wait...",
            "locations": "Loading Locations Report. Please wait...",
            "equipment": "Loading Equipment Report. Please wait..."
        }
    }
}
);

$translateProvider.translations("en", {
    "settingsForm": {
        "pageTitle": "Settings",
        "saveSuccess": "Settings Saved",
        "laborRateMultipliers": {
            "sectionTitle": "Labor Rate Settings",
            "infoText": "Labor Rate Multipliers adjust the cost of a Labor Transaction, based on its selected Hours Type. Editing these values will not affect existing labor transactions.",
            "rateTypeHelperText": "Rate x",
            "otRateMultiplier": "Overtime",
            "dtRateMultiplier": "Doubletime",
            "validation": {
                "min": "Cannot be less than 1",
                "max": "Cannot be greater than 100",
                "number": "Must be a numeric value"
            }
        },
        "areaRoomNumber": {
            "sectionTitle": "Requester's Work Order Form",
            "defaultText": "Enter your room number or explain where the problem is.",
            "helperText": "Set the text that will tell the Requester what to enter into the Area / Room Number field. They will see this next to the field.",
            "helperTextSet": "Helper text",
            "isRequired": "Area / Room Number is required?",
            "yes": "Yes",
            "no": "No"
        },
        "purpose": {
            "sectionTitle": "Purpose Settings",
            "reactivePurpose": "Purpose Default for Manually Created Work",
            "helperText": "Set the default purpose for work orders created manually and via a schedule.",
            "plannedPurpose": "Purpose Default for Schedule Generated"
        },
        "spies": {
            "laborRate": "Labor Rate Settings",
            "purpose": "Purpose Settings",
            "registration": "Requester Registration",
            "requestWorkOrderForm": "Requester's Work Order Form",
            "alerts": "System-Wide Alerts"
        }
    }
}
);

$translateProvider.translations("en", {
    "statuses": {
        "newRequest": "New Request",
        "complete" : "Complete",
        "workInProgress": "Work In Progress",
        "void": "Void",
        "onHold": "On Hold"
    }
}
);

$translateProvider.translations("en", {
    "taskBookForm": {
        "editTitle": "Edit Task Book",
        "createTitle": "New Task Book",
        "tasksAndProceduresHeading": "Tasks and Procedures",
        "taskBookTitle": "Title",
        "lastUpdated": "Last Updated",
        "notify": {
            "success": {
                "title": "Saved Successfully",
                "message": "Task Book was saved successfully"
            },
            "failure": {
                "title": "Cannot Save",
                "message": "Please fix form errors"
            },
            "delete": {
                "title": "Deleted successfully",
                "message": "Task Book deleted successfully",
            }
        },
        "deleteConfirm": {
            "title": "Delete Task Book",
            "message": "Are you sure you want to delete this task book?"
        },
        "deleteWarning": {
            "title": "Cannot Delete Task Book",
            "message1a": "Cannot delete this Task Book because it is linked to",
            "message1b": "PM Schedule(s).",
            "message2": "Please unlink the Task Book from the all linked PM Schedule(s) to remove it from use."
        }
    }
}
);

$translateProvider.translations("en", {
    "taskBookList": {
        "title": "Task Books",
        "name": "Title",
        "create": "Create"
    }
}
);

$translateProvider.translations("en", {
  "taskBookSelect":{
    "selectFrom": "Select a Task Book",
    "popbox":{
      "copy": "Copy",
      "copyFrom": "Copy From",
      "link": "Link",
      "linkMessage": "When changes are made in the original Task Book, they will be reflected here.",
      "linkWarning": "Selecting a task book will overwrite any existing information already in the task list",
      "copyMessage": "Add to existing task information or replace it?"
    }
  }
}
);

$translateProvider.translations("en", {
  "taskBook": {
    "title": "Tasks and Procedures",
    "isActive": "Active",
    "addTask": "Add Tasks",
    "procedure": "Procedure",
    "notes": "Notes",
    "delete": "Delete",
    "noResults": "No tasks and/or procedures",
    "noTasksAdded": "No tasks have been entered",
    "status": {
        "incomplete": "Incomplete",
        "notApplicable": "N/A",
        "complete": "Complete"
    }
  }
}
);

$translateProvider.translations("en", {
    "tradeForm": {
        "createTitle": "New Trade",
        "editTitle": "Edit Trade",
        "tradeName": "Name",
        "trade": "Trade",
        "notify": {
            "delete": {
                "title": "Deleted successfully",
                "message": "Trade deleted successfully",
            },
            "success": {
                "title": "Saved successfully",
                "message": "Trade saved successfully",
            }
        },
        "deleteModal": {
            "title": "Cannot Delete Trade",
            "cannotDeleteMessage": "Cannot delete this Trade because it is associated with ",
            "workOrders": "Work Order(s)",
            "and": "and",
            "pmSchedules": "PM Schedule(s)",
            "reassignMessageWorkOrders": "Please reassign the associated Work Order(s) or inactivate this Trade to remove it from use",
            "reassignMessagePmSchedules": "Please reassign the associated PM Schedule(s) or inactivate this Trade to remove it from use",
            "reassignMessage": "Please reassign the associated Work Order(s) and PM Schedule(s) or inactivate this Trade to remove it from use"
        },
        "deleteConfirm": {
            "title": "Delete Trade",
            "message": "Are you sure you want to delete this trade?"
        }
    }
}
);

$translateProvider.translations("en", {
    "tradeList": {
        "title": "Trades",
        "name": "Name",
        "active": "Active",
        "inactive": "Inactive",
        "search": "Search Name",
        "status": "Status",
        "create": "Create"
    }
}
);

$translateProvider.translations("en", {
    "general": {
        "cscUser": "CSC User",
        "filters": "Filters",
        "sort": "Sort",
        "all": "All",
        "result": "Result",
        "results": "Results",
        "noResults": "No Results",
        "actionsText": "Actions",
        "edit": "Edit",
        "refineBy": "Refine By",
        "viewDetails": "View Details",
        "active": "Active",
        "inactive": "Inactive",
        "required": "Required",
        "search": "Search",
        "close": "Close",
        "selectAll": "Select All",
        "unselectAll": "Unselect All",
        "clearAll": "Clear All",
        "disabled": "Disabled",
        "notActivated": "Not Activated",
        "total": "Total",
        "hours": "Hours",
        "at": "at",
        "of": "of",
        "spent": "spent",
        "print": "Print",
        "actions": {
            "new": "New",
            "add": "Add",
            "save": "Save",
            "saveAndNext": "Save & Next",
            "saveAndEdit": "Save & Keep Editing",
            "saveAndFinish": "Save & Finish",
            "delete": "Delete",
            "cancel": "Cancel",
            "close": "Close",
            "done": "Done",
            "ok": "Ok",
            "yes": "Yes",
            "no": "No",
            "back": "Back",
            "replace": "Replace",
            "viewWorkOrders": "View Work Orders",
            "next": "Next"
        },
        "validation": {
            "required": "Required",
            "email": "Invalid Email",
            "emailAlreadyExists": "Email address already exists",
            "timeEmpty": "Please enter a time",
            "invalidNumber": "Invalid number"
        },
        "abbreviations": {
            "hours": "hrs",
            "hour": "hr"
        }
    }
}
);

$translateProvider.translations("en", {
    "userForm": {
        "user": "user",
        "createTitle": "New User",
        "editTitle": "Edit User",
        "myProfile": "My Profile",
        "firstName": "First Name",
        "lastName": "Last Name",
        "email": "Email Address",
        "role": "Role",
        "phone": "Phone Numbers",
        "addPhone": "Add Phone Number",
        "resendActivation": "Resend activation link",
        "activationSent": "Activation Sent",
        "changePassword": "Change Password",
        "hourlyRate": "Hourly Labor Rate",
        "notify": {
            "success": {
                "saveTitle": "Saved successfully",
                "saveMessage": " was saved successfully"
            }
        },
        "delete": "Delete",
        "disableLogin": "Disable Login",
        "roles": {
            "admin": "Administrator",
            "tech": "Technician",
            "requester": "Requester"
        },
        "validation": {
            "hourlyRate.max": "Labor Rate cannot exceed $100,000,000",
            "hourlyRate.min": "Labor Rate cannot be negative",
            "hourlyRate.number": "Labor Rate must be a valid currency value"
        }
    }
}
);

$translateProvider.translations("en", {
    "userList": {
        "title": "Users",
        "fullName": "Full Name",
        "name": "Name",
        "email": "Email Address",
        "import": "Import",
        "selectImport": "Select User for Import",
        "create": "Create",
        "role": "Role",
        "roles" : {
            "admin": "Administrator",
            "tech": "Technician",
            "requester": "Requester"
        }
    }
}
);

$translateProvider.translations("en", {
    "webLinkCard": {
        "openCard": "Open WebLink Card",
        "noImage": "No Image Available",
        "altDefaultPrefix": "Image pulled from ",
        "delete": "Delete"
    }
}
);

$translateProvider.translations("en", {
    "webLinkSection": {
        "title": "Links",
        "noLinks": "No links have been added",
        "addLink": "Add Link",
        "deleteModal": {
            "title": "Delete Web Link",
            "message": "Are you sure you want to delete this web link?"
        },
        "notify": {
            "deleted": {
                "title": "Deleted Successfully",
                "message": "Web link deleted successfully."
            }
        }
    },
    "webLinkSlidingPanel": {
        "title": "Add URL/Link",
        "formDescription": "Enter the web address that you would like to attach to this ",
        "businessAsset": "asset.",
        "workOrder": "work order.",
        "url": "URL/Link",
        "name": "Name",
        "description": "Description",
        "thumbnail": "Thumbnail",
        "clear": "Clear",
        "refresh": "Refresh",
        "noThumbnail": "Enter a URL above to view the site thumbnail",
        "refreshForThumbnail": "Please refresh the URL to retrieve the site thumbnail",
        "updateData": "Website name and description could not be retrieved. You may enter it below.",
        "notify": {
            "couldNotSave": "Could Not Save",
            "duplicate": {
                "message": "A link already exists with this URL."
            },
            "invalidUrl": {
                "message": "Please provide a complete url including http:// or https://"
            },
            "saved": {
                "title": "Saved Successfully",
                "message": "Web link saved successfully."
            }
        },
        "validation": {
            "url": "Invalid URL format"
        },
        "altDefaultPrefix": "Image pulled from "
    }
}
);

$translateProvider.translations("en", {
    "workOrderCalendar": {
        "month": "Month",
        "today": "Today",
        "noScheduledWork": "No scheduled work found",
        "day": "Day",
        "assignment": "Assignment",
        "dayPmProjections": "PMs scheduled to fall on this date",
        "assignee": "Assignee",
        "print": "Print",
        "updateDayLeft": "Left Chevron",
        "updateDayRight": "Right Chevron",
        "updateMonthLeft": "Left Chevron",
        "updateMonthRight": "Right Chevron"

    }
}
);

$translateProvider.translations("en", {
    "workOrderComments": {
        "done": "Done",
        "edited": "Edited",
        "delete": "Delete",
        "cancel": "Cancel",
        "postComment": "Post Comment",
        "editComment": "Edit Comment",
        "comments": "Comments",
        "submitted": "Submitted",
        "commentBelow": "Add your comment below",
        "requesterVisible": "Visible to Requesters",
        "privateComment": "This comment is not visible to Requesters",
        "notify": {
            "delete": {
                "title": "Deleted Successfully",
                "message": "Comment deleted successfully"
            },
            "deleteConfirm": {
                "title": "Delete Comment",
                "message": "Are you sure you want to delete this Comment?"
            },
            "save": {
                "title":  "Saved Successfully",
                "message": "Comment saved successfully"
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "workOrderFilters": {
        "q": "Search",
        "quickFilter": "Quick Filter",
        "overdue": "Overdue",
        "unscheduled": "Unscheduled",
        "status": "Status",
        "requestDate": "Requested",
        "completionDate": "Completed Date",
        "dueDate": "Due Date",
        "scheduledStartDate": "Scheduled Start Date",
        "description": "Description",
        "dateFrom": "Date From",
        "dateTo": "Date To",
        "locationOrEquipment": "Location/Equipment",
        "location": "Location",
        "assignee": "Assignee",
        "failureReason": "Failure Reason",
        "workType": "Work Type",
        "purpose": "Purpose",
        "project": "Project",
        "trade": "Trade",
        "showUnassigned": "Show unassigned only",
        "includeSubItems": "Include sub-items",
        "priority": {
            "text": "Priority",
            "emergency": "Emergency",
            "high": "High",
            "medium": "Medium",
            "low": "Low"
        },
        "dateRanges": {
            "next7": "Next 7 Days",
            "next30": "Next 30 Days",
            "unscheduled": "Unscheduled",
            "all": "All"
        },
        "dateIncrements": {
            "today": "Today",
            "yesterday": "Yesterday",
            "lastWeek": "Last Week",
            "thisWeek": "This Week",
            "nextWeek": "Next Week",
            "thisMonth": "This Month",
            "nextMonth": "Next Month",
        }
    }
}
);

$translateProvider.translations("en", {
    "workOrderForm": {
        "new": "New Work Order",
        "edit": "Work Order ",
        "newRequest": "New Request",
        "completion": "Completion",
        "requestedBy": "Requested By",
        "requestDate": "Request Date",
        "dueDate": "Due Date",
        "planning": "Planning",
        "scheduledStart": "Scheduled Start Date",
        "estimatedHours": "Estimated Hours",
        "estimatedCost": "Estimated Cost",
        "notificationTitle": "Saved Successfully",
        "notification": "Work Order saved successfully",
        "description": "Description",
        "workType": "Work Type",
        "requesterWorkType": "Type of Work Needed",
        "purpose": "Purpose",
        "project": "Project",
        "assignedTo": "Assigned To",
        "trade": "Trade",
        "locationOrEquipment": "Location/Equipment",
        "requesterAsset": "Specify Where",
        "assetInWarranty": "Asset In Warranty",
        "assetViewDetails": "View Details",
        "assetRecordUsage": "Record Usage",
        "completionDate": "Completion Date",
        "totalCost": "Total Cost",
        "actionTaken": "Action Taken",
        "failureReason": "Failure Reason",
        "createdBy": "Created By",
        "createdTimeLabel": "Created Date",
        "systemGenerated": "System Generated",
        "upload": "Upload",
        "details": "Details",
        "viewHistory": "View History",
        "lastUpdated": "Last updated",
        "areaRoomNumber": "Area / Room Number",
        "validation": {
            "totalCost.max": "Total Cost must be less than $100,000,000",
            "totalCost.min": "Total Cost cannot be negative",
            "totalCost.number": "Total Cost must be a valid currency value",
            "completionDateBeforeMin": "Completion Date must be on or after Request Date",
            "requestDateAfterMax": "Request Date must be on or before Completion Date",
            "estimatedHours": {
                "max": "Estimated hours must be less than 1,000",
                "min": "Hours cannot be negative"
            },
            "estimatedCost": {
                "max": "Estimated cost cannot exceed $100,000,000",
                "min": "Cost cannot be negative"
            },
            "downtime": {
                "hours": {
                    "max": "Hours must be less than 10,000",
                    "min": "Hours cannot be negative"
                },
                "minutes": {
                    "max": "Minutes must be less than 60",
                    "min": "Minutes cannot be negative"
                },
                "cost": {
                    "max": "Cost cannot exceed $100,000,000",
                    "min": "Cost cannot be negative"
                }
            }
        },
        "priority": {
            "text": "Priority",
            "emergency": "Emergency",
            "high": "High",
            "medium": "Medium",
            "low": "Low"
        },
        "status": {
            "text": "Status",
            "newRequest": "New Request",
            "inProgress": "Work In Progress",
            "onHold": "On Hold",
            "complete": "Complete",
            "void": "Void"
        },
        "downtime": {
            "text": "Downtime",
            "cost": "Cost",
            "hours": "Hours",
            "minutes": "Minutes"
        },
        "notify": {
            "deleteAttachment": {
                "title": "Deleted Successfully",
                "message": "has been deleted successfully"
            },
            "upload": {
                "successBody": "has been attached to the work order successfully"
            }
        },
        "statusChange": {
            "title": "Removing Completion Date",
            "message": "You are changing the status away from Complete. The existing Completion Date will be removed."
        }
    }
}
);

$translateProvider.translations("en", {
    "workOrderFormReadOnly": {
        "title": "Request",
        "about": {
            "title": "About",
            "description": "Description",
            "location": "Location",
            "locationOrEquipment": "Location/Equipment",
            "typeOfWork": "Type of Work Needed",
            "trade": "Trade",
            "purpose": "Purpose",
            "areaRoomNumber": "Area / Room Number"
        },
        "details": {
            "title": "Details",
            "status": "Status",
            "assignedTo": "Assigned To",
            "requested": "Requested",
            "project": "Project",
            "completionNotes": "Completion Notes",
        }
    }
}
);

$translateProvider.translations("en", {
    "workOrderHistoryFilters": {
        "title": "Filters",
        "actions": {
            "apply": "Apply"
        },
        "clearFilters": "Clear Filters",
        "searchPlaceholder": "Search Work Order ID or Description",
        "dateIncrements": {
            "thisWeek": "This Week",
            "lastWeek": "Last Week",
            "thisMonth": "This Month",
            "lastMonth": "Last Month"
        },
        "dateRange": "Date Of Change",
        "usersTitle": "User",
        "fieldsChanged": "Fields Changed",
        "fieldTitles": {
            "details": "Details",
            "planning": "Planning",
            "tasks": "Tasks",
            "completion": "Completion",
            "attachments": "Attachments",
            "laborTransactions": "Labor Transactions",
            "purchaseTransactions": "Purchase Transactions",
            "serviceTransactions": "Service Transactions",
            "links": "Links"
        }
    }
}
);

$translateProvider.translations("en", {
    "workOrderHistorySummary": {
        "locationEquipment": "Location / Equipment",
        "description": "Description",
        "viewWorkOrder": "View Work Order",
        "workOrderID": "Work Order ID",
        "user": "User"
    }
}
);

$translateProvider.translations("en", {
    "workOrderInventory": {
        "availableQuantity": "Quantity",
        "description": "Description",
        "items": "Items",
        "title": "Inventory",
        "noTransactions": "No inventory items have been issued"
    }
}
);

$translateProvider.translations("en", {
    "workOrderList": {
        "title": "Work Orders",
        "create": "Create",
        "workOrders": "Work Orders",
        "workOrder": "Work Order",
        "results": "Results",
        "woid": "ID",
        "wo": "WO",
        "status": "Status",
        "requested": "Requested",
        "purpose": "Purpose",
        "assignedTo": "Assignee",
        "assignees": "Assignees",
        "actionTaken": "Action Taken",
        "noResults": "No Results",
        "noResultsFound": "No Results Found",
        "filters": "Filters",
        "unassigned": "Unassigned",
        "export": "Export",
        "map": "Map",
        "createNew": "Create New Request",
        "myRequests": "My Requests",
        "completed": "Completed",
        "recurring": "Recurring",
        "dueDateSort": "Due Date Sort",
        "sort": "Sort",
        "start": "Start",
        "complete": "Complete",
        "newestToOldest": "Newest to Oldest",
        "oldestToNewest": "Oldest to Newest",
        "daysLeftToComplete": "Days left to complete",
        "updateAssignee": "Assign",
        "assignTo": "Assign To",
        "updateScheduling": "Scheduling",
        "scheduledStart": "Scheduled Start Date",
        "dueDate": "Due Date",
        "scheduledEnd": "Scheduled End Date",
        "laborHours": "Labor Hours",
        "dateOfWork": "Date of Work",
        "selected": "Selected",
        "assign": "Assign",
        "workType": "Work Type",
        "bulkActions": {
            "addAssignee": "Add Assignee(s)",
            "replaceAssignee": "Replace Assignee(s)",
            "assigneeName": "Assign To",
            "updatedSuccessfully": "Work Order(s) updated successfully",
            "printSummary": "Print Summary List",
            "printForms": "Print WO Forms",
            "printLabels": {
                "display": "Loading Work Orders, Please wait.",
                "loading": "Loading..."
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "workOrderTasks": {
        "title": "Tasks",
        "addTasks": "Add Tasks",
        "addTask": "Add Task"
    }
}
);

$translateProvider.translations("en", {
    "transactions": {
        "title": "Transactions",
        "labor": "Labor",
        "purchase": "Purchases",
        "service": "Services",
        "totalCosts": "Total Costs",
        "date": "Date",
        "details": "Details",
        "type": "Type",
        "cost": "Cost",
        "serviceTypes": {
            "contract": "Contracted Service",
            "rental": "Rental",
            "other": "Other Service"
        },
        "dropDown": {
            "addTransaction": "Add Transaction",
            "labor": "Labor",
            "purchase": "Purchase",
            "service": "Service"
        },
        "abbreviations": {
            "overtime": "OT",
            "doubletime": "DT"
        },
        "noTransactions": "No transactions have been entered",
        "validation": {
            "laborHours": {
                "max": "Hours must be less than 1,000",
                "min": "Hours must be greater than 0",
                "number": "Hours must be a valid number"
            },
            "purchaseQuantity": {
                "max": "Quantity cannot exceed 9,999.99",
                "min": "Quantity cannot be less than -9,999.99"
            },
            "purchaseItemCost": {
                "max": "Unit cost cannot exceed $100,000,000",
                "min": "Unit cost cannot be negative"
            },
            "serviceTotalCost": {
                "max": "Total cost cannot exceed $999,999.99",
                "min": "Total cost cannot be negative"
            }
        },
        "notify": {
            "saveTransaction": {
                "title": "Transaction Saved Successfully",
                "message": "Transaction has been saved to the Work Order"
            },
            "deleteTransaction": {
                "title": "Deleted Successfully",
                "message": "Transaction has been successfully deleted"
            }
        },
        "transactionsPanel": {
            "new": "New Labor",
            "edit": "Edit Labor",
            "view": "View Labor",
            "hours": "Hours",
            "type": "Type",
            "name": "Name",
            "date": "Date",
            "labor": {
                "regular": "Regular",
                "overtime": "Overtime (OT)",
                "doubletime": "Doubletime (DT)"
            }
        },
        "purchaseTransactionsPanel": {
            "new": "New Purchase",
            "edit": "Edit Purchase",
            "view": "View Purchase",
            "item": "Item Purchased",
            "name": "Purchased By",
            "date": "Date",
            "po": "PO #",
            "supplier": "Supplier",
            "quantity": "Quantity",
            "unitCost": "Unit Cost",
            "totalCost": "Total Cost"
        },
        "serviceTransactionsPanel": {
            "new": "New Service",
            "edit": "Edit Service",
            "view": "View Service",
            "type": "Service Type",
            "contract": "Contract",
            "rental": "Rental",
            "other": "Other",
            "vendor": "Vendor",
            "date": "Invoice Date",
            "cost": "Total Cost",
            "po": "PO #",
            "notes": "Notes"
        },
        "deleteModal": {
            "title": "Delete Transaction",
            "message": "Are you sure you want to delete this transaction?"
        }
    }
}
);

$translateProvider.translations("en", {
    "workTypeList": {
        "title": "Work Types",
        "workType": "Work Type",
        "create": "Create",
        "name": "Name",
        "active": "Active",
        "inactive": "Inactive",
        "search": "Search Name",
        "status": "Status",
        "category": "Category",
        "newWorkType": "New Work Type",
        "editWorkType": "Edit Work Type",
        "notify": {
            "success": {
                "title": "Saved successfully",
                "message": "Work Type saved successfully",
            }
        }
    },
    "workTypePanel": {
        "isActive":"Active",
        "deleteConfirm": {
            "title": "Delete Work Type",
            "message": "Are you sure you want to delete this work type?"
        },
        "deleteModal": {
            "title": "Cannot Delete Work Type",
            "cannotDeleteMessage": "Cannot delete this Work Type because it is associated with ",
            "workOrders": "Work Order(s)",
            "and": "and",
            "pmSchedules": "PM Schedule(s)",
            "reassignMessageWorkOrders": "Please reassign the associated Work Order(s) or inactivate this Work Type to remove it from use",
            "reassignMessagePmSchedules": "Please reassign the associated PM Schedule(s) or inactivate this Work Type to remove it from use",
            "reassignMessage": "Please reassign the associated Work Order(s) and PM Schedule(s) or inactivate this Work Type to remove it from use"
        },
        "notify": {
            "delete": {
                "title": "Deleted successfully",
                "message": "Work Type deleted successfully"
            },
            "success": {
                "title": "Saved successfully",
                "message": "Work Type saved successfully"
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "workTypeReports": {
        "title": "Work Types",
        "workOrdersBy": "Work Orders By Work Type",
        "laborHoursBy": "Labor Hours By Work Type",
        "costBy": "Cost By Work Type",
        "export": "Export",
        "listRoute": "List",
        "chartRoute": "Charts"
    }
}
);

$translateProvider.translations("en", {
    "assetUsage": {
        "infoText": "This allows you to enter new usage readings directly on work orders. Create PM Schedules to have work orders created based on entered readings.",
        "setupUnit": "Setup Unit",
        "reading": "Reading",
        "newReading": "New Reading",
        "lastReading": "Last Reading",
        "stopTracking": "Stop Tracking",
        "resumeTracking": "Resume Tracking",
        "nextWorkOrderGeneration": "A work order will be generated",
        "for": "for",
        "immediately": "immediately",
        "list":{
            "recordedDate": "Recorded Date",
            "readingType": "Reading Type"
        },
        "stopTrackingModal": {
            "title": "Cannot Stop Tracking",
            "cannotStopTrackingMessage": "Cannot stop tracking on this asset because it is associated with a mixed and/or Usage based PM Schedule",
            "removeMessage": "Please remove asset from the associated PM Schedule(s) or inactivate the schedule.",
            "viewPmSchedules": "View PM Schedules"
        }
    }
}
);

$translateProvider.translations("en", {
    "filterActionsButton": {
        "label": "Actions",
        "actions": {
        	"edit" : "Edit My Filter",
        	"clear": "Clear Filter"
        }
    }
}
);

$translateProvider.translations("en", {
    "myFiltersButton": {
    	"buttonLabel": "My Filters",
    	"saveCurrentFilters": "Save Current Filters",
        "clearFilters": "Clear Filters",
        "noSavedFilters": "No Saved Filters"
    }
}
);

$translateProvider.translations("en", {
    "slidingFilterPanel": {
        "title": "Filters",
        "clearFilters": "Clear Filters",
        "apply": "Apply",
        "applyFilterWithoutSaving": "Apply Filter Without Saving",
        "saveAndApply": "Save And Apply",
        "saveAsNewFilter": "Save As New Filter",
        "deleteFilter": "Delete Filter",
        "cancel": "Cancel",
        "back": "Back",
        "notify": {
            "delete": {
                "title": "Deleted successfully",
                "message": "Saved Filter deleted successfully"
            },
            "success": {
                "title": "Saved successfully",
                "message": "Saved Filter saved successfully"
            }
        }
    }
}
);

$translateProvider.translations("en", {
    "accountAlertSettings": {
        "sectionTitle": "System-Wide Alert",
        "helperText": "You can set a system-wide alert here for all of your users to see while they are logged in.",
        "message": {
            "label": "Message"
        },
        "roles": {
            "label": "Who can see this?"
        },
        "buttons": {
            "create": "Create Alert",
            "post": "Post",
            "delete": "Delete"
        },
        "notifications": {
            "post": {
                "success":  {
                    "title": "Alert Set Successfully",
                    "message": "System-wide alert has been set successfully"
                },
                "failure": {
                    "title": "Could Not Set Alert"
                }
            },
            "delete": {
                "success":  {
                    "title": "Alert Deleted Successfully",
                    "message": "System-wide alert has been deleted successfully"
                },
                "failure": {
                    "title": "Could Not Delete Alert"
                }
            }
        },
        "deleteModal": {
            "title": "Delete alert?",
            "message": "The message will be removed and users will no longer see this alert once it has been deleted."
        }
    }
}
);

$translateProvider.translations("en", {
    "registrationLink": {
        "requesterRegistration": {
            "sectionTitle": "Requester Registration",
            "helperText": "There are two ways to provide requesters access to Maintenance Manager registration.",
            "share": {
                "label": "Share Registration Link",
                "subLabel": "Users can register as requesters by following this link.",
                "copyButton": "Copy Registration Link",
                "generateButton": "Generate New Link",
                "deactivateButton": "Deactivate Link"
            },
            "send": {
                "label": "Send Registration Link via Email",
                "subLabel": "Separate emails with commas, semicolons, or line breaks.",
                "emailButton": "Email Registration Link",
                "notify": {
                    "error": {
                        "title": "Cannot Send",
                        "message": "Please fix form errors."
                    },
                    "success": {
                        "title": "Link Sent Successfully",
                        "message": "Registration link has been sent successfully"
                    }
                }
            },
            "deleteModal": {
                "title": "Delete Registration Link",
                "message": "Are you sure you want to remove your requester registration link?",
                "notifyMessage": "Successfully deleted registration link",
                "notifyTitle": "Deleted Link"
            },
            "regenerateModal": {
                "title": "Regenerate Registration Link",
                "message": "Are you sure you want to generate a new requester registration link? This will disable the existing link from use.",
                "notifyMessage": "Successfully generated new registration link",
                "notifyTitle": "Generated link"
            },
            "copyTitle": "Copy Link",
            "copyMessage": "Registration link copied to clipboard",
            "isActive": "Active",
            "error": {
                "emails": "Please fix the following emails: "
            }
        }
    }
}
);
}]);

'use strict';

angular.module('asset-attribute-engine', [
    'asset-attribute-date',
    'asset-attribute-boolean',
    'asset-attribute-double',
    'asset-attribute-integer',
    'asset-attribute-money',
    'asset-attribute-string',
    'asset-attribute-databound-manufacturer',
    'units-of-measure',
    'dudeApi'
]);

'use strict';

angular.module('workOrder', ['helpers', 'workOrderForm', 'workOrderFormReadOnly', 'workOrderTransactions', 'workOrderTasks', 'workOrderList', 'workOrderFilters', 'workOrderCalendarMonth', 'workOrderCalendarDay']);

'use strict';

angular.module('user', ['userForm', 'userList']);

'use strict';

// The dependencies for translate must be declared in this order or translations will fail in testing declaring $translateProvider undefined.
// So the angular translate dependency 'pascalprecht.translate' must be declared first.
angular.module('translate', ['pascalprecht.translate', 'translations']);

angular.module("maintenance").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/assetFilters/assetFilters.html","<sliding-filter-panel open-when=assetListFilters.openWhen filters=assetListFilters.filters set-function=assetListFilters.setFunction({value}) clear-function=assetListFilters.clearFunction() active-saved-filter=assetListFilters.activeSavedFilter disable-my-filters=true><div class=radio ng-if=\"assetListFilters.parentAsset.id != null\"><label><input type=radio ng-model=assetListFilters.filters.searchFromCurrentNode ng-value=false> {{::\'assetList.searchFromRoot\' | translate}}</label></div><div class=radio ng-if=\"assetListFilters.parentAsset.id != null\"><label><input type=radio ng-model=assetListFilters.filters.searchFromCurrentNode ng-value=true> {{::\'assetList.searchFromCurrentNode\' | translate}} <em>{{ assetListFilters.parentAsset.name }}</em></label></div><filter-search filter=assetListFilters.filters.q></filter-search><filter-storage-area ng-if=assetListFilters.showStorageAreas filter=assetListFilters.storageAreaParams></filter-storage-area><filter-asset-category filter=assetListFilters.filters.isLocation gulp sliding-panel-display=false is-open=true></filter-asset-category><filter-status filter=assetListFilters.filters.isActive ng-if=!assetListFilters.hideStatus></filter-status><filter-business-asset-type filters=assetListFilters.filters></filter-business-asset-type><filter-asset-usage filter=assetListFilters.filters.isMetered></filter-asset-usage></sliding-filter-panel>");
$templateCache.put("app/components/assetFloorPlanView/assetFloorPlanView.html","<div class=asset-floor-plan-view><h4>{{::\'assetFloorPlanView.title\' | translate }}</h4><div class=\"row content-section\"><div class=\"col-xs-2 floor-button-section\"><button class=\"btn btn-inverse btn-sm\" ng-click=assetFloorPlanView.navigateToFloorPlanList()><i class=\"fa fa-chevron-left\" aria-hidden=true></i> {{::\'assetFloorPlanView.floorPlans\' | translate }}</button></div><div class=\"col-xs-8 text-center header-text\"><div class=asset-name><strong>{{::assetFloorPlanView.floorPlan.businessAsset.name}}</strong></div><div class=bread-crumb-section><bread-crumbs ng-if=\"assetFloorPlanView.floorPlan.businessAsset.ancestorIdPath !== \'\'\" no-links=true asset=assetFloorPlanView.floorPlan.businessAsset></bread-crumbs></div></div></div><img ng-src={{assetFloorPlanView.imageUrl}} alt=\"{{::\'assetFloorPlanView.floorPlanFor\' | translate }} {{::assetFloorPlanView.floorPlan.businessAsset.name}}\"></div>");
$templateCache.put("app/components/assetForm/assetDeleteConfirmModal.html","<div class=modal-header><h4 class=title>{{::\'assetForm.deleteConfirm.title\' | translate}}</h4></div><div class=modal-body><div class=error-container><p>{{::\'assetForm.deleteConfirm.message\' | translate}} <span ng-if=count>{{::\'assetForm.deleteConfirm.message2\' | translate}}</span></p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/assetForm/assetDeleteWarningModal.html","<div class=modal-header><h4 class=title>{{::\'assetForm.deleteModal.title\' | translate}}</h4></div><div class=modal-body><div class=error-container><p>{{::\'assetForm.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{count}}{{::\'assetForm.deleteModal.inventoryTransactions\' | translate}}</strong></p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/assetForm/assetForm.html","<div class=row><div class=col-sm-10><div class=\"row header-container\"><div class=col-xs-12 id=formHeader scroll-spy-on spy-text=\"{{:: \'assetForm.details\' | translate}}\" spies=assetForm.spies spy-position=1><h4>{{::(assetForm.asset.id ? \'assetForm.editTitle\' : \'assetForm.createTitle\') | translate}}</h4></div></div><form name=form novalidate navigation-warning form=form skip-navigation-warning=assetForm.skipNavigationWarning><div class=\"main-container assetForm\"><div class=content-section><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.name.$invalid && (form.name.$touched || assetForm.saveAttempt)}\"><label for=name>{{::\'assetForm.name\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate }} </span><input type=text id=name name=name required maxlength=100 class=form-control placeholder=\"\" ng-model=assetForm.asset.name focus-on=true ng-pattern=assetForm.regex><p class=text-danger ng-messages=form.name.$error ng-if=\"form.name.$touched || assetForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=pattern>{{::\'assetForm.validation.invalidCharacter\' | translate }}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>{{::\'assetForm.parent\' | translate}}</label><assets-typeahead ng-model=assetForm.asset.parent inline=true multi-select=false exclude-items=assetForm.excludeItems browse-options=assetForm.assetBrowseOptions></assets-typeahead></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=description>{{::\'assetForm.description\' | translate}}</label><input class=\"form-control hidden-print\" id=description name=description ng-model=assetForm.asset.description maxlength=512></div><div class=form-group><label for=notes>{{::\'assetForm.notes\' | translate }}</label><text-area id=notes textarea-name=notes ng-model=assetForm.asset.notes maxlength=2000 maxlines=10></text-area></div></div></div><div class=row ng-if=assetForm.hasInventory><div class=\"col-xs-12 form-group\"><div class=checkbox ng-class=\"{\'disabled\': !assetForm.hasWorkOrderAssetUpdatePermission}\"><label><input type=checkbox ng-disabled=!assetForm.hasWorkOrderAssetUpdatePermission ng-model=assetForm.asset.isWorkOrderAsset> {{::\'assetForm.workOrderAsset\' | translate}}</label></div><div class=checkbox ng-class=\"{\'disabled\': !assetForm.hasInventoryStorageAreaUpdatePermission || assetForm.hasQuantity, \'inventoryDisabledQuantity\': assetForm.hasQuantity}\"><label><input type=checkbox ng-disabled=\"!assetForm.hasInventoryStorageAreaUpdatePermission || assetForm.hasQuantity\" ng-model=assetForm.asset.isInventoryStorageArea> {{::\'assetForm.inventoryStorageArea\' | translate}}</label></div><em class=text-warning ng-if=\"assetForm.hasQuantity && assetForm.hasInventoryStorageAreaUpdatePermission\">*{{::\'assetForm.hasQuantityWarning\' | translate}}</em></div></div><hr><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.businessAssetCategory.$invalid && (form.businessAssetCategory.$touched || assetForm.saveAttempt)}\"><label for=assetCategory>{{:: \'assetForm.assetCategory\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate }}</span><asset-categories-typeahead ng-model=assetForm.asset.businessAssetCategory ng-required=true multi-select=false></asset-categories-typeahead><p class=text-danger ng-messages=form.businessAssetCategory.$error ng-if=\"form.businessAssetCategory.$touched || assetForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.businessAssetType.$invalid && (form.businessAssetType.$touched || assetForm.saveAttempt)}\"><label for=assetType>{{:: \'assetForm.assetType\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate }}</span><asset-types-typeahead ng-model=assetForm.asset.businessAssetType ng-required=true name=assetType multi-select=false additional-filters=assetForm.assetTypeFilter ng-disabled=\"assetForm.asset.businessAssetCategory === null\"></asset-types-typeahead><p class=text-danger ng-messages=form.businessAssetType.$error ng-if=\"form.businessAssetType.$touched || assetForm.saveAttempt\"><span ng-message=required ng-if=\"assetForm.asset.businessAssetCategory !== null\">{{::\'general.validation.required\' | translate }}</span> <span ng-message=required ng-if=\"assetForm.asset.businessAssetCategory === null\">{{::\'assetForm.validation.categoryNullError\' | translate }}</span></p></div></div></div><div class=row><div class=col-xs-12><div class=checkbox has-permissions=BusinessAssets-Delete ng-if=\"assetForm.asset.id != null\"><label><input type=checkbox ng-model=assetForm.asset.isActive> {{::\'assetForm.isActive\' | translate }}</label></div><em class=text-danger ng-if=\"!assetForm.asset.isActive && assetForm.asset.hasChildren > 0\" has-permissions=BusinessAssets-Delete><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i>&nbsp; {{::\'assetForm.inactiveWarning\' | translate}}</em></div></div><!-- this field exists so that we can invalidate the form while a file is uploading --> <input type=hidden name=uploadCheck ng-model=uploadCheck></div></div><!-- asset attribute section - driven by category + type --><div><div class=\"row sub-header-container\"><div class=col-xs-12><h5 id=attributesSection scroll-spy-on spies=assetForm.spies spy-text=\"{{\'assetForm.attributes\' | translate}}\" spy-position=2>{{:: \'assetForm.attributes\' | translate}}</h5></div></div><div class=content-section><div class=no-results ng-if=!assetForm.asset.businessAssetCategory><h6><em class=\"text-muted ng-binding\">{{:: \'assetForm.noAttributesMessage\' | translate}}</em></h6></div><!-- the ng-show is necessary due to the child scope created by the assetAttributeEngine and its caching mechanism--><asset-attribute-engine ng-show=assetForm.asset.businessAssetCategory asset-category=assetForm.asset.businessAssetCategory base-attribute-types=assetForm.asset.businessAssetCategory.businessAssetAttributeTypes asset-type=assetForm.asset.businessAssetType extension-attribute-types=assetForm.asset.businessAssetType.businessAssetAttributeTypes asset-attributes=assetForm.asset.businessAssetAttributes country={{::assetForm.country}}></asset-attribute-engine></div></div><!-- end asset attribute section --><!--Meter Attributes--><div ng-if=\"assetForm.meteredAttributes().length > 0\"><div class=\"row sub-header-container\"><div class=col-xs-9><h5 id=meteringSection scroll-spy-on spies=assetForm.spies spy-text=\"{{\'assetForm.metering.title\' | translate}}\" spy-position=3>{{::\'assetForm.metering.title\' | translate}}</h5></div></div><div class=content-section><asset-usage ng-repeat=\"assetAttribute in assetForm.meteredAttributes()\" asset-attribute=assetAttribute country={{assetForm.country}} save-attempt=assetForm.saveAttempt asset=assetForm.asset></asset-usage></div></div><!--End Meter Attributes--><attachments files=assetForm.files file=assetForm.file delete=assetForm.deleteAttachment spies=assetForm.spies ng-show=\"assetForm.files.length > 0\"></attachments><web-link-section links=assetForm.links spies=assetForm.spies object-id=assetForm.asset.id spy-position=5 entity=businessAsset ng-if=\"assetForm.links.length > 0\"></web-link-section><web-link-sliding-panel open-when=assetForm.openWebLinksPanel links=assetForm.links object-id=assetForm.asset.id link-index=null entity=businessAsset></web-link-sliding-panel><!--Build a form cards--><div class=row><div class=\"col-sm-6 col-md-4\" ng-if=\"assetForm.hasMeterableAttributes() && assetForm.meteredAttributes().length === 0\"><div class=\"content-section cards-row-container\"><div class=card><div class=card-header><h4>{{::\'assetForm.buildAForm.assetUsage.cardHeader\' | translate }}</h4></div><div class=card-body>{{::\'assetForm.buildAForm.assetUsage.cardBody\' | translate }}</div><input type=hidden ng-model=assetUsageCard name=assetusagecard ng-required=false><div class=card-footer><button class=\"btn btn-default\" ng-click=assetForm.showAssetUsage()>{{::\'assetForm.buildAForm.assetUsage.buttonText\' | translate }}</button></div></div></div></div><div class=\"col-sm-6 col-md-4\" ng-if=\"!assetForm.files || assetForm.files.length === 0\"><div class=\"content-section cards-row-container\"><div class=card><div class=card-header><h4>{{::\'assetForm.attachments.title\' | translate}}</h4></div><div class=card-body>{{::\'assetForm.cards.attachment.body\' | translate}}</div><div class=card-footer><button class=\"btn btn-default\" ng-click=assetForm.addAttachment()>{{::\'assetForm.cards.attachment.button\' | translate}}</button></div></div></div></div><div class=\"col-sm-6 col-md-4\" ng-if=\"!assetForm.links || assetForm.links.length === 0\"><div class=\"content-section cards-row-container\"><div class=card><div class=card-header><h4>{{::\'assetForm.links.title\' | translate}}</h4></div><div class=card-body>{{::\'assetForm.cards.link.body\' | translate}}</div><div class=card-footer><button class=\"btn btn-default\" ng-click=assetForm.addLinks()>{{::\'assetForm.cards.link.button\' | translate}}</button></div></div></div></div></div><!--End Build a form cards--></form><div class=\"row action-row-fixed hidden-print\"><div class=container><div class=\"col-xs-12 col-sm-6\"><save-button form=form click-function=assetForm.saveAsset() save-attempt=assetForm.saveAttempt></save-button><div ng-show=\"assetForm.asset.id && (assetForm.asset.isActive || assetForm.isAdmin)\" class=\"btn-group dropup\" uib-dropdown is-open=action.isopen><a class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=disabled>{{::\'general.actionsText\' | translate}} <i class=\"fa fa-caret-down\"></i></a><ul class=dropdown-menu role=menu><li ng-if=assetForm.asset.isActive class=cursor-pointer><a ui-sref=\"secure.workOrderFormNew({businessAsset: assetForm.asset.id})\">{{::\'assetList.createWorkOrder\' | translate}}</a></li><li class=cursor-pointer><a ui-sref=\"secure.workOrderList({businessAsset: assetForm.asset.id, status: \'all\', includeDescendants: \'true\', assignees: \'none\'})\">{{::\'assetList.viewWorkOrders\' | translate}}</a></li><li class=cursor-pointer><a ui-sref=\"secure.pmScheduleList({businessAssets: assetForm.asset.id})\" ng-click=$event.stopPropagation()>{{::\'assetList.viewPmSchedules\' | translate}}</a></li><li ng-if=assetForm.asset.isActive class=cursor-pointer><a ui-sref=\"secure.assetCreate({parentId: assetForm.asset.id})\">{{::\'assetList.addLocationOrEquipment\' | translate}}</a></li><li class=divider></li><li class=cursor-pointer has-permissions=BusinessAssets-Delete><a ng-click=assetForm.deleteAsset() ng-disabled=form.$invalid class=text-danger>{{::\'assetForm.assetTools.deleteLocationOrEquipment\' | translate}}</a></li></ul></div></div></div></div></div><div class=\"col-sm-2 hidden-xs\"><scroll-spy anchors=assetForm.spies header-offset=assetForm.headerOffset></scroll-spy></div></div>");
$templateCache.put("app/components/assetList/assetList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-sm-12><div class=pull-left><h4 ng-if=!assetList.isPmSchedule>{{::\'assetList.title\' | translate}}<results-message total=assetList.filterState.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\" aria-label=\"{{::\'assetList.sort\' | translate}}\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button ng-click=assetList.assetCreate() ng-if=!assetList.isPmSchedule ng-disabled=\"assetList.parentAsset != null && !assetList.parentAsset.isActive\" class=\"btn btn-primary btn\" aria-label=\"{{::\'assetList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline-block\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></button></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header ng-if=!assetList.isPmSchedule><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"assetList.sort(\'Name\')\"><strong>{{::\'assetList.name\' | translate}}<sort-icon property=assetList.sortable.Name></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div></div><filter-bar clear-function=assetList.clearFilters() toggle-filters=assetList.assetFilter() filters=assetList.filters disable-my-filters=assetList.disableMyFilters></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 col-sm-12 content-body content-section\"><div class=\"row breadcrumb-container\"><div class=col-xs-12><!-- Asset List Breadcrumbs--><bread-crumbs path=\"{{::\'assetList.showing\' | translate}}\" root=\"{{::\'assetList.all\' | translate}}\" asset=assetList.parentAsset last-as-link=false sref=secure.assetList ng-if=!assetList.isPmSchedule></bread-crumbs><!-- PM Schedule List Breadcrumbs--><bread-crumbs path=\"{{::\'assetList.location\' | translate }}\" root=\"{{::\'assetList.all\' | translate}}\" asset=assetList.parentAsset last-as-link=false on-click=\"assetList.pmScheduleBreadcrumb(leaf); $event.stopPropagation()\" ng-if=assetList.isPmSchedule></bread-crumbs></div></div><div class=row ng-if=assetList.isPmSchedule><div class=col-xs-12><button class=\"btn btn-default btn-sm\" ng-click=assetList.selectAll()>{{::\'general.selectAll\' | translate}}</button></div></div><div class=row ng-if=assetList.isPmSchedule><div class=\"col-xs-12 grid-header\"></div></div><div class=\"row hidden-xs grid-header\" ng-if=!assetList.isPmSchedule><div class=\"col-sm-12 asset-list-row\"><div class=asset-list-offset-header><div class=row><div class=\"col-sm-7 title\"><strong class=cursor-pointer ng-click=\"assetList.sort(\'Name\')\">{{::\'assetList.name\' | translate}}<sort-icon property=assetList.sortable.Name></sort-icon></strong></div><div class=col-sm-4><strong class=cursor-pointer ng-click=\"assetList.sort(\'BusinessAssetCategory/Name\')\">{{::\'assetList.category\' | translate}}<sort-icon property=\"assetList.sortable[\'BusinessAssetCategory/Name\']\"></sort-icon></strong></div></div></div></div></div><div class=\"col-sm-12 no-results\" ng-if=\"assetList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div ng-if=!assetList.isPmSchedule ng-include=\"\'app/components/assetList/assetListRow.html\'\"></div><div ng-if=assetList.isPmSchedule ng-include=\"\'app/components/assetList/pmScheduleAssetListRow.html\'\"></div><div class=row><div class=col-sm-12 ng-hide=\"assetList.filterState.totalCount <= assetList.filters.pageSize\"><ul uib-pagination total-items=assetList.filterState.totalCount ng-model=assetList.filters.page ng-change=assetList.pageChanged() items-per-page=assetList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><meter-reading open-when=assetList.panelOpen asset=assetList.asset></meter-reading><asset-filters open-when=assetList.openAssetFilterSlidingPanel filters=assetList.filters parent-asset=assetList.parentAsset show-storage-areas=assetList.hasInventory set-function=assetList.setFilters(value) clear-function=assetList.clearFilters()></asset-filters>");
$templateCache.put("app/components/assetList/assetListRow.html","<div class=\"row grid-row grid-row-unclickable asset-list-row\" ng-repeat=\"asset in assetList.listData track by asset.id\"><div class=\"col-xs-12 asset-list-wrapping-column\"><div class=asset-hierarchy-container><div class=asset-hierarchy-button-wrapper><button class=\"btn btn-default btn-circle center-block\" ng-if=asset.hasChildren ng-click=\"assetList.getChild(asset); $event.stopPropagation()\" aria-label=\"{{::\'assetList.showChild\' | translate}}\"><i class=\"fa text-muted fa-lg fa-sitemap\" aria-hidden=true></i></button></div></div><div class=asset-content-container><div class=asset-content-sub-container><div class=row ng-click=assetList.edit(asset)><div class=\"col-xs-7 break-word title asset-list-column\"><strong>{{::asset.name}}</strong> <span class=\"label label-warning\" ng-if=!asset.isActive>{{::\'assetList.inactive\' | translate}}</span><br><span ng-bind-html=\"::asset.description | linebreaks\"></span><br><div class=truncate ng-if=assetList.showAssetRowBreadCrumb()><bread-crumbs root=\"{{::\'assetList.assets\' | translate}}\" asset=asset no-links=true sref=secure.assetList></bread-crumbs></div></div><div class=\"col-xs-3 asset-list-column\"><span class=font-secondary>{{::asset.businessAssetCategory.name}}</span></div><div class=\"col-xs-2 asset-list-column\"><div class=\"btn-group dropdown pull-right\" uib-dropdown is-open=action.isopen ng-click=$event.stopPropagation();><button type=button class=\"btn btn-default btn-sm asset-actions\" uib-dropdown-toggle ng-disabled=disabled ng-click=$event.stopPropagation() aria-label=\"\'{{::\'assetList.actionDropDown\' | translate}}\"><span class=hidden-xs>{{::\'general.actionsText\' | translate}} <i class=\"fa fa-caret-down\" aria-hidden=true></i> </span><span class=visible-xs-inline-block><i class=\"fa fa-ellipsis-h\"></i></span></button><ul class=dropdown-menu role=menu><li ng-if=asset.isActive class=cursor-pointer><a ui-sref=\"secure.assetCreate({ parentId: asset.id })\" ng-click=$event.stopPropagation()>{{::\'assetList.addLocationOrEquipment\' | translate}}</a></li><li class=divider ng-if=asset.isActive></li><li ng-if=asset.isMetered class=cursor-pointer><a ng-click=\"$event.stopPropagation(); assetList.openPanel(asset)\">{{::\'assetList.recordUsage\' | translate }}</a></li><li ng-if=asset.isActive class=cursor-pointer><a ui-sref=\"secure.workOrderFormNew({businessAsset: asset.id})\" ng-click=$event.stopPropagation()>{{::\'assetList.createWorkOrder\' | translate}}</a></li><li class=cursor-pointer><a ui-sref=\"secure.workOrderList({businessAsset: asset.id, status: \'all\', includeDescendants: \'true\', assignees: \'none\'})\" ng-click=$event.stopPropagation()>{{::\'assetList.viewWorkOrders\' | translate}}</a></li><li class=cursor-pointer ng-if=!assetList.isTechnician><a ui-sref=\"secure.pmScheduleList({businessAssets: asset.id})\" ng-click=$event.stopPropagation()>{{::\'assetList.viewPmSchedules\' | translate}}</a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/components/assetList/pmScheduleAssetListRow.html","<div class=\"row grid-row grid-row-unclickable\" ng-repeat=\"asset in assetList.listData track by asset.id\"><div class=\"pull-left pmschedule-asset-list-row-action\"><input type=checkbox ng-click=assetList.selectAsset(asset) ng-checked=assetList.isSelected(asset)><button class=\"btn btn-default btn-circle\" ng-if=asset.hasChildren ng-click=\"assetList.getChild(asset); $event.stopPropagation()\" aria-label=\"{{::\'assetList.getAsset\' | translate}}\"><i class=\"fa text-muted fa-lg fa-sitemap\" aria-hidden=true></i></button></div><div class=\"col-xs-8 col-sm-10 break-word\"><strong>{{::asset.name}}</strong><br><span ng-bind-html=\"::asset.description | linebreaks\"></span><br><bread-crumbs root=\"{{::\'assetList.assets\' | translate}}\" path=\"\" asset=asset no-links=true sref=secure.assetList></bread-crumbs></div></div>");
$templateCache.put("app/components/assetReport/assetReportChart.html","<div><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-link hidden-xs\" has-markets=\"assetReport.market.k12, assetReport.market.he, assetReport.market.ips\" ng-click=assetReport.printCharts()>{{::\'general.print\' | translate}}</button> <button class=\"btn btn-default\" ng-click=assetReport.listRoute() aria-label=\"{{::\'assetReport.listRoute\' | translate}}\"><i class=\"fa fa-list\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 sort-body content-section visible-xs\" ng-class=\"{\'hidden-xs\': hideFiltersMobile}\"><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=assetReport.clearFilters() toggle-filters=assetReport.assetReportFilter() set-function=\"assetReport.setFilters(value, save)\" filters=assetReport.filters disable-my-filters=false></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><report-navigation filters=assetReport.filters></report-navigation><div ng-if=assetReport.showDrilldown><report-drill-down-chart is-location=true filters=assetReport.filters chart-type=\"\'workOrder\'\" drill-down-data=assetReport.drillDownData></report-drill-down-chart><report-drill-down-chart is-location=true filters=assetReport.filters chart-type=\"\'cost\'\" drill-down-data=assetReport.drillDownData></report-drill-down-chart><report-drill-down-chart is-location=true filters=assetReport.filters chart-type=\"\'labor\'\" drill-down-data=assetReport.drillDownData></report-drill-down-chart></div><div ng-if=!assetReport.showDrilldown><div class=\"border-bottom work-order-chart chart-wrapper interactive-chart\"><charting chart-data=assetReport.workOrderChartData chart-labels=assetReport.workOrderLabels chart-type=\"\'bar\'\" click-function=assetReport.clickFunctionObject></charting></div><div class=\"border-bottom cost-chart chart-wrapper\"><charting chart-data=assetReport.costChartData chart-labels=assetReport.costLabels chart-type=\"\'stacked-bar\'\" chart-legend=assetReport.costLegend></charting></div><div class=\"labor-hours-chart chart-wrapper\"><charting chart-data=assetReport.laborChartData chart-labels=assetReport.laborHoursLabels chart-type=\"\'bar\'\"></charting></div></div></div></div></div></div><report-filters filters=assetReport.filters set-function=\"assetReport.setFilters(value, save)\" open-when=assetReport.openWhen clear-function=assetReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/assetReport/assetReportList.html","<div class=report-list><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile=true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button class=\"btn btn-link hidden-xs\" ng-if=assetReport.filterState.totalCount ng-click=assetReport.export()>{{::\'reports.export\' | translate}}</button> <button class=\"btn btn-default\" ng-click=assetReport.chartRoute() aria-label=\"{{::\'assetReport.chartRoute\' | translate}}\"><i class=\"fa fa-bar-chart\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\': hideSortMobile}\"><div class=filter-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=row><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"assetReport.sort(\'Asset/Value\')\"><strong><span>{{::assetReport.title}}</span><sort-icon property=\"assetReport.sortable[\'Asset/Value\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"assetReport.sort(\'Count/WorkOrders\')\"><strong>{{::\'reports.count\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Count/WorkOrders\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Count/WorkOrders\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"assetReport.sort(\'Count/LaborHours\')\"><strong>{{::\'general.hours\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Count/LaborHours\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Count/LaborHours\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"assetReport.sort(\'Cost/Labor\')\"><strong>{{::\'reports.byCost.labor\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Labor\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Labor\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"assetReport.sort(\'Cost/Purchase\')\"><strong>{{::\'reports.byCost.purchase\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Purchase\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Purchase\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"assetReport.sort(\'Cost/Service\')\"><strong>{{::\'reports.byCost.service\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Service\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Service\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"assetReport.sort(\'Cost/Total\')\"><strong>{{::\'general.total\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Total\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Total\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=assetReport.clearFilters() toggle-filters=assetReport.assetReportFilter() set-function=\"assetReport.setFilters(value, save)\" filters=assetReport.filters disable-my-filters=false></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><report-navigation filters=assetReport.filters></report-navigation><report-list-totals ng-if=\"assetReport.listData.length !== 0\" data=assetReport.totalListData></report-list-totals><div class=\"row hidden-xs grid-header\"><div class=col-sm-2><strong class=cursor-pointer ng-click=\"assetReport.sort(\'Asset/Value\')\" ng-class=\"{\'drill-down-first-column\':assetReport.isLocation}\"><span>{{assetReport.title}}</span><sort-icon property=\"assetReport.sortable[\'Asset/Value\']\"></sort-icon></strong></div><div class=col-sm-10><div class=row><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"assetReport.sort(\'Count/WorkOrders\')\">{{::\'reports.count\' | translate}}<sort-icon ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Count/WorkOrders\']\"></sort-icon><sort-icon ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Count/WorkOrders\']\"></sort-icon></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"assetReport.sort(\'Count/LaborHours\')\"><div>{{::\'general.total\' | translate}}</div><div class=column-header>{{::\'general.hours\' | translate}}<sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Count/LaborHours\']\"></sort-icon><sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Count/LaborHours\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"assetReport.sort(\'Cost/Labor\')\"><div>{{::\'general.total\' | translate}}</div><div class=column-header>{{::\'reports.byCost.labor\' | translate}}<sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Labor\']\"></sort-icon><sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Labor\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"assetReport.sort(\'Cost/Purchase\')\"><div>{{::\'general.total\' | translate}}</div><div class=column-header>{{::\'reports.byCost.purchase\' | translate}}<sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Purchase\']\"></sort-icon><sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Purchase\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"assetReport.sort(\'Cost/Service\')\"><div>{{::\'general.total\' | translate}}</div><div class=column-header>{{::\'reports.byCost.service\' | translate}}<sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Service\']\"></sort-icon><sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Service\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"assetReport.sort(\'Cost/Total\')\"><div>{{::\'general.total\' | translate}}</div><div class=column-header>{{::\'reports.byCost.cost\' | translate}}<sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp !== \'true\'\" property=\"assetReport.sortable[\'Cost/Total\']\"></sort-icon><sort-icon class=sort-icon-align ng-if=\"assetReport.filters.assetRollUp === \'true\'\" property=\"assetReport.sortable[\'TotalsWithDescendants/Cost/Total\']\"></sort-icon></div></strong></div></div></div></div><div class=\"col-sm-12 no-results\" ng-if=\"assetReport.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><asset-report-drilldown-list list-data=assetReport.listData filters=assetReport.filters entity=\"\'WorkTypesSummaryEntity\'\" ng-if=assetReport.showDrilldown></asset-report-drilldown-list><div class=\"row grid-row cursor-pointer\" ng-if=!assetReport.showDrilldown ng-repeat=\"value in assetReport.listData\" ng-click=assetReport.viewWorkOrders(value.asset.id)><div class=\"col-sm-2 truncate\"><span class=hidden-xs>{{::value.asset.value}}</span> <span class=\"visible-xs text-medium-weight\">{{::value.asset.value}}</span></div><div class=\"col-sm-10 hidden-xs\"><div class=row><div class=col-sm-2><span class=pull-right>{{::value.count.workOrders | number}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.count.laborHours| number:2}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.labor | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.service | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.total | currency}}</span></div></div></div><div class=col-xs-12><bread-crumbs ng-if=\"value.asset.ancestorIdPath !== \'\'\" no-links=true asset=value.asset></bread-crumbs></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <span class=pull-right>{{::value.count.workOrders | number}}</span></div><div><span>{{::\'reports.byLaborHours.hours\' | translate}}</span> <span class=pull-right>{{::value.count.laborHours | number:2}}</span></div></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'general.total\' | translate}}</span> <span class=pull-right>{{::value.cost.total | currency}}</span></div><div><span>{{::\'reports.byCost.labor\' | translate}}</span> <span class=pull-right>{{::value.cost.labor | currency}}</span></div><div><span>{{::\'reports.byCost.purchase\' | translate}}</span> <span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div><span>{{::\'reports.byCost.service\' | translate}}</span> <span class=pull-right>{{::value.cost.service | currency}}</span></div></div></div><div class=row><div class=col-sm-12 ng-hide=\"assetReport.filterState.totalCount <= assetReport.filters.pageSize\"><ul uib-pagination total-items=assetReport.filterState.totalCount ng-model=assetReport.filters.page ng-change=assetReport.pageChanged() items-per-page=assetReport.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><report-filters filters=assetReport.filters set-function=\"assetReport.setFilters(value, save)\" open-when=assetReport.openWhen clear-function=assetReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/assetTypeForm/assetCategoryAttributes.html","<div><ul class=asset-type-attribute><li ng-repeat=\"attributeType in assetCategoryAttributes.attributeTypes\"><span>{{::attributeType._translatedKey}}</span></li></ul></div>");
$templateCache.put("app/components/assetTypeForm/assetTypeDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'assetTypeForm.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'assetTypeForm.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/assetTypeForm/assetTypeDeleteWarningModal.html","<div class=modal-header><h4><span class=title>{{::\'assetTypeForm.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'assetTypeForm.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{count}}{{::\'assetTypeForm.deleteModal.assets\' | translate}}</strong></p><p>{{::\'assetTypeForm.deleteModal.reassignMessage\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/assetTypeForm/assetTypeForm.html","<div class=\"row header-container\"><div class=col-xs-12><h4 ng-if=assetTypeForm.assetType.isDudeAssetType>{{::\'assetTypeForm.dudeAsset\' | translate}}</h4><h4 ng-if=!assetTypeForm.assetType.isDudeAssetType>{{::(assetTypeForm.assetType.id ? \'assetTypeForm.editTitle\' : \'assetTypeForm.createTitle\') | translate}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.name.$invalid && form.name.$touched}\"><label for=name>{{::\'assetTypeForm.assetTypeName\' | translate}}</label><span class=\"label label-default text-capitalize\" ng-if=!assetTypeForm.assetType.isDudeAssetType>{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=name required maxlength=100 class=form-control placeholder=\"\" ng-model=assetTypeForm.assetType.name ng-readonly=assetTypeForm.assetType.isDudeAssetType focus-on=true><p class=text-danger ng-messages=form.name.$error ng-if=\"form.name.$touched || assetTypeForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=form-group><label for=name>{{::\'assetTypeForm.assetCategory\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><div class=row><div class=col-xs-12><div class=checkbox><label class=checkbox-inline ng-repeat=\"category in assetTypeForm.assetCategories\"><input type=checkbox ng-model=assetTypeForm.selectedCategories[category.id] ng-disabled=assetTypeForm.assetType.isDudeAssetType> {{::category.name}}</label></div></div></div><div class=row><div class=col-md-3 ng-repeat=\"category in assetTypeForm.assetCategories\" ng-if=assetTypeForm.selectedCategories[category.id]><label>{{::category.name}}</label><asset-category-attributes category=category></asset-category-attributes></div></div><input type=hidden name=categoryCheck ng-model=categoryRequired><p class=text-danger ng-messages=form.categoryCheck.$error ng-if=\"assetTypeForm.assetType.businessAssetCategories.length === 0\"><span ng-message=categoryRequired>{{::\'general.validation.required\' | translate }}</span></p></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=checkbox ng-if=assetTypeForm.assetType.id><label><input type=checkbox ng-model=assetTypeForm.assetType.isActive> {{::\'assetTypeForm.isActive\' | translate}}</label></div></div></div></form></div><div class=\"row action-row\"><div class=col-xs-12><save-button form=form click-function=assetTypeForm.saveAssetType() save-attempt=assetTypeForm.saveAttempt></save-button><button class=\"btn btn-link text-danger\" ng-if=!assetTypeForm.assetType.isDudeAssetType ng-click=assetTypeForm.deleteAssetType() ng-show=assetTypeForm.assetType.id>{{::\'general.actions.delete\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/assetTypeList/assetTypeList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'assetTypeList.title\' | translate}}<results-message total=assetTypeList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\" aria-label=\"{{::\'assetTypeList.create\' | translate}}\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\':assetTypeList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <a ui-sref=secure.assetTypeCreate class=\"btn btn-primary\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"assetTypeList.sort(\'Name\')\"><strong>{{::\'assetTypeList.name\' | translate}}<sort-icon property=assetTypeList.sortable.Name></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'assetTypeListFiltersForm\'\" filters=assetTypeList.filters clear-filters=assetTypeList.clearFilters()><filter-search filter=assetTypeList.filters.q></filter-search><filter-status filter=assetTypeList.filters.isActive></filter-status></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-5><strong class=cursor-pointer ng-click=\"assetTypeList.sort(\'Name\')\">{{::\'assetTypeList.name\' | translate}}<sort-icon property=assetTypeList.sortable.Name></sort-icon></strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"assetTypeList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-click=assetTypeList.editAssetType(assetType.id) ng-repeat=\"assetType in assetTypeList.listData track by assetType.id\"><div class=col-xs-8>{{::assetType.name}}</div><div class=col-xs-4><div class=\"label label-warning\" ng-if=::!assetType.isActive>{{::\'assetTypeList.inactive\' | translate}}</div></div></div><div class=row><div class=col-sm-12 ng-hide=\"assetTypeList.totalCount <= assetTypeList.filters.pageSize\"><ul uib-pagination total-items=assetTypeList.totalCount ng-model=assetTypeList.filters.page ng-change=assetTypeList.pageChanged() items-per-page=assetTypeList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/changePassword/changePassword.html","<div class=\"row header-container\"><div class=col-xs-12><h4>{{:: \'changePassword.title\' | translate}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.currentPassword.$invalid && (form.currentPassword.$touched || changePassword.saveAttempt)}\"><label for=currentPassword>{{::\'changePassword.currentPassword\' | translate}}</label><input type=password id=currentPassword name=currentPassword required class=form-control ng-model=changePassword.passwords.oldPassword><p class=text-danger ng-messages=form.currentPassword.$error ng-if=\"form.currentPassword.$touched || changePassword.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=matchesOld>{{::\'changePassword.validation.old\' | translate }}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.newPassword.$invalid && (form.newPassword.$touched || changePassword.saveAttempt)}\"><label for=newPassword>{{::\'changePassword.newPassword\' | translate}}</label><input type=password id=newPassword name=newPassword required class=form-control ng-model=changePassword.passwords.newPassword password-length-validator password-validator><p class=text-danger ng-messages=form.newPassword.$error ng-if=\"form.newPassword.$touched || changePassword.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=validLength>{{::\'changePassword.validation.length\' | translate}}</span> <span ng-message=validPassword>{{::\'changePassword.validation.invalid\' | translate }}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.reenterPassword.$invalid && (form.reenterPassword.$touched || changePassword.saveAttempt)}\"><label for=reenterPassword>{{::\'changePassword.reenterPassword\' | translate}}</label><input type=password id=reenterPassword name=reenterPassword required class=form-control ng-model=changePassword.passwords.reenterPassword password-length-validator password-validator match-password-validator=changePassword.passwords.newPassword><p class=text-danger ng-messages=form.reenterPassword.$error ng-if=\"form.reenterPassword.$touched || changePassword.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=validLength>{{::\'changePassword.validation.length\' | translate}}</span> <span ng-message=validPassword>{{::\'changePassword.validation.invalid\' | translate }}</span> <span ng-message=matchPassword>{{::\'changePassword.validation.match\' | translate }}</span></p></div></div></div></form></div><div class=\"row action-row\"><div class=\"col-xs-12 col-sm-6\"><save-button form=form click-function=changePassword.changePassword() save-attempt=changePassword.saveAttempt></save-button></div></div></div>");
$templateCache.put("app/components/dashboard/dashboard.html","<div class=\"row header-container\"><div class=col-xs-12><h4>{{::\'dashboard.title\' | translate}}</h4></div></div><div has-markets=\"dashboard.market.mfg, dashboard.market.club, dashboard.market.other, dashboard.market.gov\"><mfg-admin-dashboard></mfg-admin-dashboard></div><div has-markets=\"dashboard.market.k12, dashboard.market.he, dashboard.market.ips\"><k12-tech-dashboard ng-if=dashboard.isTechnician></k12-tech-dashboard><k12-admin-dashboard ng-if=\"!dashboard.isTechnician && !dashboard.isRequester\"></k12-admin-dashboard></div>");
$templateCache.put("app/components/departmentForm/departmentForm.html","<div class=\"row header-container\"><div class=col-xs-12><h4 class=inline-block>{{::(departmentForm.department.id ? \'departmentForm.editTitle\' : \'departmentForm.createTitle\') | translate}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.name.$invalid && (form.name.$touched || departmentForm.saveAttempt)}\"><label for=name>{{::\'departmentForm.departmentName\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=name required maxlength=50 class=form-control placeholder=\"\" ng-model=departmentForm.department.name focus-on=true><p class=text-danger ng-messages=form.name.$error ng-if=\"form.name.$touched || departmentForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div><div class=checkbox><label><input type=checkbox ng-model=departmentForm.department.isActive> {{::\'general.active\' | translate}}</label></div></div></div></form></div><div class=\"row action-row\"><div class=col-xs-12><save-button form=form click-function=departmentForm.saveDepartment() save-attempt=departmentForm.saveAttempt></save-button><a class=\"btn btn-link\" ui-sref=secure.departmentList>{{::\'general.actions.cancel\' | translate}}</a></div></div></div>");
$templateCache.put("app/components/departmentList/departmentList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'departmentList.title\' | translate}}<results-message total=departmentList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\" aria-label=\"{{::\'departmentList.create\' | translate}}\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\': departmentList.isFilterApplied()}\" aria-hidden=true></i></button> <a ui-sref=secure.departmentCreate class=\"btn btn-primary\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'departmentListFiltersForm\'\" filters=departmentList.filters clear-filters=departmentList.clearFilters()><filter-search filter=departmentList.filters.q></filter-search></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-5><strong class=cursor-pointer>{{::\'departmentList.name\' | translate}}</strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"departmentList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><a ui-sref=\"secure.departmentEdit({id: department.id})\" class=\"row grid-row cursor-pointer\" ng-repeat=\"department in departmentList.listData track by department.id\"><span class=col-xs-8>{{::department.name}} </span><span class=col-xs-4><span class=\"label label-warning\" ng-if=::!department.isActive>{{::\'general.inactive\' | translate}}</span></span></a><div class=row><div class=col-sm-12 ng-hide=\"departmentList.totalCount <= departmentList.filters.pageSize\"><ul uib-pagination total-items=departmentList.totalCount ng-model=departmentList.filters.page ng-change=departmentList.pageChanged() items-per-page=departmentList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/employeeReport/employeeReportFilters.html","<div><sliding-filter-panel open-when=employeeReportFilter.openWhen filters=employeeReportFilter.filters set-function=\"employeeReportFilter.setFunction({value, save})\" clear-function=employeeReportFilter.clearFunction({removeMyFilter})><filter-report-date-range filters=employeeReportFilter.filters date-values=employeeReportFilter.dateRanges title=employeeReportFilter.dateFilterTitle cleared=employeeReportFilter.cleared></filter-report-date-range><filter-work-type has-markets=\"employeeReportFilter.market.k12, employeeReportFilter.market.he, employeeReportFilter.market.ips\" filter=employeeReportFilter.filters.workType></filter-work-type><filter-purpose filter=employeeReportFilter.filters.purpose></filter-purpose><filter-assets filter=employeeReportFilter.filters.businessAsset include-descendants=employeeReportFilter.checkbox.state hide-check-box=employeeReportFilter.assetHideCheckBox browse-options=employeeReportFilter.assetBrowseOptions></filter-assets><filter-user filter=employeeReportFilter.filters.assignees title=employeeReportFilter.assigneeTitle roles=employeeReportFilter.assigneeRoles ignore-checkbox=true multi-select=true show-disabled=true></filter-user></sliding-filter-panel></div>");
$templateCache.put("app/components/employeeReport/employeeReportList.html","<div><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile=true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button class=\"btn btn-link hidden-xs\" ng-if=employeeReport.filterState.totalCount ng-click=employeeReport.export()>{{::\'employeeReports.export\' | translate}}</button></div></div></div><div class=\"main-container employee-report\"><div class=\"col-sm-push-9 col-sm-3 sort-body content-section visible-xs\" ng-class=\"{\'hidden-xs\': hideSortMobile}\"><div class=filter-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=row><div class=col-xs-12><ul class=list-unstyled><li><strong>{{::\'employeeReports.title\' | translate}}</strong></li><li class=cursor-pointer ng-click=\"employeeReport.sort(\'laborHours\')\"><strong>{{::\'employeeReports.hoursLogged\' | translate}}<sort-icon property=\"employeeReport.sortable[\'laborHours\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"employeeReport.sort(\'completedWorkOrders\')\"><strong>{{::\'employeeReports.completedWO\' | translate}}<sort-icon property=\"employeeReport.sortable[\'completedWorkOrders\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=employeeReport.clearFilters() toggle-filters=employeeReport.employeeReportFilter() set-function=\"employeeReport.setFilters(value, save)\" filters=employeeReport.filters></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 col-sm-12 content-body content-section\"><report-navigation filters=employeeReport.filters></report-navigation><div class=\"row hidden-xs grid-header\"><div class=col-sm-5><strong class=employee-name>{{::\'employeeReports.title\' | translate}}</strong></div><div class=col-sm-3><strong class=\"pull-right cursor-pointer\" ng-click=\"employeeReport.sort(\'completedWorkOrders\')\">{{::\'employeeReports.completedWO\' | translate}}<sort-icon property=\"employeeReport.sortable[\'completedWorkOrders\']\"></sort-icon></strong></div><div class=col-sm-3><strong class=\"pull-right cursor-pointer\" ng-click=\"employeeReport.sort(\'laborHours\')\">{{::\'employeeReports.hoursLogged\' | translate}}<sort-icon property=\"employeeReport.sortable[\'laborHours\']\"></sort-icon></strong></div></div><div class=\"col-xs-12 no-results\" ng-if=\"employeeReport.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row grid-row-unclickable\" ng-repeat=\"employee in employeeReport.listData\"><div class=\"col-xs-12 drill-down-col\" ng-class=\"{\'drill-down-open\': employee.showLabor === true,\n                                        \'drill-down-chevron\': employee.completedWorkOrders !== 0 || employee.laborHours !== 0,\n                                        \'no-drill-down\': employee.completedWorkOrders === 0 && employee.laborHours === 0}\"><div class=row><div class=col-xs-12 ng-click=employeeReport.getDrillDownData(employee)><div class=row><div class=col-sm-5><div class=\"inline-block employee-name\">{{::employee.assignee.firstName}} {{::employee.assignee.lastName}}</div><div class=\"label label-default inline-block disabled-employee\" ng-if=::!employee.assignee.isEnabled>{{::\'general.disabled\' | translate}}</div></div><div class=\"col-sm-3 col-xs-6\"><div class=\"inline-block pull-left visible-xs\">{{::\'employeeReports.completedWO\' | translate}}</div><div class=\"inline-block pull-right\">{{employee.completedWorkOrders}}</div></div><div class=\"col-sm-3 col-xs-6\"><div class=\"inline-block pull-left visible-xs\">{{::\'employeeReports.hoursLogged\' | translate}}</div><div class=\"inline-block pull-right\">{{employee.laborHours}}</div></div></div></div></div></div><div class=col-sm-12><div uib-collapse=!employee.showLabor class=drill-down><div class=\"row grid-header hidden-xs\"><div class=col-sm-5><strong class=truncate>{{::\'employeeReports.workOrder\' | translate}}</strong></div><div class=\"col-sm-4 drill-down-padding\"><strong has-markets=\"employeeReport.market.k12, employeeReport.market.he, employeeReport.market.ips\">{{::\'employeeReports.workType\' | translate}} </strong><strong has-markets=\"employeeReport.market.mfg, employeeReport.market.club, employeeReport.market.other\">{{::\'employeeReports.trade\' | translate}}</strong></div><div class=\"col-sm-2 drill-down-padding\"><strong class=pull-right>{{::\'general.hours\' | translate}}</strong></div></div><div class=drill-down-list><a class=\"row labor-transaction\" ng-repeat=\"transaction in employee.laborTransactions\" ui-sref=\"secure.workOrderFormEdit({id: transaction.workOrderId})\"><div class=\"col-xs-12 visible-xs truncate\"><span>{{::transaction.displayId}} - {{::transaction.description}}</span></div><div class=\"col-xs-4 visible-xs\"><span>{{::transaction.laborHours}} {{::\'general.hours\' | translate}}</span></div><div class=\"col-sm-5 hidden-xs truncate\"><span>{{::transaction.displayId}} - {{::transaction.description}}</span></div><div class=\"col-sm-4 col-xs-8\"><span has-markets=\"employeeReport.market.k12, employeeReport.market.he, employeeReport.market.ips\">{{::transaction.workTypeName}} </span><span has-markets=\"employeeReport.market.mfg, employeeReport.market.club, employeeReport.market.other\">{{::transaction.tradeName}}</span></div><div class=\"col-sm-2 hidden-xs drill-down-padding\"><span class=pull-right>{{::transaction.laborHours}}</span></div></a><div class=row ng-if=\"employee.totalTransactions > 1000\"><div class=\"col-xs-12 text-center\"><em>{{::\'employeeReports.top1000\' | translate}}</em></div></div></div><div class=row ng-if=!employee.laborTransactions.length><div class=\"col-xs-12 text-center drill-down-no-results\"><em>{{::\'employeeReports.noHours\' | translate}}</em></div></div><div class=row><div class=col-xs-12><div class=drill-down-footer><em class=drill-down-no-results ng-if=!employee.completedWorkOrders>{{::\'employeeReports.noCompletedWorkOrders\' | translate}}</em> <a ui-sref=\"secure.workOrderList({assignees: employee.assignee.id,\n                                                                                  status: employeeReport.complete,\n                                                                                  completionDateFrom: employeeReport.filters.dateFrom,\n                                                                                  completionDateTo: employeeReport.filters.dateTo,\n                                                                                  workType: employeeReport.filters.workType,\n                                                                                  purpose: employeeReport.filters.purpose,\n                                                                                  businessAsset: employeeReport.filters.businessAsset,\n                                                                                  includeDescendants: employeeReport.filters.includeDescendants})\" ng-if=employee.completedWorkOrders>{{::employee.completedWorkOrders}}<ng-pluralize count=employee.completedWorkOrders when=\"{\'1\': \' {{::&quot;employeeReports.completedWorkOrder&quot; | translate}}\',\n                                                           \'other\': \' {{::&quot;employeeReports.completedWorkOrders&quot; | translate}}\' }\"></ng-pluralize></a></div></div></div></div></div></div><div class=row><div class=col-xs-12 ng-if=\"employeeReport.filterState.totalCount > employeeReport.filters.pageSize\"><ul uib-pagination total-items=employeeReport.filterState.totalCount ng-model=employeeReport.filters.page ng-change=employeeReport.pageChanged() items-per-page=employeeReport.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><employee-report-filters open-when=employeeReport.openWhen filters=employeeReport.filters asset-toggle=assetRollUp set-function=\"employeeReport.setFilters(value, save)\" clear-function=employeeReport.clearFilters(removeMyFilter)></employee-report-filters></div>");
$templateCache.put("app/components/equipmentReport/equipmentChart.html","<asset-report-chart is-location=false init-data=equipmentReport.initData></asset-report-chart>");
$templateCache.put("app/components/equipmentReport/equipmentList.html","<asset-report-list is-location=false init-data=equipmentReport.initData report-title=equipmentReport.title></asset-report-list>");
$templateCache.put("app/components/failureReport/failureReportChart.html","<div><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\' : failureReport.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default\" ng-click=failureReport.listRoute() aria-label=\"{{::\'failureReports.listRoute\' | translate}}\"><i class=\"fa fa-list\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 sort-body content-section visible-xs\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=failureReport.clearFilters() toggle-filters=failureReport.failureReportFilter() set-function=\"failureReport.setFilters(value, save)\" filters=failureReport.filters></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><report-navigation filters=failureReport.filters></report-navigation><div class=\"interactive-chart work-order-chart chart-wrapper\"><charting chart-data=failureReport.assetChartData chart-labels=failureReport.assetLabels chart-type=\"\'bar\'\" click-function=failureReport.clickFunctionObject></charting></div><div ng-if=\"failureReport.screenSize.breakpoint > 768\"><pop-box name={{failureReport.DRILLDOWN_POPBOX}} show-arrow=true backdrop-close=false open-on-init=false close-fn=failureReport.clearSelection() button-close=true><div class=row><div class=col-xs-6><h6><strong>{{failureReport.activeAsset.name}}</strong></h6></div><div ng-if=\"failureReport.activeAsset.value > 1\"><a class=\"cursor-pointer pull-right chart-title-link\" ui-sref=secure.workOrderList(failureReport.activeAsset.filters)>{{failureReport.activeAsset.value}} {{::\'failureReports.totalFailures\' | translate}}</a></div></div><div class=\"interactive-chart work-order-chart chart-wrapper\"><google-chart chart-data=failureReport.failureReasonChartData chart-labels=failureReport.failureReasonLabels chart-type=\"\'horizontal-bar\'\" click-function=failureReport.subChartClickObject hide-chart=\"failureReport.screenSize.breakpoint === 768\"></google-chart></div></pop-box></div></div></div></div></div><report-filters filters=failureReport.filters set-function=\"failureReport.setFilters(value, save)\" open-when=failureReport.openWhen clear-function=failureReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/failureReport/failureReportList.html","<div><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile=true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button class=\"btn btn-link hidden-xs\" ng-if=failureReport.filterState.totalCount ng-click=failureReport.export()>{{::\'reports.export\' | translate}}</button> <button class=\"btn btn-default\" ng-click=failureReport.chartRoute() aria-label=\"{{::\'failureReports.chartRoute\' | translate}}\"><i class=\"fa fa-bar-chart\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=filter-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=row><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"failureReport.sort(\'Asset/Value\')\"><strong>{{::\'reports.locationOrEquipment\' | translate}}<sort-icon property=\"failureReport.sortable[\'Asset/Value\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"failureReport.sort(\'Self/Failures\')\" ng-if=\"failureReport.filters.assetRollUp !== \'true\'\"><strong>{{::\'failureReports.numberOf\' | translate}}<sort-icon property=\"failureReport.sortable[\'Self/Failures\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"failureReport.sort(\'Totals/Failures\')\" ng-if=\"failureReport.filters.assetRollUp === \'true\'\"><strong>{{::\'failureReports.numberOf\' | translate}}<sort-icon property=\"failureReport.sortable[\'Totals/Failures\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=failureReport.clearFilters() toggle-filters=failureReport.failureReportFilter() set-function=\"failureReport.setFilters(value, save)\" filters=failureReport.filters></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><report-navigation filters=failureReport.filters></report-navigation><div class=\"row hidden-xs grid-header\"><div class=col-sm-3><strong class=cursor-pointer ng-click=\"failureReport.sort(\'Asset/Value\')\">{{::\'reports.locationOrEquipment\' | translate}}<sort-icon property=\"failureReport.sortable[\'Asset/Value\']\"></sort-icon></strong></div><div class=col-sm-5 ng-if=\"failureReport.filters.assetRollUp !== \'true\'\"><strong class=\"pull-right cursor-pointer\" ng-click=\"failureReport.sort(\'Self/Failures\')\">{{::\'failureReports.numberOf\' | translate}}<sort-icon property=\"failureReport.sortable[\'Self/Failures\']\"></sort-icon></strong></div><div class=col-sm-5 ng-if=\"failureReport.filters.assetRollUp === \'true\'\"><strong class=\"pull-right cursor-pointer\" ng-click=\"failureReport.sort(\'Totals/Failures\')\">{{::\'failureReports.numberOf\' | translate}}<sort-icon property=\"failureReport.sortable[\'Totals/Failures\']\"></sort-icon></strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"failureReport.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row grid-row-unclickable\" ng-repeat=\"value in failureReport.listData\"><div class=\"col-sm-5 truncate\"><span class=hidden-xs>{{::value.asset.value}}</span> <span class=\"visible-xs text-medium-weight\">{{::value.asset.value}}</span></div><div class=\"col-sm-3 hidden-xs\"><span class=pull-right>{{::value.self.failures | number}}</span></div><div class=col-xs-12><bread-crumbs ng-if=\"value.asset.ancestorIdPath !== \'\'\" no-links=true asset=value.asset></bread-crumbs></div><div class=\"col-xs-7 visible-xs\"><div><span>{{::\'failureReports.numberOf\' | translate}}</span> <span class=pull-right>{{::value.self.failures | number}}</span></div></div><div class=col-xs-12 ng-if=value.self.failures><div class=cursor-pointer ng-click=failureReport.getFailures(value)><span class=\"text-medium-weight text-uppercase\">{{::\'failureReports.failureReasons\' | translate}}</span> <i class=fa ng-class=\"{\'fa-chevron-down\': !value.failureToggle, \'fa-chevron-up\': value.failureToggle}\" aria-hidden=true></i></div><div class=row><div class=\"col-lg-3 col-sm-4 col-xs-7\" ng-if=value.failureToggle><div ng-repeat=\"reason in value.failureSummary\"><a class=cursor-pointer ng-click=\"failureReport.routeToWorkOrders(reason.failureReason.id, value.asset.id)\">{{reason.failureReason.name}}</a> <strong class=\"pull-right cursor-pointer\" ng-click=\"failureReport.routeToWorkOrders(reason.failureReason.id, value.asset.id)\">{{reason.count}}</strong></div></div></div></div></div><div class=row><div class=col-sm-12 ng-hide=\"failureReport.filterState.totalCount <= failureReport.filters.pageSize\"><ul uib-pagination total-items=failureReport.filterState.totalCount ng-model=failureReport.filters.page ng-change=failureReport.pageChanged() items-per-page=failureReport.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><report-filters filters=failureReport.filters set-function=\"failureReport.setFilters(value, save)\" open-when=failureReport.openWhen clear-function=failureReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/filter-bar/filter-bar.html","<div class=filter-bar-header><div class=\"row filter-bar-wrapper\" sticky-element><div class=\"col-md-12 content-section filter-bar-content-section\" ng-class=\"{\'active-saved-filter\' : filterBar.filterState.activeSavedFilter }\"><div class=filter-bar><div class=\"list-body filter-bar-body\"><ul class=filter-bar-nav><li class=pull-left ng-if=!filterBar.filterState.activeSavedFilter><div class=badge-wrapper><span class=\"filter-badge label label-default\" ng-if=\"filterBar.filters | badges: filterBar.filterState.ignoreForBadge\">{{filterBar.filters | badges: filterBar.filterState.ignoreForBadge}}</span> <button class=\"btn btn-default btn-sm\" ng-click=filterBar.toggleFilters()><span class=hidden-xs>{{:: \'filterBar.filters\' | translate}}</span> <i class=\"fa fa-filter visible-xs-inline-block\" aria-hidden=true></i></button></div></li><li class=\"pull-left active-filter-item\" ng-if=filterBar.filterState.activeSavedFilter><h4 class=\"active-filter-label truncate\"><span class=my-filter-label>{{\'filterBar.myFilter\' | translate }}:</span> {{filterBar.filterState.activeSavedFilter.name}}</h4></li><li class=\"pull-right nav-option\" ng-if=!filterBar.disableMyFilters><my-filters-button clear-function=filterBar.clearFunction() filter-handler=\"filterBar.setFunction({value: activeSavedFilter, save: false})\" filters=filterBar.filters pop-box-name=myFiltersPopBox toggle-filters-function=filterBar.toggleFilters()></my-filters-button></li><li class=\"pull-right nav-option filter-actions-item\" ng-if=filterBar.filterState.activeSavedFilter><filter-actions-button clear-function=filterBar.clearFunction() toggle-filters-function=filterBar.toggleFilters()></filter-actions-button></li><li class=\"pull-right nav-option\" ng-if=!filterBar.filterState.activeSavedFilter><button ng-disabled=\"!(filterBar.filters | badges: filterBar.filterState.ignoreForBadge)\" class=\"btn btn-default btn-sm\" type=button name=clear-all-filters ng-click=filterBar.clearFunction()><span class=hidden-xs>{{:: \'filterBar.clearFilters\' | translate}}</span> <span class=visible-xs>{{:: \'filterBar.clear\' | translate}}</span></button></li></ul></div></div></div></div></div>");
$templateCache.put("app/components/filterAssetCategory/filterAssetCategory.html","<filter-wrapper header=\"\'filterAssetCategory.show\' | translate\" is-open=filterAssetCategory.isOpen badge=filterAssetCategory.showBadge()><div class=\"row filter-asset-category\"><div class=col-xs-12><div class=form-group><div ng-class=\"{\'radio-box\': filterAssetCategory.slidingPanelDisplay}\"><div class=row><div class=radio-section ng-class=\"{\'col-sm-4\': filterAssetCategory.slidingPanelDisplay, \'col-sm-12\': !filterAssetCategory.slidingPanelDisplay}\"><div class=radio><label ng-class=\"{\'disabled\': filterAssetCategory.isDisabled}\"><input type=radio ng-model=filterAssetCategory.radioValue value={{filterAssetCategory.values.all}} ng-disabled=filterAssetCategory.isDisabled> {{::\'filterAssetCategory.all\' | translate}}</label></div></div><div class=radio-section ng-class=\"{\'col-sm-4\': filterAssetCategory.slidingPanelDisplay, \'col-sm-12\': !filterAssetCategory.slidingPanelDisplay}\"><div class=radio><label ng-class=\"{\'disabled\': filterAssetCategory.isDisabled}\"><input type=radio ng-model=filterAssetCategory.radioValue value={{filterAssetCategory.values.location}} ng-disabled=filterAssetCategory.isDisabled> {{::\'filterAssetCategory.locations\' | translate}}</label></div></div><div class=radio-section ng-class=\"{\'col-sm-4\': filterAssetCategory.slidingPanelDisplay, \'col-sm-12\': !filterAssetCategory.slidingPanelDisplay}\"><div class=radio><label ng-class=\"{\'disabled\': filterAssetCategory.isDisabled}\"><input type=radio ng-model=filterAssetCategory.radioValue value={{filterAssetCategory.values.equipment}} ng-disabled=filterAssetCategory.isDisabled> {{::\'filterAssetCategory.equipment\' | translate}}</label></div></div></div></div></div></div></div></filter-wrapper>");
$templateCache.put("app/components/filterAssetNodeSearch/filterAssetNodeSearch.html","<div class=asset-node-search-filter ng-if=filterAssetNodeSearch.showToggles><div class=radio><label ng-class=\"{\'disabled\': filterAssetNodeSearch.isDisabled}\"><input type=radio ng-model=filterAssetNodeSearch.filterValue ng-value=true ng-disabled=filterAssetNodeSearch.isDisabled> {{::\'filterAssetNodeSearch.searchWithin\' | translate}} <em>{{ filterAssetNodeSearch.parent.name }}</em></label></div><div class=radio><label ng-class=\"{\'disabled\': filterAssetNodeSearch.isDisabled}\"><input type=radio ng-model=filterAssetNodeSearch.filterValue ng-value=false ng-disabled=filterAssetNodeSearch.isDisabled> {{::\'filterAssetNodeSearch.searchAll\' | translate}} <span ng-if=\"filterAssetNodeSearch.filters.isLocation === \'true\'\">{{::\'filterAssetNodeSearch.locations\' | translate}}</span> <span ng-if=\"filterAssetNodeSearch.filters.isLocation === \'false\'\">{{::\'filterAssetNodeSearch.equipment\' | translate}}</span> <span ng-if=!filterAssetNodeSearch.filters.isLocation>{{::\'filterAssetNodeSearch.all\' | translate}}</span></label></div></div>");
$templateCache.put("app/components/filterCheckboxGroup/filterCheckboxGroup.html","<div class=\"checkbox header\" ng-class=\"{\'single\': filterCheckboxGroup.singleField}\"><label><input type=checkbox ng-click=filterCheckboxGroup.updateAll() ng-model=filterCheckboxGroup.parentSelected ng-checked=filterCheckboxGroup.parentSelected ng-class=\"{\'indeterminate\': filterCheckboxGroup.parentIndeterminate}\"><div class=label-text>{{::filterCheckboxGroup.header}}</div></label></div><uib-accordion ng-if=!filterCheckboxGroup.singleField><div uib-accordion-group is-open=filterCheckboxGroup.isOpen><uib-accordion-heading><div class=\"row filter-checkbox-accordion\"><div class=col-xs-12><i class=\"pull-right fa\" ng-class=\"{\'fa-chevron-down\': filterCheckboxGroup.isOpen, \'fa-chevron-right\': !filterCheckboxGroup.isOpen}\" aria-hidden=true></i></div></div></uib-accordion-heading><uib-accordion-transclude><div ng-repeat=\"field in filterCheckboxGroup.fields track by field.name\" class=checkbox><label><input type=checkbox ng-click=filterCheckboxGroup.update(field) ng-checked=field.isSelected> {{::field.name}}</label></div></uib-accordion-transclude></div></uib-accordion>");
$templateCache.put("app/components/filterProject/filterProject.html","<filter-wrapper header=\"\'filterProject.title\' | translate\" is-open=filterProject.isOpen badge=filterProject.showBadge()><projects-typeahead ng-model=filterProject.temp filter-model=filterProject.filter multi-select=true ng-disabled=isDisabled></projects-typeahead></filter-wrapper>");
$templateCache.put("app/components/filterPurposeType/filterPurposeType.html","<filter-wrapper header=\"\'filterPurposeType.title\' | translate\" is-open=filterPurposeType.isOpen badge=filterPurposeType.showBadge()><select class=form-control id=type name=type ng-change=filterPurposeType.setFilter() ng-model=filterPurposeType.purposeType ng-options=\"purposeType.name for purposeType in filterPurposeType.purposeTypes track by purposeType.id\"><option value=\"\">{{::\'general.all\' | translate}}</option></select></filter-wrapper>");
$templateCache.put("app/components/filterReportDateRange/filterReportDateRange.html","<filter-wrapper header=filterReportDateRange.title is-open=filterReportDateRange.isOpen badge=filterReportDateRange.showBadge()><date-range date-to=filterReportDateRange.filters.dateTo date-from=filterReportDateRange.filters.dateFrom current-range=filterReportDateRange.filters.dateRange date-range-array=filterReportDateRange.dateValues></date-range></filter-wrapper>");
$templateCache.put("app/components/filterStorageArea/filterStorageArea.html","<div class=storage-area-dropdown><select class=form-control ng-model=filterStorageArea.filterString><option value=all>{{::\'filterStorageArea.all\' | translate}}</option><option value=isInventoryStorageArea>{{::\'filterStorageArea.inventoryStorageAreas\' | translate}}</option><option value=isWorkOrderAsset>{{::\'filterStorageArea.workOrderAssets\' | translate}}</option></select></div>");
$templateCache.put("app/components/filterWorkType/filterWorkType.html","<filter-wrapper header=\"\'filterWorkType.title\' | translate\" is-open=filterWorkType.isOpen badge=filterWorkType.showBadge()><work-types-typeahead ng-model=filterWorkType.temp filter-model=filterWorkType.filter multi-select=true filters=\"{hasParent: true, orderBy: \'Name asc\'}\"></work-types-typeahead></filter-wrapper>");
$templateCache.put("app/components/filterWorkorderDate/filterWorkorderDate.html","<filter-wrapper header=filterWorkorderDate.title is-open=filterWorkorderDate.isOpen badge=filterWorkorderDate.showBadge()><work-order-date-filter filters=filterWorkorderDate.filters date-values=filterWorkorderDate.dateValues cleared=filterWorkorderDate.cleared></work-order-date-filter></filter-wrapper>");
$templateCache.put("app/components/filterWorkorderDate/workOrderDateFilter.html","<div><div class=radio><label><input type=radio ng-model=dateType value=requestDate> {{::\'reportFilters.requested\' | translate}}</label></div><div class=radio><label><input type=radio ng-model=dateType value=completionDate> {{::\'reportFilters.completed\' | translate}}</label></div><date-range date-to=dates.to date-from=dates.from current-range=dates.range date-range-array=dateValues></date-range></div>");
$templateCache.put("app/components/filterWorkorderPriority/filterWorkorderPriority.html","<filter-wrapper header=\"\'filterWorkorderPriority.title\' | translate\" is-open=filterWorkorderPriority.isOpen badge=filterWorkorderPriority.showBadge()><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderPriority.updatePriorities(filterWorkorderPriority.priority.emergency) class=emergency-priority ng-checked=\"filterWorkorderPriority.filter.indexOf(filterWorkorderPriority.priority.emergency) > -1\"> <span class=priority-Emergency-filter>{{::\'filterWorkorderPriority.priority.emergency\' | translate}}</span></label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderPriority.updatePriorities(filterWorkorderPriority.priority.high) class=high-priority ng-checked=\"filterWorkorderPriority.filter.indexOf(filterWorkorderPriority.priority.high) > -1\"> <span class=priority-High-filter>{{::\'filterWorkorderPriority.priority.high\' | translate}}</span></label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderPriority.updatePriorities(filterWorkorderPriority.priority.medium) class=medium-priority ng-checked=\"filterWorkorderPriority.filter.indexOf(filterWorkorderPriority.priority.medium) > -1\"> <span class=priority-Medium-filter>{{::\'filterWorkorderPriority.priority.medium\' | translate}}</span></label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderPriority.updatePriorities(filterWorkorderPriority.priority.low) class=low-priority ng-checked=\"filterWorkorderPriority.filter.indexOf(filterWorkorderPriority.priority.low) > -1\"> <span class=priority-Low-filter>{{::\'filterWorkorderPriority.priority.low\' | translate}}</span></label></div></filter-wrapper>");
$templateCache.put("app/components/filterWorkorderStatus/filterWorkorderStatus.html","<filter-wrapper header=\"\'filterWorkorderStatus.title\' | translate\" is-open=filterWorkorderStatus.isOpen badge=filterWorkorderStatus.showBadge()><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderStatus.updateStatuses(filterWorkorderStatus.status.newRequest) ng-checked=\"filterWorkorderStatus.filter.indexOf(filterWorkorderStatus.status.newRequest) > -1\"> {{::\'filterWorkorderStatus.statuses.newRequest\' | translate}}</label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderStatus.updateStatuses(filterWorkorderStatus.status.workInProgress) ng-checked=\"filterWorkorderStatus.filter.indexOf(filterWorkorderStatus.status.workInProgress) > -1\"> {{::\'filterWorkorderStatus.statuses.workInProgress\' | translate}}</label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderStatus.updateStatuses(filterWorkorderStatus.status.complete) ng-checked=\"filterWorkorderStatus.filter.indexOf(filterWorkorderStatus.status.complete) > -1\"> {{::\'filterWorkorderStatus.statuses.complete\' | translate}}</label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderStatus.updateStatuses(filterWorkorderStatus.status.onHold) ng-checked=\"filterWorkorderStatus.filter.indexOf(filterWorkorderStatus.status.onHold) > -1\"> {{::\'filterWorkorderStatus.statuses.onHold\' | translate}}</label></div><div class=checkbox><label><input type=checkbox ng-click=filterWorkorderStatus.updateStatuses(filterWorkorderStatus.status.void) ng-checked=\"filterWorkorderStatus.filter.indexOf(filterWorkorderStatus.status.void) > -1\"> {{::\'filterWorkorderStatus.statuses.void\' | translate}}</label></div></filter-wrapper>");
$templateCache.put("app/components/floorPlanList/floorPlanList.html","<div class=floor-plan-list><div class=\"row header-container\"><div class=col-xs-9><h4 class=inline-block>{{::\'floorPlanList.title\' | translate}}</h4></div><div class=col-xs-3><button class=\"pull-right btn btn-primary\" ng-click=floorPlanList.openFloorPlanListPanel()><span>{{::\'general.actions.new\' | translate}}</span></button></div></div><div class=main-container><div class=row><div class=list-body><div class=\"col-sm-12 content-body content-section\"><div class=row><div class=\"col-sm-12 no-results\" ng-if=\"floorPlanList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><a ui-sref=\"secure.assetFloorPlanView({id: floorPlan.id})\" class=\"row grid-row cursor-pointer\" ng-repeat=\"floorPlan in floorPlanList.listData track by floorPlan.id\"><div class=col-xs-12><div class=floor-plan-thumbnail><img class=thumbnail-image ng-src=\"{{::floorPlanList.imageUrlPrefix + floorPlan.fileViewToken}}\"></div><div class=floor-plan-text><div>{{::floorPlan.businessAsset.name}}</div><div><bread-crumbs root=\"{{::\'assetList.assets\' | translate}}\" asset=floorPlan.businessAsset no-links=true sref=secure.assetList></bread-crumbs></div></div></div></a><div class=row><div class=col-sm-12 ng-hide=\"floorPlanList.totalCount <= floorPlanList.filters.pageSize\"><ul uib-pagination total-items=floorPlanList.totalCount ng-model=floorPlanList.filters.page ng-change=floorPlanList.pageChanged() items-per-page=floorPlanList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><floor-plan-list-panel template-url={{::floorPlanList.panelObject.template}} panel-object=floorPlanList.panelObject></floor-plan-list-panel></div>");
$templateCache.put("app/components/floorPlanList/floorPlanListPanel.html","<sliding-panel titles=floorPlanListPanel.panelObject.titles show-navigation-warning=true save-attempt=floorPlanListPanel.saveAttempt open-when=floorPlanListPanel.panelObject.open button-functions=floorPlanListPanel.buttonFunctions><panel-body><ng-form name=floorPlanListForm><div class=panel-form-content><div class=margin-bottom-sm><div class=\"text-info margin-bottom-sm\"><em>{{::\'floorPlanList.floorPlanHelperText\' | translate}}</em></div><div class=margin-bottom-sm><strong>{{::\'floorPlanList.addFloorPlan\' | translate}}</strong></div><div class=\"row image-row\"><div class=\"col-xs-4 image-icon\" ng-class=\"{\'image-error\': floorPlanListPanel.file.errorMessage || (!floorPlanListPanel.file && floorPlanListPanel.saveAttempt)}\"><div class=no-image ng-if=\"!floorPlanListPanel.file && !floorPlanListPanel.saveAttempt\" aria-label=\"{{::\'floorPlanList.ariaLabels.placeholderImage\' | translate}}\"><i class=\"fa fa-picture-o\" aria-hidden=true></i></div><div ng-if=\"floorPlanListPanel.file && !floorPlanListPanel.file.errorMessage && !floorPlanListPanel.entity\" aria-label=\"{{::\'floorPlanList.ariaLabels.loadingSpinner\' | translate}}\" class=image><i class=\"spinner fa-spin fa fa-4x fa-fw fa-circle-o-notch text-primary\" aria-hidden=true></i></div><div ng-if=\"floorPlanListPanel.file.errorMessage || (!floorPlanListPanel.file && floorPlanListPanel.saveAttempt)\" aria-label=\"{{::\'floorPlanList.ariaLabels.errorImage\' | translate}}\" class=\"text-danger image\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i></div><div class=image-container ng-if=floorPlanListPanel.entity><img class=image ng-src={{::floorPlanListPanel.entity.thumbnails.medium.shareableUri}} alt={{floorPlanListPanel.entity.filename}}></div></div><div class=col-xs-8><div ng-if=\"!floorPlanListPanel.file || floorPlanListPanel.file.errorMessage\"><button name=fileUpload ng-model=floorPlanListPanel.file ngf-select class=\"fileUpload btn btn-default margin-bottom-sm\" ng-required=true><span>{{::\'floorPlanList.addImage\' | translate}}</span></button><div class=text-muted><span>({{::\'floorPlanList.allowedFileTypes\' | translate}})</span></div></div><div ng-if=\"floorPlanListPanel.entity && !floorPlanListPanel.file.errorMessage\"><div><span>{{floorPlanListPanel.entity.filename}}</span></div><div class=text-muted><span>{{::\'floorPlanList.added\' | translate}}: {{floorPlanListPanel.entity.createdDateTime | date: \'MM/dd/yyyy | mm:hh a\'}}</span></div></div></div></div><div ng-if=\"floorPlanListPanel.file.errorMessage || (!floorPlanListPanel.file && floorPlanListPanel.saveAttempt)\" class=row><div class=\"col-xs-12 text-danger\" ng-messages=floorPlanListForm.fileUpload.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-if=\"floorPlanListPanel.file.errorMessage === floorPlanListPanel.minimumSizeError\">{{::\'floorPlanList.minimumSizeError\' | translate}}</span> <span ng-if=\"floorPlanListPanel.file.errorMessage === floorPlanListPanel.fileTooLarge\">{{::\'floorPlanList.maximumSizeError\' | translate}}</span> <span ng-if=floorPlanListPanel.isGenericFileError>{{::floorPlanListPanel.file.errorMessage}}</span></div></div></div><hr><div class=margin-bottom-sm><strong>{{::\'floorPlanList.assignToLocation\' | translate}}</strong> <span class=text-muted>({{::\'floorPlanList.floorTypes\' | translate}})</span></div><div class=row><div class=form-group><div class=\"col-xs-12 margin-bottom-sm\" ng-class=\"{\'has-error\': floorPlanListPanel.saveError || floorPlanListForm.assets.$invalid && (floorPlanListForm.assets.$touched || floorPlanListPanel.saveAttempt)}\"><assets-typeahead ng-model=floorPlanListPanel.asset multi-select=false additional-filters=\"{isLocation: true}\" browse-options=floorPlanListPanel.assetBrowseOptions ng-required=true></assets-typeahead><p class=text-danger ng-messages=floorPlanListForm.assets.$error ng-if=\"floorPlanListForm.assets.$touched || floorPlanListPanel.saveAttempt\"><span ng-if=floorPlanListForm.assets.$invalid ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span class=text-danger style=\"position: relative\" ng-if=\"floorPlanListPanel.saveError && floorPlanListPanel.asset\">{{::\'floorPlanList.saveError\' | translate}}</span></p></div></div></div></div></ng-form></panel-body></sliding-panel>");
$templateCache.put("app/components/history/historyEventCard.html","<div class=\"row history-event-card\"><div class=col-xs-12><div class=row ng-if=!historyEventCard.isWorkOrderType><div class=col-xs-12><h4 class=section-name>{{historyEventCard.name}} <span class=font-size-md>{{historyEventCard.subname}}</span></h4></div></div><div class=row><div class=col-xs-12><div class=row ng-repeat=\"change in historyEventCard.changeEvent.details track by historyEventCard.tracker($index)\"><div class=col-xs-12><div class=\"row history-event-card-title\"><div class=col-xs-12><strong>{{::historyEventCard.translateFallback(\'history.changeFields.\' + change.field)}}</strong> <span>({{::\'history.changeTypes.\' + change.changeType | translate }})</span></div></div><div class=\"row history-event-card-change\" ng-if=\"change.changeType === historyEventCard.update\"><div class=col-md-6><span class=history-event-card-label>{{::\'history.from\' | translate}}</span> <span class=history-event-change-value>{{::change.beforeString}}</span></div><div class=col-md-6><span class=history-event-card-label>{{::\'history.to\' | translate}}</span> <span class=history-event-change-value>{{::change.afterString}}</span></div></div><div class=\"row history-event-card-change\" ng-if=\"change.changeType !== historyEventCard.update\"><div ng-if=\"change.before != null\" class=col-xs-12><span class=history-event-card-label>{{::\'history.value\' | translate}}</span> <span class=history-event-change-value>{{::change.beforeString}}</span></div><div ng-if=\"change.after != null\" class=col-xs-12><span class=history-event-card-label>{{::\'history.value\' | translate}}</span> <span class=history-event-change-value>{{::change.afterString}}</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/history/historySlidingPanel.html","<sliding-panel open-when=historySlidingPanel.openWhen cancel-button=false button-functions=historySlidingPanel.panelFunctions random-panel-name=historySlidingPanel.randomPanelName titles=historySlidingPanel.titles><panel-body><div class=row ng-if=\"historySlidingPanel.events.length == 0\"><div class=col-xs-12><div class=\"text-info text-center\"><em>{{historySlidingPanel.emptyMessage}}</em></div></div></div><div class=\"row history-panel-list\"><div class=col-xs-12><uib-accordion close-others=false><div uib-accordion-group class=header-padding ng-init=\"historyEvent.isOpen = true\" is-open=historyEvent.isOpen ng-repeat=\"historyEvent in historySlidingPanel.events\"><uib-accordion-heading ng-click=$event.stopPropagation()><div class=history-panel-wrapper><span class=\"history-dropdown-icon fa\" ng-class=\"{\'fa-angle-right\': !historyEvent.isOpen, \'fa-angle-down\': historyEvent.isOpen}\"></span><div class=history-panel-text><span class=history-panel-datetime><span class=history-panel-date>{{::historyEvent.changeDateTime | date:\'MM/dd/yyyy\'}}</span> <span class=history-panel-time>{{::historyEvent.changeDateTime | date:\'hh:mm:ss a\'}}</span> </span><span class=history-panel-name>{{::historyEvent.userName}}</span></div></div></uib-accordion-heading><history-event-card change-event=historyEvent></history-event-card></div></uib-accordion></div></div></panel-body><panel-footer><button type=button ng-click=historySlidingPanel.close() class=\"btn btn-primary\">{{::\'general.actions.close\' | translate}}</button> <button type=button ng-click=historySlidingPanel.navigate() class=\"btn btn-link\">{{::\'history.viewAllHistory\' | translate}}</button></panel-footer></sliding-panel>");
$templateCache.put("app/components/historyList/historyListNavigation.html","<div class=\"history-list-navigation-section hidden\"><div class=row><div class=col-md-12><ul class=\"nav nav-tabs tab-navigation history-list-tabs\"><li role=presentation ng-class=\"{\'active\': historyListNavigation.isActiveRoute(\'workorders\')}\"><a ng-click=\"historyListNavigation.routeTo(\'workorders\')\" class=\"text-medium-weight cursor-pointer\">{{::\'historyList.workOrders\' | translate}}</a></li></ul></div></div></div>");
$templateCache.put("app/components/issueToWorkOrder/issueToWorkOrder.html","<sliding-panel open-when=issueToWorkOrder.openWhen titles=issueToWorkOrder.titles button-functions=issueToWorkOrder.panelFunctions show-navigation-warning=true><panel-body><div class=issue-to-work-order><div class=row><div class=\"col-xs-12 selection-text\"><em class=text-info>{{::\'issueToWorkOrder.selectText\' | translate}}</em></div></div><uib-accordion close-others=true><div uib-accordion-group class=transfer-from is-open=issueToWorkOrder.issuedFromOpen><uib-accordion-heading><div class=row><div class=col-xs-8><span class=transfer-label>{{::\'issueToWorkOrder.issuedFrom\' | translate}}</span></div><div class=col-xs-4><i class=\"pull-right fa\" ng-class=\"{\'fa-chevron-up\': issueToWorkOrder.issuedFromOpen, \'fa-chevron-right\': !issueToWorkOrder.issuedFromOpen}\" aria-hidden=true></i></div></div></uib-accordion-heading><div class=row><div class=col-xs-12><inventory-items-typeahead multi-select=false ng-model=issueToWorkOrder.inventoryItem additional-filters=issueToWorkOrder.additionalFilters></inventory-items-typeahead></div></div><button class=\"btn btn-lg btn-default btn-block\" ng-click=issueToWorkOrder.openStoragePanelFunction() ng-if=\"issueToWorkOrder.inventoryItem != null\">{{::\'issueToWorkOrder.selectStorageArea\' | translate}}</button></div><div class=storage-area-display ng-if=\"issueToWorkOrder.selectedStorageArea != null\" ng-click=\"issueToWorkOrder.issuedFromOpen = issueToWorkOrder.issuedFromOpen !== true\"><div class=row><div class=col-xs-6>{{::issueToWorkOrder.inventoryItem.name }}</div><div class=col-xs-6><span class=\"pull-right text-right\">{{::\'issueToWorkOrder.unitOfIssue\' | translate}} {{::issueToWorkOrder.inventoryItem.unitOfIssue}}</span></div></div><div class=row><div class=col-xs-6>{{::\'issueToWorkOrder.storageArea\' | translate}} {{::issueToWorkOrder.selectedStorageArea.asset.name }}</div><div class=col-xs-6><span class=\"pull-right text-right\">{{::\'issueToWorkOrder.transferableQuantity\' | translate}} {{ issueToWorkOrder.selectedStorageArea.availableQuantity }}</span></div></div></div><div uib-accordion-group class=transfer-to is-open=issueToWorkOrder.issuedToOpen><uib-accordion-heading><div class=row><div class=col-xs-8><span class=transfer-label>{{::\'issueToWorkOrder.issuedTo\' | translate}}</span></div><div class=col-xs-4><i class=\"pull-right fa\" ng-class=\"{\'fa-chevron-up\': issueToWorkOrder.issuedToOpen, \'fa-chevron-right\': !issueToWorkOrder.issuedToOpen}\" aria-hidden=true></i></div></div></uib-accordion-heading><form name=issueToWorkOrderForm ng-if=\"issueToWorkOrder.selectedStorageArea != null\"><div class=row><div class=col-xs-12><quantity-adjustments form=issueToWorkOrderForm quantity-info=issueToWorkOrder.quantityInfo[issueToWorkOrder.workOrder.displayId] identifier=issueToWorkOrder.workOrder.displayId save-attempt=issueToWorkOrder.saveAttempt new-quantity-min=issueToWorkOrder.quantityInfo[issueToWorkOrder.workOrder.displayId].availableQuantity change-in-quantity-min=0 transferable-quantity=issueToWorkOrder.selectedStorageArea.availableQuantity hide-change-in-quantity=true new-quantity-text=issueToWorkOrder.quantityToIssue></quantity-adjustments></div></div></form><div class=row ng-if=\"issueToWorkOrder.selectedStorageArea === null\"><div class=\"col-xs-12 selection-text\"><em class=text-info>{{::\'issueToWorkOrder.selectTextAbove\' | translate}}</em></div></div></div></uib-accordion></div></panel-body></sliding-panel>");
$templateCache.put("app/components/locationReport/locationChart.html","<asset-report-chart is-location=true init-data=locationReport.initData></asset-report-chart>");
$templateCache.put("app/components/locationReport/locationList.html","<asset-report-list is-location=true init-data=locationReport.initData report-title=locationReport.title></asset-report-list>");
$templateCache.put("app/components/meterReading/meterReading.html","<sliding-panel cancel-button=true button-functions=meterReading.slidingButtons open-when=meterReading.openWhen titles=meterReading.titles save-attempt=meterReading.saveAttempt><panel-body><div class=panel-form-content><div class=row><div class=\"col-xs-12 sliding-panel-helper\"><p><em class=text-info>{{::\'meterReading.helperMessage\' | translate}}</em></p></div></div><div class=row><div class=col-xs-12><div class=form-group><strong>{{::meterReading.asset.name}}</strong> <span class=text-muted ng-if=meterReading.asset.ancestorIdPath><bread-crumbs path=\"\" root=\"\" asset=meterReading.asset no-links=true inline=false></bread-crumbs></span><asset-usage ng-repeat=\"attribute in meterReading.attributes\" asset-attribute=attribute country={{::meterReading.country}} save-attempt=meterReading.saveAttempt asset=meterReading.asset disable-actions=true show-title=false should-validate=true></asset-usage></div></div></div></div></panel-body></sliding-panel>");
$templateCache.put("app/components/navbar/navbar.html","<div ng-controller=\"NavbarController as navBar\"><dude-navigation navigation-title=navBar.title help-menu=navBar.support navigation-search=navBar.search navigation=navBar.navigationArray></dude-navigation></div>");
$templateCache.put("app/components/notifications/notifications.html","<div class=\"row header-container\"><div class=col-xs-12><h4>{{::\'notifications.title\' | translate}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate><div class=row><div id={{setting.name}} class=col-xs-12 ng-repeat=\"setting in notifications.settings\"><label>{{:: \'notifications.\' + setting.name + \'.title\' | translate}}</label><toggle-switch toggle-object=setting.email label=setting.formLabel toggle-disabled=setting.disabled id-param=setting.name toggle-function=notifications.updateSetting(setting)></toggle-switch></div></div></form></div></div>");
$templateCache.put("app/components/pmScheduleAssets/pmScheduleAssets.html","<sliding-panel cancel-button=true button-functions=pmScheduleAssets.slidingButtons show-navigation-warning=true open-when=pmScheduleAssets.openWhen titles=pmScheduleAssets.titles><panel-body><div class=panel-form-content><div class=row><div class=\"col-xs-12 sliding-panel-helper\"><em class=text-info>{{::\'pmScheduleAssets.helperMessage\' | translate}}</em></div></div><div class=row><div class=col-xs-12><div class=form-group><label>{{::\'pmScheduleAssets.locationOrEquipment\' | translate}}</label><assets-typeahead ng-model=pmScheduleAssets.businessAssetsModel multi-select=true browse-options=pmScheduleAssets.browseOptions focus-on=500></assets-typeahead></div></div></div></div></panel-body></sliding-panel>");
$templateCache.put("app/components/pmScheduleAssignees/pmScheduleAssignees.html","<sliding-panel cancel-button=true button-functions=pmScheduleAssignees.slidingButtons open-when=pmScheduleAssignees.openWhen show-navigation-warning=true titles=pmScheduleAssignees.titles><panel-body><div class=panel-form-content><div class=row><div class=\"col-xs-12 sliding-panel-helper\"><em class=text-info>{{::\'pmScheduleAssignees.helperMessage\' | translate}}</em></div></div><div class=row><div class=col-xs-12><div class=form-group><label>{{::\'pmScheduleAssignees.assignees\' | translate}}</label><users-typeahead roles=pmScheduleAssignees.roles ng-model=pmScheduleAssignees.assigneesModel multi-select=true browse-options=pmScheduleAssignees.browseOptions focus-on=500></users-typeahead></div></div></div></div></panel-body></sliding-panel>");
$templateCache.put("app/components/pmScheduleDetails/pmScheduleDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'pmScheduleDetails.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'pmScheduleDetails.deleteConfirm.message1\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=pmScheduleDetailsDeleteModal.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=pmScheduleDetailsDeleteModal.close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/pmScheduleDetails/pmScheduleDetails.html","<div class=\"row sub-header-container\"><div class=col-xs-9><h5 id=schedulingSection scroll-spy-on spies=pmScheduleDetails.spies spy-text=\"{{\'pmScheduleForm.cards.schedule.title\' | translate}}\" spy-position=2>{{\'pmScheduleForm.cards.schedule.title\' | translate}}</h5></div><div class=col-xs-3><div class=\"pull-right sub-header-container-btn\" ng-click=pmScheduleDetails.addSchedule()><button type=button class=\"btn btn-link hidden-xs\">{{\'pmScheduleForm.cards.schedule.button\' | translate}}</button> <button type=button class=\"btn btn-circle btn-default visible-xs add-schedule-mobile\"><i class=\"fa fa-plus fa-2x text-primary\" aria-hidden=true></i></button></div></div></div><div class=content-section><ng-form name=scheduleForm><div class=\"schedule-container schedule-row\" ng-repeat=\"schedule in pmScheduleDetails.schedules track by $index\"><div class=\"row schedule-data cursor-pointer\" ng-class=\"{active: pmScheduleDetails.isActive === $index, inactive: pmScheduleDetails.isActive && pmScheduleDetails.isActive !== $index}\" ng-click=pmScheduleDetails.setActive($index)><div class=col-xs-8><div class=row><div class=col-xs-12><span class=font-size-md>{{::\'pmScheduleDetails.repeats\' | translate}}</span> <span><a ng-click=\"pmScheduleDetails.addRecurrence(schedule, $index)\" ng-class=\"{\'text-uppercase\': !pmScheduleDetails.hasRecurrencePattern(schedule)}\"><span ng-if=!pmScheduleDetails.hasRecurrencePattern(schedule)>{{::\'pmScheduleDetails.schedulePattern\' | translate}}</span> <span ng-if=\"pmScheduleDetails.hasRecurrencePattern(schedule) && schedule.scheduleType !== pmScheduleDetails.defaultScheduleType\"><strong class=font-size-md ng-if=\"schedule.scheduleType === pmScheduleDetails.scheduleTypes.FLOATING\"><human-readable-date quartz-date=schedule.recurrencePattern schedule-type=schedule.scheduleType></human-readable-date>: </strong><strong class=font-size-md ng-if=\"schedule.scheduleType === pmScheduleDetails.scheduleTypes.METERED\">{{::\'pmScheduleDetails.meteredMessage.messagePrefix\' | translate}} {{schedule.meterInterval}} {{::\'pmScheduleDetails.meteredMessage.messageSuffix\' | translate}} </strong><strong class=font-size-md ng-if=\"schedule.scheduleType === pmScheduleDetails.scheduleTypes.MIXED\">{{::\'pmScheduleDetails.meteredMessage.messagePrefix\' | translate}} {{schedule.meterInterval}} {{::\'pmScheduleDetails.meteredMessage.messageSuffix\' | translate}} {{::\'pmScheduleDetails.mixedMessage.or\' | translate}} {{::\'pmScheduleDetails.mixedMessage.every\' | translate}}&nbsp;<human-readable-date quartz-date=schedule.recurrencePattern schedule-type=schedule.scheduleType></human-readable-date>: </strong><span class=font-size-md>{{::\'pmScheduleDetails.floatingRecurrenceMessage\' | translate}} </span></span><span ng-if=\"pmScheduleDetails.hasRecurrencePattern(schedule) && schedule.scheduleType === pmScheduleDetails.defaultScheduleType\"><strong class=font-size-md>{{pmScheduleDetails.getPeriodTranslationKey(schedule.recurrencePattern.period) | translate}}:</strong>&nbsp <span class=font-size-md><human-readable-date quartz-date=schedule.recurrencePattern></human-readable-date></span></span></a><span class=label ng-if=!pmScheduleDetails.hasRecurrencePattern(schedule) ng-class=\"{\'label-default\': pmScheduleDetails.isValid, \'label-danger\': !pmScheduleDetails.isValid}\">{{::\'general.validation.required\' | translate}}</span></span></div></div><div class=row><div class=col-xs-12><span>{{::\'pmScheduleDetails.locationOrEquipment\' | translate}}: </span><a ng-click=\"pmScheduleDetails.addAssets(schedule, $index)\" ng-class=\"{\'text-uppercase\': !schedule.businessAssets || schedule.businessAssets.length === 0}\"><span ng-if=\"!schedule.businessAssets || schedule.businessAssets.length === 0\">{{::\'pmScheduleDetails.select\' | translate}}</span> <span ng-if=\"schedule.businessAssets.length > 0\">{{schedule.businessAssets | commaSeparate:\'name\'}}</span> </a><span class=\"label label-default\" ng-if=\"!schedule.businessAssets || schedule.businessAssets.length === 0\" ng-class=\"{\'label-default\': pmScheduleDetails.isValid, \'label-danger\': !pmScheduleDetails.isValid}\">{{::\'general.validation.required\' | translate}}</span></div></div><div class=row ng-if=\"(schedule.scheduleType === \'Mixed\' || schedule.scheduleType === \'Metered\') && schedule.businessAssets && schedule.businessAssets.length > 0\"><div class=col-xs-12><span>{{::\'pmScheduleDetails.readings\' | translate}}: </span><a ng-click=\"pmScheduleDetails.addReadings(schedule, $index)\" class=\"{\'text-uppercase\': !schedule.businessAssets || (schedule.businessAssets|filter:{startingThreshold:\'!!\'}).length === 0}\"><span ng-if=\"!schedule.businessAssets || (schedule.businessAssets|filter:{startingThreshold:\'!!\'}).length === 0\" class=text-uppercase>{{::\'pmScheduleDetails.setReadings\' | translate}}</span> <span ng-if=\"schedule.businessAssets && (schedule.businessAssets|filter:{startingThreshold:\'!!\'}).length > 0\">{{::\'pmScheduleDetails.startReadings\' | translate}}</span> </a><span class=label ng-if=\"!schedule.businessAssets || (schedule.businessAssets|filter:{startingThreshold:\'!!\'}).length !== schedule.businessAssets.length\" ng-class=\"{\'label-default\': pmScheduleDetails.isValid, \'label-danger\': !pmScheduleDetails.isValid}\">{{::\'general.validation.required\' | translate}}</span></div></div><div class=row ng-if=\"pmScheduleDetails.isActive === $index && schedule.id\"><div class=col-xs-12><div class=checkbox><label><input type=checkbox name=active id=active ng-model=schedule.isActive pm-inactive-association-validator=pmScheduleDetails.workOrderTemplate schedule=schedule> {{::\'general.active\' | translate}}</label></div><p class=text-danger ng-messages=scheduleForm.active.$error ng-messages-multiple><span class=\"show inactive-error\" ng-message=pmWorkTypeAssociation>{{::\'pmScheduleDetails.validation.active.workType\'| translate}}</span> <span class=\"show inactive-error\" ng-message=pmPurposeAssociation>{{::\'pmScheduleDetails.validation.active.purpose\' | translate}}</span> <span class=\"show inactive-error\" ng-message=pmTradeAssociation>{{::\'pmScheduleDetails.validation.active.trade\' | translate}}</span> <span class=\"show inactive-error\" ng-message=pmAssigneeAssociation>{{::\'pmScheduleDetails.validation.active.assignee\' | translate}}</span></p></div></div></div><div class=col-xs-4><div class=row><div class=col-xs-12><div class=text-right><span ng-if=\"schedule.scheduleType == pmScheduleDetails.defaultScheduleType && schedule.nextRunDateTime && schedule.isActive\"><small class=text-muted>{{::\'pmScheduleDetails.nextOccurrence\' | translate}}:</small> {{::schedule.nextRunDateTime | date:\'M/d/yyyy\'}}</span><div class=\"label label-warning\" ng-if=!schedule.isActive>{{::\'general.inactive\' | translate}}</div></div></div></div><div class=row><div class=col-xs-12><div class=text-right><a ng-click=\"pmScheduleDetails.addAssignees(schedule, $index)\" ng-class=\"{\'text-uppercase\': (!schedule.assignees || schedule.assignees.length === 0) && pmScheduleDetails.isActive === $index}\"><span ng-if=\"(!schedule.assignees || schedule.assignees.length === 0) && pmScheduleDetails.isActive === $index\">{{::\'pmScheduleDetails.assign\' | translate}}</span> <span ng-if=\"(!schedule.assignees || schedule.assignees.length === 0) && pmScheduleDetails.isActive !== $index\">{{::\'pmScheduleDetails.unassigned\' | translate}}</span> <span ng-if=\"schedule.assignees.length === 1\"><small class=text-muted>{{::\'pmScheduleDetails.assignedTo\' | translate}}:</small> {{schedule.assignees[0].firstName}}&nbsp;{{schedule.assignees[0].lastName}} </span><span ng-if=\"schedule.assignees.length > 1\"><strong>{{schedule.assignees.length}}&nbsp;{{::\'pmScheduleDetails.assignees\' | translate}}</strong></span></a></div></div></div></div></div><div class=\"row schedule-actions\" ng-if=\"pmScheduleDetails.isActive === $index\"><div class=col-xs-9><button type=button class=\"btn btn-link\" ng-click=pmScheduleDetails.done($index)>{{::\'general.actions.done\' | translate}}</button> <button type=button class=\"btn btn-link\" ng-click=pmScheduleDetails.cancel($index) ng-if=\"!schedule.id && !schedule.__commited\">{{::\'general.actions.cancel\' | translate}}</button></div><div class=col-xs-3><div class=pull-right><button type=button class=\"btn btn-link text-danger\" ng-click=pmScheduleDetails.delete($index) ng-if=\"schedule.workOrderCount === 0 || schedule.__commited\">{{::\'general.actions.delete\' | translate}}</button> <a ui-sref=\"secure.workOrderList({pmSchedule: schedule.id, status: \'all\', includeDescendants: \'true\', assignees: \'none\'})\" ng-if=\"schedule.workOrderCount > 0\" class=\"btn btn-link\">{{::\'general.actions.viewWorkOrders\' | translate}}</a></div></div></div></div></ng-form></div><!-- Sliding Panels --><pmschedule-assets schedule=pmScheduleDetails.editingSchedule open-when=pmScheduleDetails.openAssetsSlidingPanel></pmschedule-assets><pmschedule-assignees schedule=pmScheduleDetails.editingSchedule open-when=pmScheduleDetails.openAssigneesSlidingPanel></pmschedule-assignees><pmschedule-recurrence schedule=pmScheduleDetails.editingSchedule open-when=pmScheduleDetails.openRecurrenceSlidingPanel></pmschedule-recurrence><pm-schedule-meter-reading schedule=pmScheduleDetails.editingSchedule open-when=pmScheduleDetails.openReadingsSlidingPanel></pm-schedule-meter-reading>");
$templateCache.put("app/components/pmScheduleForm/pmScheduleDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'pmScheduleDelete.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'pmScheduleDelete.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/pmScheduleForm/pmScheduleDeleteWarningModal.html","<div class=modal-header><h4><span class=title>{{::\'pmScheduleDelete.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'pmScheduleDelete.deleteWarning.message1\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/pmScheduleForm/pmScheduleForm.html","<div class=\"row header-container\"><div class=\"col-sm-6 col-xs-12\"><h4>{{::(pmScheduleForm.workOrderTemplate.id ? \'pmScheduleForm.editTitle\' : \'pmScheduleForm.createTitle\') | translate}}</h4></div></div><div class=\"main-container pmScheduleForm\"><div class=row><div class=\"col-xs-12 col-sm-10\"><form name=form novalidate navigation-warning form=form reload=true skip-navigation-warning=pmScheduleForm.skipNavigationWarning><!--Work Order Template sections--><div class=content-section><div class=row><div class=col-xs-12 id=formHeader scroll-spy-on spy-text=\"{{::\'pmScheduleForm.spies.template\' | translate}}\" spies=pmScheduleForm.spies spy-position=1><div class=form-group ng-class=\"{\'has-error\': form.title.$invalid && (form.title.$touched || pmScheduleDetailsForm.saveAttempt)}\"><label for=name>{{::\'pmScheduleForm.title\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=title required maxlength=50 class=form-control placeholder=\"\" ng-model=pmScheduleForm.workOrderTemplate.description focus-on=true><p class=text-danger ng-messages=form.title.$error ng-if=\"form.title.$touched || pmScheduleForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\" has-markets=\"pmScheduleForm.market.k12, pmScheduleForm.market.he, pmScheduleForm.market.ips\"><div class=form-group ng-class=\"{\'has-error\': form.workTypes.$invalid && (form.workTypes.$touched || pmScheduleForm.saveAttempt)}\" accessibility><label for=workType>{{::\'pmScheduleForm.workType\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><work-types-dropdown ng-model=pmScheduleForm.workOrderTemplate.workType filters=\"{hasParent: true, orderBy: \'Name asc\', isActive: \'true\'}\" ng-required=true></work-types-dropdown><p class=text-danger ng-messages=form.workTypes.$error ng-if=\"form.workTypes.$touched || pmScheduleForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>{{::\'pmScheduleForm.purpose\' | translate}}</label><purposes-dropdown ng-model=pmScheduleForm.workOrderTemplate.purpose></purposes-dropdown></div></div><div class=\"col-xs-12 col-sm-6\" has-markets=\"pmScheduleForm.market.mfg, pmScheduleForm.market.club, pmScheduleForm.market.other, pmScheduleForm.market.gov\"><div class=form-group><label>{{::\'pmScheduleForm.trade\' | translate}}</label><trades-dropdown ng-model=pmScheduleForm.workOrderTemplate.trade></trades-dropdown></div></div></div><hr><!-- Estimate Fields --><div class=row><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': form.estimatedHours.$invalid && (form.estimatedHours.$touched || pmScheduleForm.saveAttempt)}\"><div class=form-group><label for=estimatedHours>{{::\'pmScheduleForm.estimatedHours\' | translate}}</label><number-field ng-model=pmScheduleForm.workOrderTemplate.estimatedHours places=2 max=999.99 min=0 name=estimatedHours></number-field><p class=text-danger ng-messages=form.estimatedHours.$error ng-if=\"form.estimatedHours.$touched || pmScheduleForm.saveAttempt\"><span ng-message=maximum>{{::\'pmScheduleForm.validation.estimatedHours.max\' | translate}} </span><span ng-message=minimum>{{::\'pmScheduleForm.validation.estimatedHours.min\' | translate}}</span></p></div></div><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': form.estimatedCost.$invalid && (form.estimatedCost.$touched || pmScheduleForm.saveAttempt)}\"><div class=form-group><label for=estimatedCost>{{::\'pmScheduleForm.estimatedCost\' | translate}}</label><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i><number-field ng-model=pmScheduleForm.workOrderTemplate.estimatedCost max=100000000 min=0 places=2 name=estimatedCost></number-field></div><p class=text-danger ng-messages=form.estimatedCost.$error ng-if=\"form.estimatedCost.$touched || pmScheduleForm.saveAttempt\"><span ng-message=maximum>{{::\'pmScheduleForm.validation.estimatedCost.max\' | translate}} </span><span ng-message=minimum>{{::\'pmScheduleForm.validation.estimatedCost.min\' | translate}}</span></p></div></div></div><hr><div class=row><div class=col-xs-12><h5>{{::\'pmScheduleForm.settings\' | translate}}</h5></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><label>{{::\'pmScheduleForm.daysToComplete\' | translate}}</label><number-field ng-model=pmScheduleForm.workOrderTemplate.dueDateOffset max=1000 min=1 name=dueDateOffset places=0></number-field><div class=text-danger ng-messages=form.dueDateOffset.$error ng-if=\"form.dueDateOffset.$touched || pmScheduleForm.saveAttempt\"><span ng-message=minimum>{{::\'pmScheduleForm.validation.min\' | translate }}</span> <span ng-message=maximum>{{::\'pmScheduleForm.validation.max\' | translate }}</span></div></div></div></div><!--End Work Order Template sections--><!--scheduling list--><div class=pmschedule-details><div ng-if=\"pmScheduleForm.schedules.length > 0\"><pmschedule-details schedules=pmScheduleForm.schedules spies=pmScheduleForm.spies schedules-to-delete=pmScheduleForm.schedulesToDelete save-attempt=pmScheduleForm.saveAttempt work-order-template=pmScheduleForm.workOrderTemplate></pmschedule-details></div></div><!-- end scheduling list--><!--taskbook--><div ng-if=pmScheduleForm.workOrderTemplate.taskBook><div class=\"row sub-header-container\"><div class=col-xs-9><h5 id=taskBookSection scroll-spy-on spies=pmScheduleForm.spies spy-text=\"{{\'pmScheduleForm.cards.task.title\' | translate}}\" spy-position=3>{{\'pmScheduleForm.cards.task.title\' | translate}}</h5></div></div><div class=content-section><task-book-select task-book=pmScheduleForm.workOrderTemplate.taskBook link-id=pmScheduleForm.taskBookLinkId></task-book-select><div class=row ng-if=pmScheduleForm.workOrderTemplate.taskBook.isMaster><div class=col-xs-12><strong>{{::\'pmScheduleForm.cards.task.linkedTo\' | translate}}:</strong>&nbsp <a class=cursor-pointer ui-sref=\"secure.taskBookEdit({id: pmScheduleForm.taskBookLinkId || pmScheduleForm.workOrderTemplate.taskBook.id})\">{{pmScheduleForm.workOrderTemplate.taskBook.title}}</a></div></div><task-book task-book=pmScheduleForm.workOrderTemplate.taskBook mode=pmScheduleForm.taskBookMode tasks-to-delete=pmScheduleForm.tasksToDelete></task-book></div></div><!-- end taskbook--><!--Build a form cards--><div class=row><div class=\"col-sm-6 col-md-4\" ng-if=\"pmScheduleForm.schedules.length === 0\"><div class=\"content-section cards-row-container\"><div class=card><div class=card-header><h4>{{::\'pmScheduleForm.cards.schedule.title\' | translate}} <small><span class=\"label text-capitalize\" ng-class=\"{\'label-danger\': form.schedulecard.$error && pmScheduleForm.saveAttempt, \'label-default\': !pmScheduleForm.saveAttempt }\">{{::\'general.validation.required\' | translate}}</span></small></h4></div><div class=card-body>{{::\'pmScheduleForm.cards.schedule.body\' | translate}}</div><input type=hidden ng-model=scheduleCard name=schedulecard ng-required=true><div class=card-footer><button class=\"btn btn-default\" ng-click=pmScheduleForm.addSchedule()>{{::\'pmScheduleForm.cards.schedule.button\' | translate}}</button></div></div></div></div><div class=\"col-sm-6 col-md-4\" ng-if=!pmScheduleForm.workOrderTemplate.taskBook><div class=\"content-section cards-row-container\"><div class=card><div class=card-header><h4>{{::\'pmScheduleForm.cards.task.title\' | translate}}</h4></div><div class=card-body>{{::\'pmScheduleForm.cards.task.body\' | translate}}</div><div class=card-footer><button class=\"btn btn-default\" ng-click=pmScheduleForm.addTaskBook()>{{::\'pmScheduleForm.cards.task.button\' | translate}}</button></div></div></div></div></div><!--End Build a form cards--></form></div><div class=\"col-sm-2 hidden-xs\"><scroll-spy anchors=pmScheduleForm.spies header-offset=pmScheduleForm.headerOffset></scroll-spy></div></div></div><div class=\"row action-row-fixed hidden-print\"><div class=container><div class=col-xs-12><save-button form=form click-function=pmScheduleForm.save() save-attempt=pmScheduleForm.saveAttempt></save-button><a ui-sref=secure.pmScheduleList class=\"btn btn-link\">{{::\'general.actions.cancel\' | translate}}</a> <button class=\"btn btn-link text-danger pull-right\" ng-click=pmScheduleForm.deletePmSchedule() ng-if=pmScheduleForm.workOrderTemplate.id>{{::\'general.actions.delete\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/pmScheduleList/pmScheduleList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-xs-6><h4>{{::\'pmScheduleList.title\' | translate}}<results-message total=pmScheduleList.totalCount class=hidden-xs></results-message></h4></div><div class=\"col-xs-6 col-sm-3\"><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\': pmScheduleList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <a ui-sref=secure.pmScheduleCreate class=\"btn btn-primary\" aria-label=\"{{::\'pmScheduleList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"pmScheduleList.sort(\'Title\')\"><strong>{{::\'pmScheduleList.schedule\' | translate}}<sort-icon property=pmScheduleList.sortable.Title></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'pmScheduleListFiltersForm\'\" filters=pmScheduleList.filters clear-filters=pmScheduleList.clearFilters()><filter-search filter=pmScheduleList.filters.q></filter-search><filter-status filter=pmScheduleList.filters.isActive></filter-status><filter-assets filter=pmScheduleList.filters.businessAssets include-descendants=pmScheduleList.filters.includeDescendants hide-check-box=pmScheduleList.assetHideCheckBox browse-options=pmScheduleList.assetBrowseOptions></filter-assets><filter-purpose filter=pmScheduleList.filters.purpose></filter-purpose></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-4><strong class=cursor-pointer ng-click=\"pmScheduleList.sort(\'Description\')\">{{::\'pmScheduleList.schedule\' | translate}}<sort-icon property=pmScheduleList.sortable.Description></sort-icon></strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"pmScheduleList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-click=pmScheduleList.editPmSchedule(pmSchedule) ng-repeat=\"pmSchedule in pmScheduleList.listData track by pmSchedule.id\"><div class=col-xs-4>{{::pmSchedule.description}}</div></div><div class=row><div class=col-sm-12 ng-hide=\"pmScheduleList.totalCount <= pmScheduleList.filters.pageSize\"><ul uib-pagination total-items=pmScheduleList.totalCount ng-model=pmScheduleList.filters.page ng-change=pmScheduleList.pageChanged() items-per-page=pmScheduleList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/pmScheduleMeterReading/pmScheduleMeterReading.html","<sliding-panel cancel-button=true button-functions=pmScheduleMeterReading.slidingButtons open-when=pmScheduleMeterReading.openWhen titles=pmScheduleMeterReading.titles form=scheduleAssetReadingForm><panel-body><div class=panel-form-content><form name=scheduleAssetReadingForm novalidate><div class=row><div class=\"col-xs-12 sliding-panel-helper\"><em class=text-info>{{::\'pmScheduleMeterReading.helperMessage\' | translate}}</em></div></div><div class=\"row margin\" ng-repeat=\"businessAsset in pmScheduleMeterReading.meteredAssets\"><div class=col-xs-12><label>{{::businessAsset.name}}</label><bread-crumbs asset=businessAsset no-links=true></bread-crumbs><asset-usage should-validate=true ng-if=businessAsset.meteredAttribute required asset-attribute=businessAsset.meteredAttribute asset=businessAsset show-title=false disable-actions=true country=USA show-previous-value=true></asset-usage><hr ng-if=!$last></div></div></form></div><hr ng-if=\"pmScheduleMeterReading.notMeteredAssets.length > 0\"><div class=panel-form-content ng-if=\"pmScheduleMeterReading.notMeteredAssets.length > 0\"><div class=row><div class=col-xs-12><h4>{{::\'pmScheduleMeterReading.notTrackedHeader\' | translate}}</h4></div></div><div class=row><div class=\"col-xs-12 sliding-panel-helper\"><em class=text-danger>{{::\'pmScheduleMeterReading.removeWarning\' | translate}}</em></div></div><div class=row ng-repeat-start=\"businessAsset in pmScheduleMeterReading.notMeteredAssets\"><div class=col-xs-12><label>{{::businessAsset.name}}</label><bread-crumbs asset=businessAsset no-links=true></bread-crumbs></div></div><hr ng-if=!$last ng-repeat-end></div></panel-body></sliding-panel>");
$templateCache.put("app/components/pmScheduleRecurrence/pmScheduleRecurrence.html","<sliding-panel cancel-button=true button-functions=pmScheduleRecurrence.slidingButtons show-navigation-warning=true open-when=pmScheduleRecurrence.openWhen titles=pmScheduleRecurrence.titles><panel-body><div class=panel-form-content><ng-form name=recurrencePatternForm><div class=row><div class=\"col-xs-12 sliding-panel-helper\"><em class=text-info>{{::\'pmScheduleRecurrence.helperMessage\' | translate}}</em></div></div><div class=row><div class=col-xs-12><div class=form-group><recurrence-pattern ng-model=pmScheduleRecurrence.recurrencePatternModel form=recurrencePatternForm schedule-type=pmScheduleRecurrence.scheduleType meter-interval=pmScheduleRecurrence.meterInterval></recurrence-pattern></div></div></div></ng-form></div></panel-body></sliding-panel>");
$templateCache.put("app/components/projectForm/projectForm.html","<div class=\"row header-container\"><div class=col-xs-12><h4 class=inline-block>{{::(projectForm.project.id ? \'projectForm.editTitle\' : \'projectForm.createTitle\') | translate}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate navigation-warning form=form skip-navigation-warning=projectForm.skipNavigationWarning><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.name.$invalid && (form.name.$touched || projectForm.saveAttempt)}\"><label for=name>{{::\'projectForm.projectName\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=name required maxlength=50 class=form-control placeholder=\"\" ng-model=projectForm.project.name focus-on=true><p class=text-danger ng-messages=form.name.$error ng-if=\"form.name.$touched || projectForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=description>{{::\'projectForm.description\' | translate}}</label><text-area id=description textarea-name=description ng-model=projectForm.project.description maxlength=255 maxlines=10></text-area></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=notes>{{::\'projectForm.notes\' | translate}}</label><text-area id=notes textarea-name=notes ng-model=projectForm.project.notes maxlength=2000 maxlines=10></text-area></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=startDate>{{::\'projectForm.startDate\' | translate}}</label><calendar id=startDate name=startDate max-date=projectForm.project.endDate end-of-day=true ng-model=projectForm.project.startDate></calendar></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=endDate>{{::\'projectForm.endDate\' | translate}}</label><calendar id=endDate name=endDate min-date=projectForm.project.startDate end-of-day=true ng-model=projectForm.project.endDate></calendar></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\" ng-class=\"{\'has-error\': form.budget.$invalid && (form.budgetedAmount.$touched || projectForm.saveAttempt)}\"><div class=form-group><label for=budgetedAmount>{{::\'projectForm.budgetedAmount\' | translate}}</label><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i><number-field ng-model=projectForm.project.budgetedAmount max=999999999 min=0 name=budgetedAmount places=2></number-field></div><p class=text-danger ng-messages=form.budgetedAmount.$error ng-if=\"form.budgetedAmount.$touched || projectForm.saveAttempt\"><span ng-message=maximum>{{::\'projectForm.validation.budgetedAmount.max\' | translate}} </span><span ng-message=minimum>{{::\'projectForm.validation.budgetedAmount.min\' | translate}}</span></p></div></div></div><div class=row><div class=col-xs-6><div class=checkbox><label><input type=checkbox ng-model=projectForm.project.isActive> {{::\'general.active\' | translate}}</label></div></div></div></form></div><div class=\"row sub-header-container\"><div class=col-xs-12><h5>{{::\'projectForm.tracking.title\' | translate}}</h5></div></div><div class=content-section><div class=row><div class=\"col-xs-12 col-sm-6 pull-right\"><div class=row><div class=col-xs-9><em class=text-muted>{{::projectForm.totalCost.total | currency}} {{::\'general.of\' | translate}} <span ng-if=projectForm.project.budgetedAmount>{{projectForm.budget | currency}}</span> <span ng-if=!projectForm.project.budgetedAmount>$0.00</span> {{::\'general.spent\' | translate}}</em><div class=budget-bar><uib-progressbar type={{projectForm.barState}} value=projectForm.barValue></uib-progressbar></div></div><div class=col-xs-3><div class=text-right><strong>{{::\'projectForm.tracking.remaining\' | translate}}</strong></div><div class=text-right><strong ng-class=\"\'text-\' + projectForm.barState\">{{projectForm.budgetRemainder | currency}}</strong></div></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=\"col-xs-12 font-secondary\"><strong>{{::\'projectForm.tracking.purchases\' | translate}}</strong> <span class=pull-right>{{::projectForm.totalCost.purchase | currency}}</span></div><div class=\"col-xs-12 font-secondary\"><strong>{{::\'projectForm.tracking.labor\' | translate}}</strong> <span class=pull-right>{{::projectForm.totalCost.labor | currency}}</span></div><div class=\"col-xs-12 font-secondary\"><strong>{{::\'projectForm.tracking.services\' | translate}}</strong> <span class=pull-right>{{::projectForm.totalCost.service | currency}}</span></div><div class=col-xs-12><strong>{{::\'projectForm.tracking.total\' | translate}}</strong> <span class=pull-right>{{::projectForm.totalCost.total | currency}}</span></div></div></div></div><hr class=tracking-spacer><div class=row><div class=col-xs-12><div class=project-association><stong ng-if=\"projectForm.workOrderCount > 0\">{{:: \'projectForm.workOrder.association\' | translate}}</stong><a ui-sref=secure.workOrderList({{projectForm.workOrderFilters}}) ng-if=\"projectForm.workOrderCount > 0\">{{projectForm.workOrderCount}}<ng-pluralize count=projectForm.workOrderCount when=\"{\'1\': \' {{::&quot;projectForm.workOrder.singular&quot; | translate}}\',\n                                   \'other\': \' {{::&quot;projectForm.workOrder.plural&quot; | translate}}\' }\"></ng-pluralize></a><em ng-if=\"projectForm.workOrderCount === 0\" class=text-hint>{{::\'projectForm.workOrder.noAssociation\' | translate}}</em></div><div ng-if=projectForm.activeProject class=project-create-button><button class=\"btn btn-default\" ng-disabled=!projectForm.project.id ui-sref=\"secure.workOrderFormNew({project: projectForm.project.id})\">{{::\'projectForm.workOrder.create\' | translate}}</button></div></div></div></div><div class=\"row action-row-fixed\"><div class=container><div class=col-xs-12><save-button form=form click-function=projectForm.saveProject() save-attempt=projectForm.saveAttempt></save-button><a class=\"btn btn-link\" ui-sref=secure.projectList>{{::\'general.actions.cancel\' | translate}}</a></div></div></div></div>");
$templateCache.put("app/components/projectList/projectList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'projectList.title\' | translate}}<results-message total=projectList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\': projectList.isFilterApplied()}\" aria-hidden=true></i></button> <a ui-sref=secure.projectCreate class=\"btn btn-primary\" aria-label=\"{{::\'projectList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'projectListFiltersForm\'\" filters=projectList.filters clear-filters=projectList.clearFilters()><filter-search filter=projectList.filters.q></filter-search></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-8><strong>{{::\'projectList.name\' | translate}}</strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"projectList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><a ui-sref=\"secure.projectEdit({id: project.id})\" class=\"row grid-row cursor-pointer\" ng-repeat=\"project in projectList.listData track by project.id\"><div class=col-xs-8><strong class=truncate>{{::project.name}}</strong><div>{{::project.description}}</div></div><span class=col-xs-4><span class=\"label label-warning\" ng-if=::!project.isActive>{{::\'general.inactive\' | translate}}</span></span></a><div class=row><div class=col-sm-12 ng-hide=\"projectList.totalCount <= projectList.filters.pageSize\"><ul uib-pagination total-items=projectList.totalCount ng-model=projectList.filters.page ng-change=projectList.pageChanged() items-per-page=projectList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/purposeList/purposeList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'purposeList.title\' | translate}}<results-message total=purposeList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\': purposeList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button ng-click=purposeList.openPurposePanel(true) class=\"btn btn-primary\" aria-label=\"{{::\'purposeList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></button></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"purposeList.sort(\'Value\')\"><strong>{{::\'purposeList.name\' | translate}}<sort-icon property=purposeList.sortable.Value></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeList.sort(\'PurposeType/Name\')\"><strong>{{::\'purposeList.purposeType\' | translate}}<sort-icon property=\"purposeList.sortable[\'PurposeType/Name\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'purposeListFiltersForm\'\" filters=purposeList.filters clear-filters=purposeList.clearFilters()><filter-search filter=purposeList.filters.q></filter-search><filter-status filter=purposeList.filters.isActive></filter-status><filter-purpose-type filter=purposeList.filters.purposeTypeId></filter-purpose-type></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-xs-5><strong class=cursor-pointer ng-click=\"purposeList.sort(\'Value\')\">{{::\'purposeList.name\' | translate}}<sort-icon property=purposeList.sortable.Value></sort-icon></strong></div><div class=col-xs-5><strong class=cursor-pointer ng-click=\"purposeList.sort(\'PurposeType/Name\')\">{{::\'purposeList.purposeType\' | translate}}<sort-icon property=\"purposeList.sortable[\'PurposeType/Name\']\"></sort-icon></strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"purposeList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-click=\"purposeList.openPurposePanel(false, purpose)\" ng-repeat=\"purpose in purposeList.listData track by purpose.id\"><div class=col-xs-5>{{ purpose.value }}</div><div class=col-xs-5>{{ purpose.purposeType.name }}</div><div class=col-xs-2><div class=\"label label-warning\" ng-if=!purpose.isActive>{{::\'purposeList.inactive\' | translate}}</div><div class=\"label label-default\" ng-if=\"(purpose.id === purposeList.reactiveDefault.id) || (purpose.id === purposeList.plannedDefault.id)\">{{::\'purposeList.default\' | translate}}</div></div></div><div class=row><div class=col-sm-12 ng-hide=\"purposeList.totalCount <= purposeList.filters.pageSize\"><ul uib-pagination total-items=purposeList.totalCount ng-model=purposeList.filters.page ng-change=purposeList.pageChanged() items-per-page=purposeList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><purpose-panel purposes=purposeList.listData total-count=purposeList.totalCount></purpose-panel>");
$templateCache.put("app/components/purposePanel/purposeDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'purposePanel.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'purposePanel.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=purposeDeleteModalController.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=purposeDeleteModalController.close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/purposePanel/purposeDeleteWarningModal.html","<div class=modal-header><h4><span class=title>{{purposeDeleteModalController.getTitle()}}</span></h4></div><div class=modal-body><div class=error-container><div ng-if=purposeDeleteModalController.purpose.isDefault><div ng-if=purposeDeleteModalController.fromSaveInactive><p>{{::\'purposePanel.defaultModal.defaultedValue\' | translate}}</p><p><a ui-sref=secure.settingsEdit ng-click=purposeDeleteModalController.close()>{{::\'purposePanel.deleteModal.manageDefaults\' | translate}}</a></p></div><div ng-if=!purposeDeleteModalController.fromSaveInactive><p>{{::\'purposePanel.deleteModal.defaultedValue\' | translate}}</p><p><a ui-sref=secure.settingsEdit ng-click=purposeDeleteModalController.close()>{{::\'purposePanel.deleteModal.manageDefaults\' | translate}}</a></p></div></div><div ng-if=!purposeDeleteModalController.purpose.isDefault><div ng-if=\"purposeDeleteModalController.workOrderCount > 0 && purposeDeleteModalController.workOrderTemplateCount === 0\"><p>{{::\'purposePanel.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{purposeDeleteModalController.workOrderCount}}&nbsp{{::\'purposePanel.deleteModal.workOrders\' | translate}}</strong>.</p><p>{{::\'purposePanel.deleteModal.reassignMessageWorkOrders\' | translate}}.</p><p><a ui-sref=\"secure.workOrderList({\'purpose\': purposeDeleteModalController.purpose.id})\" ng-click=purposeDeleteModalController.close()>{{::\'purposePanel.deleteModal.viewWorkOrders\' | translate}}</a></p></div><div ng-if=\"purposeDeleteModalController.workOrderTemplateCount > 0 && purposeDeleteModalController.workOrderCount === 0\"><p>{{::\'purposePanel.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{purposeDeleteModalController.workOrderTemplateCount}}&nbsp{{::\'purposePanel.deleteModal.pmSchedules\' | translate}}</strong>.</p><p>{{::\'purposePanel.deleteModal.reassignMessagePmSchedules\' | translate}}.</p><p><a ui-sref=\"secure.pmScheduleList({\'purpose\': purposeDeleteModalController.purpose.id})\" ng-click=purposeDeleteModalController.close()>{{::\'purposePanel.deleteModal.viewPmSchedules\' | translate}}</a></p></div><div ng-if=\"purposeDeleteModalController.workOrderTemplateCount > 0 && purposeDeleteModalController.workOrderCount > 0\"><p>{{::\'purposePanel.deleteModal.cannotDeleteMessage\' | translate}} <strong>{{purposeDeleteModalController.workOrderTemplateCount}}&nbsp{{::\'purposePanel.deleteModal.pmSchedules\' | translate}}</strong>&nbsp{{::\'purposePanel.deleteModal.and\' | translate}}<strong>&nbsp{{purposeDeleteModalController.workOrderCount}}&nbsp{{::\'purposePanel.deleteModal.workOrders\' | translate}}</strong>.</p><p>{{::\'purposePanel.deleteModal.reassignMessage\' | translate}}.</p><p><a ui-sref=\"secure.workOrderList({\'purpose\': purposeDeleteModalController.purpose.id})\" ng-click=purposeDeleteModalController.close()>{{::\'purposePanel.deleteModal.viewWorkOrders\' | translate}}</a></p><p><a ui-sref=\"secure.pmScheduleList({\'purpose\': purposeDeleteModalController.purpose.id})\" ng-click=purposeDeleteModalController.close()>{{::\'purposePanel.deleteModal.viewPmSchedules\' | translate}}</a></p></div></div></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=purposeDeleteModalController.close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/purposePanel/purposePanel.html","<sliding-panel open-when=purposePanel.openWhen button-functions=purposePanel.buttonFunctions titles=purposePanel.titles show-navigation-warning=true save-attempt=purposePanel.saveAttempt form=purposePanelForm><panel-body><div class=panel-form-content><form name=purposePanelForm novalidate><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': purposePanelForm.value.$invalid && (purposePanelForm.value.$touched || purposePanel.saveAttempt)}\"><label for=value>{{::\'purposePanel.purposeName\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=value name=value required maxlength=50 class=form-control placeholder=\"\" ng-model=purposePanel.purpose.value focus-on=true><p class=text-danger ng-messages=purposePanelForm.value.$error ng-if=\"purposePanelForm.value.$touched || purposePanel.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': purposePanelForm.type.$invalid && (purposePanelForm.type.$touched || purposePanel.saveAttempt)}\"><label for=type>{{::\'purposeList.purposeType\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><select class=form-control id=type name=type ng-change=purposePanel.setPurposeType() ng-required=purposePanel.purpose.isActive ng-model=purposePanel.selected ng-options=\"purposeType.name for purposeType in purposePanel.purposeTypes\"><option value=\"\"></option></select><p class=text-danger ng-messages=purposePanelForm.type.$error ng-if=\"purposePanelForm.type.$touched || purposePanel.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div><div class=checkbox><label><input type=checkbox name=active id=active ng-model=purposePanel.purpose.isActive pm-association-validator=purposePanel.associations> {{::\'purposePanel.isActive\' | translate}}</label><p class=text-danger ng-messages=purposePanelForm.active.$error><span ng-message=pmAssociation>{{purposePanel.associationsValidation}}</span></p></div></div></div></form></div></panel-body></sliding-panel>");
$templateCache.put("app/components/purposeReport/purposeReportChart.html","<div><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-link hidden-xs\" has-markets=\"purposeReport.market.k12, purposeReport.market.he, purposeReport.market.ips\" ng-click=purposeReport.printCharts()>{{::\'general.print\' | translate}}</button> <button class=\"btn btn-default\" ng-click=purposeReport.listRoute() aria-label=\"{{::\'purposeReports.listRoute\' | translate}}\"><i class=\"fa fa-list\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=purposeReport.clearFilters() toggle-filters=purposeReport.purposeReportFilter() set-function=\"purposeReport.setFilters(value, save)\" filters=purposeReport.filters></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><report-navigation filters=purposeReport.filters></report-navigation><div class=\"border-bottom work-order-chart chart-wrapper interactive-chart\"><charting chart-data=purposeReport.workOrderChartData chart-labels=purposeReport.workOrderLabels chart-type=\"\'bar\'\" click-function=purposeReport.clickFunctionObject></charting></div><div class=\"border-bottom cost-chart chart-wrapper\"><charting chart-data=purposeReport.costChartData chart-labels=purposeReport.costLabels chart-type=\"\'stacked-bar\'\" chart-legend=purposeReport.costLegend></charting></div><div class=\"labor-hours-chart chart-wrapper\"><charting chart-data=purposeReport.laborChartData chart-labels=purposeReport.laborHoursLabels chart-type=\"\'bar\'\"></charting></div></div></div></div></div><report-filters filters=purposeReport.filters set-function=\"purposeReport.setFilters(value, save)\" open-when=purposeReport.openWhen clear-function=purposeReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/purposeReport/purposeReportList.html","<div class=report-list><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile=true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button class=\"btn btn-link hidden-xs\" ng-if=purposeReport.filterState.totalCount ng-click=purposeReport.export()>{{::\'purposeReports.export\' | translate}}</button> <button class=\"btn btn-default\" ng-click=purposeReport.chartRoute() aria-label=\"{{::\'purposeReports.chartRoute\' | translate}}\"><i class=\"fa fa-bar-chart\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=filter-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=row><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Purpose/Value\')\"><strong>{{::\'purposeReports.title\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Purpose/Value\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Count/WorkOrders\')\"><strong>{{::\'reports.count\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Count/WorkOrders\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Count/LaborHours\')\"><strong>{{::\'general.hours\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Count/LaborHours\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Cost/Labor\')\"><strong>{{::\'reports.byCost.labor\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Cost/Labor\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Cost/Purchase\')\"><strong>{{::\'reports.byCost.purchase\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Cost/Purchase\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Cost/Service\')\"><strong>{{::\'reports.byCost.service\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Cost/Service\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Cost/Total\')\"><strong>{{::\'general.total\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Cost/Total\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=purposeReport.clearFilters() toggle-filters=purposeReport.purposeReportFilter() set-function=\"purposeReport.setFilters(value, save)\" filters=purposeReport.filters></filter-bar><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><report-navigation filters=purposeReport.filters></report-navigation><report-list-totals ng-if=\"purposeReport.listData.length !== 0 && purposeReport.filters.returnAverages !== \'true\'\" data=purposeReport.totalListData></report-list-totals><div class=\"row hidden-xs grid-header\"><div class=col-sm-2><strong class=cursor-pointer ng-click=\"purposeReport.sort(\'Purpose/Value\')\">{{::\'purposeReports.title\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Purpose/Value\']\"></sort-icon></strong></div><div class=col-sm-10><div class=row><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"purposeReport.sort(\'Count/WorkOrders\')\">{{::\'reports.count\' | translate}}<sort-icon property=\"purposeReport.sortable[\'Count/WorkOrders\']\"></sort-icon></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"purposeReport.sort(\'Count/LaborHours\')\"><div ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'general.hours\' | translate}}<sort-icon class=sort-icon-align property=\"purposeReport.sortable[\'Count/LaborHours\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"purposeReport.sort(\'Cost/Labor\')\"><div ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'reports.byCost.labor\' | translate}}<sort-icon class=sort-icon-align property=\"purposeReport.sortable[\'Cost/Labor\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"purposeReport.sort(\'Cost/Purchase\')\"><div ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'reports.byCost.purchase\' | translate}}<sort-icon class=sort-icon-align property=\"purposeReport.sortable[\'Cost/Purchase\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"purposeReport.sort(\'Cost/Service\')\"><div ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'reports.byCost.service\' | translate}}<sort-icon class=sort-icon-align property=\"purposeReport.sortable[\'Cost/Service\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"purposeReport.sort(\'Cost/Total\')\"><div ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}<sort-icon class=sort-icon-align property=\"purposeReport.sortable[\'Cost/Total\']\"></sort-icon><div class=column-header>{{::\'reports.byCost.cost\' | translate}}</div></div><div ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}<div class=column-header>{{::\'general.total\' | translate}} {{::\'reports.byCost.cost\' | translate}}<sort-icon class=sort-icon-align property=\"purposeReport.sortable[\'Cost/Total\']\"></sort-icon></div></div></strong></div></div></div></div><div class=\"col-sm-12 no-results\" ng-if=\"purposeReport.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-repeat=\"value in purposeReport.listData\" ng-click=purposeReport.viewWorkOrders(value.purpose.id)><div class=\"col-sm-2 truncate\"><span class=hidden-xs>{{::value.purpose.value}}</span> <span class=\"visible-xs text-medium-weight\">{{::value.purpose.value}}</span></div><div class=\"col-sm-10 hidden-xs\"><div class=row><div class=col-sm-2><span class=pull-right>{{::value.count.workOrders | number}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.count.laborHours| number:2}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.labor | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.service | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.total | currency}}</span></div></div></div><div class=\"col-xs-10 visible-xs\"><div class=row><div class=col-xs-6><div><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <span class=pull-right><strong>{{::value.count.workOrders | number}}</strong></span></div><div><span ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'general.hours\' | translate}}</span> <span class=pull-right><strong>{{::value.count.laborHours | number:2}}</strong></span></div></div><div class=col-xs-6><div><span ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} {{::\'general.total\' | translate}} </span><span>{{::\'reports.byCost.cost\' | translate}}</span> <span class=pull-right><strong>{{::value.cost.total | currency}}</strong></span></div><div><span ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'reports.byCost.labor\' | translate}}</span> <span class=pull-right>{{::value.cost.labor | currency}}</span></div><div><span ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'reports.byCost.purchase\' | translate}}</span> <span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div><span ng-if=\"purposeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"purposeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'reports.byCost.service\' | translate}}</span> <span class=pull-right>{{::value.cost.service | currency}}</span></div></div></div></div></div><div class=row><div class=col-sm-12 ng-hide=\"purposeReport.filterState.totalCount <= purposeReport.filters.pageSize\"><ul uib-pagination total-items=purposeReport.filterState.totalCount ng-model=purposeReport.filters.page ng-change=purposeReport.pageChanged() items-per-page=purposeReport.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><report-filters filters=purposeReport.filters set-function=\"purposeReport.setFilters(value, save)\" open-when=purposeReport.openWhen clear-function=purposeReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/reportFilters/reportFilters.html","<div><sliding-filter-panel open-when=openWhen.value filters=filters set-function=\"setFilters({value, save})\" clear-function=clearFilters({removeMyFilter})><filter-workorder-date filters=filters date-values=dateValues cleared=cleared></filter-workorder-date><filter-workorder-status filter=filters.status></filter-workorder-status><filter-work-type has-markets=\"market.k12, market.he, market.ips\" filter=filters.workType></filter-work-type><filter-purpose filter=filters.purpose></filter-purpose><filter-assets filter=filters.businessAsset include-descendants=checkbox.state hide-check-box=assetHideCheckBox browse-options=assetBrowseOptions additional-filters=assetAdditionalFilters></filter-assets></sliding-filter-panel></div>");
$templateCache.put("app/components/reports/reportListTotals.html","<div class=\"row report-totals-row\"><div class=\"col-sm-3 hidden-xs\"><div><strong>{{::\'reports.totals\' | translate}}</strong></div><div class=total-number><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <strong>{{reportListTotals.data.count.workOrders | number}}</strong></div><div class=total-number><span>{{::\'reports.byCost.hours\' | translate}}</span> <strong>{{reportListTotals.data.count.laborHours | number:2}}</strong></div></div><div class=\"col-sm-9 hidden-xs\"><div class=row><div class=\"col-sm-3 first-segment total-segment text-center\"><div><span>{{::\'reports.byCost.labor\' | translate}}</span></div><div class=total-number ng-class=\"{\'font-size-lg\': reportListTotals.data.cost.labor <= 99999, \'font-size-md\': reportListTotals.data.cost.labor > 99999 && reportListTotals.data.cost.labor <= 999999, \'font-size-base\': reportListTotals.data.cost.labor > 999999  && reportListTotals.data.cost.labor <= 9999999, \'font-size-sm\': reportListTotals.data.cost.labor > 9999999}\"><span>{{reportListTotals.data.cost.labor | currency}}</span></div></div><div class=\"col-sm-3 total-segment text-center\"><div><span>{{::\'reports.byCost.purchase\' | translate}}</span></div><div class=total-number ng-class=\"{\'font-size-lg\': reportListTotals.data.cost.purchase <= 99999, \'font-size-md\': reportListTotals.data.cost.purchase > 99999 && reportListTotals.data.cost.purchase <= 999999, \'font-size-base\': reportListTotals.data.cost.purchase > 999999  && reportListTotals.data.cost.purchase <= 9999999, \'font-size-sm\': reportListTotals.data.cost.purchase > 9999999}\"><span>{{reportListTotals.data.cost.purchase | currency}}</span></div></div><div class=\"col-sm-3 total-segment text-center\"><div><span>{{::\'reports.byCost.service\' | translate}}</span></div><div class=total-number ng-class=\"{\'font-size-lg\': reportListTotals.data.cost.service <= 99999, \'font-size-md\': reportListTotals.data.cost.service > 99999 && reportListTotals.data.cost.service <= 999999, \'font-size-base\': reportListTotals.data.cost.service > 999999  && reportListTotals.data.cost.service <= 9999999, \'font-size-sm\': reportListTotals.data.cost.service > 9999999}\"><span>{{reportListTotals.data.cost.service | currency}}</span></div></div><div class=\"col-sm-3 text-center\"><div><span>{{::\'reports.byCost.total\' | translate}}</span></div><div class=total-number ng-class=\"{\'font-size-lg\': reportListTotals.data.cost.total <= 99999, \'font-size-md\': reportListTotals.data.cost.total > 99999 && reportListTotals.data.cost.total <= 999999, \'font-size-base\': reportListTotals.data.cost.total > 999999  && reportListTotals.data.cost.total <= 9999999, \'font-size-sm\': reportListTotals.data.cost.total > 9999999}\"><strong>{{reportListTotals.data.cost.total | currency}}</strong></div></div></div></div><div class=\"mobile-report-totals-row visible-xs\"><div class=col-xs-6><div><strong><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <span class=pull-right>{{::reportListTotals.data.count.workOrders | number}}</span></strong></div><div><strong>{{::\'reports.totals\' | translate}}</strong></div><div><strong><span>{{::\'reports.byLaborHours.hours\' | translate}}</span> <span class=pull-right>{{::reportListTotals.data.count.laborHours | number:2}}</span></strong></div><div><span>{{::\'reports.byCost.labor\' | translate}}</span> <span class=pull-right>{{::reportListTotals.data.cost.labor | currency}}</span></div><div><span>{{::\'reports.byCost.purchase\' | translate}}</span> <span class=pull-right>{{::reportListTotals.data.cost.purchase | currency}}</span></div><div><span>{{::\'reports.byCost.service\' | translate}}</span> <span class=pull-right>{{::reportListTotals.data.cost.service | currency}}</span></div></div><div class=col-xs-6><div class=\"text-right mobile-total-cost\">{{::\'reports.byCost.total\' | translate}}</div><div class=\"text-right total-number\" ng-class=\"{\'font-size-lg\': reportListTotals.data.cost.labor <= 99999, \'font-size-md\': reportListTotals.data.cost.labor > 99999 && reportListTotals.data.cost.labor <= 999999, \'font-size-base\': reportListTotals.data.cost.labor > 999999  && reportListTotals.data.cost.labor <= 9999999, \'font-size-sm\': reportListTotals.data.cost.labor > 9999999}\"><strong>{{::reportListTotals.data.cost.total | currency}}</strong></div></div></div><div class=row><div class=\"visible-xs col-xs-12 mobile-section-separator\"></div></div></div>");
$templateCache.put("app/components/reports/reportNavigation.html","<div class=report-navigation-section><div class=row><div ng-class=\"(reportNavigation.isActiveRoute(\'purpose\') || reportNavigation.isActiveRoute(\'workType\')) && !reportNavigation.isChartView ? \'col-lg-8\' : \'col-md-12\'\"><ul class=\"nav nav-tabs tab-navigation\"><li role=presentation ng-class=\"{\'active\': reportNavigation.isActiveRoute(\'locations\')}\"><a ng-click=\"reportNavigation.routeTo(\'locations\')\" class=\"text-medium-weight cursor-pointer\">{{::\'reports.locations\' | translate}}</a></li><li role=presentation ng-class=\"{\'active\': reportNavigation.isActiveRoute(\'equipment\')}\"><a ng-click=\"reportNavigation.routeTo(\'equipment\')\" class=\"text-medium-weight cursor-pointer\">{{::\'reports.equipment\' | translate}}</a></li><li role=presentation ng-class=\"{\'active\': reportNavigation.isActiveRoute(\'workType\')}\" has-markets=\"reportNavigation.market.k12, reportNavigation.market.he, reportNavigation.market.ips\"><a ng-click=\"reportNavigation.routeTo(\'workType\')\" class=\"text-medium-weight cursor-pointer\">{{::\'reports.workTypes\' | translate}}</a></li><li role=presentation ng-class=\"{\'active\': reportNavigation.isActiveRoute(\'purpose\')}\"><a ng-click=\"reportNavigation.routeTo(\'purpose\')\" class=\"text-medium-weight cursor-pointer\">{{::\'reports.purposes\' | translate}}</a></li><li role=presentation ng-class=\"{\'active\': reportNavigation.isActiveRoute(\'failure\')}\" has-markets=\"reportNavigation.market.mfg, reportNavigation.market.club, reportNavigation.market.other, reportNavigation.market.gov\"><a ng-click=\"reportNavigation.routeTo(\'failure\')\" class=\"text-medium-weight cursor-pointer\">{{::\'reports.failures\' | translate}}</a></li><li role=presentation ng-class=\"{\'active\': reportNavigation.isActiveRoute(\'employee\')}\"><a ng-click=\"reportNavigation.routeTo(\'employee\', true)\" class=\"text-medium-weight cursor-pointer\">{{::\'reports.employees\' | translate}}</a></li></ul></div><div class=\"hidden-xs hidden-sm hidden-md col-md-4 radio-border\" ng-if=\"(reportNavigation.isActiveRoute(\'purpose\') || reportNavigation.isActiveRoute(\'workType\')) && !reportNavigation.isChartView\"><div class=row><div class=col-md-6><div class=radio><label><input type=radio ng-model=reportNavigation.filters.returnAverages ng-value=\"\'false\'\"> {{::\'reports.totals\' | translate}}</label></div></div><div class=col-md-6><div class=radio><label><input type=radio ng-model=reportNavigation.filters.returnAverages ng-value=\"\'true\'\"> {{::\'reports.averages\' | translate}}</label></div></div></div></div></div><div class=\"row visible-xs visible-sm visible-md\"><div class=col-xs-12 ng-if=\"(reportNavigation.isActiveRoute(\'purpose\') || reportNavigation.isActiveRoute(\'workType\')) && !reportNavigation.isChartView\"><div class=col-xs-6><div class=radio><label><input type=radio ng-model=reportNavigation.filters.returnAverages ng-value=\"\'false\'\"> {{::\'reports.totals\' | translate}}</label></div></div><div class=col-xs-6><div class=radio><label><input type=radio ng-model=reportNavigation.filters.returnAverages ng-value=\"\'true\'\"> {{::\'reports.averages\' | translate}}</label></div></div></div></div></div>");
$templateCache.put("app/components/settingsForm/settingsForm.html","<div class=row><div class=col-sm-10><div class=\"row header-container\"><div class=col-xs-12><h4 class=h4>{{::\'settingsForm.pageTitle\' | translate}}</h4></div></div><form name=form novalidate><div><div class=\"row sub-header-container\"><div class=col-xs-12><h5 id=laborRateSection scroll-spy-on spies=settingsForm.spies spy-text=\"{{\'settingsForm.spies.laborRate\' | translate}}\" spy-position=1>{{:: \'settingsForm.laborRateMultipliers.sectionTitle\' | translate}}</h5></div></div><div class=content-section><div class=\"row form-descriptor\"><div class=col-xs-12><em class=text-info>{{::\'settingsForm.laborRateMultipliers.infoText\' | translate}}</em></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.otRateMultiplier.$invalid && (form.otRateMultiplier.$touched || settingsForm.saveAttempt)}\"><label for=otRateMultiplier>{{::\'settingsForm.laborRateMultipliers.otRateMultiplier\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><div class=input-group><div class=input-group-addon><em>{{::\'settingsForm.laborRateMultipliers.rateTypeHelperText\' | translate}}</em></div><input id=otRateMultiplier name=otRateMultiplier class=form-control min=1 max=100 ng-model=settingsForm.otRateMultiplier.multiplier type=text required force-decimal-precision min-validator max-validator number-validator focus-on=true></div><p class=\"text-danger rate-error\" ng-messages=form.otRateMultiplier.$error ng-if=\"form.otRateMultiplier.$touched || settingsForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=validNumber>{{::\'settingsForm.laborRateMultipliers.validation.number\' | translate }} </span><span ng-message=minNumber>{{::\'settingsForm.laborRateMultipliers.validation.min\' | translate }} </span><span ng-message=maxNumber>{{::\'settingsForm.laborRateMultipliers.validation.max\' | translate }}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.dtRateMultiplier.$invalid && (form.dtRateMultiplier.$touched || settingsForm.saveAttempt)}\"><label for=dtRateMultiplier>{{::\'settingsForm.laborRateMultipliers.dtRateMultiplier\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><div class=input-group><div class=input-group-addon><em>{{::\'settingsForm.laborRateMultipliers.rateTypeHelperText\' | translate}}</em></div><input id=dtRateMultiplier name=dtRateMultiplier class=form-control min=1 max=100 ng-model=settingsForm.dtRateMultiplier.multiplier type=text required force-decimal-precision min-validator max-validator number-validator></div><p class=\"text-danger rate-error\" ng-messages=form.dtRateMultiplier.$error ng-if=\"form.dtRateMultiplier.$touched || settingsForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=validNumber>{{::\'settingsForm.laborRateMultipliers.validation.number\' | translate }} </span><span ng-message=minNumber>{{::\'settingsForm.laborRateMultipliers.validation.min\' | translate }} </span><span ng-message=maxNumber>{{::\'settingsForm.laborRateMultipliers.validation.max\' | translate }}</span></p></div></div></div></div></div><div><div class=\"row sub-header-container\"><div class=col-xs-12><h5 id=purposeSection scroll-spy-on spies=settingsForm.spies spy-text=\"{{\'settingsForm.spies.purpose\' | translate}}\" spy-position=2>{{:: \'settingsForm.purpose.sectionTitle\' | translate}}</h5></div></div><div class=content-section><div class=\"row form-descriptor\"><div class=col-xs-12><em class=text-info>{{::\'settingsForm.purpose.helperText\' | translate}}</em></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>{{::\'settingsForm.purpose.reactivePurpose\' | translate}}</label><purposes-dropdown ng-model=settingsForm.defaultReactivePurpose hide-blank=true></purposes-dropdown></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>{{::\'settingsForm.purpose.plannedPurpose\' | translate}}</label><purposes-dropdown ng-model=settingsForm.defaultPlannedPurpose hide-blank=true></purposes-dropdown></div></div></div></div></div><div><div class=\"row sub-header-container\"><div class=col-xs-12><h5 id=registrationSection scroll-spy-on spies=settingsForm.spies spy-text=\"{{\'settingsForm.spies.registration\' | translate}}\" spy-position=3>{{:: \'registrationLink.requesterRegistration.sectionTitle\' | translate}}</h5></div></div><registration-link></registration-link></div><div has-markets=\"settingsForm.market.k12, settingsForm.market.he, settingsForm.market.ips\"><div class=sub-header-container><h5 id=areaRoomNumberSection scroll-spy-on spies=settingsForm.spies spy-text=\"{{::\'settingsForm.spies.requestWorkOrderForm\' | translate}}\" spy-position=4>{{:: \'settingsForm.areaRoomNumber.sectionTitle\' | translate}}</h5></div><div class=content-section><div class=row><div class=\"col-xs-12 form-descriptor\"><em class=text-info>{{::\'settingsForm.areaRoomNumber.helperText\' | translate}}</em></div><div class=col-xs-12><div class=form-group><label>{{::\'settingsForm.areaRoomNumber.helperTextSet\' | translate}}</label><text-area id=areaRoomNumber textarea-name=areaRoomNumber ng-model=settingsForm.areaRoomNumber.text maxlength=100 maxlines=10 is-required=false></text-area></div></div><div class=col-xs-12><div class=form-group><label>{{::\'settingsForm.areaRoomNumber.isRequired\' | translate}}</label><div class=form-group><div class=row><div class=col-xs-12><div class=radio><label><input type=radio ng-model=settingsForm.areaRoomNumber.isRequired ng-value=true> {{::\'settingsForm.areaRoomNumber.yes\' | translate}}</label></div><div class=radio><label><input type=radio ng-model=settingsForm.areaRoomNumber.isRequired ng-value=false> {{::\'settingsForm.areaRoomNumber.no\' | translate}}</label></div></div></div></div></div></div></div></div></div></form><div class=\"row action-row-fixed hidden-print\"><div class=container><div class=\"col-xs-12 col-sm-6\"><save-button form=form click-function=settingsForm.save() save-attempt=settingsForm.saveAttempt></save-button></div></div></div></div><div class=\"col-sm-2 hidden-xs\"><scroll-spy anchors=settingsForm.spies header-offset=settingsForm.headerOffset></scroll-spy></div></div>");
$templateCache.put("app/components/taskBookForm/taskBookDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'taskBookForm.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'taskBookForm.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/taskBookForm/taskBookDeleteWarningModal.html","<div class=modal-header><h4><span class=title>{{::\'taskBookForm.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'taskBookForm.deleteWarning.message1a\' | translate}}&nbsp<strong>{{pmScheduleCount}}&nbsp{{::\'taskBookForm.deleteWarning.message1b\' | translate}}</strong></p><p>{{::\'taskBookForm.deleteWarning.message2\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/taskBookForm/taskBookForm.html","<div class=header-container><div class=row><div class=col-xs-12><h4>{{::!taskBookForm.taskBook.id ? \'taskBookForm.createTitle\' : \'taskBookForm.editTitle\' | translate}}</h4></div></div></div><div class=main-container><form name=form novalidate navigation-warning form=form skip-navigation-warning=taskBookForm.skipNavigationWarning><div class=content-section><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.title.$invalid && (form.title.$touched || taskBookForm.saveAttempt)}\"><label for=title>{{::\'taskBookForm.taskBookTitle\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=title name=title required maxlength=100 class=form-control placeholder=\"\" ng-model=taskBookForm.taskBook.title focus-on=true><p class=text-danger ng-messages=form.title.$error ng-if=\"form.title.$touched || taskBookForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=col-xs-9 ng-show=taskBookForm.taskBook.id><label class=text-muted>{{::\'taskBookForm.lastUpdated\' | translate}}</label>&nbsp; <span name=updatedTime class=text-muted ng-if=taskBookForm.taskBook.id>{{::taskBookForm.updatedTime | translate}}</span></div></div><div class=\"row inner-heading-row\"><div class=col-xs-12><h6 class=inner-heading>{{::\'taskBookForm.tasksAndProceduresHeading\' | translate}}</h6></div></div><task-book task-book=taskBookForm.taskBook tasks-to-delete=taskBookForm.tasksToDelete></task-book></div></form><div class=\"row action-row\"><div class=col-xs-12><save-button form=form click-function=taskBookForm.saveTaskBook() save-attempt=taskBookForm.saveAttempt></save-button><button class=\"btn btn-link text-danger\" ng-click=taskBookForm.deleteTaskBook() ng-show=taskBookForm.taskBook.id>{{::\'general.actions.delete\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/taskBookList/taskBookList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'taskBookList.title\' | translate}}<results-message total=taskBookList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\':taskBookList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <a ui-sref=secure.taskBookCreate class=\"btn btn-primary\" aria-label=\"{{::\'taskBookList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"taskBookList.sort(\'Title\')\"><strong>{{::\'taskBookList.name\' | translate}}<sort-icon property=taskBookList.sortable.Title></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'taskBookFilters\'\" filters=taskBookList.filters clear-filters=taskBookList.clearFilters()><filter-search filter=taskBookList.filters.q></filter-search></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-5><strong class=cursor-pointer ng-click=\"taskBookList.sort(\'Title\')\">{{::\'taskBookList.name\' | translate}}<sort-icon property=taskBookList.sortable.Title></sort-icon></strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"taskBookList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-click=taskBookList.editTaskBook(taskBook.id) ng-repeat=\"taskBook in taskBookList.listData track by taskBook.id\"><div class=col-xs-8>{{::taskBook.title}}</div></div><div class=row><div class=col-sm-12 ng-hide=\"taskBookList.totalCount <= taskBookList.filters.pageSize\"><ul uib-pagination total-items=taskBookList.totalCount ng-model=taskBookList.filters.page ng-change=taskBookList.pageChanged() items-per-page=taskBookList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/taskBookSelect/taskBookPopBox.html","<div class=row><div class=\"copy-link col-xs-3\"><div class=\"form-group inline-block\"><div class=radio><label ng-if=popbox.showLink><input type=radio name=copyLink ng-checked=\"popbox.action === \'copy\'\" value=copy ng-model=popbox.action> {{::\'taskBookSelect.popbox.copy\' | translate}}</label></div><div ng-if=!popbox.showLink><label class=no-link>{{::\'taskBookSelect.popbox.copyFrom\' | translate}}</label></div></div><div class=\"form-group inline-block\" ng-if=popbox.showLink><div class=radio><label><input type=radio name=copyLink ng-checked=\"popbox.action === \'link\'\" value=link ng-model=popbox.action> {{::\'taskBookSelect.popbox.link\' | translate}}</label></div></div></div><div class=col-xs-8><taskbooks-typeahead ng-model=popbox.taskBookTypeahead></taskbooks-typeahead></div></div><div class=row><div class=col-xs-12><div ng-if=\"popbox.action === \'link\'\"><p>{{::\'taskBookSelect.popbox.linkMessage\' | translate}}</p><em class=text-danger ng-if=\"taskBook.tasks.length > 0 && areThereTaskOrProceduresFilledOut()\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i>&nbsp;{{::\'taskBookSelect.popbox.linkWarning\' | translate}}</em></div><div ng-if=\"popbox.action === \'copy\' && areThereTaskOrProceduresFilledOut()\"><span class=add-replace>{{::\'taskBookSelect.popbox.copyMessage\' | translate}}</span><div class=inline-block><div class=\"radio inline-block\"><label><input type=radio name=copy-action ng-checked=\"popbox.copy.action === \'add\'\" value=add ng-model=popbox.copy.action> {{::\'general.actions.add\' | translate}}</label></div><div class=\"radio inline-block\"><label><input type=radio name=copy-action ng-checked=\"popbox.copy.action === \'replace\'\" value=replace ng-model=popbox.copy.action> {{::\'general.actions.replace\' | translate}}</label></div></div></div></div></div><div class=row><div class=col-xs-12><button class=\"btn btn-primary\" ng-click=popBoxOk($event) ng-disabled=!popbox.taskBookTypeahead>{{\'general.actions.ok\'| translate}}</button> <button class=\"btn btn-link\" ng-click=closePopBox($event)>{{\'general.actions.cancel\'| translate}}</button></div></div>");
$templateCache.put("app/components/taskBookSelect/taskBookSelect.html","<div class=taskBookSelect><div class=row><div class=col-xs-6><button type=button class=\"btn btn-default open-pop-box\" ng-click=togglePopBox($event)>{{::\'taskBookSelect.selectFrom\' | translate}}</button></div></div><div class=row><div class=\"col-sm-12 col-md-6\"><pop-box name=pm-schedule-tasks-pop-box show-arrow=true arrow-position=110px><ng-include src=\"\'app/components/taskBookSelect/taskBookPopBox.html\'\"></ng-include></pop-box></div></div></div>");
$templateCache.put("app/components/taskbook/taskBook.html","<div ng-form=tasksBookForm><div class=pull-right ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_EDIT && !taskBook.hideButton\"><button class=\"btn btn-default btn-circle hidden-print\" ng-click=taskBook.addTasks(1) type=button><i class=\"fa fa-plus fa-2x text-primary\" aria-hidden=true></i></button></div><div class=no-results><h6 ng-if=\"taskBook.taskBook.tasks.length === 0\"><em class=text-muted>{{taskBook.mode === taskBook.MODES.COMPLETED_EDIT ? \'taskBook.noTasksAdded\' : \'taskBook.noResults\' | translate}}</em></h6></div><task-book-select ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_EDIT && taskBook.taskBook.tasks.length > 0\" task-book=taskBook.taskBook link-id=null tasks-to-delete=taskBook.tasksToDelete show-link=false></task-book-select><div class=task-row ng-repeat=\"task in taskBook.taskBook.tasks\"><div class=row><div class=\"col-xs-1 text-right\"><strong class=tasks-text-align>{{$index + 1}}.</strong></div><div class=\"col-xs-1 pull-right\" ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_EDIT || taskBook.mode === taskBook.MODES.EDIT\"><span class=\"tasks-text-align task-delete\" ng-click=taskBook.removeTask($index) aria-label=\"{{::\'taskBook.delete\' | translate}}\"><i class=\"fa fa-trash fa-lg\" aria-hidden=true></i></span></div><div ng-class=\"{\'col-sm-5\': taskBook.mode === taskBook.MODES.COMPLETED_READONLY || taskBook.mode === taskBook.MODES.COMPLETED_EDIT}\"><div ng-class=\"{\'col-xs-9 col-sm-10\': taskBook.mode === taskBook.MODES.EDIT || taskBook.mode === taskBook.MODES.READONLY}\"><div class=form-group><strong><text-area ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_EDIT || taskBook.mode === taskBook.MODES.EDIT\" textarea-name=\"{{\'task-title\' + $index}}\" ng-model=task.title is-required=\"!!((taskBook.taskBook.tasks[$index + 1].title || taskBook.taskBook.tasks[$index + 1].procedure) || taskBook.task.procedure)\" maxlength=250 is-disabled=taskBook.disableTitle($index) is-focused=\"taskBook.focusFirst && $first\"></text-area><strong ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_READONLY || taskBook.mode === taskBook.MODES.READONLY\" class=\"title-readonly task-title\"><span ng-if=\"!taskBook.mode === taskBook.MODES.COMPLETED_READONLY\">{{$index + 1}}. </span>{{task.title}}</strong></strong><p class=\"text-danger task-required\" ng-messages=\"tasksBookForm[\'task-title\' + $index].$error\" ng-if=\"tasksBookForm[\'task-title\' + $index].$touched\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=procedure-row ng-class=\"{\'col-xs-offset-1 col-xs-10\': taskBook.mode === taskBook.MODES.EDIT || taskBook.mode === taskBook.MODES.READONLY}\"><div class=form-group><label for=\"{{\'procedure\' + $index}}\">{{::\'taskBook.procedure\' | translate}}</label><br><div ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_EDIT || taskBook.mode === taskBook.MODES.EDIT\"><text-area ng-model=task.procedure maxlength=2000 id=\"{{\'procedure\' + $index}}\" is-disabled=taskBook.disableFields($index)></text-area></div><div ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_READONLY || taskBook.mode === taskBook.MODES.READONLY\"><span class=procedure-readonly><span ng-bind-html=\"::task.procedure | linebreaks\"></span></span></div></div></div></div><div class=\"col-sm-5 col-xs-12\" ng-if=\"taskBook.mode === taskBook.MODES.COMPLETED_EDIT || taskBook.mode === taskBook.MODES.COMPLETED_READONLY\"><div class=form-group><div><label class=radio-inline><input type=radio name=statusRadios-{{$index}} ng-model=task.status value={{taskBook.status.INCOMPLETE}}> {{::\'taskBook.status.incomplete\' | translate}}</label><label class=radio-inline><input type=radio name=statusRadios-{{$index}} ng-model=task.status value={{taskBook.status.NOT_APPLICABLE}}> {{::\'taskBook.status.notApplicable\' | translate}}</label><label class=radio-inline><input type=radio name=statusRadios-{{$index}} ng-model=task.status value={{taskBook.status.COMPLETE}}> {{::\'taskBook.status.complete\' | translate}}</label></div></div><div><div class=form-group><label for=\"{{\'notes\' + $index}}\">{{::\'taskBook.notes\' | translate}}</label><br><div><text-area ng-model=task.notes maxlength=500 id=\"{{\'notes\' + $index}}\" is-disabled=taskBook.disableFields($index)></text-area></div></div></div></div></div></div><div class=row ng-if=\"taskBook.mode === taskBook.MODES.EDIT\"><button type=button class=\"btn btn-default\" ng-click=taskBook.addTasks(5)>{{::\'taskBook.addTask\' | translate}}</button></div></div>");
$templateCache.put("app/components/tradeForm/tradeDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'tradeForm.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'tradeForm.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/tradeForm/tradeDeleteWarningModal.html","<div class=modal-header><h4><span class=title>{{::\'tradeForm.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><div ng-if=\"workOrderCount > 0 && workOrderTemplateCount === 0\"><p>{{::\'tradeForm.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{workOrderCount}}&nbsp{{::\'tradeForm.deleteModal.workOrders\' | translate}}</strong>.</p><p>{{::\'tradeForm.deleteModal.reassignMessageWorkOrders\' | translate}}.</p></div><div ng-if=\"workOrderTemplateCount > 0 && workOrderCount === 0\"><p>{{::\'tradeForm.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{workOrderTemplateCount}}&nbsp{{::\'tradeForm.deleteModal.pmSchedules\' | translate}}</strong>.</p><p>{{::\'tradeForm.deleteModal.reassignMessagePmSchedules\' | translate}}.</p></div><div ng-if=\"workOrderTemplateCount > 0 && workOrderCount > 0  \"><p>{{::\'tradeForm.deleteModal.cannotDeleteMessage\' | translate}} <strong>{{workOrderTemplateCount}}&nbsp{{::\'tradeForm.deleteModal.pmSchedules\' | translate}}</strong>&nbsp{{::\'tradeForm.deleteModal.and\' | translate}}<strong>&nbsp{{workOrderCount}}&nbsp{{::\'tradeForm.deleteModal.workOrders\' | translate}}</strong>.</p><p>{{::\'tradeForm.deleteModal.reassignMessage\' | translate}}.</p></div></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/tradeForm/tradeForm.html","<div class=\"row header-container\"><div class=col-xs-12><h4>{{::(tradeForm.trade.id ? \'tradeForm.editTitle\' : \'tradeForm.createTitle\') | translate}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.name.$invalid && (form.name.$touched || tradeForm.saveAttempt)}\"><label for=name>{{::\'tradeForm.tradeName\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=name required maxlength=50 class=form-control placeholder=\"\" ng-model=tradeForm.trade.name value={{trade.name}} focus-on=true><p class=text-danger ng-messages=form.name.$error ng-if=\"form.name.$touched || tradeForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div><div class=checkbox><label><input type=checkbox name=active id=active ng-model=tradeForm.trade.isActive pm-association-validator=tradeForm.associations> {{::\'general.active\' | translate}}</label></div><p class=text-danger ng-messages=form.active.$error><span ng-message=pmAssociation>{{tradeForm.associationsValidation}}</span></p></div></div></form></div><div class=\"row action-row\"><div class=col-xs-12><save-button form=form click-function=tradeForm.saveTrade() save-attempt=tradeForm.saveAttempt></save-button><button class=\"btn btn-link text-danger\" ng-click=tradeForm.deleteTrade() ng-show=tradeForm.trade.id>{{::\'general.actions.delete\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/tradeList/tradeList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'tradeList.title\' | translate}}<results-message total=tradeList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\': tradeList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <a ui-sref=secure.tradeCreate class=\"btn btn-primary\" aria-label=\"{{::\'tradeList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"tradeList.sort(\'Name\')\"><strong>{{::\'tradeList.name\' | translate}}<sort-icon property=tradeList.sortable.Name></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'tradeListFilterForm\'\" filters=tradeList.filters clear-filters=tradeList.clearFilters()><filter-search filter=tradeList.filters.q></filter-search><filter-status filter=tradeList.filters.isActive></filter-status></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-5><strong class=cursor-pointer ng-click=\"tradeList.sort(\'Name\')\">{{::\'tradeList.name\' | translate}}<sort-icon property=tradeList.sortable.Name></sort-icon></strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"tradeList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-click=tradeList.editTrade(trade.id) ng-repeat=\"trade in tradeList.listData track by trade.id\"><div class=col-xs-8>{{::trade.name}}</div><div class=col-xs-4><div class=\"label label-warning\" ng-if=::!trade.isActive>{{::\'tradeList.inactive\' | translate}}</div></div></div><div class=row><div class=col-sm-12 ng-hide=\"tradeList.totalCount <= tradeList.filters.pageSize\"><ul uib-pagination total-items=tradeList.totalCount ng-model=tradeList.filters.page ng-change=tradeList.pageChanged() items-per-page=tradeList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/userForm/userForm.html","<div class=\"row header-container\"><div class=col-xs-12><h4>{{::userForm.title()}}</h4></div></div><div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.firstName.$invalid && (form.firstName.$touched || userForm.saveAttempt)}\"><label for=firstName>{{::\'userForm.firstName\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span> <input type=text id=firstName name=firstName required class=form-control placeholder=\"\" ng-model=userForm.user.firstName maxlength=50 focus-on=true><p class=text-danger ng-messages=form.firstName.$error ng-if=\"form.firstName.$touched || userForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.lastName.$invalid && (form.lastName.$touched || userForm.saveAttempt)}\"><label for=lastName>{{::\'userForm.lastName\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span> <input type=text id=lastName name=lastName required class=form-control placeholder=\"\" ng-model=userForm.user.lastName value={{user.lastName}} maxlength=50><p class=text-danger ng-messages=form.lastName.$error ng-if=\"form.lastName.$touched || userForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.email.$invalid && (form.email.$touched || userForm.saveAttempt)}\"><label for=email>{{::\'userForm.email\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><!--TODO Email Validation--> <input type=email id=email name=email required class=form-control placeholder=\"\" ng-model=userForm.user.email ng-pattern=userForm.emailRegex maxlength=100><p class=text-danger ng-messages=form.email.$error ng-if=\"form.email.$touched || userForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=email>{{::\'general.validation.email\' | translate }}</span> <span ng-message=pattern>{{::\'general.validation.email\' | translate}}</span> <span ng-message=uniqueEmail>{{::\'general.validation.emailAlreadyExists\' | translate}}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-if=!userForm.isCsc><label for=role>{{::\'userForm.role\' | translate}}</label><select id=role name=role class=form-control ng-disabled=!userForm.editUserRole ng-options=\"item as item.roleName for item in userForm.roleTypes track by item.id\" ng-model=userForm.user.roles[0] ng-if=!userForm.myProfile></select><span class=field-label ng-if=userForm.myProfile>{{::userForm.user.roles[0].roleName}}</span></div><div class=form-group ng-if=userForm.isCsc><label for=role>{{::\'userForm.role\' | translate}}</label><p class=read-only><span>{{::userForm.user.roles[0].roleName}}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\" ng-if=\"!userForm.myProfile && !userForm.requester\"><div class=form-group ng-class=\"{\'has-error\': form.hourlyRate.$invalid}\"><label for=hourlyRate>{{::\'userForm.hourlyRate\' | translate}}</label><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i> <input id=hourlyRate name=hourlyRate class=form-control min=0 max=100000000 ng-model=userForm.user.hourlyRate type=text force-decimal-precision currency=true max-validator min-validator number-validator></div><p class=text-danger ng-messages=\"form.hourlyRate.$error || userForm.saveAttempt\"><span ng-message=validNumber>{{::\'userForm.validation.hourlyRate.number\' | translate }} </span><span ng-message=maxNumber>{{::\'userForm.validation.hourlyRate.max\' | translate }} </span><span ng-message=minNumber>{{::\'userForm.validation.hourlyRate.min\' | translate }}</span></p></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\" ng-if=\"!userForm.myId && userForm.user.id\"><div class=checkbox><label><input type=checkbox name=active id=active ng-model=userForm.disableLogin pm-association-validator=userForm.associations invert-check=true> {{::\'userForm.disableLogin\' | translate}}</label></div><p class=text-danger ng-messages=form.active.$error><span ng-message=pmAssociation>{{userForm.associationsValidation}}</span></p></div></div><hr><div class=row><div class=\"col-xs-12 col-sm-8\"><h5>{{::\'userForm.phone\' | translate}}</h5><div class=row ng-repeat=\"phone in userForm.user.phones track by $index\"><div class=col-xs-11><phone-number index=$index form=form save-attempt=userForm.saveAttempt phone=phone></phone-number></div><div class=col-xs-1><span ng-show=\"userForm.phoneHasValue(phone) || userForm.user.phones.length > 1\" ng-click=userForm.removePhone($index) aria-label=\"{{::\'userForm.delete\' | translate}}\"><i class=\"fa fa-lg fa-trash cursor-pointer user-phone-delete\" aria-hidden=true></i></span></div></div><div class=row><div class=col-xs-12><button class=\"btn btn-default\" type=button ng-show=\"userForm.user.phones.length < 4\" ng-click=userForm.addPhone() aria-label=\"{{::\'userForm.addPhone\' | translate}}\"><i class=\"fa fa-plus\" aria-hidden=true></i></button></div></div></div></div></form></div><div class=\"row action-row\"><div class=col-xs-12><save-button form=form click-function=userForm.saveUser() save-attempt=userForm.saveAttempt></save-button><button class=\"btn btn-link\" ng-click=userForm.resendActivation() ng-if=\"!userForm.user.isActivated  && userForm.user.id\" ng-disabled=\"userForm.activationSent || form.$invalid\"><span ng-if=!userForm.activationSent>{{::\'userForm.resendActivation\' | translate}}</span> <span ng-if=userForm.activationSent>{{::\'userForm.activationSent\' | translate}}</span></button> <a ui-sref=secure.changePassword class=\"btn btn-link\" ng-if=userForm.myProfile>Change Password</a></div></div></div>");
$templateCache.put("app/components/userList/importUserModal.html","<div class=modal-header><h5>{{::\'userList.selectImport\' | translate}}</h5></div><div class=modal-body><div class=row><div class=\"col-xs-12 content-body\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-6><strong class=cursor-pointer>{{::\'userList.name\' | translate}}</strong></div><div class=col-sm-6><strong>{{::\'userList.email\' | translate}}</strong></div></div><div class=\"row grid-row cursor-pointer\" ng-click=importUser(user) ng-repeat=\"user in users.data track by user.id\"><div class=\"col-sm-6 col-xs-12 truncate\">{{::user.firstName}} {{::user.lastName}}</div><div class=\"col-sm-6 col-xs-12 truncate\"><a href=mailto:{{user.email}} ng-click=$event.stopPropagation()>{{::user.email}}</a></div></div></div><div class=row ng-hide=\"users.total <= filters.pageSize\"><div class=col-sm-12><ul uib-pagination total-items=users.total ng-model=filters.page ng-change=pageChanged() items-per-page=filters.pageSize max-size=5 class=\"pagination-sm pull-right\" boundary-links=false rotate=true scroll-to-top></ul></div></div></div></div><div class=modal-footer><button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.cancel\' | translate}}</button></div>");
$templateCache.put("app/components/userList/userList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile=true; hideSortMobile=true;\"><div class=col-sm-9><div class=pull-left><!--page Title --><h4>{{::\'userList.title\' | translate}}<results-message total=userList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\' : userList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button class=\"btn btn-link\" ng-if=userList.importList.total ng-click=userList.importUsers()>{{::\'userList.import\' | translate}}</button> <a ui-sref=secure.userCreate class=\"btn btn-primary\" aria-label=\"{{::\'userList.create\' | translate}}\"><i class=\"fa fa-plus visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=row><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"userList.sort([\'FirstName\', \'LastName\'])\"><strong>{{::\'userList.name\' | translate}}<sort-icon property=userList.sortable.FirstName></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'userListFiltersForm\'\" filters=userList.filters clear-filters=userList.clearFilters()><filter-search filter=userList.filters.q></filter-search><filter-role filter=userList.filters.roles roles=userList.roles></filter-role><filter-user-status filter=userList.filters.isEnabled></filter-user-status></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-4><strong class=cursor-pointer ng-click=\"userList.sort([\'FirstName\', \'LastName\'])\">{{::\'userList.name\' | translate}}<sort-icon property=userList.sortable.FirstName></sort-icon></strong></div><div class=col-sm-4><strong>{{::\'userList.email\' | translate}}</strong></div><div class=col-sm-2><strong>{{::\'userList.role\' | translate}}</strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"userList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-click=userList.editUser(user.id) ng-repeat=\"user in userList.listData track by user.id\"><div class=\"col-sm-4 col-xs-12 truncate\">{{::user.firstName}} {{::user.lastName}}</div><div class=\"col-sm-4 col-xs-12 truncate\"><a href=mailto:{{user.email}} ng-click=$event.stopPropagation()>{{::user.email}}</a></div><div class=\"col-sm-2 col-xs-12\">{{::user.roles[0].roleName}}</div><div class=\"col-sm-2 col-xs-12\"><div class=\"label label-default\" ng-if=::!user.isEnabled>{{::\'general.disabled\' | translate}}</div><div class=\"label label-warning\" ng-if=\"::!user.isActivated && user.isEnabled\">{{::\'general.notActivated\' | translate}}</div></div></div><div class=row ng-hide=\"userList.totalCount <= userList.filters.pageSize\"><div class=col-sm-12><ul uib-pagination total-items=userList.totalCount ng-model=userList.filters.page ng-change=userList.pageChanged() items-per-page=userList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" boundary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/webLinkCard/webLinkCard.html","<div class=web-link-card><div class=web-link-meta><a href={{::webLinkCard.link.url}} target=_blank><div class=\"web-link-thumbnail-wrapper hidden-xs\"><img ng-if=\"webLinkCard.link.title && webLinkCard.link.thumbnail\" class=web-link-thumbnail ng-src={{::webLinkCard.link.thumbnail}} alt={{::webLinkCard.link.title}}> <img ng-if=\"!webLinkCard.link.title && webLinkCard.link.thumbnail\" class=web-link-thumbnail ng-src={{::webLinkCard.link.thumbnail}} alt=\"{{::\'webLinkCard.altDefaultPrefix\' | translate}}{{::webLinkCard.link.thumbnail}}\"> <span ng-if=!webLinkCard.link.thumbnail class=\"web-link-thumbnail text-muted\">{{::\'webLinkCard.noImage\' | translate}}</span></div><div class=web-link-info><div class=row ng-if=webLinkCard.link.title><div class=col-xs-12><strong>{{::webLinkCard.link.title}}</strong></div></div><div class=row><div class=col-xs-12><div class=\"web-link-url truncate web-link-color\">{{::webLinkCard.link.url}}</div></div></div><div class=row ng-if=webLinkCard.listDescription><div class=col-xs-12>{{::webLinkCard.listDescription}}</div></div></div></a></div><div class=web-link-footer><div class=web-link-actions><small class=\"pull-left text-muted\" ng-if=entity>{{entity.size | bytes}}</small><div class=\"btn-actions pull-right hidden-print\"><button class=\"btn btn-sm btn-default\" type=button ng-click=\"$event.stopPropagation(); webLinkCard.openPanel()\" aria-label=\"{{::\'webLinkCard.openCard\' | translate}}\"><i class=\"fa fa-pencil\" aria-hidden=true></i></button> <button class=\"btn btn-sm btn-default\" type=button ng-click=\"$event.stopPropagation(); webLinkCard.deleteLink()\" aria-label=\"{{::\'webLinkCard.delete\' | translate}}\"><i class=\"fa fa-trash\" aria-hidden=true></i></button></div></div></div></div>");
$templateCache.put("app/components/webLinkSection/deleteConfirmModal.html","<div class=delete-web-link-modal><div class=modal-header><h4><span class=title>{{::\'webLinkSection.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'webLinkSection.deleteModal.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=deleteConfirmModalController.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=deleteConfirmModalController.close()>{{::\'general.actions.no\' | translate}}</button></div></div>");
$templateCache.put("app/components/webLinkSection/webLinkSection.html","<div class=web-link-section><div class=\"row sub-header-container\"><div class=col-xs-9><h5 id=webLinkSection scroll-spy-on spy-text=\"{{::\'webLinkSection.title\' | translate}}\" spies=webLinkSection.spies spy-position={{::webLinkSection.spyPosition}}>{{::\'webLinkSection.title\' | translate}}</h5></div><div class=col-xs-3><div class=\"pull-right sub-header-container-btn\"><button type=button class=\"btn btn-link\" ng-click=webLinkSection.openPanel(null)>{{::\'webLinkSection.addLink\' | translate}}</button></div></div></div><div class=content-section><div class=row ng-if=\"webLinkSection.links.length === 0\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'webLinkSection.noLinks\' | translate}}</em></h6></div></div><div class=row><div class=col-xs-12><web-link-card ng-repeat=\"link in webLinkSection.links\" link=link open-panel=webLinkSection.openPanel($index) delete-link=webLinkSection.deleteLink($index) work-order-id=webLinkSection.workOrderId></web-link-card></div></div></div></div><web-link-sliding-panel open-when=webLinkSection.openWhen object-id=webLinkSection.objectId links=webLinkSection.links entity={{webLinkSection.entity}} link-index=webLinkSection.linkIndex></web-link-sliding-panel>");
$templateCache.put("app/components/workOrderCalendar/calendarDayView.html","<div class=mobile-calendar><div class=text-center><span class=mobile-calendar-no-work ng-if=!calendarDayView.events.length><div><i class=\"fa fa-calendar-o\" aria-hidden=true></i></div><div>{{::\'workOrderCalendar.noScheduledWork\' | translate}}&nbsp;&nbsp;</div></span></div><div class=daily-work-orders ng-if=calendarDayView.workOrders.length><div ng-repeat=\"event in calendarDayView.workOrders\"><div class=\"cursor-pointer calendar-chip\" ng-class=\"{\n                \'planned\': event.pmScheduleId,\n                \'selected-day\': calendarDayView.compareIds(event),\n                \'faded\': event.faded}\"><div class=calendar-chip-content ng-class=\"{\n                        \'priority-emergency\': event.priority === calendarDayView.priority.emergency,\n                        \'priority-high\': event.priority === calendarDayView.priority.high,\n                        \'priority-medium\': event.priority === calendarDayView.priority.medium,\n                        \'priority-low\': event.priority === calendarDayView.priority.low\n                        }\"><div ng-click=calendarDayView.edit(event)><div class=calendar-chip-top><div class=calendar-chip-main-content><span class=\"hidden-xs font-size-sm\">ID: {{event.displayId}}</span><div ng-if=event.businessAsset><strong>{{::event.businessAsset.name}}</strong> <em class=\"text-muted hidden-xs font-size-base\" ng-if=event.businessAsset.ancestorIdPath><bread-crumbs path=\"\" root=\"\" asset=event.businessAsset no-links=true inline=true prepend-char=( append-char=)></bread-crumbs></em></div><div class=\"calendar-chip-text font-size-base\">{{::event.eventDescription}}</div><div class=\"calendar-chip-sub-information text-muted font-size-base\">{{::event.workType.name}}</div></div><div class=calendar-chip-pill-content><div class=\"pull-right margin-right-xs\" ng-if=event.pmScheduleId><div class=\"calendar-chip-icon visible-xs\"><i class=\"fa fa-refresh\" aria-hidden=true></i></div><div class=\"pill-tag pill-recurring hidden-xs\"><i class=\"fa fa-refresh\" aria-hidden=true></i> {{::\'workOrderList.recurring\' | translate}}</div></div><div class=\"pull-right margin-right-xs hidden-xs\"><days-to ng-if=\"event.dueDate && event.status !== calendarDayView.status.complete\" target-date=event.dueDate show-as-pill=true></days-to></div></div></div><div class=hidden-xs><div class=day-view-assignees><span class=\"text-muted font-size-sm\">{{::\'workOrderCalendar.assignment\' | translate}}:</span><div class=font-size-base><multiple-assignees assignees=event.assignees></multiple-assignees></div></div><div class=\"pull-right margin-top-xs day-view-quick-actions\"><button class=\"btn btn-default btn-sm hidden-xs quick-action-button pull-right\" ng-click=\"$event.stopPropagation(); calendarDayView.printWorkOrder(event.workOrderId);\" arial-label=\"{{::\'workOrderCalendar.print\' | translate}}\"><i class=\"fa fa-print\" aria-hidden=true></i>&nbsp;&nbsp;{{::\'general.print\' | translate}}</button> <button class=\"btn btn-default btn-sm hidden-xs quick-action-button pull-right\" ng-click=\"$event.stopPropagation(); calendarDayView.updateAssignees($index);\" ng-class=\"{\'active\': calendarDayView.quickActionsUpdateAssignee}\"><i class=\"fa fa-user\" aria-hidden=true></i>&nbsp;&nbsp;{{::\'workOrderList.updateAssignee\' | translate}}</button> <button class=\"btn btn-default btn-sm hidden-xs quick-action-button pull-right\" ng-click=\"$event.stopPropagation(); calendarDayView.updateSchedule($index);\" ng-class=\"{\'active\': calendarDayView.quickActionsUpdateSchedule}\"><i class=\"fa fa-calendar-o\" aria-hidden=true></i>&nbsp;&nbsp;{{::\'workOrderList.updateScheduling\' | translate}}</button></div></div></div><!-- custom padding prevent need for a nested col --><div class=\"row work-order-quick-actions hidden-xs\" ng-if=\"event.quickActionsUpdateAssignee || event.quickActionsUpdateSchedule\" hide-quick-actions close-function=calendarDayView.closeLastQuickAction()><form><schedule-quick-action due-date=event.dueDate request-date=event.requestDate start-date=event.scheduledStartDate ng-if=event.quickActionsUpdateSchedule></schedule-quick-action><assignee-quick-action assignees=event.assignees ng-if=event.quickActionsUpdateAssignee></assignee-quick-action><div><button class=\"btn btn-link\" ng-click=calendarDayView.closeLastQuickAction()>{{::\'general.actions.close\' | translate}}</button></div></form></div></div></div></div></div><span class=\"projections-title font-size-md\" ng-if=calendarDayView.projections.length>{{::\'workOrderCalendar.dayPmProjections\' | translate}}</span><div ng-repeat=\"event in calendarDayView.projections\"><div class=\"cursor-pointer calendar-chip planned projected\" ng-click=calendarDayView.edit(event) ng-class=\"{\n                \'selected-day\': calendarDayView.compareIds(event)}\"><div class=calendar-chip-content ng-class=\"{\n                        \'priority-emergency\': event.priority === calendarDayView.priority.emergency,\n                        \'priority-high\': event.priority === calendarDayView.priority.high,\n                        \'priority-medium\': event.priority === calendarDayView.priority.medium,\n                        \'priority-low\': event.priority === calendarDayView.priority.low\n                        }\"><div class=calendar-chip-top><div class=calendar-chip-main-content><div ng-if=event.businessAsset><strong>{{::event.businessAsset.name}}</strong> <em class=\"text-muted hidden-xs font-size-base\" ng-if=event.businessAsset.ancestorIdPath><bread-crumbs path=\"\" root=\"\" asset=event.businessAsset no-links=true inline=true prepend-char=( append-char=)></bread-crumbs></em></div><div class=\"calendar-chip-text font-size-base\">{{::event.eventDescription}}</div><div class=\"calendar-chip-sub-information text-muted font-size-base\">{{::event.workType.name}}</div></div><div class=calendar-chip-pill-content><div class=\"pull-right margin-right-xs\"><div class=\"calendar-chip-icon visible-xs\"><i class=\"fa fa-refresh\" aria-hidden=true></i></div><div class=\"pill-tag pill-recurring hidden-xs\"><i class=\"fa fa-refresh\" aria-hidden=true></i> {{::\'workOrderList.recurring\' | translate}}</div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/workOrderCalendar/calendarNavigation.html","<div class=row><div class=col-xs-12><ul class=\"nav nav-tabs tab-navigation calendar-nav\"><li role=presentation ng-class=\"{\'active\': calendarNavigation.isActiveRoute(\'month\')}\"><a ui-sref=secure.workOrderCalendar.month(calendarNavigation.filters) class=text-medium-weight>{{::\'workOrderCalendar.month\' | translate}}</a></li><li role=presentation ng-class=\"{\'active\': calendarNavigation.isActiveRoute(\'day\')}\"><a ui-sref=secure.workOrderCalendar.day(calendarNavigation.filters) class=text-medium-weight>{{::\'workOrderCalendar.day\' | translate}}</a></li></ul></div></div>");
$templateCache.put("app/components/workOrderCalendarDay/workOrderCalendarDay.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true\"><div class=col-xs-12><div class=\"visible-xs-inline mobile-calendar-date pull-left\"><!-- Small desktop screen only --><div ng-if=!workOrderCalendar.isMobilePhone><form class=desktop-date-picker><calendar id=datePickerDesktop allow-update=true max-date=workOrderCalendar.maxDay name=datePickerDesktop ng-model=workOrderCalendar.targetDateCopy></calendar></form></div><!-- Mobile device only --><div ng-if=workOrderCalendar.isMobilePhone><label class=mobile-calendar-picker-trigger for=datePickerDevice>{{workOrderCalendar.targetDate | date:\'MMMM d\'}} <span class=font-secondary ng-if=workOrderCalendar.isToday>({{::\'workOrderCalendar.today\' | translate}})</span> <i class=\"fa fa-chevron-down\" aria-hidden=true></i></label><input id=datePickerDevice type=date class=mobile-calendar-picker max=workOrderCalendar.maxDay ng-model=workOrderCalendar.targetDateCopy></div></div><div class=\"pull-right mobile-calendar-actions\"><button class=\"btn btn-default visible-xs calendar-filter-button pull-right\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\' : workOrderCalendar.isFilterApplied()}\" aria-hidden=true></i></button><div class=\"visible-xs-inline mobile-event-count-wrapper pull-right\"><div class=mobile-event-counts>{{workOrderCalendar.counts.reactive}}</div><div class=\"mobile-event-counts planned-events\">{{workOrderCalendar.counts.planned}}</div></div></div></div></div><div class=\"main-container calendar-day-view\"><div class=row><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'calendarFiltersForm\'\" clear-filters=workOrderCalendar.clearFilters()><filter-workorder-status filter=workOrderCalendar.filters.status></filter-workorder-status><filter-user filter=workOrderCalendar.filters.assignees unassigned=workOrderCalendar.filters.unassigned title=workOrderCalendar.assigneeTitle roles=workOrderCalendar.assigneeRoles></filter-user><filter-purpose filter=workOrderCalendar.filters.purpose></filter-purpose><filter-assets filter=workOrderCalendar.filters.businessAsset include-descendants=workOrderCalendar.filters.includeDescendants hide-check-box=workOrderCalendar.assetHideCheckBox browse-options=workOrderCalendar.assetBrowseOptions></filter-assets><filter-work-type filter=workOrderCalendar.filters.workType has-markets=\"workOrderCalendar.market.k12, workOrderCalendar.market.he, workOrderCalendar.market.ips\"></filter-work-type></filter-panel></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs\"><div class=col-sm-3><work-order-calendar-navigation filters=workOrderCalendar.filters></work-order-calendar-navigation></div><div class=event-calendar-header><div class=\"col-sm-6 day-header\"><h5 class=text-center><button class=\"btn btn-link calendar-navigation\" aria-label=\"{{::\'workOrderCalendar.updateDayLeft\' | translate}}\" ng-click=workOrderCalendar.updateDate(-1)><i class=\"fa fa-chevron-left\" aria-hidden=true></i></button> <span><span class=hidden-sm>{{workOrderCalendar.targetDate | date:\'MMMM d, yyyy\'}}</span> <span class=visible-sm-inline>{{workOrderCalendar.targetDate | date:\'MMMM d\'}}</span> <span class=text-muted ng-if=workOrderCalendar.isToday>({{::\"workOrderCalendar.today\" | translate}})</span> </span><button class=\"btn btn-link calendar-navigation\" aria-label=\"{{::\'workOrderCalendar.updateDayRight\' | translate}}\" ng-click=workOrderCalendar.updateDate(1) ng-disabled=workOrderCalendar.maxDayLimit><i class=\"fa fa-chevron-right\" aria-hidden=true></i></button></h5></div></div><div class=\"hidden-xs col-sm-3\"></div></div><calendar-day-view events=workOrderCalendar.mobileEvents target-id=workOrderCalendar.targetId target-date=workOrderCalendar.targetDate></calendar-day-view></div></div></div></div>");
$templateCache.put("app/components/workOrderCalendarMonth/workOrderCalendarMonth.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true\"><div class=col-xs-12><div class=\"visible-xs-inline mobile-calendar-date pull-left\"><!-- Small desktop screen only --><div ng-if=!workOrderCalendar.isMobilePhone><form class=desktop-date-picker><calendar id=datePickerDesktop allow-update=true name=datePickerDesktop ng-model=workOrderCalendar.targetDateCopy></calendar></form></div><!-- Mobile device only --><div ng-if=workOrderCalendar.isMobilePhone><label class=mobile-calendar-picker-trigger for=datePickerDevice>{{workOrderCalendar.targetDate | date:\'MMMM d\'}} <span class=font-secondary ng-if=workOrderCalendar.isToday>({{::\'workOrderCalendar.today\' | translate}})</span> <i class=\"fa fa-chevron-down\" aria-hidden=true></i></label><input id=datePickerDevice type=date class=mobile-calendar-picker ng-model=workOrderCalendar.targetDateCopy></div></div><div class=\"pull-right mobile-calendar-actions\"><button class=\"btn btn-default visible-xs calendar-filter-button pull-right\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\' : workOrderCalendar.isFilterApplied()}\" aria-hidden=true></i></button><div class=\"visible-xs-inline mobile-event-count-wrapper pull-right\"><div class=mobile-event-counts>{{workOrderCalendar.counts.reactive}}</div><div class=\"mobile-event-counts planned-events\">{{workOrderCalendar.counts.planned}}</div></div></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'calendarFiltersForm\'\" clear-filters=workOrderCalendar.clearFilters()><filter-workorder-status filter=workOrderCalendar.filters.status></filter-workorder-status><filter-user filter=workOrderCalendar.filters.assignees unassigned=workOrderCalendar.filters.unassigned title=workOrderCalendar.assigneeTitle roles=workOrderCalendar.assigneeRoles></filter-user><filter-purpose filter=workOrderCalendar.filters.purpose></filter-purpose><filter-assets filter=workOrderCalendar.filters.businessAsset include-descendants=workOrderCalendar.filters.includeDescendants hide-check-box=workOrderCalendar.assetHideCheckBox browse-options=workOrderCalendar.assetBrowseOptions></filter-assets><filter-work-type filter=workOrderCalendar.filters.workType has-markets=\"workOrderCalendar.market.k12, workOrderCalendar.market.he, workOrderCalendar.market.ips\"></filter-work-type></filter-panel></div><div class=\"col-sm-pull-3 col-sm-9 calendar-day-view\" ng-if=workOrderCalendar.isMobile><calendar-day-view events=workOrderCalendar.mobileEvents></calendar-day-view></div><div class=list-body ng-if=!workOrderCalendar.isMobile><div class=\"col-sm-pull-3 col-sm-9 content-section calendar-page\"><div class=row><div class=event-calendar-header><div class=col-sm-3><work-order-calendar-navigation filters=workOrderCalendar.filters></work-order-calendar-navigation></div><div class=col-sm-6><h5 class=text-center><button class=\"btn btn-link calendar-navigation\" aria-label=\"{{::\'workOrderCalendar.updateMonthLeft\' | translate}}\" ng-click=workOrderCalendar.setMonth(-1)><i class=\"fa fa-chevron-left\" aria-hidden=true></i></button> <span>{{workOrderCalendar.targetDate | date:\'MMMM yyyy\'}}</span> <button class=\"btn btn-link calendar-navigation\" aria-label=\"{{::\'workOrderCalendar.updateMonthRight\' | translate}}\" ng-click=workOrderCalendar.setMonth(1) ng-disabled=workOrderCalendar.monthLimit><i class=\"fa fa-chevron-right\" aria-hidden=true></i></button></h5></div></div></div><div class=row><div class=\"col-xs-12 event-calendar-body\"><event-calendar events=workOrderCalendar.events target-date=workOrderCalendar.targetDate drop-function=workOrderCalendar.dropFunction(event) day-function=\"workOrderCalendar.dayFunction(date, id)\"></event-calendar></div></div></div></div></div></div>");
$templateCache.put("app/components/workOrderComments/workOrderComments.html","<div class=comments-section><div class=sub-header-container><div><h5>{{::\'workOrderComments.comments\' | translate}}</h5></div></div><div class=content-section><div ng-repeat=\"comment in workOrderComments.comments track by comment.id\" class=\"row grid-row grid-row-unclickable grid-row-last-no-border comment-body\"><div class=col-xs-12><div class=\"row comment-header\"><div class=col-xs-6><strong>{{::comment.postedBy.firstName}} {{::comment.postedBy.lastName}}</strong></div><div class=col-xs-6><span ng-if=!comment.edited class=\"font-secondary pull-right\">{{::\'workOrderComments.submitted\' | translate}}: {{::(comment.audit.createdDateTime | date:\'MM/dd/yyyy h:mm a\')}} </span><span ng-if=comment.edited class=\"font-secondary pull-right\">{{::\'workOrderComments.edited\' | translate}}: {{(comment.audit.updatedDateTime | date:\'MM/dd/yyyy h:mm a\')}}</span></div></div><div ng-if=\"workOrderComments.editingComment.id !== comment.id\" class=row><div class=col-xs-12><span class=comment-text>{{comment.text}}</span></div></div><div ng-if=\"workOrderComments.editingComment.id === comment.id\" class=row><div class=col-xs-12><div class=new-comment-text><text-area id=comment textarea-name=comment ng-model=workOrderComments.editingComment.text maxlength=2000 maxlines=10 is-focused=true></text-area><div class=checkbox ng-if=!workOrderComments.isRequester><label><input type=checkbox ng-model=workOrderComments.editingComment.isInternalCheckbox> {{::\'workOrderComments.requesterVisible\' | translate}}</label></div></div></div></div><div class=\"row comment-footer-row\" ng-if=comment.isEditable><div class=col-xs-6><div class=private-comment-notice ng-if=\"comment.isInternal && !(workOrderComments.editingComment.id === comment.id)\"><em><i class=\"fa fa-eye-slash\" aria-hidden=true></i> {{::\'workOrderComments.privateComment\' | translate}}</em></div><div class=pull-left ng-if=\"workOrderComments.editingComment.id === comment.id\"><button class=\"btn btn-default ng-binding\" ng-click=workOrderComments.updateComment(workOrderComments.editingComment)>{{::\'workOrderComments.postComment\' | translate}}</button> <button class=\"btn btn-link ng-binding\" ng-click=workOrderComments.setEditComment(comment)>{{::\'workOrderComments.cancel\' | translate}}</button></div></div><div class=\"col-xs-6 comment-edit-buttons\"><button ng-click=workOrderComments.deleteComment(comment) aria-label=\"{{::\'workOrderComments.delete\' | translate}}\" class=\"btn btn-default btn-sm pull-right comment-delete-button\"><i class=\"fa fa-trash-o\" aria-hidden=true></i></button><div ng-if=\"workOrderComments.editingComment.id !== comment.id\"><button ng-click=workOrderComments.setEditComment(comment) aria-label=\"{{::\'workOrderComments.editComment\' | translate}}\" class=\"btn btn-default btn-sm pull-right\"><i class=\"fa fa-pencil\" aria-hidden=true></i></button></div></div></div></div></div><div class=new-comment-header id=commentsSection scroll-spy-on spies=workOrderComments.spies spy-text=\"{{::\'workOrderComments.comments\' | translate}}\" spy-position=8><em class=text-info>{{::\'workOrderComments.commentBelow\' | translate}}</em></div><div class=new-comment-text><text-area id=comment textarea-name=comment ng-model=workOrderComments.comment.text maxlength=2000 maxlines=10></text-area><div class=checkbox ng-if=!workOrderComments.isRequester><label><input type=checkbox ng-model=workOrderComments.comment.isInternalCheckbox> {{::\'workOrderComments.requesterVisible\' | translate}}</label></div></div><div class=comment-button-container><button class=\"btn btn-default ng-binding\" ng-click=workOrderComments.saveComment()>{{::\'workOrderComments.postComment\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/workOrderComments/workOrderCommentsDeleteConfirmModal.html","<div class=modal-header><h4 class=title>{{::\'workOrderComments.notify.deleteConfirm.title\' | translate}}</h4></div><div class=modal-body><div class=error-container><p>{{::\'workOrderComments.notify.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/workOrderFilters/workOrderFilters.html","<div ng-class=\"{\'disabled-filters\': workOrderFilters.isDisabled}\"><div has-markets=\"workOrderFilters.market.k12, workOrderFilters.market.he, workOrderFilters.market.ips\"><filter-panel name=\"\'workOrderFiltersForm\'\" clear-filters=workOrderFilters.clearFilters()><filter-search filter=workOrderFilters.filters.q></filter-search><filter-quick-filter ng-if=!workOrderFilters.isRequester filters=workOrderFilters.filters quick-filters=workOrderFilters.quickFilters open-function=workOrderFilters.openQuickFilters(openList)></filter-quick-filter><filter-workorder-priority ng-if=::!workOrderFilters.isRequester filter=workOrderFilters.filters.priority></filter-workorder-priority><filter-workorder-status filter=workOrderFilters.filters.status is-open=workOrderFilters.status.open>></filter-workorder-status><filter-date-range data-qa=requested ng-if=!workOrderFilters.isRequester date-ranges=workOrderFilters.requestDateIncrements current-range=workOrderFilters.currentIncrement to=workOrderFilters.filters.requestDateTo from=workOrderFilters.filters.requestDateFrom title=\"\'workOrderFilters.requestDate\' | translate\"></filter-date-range><filter-user ng-if=workOrderFilters.assignedToVisible() filter=workOrderFilters.filters.assignees unassigned=workOrderFilters.filters.unassigned title=workOrderFilters.assigneeTitle roles=workOrderFilters.assigneeRoles></filter-user><filter-assets ng-if=workOrderFilters.isRequester data-qa=assets filter=workOrderFilters.filters.businessAsset include-descendants=workOrderFilters.filters.includeDescendants browse-options=workOrderFilters.assetBrowseOptions hide-check-box=workOrderFilters.assetHideCheckBox additional-filters=\"{isWorkOrderAsset: true, isLocation: true}\"></filter-assets><filter-assets ng-if=!workOrderFilters.isRequester data-qa=assets filter=workOrderFilters.filters.businessAsset include-descendants=workOrderFilters.filters.includeDescendants browse-options=workOrderFilters.assetBrowseOptions hide-check-box=workOrderFilters.assetHideCheckBox></filter-assets><filter-work-type filter=workOrderFilters.filters.workType></filter-work-type><filter-purpose ng-if=::!workOrderFilters.isRequester filter=workOrderFilters.filters.purpose></filter-purpose><filter-date-range data-qa=completed ng-if=!workOrderFilters.isRequester date-ranges=workOrderFilters.completedDateIncrements current-range=workOrderFilters.currentIncrement to=workOrderFilters.filters.completionDateTo from=workOrderFilters.filters.completionDateFrom title=\"\'workOrderFilters.completionDate\' | translate\"></filter-date-range><filter-date-range data-qa=due ng-if=!workOrderFilters.isRequester is-open=workOrderFilters.dueDate.open date-ranges=workOrderFilters.dueDateIncrements current-range=workOrderFilters.currentIncrement to=workOrderFilters.filters.dueDateTo from=workOrderFilters.filters.dueDateFrom title=\"\'workOrderFilters.dueDate\' | translate\"></filter-date-range><filter-date-range data-qa=scheduled ng-if=!workOrderFilters.isRequester is-open=workOrderFilters.scheduledStartDate.open date-ranges=workOrderFilters.scheduledStartRanges current-range=workOrderFilters.currentScheduledIncrement disable-increment=\"workOrderFilters.scheduledDatesDisabled || workOrderFilters.isDisabled\" to=workOrderFilters.filters.scheduledStartDateTo from=workOrderFilters.filters.scheduledStartDateFrom title=\"\'workOrderFilters.scheduledStartDate\' | translate\" clear-function=workOrderFilters.setScheduled()></filter-date-range></filter-panel></div><div has-markets=\"workOrderFilters.market.gov, workOrderFilters.market.mfg, workOrderFilters.market.club, workOrderFilters.market.other\"><filter-panel name=\"\'workOrderFiltersForm\'\" clear-filters=workOrderFilters.clearFilters()><filter-search filter=workOrderFilters.filters.q></filter-search><filter-quick-filter ng-if=!workOrderFilters.isRequester filters=workOrderFilters.filters quick-filters=workOrderFilters.quickFilters open-function=workOrderFilters.openQuickFilters(openList)></filter-quick-filter><filter-workorder-priority ng-if=::!workOrderFilters.isRequester filter=workOrderFilters.filters.priority></filter-workorder-priority><filter-workorder-status filter=workOrderFilters.filters.status is-open=workOrderFilters.status.open></filter-workorder-status><filter-date-range data-qa=requested ng-if=!workOrderFilters.isRequester current-range=workOrderFilters.currentIncrement to=workOrderFilters.filters.requestDateTo from=workOrderFilters.filters.requestDateFrom title=\"\'workOrderFilters.requestDate\' | translate\"></filter-date-range><filter-user ng-if=workOrderFilters.assignedToVisible() filter=workOrderFilters.filters.assignees unassigned=workOrderFilters.filters.unassigned title=workOrderFilters.assigneeTitle roles=workOrderFilters.assigneeRoles></filter-user><filter-assets data-qa=assets filter=workOrderFilters.filters.businessAsset include-descendants=workOrderFilters.filters.includeDescendants browse-options=workOrderFilters.assetBrowseOptions hide-check-box=workOrderFilters.assetHideCheckBox></filter-assets><filter-failure-reason ng-if=\"!workOrderFilters.isRequester && !workOrderFilters.isTechnician\" filter=workOrderFilters.filters.failureReason></filter-failure-reason><filter-purpose ng-if=::!workOrderFilters.isRequester filter=workOrderFilters.filters.purpose></filter-purpose><filter-project filter=workOrderFilters.filters.project></filter-project><filter-trade ng-if=::!workOrderFilters.isRequester filter=workOrderFilters.filters.trade></filter-trade><filter-date-range data-qa=completed ng-if=!workOrderFilters.isRequester date-ranges=workOrderFilters.completedDateIncrements current-range=workOrderFilters.currentIncrement to=workOrderFilters.filters.completionDateTo from=workOrderFilters.filters.completionDateFrom title=\"\'workOrderFilters.completionDate\' | translate\"></filter-date-range><filter-date-range data-qa=due ng-if=!workOrderFilters.isRequester is-open=workOrderFilters.dueDate.open date-ranges=workOrderFilters.dueDateIncrements current-range=workOrderFilters.currentIncrement to=workOrderFilters.filters.dueDateTo from=workOrderFilters.filters.dueDateFrom title=\"\'workOrderFilters.dueDate\' | translate\"></filter-date-range><filter-date-range data-qa=scheduled ng-if=!workOrderFilters.isRequester is-open=workOrderFilters.scheduledStartDate.open date-ranges=workOrderFilters.scheduledStartRanges current-range=workOrderFilters.currentScheduledRange disable-range=\"workOrderFilters.scheduledDatesDisabled || workOrderFilters.isDisabled\" to=workOrderFilters.filters.scheduledStartDateTo from=workOrderFilters.filters.scheduledStartDateFrom title=\"\'workOrderFilters.scheduledStartDate\' | translate\" clear-function=workOrderFilters.setScheduled()></filter-date-range></filter-panel></div></div>");
$templateCache.put("app/components/workOrderForm/requesterForm.html","<div class=content-section><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.description.$invalid && (form.description.$touched || workOrderForm.saveAttempt)}\"><label for=description>{{::\'workOrderForm.description\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><text-area id=description textarea-name=description ng-model=workOrderForm.workOrder.description maxlength=2000 maxlines=10 is-required=true is-focused=true></text-area><p class=text-danger ng-messages=form.description.$error ng-if=\"form.description.$touched || workOrderForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': form.assets.$invalid && (form.assets.$touched || workOrderForm.saveAttempt)}\"><label has-markets=\"workOrderForm.market.mfg, workOrderForm.market.club, workOrderForm.market.other, workOrderForm.market.gov\">{{::\'workOrderForm.locationOrEquipment\' | translate}}</label><label has-markets=\"workOrderForm.market.k12, workOrderForm.market.he, workOrderForm.market.ips\">{{::\'workOrderForm.requesterAsset\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><assets-typeahead has-markets=\"workOrderForm.market.mfg, workOrderForm.market.club, workOrderForm.market.other, workOrderForm.market.gov\" ng-model=workOrderForm.workOrder.businessAsset multi-select=false ng-required=true browse-options=workOrderForm.assetBrowseOptions></assets-typeahead><assets-typeahead has-markets=\"workOrderForm.market.k12, workOrderForm.market.he, workOrderForm.market.ips\" ng-model=workOrderForm.workOrder.businessAsset multi-select=false ng-required=true additional-filters=\"{isWorkOrderAsset: true, isLocation: true}\" apply-additional-filters-to=workOrderForm.applyAdditionalFiltersTo.dropdown browse-options=workOrderForm.assetBrowseOptions></assets-typeahead><span ng-if=\"workOrderForm.workOrder.businessAsset && workOrderForm.warranty\"><i class=\"fa fa-exclamation-circle text-warning\" aria-hidden=true></i> <span>{{::\'workOrderForm.assetInWarranty\' | translate}}</span></span><p class=text-danger ng-messages=form.assets.$error ng-if=\"form.assets.$touched || workOrderForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=col-sm-6 has-markets=\"workOrderForm.market.mfg, workOrderForm.market.club, workOrderForm.market.other, workOrderForm.market.gov\"><div class=form-group><label>{{::\'workOrderForm.purpose\' | translate}}</label><purposes-dropdown ng-model=workOrderForm.workOrder.purpose></purposes-dropdown></div></div><div class=col-sm-6 has-markets=\"workOrderForm.market.k12, workOrderForm.market.he, workOrderForm.market.ips\"><div class=form-group ng-class=\"{\'has-error\': form.workTypes.$invalid && (form.workTypes.$touched || workOrderForm.saveAttempt)}\" accessibility><label for=workType>{{::\'workOrderForm.requesterWorkType\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><work-types-dropdown ng-model=workOrderForm.workOrder.workType filters=\"{hasParent: true, orderBy: \'Name asc\', isActive: \'true\'}\" ng-required=true></work-types-dropdown><p class=text-danger ng-messages=form.workTypes.$error ng-if=\"form.workTypes.$touched || workOrderForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row has-markets=\"workOrderForm.market.k12, workOrderForm.market.he, workOrderForm.market.ips\"><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': form.assets.$invalid && (workOrderForm.areaRoomNumberHelper.isRequired && (form.locationDescription.$touched || workOrderForm.saveAttempt))}\"><label for=locationDescription>{{::\'workOrderForm.areaRoomNumber\' | translate}}</label><span ng-if=\"workOrderForm.areaRoomNumberHelper.isRequired === true\" class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><div>{{workOrderForm.areaRoomNumberHelper.text}}</div><input id=locationDescription name=locationDescription class=form-control maxlength=50 ng-model=workOrderForm.workOrder.locationDescription ng-required=workOrderForm.areaRoomNumberHelper.isRequired><p class=text-danger ng-messages=form.locationDescription.$error ng-if=\"workOrderForm.areaRoomNumberHelper.isRequired && (form.locationDescription.$touched || workOrderForm.saveAttempt)\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><!-- this field exists so that we can invalidate the form while a file is uploading --> <input type=hidden name=uploadCheck ng-model=uploadCheck></div>");
$templateCache.put("app/components/workOrderForm/standardForm.html","<work-order-details work-order=workOrderForm.workOrder is-new=workOrderForm.isNew save-attempt=workOrderForm.saveAttempt></work-order-details><work-order-planning work-order=workOrderForm.workOrder spies=workOrderForm.spies is-new=workOrderForm.isNew is-technician=workOrderForm.isTechnician save-attempt=workOrderForm.saveAttempt></work-order-planning><work-order-tasks ng-if=\"workOrderForm.tasks.length > 0 || (workOrderForm.canAddTasks && !workOrderForm.workOrder.pmSchedule)\" spies=workOrderForm.spies tasks=workOrderForm.tasks tasks-to-delete=workOrderForm.tasksToDelete edit-mode=\"workOrderForm.canAddTasks && !workOrderForm.workOrder.pmSchedule\"></work-order-tasks><work-order-completion work-order=workOrderForm.workOrder spies=workOrderForm.spies save-attempt=workOrderForm.saveAttempt></work-order-completion>");
$templateCache.put("app/components/workOrderForm/workOrderForm.html","<div class=row><div ng-class=\"{\'col-sm-10\': !workOrderForm.isRequester, \'col-sm-12\': workOrderForm.isRequester}\"><div class=\"row header-container\"><div class=col-xs-12 id=formHeader scroll-spy-on spy-text=\"{{:: \'workOrderForm.details\' | translate}}\" spies=workOrderForm.spies spy-position=1><div class=row><div class=col-xs-9><h4 ng-show=\"workOrderForm.isNew && !workOrderForm.isRequester\">{{::\'workOrderForm.new\' | translate}}</h4><h4 ng-hide=workOrderForm.isNew><i class=\"fa fa-refresh\" ng-if=workOrderForm.workOrder.pmSchedule aria-hidden=true></i> {{\'workOrderForm.edit\' | translate}} <span>{{workOrderForm.workOrder.displayId}}</span> <span ng-if=false class=\"font-size-md wo-last-updated\">( {{::\'workOrderForm.lastUpdated\' | translate}} {{::workOrderForm.workOrder.updatedDateTime | date:\'MM/dd/yyyy h:mm a\'}} )</span></h4><h4 ng-hide=!workOrderForm.isRequester>{{::\'workOrderForm.newRequest\' | translate}}</h4></div><div class=col-xs-3 ng-if=\"!workOrderForm.isNew && !workOrderForm.isRequester\"><button ng-click=workOrderForm.showHistoryPanel() class=\"btn btn-default pull-right\">{{::\'workOrderForm.viewHistory\' | translate}}</button></div></div></div></div><div class=main-container><form name=form novalidate navigation-warning form=form skip-navigation-warning=workOrderForm.skipNavigationWarning><div ng-if=!workOrderForm.isRequester ng-cloak ng-include=\"\'app/components/workOrderForm/standardForm.html\'\"></div><div ng-if=workOrderForm.isRequester ng-cloak ng-include=\"\'app/components/workOrderForm/requesterForm.html\'\"></div><!-- this field exists so that we can invalidate the form while a file is uploading --> <input type=hidden name=uploadCheck ng-model=uploadCheck></form><work-order-transactions transactions=workOrderForm.transactions work-order-id=workOrderForm.workOrder.id ng-if=!workOrderForm.isNew spies=workOrderForm.spies></work-order-transactions><work-order-inventory ng-if=workOrderForm.canInventory() spies=workOrderForm.spies inventory-transactions=workOrderForm.inventory.inventoryTransactions open-when=workOrderForm.openIssueToWorkOrder work-order=workOrderForm.workOrder></work-order-inventory><attachments files=workOrderForm.files file=workOrderForm.file delete=workOrderForm.deleteAttachment spies=workOrderForm.spies></attachments><web-link-section links=workOrderForm.links spies=workOrderForm.spies object-id=workOrderForm.workOrder.id spy-position=7 entity=workOrder ng-if=!workOrderForm.isRequester></web-link-section><work-order-comments ng-if=!workOrderForm.isNew spies=workOrderForm.spies work-order-id=workOrderForm.workOrder.id save-attempt=workOrderForm.saveAttempt></work-order-comments><div class=\"row action-row-fixed hidden-print\"><div class=container><div class=\"col-xs-12 col-sm-6\"><save-button form=form click-function=workOrderForm.saveWorkOrder() save-attempt=workOrderForm.saveAttempt disable-save=workOrderForm.disableSave></save-button><button class=\"btn btn-default\" ng-click=workOrderForm.printWorkOrder() ng-if=!workOrderForm.isNew>{{::\'general.print\' | translate}}</button></div></div></div></div></div><div class=\"col-sm-2 hidden-xs\" ng-if=\"workOrderForm.spies.length >= 2  && !workOrderForm.isRequester\"><scroll-spy anchors=workOrderForm.spies header-offset=workOrderForm.headerOffset></scroll-spy></div></div><issue-to-work-order ng-if=!workOrderForm.isRequester open-when=workOrderForm.openIssueToWorkOrder storage-areas=workOrderForm.storageAreas inventory-item=workOrderForm.inventoryItem inventory-transactions=workOrderForm.inventory.inventoryTransactions open-storage-panel=workOrderForm.openStoragePanel work-order=workOrderForm.workOrder></issue-to-work-order><sliding-panel-select-storage-area ng-if=!workOrderForm.isRequester storage-areas=workOrderForm.storageAreas inventory-item=workOrderForm.inventoryItem open-when=workOrderForm.openStoragePanel></sliding-panel-select-storage-area><history-sliding-panel open-when=workOrderForm.openHistoryPanel display-id=workOrderForm.workOrder.displayId object=workOrderForm.historyEntity></history-sliding-panel>");
$templateCache.put("app/components/workOrderFormReadOnly/requesterFormReadOnly.html","<div class=work-order-form-read-only><div class=row><div class=col-sm-10><div class=\"row header-container\"><div class=col-sm-12 id=aboutSection scroll-spy-on spy-text=\"{{::\'workOrderFormReadOnly.about.title\' | translate}}\" spies=workOrderForm.spies spy-position=1><h5>{{::\'workOrderFormReadOnly.title\' | translate}} {{::(workOrderForm.workOrder.displayId)}}</h5></div></div><div class=content-section><div class=row><div class=col-sm-12><div class=form-group><label>{{::\'workOrderFormReadOnly.about.description\' | translate}}</label><div>{{::(workOrderForm.workOrder.description)}}</div></div></div></div><div class=row><div ng-class=\"{\'col-xs-12\': !workOrderForm.isEduMarket, \'col-xs-6\': workOrderForm.isEduMarket}\"><div class=form-group><label ng-if=workOrderForm.isEduMarket>{{::\'workOrderFormReadOnly.about.location\' | translate}}</label><label ng-if=!workOrderForm.isEduMarket>{{::\'workOrderFormReadOnly.about.locationOrEquipment\' | translate}}</label><div>{{::(workOrderForm.workOrder.businessAsset.name)}}</div><div class=asset-bread-crumbs-space><span class=text-muted ng-if=workOrderForm.workOrder.businessAsset.ancestorIdPath><bread-crumbs path=\"\" root=\"\" asset=workOrderForm.workOrder.businessAsset no-links=true inline=true></bread-crumbs></span></div></div></div><div class=col-xs-6 ng-if=workOrderForm.isEduMarket><div class=form-group><label>{{::\'workOrderFormReadOnly.about.typeOfWork\' | translate}}</label><div>{{::(workOrderForm.workOrder.workType.name)}}</div></div></div></div><div class=row ng-if=workOrderForm.isEduMarket><div class=col-xs-6><div class=form-group><label>{{::\'workOrderFormReadOnly.about.areaRoomNumber\' | translate}}</label><div>{{::workOrderForm.workOrder.locationDescription}}</div></div></div></div><div class=row ng-if=!workOrderForm.isEduMarket><div class=col-xs-6><div class=form-group><label>{{::\'workOrderFormReadOnly.about.trade\' | translate}}</label><div>{{::(workOrderForm.workOrder.trade.name)}}</div></div></div><div class=col-xs-6><div class=form-group><label>{{::\'workOrderFormReadOnly.about.purpose\' | translate}}</label><div>{{::(workOrderForm.workOrder.purpose.value)}}</div></div></div></div></div><div class=\"row sub-header-container\" id=detailsSection scroll-spy-on spy-text=\"{{::\'workOrderFormReadOnly.details.title\' | translate}}\" spies=workOrderForm.spies spy-position=2><div class=col-sm-12><h5>{{::\'workOrderFormReadOnly.details.title\' | translate}}</h5></div></div><div class=content-section><div class=row><div class=col-xs-6><div class=form-group><label>{{::\'workOrderFormReadOnly.details.status\' | translate}}</label><div ng-if=\"workOrderForm.workOrder.status !== workOrderForm.status.complete\">{{::(workOrderForm.workOrder.status | status)}}</div><div ng-if=\"workOrderForm.workOrder.status === workOrderForm.status.complete\">{{::\'workOrderList.completed\' | translate}}&nbsp;| <span class=date-color>{{::(workOrderForm.workOrder.completionDateTime | date: \'MM/dd/yyyy h:mma\')}}</span></div></div></div><div class=col-xs-6><div class=form-group><label>{{::\'workOrderFormReadOnly.details.assignedTo\' | translate}}</label><div><span class=assignees ng-repeat=\"assignee in workOrderForm.workOrder.assignees track by assignee.id\"><span class=truncate>{{assignee.firstName}}&nbsp;{{assignee.lastName}}{{$last ? \'\' : \',&nbsp;\'}}</span></span></div></div></div></div><div class=row><div ng-class=\"{\'col-xs-12\': workOrderForm.isEduMarket, \'col-xs-6\': !workOrderForm.isEduMarket}\"><div class=form-group><label>{{::\'workOrderFormReadOnly.details.requested\' | translate}}</label><div>{{::(workOrderForm.workOrder.requestedBy.firstName)}}&nbsp;{{::(workOrderForm.workOrder.requestedBy.lastName)}}&nbsp;| <span class=date-color>{{::(workOrderForm.workOrder.requestDateTime | date: \'MM/dd/yyyy h:mma\')}}</span></div></div></div><div class=col-xs-6 ng-if=!workOrderForm.isEduMarket><div class=form-group><label>{{::\'workOrderFormReadOnly.details.project\' | translate}}</label><div>{{::(workOrderForm.workOrder.project.name)}}</div></div></div></div><div class=row ng-if=\"workOrderForm.workOrder.status === workOrderForm.status.complete\"><div class=col-sm-12><div class=form-group><label>{{::\'workOrderFormReadOnly.details.completionNotes\' | translate}}</label><div>{{::(workOrderForm.workOrder.actionTaken)}}</div></div></div></div></div><attachments files=workOrderForm.files file=workOrderForm.file spies=workOrderForm.spies hide-delete=true></attachments><work-order-comments spies=workOrderForm.spies work-order-id=workOrderForm.workOrder.id save-attempt=workOrderForm.saveAttempt></work-order-comments></div><div class=\"col-sm-2 hidden-xs\" ng-if=\"workOrderForm.spies.length >= 2\"><scroll-spy anchors=workOrderForm.spies header-offset=workOrderForm.headerOffset></scroll-spy></div></div></div>");
$templateCache.put("app/components/workOrderHistoryFilters/workOrderHistoryFilters.html","<sliding-panel cancel-button=true button-functions=workOrderHistoryFilters.buttonFunctions open-when=workOrderHistoryFilters.openWhen titles=workOrderHistoryFilters.titles><panel-header><div class=row><div class=\"col-xs-8 col-sm-10\"><h2 class=\"sliding-panel-title sliding-panel-header-text truncate\">{{::\'workOrderHistoryFilters.title\' | translate}}</h2></div><div class=\"col-xs-4 col-sm-2\"><button type=button class=\"btn btn-sm btn-inverse pull-right\" ng-disabled=\"!(workOrderHistoryFilters.filters | badges)\" ng-click=workOrderHistoryFilters.clearFunction()>{{::\'workOrderHistoryFilters.clearFilters\' | translate}}</button></div></div></panel-header><panel-body><div class=panel-form-content><div class=row><div class=col-xs-12><div class=form-group><filter-panel name=\"\'workOrderHistoryFiltersForm\'\" filters=workOrderHistoryFilters.filters hide-header=true><filter-search filter=workOrderHistoryFilters.filters.q focus-on=workOrderHistoryFilters.openWhen placeholder=workOrderHistoryFilters.placeHolder></filter-search><!-- TODO set hide-check-box to workOrderHistoryFilters.isEduMarket after filter is added--><filter-assets filter=workOrderHistoryFilters.filters.businessAsset include-descendants=workOrderHistoryFilters.filters.includeDescendants hide-check-box=true browse-options=workOrderHistoryFilters.browseOptions single-select=false></filter-assets><filter-date-range date-ranges=workOrderHistoryFilters.dateIncrements to=workOrderHistoryFilters.filters.changeDateTimeTo from=workOrderHistoryFilters.filters.changeDateTimeFrom title=\"::\'workOrderHistoryFilters.dateRange\' | translate\"></filter-date-range><filter-user filter=workOrderHistoryFilters.filters.userIds title=workOrderHistoryFilters.usersTitle roles=workOrderHistoryFilters.roles multi-select=true ignore-checkbox=true></filter-user><uib-accordion class=checkbox-group><div uib-accordion-group is-open=workOrderHistoryFilters.fieldsFiltersOpen><uib-accordion-heading><div class=row><div class=col-xs-8>{{::\'workOrderHistoryFilters.fieldsChanged\' | translate}} <span class=\"filter-badge label label-default\" ng-if=\"workOrderHistoryFilters.filters.fields.length > 0\">{{workOrderHistoryFilters.filters.fields.length}}</span></div><div class=col-xs-4><i class=\"pull-right fa\" ng-class=\"{\'fa-chevron-down\': workOrderHistoryFilters.fieldsFiltersOpen, \'fa-chevron-right\': !workOrderHistoryFilters.fieldsFiltersOpen}\"></i></div></div></uib-accordion-heading><uib-accordion-transclude><filter-checkbox-group ng-repeat=\"title in workOrderHistoryFilters.fieldTitles\" ng-class=\"\'filter-checkbox-group-\' + title\" filter=workOrderHistoryFilters.filters.fields header=\"::\'workOrderHistoryFilters.fieldTitles.\' + title | translate\" fields=workOrderHistoryFilters.fields[title]></filter-checkbox-group></uib-accordion-transclude></div></uib-accordion></filter-panel></div></div></div></div></panel-body></sliding-panel>");
$templateCache.put("app/components/workOrderHistoryList/workOrderHistoryList.html","<div class=work-order-history-list><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-xs-12><div class=pull-left><h4>{{::\'historyList.title\' | translate}}<results-message total=workOrderHistoryList.totalCount class=hidden-xs></results-message></h4></div></div></div><div class=main-container><filter-bar clear-function=workOrderHistoryList.clearFilters() disable-my-filters=true toggle-filters=workOrderHistoryList.openFilters() filters=workOrderHistoryList.filters></filter-bar><div class=row><div class=\"col-xs-12 content-body\"><div class=row><div class=col-xs-12><history-list-navigation filters=workOrderHistoryList.filters></history-list-navigation></div></div><div class=\"row text-center\" ng-if=\"workOrderHistoryList.changes.length === 0\"><div class=col-xs-12><span class=history-list-no-results><em class=text-muted>{{::\'general.noResults\' | translate}}</em></span></div></div><div class=row ng-if=\"workOrderHistoryList.changes.length > 0\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-5\"><div class=history-list-body-wrapper><div class=history-list-body><div class=\"list-object font-size-md cursor-pointer box-shadow\" ng-click=\"workOrderHistoryList.setActiveChange(change); workOrderHistoryList.openPanel();\" ng-class=\"{\'active-change\': workOrderHistoryList.activeChange.key === change.key}\" ng-repeat=\"change in workOrderHistoryList.changes track by change.key\"><div class=\"row left-info\"><div class=\"col-xs-6 col-md-3\">{{::change.changeDateTime | date: \'MM/dd/yyyy\'}}</div><div class=\"col-xs-6 col-md-5 text-right-mobile\">{{::change.changeDateTime | date: \'hh:mm:ss a\'}}</div><div ng-if=workOrderHistoryList.workOrders[change.workOrderId].displayId class=\"col-md-4 visible-md visible-lg text-right\">{{::\'historyList.id\' | translate}} {{::workOrderHistoryList.workOrders[change.workOrderId].displayId}}</div></div><div class=\"row left-info\"><div class=\"col-xs-8 col-md-6 user-full-name truncate\" ng-class=\"{\'text-muted\': workOrderHistoryList.activeChange.key !== change.key}\"><div ng-if=!change.impersonatedByUser>{{::change.user.firstName}} {{::change.user.lastName}}</div><div ng-if=change.impersonatedByUser>{{::\'general.cscUser\' | translate}}</div></div><div class=\"col-xs-4 text-right hidden-md hidden-lg pull-right\">{{::\'historyList.id\' | translate}} {{::workOrderHistoryList.workOrders[change.workOrderId].displayId}}</div><div class=\"col-xs-8 col-md-6 text-right-desktop truncate\" ng-class=\"{\'text-muted\': workOrderHistoryList.activeChange.key !== change.key}\">{{::workOrderHistoryList.workOrders[change.workOrderId].businessAsset.name}}</div></div></div></div></div></div><div class=\"col-sm-7 hidden-xs\"><div class=history-list-details><work-order-history-summary active-change=workOrderHistoryList.activeChange work-order=workOrderHistoryList.workOrders[workOrderHistoryList.activeChange.workOrderId]></work-order-history-summary><history-event-card class=details-list change-event=workOrderHistoryList.activeChange></history-event-card></div></div></div></div></div></div></div><div class=row><div class=col-sm-12 ng-hide=\"workOrderHistoryList.totalCount <= workOrderHistoryList.filters.pageSize\"><ul uib-pagination total-items=workOrderHistoryList.totalCount ng-model=workOrderHistoryList.filters.page ng-change=workOrderHistoryList.pageChanged() items-per-page=workOrderHistoryList.filters.pageSize max-size=5 class=\"pagination-sm pull-left\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div><sliding-panel open-when=workOrderHistoryList.panelOpen button-functions=workOrderHistoryList.panelOptions.buttonFunctions cancel-button=false titles=workOrderHistoryList.panelOptions.titles><panel-body><work-order-history-summary active-change=workOrderHistoryList.activeChange work-order=workOrderHistoryList.workOrders[workOrderHistoryList.activeChange.workOrderId]></work-order-history-summary><history-event-card class=mobile-details-list change-event=workOrderHistoryList.activeChange></history-event-card></panel-body></sliding-panel><work-order-history-filters open-when=workOrderHistoryList.filterOpen clear-function=workOrderHistoryList.clearFilters() filters=workOrderHistoryList.filters></work-order-history-filters></div>");
$templateCache.put("app/components/workOrderInventory/workOrderInventory.html","<div class=inventory-section><div class=\"row sub-header-container\"><div class=col-xs-12><h5 id=inventorySection scroll-spy-on spies=workOrderInventory.spies spy-text=\"{{::\'workOrderInventory.title\' | translate}}\" spy-position=5>{{::\'workOrderInventory.title\' | translate}}</h5></div></div><div class=content-section><div class=row><div class=col-xs-12><button class=\"btn btn-default btn-circle hidden-print pull-right\" ng-click=\"workOrderInventory.openWhen = true\"><i class=\"fa fa-plus fa-2x text-primary\" aria-hidden=true></i></button></div><div class=\"col-xs-12 no-results\" ng-if=\"workOrderInventory.inventoryTransactions.length === 0\"><h6><em class=text-muted>{{::\'workOrderInventory.noTransactions\' | translate}}</em></h6></div></div><div class=list-body><div class=\"row grid-row grid-row-last-no-border\" ng-repeat=\"inventoryTransaction in workOrderInventory.inventoryTransactions track by inventoryTransaction.id\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 col-sm-4 darker-font\"><div class=truncate>{{::inventoryTransaction.inventoryItem.name}}</div></div><div class=\"col-xs-12 col-sm-6\"><div class=truncate>{{::inventoryTransaction.inventoryItem.description}}</div></div><div class=\"col-xs-12 col-sm-2\">{{::inventoryTransaction.inventoryTransactionDetails[0].transactionQuantity * -1}} {{::inventoryTransaction.inventoryItem.unitOfIssue}}</div></div><div class=row><div class=col-xs-12><bread-crumbs class=font-secondary no-links=true inline=true include-self=true asset=inventoryTransaction.asset></bread-crumbs></div></div></div></div></div></div></div>");
$templateCache.put("app/components/workOrderList/multipleAssignees.html","<div class=work-order-assignees ng-repeat=\"assignee in multipleAssignees.assignees track by assignee.id\"><span class=\"assignee-name truncate\">{{assignee.firstName}} {{assignee.lastName}} </span><span ng-if=\"$index != (multipleAssignees.assignees.length -1)\">,</span></div>");
$templateCache.put("app/components/workOrderList/requesterList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'workOrderList.myRequests\' | translate}}<results-message total=workOrderList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row\"><a ui-sref=secure.workOrderFormNew class=\"btn btn-primary hidden-xs\"><span>{{::\'workOrderList.createNew\' | translate}}</span> </a><button class=\"btn btn-default visible-xs-inline\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\' : workOrderList.isFilterApplied()}\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><work-order-filters filters=workOrderList.filters></work-order-filters><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section work-order-list\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-2><strong>{{::\'workOrderList.woid\' | translate}}</strong></div><div class=col-sm-4><strong>{{::\'workOrderList.status\' | translate}}</strong></div><div class=col-sm-3><strong>{{::\'workOrderList.requested\' | translate}}</strong></div><div class=col-sm-3><strong>{{::\'workOrderList.assignedTo\' | translate}}</strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"workOrderList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row\" ng-repeat=\"workorder in workOrderList.listData track by workorder.id\" ng-class=\"{\n                        \'priority-emergency\': workorder.priority === workOrderList.priority.emergency,\n                        \'priority-high\': workorder.priority === workOrderList.priority.high,\n                        \'priority-medium\': workorder.priority === workOrderList.priority.medium,\n                        \'priority-low\': workorder.priority === workOrderList.priority.low\n                        }\" ng-click=workOrderList.viewWorkOrderReadOnly(workorder.id)><div class=\"col-sm-2 col-xs-2\"><strong>{{::workorder.displayId}}</strong></div><div class=\"col-sm-4 col-xs-10\" ng-if=\"workorder.status !== workOrderList.status.complete\">{{::(workorder.status | status)}}</div><div class=\"col-sm-4 cols-xs-10\" ng-if=\"workorder.status === workOrderList.status.complete\">{{::\'workOrderList.completed\' | translate}} <span class=hidden-xs>{{::(workorder.completionDateTime | date: \'MM/dd/yyyy h:mma\')}}</span></div><div class=\"col-sm-3 col-xs-12 hidden-xs\"><span class=visible-xs-inline-block>{{::\'workOrderList.requested\' | translate}}:</span> {{::(workorder.requestDateTime | date:\'MM/dd/yyyy h:mma\')}}</div><div class=\"col-sm-3 col-xs-12\"><span class=visible-xs-inline-block>{{::\'workOrderList.assignedTo\' | translate}}:</span><multiple-assignees assignees=::workorder.assignees></div><div class=\"col-sm-12 col-xs-12\" ng-if=workorder.businessAsset><em><span has-markets=\"workOrderList.market.k12, workOrderList.market.he, workOrderList.market.ips\" ng-if=workorder.locationDescription>{{::workorder.locationDescription}} - </span>{{::workorder.businessAsset.name}} <span class=text-muted ng-if=workorder.businessAsset.parent><bread-crumbs path=\"\" root=\"\" asset=workorder.businessAsset no-links=true inline=true prepend-char=( append-char=)></bread-crumbs></span></em></div><div class=col-xs-12><span ng-bind-html=\"::workorder.description | linebreaks\"></span></div><div class=col-sm-12 ng-if=workorder.actionTaken><em><strong>{{::\'workOrderList.actionTaken\' | translate}}: {{::workorder.actionTaken}}</strong></em></div></div><div class=row><div class=col-sm-12><ul uib-pagination ng-hide=\"workOrderList.totalCount <= workOrderList.filters.pageSize\" total-items=workOrderList.totalCount ng-model=workOrderList.filters.page ng-change=workOrderList.pageChanged() items-per-page=workOrderList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" boundary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/workOrderList/workOrderBulkAction.html","<sliding-panel open-when=bulkAction.panelOpen titles=bulkAction.panelTitles button-functions=bulkAction.panelFunctions><panel-body><div class=panel-form-content><ng-form name=form><div class=row><div class=col-xs-12><div class=form-group><div class=radio-box><div class=row><div class=col-xs-6><div class=radio><label><input type=radio ng-model=bulkAction.assignmentType value={{bulkAction.assignmentTypes.add}}> {{::\'workOrderList.bulkActions.addAssignee\' | translate}}</label></div></div><div class=col-xs-6><div class=radio><label><input type=radio ng-model=bulkAction.assignmentType value={{bulkAction.assignmentTypes.replace}}> {{::\'workOrderList.bulkActions.replaceAssignee\' | translate}}</label></div></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.users.$invalid && form.users.$touched}\"><label>{{::\'workOrderList.bulkActions.assigneeName\' | translate}}</label><users-typeahead ng-model=bulkAction.assignees ng-required=true ng-if=\"bulkAction.assignmentType === bulkAction.assignmentTypes.add\" multi-select=true focus-on={{bulkAction.panelOpen}} roles=bulkAction.roles></users-typeahead><users-typeahead ng-model=bulkAction.assignees ng-if=\"bulkAction.assignmentType === bulkAction.assignmentTypes.replace\" multi-select=true focus-on={{bulkAction.panelOpen}} roles=bulkAction.roles></users-typeahead><p class=text-danger ng-messages=form.users.$error ng-if=form.users.$touched><span ng-message=emptyMultiSelect>{{::\'general.validation.required\' | translate }}</span></p></div></div></div></ng-form></div></panel-body></sliding-panel>");
$templateCache.put("app/components/workOrderList/workOrderList.html","<div ng-if=!workOrderList.isRequester ng-init=\"workOrderList.hideFiltersMobile = true;\"><!--Normal Header--><div class=\"row header-container\" ng-if=!workOrderList.bulkWorkOrders.length><div class=col-sm-9><div class=pull-left><h4>{{::\'workOrderList.title\' | translate}}<results-message total=workOrderList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row\"><div class=\"btn-group dropdown\" uib-dropdown is-open=action.isopen ng-click=$event.stopPropagation();><button type=button class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=disabled ng-click=$event.stopPropagation()><i class=\"fa fa-sort visible-xs-inline\" aria-hidden=true></i> <span class=hidden-xs>Sort</span></button><ul class=\"dropdown-menu pull-right\" role=menu><li><a ui-sref=secure.workOrderList ui-sref-opts=\"{reload: true}\" ng-click=\"workOrderList.sort(\'RequestDateTime desc\')\">{{::\'workOrderList.newestToOldest\' | translate}}</a></li><li><a ui-sref=secure.workOrderList ui-sref-opts=\"{reload: true}\" ng-click=\"workOrderList.sort(\'RequestDateTime asc\')\">{{::\'workOrderList.oldestToNewest\' | translate}}</a></li><li><a ui-sref=secure.workOrderList ui-sref-opts=\"{reload: true}\" ng-click=\"workOrderList.sort(\'DueDateTime asc\')\">{{::\'workOrderList.daysLeftToComplete\' | translate}}</a></li></ul></div><button class=\"btn btn-link hidden-xs\" ng-if=\"workOrderList.totalCount && !workOrderList.isTechnician\" ng-click=workOrderList.export()>{{::\'workOrderList.export\' | translate}}</button> <button class=\"btn btn-link visible-xs-inline\" ng-click=\"workOrderList.hideFiltersMobile = !workOrderList.hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\' : workOrderList.isFilterApplied()}\" aria-hidden=true></i></button> <a ui-sref=secure.workOrderFormNew class=\"btn btn-primary hidden-xs\" aria-label=\"{{::\'workOrderList.create\' | translate}}\"><span>{{::\'general.actions.new\' | translate}}</span></a></div></div></div><!--Bulk Actions Header--><div class=row ng-if=workOrderList.bulkWorkOrders.length><div class=list-body><div class=\"col-sm-9 bulk-header work-order-bulk\"><div class=\"inline-block bulk-title\"><strong><span>{{workOrderList.bulkWorkOrders.length}}</span> <span>{{::\'workOrderList.selected\' | translate}}</span></strong></div><div class=\"inline-block bulk-clear\"><span class=font-size-sm ng-click=workOrderList.clearAll()>{{::\'general.clearAll\' | translate}}</span></div><div class=pull-right><button class=\"btn btn-inverse\" ng-click=\"workOrderList.bulkAction(\'assign\')\"><i class=\"fa fa-user\" aria-hidden=true></i> <span class=font-size-md>{{::\'workOrderList.assign\' | translate}}</span></button> <button class=\"btn btn-inverse\" ng-click=workOrderList.bulkPrint(false) has-markets=\"workOrderList.market.mfg, workOrderList.market.other, workOrderList.market.club, workOrderList.market.gov\"><i class=\"fa fa-print\" aria-hidden=true></i> <span class=font-size-md>{{::\'general.print\' | translate}}</span></button><div class=\"btn-group print-dropdown\" uib-dropdown keyboard-nav dropdown-append-to=appendToEl has-markets=\"workOrderList.market.k12, workOrderList.market.he, workOrderList.market.ips\"><button id=bulk-print type=button class=\"btn btn-inverse\" uib-dropdown-toggle><i class=\"fa fa-print\" aria-hidden=true></i> <span class=font-size-md>{{::\'general.print\' | translate}}</span> <span class=caret></span></button><ul class=\"dropdown-menu cursor-pointer\" uib-dropdown-menu role=menu aria-labelledby=bulk-print><li role=menuitem><a ng-click=workOrderList.bulkPrint(false)>{{::\'workOrderList.bulkActions.printForms\' | translate}}</a></li><li role=menuitem><a ng-click=workOrderList.bulkPrint(true)>{{::\'workOrderList.bulkActions.printSummary\' | translate}}</a></li></ul></div></div></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\': workOrderList.hideFiltersMobile}\"><work-order-filters filters=workOrderList.filters hide-filters=workOrderList.hideFiltersMobile is-disabled=!!workOrderList.bulkWorkOrders.length></work-order-filters><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"workOrderList.hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body ng-class=\"{\'no-results\': workOrderList.listData.length === 0, \'bulk-list\': workOrderList.bulkWorkOrders.length}\"><div class=\"col-sm-pull-3 col-sm-9 content-body content-section work-order-list\"><div class=\"row hidden-xs grid-header\" ng-if=\"workOrderList.listData.length > 0\"><div class=col-sm-10><div class=\"row work-order-headings\"><div class=col-sm-2><input ng-click=workOrderList.selectAllBulk() class=\"hidden-xs bulk-checkbox\" type=checkbox ng-model=workOrderList.allBulk> <strong>{{::\'workOrderList.woid\' | translate}}</strong></div><div class=col-sm-3><strong>{{::\'workOrderList.status\' | translate}}</strong></div><div class=col-sm-4 has-markets=\"workOrderList.market.mfg, workOrderList.market.club, workOrderList.market.other, workOrderList.market.gov\"><strong>{{::\'workOrderList.purpose\' | translate}}</strong></div><div class=col-sm-4 has-markets=\"workOrderList.market.k12, workOrderList.market.he, workOrderList.market.ips\"><strong>{{::\'workOrderList.workType\' | translate}}</strong></div><div class=col-sm-3><strong>{{::\'workOrderList.requested\' | translate}}</strong></div></div></div><div class=col-sm-2><strong>{{::\'workOrderList.assignedTo\' | translate}}</strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"workOrderList.listData.length === 0\"><h6><em class=text-muted>{{::\'workOrderList.noResultsFound\' | translate}}</em></h6></div><div ng-repeat=\"workorder in workOrderList.listData track by workorder.id\"><div class=\"row grid-row\" ng-class=\"{\n                        \'priority-emergency\': workorder.priority === workOrderList.priority.emergency,\n                        \'priority-high\': workorder.priority === workOrderList.priority.high,\n                        \'priority-medium\': workorder.priority === workOrderList.priority.medium,\n                        \'priority-low\': workorder.priority === workOrderList.priority.low,\n                        \'bulk-selection\': workorder.bulk,\n                        \'cursor-pointer\' : !workOrderList.bulkWorkOrders.length,\n                        \'cursor-default\' : workOrderList.bulkWorkOrders.length\n                        }\" ng-click=workOrderList.edit(workorder.id)><div class=\"col-sm-10 col-xs-12\"><div class=row><div class=\"col-sm-2 col-xs-2\"><input ng-click=\"workOrderList.updateBulk($event, workorder)\" ng-checked=workorder.bulk class=\"hidden-xs bulk-checkbox\" type=checkbox> <strong>{{::workorder.displayId}}</strong></div><div class=\"col-sm-3 col-xs-7\">{{workorder.status | status}}</div><div class=\"col-sm-3 col-xs-3\" ng-if=\"workOrderList.screenSize.breakpoint === workOrderList.breakpoints.xs\"><div class=\"inline-block pull-right\"><status-quick-action work-order=workorder panel-options=workOrderList.panelOptions editing-object=workOrderList.editing ng-disabled=workOrderList.bulkWorkOrders.length></status-quick-action></div></div><div class=\"col-sm-4 col-xs-12 hidden-xs truncate\" has-markets=\"workOrderList.market.mfg, workOrderList.market.club, workOrderList.market.other, workOrderList.market.gov\">{{::workorder.purpose.value}}</div><div class=\"col-sm-4 col-xs-12 hidden-xs truncate\" has-markets=\"workOrderList.market.k12, workOrderList.market.he, workOrderList.market.ips\"><span ng-if=workorder.workType>{{::workorder.workType.name}}</span></div><div class=\"col-sm-3 col-xs-12 hidden-xs\">{{::(workorder.requestDateTime | date:\'MM/dd/yyyy h:mma\')}}</div><div class=\"col-sm-12 col-xs-12\" ng-if=workorder.businessAsset><em class=bulk-spacer><span has-markets=\"workOrderList.market.k12, workOrderList.market.he, workOrderList.market.ips\" ng-if=workorder.locationDescription>{{::workorder.locationDescription}} - </span>{{::workorder.businessAsset.name}} <span class=text-muted ng-if=workorder.businessAsset.ancestorIdPath><bread-crumbs path=\"\" root=\"\" asset=workorder.businessAsset no-links=true inline=true prepend-char=( append-char=)></bread-crumbs></span></em></div><div class=col-xs-12><span class=bulk-spacer ng-bind-html=\"::workorder.description | linebreaks\"></span></div></div></div><div class=\"col-sm-2 col-xs-12 hidden-xs\"><multiple-assignees assignees=workorder.assignees></multiple-assignees></div><div class=col-sm-12><span class=\"pull-left margin-top-xs bulk-spacer\"><span class=\"pull-left margin-right-xs\"><days-to ng-if=\"workorder.dueDateTime && workorder.status !== workOrderList.status.complete\" target-date=workorder.dueDateTime show-as-pill=true></days-to></span><span class=\"pull-left margin-right-xs\"><div ng-if=workorder.pmSchedule class=\"pill-tag pill-recurring pull-left\"><i class=\"fa fa-refresh\" aria-hidden=true></i> {{::\'workOrderList.recurring\' | translate}}</div></span></span><span class=\"pull-right margin-top-xs\" ng-if=\"workOrderList.screenSize.breakpoint !== workOrderList.breakpoints.xs\"><div class=\"inline-block pull-right\" ng-class=\"{\'divided-actions\' : workorder.status === workOrderList.status.newRequest || workorder.status === workOrderList.status.workInProgress}\"><status-quick-action work-order=workorder panel-options=workOrderList.panelOptions editing-object=workOrderList.editing ng-disabled=workOrderList.bulkWorkOrders.length></status-quick-action></div><div class=inline-block ng-if=\"workorder.status === workOrderList.status.newRequest || workorder.status === workOrderList.status.workInProgress\"><button class=\"btn btn-default btn-sm quick-action-button pull-right\" ng-click=\"$event.stopPropagation(); workOrderList.updateAssignees($index);\" ng-class=\"{\'active\': workorder.quickActionsUpdateAssignee}\" ng-disabled=workOrderList.bulkWorkOrders.length><i class=\"fa fa-user\" aria-hidden=true></i>&nbsp;&nbsp;{{::\'workOrderList.updateAssignee\' | translate}}</button> <button class=\"btn btn-default btn-sm hidden-xs quick-action-button pull-right\" ng-click=\"$event.stopPropagation(); workOrderList.updateSchedule($index);\" ng-class=\"{\'active\': workorder.quickActionsUpdateSchedule}\" ng-if=\"!workOrderList.isTechnician && !workOrderList.isRequester\" ng-disabled=workOrderList.bulkWorkOrders.length><i class=\"fa fa-calendar-o\" aria-hidden=true></i>&nbsp;&nbsp;{{::\'workOrderList.updateScheduling\' | translate}}</button></div></span></div></div><form><div class=\"work-order-quick-actions row hidden-xs\" hide-quick-actions close-function=workOrderList.closeLastQuickAction() ng-if=\"workorder.quickActionsUpdateAssignee || workorder.quickActionsUpdateSchedule\"><div class=col-sm-12><schedule-quick-action due-date=workorder.dueDateTime request-date=workorder.requestDateTime start-date=workorder.scheduledStartDate ng-if=\"workorder.quickActionsUpdateSchedule && !workOrderList.isTechnician && !workOrderList.isRequester\"></schedule-quick-action><assignee-quick-action assignees=workorder.assignees ng-if=workorder.quickActionsUpdateAssignee></assignee-quick-action><div class=row><div class=col-sm-6><button class=\"btn btn-link\" ng-click=workOrderList.closeLastQuickAction()>{{::\'general.actions.close\' | translate}}</button></div></div></div></div></form></div><div class=row><div class=col-sm-12><ul uib-pagination ng-hide=\"workOrderList.totalCount <= workOrderList.filters.pageSize\" total-items=workOrderList.totalCount ng-model=workOrderList.filters.page ng-change=workOrderList.pageChanged() items-per-page=workOrderList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" boundary-links=false rotate=true ng-disabled=workOrderList.bulkWorkOrders.length scroll-to-top></ul></div></div></div></div></div></div></div><work-order-bulk-action panel-open=workOrderList.bulkPanelOpen work-orders=workOrderList.bulkWorkOrders action=workOrderList.bulkActionType></work-order-bulk-action><sliding-panel open-when=workOrderList.panelOptions.open titles=workOrderList.panelOptions.titles button-functions=workOrderList.panelOptions.functions><panel-body><ng-form name=form ng-if=workOrderList.editing.workOrder.id><div class=panel-form-content><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.completionDate.$invalid}\"><label for=completionDate>{{:: \'workOrderForm.completionDate\' | translate}}</label><span class=\"label label-default\" ng-if=\"workOrderList.editing.workOrder.status == workOrderList.status.complete\">{{::\'general.required\' | translate}}</span><date-time id=completionDate name=completionDate min-date=workOrderList.editing.workOrder.requestDateTime ng-model=workOrderList.editing.workOrder.completionDateTime ng-required=\"workOrderList.editing.workOrder.status == workOrderList.status.complete\"></date-time><p class=text-danger ng-messages=form.completionDate.$error><span ng-message=required>{{::\'general.validation.required\' | translate}}</span> <span ng-message=timeEmpty>{{::\'general.validation.timeEmpty\' | translate}}</span> <span ng-message=dateTimeBeforeMin>{{::\'workOrderForm.validation.completionDateBeforeMin\' | translate}}</span></p></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=actionTaken>{{::\'workOrderForm.actionTaken\' | translate}}</label><text-area id=actionTaken name=actionTaken ng-model=workOrderList.editing.workOrder.actionTaken maxlength=2000 maxlines=5></text-area></div></div></div></div><div class=\"form-group hairline\"></div><div class=panel-form-content><div class=row><div class=col-xs-12><label>{{:: \'transactions.labor\' | translate}}</label><p class=read-only><span>{{::workOrderList.editing.transaction.typeAttributes.user.firstName}}</span> <span>{{::workOrderList.editing.transaction.typeAttributes.user.lastName}}</span></p></div></div><div class=row><div class=col-xs-6><label for=date>{{::\'workOrderList.dateOfWork\' | translate}}</label><calendar id=date name=date allow-update=true ng-model=workOrderList.editing.transaction.transactionDate></calendar></div><div class=col-xs-6><div ng-class=\"{\'has-error\': form.hours.$invalid}\"><label for=hours>{{::\'general.hours\' | translate}}</label><number-field name=hours ng-model=workOrderList.editing.transaction.typeAttributes.hours disallow-precision=true min=0.01 max=999.99></number-field></div></div><div class=\"col-xs-12 outside-validation\"><p class=text-danger ng-messages=form.hours.$error ng-if=\"form.hours.$touched || transaction.saveAttempt\"><span ng-message=maximum>{{::\'transactions.validation.laborHours.max\' | translate }} </span><span ng-message=minimum>{{::\'transactions.validation.laborHours.min\' | translate }}</span></p></div></div></div></ng-form></panel-body></sliding-panel><div ng-if=workOrderList.isRequester ng-include=\"\'app/components/workOrderList/requesterList.html\'\"></div>");
$templateCache.put("app/components/workOrderQuickActions/assigneeQuickAction.html","<div class=row><div class=col-md-6><div class=form-group><label>{{::\'workOrderList.assignTo\' | translate}}</label><users-typeahead roles=quickAction.roles ng-model=quickAction.assignees multi-select=true></users-typeahead></div></div></div>");
$templateCache.put("app/components/workOrderQuickActions/scheduleQuickAction.html","<div class=row><div class=col-sm-6><div class=form-group><label for=scheduledStart>{{::\'workOrderList.scheduledStart\' | translate}}</label><calendar id=scheduledStart name=scheduledStart min-date=quickAction.requestDate max-date=quickAction.dueDate end-of-day=true ng-model=quickAction.startDate></calendar></div></div><div class=col-sm-6><div class=form-group><label for=dueDate>{{::\'workOrderList.dueDate\' | translate}}</label><calendar id=dueDate name=dueDate min-date=\"quickAction.startDate || quickAction.requestDate\" end-of-day=true ng-model=quickAction.dueDate></calendar></div></div></div>");
$templateCache.put("app/components/workOrderQuickActions/statusQuickAction.html","<div class=inline-block><button class=\"btn btn-default btn-sm quick-action-button\" ng-click=\"$event.stopPropagation(); quickAction.quickStatusChange(quickAction.workOrder);\" ng-if=\"quickAction.workOrder.status === quickAction.status.newRequest  || quickAction.workOrder.status === quickAction.status.workInProgress\" ng-disabled=quickAction.ngDisabled><span ng-if=\"quickAction.workOrder.status === quickAction.status.newRequest \"><i class=\"fa fa-play-circle\" aria-hidden=true></i> {{::\'workOrderList.start\' | translate}}</span> <span ng-if=\"quickAction.workOrder.status === quickAction.status.workInProgress \"><i class=\"fa fa-check-circle-o\" aria-hidden=true></i> {{::\'workOrderList.complete\' | translate}}</span></button></div>");
$templateCache.put("app/components/workOrderTasks/workOrderTasks.html","<div class=tasks-section><div class=\"row sub-header-container\"><div class=col-xs-9><h5 id=tasksSection scroll-spy-on spies=spies spy-text=\"{{::\'workOrderTasks.title\' | translate}}\" spy-position=2>{{::\'workOrderTasks.title\' | translate}}</h5></div><div class=col-xs-3><div class=\"pull-right sub-header-container-btn\"><button type=button class=\"btn btn-link\" ng-click=addTasks(1)>{{::\'workOrderTasks.addTask\' | translate}}</button></div></div></div><div class=content-section><task-book task-book=taskBook tasks-to-delete=tasksToDelete seed-tasks=0 mode=mode hide-button=hideButton></task-book></div></div>");
$templateCache.put("app/components/workOrderTransactions/deleteConfirmModal.html","<div class=delete-transaction-modal><div class=modal-header><h4><span class=title>{{::\'transactions.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'transactions.deleteModal.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=deleteConfirmModalController.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=deleteConfirmModalController.close()>{{::\'general.actions.no\' | translate}}</button></div></div>");
$templateCache.put("app/components/workOrderTransactions/laborTransactions.html","<div class=panel-form-content><ng-form name=form novalidate><div class=row><div class=col-xs-6><div class=form-group ng-class=\"{\'has-error\': form.hours.$invalid && (form.hours.$touched || transaction.saveAttempt)}\"><label for=hours>{{::\'transactions.transactionsPanel.hours\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span> <input id=hours type=text name=hours class=form-control min=0.01 max=999.99 force-decimal-precision precision=0 ng-model=transactionsPanel.transaction.typeAttributes.hours max-validator min-validator number-validator required focus-on=true focus-wait=700><p class=text-danger ng-messages=form.hours.$error ng-if=\"form.hours.$touched || transactionsPanel.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }} </span><span ng-message=validNumber>{{::\'transactions.validation.laborHours.number\' | translate }} </span><span ng-message=maxNumber>{{::\'transactions.validation.laborHours.max\' | translate }} </span><span ng-message=minNumber>{{::\'transactions.validation.laborHours.min\' | translate }}</span></p></div></div><div class=col-xs-6><div class=form-group><label for=hoursType>{{::\'transactions.transactionsPanel.type\' | translate}}</label><select id=hoursType name=hoursType class=form-control ng-model=transactionsPanel.transaction.typeAttributes.laborType ng-options=\"type.value as type.name for type in transactionsPanel.laborTypes\"></select></div></div></div><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.transactionUser.$invalid}\"><label>{{:: \'transactions.transactionsPanel.name\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><users-typeahead ng-model=transactionsPanel.transaction.typeAttributes.user multi-select=false ng-required=true name=transactionUser roles=transactionsPanel.roles></users-typeahead><p class=text-danger ng-messages=form.transactionUser.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.date.$invalid}\"><label for=date>{{::\'transactions.transactionsPanel.date\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><calendar id=date name=date ng-model=transactionsPanel.transaction.transactionDate ng-required=true></calendar><p class=text-danger ng-messages=form.date.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div></ng-form></div>");
$templateCache.put("app/components/workOrderTransactions/laborTransactionsReadOnly.html","<div class=panel-form-content><div class=row><div class=col-xs-6><div><label for=hours>{{::\'transactions.transactionsPanel.hours\' | translate}}</label><p><span id=hours>{{transactionsPanel.transaction.typeAttributes.hours}}</span></p></div></div><div class=col-xs-6><div><label for=hoursType>{{::\'transactions.transactionsPanel.type\' | translate}}</label><p><span id=hoursType>{{::\'transactions.transactionsPanel.labor.\' + transactionsPanel.transaction.typeAttributes.laborType | translate }}</span></p></div></div></div><div class=row><div class=col-xs-12><div><label for=name>{{:: \'transactions.transactionsPanel.name\' | translate}}</label><p><span id=name>{{::transactionsPanel.transaction.typeAttributes.user.firstName}} {{::transactionsPanel.transaction.typeAttributes.user.lastName}}</span></p></div></div></div><div class=row><div class=col-xs-12><div><label for=date>{{::\'transactions.transactionsPanel.date\' | translate}}</label><p><span id=date>{{(transactionsPanel.transaction.transactionDate | date:\'MM/dd/yyyy\')}}</span></p></div></div></div></div>");
$templateCache.put("app/components/workOrderTransactions/purchaseTransactions.html","<div class=panel-form-content><ng-form name=form novalidate><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.description.$invalid && (form.description.$touched || transactionsPanel.saveAttempt)}\"><label for=description>{{::\'transactions.purchaseTransactionsPanel.item\'| translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><text-area id=description textarea-name=description ng-model=transactionsPanel.transaction.description maxlength=255 maxlines=10 is-required=true is-focused=true focus-wait=true></text-area><p class=text-danger ng-messages=form.description.$error ng-if=\"form.description.$touched || transactionsPanel.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=\"col-xs-6 col-sm-4\"><div class=\"form-group equation\" ng-class=\"{\'has-error\': form.quantity.$invalid && (form.quantity.$touched || transactionsPanel.saveAttempt)}\" accessibility><label for=quantity>{{::\'transactions.purchaseTransactionsPanel.quantity\' | translate}}</label><number-field name=quantity ng-model=transactionsPanel.transaction.typeAttributes.quantity disallow-precision=true min=-9999.99 max=9999.99></number-field></div></div><div class=\"col-xs-6 col-sm-4\"><div class=\"form-group equation\" ng-class=\"{\'has-error\': form.itemCost.$invalid && (form.itemCost.$touched || transactionsPanel.saveAttempt)}\" accessibility><label for=itemCost>{{::\'transactions.purchaseTransactionsPanel.unitCost\' | translate}}</label><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i><number-field name=itemCost ng-model=transactionsPanel.transaction.typeAttributes.unitCost min=0 max=100000000 places=2></number-field></div></div></div><div class=\"col-sm-4 hidden-xs\"><div class=\"form-group purchase-total-cost\"><label>{{::\'transactions.purchaseTransactionsPanel.totalCost\' | translate}}</label><div><span class=field-label>{{transactionsPanel.transaction.typeAttributes.totalCost | currency}}</span></div></div></div></div><p class=\"text-danger equation-validation\" ng-messages=form.quantity.$error ng-if=\"form.quantity.$touched || transactionsPanel.saveAttempt\"><span ng-message=maximum>{{::\'transactions.validation.purchaseQuantity.max\' | translate }} </span><span ng-message=minimum>{{::\'transactions.validation.purchaseQuantity.min\' | translate }}</span></p><p class=\"text-danger equation-validation\" ng-messages=form.itemCost.$error ng-if=\"form.itemCost.$touched || transactionsPanel.saveAttempt\"><span ng-message=maximum>{{::\'transactions.validation.purchaseItemCost.max\' | translate }} </span><span ng-message=minimum>{{::\'transactions.validation.purchaseItemCost.min\' | translate }}</span></p></div></div><div class=\"row visible-xs purchase-total-cost\"><div class=col-xs-12><div class=form-group><label>{{::\'transactions.purchaseTransactionsPanel.totalCost\' | translate}}</label><div><span class=field-label>{{transactionsPanel.transaction.typeAttributes.totalCost | currency}}</span></div></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label for=po>{{::\'transactions.purchaseTransactionsPanel.po\' | translate}}</label><input id=po class=form-control ng-model=transactionsPanel.transaction.typeAttributes.purchaseOrder maxlength=100></div></div><div class=col-sm-6><div class=form-group><label>{{::\'transactions.purchaseTransactionsPanel.supplier\' | translate}}</label><supplier-typeahead ng-model=transactionsPanel.transaction.typeAttributes.supplierName multi-select=false allow-creation=true></supplier-typeahead></div></div></div><div class=row><div class=col-sm-12><div class=form-group ng-class=\"{\'has-error\': form.transactionUser.$invalid}\"><label>{{:: \'transactions.purchaseTransactionsPanel.name\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><users-typeahead ng-model=transactionsPanel.transaction.typeAttributes.user multi-select=false ng-required=true name=transactionUser roles=transactionsPanel.roles></users-typeahead><p class=text-danger ng-messages=form.transactionUser.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-sm-12><div class=form-group ng-class=\"{\'has-error\': form.date.$invalid}\"><label for=date>{{::\'transactions.purchaseTransactionsPanel.date\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><calendar id=date name=date ng-model=transactionsPanel.transaction.transactionDate ng-required=true></calendar><p class=text-danger ng-messages=form.date.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div></ng-form></div>");
$templateCache.put("app/components/workOrderTransactions/purchaseTransactionsReadOnly.html","<div class=panel-form-content><div class=row><div class=col-xs-12><label for=description>{{::\'transactions.purchaseTransactionsPanel.item\'| translate}}</label><p><span id=description>{{transactionsPanel.transaction.description}}</span></p></div></div><div class=row><div class=col-sm-4><label for=quantity>{{::\'transactions.purchaseTransactionsPanel.quantity\' | translate}}</label><p><span id=quantity>{{transactionsPanel.transaction.typeAttributes.quantity | number}}</span></p></div><div class=col-sm-4><label for=itemCost>{{::\'transactions.purchaseTransactionsPanel.unitCost\' | translate}}</label><p><span id=itemCost>{{transactionsPanel.transaction.typeAttributes.unitCost | currency}}</span></p></div><div class=col-sm-4><label for=totalCost>{{::\'transactions.purchaseTransactionsPanel.totalCost\' | translate}}</label><p><span id=totalCost>{{transactionsPanel.transaction.typeAttributes.totalCost | currency}}</span></p></div></div><div class=row><div class=col-sm-6><label for=po>{{::\'transactions.purchaseTransactionsPanel.po\' | translate}}</label><p><span id=po>{{transactionsPanel.transaction.typeAttributes.purchaseOrder}}</span>&nbsp;</p></div><div class=col-sm-6><label for=supplier>{{::\'transactions.purchaseTransactionsPanel.supplier\' | translate}}</label><p><span id=supplier>{{transactionsPanel.transaction.typeAttributes.supplierName}}</span>&nbsp;</p></div></div><div class=row><div class=col-xs-12><label for=name>{{:: \'transactions.purchaseTransactionsPanel.name\' | translate}}</label><p><span id=name>{{::transactionsPanel.transaction.typeAttributes.user.firstName}} {{::transactionsPanel.transaction.typeAttributes.user.lastName}}</span></p></div></div><div class=row><div class=col-xs-12><label for=date>{{::\'transactions.purchaseTransactionsPanel.date\' | translate}}</label><p><span id=date>{{(transactionsPanel.transaction.transactionDate | date:\'MM/dd/yyyy\')}}</span></p></div></div></div>");
$templateCache.put("app/components/workOrderTransactions/serviceTransactions.html","<div class=\"panel-form-content service-panel\"><ng-form name=form novalidate><div class=row><div class=col-xs-12><div class=form-group><div class=service-type-label>{{::\'transactions.serviceTransactionsPanel.type\'| translate}}</div><div class=radio-box><div class=row><div class=col-sm-4><div class=radio><label><input type=radio ng-model=transactionsPanel.transaction.typeAttributes.serviceType ng-value=transactionsPanel.serviceTypes.contract> {{::\'transactions.serviceTransactionsPanel.contract\' | translate}}</label></div></div><div class=col-sm-4><div class=radio><label><input type=radio ng-model=transactionsPanel.transaction.typeAttributes.serviceType ng-value=transactionsPanel.serviceTypes.rental> {{::\'transactions.serviceTransactionsPanel.rental\' | translate}}</label></div></div><div class=col-sm-4><div class=radio><label><input type=radio ng-model=transactionsPanel.transaction.typeAttributes.serviceType ng-value=transactionsPanel.serviceTypes.other> {{::\'transactions.serviceTransactionsPanel.other\' | translate}}</label></div></div></div></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.supplier.$invalid && (form.supplier.$touched || transactionsPanel.saveAttempt)}\"><label>{{::\'transactions.serviceTransactionsPanel.vendor\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><supplier-typeahead ng-model=transactionsPanel.transaction.typeAttributes.supplierName multi-select=false allow-creation=true typeahead-title=\"\'transactions.serviceTransactionsPanel.vendor\' | translate\" ng-required=true></supplier-typeahead><p class=text-danger ng-messages=form.supplier.$error ng-if=\"form.supplier.$touched || transactionsPanel.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': form.date.$invalid && (form.date.$touched || transactionsPanel.saveAttempt)}\"><label for=serviceTransactionDate>{{::\'transactions.serviceTransactionsPanel.date\' | translate}}</label><span class=\"label label-default\">{{::\'general.required\' | translate}}</span><calendar id=serviceTransactionDate name=date ng-model=transactionsPanel.transaction.transactionDate ng-required=true></calendar><p class=text-danger ng-messages=form.date.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': form.totalCost.$invalid && (form.totalCost.$touched || transactionsPanel.saveAttempt)}\" accessibility><label for=totalCost>{{::\'transactions.serviceTransactionsPanel.cost\' | translate}}</label><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i><number-field name=totalCost ng-model=transactionsPanel.transaction.typeAttributes.cost min=0 max=999999.99 places=2></number-field></div><p class=\"text-danger equation-validation\" ng-messages=form.totalCost.$error ng-if=\"form.totalCost.$touched || transactionsPanel.saveAttempt\"><span ng-message=maximum>{{::\'transactions.validation.serviceTotalCost.max\' | translate }} </span><span ng-message=minimum>{{::\'transactions.validation.serviceTotalCost.min\' | translate }}</span></p></div></div><div class=col-sm-6><div class=form-group><label for=serviceTransactionsPo>{{::\'transactions.serviceTransactionsPanel.po\' | translate}}</label><input id=serviceTransactionsPo class=form-control ng-model=transactionsPanel.transaction.typeAttributes.purchaseOrder maxlength=100></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=serviceTransactionNotes>{{::\'transactions.serviceTransactionsPanel.notes\'| translate}}</label><text-area id=serviceTransactionNotes textarea-name=serviceTransactionNotes ng-model=transactionsPanel.transaction.description maxlength=255 maxlines=10 focus-wait=true></text-area></div></div></div></ng-form></div>");
$templateCache.put("app/components/workOrderTransactions/serviceTransactionsReadOnly.html","<div class=panel-form-content><div class=row><div class=col-sm-12><label for=serviceTransactionType>{{::\'transactions.serviceTransactionsPanel.type\' | translate}}</label><p><span id=serviceTransactionType>{{transactionsPanel.transaction.typeAttributes.serviceType | serviceTypeFilter}}</span></p></div></div><div class=row><div class=col-xs-12><label for=serviceTransactionSupplier>{{::\'transactions.purchaseTransactionsPanel.supplier\' | translate}}</label><p><span id=serviceTransactionSupplier>{{transactionsPanel.transaction.typeAttributes.supplierName}}</span>&nbsp;</p></div></div><div class=row><div class=col-xs-12><label for=serviceTransactionDate>{{::\'transactions.purchaseTransactionsPanel.date\' | translate}}</label><p><span id=serviceTransactionDate>{{(transactionsPanel.transaction.transactionDate | date:\'MM/dd/yyyy\')}}</span></p></div></div><div class=row><div class=col-sm-6><label for=serviceTransactionTotalCost>{{::\'transactions.purchaseTransactionsPanel.totalCost\' | translate}}</label><p><span id=serviceTransactionTotalCost>{{transactionsPanel.transaction.typeAttributes.cost | currency}}</span></p></div><div class=col-sm-6><label for=serviceTransactionPo>{{::\'transactions.purchaseTransactionsPanel.po\' | translate}}</label><p><span id=serviceTransactionPo>{{transactionsPanel.transaction.typeAttributes.purchaseOrder}}</span>&nbsp;</p></div></div><div class=row><div class=col-xs-12><label for=serviceTransactionDescription>{{::\'transactions.serviceTransactionsPanel.notes\'| translate}}</label><p><span id=serviceTransactionDescription>{{transactionsPanel.transaction.description}}</span></p></div></div></div>");
$templateCache.put("app/components/workOrderTransactions/workOrderTransactions.html","<div class=transactions-section><div class=\"row sub-header-container\"><div class=col-xs-9><h5 id=transactionsSection scroll-spy-on spies=transactions.spies spy-text=\"{{::\'transactions.title\' | translate}}\" spy-position=4>{{::\'transactions.title\' | translate}}</h5></div><div class=col-xs-3><div class=\"pull-right sub-header-container-btn\"><div class=btn-group uib-dropdown keyboard-nav dropdown-append-to=appendToEl><button id=btn-append-to type=button class=\"btn btn-link\" uib-dropdown-toggle><div>{{:: \'transactions.dropDown.addTransaction\' | translate}} <span class=caret></span></div></button><ul class=\"dropdown-menu cursor-pointer pull-right\" uib-dropdown-menu role=menu aria-labelledby=btn-append-to><li role=menuitem><a ng-click=\"transactions.addTransaction(null, \'labor\')\">{{::\'transactions.dropDown.labor\' | translate}}</a></li><li role=menuitem><a ng-click=\"transactions.addTransaction(null, \'purchase\')\">{{::\'transactions.dropDown.purchase\' | translate}}</a></li><li role=menuitem><a ng-click=\"transactions.addTransaction(null, \'service\')\">{{::\'transactions.dropDown.service\' | translate}}</a></li></ul></div></div></div></div><div class=content-section><div class=row ng-if=\"transactions.transactions.length > 0\"><div class=\"col-sm-12 type-row\"><div class=row><div class=\"col-sm-9 col-xs-8\"><div class=row><div class=col-sm-3><span>{{::\'transactions.purchase\' | translate}}</span> <span class=cost-totals>&nbsp;{{(transactions.transactions| transactionTypeSum:\'purchase\') | currency}}</span></div><div class=col-sm-3><span>{{::\'transactions.service\' | translate}}</span> <span class=cost-totals>&nbsp;{{(transactions.transactions| transactionTypeSum:\'service\') | currency}}</span></div><div class=col-sm-6><span>{{::\'transactions.labor\' | translate}}</span> <span class=cost-totals><span class=total-hours>({{(transactions.transactions | transactionHours) | number}}&nbsp;<ng-pluralize count=\"transactions.transactions | transactionHours\" when=\"{\'1\': \'{{::&quot;general.abbreviations.hour&quot;  | translate}}\',\n                                              \'other\': \'{{::&quot;general.abbreviations.hours&quot; | translate}}\'}\"></ng-pluralize>) </span><span has-permissions=Transactions-UpdateAny>{{(transactions.transactions | transactionTypeSum:\'labor\') | currency}}</span></span></div></div></div><div class=\"col-sm-3 col-xs-4\"><div class=row><div class=total-costs has-permissions=Transactions-UpdateAny><div class=pull-right><span>{{::\'transactions.totalCosts\' | translate}}</span></div><div class=\"total-cost-amount text-right\"><strong>{{(transactions.transactions | sum:\'typeAttributes.cost\') | currency}}</strong></div></div></div></div></div></div></div><div class=\"visible-xs mobile-divider\" ng-if=\"transactions.transactions.length > 0\"><hr></div><div class=list-body><div class=row ng-if=\"transactions.transactions.labor.length === 0\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'transactions.noTransactions.labor\' | translate}}</em></h6></div></div><div class=\"row hidden-xs grid-header\"><div class=col-sm-2><strong>{{::\'transactions.date\' | translate}}</strong></div><div class=col-sm-6><strong>{{::\'transactions.details\' | translate}}</strong></div><div class=col-sm-2><strong>{{::\'transactions.type\' | translate}}</strong></div><div class=col-sm-2><strong class=pull-right>{{::\'transactions.cost\' | translate}}</strong></div></div><div class=row><div class=\"col-sm-12 no-results\" ng-if=\"transactions.transactions.length === 0\"><h6><em class=text-muted>{{::\'transactions.noTransactions\' | translate}}</em></h6></div></div><div ng-repeat=\"transaction in transactions.transactions\" class=\"row grid-row grid-row-last-no-border cursor-pointer\" ng-class=\"{\'grid-row-locked\': !transaction.isEditable, \'\': !transaction.isEditable}\" ng-click=\"transactions.addTransaction(transaction, transaction.typeAttributes.type)\"><div class=hidden-xs><div class=col-sm-2><span>{{::transaction.transactionDate | date:\'MM/dd/yyyy\'}}</span></div><div class=col-sm-6><div ng-if=\"transaction.typeAttributes.type === \'labor\'\"><strong>{{::transaction.typeAttributes.hours}}</strong> <strong><ng-pluralize count=transaction.typeAttributes.hours when=\"{\'1\': \'{{::&quot; general.abbreviations.hour&quot;  | translate}}\',\n                                              \'other\': \'{{::&quot;general.abbreviations.hours&quot; | translate}}\'}\"></ng-pluralize></strong><strong ng-if=\"transaction.typeAttributes.laborType !== \'regular\'\">({{\'transactions.abbreviations.\' + transaction.typeAttributes.laborType | translate}})</strong> <strong has-permissions=Transactions-UpdateAny>{{::\'general.at\' | translate}} {{transaction.typeAttributes.rate * transaction.typeAttributes.multiplier | currency}}/{{::\'general.abbreviations.hour\' | translate}}</strong></div><div ng-if=\"transaction.typeAttributes.type !== \'labor\'\"><strong>{{::transaction.description}}</strong></div><div><span ng-if=transaction.typeAttributes.supplierName>{{::transaction.typeAttributes.supplierName}} | </span><span ng-if=transaction.typeAttributes.user>{{::transaction.typeAttributes.user.firstName}} {{::transaction.typeAttributes.user.lastName}}</span> <span ng-if=transaction.typeAttributes.serviceType>{{(transaction.typeAttributes.serviceType | serviceTypeFilter)}}</span></div></div><div class=col-sm-2><span class=text-capitalize>{{::transaction.typeAttributes.type}}</span></div><div class=col-sm-2><strong class=pull-right ng-if=\"transaction.typeAttributes.cost !== undefined\">{{::transaction.typeAttributes.cost | currency}}</strong> <span class=pull-right ng-if=\"transaction.typeAttributes.cost === undefined\">- - -</span></div></div><div class=visible-xs><div class=col-xs-9><div class=row><div class=col-sm-12><span>{{::transaction.transactionDate | date:\'MM/dd/yyyy\'}}</span></div></div><div class=row><div class=col-sm-12><div ng-if=\"transaction.typeAttributes.type === \'labor\'\"><strong>{{::transaction.typeAttributes.hours}}</strong> <strong><ng-pluralize count=transaction.typeAttributes.hours when=\"{\'1\': \'{{::&quot; general.abbreviations.hour&quot;  | translate}}\',\n                                                      \'other\': \'{{::&quot;general.abbreviations.hours&quot; | translate}}\'}\"></ng-pluralize></strong><strong ng-if=\"transaction.typeAttributes.laborType !== \'regular\'\">({{\'transactions.abbreviations.\' + transaction.typeAttributes.laborType | translate}})</strong> <strong has-permissions=Transactions-UpdateAny>{{::\'general.at\' | translate}} {{transaction.typeAttributes.rate * transaction.typeAttributes.multiplier | currency}}/{{::\'general.abbreviations.hour\' | translate}}</strong></div><div ng-if=\"transaction.typeAttributes.type !== \'labor\'\"><strong>{{::transaction.description}}</strong></div><div><span ng-if=transaction.typeAttributes.supplierName>{{::transaction.typeAttributes.supplierName}} | </span><span ng-if=transaction.typeAttributes.user>{{::transaction.typeAttributes.user.firstName}} {{::transaction.typeAttributes.user.lastName}}</span> <span ng-if=transaction.typeAttributes.serviceType>{{(transaction.typeAttributes.serviceType | serviceTypeFilter)}}</span></div></div></div></div><div class=col-xs-3><div class=row><div class=col-sm-12><strong ng-if=\"transaction.typeAttributes.cost !== undefined\">{{::transaction.typeAttributes.cost | currency}}</strong> <span class=pull-right ng-if=\"transaction.typeAttributes.cost === undefined\">- - -</span></div></div><div class=row><div class=col-sm-12><span class=text-capitalize>{{::transaction.typeAttributes.type}}</span></div></div></div></div></div></div></div><sliding-panel titles=transactions.panelObject.titles button-functions=transactions.panelObject.buttonFunctions cancel-button=!transactions.panelObject.readOnly show-navigation-warning=true save-attempt=transactions.panelObject.saveAttempt open-when=transactions.panelObject.open><panel-body><transactions-panel template-url={{::transactions.panelObject.template}} save-attempt=transactions.panelObject.saveAttempt transaction=transactions.panelObject.transaction></transactions-panel></panel-body></sliding-panel></div>");
$templateCache.put("app/components/workTypeList/workTypeList.html","<div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile = true;\"><div class=col-sm-9><div class=pull-left><h4>{{::\'workTypeList.title\' | translate}}<results-message total=workTypeList.totalCount class=hidden-xs></results-message></h4></div><div class=\"pull-right top-action-row hidden-print\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideFiltersMobile = !hideFiltersMobile\"><i class=\"fa fa-filter\" ng-class=\"{\'filter-applied\': workTypeList.isFilterApplied()}\" aria-hidden=true></i></button> <button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button ng-click=workTypeList.openPanel() aria-label=\"{{::\'workTypeList.create\' | translate}}\" class=\"btn btn-primary btn\"><i class=\"fa fa-plus visible-xs-inline-block\" aria-hidden=true></i> <span class=hidden-xs>{{::\'general.actions.new\' | translate}}</span></button></div></div></div><div class=main-container><div class=row><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=sort-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"workTypeList.sort(\'Name\')\"><strong>{{::\'workTypeList.name\' | translate}}<sort-icon property=workTypeList.sortable.Name></sort-icon></strong></li></ul></div></div><div class=\"row sort\"><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"workTypeList.sort(\'Parent/Name\')\"><strong>{{::\'workTypeList.category\' | translate}}<sort-icon property=\"workTypeList.sortable[\'Parent/Name\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><filter-panel name=\"\'workTypeListFilterForm\'\" filters=workTypeList.filters clear-filters=workTypeList.clearFilters()><filter-search filter=workTypeList.filters.q></filter-search></filter-panel><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><div class=list-body><div class=\"col-sm-pull-3 col-sm-9 content-body content-section\"><div class=\"row hidden-xs grid-header\"><div class=col-sm-5><strong class=cursor-pointer ng-click=\"workTypeList.sort(\'Name\')\">{{::\'workTypeList.name\' | translate}}<sort-icon property=workTypeList.sortable.Name></sort-icon></strong></div><div class=col-sm-5><strong class=cursor-pointer ng-click=\"workTypeList.sort(\'Parent/Name\')\">{{::\'workTypeList.category\' | translate}}<sort-icon property=\"workTypeList.sortable[\'Parent/Name\']\"></sort-icon></strong></div></div><div class=\"row visible-xs grid-header\"><div class=col-xs-5><strong>{{::\'workTypeList.name\' | translate}}</strong></div><div class=col-xs-5><strong>{{::\'workTypeList.category\' | translate}}</strong></div></div><div class=\"col-sm-12 no-results\" ng-if=\"workTypeList.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-repeat=\"workType in workTypeList.listData\" ng-click=workTypeList.openPanel(workType)><div class=col-xs-5><div>{{::workType.name}}</div></div><div class=col-xs-5><div>{{::workType.parent.name}}</div></div><div class=col-xs-2><div class=\"label label-warning\" ng-if=::!workType.isActive>{{::\'workTypeList.inactive\' | translate}}</div></div></div><div class=row><div class=col-sm-12 ng-hide=\"workTypeList.totalCount <= workTypeList.filters.pageSize\"><ul uib-pagination total-items=workTypeList.totalCount ng-model=workTypeList.filters.page ng-change=workTypeList.pageChanged() items-per-page=workTypeList.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div><work-type-form panel-open=workTypeList.panelOpen work-type=workTypeList.workType updated=workTypeList.updated></work-type-form>");
$templateCache.put("app/components/workTypeReport/workTypeReportChart.html","<div><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-link hidden-xs\" ng-click=workTypeReport.printCharts()>{{::\'general.print\' | translate}}</button> <button class=\"btn btn-default\" ng-click=workTypeReport.listRoute() aria-label=\"{{::\'workTypeReports.listRoute\' | translate}}\"><i class=\"fa fa-list\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 filter-body content-section\" ng-class=\"{\'hidden-xs\':hideFiltersMobile}\"><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideFiltersMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=workTypeReport.clearFilters() toggle-filters=workTypeReport.workTypeReportFilter() set-function=\"workTypeReport.setFilters(value, save)\" filters=workTypeReport.filters disable-my-filters=false></filter-bar><div class=row><div class=list-body><div class=\"col-sm-12 content-body content-section\"><report-navigation filters=workTypeReport.filters></report-navigation><div class=\"border-bottom work-order-chart chart-wrapper interactive-chart\"><charting chart-data=workTypeReport.workOrderChartData chart-labels=workTypeReport.workOrderLabels chart-type=\"\'bar\'\" click-function=workTypeReport.clickFunctionObject></charting></div><div class=\"border-bottom cost-chart chart-wrapper\"><charting chart-data=workTypeReport.costChartData chart-labels=workTypeReport.costLabels chart-type=\"\'stacked-bar\'\" chart-legend=workTypeReport.costLegend></charting></div><div class=\"labor-hours-chart chart-wrapper\"><charting chart-data=workTypeReport.laborChartData chart-labels=workTypeReport.laborHoursLabels chart-type=\"\'bar\'\"></charting></div></div></div></div></div><report-filters filters=workTypeReport.filters set-function=\"workTypeReport.setFilters(value, save)\" open-when=workTypeReport.openWhen clear-function=workTypeReport.clearFilters(removeMyFilter)></report-filters></div>");
$templateCache.put("app/components/workTypeReport/workTypeReportList.html","<div class=report-list><div class=\"row header-container\" ng-init=\"hideFiltersMobile = true; hideSortMobile=true;\"><div class=col-sm-12><div class=pull-left><h4>{{::\'reports.title\' | translate}}</h4></div><div class=\"pull-right top-action-row\"><button class=\"btn btn-default visible-xs-inline-block\" ng-click=\"hideSortMobile = !hideSortMobile\"><i class=\"fa fa-sort\" aria-hidden=true></i></button> <button class=\"btn btn-link hidden-xs\" ng-if=workTypeReport.filterState.totalCount ng-click=workTypeReport.export()>{{::\'workTypeReports.export\' | translate}}</button> <button class=\"btn btn-default\" ng-click=workTypeReport.chartRoute() aria-label=\"{{::\'workTypeReports.chartRoute\' | translate}}\"><i class=\"fa fa-bar-chart\" aria-hidden=true></i></button></div></div></div><div class=main-container><div class=\"col-sm-push-9 col-sm-3 sort-body content-section hidden-sm hidden-md hidden-lg\" ng-class=\"{\'hidden-xs\':hideSortMobile}\"><div class=filter-header><div class=pull-left><h6>{{::\'general.sort\' | translate}}</h6></div></div><div class=clearfix></div><div class=row><div class=col-xs-12><ul class=list-unstyled><li class=cursor-pointer ng-click=\"workTypeReport.sort(\'WorkType/Name\')\"><strong>{{::\'workTypeReports.title\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'WorkType/Name\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"workTypeReport.sort(\'Count/WorkOrders\')\"><strong>{{::\'reports.count\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Count/WorkOrders\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"workTypeReport.sort(\'Count/LaborHours\')\"><strong>{{::\'general.hours\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Count/LaborHours\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"workTypeReport.sort(\'Cost/Labor\')\"><strong>{{::\'reports.byCost.labor\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Cost/Labor\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"workTypeReport.sort(\'Cost/Purchase\')\"><strong>{{::\'reports.byCost.purchase\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Cost/Purchase\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Cost/Service\')\"><strong>{{::\'reports.byCost.service\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Cost/Service\']\"></sort-icon></strong></li><li class=cursor-pointer ng-click=\"purposeReport.sort(\'Cost/Total\')\"><strong>{{::\'general.total\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Cost/Total\']\"></sort-icon></strong></li></ul></div></div><div class=\"pull-right visible-xs\"><button type=button class=\"btn btn-link\" ng-click=\"hideSortMobile = true\">{{::\'general.close\' | translate}}</button></div><div class=clearfix></div></div><filter-bar clear-function=workTypeReport.clearFilters() toggle-filters=workTypeReport.workTypeReportFilter() set-function=\"workTypeReport.setFilters(value, save)\" filters=workTypeReport.filters disable-my-filters=false></filter-bar><div class=row><div class=list-body><div class=\"col-sm-12 content-body content-section\"><report-navigation filters=workTypeReport.filters></report-navigation><report-list-totals ng-if=\"workTypeReport.listData.length !== 0 && workTypeReport.filters.returnAverages !== \'true\'\" data=workTypeReport.totalListData></report-list-totals><div class=\"row hidden-xs grid-header\"><div class=col-sm-2><strong class=cursor-pointer ng-click=\"workTypeReport.sort(\'WorkType/Name\')\">{{::\'workTypeReports.title\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'WorkType/Name\']\"></sort-icon></strong></div><div class=col-sm-10><div class=row><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"workTypeReport.sort(\'Count/WorkOrders\')\">{{::\'reports.count\' | translate}}<sort-icon property=\"workTypeReport.sortable[\'Count/WorkOrders\']\"></sort-icon></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"workTypeReport.sort(\'Count/LaborHours\')\"><div ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'general.hours\' | translate}}<sort-icon class=sort-icon-align property=\"workTypeReport.sortable[\'Count/LaborHours\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"workTypeReport.sort(\'Cost/Labor\')\"><div ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'reports.byCost.labor\' | translate}}<sort-icon class=sort-icon-align property=\"workTypeReport.sortable[\'Cost/Labor\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"workTypeReport.sort(\'Cost/Purchase\')\"><div ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'reports.byCost.purchase\' | translate}}<sort-icon class=sort-icon-align property=\"workTypeReport.sortable[\'Cost/Purchase\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"workTypeReport.sort(\'Cost/Service\')\"><div ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}</div><div ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}</div><div class=column-header>{{::\'reports.byCost.service\' | translate}}<sort-icon class=sort-icon-align property=\"workTypeReport.sortable[\'Cost/Service\']\"></sort-icon></div></strong></div><div class=col-sm-2><strong class=\"pull-right cursor-pointer\" ng-click=\"workTypeReport.sort(\'Cost/Total\')\"><div ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}}<sort-icon class=sort-icon-align property=\"workTypeReport.sortable[\'Cost/Total\']\"></sort-icon><div class=column-header>{{::\'reports.byCost.cost\' | translate}}</div></div><div ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}}<div class=column-header>{{::\'general.total\' | translate}} {{::\'reports.byCost.cost\' | translate}}<sort-icon class=sort-icon-align property=\"workTypeReport.sortable[\'Cost/Total\']\"></sort-icon></div></div></strong></div></div></div></div><div class=\"col-sm-12 no-results\" ng-if=\"workTypeReport.listData.length === 0\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div><div class=\"row grid-row cursor-pointer\" ng-repeat=\"value in workTypeReport.listData\" ng-click=workTypeReport.viewWorkOrders(value.workType.id)><div class=\"col-sm-2 truncate\"><span class=hidden-xs>{{::value.workType.name}}</span> <span class=\"visible-xs text-medium-weight\">{{::value.workType.name}}</span></div><div class=\"col-sm-10 hidden-xs\"><div class=row><div class=\"col-sm-2 hidden-xs\"><span class=pull-right>{{::value.count.workOrders | number}}</span></div><div class=\"col-sm-2 hidden-xs\"><span class=pull-right>{{::value.count.laborHours| number:2}}</span></div><div class=\"col-sm-2 hidden-xs\"><span class=pull-right>{{::value.cost.labor | currency}}</span></div><div class=\"col-sm-2 hidden-xs\"><span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.service | currency}}</span></div><div class=\"col-sm-2 hidden-xs\"><span class=pull-right>{{::value.cost.total | currency}}</span></div></div></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <span class=pull-right><strong>{{::value.count.workOrders | number}}</strong></span></div><div><span>{{::\'reports.byLaborHours.hours\' | translate}}</span> <span class=pull-right><strong>{{::value.count.laborHours | number:2}}</strong></span></div></div><div class=\"col-xs-6 visible-xs\"><div><span ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} {{::\'general.total\' | translate}} </span><span>{{::\'reports.byCost.cost\' | translate}}</span> <span class=pull-right><strong>{{::value.cost.total | currency}}</strong></span></div><div><span ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'reports.byCost.labor\' | translate}}</span> <span class=pull-right>{{::value.cost.labor | currency}}</span></div><div><span ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'reports.byCost.purchase\' | translate}}</span> <span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div><span ng-if=\"workTypeReport.filters.returnAverages !== \'true\'\">{{::\'general.total\' | translate}} </span><span ng-if=\"workTypeReport.filters.returnAverages === \'true\'\">{{::\'reports.avg\' | translate}} </span><span>{{::\'reports.byCost.service\' | translate}}</span> <span class=pull-right>{{::value.cost.service | currency}}</span></div></div><div class=row><div class=col-sm-12 ng-if=\"workTypeReport.totalCount > workTypeReport.filters.pageSize\"><ul uib-pagination total-items=workTypeReport.totalCount ng-model=workTypeReport.filters.page ng-change=workTypeReport.pageChanged() items-per-page=workTypeReport.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" bondary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div></div></div><report-filters filters=workTypeReport.filters set-function=\"workTypeReport.setFilters(value, save)\" open-when=workTypeReport.openWhen clear-function=workTypeReport.clearFilters(removeMyFilter)></report-filters>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-boolean/asset-attribute-boolean.html","<div><div ng-class=\"{\'col-xs-6 col-sm-4\': attributeType.quantityType.quantity !== \'unitless\', \'col-xs-12 col-sm-6\': attributeType.quantityType.quantity === \'unitless\'}\"><div class=form-group><label for={{::attributeType.key}}>{{::attributeType._translatedKey}}</label><div class=checkbox><label><input id={{attributeType.key}} type=checkbox ng-model=assetAttribute.value ng-disabled=!attributeType.isActive> {{checkboxLabel}}</label></div></div></div><!-- All asset attributes require a unit of measure. This will not render the directive; however, it will set the unit of measure to unitless --><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{country}} is-active=attributeType.isActive></units-of-measure></div>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-databound-manufacturer/asset-attribute-databound-manufacturer.html","<span><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for={{::attributeType.key}}>{{::attributeType._translatedKey}}</label><manufacturer-typeahead ng-model=assetAttribute.value allow-creation=true allow-creation-return-object=true is-asset-attribute=true></manufacturer-typeahead></div></div><!-- All asset attributes require a unit of measure. This will not render the directive; however, it will set the unit of measure to unitless --><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{::country}} is-active=attributeType.isActive></units-of-measure></span>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-date/asset-attribute-date.html","<span><div ng-class=\"{\'col-xs-6 col-sm-4\': attributeType.quantityType.quantity !== \'unitless\', \'col-xs-12 col-sm-6\': attributeType.quantityType.quantity === \'unitless\'}\"><div class=form-group><label for={{::attributeType.key}}>{{::attributeType._translatedKey}}</label><calendar ng-model=assetAttribute.value></calendar></div></div><!-- All asset attributes require a unit of measure. This will not render the directive; however, it will set the unit of measure to unitless --><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{country}} is-active=attributeType.isActive></units-of-measure></span>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-double/asset-attribute-double.html","<div><div ng-class=\"{\'col-xs-6 col-sm-4\': attributeType.quantityType.quantity !== \'unitless\', \'col-xs-12 col-sm-6\': attributeType.quantityType.quantity === \'unitless\'}\"><div class=form-group><label for={{::attributeType.key}}>{{::attributeType._translatedKey}}</label><input id={{::attributeType.key}} type=text class=form-control maxlength={{attributeType.fieldLength}} ng-model=assetAttribute.value ng-disabled=!attributeType.isActive></div></div><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{country}} is-active=attributeType.isActive></units-of-measure></div>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-integer/asset-attribute-integer.html","<div><div ng-class=\"{\'col-xs-6 col-sm-4\': attributeType.quantityType.quantity !== \'unitless\', \'col-xs-12 col-sm-6\': attributeType.quantityType.quantity === \'unitless\'}\"><div class=form-group><label for={{::attributeType.key}}>{{attributeType._translatedKey}}</label><input id={{::attributeType.key}} type=text class=form-control maxlength={{attributeType.fieldLength}} ng-model=assetAttribute.value ng-disabled=!attributeType.isActive></div></div><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{country}} is-active=attributeType.isActive></units-of-measure></div>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-money/asset-attribute-money.html","<div><div ng-class=\"{\'col-xs-6 col-sm-4\': attributeType.quantityType.quantity !== \'unitless\', \'col-xs-12 col-sm-6\': attributeType.quantityType.quantity === \'unitless\'}\"><ng-form name=money><div class=form-group ng-class=\"{\'has-error\': money.input.$invalid && money.input.$touched}\"><label for={{::attributeType.key}}>{{::attributeType._translatedKey}}</label><input id={{::attributeType.key}} name=input class=form-control ng-model=assetAttribute.value type=text min=0 max=999999999999999 ng-disabled=!attributeType.isActive force-decimal-precision min-validator max-validator number-validator><p class=text-danger ng-messages=money.input.$error ng-if=money.input.$touched><span ng-message=validNumber>{{::attributeType._translatedKey}} {{::\'assetForm.validation.money.number\' | translate }} </span><span ng-message=maxNumber>{{::attributeType._translatedKey}} {{::\'assetForm.validation.money.max\' | translate }} </span><span ng-message=minNumber>{{::attributeType._translatedKey}} {{::\'assetForm.validation.money.min\' | translate }}</span></p></div></ng-form></div><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{country}} is-active=attributeType.isActive></units-of-measure></div>");
$templateCache.put("app/components/assetAttributeEngine/asset-attribute-string/asset-attribute-string.html","<div><div ng-class=\"{\'col-xs-6 col-sm-4\': attributeType.quantityType.quantity !== \'unitless\', \'col-xs-12 col-sm-6\': attributeType.quantityType.quantity === \'unitless\'}\"><div class=form-group><label for={{::attributeType.key}}>{{attributeType._translatedKey}}</label><input id={{::attributeType.key}} ng-if=!hasAttributeTypeCodes type=text class=form-control maxlength={{attributeType.fieldLength}} ng-model=assetAttribute.value ng-disabled=!attributeType.isActive><select id={{::attributeType.key}} ng-if=hasAttributeTypeCodes name=businessAssetAttributeTypeCode class=form-control ng-model=assetAttribute.value ng-disabled=!attributeType.isActive ng-options=\"::attributeTypeCode.keyCode as \'assetForm.attributeTypeCodes.\' + attributeTypeCode.keyCode | translate\n                   for attributeTypeCode in ::attributeType.businessAssetAttributeTypeCodes\"><option value=\"\">{{nullOptionText}}</option></select></div></div><units-of-measure quantity=attributeType.quantityType unit-of-measure=assetAttribute.unitOfMeasure country={{country}} is-active=attributeType.isActive></units-of-measure></div>");
$templateCache.put("app/components/assetAttributeEngine/asset-usage/asset-usage.html","<div class=asset-usage><div ng-if=assetUsage.assetAttribute.isMetered><div class=row ng-if=assetUsage.isDisplay><units-of-measure id=assetUsageMeasure name=metered quantity=assetUsage.assetAttribute.businessAssetAttributeType.quantityType unit-of-measure=assetUsage.assetAttribute.unitOfMeasure country={{country}} is-active=true label=\"{{::\'assetUsage.setupUnit\' | translate}}\" allow-blank=true ng-required=true save-attempt=assetUsage.saveAttempt></units-of-measure></div><div class=row><div class=\"col-xs-10 col-sm-4\"><ng-form name=assetUsageForm><div ng-class=\"{\'has-error\': assetUsage.shouldValidate && assetUsageForm.meterReading.$invalid}\"><label for=meterReading ng-if=\"assetUsage.showTitle && assetUsage.assetAttribute.id\">{{::\'assetUsage.reading\' | translate}}</label><label for=meterReading ng-if=\"assetUsage.showTitle && !assetUsage.assetAttribute.id\">{{::\'assetUsage.newReading\' | translate}}</label><input id=meterReading name=meterReading ng-required=assetUsage.shouldValidate type=text class=form-control maxlength={{::assetUsage.assetAttribute.businessAssetAttributeType.fieldLength}} ng-model=assetUsage.assetAttribute.value></div></ng-form></div><div class=\"col-xs-2 col-sm-2 meter-label\"><label for=meterReadingUnitLabel ng-if=assetUsage.showTitle>&nbsp;</label><div id=meterReadingUnitLabel>{{assetUsage.uom}}</div></div></div><div class=row ng-if=assetUsage.hasTransactions()><div class=col-xs-12><strong class=\"font-secondary font-size-sm\">{{::\'assetUsage.lastReading\' | translate}}: {{::assetUsage.transactions[0].reading | number}} {{::assetUsage.uom | lowercase}}</strong></div></div></div><div ng-if=!assetUsage.assetAttribute.isMetered><div class=list-body><div class=\"row grid-header\"><div class=col-xs-4><strong>{{::\'assetUsage.lastReading\' | translate}}</strong></div><div class=\"col-xs-4 text-center\"><strong>{{::\'assetUsage.list.recordedDate\' | translate}}</strong></div><div class=\"col-xs-4 text-right\"><strong>{{::\'assetUsage.list.readingType\' | translate}}</strong></div></div><div class=\"row grid-row grid-row-unclickable\" ng-repeat=\"transaction in assetUsage.transactions track by transaction.id\"><div class=col-xs-4>{{::transaction.reading}}</div><div class=\"col-xs-4 text-center\">{{::transaction.createdDateTime | date:\'short\'}}</div><div class=\"col-xs-4 text-right\">{{::assetUsage.uom}}</div></div></div></div><div class=\"row metering-actions reading-actions\" ng-if=!assetUsage.disableActions><div class=col-xs-12><button type=button class=\"btn btn-link\" ng-click=assetUsage.cancel() ng-if=!assetUsage.hasTransactions()>{{\'general.actions.cancel\' | translate}}</button> <button type=button class=\"btn btn-link\" ng-click=assetUsage.stopTracking() ng-disabled=assetUsage.isMakingApiCall ng-if=\"assetUsage.hasTransactions() && assetUsage.assetAttribute.isMetered\">{{\'assetUsage.stopTracking\' | translate}}</button> <button type=button class=\"btn btn-link\" ng-click=assetUsage.resumeTracking() ng-if=\"assetUsage.hasTransactions() && !assetUsage.assetAttribute.isMetered\">{{\'assetUsage.resumeTracking\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/assetAttributeEngine/asset-usage/assetStopTrackingWarningModal.html","<div class=modal-header><h4 class=title>{{::\'assetUsage.stopTrackingModal.title\' | translate}}</h4></div><div class=modal-body><div class=error-container><p>{{::\'assetUsage.stopTrackingModal.cannotStopTrackingMessage\' | translate}}</p><p>{{::\'assetUsage.stopTrackingModal.removeMessage\' | translate}}</p><p><a ui-sref=secure.pmScheduleList(assetStopTrackingModal.pmScheduleFilter) ng-click=assetStopTrackingModal.close()>{{::\'assetUsage.stopTrackingModal.viewPmSchedules\' | translate}}</a></p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=assetStopTrackingModal.close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/assetReport/assetReportDrillDown/reportDrillDownChart.html","<div class=\"border-bottom chart-wrapper interactive-chart\" ng-class=reportDrillDownChart.chartClass><charting chart-data=reportDrillDownChart.chartData chart-labels=reportDrillDownChart.chartLabels chart-type=reportDrillDownChart.chartDisplayType chart-legend=reportDrillDownChart.costLegend click-function=reportDrillDownChart.clickFunctionObject></charting></div><div><pop-box id={{reportDrillDownChart.id}} name={{reportDrillDownChart.drillDownPopBox}} show-arrow=true backdrop-close=false open-on-init=false close-fn=reportDrillDownChart.clearSelection() button-close=true><div class=row><div class=\"col-xs-12 col-sm-6\"><h6><strong>{{reportDrillDownChart.activeAsset.name}}</strong></h6></div></div><div ng-if=\"reportDrillDownChart.chartType === reportDrillDownChart.chartCategories.cost\" class=\"interactive-chart cost-drill-down-chart chart-wrapper drill-down-chart\"><charting chart-data=reportDrillDownChart.drillDownCostChartData chart-labels=reportDrillDownChart.drillDownChartLabels chart-type=\"\'horizontal-stacked-bar\'\" chart-legend=reportDrillDownChart.costLegend click-function=reportDrillDownChart.subChartClickObject is-drill-down=true></charting></div><div ng-if=\"reportDrillDownChart.chartType !== reportDrillDownChart.chartCategories.cost\" ng-class=reportDrillDownChart.drillDownChartClass class=\"interactive-chart work-order-chart chart-wrapper drill-down-chart\"><charting chart-data=reportDrillDownChart.drillDownChartData chart-labels=reportDrillDownChart.drillDownChartLabels chart-type=\"\'horizontal-bar\'\" chart-legend=reportDrillDownChart.costLegend click-function=reportDrillDownChart.subChartClickObject is-drill-down=true></charting></div><div ng-if=\"reportDrillDownChart.chartType === reportDrillDownChart.chartCategories.workOrder\" class=drill-down-footer><hr><div><a class=\"cursor-pointer chart-title-link\" ui-sref=secure.workOrderList(reportDrillDownChart.activeAsset.filters)>{{reportDrillDownChart.activeAsset.value}}<ng-pluralize count=reportDrillDownChart.activeAsset.value when=\"{\'1\': \' {{::&quot;assetReport.totalWorkOrder&quot; | translate}}\',\n                                       \'other\': \' {{::&quot;assetReport.totalWorkOrders&quot; | translate}}\' }\"></ng-pluralize></a></div></div></pop-box></div>");
$templateCache.put("app/components/assetReport/assetReportDrilldownList/assetReportDrilldownList.html","<div ng-repeat=\"value in drilldownList.listData\"><div class=\"row grid-row grid-row-unclickable\"><div class=\"col-xs-12 drill-down-chevron\" ng-class=\"{\'chevron-open\': value.showSubList}\"><div class=\"row cursor-pointer drill-down-row\" ng-click=drilldownList.viewDetails(value)><div class=\"col-sm-2 truncate drill-down-mobile-top-row\"><span class=drill-down-first-column><span class=hidden-xs>{{::value.asset.value}}</span> <span class=\"visible-xs text-medium-weight\">{{::value.asset.value}}</span></span></div><div class=\"col-sm-10 hidden-xs\"><div class=row><div class=col-sm-2><span class=pull-right>{{::value.count.workOrders | number}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.count.laborHours| number:2}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.labor | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.service | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::value.cost.total | currency}}</span></div></div></div><div class=col-xs-12><bread-crumbs ng-if=\"value.asset.ancestorIdPath !== \'\'\" no-links=true asset=value.asset></bread-crumbs></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <span class=pull-right>{{::value.count.workOrders | number}}</span></div><div><span>{{::\'reports.byLaborHours.hours\' | translate}}</span> <span class=pull-right>{{::value.count.laborHours | number:2}}</span></div></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'general.total\' | translate}}</span> <span class=pull-right>{{::value.cost.total | currency}}</span></div><div><span>{{::\'reports.byCost.labor\' | translate}}</span> <span class=pull-right>{{::value.cost.labor | currency}}</span></div><div><span>{{::\'reports.byCost.purchase\' | translate}}</span> <span class=pull-right>{{::value.cost.purchase | currency}}</span></div><div><span>{{::\'reports.byCost.service\' | translate}}</span> <span class=pull-right>{{::value.cost.service | currency}}</span></div></div></div></div><div class=col-xs-12><div class=row><div uib-collapse=!value.showSubList class=drill-down-sub-list><div class=col-xs-12><div class=\"row grid-header\"><div class=col-sm-3><strong>{{drilldownList.subListTitle}}</strong></div><div class=\"col-sm-9 hidden-xs\"><div class=row><div class=col-sm-2><strong class=pull-right>{{::\'reports.count\' | translate}}</strong></div><div class=col-sm-2><strong class=pull-right>{{::\'general.hours\' | translate}}</strong></div><div class=col-sm-2><strong class=pull-right>{{::\'reports.byCost.labor\' | translate}}</strong></div><div class=col-sm-2><strong class=pull-right>{{::\'reports.byCost.purchase\' | translate}}</strong></div><div class=col-sm-2><strong class=pull-right>{{::\'reports.byCost.service\' | translate}}</strong></div><div class=col-sm-2><strong class=pull-right>{{::\'reports.byCost.cost\' | translate}}</strong></div></div></div></div><div class=\"row sub-list-wrapper\"><div class=col-xs-12><div class=\"row grid-row\" ng-repeat=\"summary in value.subList\" ng-click=\"$event.stopPropagation(); drilldownList.viewDrilldownWorkOrders(summary.workType.id, value.asset.id)\"><div class=\"col-sm-3 truncate sub-list-mobile-title\"><span class=hidden-xs>{{::summary.workType.name}}</span> <span class=\"visible-xs text-medium-weight\">{{::summary.workType.name}}</span></div><div class=\"col-sm-9 hidden-xs\"><div class=row><div class=col-sm-2><span class=pull-right>{{::summary.count.workOrders | number}}</span></div><div class=col-sm-2><span class=pull-right>{{::summary.count.laborHours| number:2}}</span></div><div class=col-sm-2><span class=pull-right>{{::summary.cost.labor | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::summary.cost.purchase | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::summary.cost.service | currency}}</span></div><div class=col-sm-2><span class=pull-right>{{::summary.cost.total | currency}}</span></div></div></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'reports.byWorkOrders.workOrders\' | translate}}</span> <span class=pull-right>{{::summary.count.workOrders | number}}</span></div><div><span>{{::\'reports.byLaborHours.hours\' | translate}}</span> <span class=pull-right>{{::summary.count.laborHours | number:2}}</span></div></div><div class=\"col-xs-6 visible-xs\"><div><span>{{::\'general.total\' | translate}}</span> <span class=pull-right>{{::summary.cost.total | currency}}</span></div><div><span>{{::\'reports.byCost.labor\' | translate}}</span> <span class=pull-right>{{::summary.cost.labor | currency}}</span></div><div><span>{{::\'reports.byCost.purchase\' | translate}}</span> <span class=pull-right>{{::summary.cost.purchase | currency}}</span></div><div><span>{{::\'reports.byCost.service\' | translate}}</span> <span class=pull-right>{{::summary.cost.service | currency}}</span></div></div></div></div></div><div class=\"row grid-footer\"><div class=col-xs-12><a ui-sref=\"secure.workOrderList({businessAsset: value.asset.id,\n                                                  status: drilldownList.filters.status,\n                                                  completionDateFrom: drilldownList.filters.completionDateFrom,\n                                                  completionDateTo: drilldownList.filters.completionDateTo,\n                                                  requestDateFrom: drilldownList.filters.requestDateFrom,\n                                                  requestDateTo: drilldownList.filters.requestDateTo,\n                                                  workType: drilldownList.filters.workType,\n                                                  purpose: drilldownList.filters.purpose,\n                                                  includeDescendants: drilldownList.filters.assetRollUp})\" ng-if=value.subList>{{::value.count.workOrders}} {{::\'general.total\' | translate}}<ng-pluralize count=value.count.workOrders when=\"{\'1\': \' {{::&quot;reports.byWorkOrders.workOrder&quot; | translate}}\',\n                                                           \'other\': \' {{::&quot;reports.byWorkOrders.workOrders&quot; | translate}}\' }\"></ng-pluralize></a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/dashboard/k12Admin/k12AdminDashboard.html","<div class=\"main-container dashboard\"><div class=content-section><form name=form novalidate><div class=row><div class=\"col-sm-3 dashboard-col assigned-to-me\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.assignedToMe\' | translate}}\" query-params=k12AdminDashboard.queries.assignedToMe></dashboard-card></div><div class=\"col-sm-3 dashboard-col unassigned\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.unassigned\' | translate}}\" query-params=k12AdminDashboard.queries.unassigned></dashboard-card></div><div class=\"col-sm-3 dashboard-col due-next-seven-days\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.dueNextSevenDays\' | translate}}\" query-params=k12AdminDashboard.queries.dueNextSevenDays sub-entity=WorkOrderEntity sub-query-params=k12AdminDashboard.queries.overdue sub-text=\"{{::\'dashboard.overdue\' | translate}}\" mobile-sub-text=\"{{::\'dashboard.overdue\' | translate}}\"></dashboard-card></div><div class=\"col-sm-3 dashboard-col emergencies-unassigned\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.emergencies\' | translate}}\" query-params=k12AdminDashboard.queries.emergencies sub-entity=WorkOrderEntity sub-query-params=k12AdminDashboard.queries.emergenciesUnassigned sub-text=\"{{::\'dashboard.unassigned\' | translate}}\" mobile-sub-text=\"{{::\'dashboard.emergenciesUnassigned\' | translate}}\" is-danger=true></dashboard-card></div></div></form></div><div class=container-section><div class=row><div class=\"col-sm-6 sub-section-col\"><div class=\"dashboard-widget sub-section location-and-work-type-chart\"><div class=\"row sub-grid-header\"><div class=\"col-xs-12 header-text\"><h6 class=\"heading dashboard-card-title\"><strong>{{::\'dashboard.byLocationAndWorkType\' | translate}}</strong> <span ng-if=k12AdminDashboard.moreThanFive>({{::\'dashboard.topFive\' | translate}})</span></h6></div></div><div class=row ng-if=\"k12AdminDashboard.assetReports.length === 0\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><div class=row ng-if=\"k12AdminDashboard.assetReports.length > 0\"><div class=\"accordion-chart col-xs-12\"><uib-accordion><div uib-accordion-group is-open=businessAsset.isOpen ng-repeat=\"assetReport in k12AdminDashboard.assetReports track by assetReport.asset.id\" ng-if=k12AdminDashboard.workTypeChartData[assetReport.asset.id]><uib-accordion-heading><span class=pull-left>{{::assetReport.asset.value}}</span> <span class=\"pull-right count\">{{::k12AdminDashboard.assetTotals[assetReport.asset.id]}}</span></uib-accordion-heading><div class=\"location-and-work-type-chart chart-wrapper interactive-chart\"><mobile-bar-chart chart-data=k12AdminDashboard.workTypeChartData[assetReport.asset.id] chart-type=\"\'bar-dashboard\'\" percent-modifier=85 click-function=k12AdminDashboard.workTypeClickFunctions[assetReport.asset.id]></mobile-bar-chart></div></div></uib-accordion></div></div></div></div><div class=\"col-sm-6 sub-section-col\"><div class=\"dashboard-widget sub-section status-chart\"><div class=\"row sub-grid-header\"><div class=\"col-xs-12 header-text\"><h5 class=\"heading dashboard-card-title\"><strong>{{::\'dashboard.byStatus\' | translate}}</strong></h5></div></div><div class=row ng-if=\"k12AdminDashboard.statusChartData.dataArray.length === 1\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><div class=\"work-order-chart chart-wrapper interactive-chart\" ng-if=\"k12AdminDashboard.chartData.dataArray.length > 1\"><charting chart-data=k12AdminDashboard.chartData chart-options=k12AdminDashboard.chartOptions click-function=k12AdminDashboard.clickFunction chart-type=\"\'pie-hole\'\" chart-legend=k12AdminDashboard.chartLegend></charting></div><div class=\"pie-chart-total cursor-pointer font-primary\"><span class=\"pie-chart-total-message empty-message\" ng-if=\"k12AdminDashboard.totalWorkOrders == 0\">{{::\'dashboard.noWorkOrders\' | translate}} </span><span class=pie-chart-total-message ng-if=\"k12AdminDashboard.totalWorkOrders > 0\" ng-click=k12AdminDashboard.goToTotal()><span>{{::\'general.total\' | translate}}: {{::k12AdminDashboard.totalWorkOrders}}</span></span></div><div class=pie-chart-legend><p ng-click=k12AdminDashboard.clickFunction.chartFunction(1)>{{ k12AdminDashboard.statusCounts[k12AdminDashboard.newRequests] }}</p><p ng-click=k12AdminDashboard.clickFunction.chartFunction(2)>{{ k12AdminDashboard.statusCounts[k12AdminDashboard.inProgress] }}</p><p ng-click=k12AdminDashboard.clickFunction.chartFunction(3)>{{ k12AdminDashboard.statusCounts[k12AdminDashboard.onHold] }}</p></div></div></div></div></div></div>");
$templateCache.put("app/components/dashboard/k12Tech/k12TechDashboard.html","<div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-sm-3 dashboard-col assigned-to-me\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.assignedToMe\' | translate}}\" query-params=k12TechDashboard.queries.assignedToMe sub-entity=WorkOrderEntity sub-query-params=k12TechDashboard.queries.allWorkOrders mobile-sub-text=\"{{::\'general.total\' | translate}}\" sub-text=\"{{::\'general.total\' | translate}}\"></dashboard-card></div><div class=\"col-sm-3 dashboard-col due-next-seven-days\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.dueNextSevenDays\' | translate}}\" query-params=k12TechDashboard.queries.dueNextSevenDays></dashboard-card></div><div class=\"col-sm-3 dashboard-col overdue\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.overdue\' | translate}}\" query-params=k12TechDashboard.queries.overdue is-danger=true></dashboard-card></div><div class=\"col-sm-3 dashboard-col emergencies-assigned-to-me\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.emergenciesAssignedToMe\' | translate}}\" query-params=k12TechDashboard.queries.emergenciesAssignedToMe sub-entity=WorkOrderEntity sub-query-params=k12TechDashboard.queries.emergenciesUnassigned sub-text=\"{{::\'dashboard.unassigned\' | translate}}\" mobile-sub-text=\"{{::\'dashboard.emergenciesUnassigned\' | translate}}\" is-danger=true></dashboard-card></div></div></form></div><div class=container-section><div class=row><div class=\"col-sm-6 sub-section-col\"><div class=\"dashboard-widget sub-section location-and-work-type-chart\"><div class=\"row sub-grid-header\"><div class=\"col-xs-12 header-text\"><h6 class=\"heading dashboard-card-title\"><strong>{{::\'dashboard.myByLocationAndWorkType\' | translate}}</strong> <span ng-if=k12TechDashboard.moreThanFive>({{::\'dashboard.topFive\' | translate}})</span></h6></div></div><div class=row ng-if=\"k12TechDashboard.assetReports.length === 0\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><div class=row ng-if=\"k12TechDashboard.assetReports.length > 0\"><div class=\"accordion-chart col-xs-12\"><uib-accordion><div uib-accordion-group is-open=businessAsset.isOpen ng-repeat=\"assetReport in k12TechDashboard.assetReports track by assetReport.asset.id\" ng-if=k12TechDashboard.workTypeChartData[assetReport.asset.id]><uib-accordion-heading><span class=pull-left>{{::assetReport.asset.value}}</span> <span class=\"pull-right count\">{{::k12TechDashboard.assetTotals[assetReport.asset.id]}}</span></uib-accordion-heading><div class=\"location-and-work-type-chart chart-wrapper interactive-chart\"><mobile-bar-chart chart-data=k12TechDashboard.workTypeChartData[assetReport.asset.id] chart-type=\"\'bar-dashboard\'\" percent-modifier=85 click-function=k12TechDashboard.workTypeClickFunctions[assetReport.asset.id]></mobile-bar-chart></div></div></uib-accordion></div></div></div></div><div class=\"col-sm-6 sub-section-col\"><div class=\"dashboard-widget sub-section purpose-chart\"><div class=\"row sub-grid-header\"><div class=\"col-xs-12 header-text\"><h6 class=\"heading dashboard-card-title\"><strong>{{::\'dashboard.myByPurpose\' | translate}}</strong> <span ng-if=\"k12TechDashboard.purposeChartData.dataArray.length > 5\">({{::\'dashboard.topFive\' | translate}})</span></h6></div></div><div class=row ng-if=\"k12TechDashboard.purposeChartData.dataArray.length === 1\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><div class=\"work-order-chart chart-wrapper interactive-chart\" ng-if=\"k12TechDashboard.purposeChartData.dataArray.length > 1\"><mobile-bar-chart chart-data=k12TechDashboard.purposeChartData chart-type=\"\'bar-dashboard\'\" click-function=k12TechDashboard.purposeFunctionObject></mobile-bar-chart></div></div></div></div></div></div>");
$templateCache.put("app/components/dashboard/mfgAdmin/mfgAdminDashboard.html","<div class=main-container><div class=content-section><form name=form novalidate><div class=row><div class=\"col-sm-3 dashboard-col new-request\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.newRequests\' | translate}}\" query-params=mfgAdminDashboard.queries.newRequest sub-entity=WorkOrderEntity sub-query-params=mfgAdminDashboard.queries.unassigned sub-text=\"{{::\'workOrderList.unassigned\' | translate}}\"></dashboard-card></div><div class=\"col-sm-3 dashboard-col assigned-to-me\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.assignedToMe\' | translate}}\" query-params=mfgAdminDashboard.queries.assignedToMe></dashboard-card></div><div class=\"col-sm-3 dashboard-col overdue\"><dashboard-card entity=WorkOrderEntity card-title=\"{{::\'dashboard.overdue\' | translate}}\" query-params=mfgAdminDashboard.queries.overdue is-danger=true></dashboard-card></div><div class=\"col-sm-3 dashboard-col completed-on-time\" ng-if=mfgAdminDashboard.completedChart><percent-dashboard-card card-title=\"{{::\'dashboard.completedOnTime\' | translate}}\" info-text=\"{{::\'dashboard.dueLastThirtyDays\' | translate}}\" card-data=mfgAdminDashboard.compliance></percent-dashboard-card></div><div class=\"col-sm-3 dashboard-col completed-on-time\" ng-if=!mfgAdminDashboard.completedChart><dashboard-card card-title=\"{{::\'dashboard.completedOnTime\' | translate}}\" result-text=\"{{::\'dashboard.noScheduledWork\' | translate}}\"></dashboard-card></div></div></form></div><div class=container-section><div class=row><div class=\"col-sm-6 sub-section-col\"><div class=\"dashboard-widget sub-section assignee-list\"><div class=\"row sub-grid-header\"><div class=\"col-xs-12 header-text\"><h6 class=heading><strong>{{::\'dashboard.openByAssignee\' | translate}}</strong> <span ng-if=\"mfgAdminDashboard.assigneesSummary.length > 6\">({{::\'dashboard.topSeven\' | translate}})</span></h6></div></div><div class=row ng-if=\"mfgAdminDashboard.assigneesSummary.length === 0\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><div class=\"row grid-row grid-row-last-no-border cursor-pointer\" ng-click=mfgAdminDashboard.assigneeListRoute(assignee.assignee.id) ng-repeat=\"assignee in mfgAdminDashboard.assigneesSummary | limitTo:7\"><div class=\"col-xs-7 truncate\">{{::assignee.assignee.firstName}} {{:: assignee.assignee.lastName}}</div><div class=col-xs-5><span>{{assignee.count.workOrders | number}}</span></div></div></div></div><div class=\"col-sm-6 sub-section-col\"><div class=\"dashboard-widget sub-section purpose-chart\"><div class=\"row sub-grid-header\"><div class=\"col-xs-12 header-text\"><h6 class=heading><strong>{{::\'dashboard.byPurpose\' | translate}}</strong> <span ng-if=\"mfgAdminDashboard.purposeChartData.dataArray.length > 5\">({{::\'dashboard.topFive\' | translate}})</span></h6></div></div><div class=row ng-if=\"mfgAdminDashboard.purposeChartData.dataArray.length === 1\"><div class=\"col-sm-12 no-results\"><h6><em class=text-muted>{{::\'general.noResults\' | translate}}</em></h6></div></div><div class=\"work-order-chart chart-wrapper interactive-chart\" ng-if=\"mfgAdminDashboard.purposeChartData.dataArray.length > 1\"><mobile-bar-chart chart-data=mfgAdminDashboard.purposeChartData chart-type=\"\'bar-dashboard\'\" click-function=mfgAdminDashboard.purposeFunctionObject></mobile-bar-chart></div><div class=\"row dashboard-widget-footer\"><div class=\"col-xs-12 text-right\">{{\'dashboard.requestedLastThirtyDays\' | translate}}</div></div></div></div></div></div></div>");
$templateCache.put("app/components/filter-bar/filter-actions-button/filter-actions-button.html","<div class=dropdown uib-dropdown><button class=\"btn btn-default btn-sm dropdown-toggle\" uib-dropdown-toggle type=button id=filterActionsMenu data-toggle=dropdown>{{::\'filterActionsButton.label\' | translate }} <span class=caret></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu aria-labelledby=filterActionsMenu><li><a class=\"filter-action cursor-pointer\" ng-click=filterActionsButton.toggleFiltersFunction()>{{::\'filterActionsButton.actions.edit\' | translate}}</a></li><li><a class=\"filter-action cursor-pointer\" ng-click=filterActionsButton.clearFunction()>{{::\'filterActionsButton.actions.clear\' | translate}}</a></li></ul></div>");
$templateCache.put("app/components/filter-bar/my-filters-button/my-filters-button.html","<div><button type=button class=\"btn btn-default btn-sm my-filters-toggle\" ng-click=\"$event.stopPropagation(); myFiltersButton.popBoxToggle()\">{{::\'myFiltersButton.buttonLabel\' | translate }}<span class=caret></span></button><pop-box name={{::myFiltersButton.popBoxName}} show-arrow=true arrow-position=80 backdrop-close=true overlay=true pop-up=true open-on-init=false close-fn=myFiltersButton.clearFn() button-close=true><div class=my-filters-list><ul class=btn-group ng-if=myFiltersButton.filterState.myFilters><li class=filter-set ng-repeat=\"(filterIndex, filterDefinition) in (myFiltersButton.filterState.myFilters | orderBy: \'value.name\')\"><button class=\"btn btn-default saved-filter truncate\" ng-disabled=myFiltersButton.isActiveFilter(filterDefinition.value.query.filterId) type=button ng-click=myFiltersButton.setActiveFilter(filterDefinition.value)>{{::filterDefinition.value.name}}</button> <button class=\"btn btn-default pull-right\" ng-click=myFiltersButton.setEditingFilter(filterDefinition.value) type=button><span class=\"fa fa-pencil\"></span></button></li></ul><div class=text-center ng-if=!myFiltersButton.filterState.myFilters.length><p>{{:: \'myFiltersButton.noSavedFilters\' | translate}}</p></div></div><div class=my-filters-actions><button class=\"btn btn-link cursor-pointer\" ng-disabled=\"!(myFiltersButton.filters | badges: myFiltersButton.filterState.ignoreForBadge)\" ng-click=myFiltersButton.toggleFiltersFunction()>{{:: \'myFiltersButton.saveCurrentFilters\' | translate}}</button> <button ng-if=myFiltersButton.filters.filterId class=\"btn btn-link cursor-pointer\" ng-click=myFiltersButton.clearFilters()>{{:: \'myFiltersButton.clearFilters\' | translate}}</button></div></pop-box></div>");
$templateCache.put("app/components/filter-bar/saved-filters/saved-filter-delete-confirmation-modal.html","<div class=modal-header><h4><span class=title>{{::\'savedFilters.delete.confirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'savedFilters.delete.confirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/filter-bar/saved-filters/saved-filters-review.html","<sliding-panel cancel-button=true button-functions=savedFiltersReview.buttonFunctions random-panel-name=savedFiltersReview.randomPanelName open-when=savedFiltersReview.openWhen titles=savedFiltersReview.titles><panel-body><div class=panel-form-content><ng-form name=savedFiltersReviewForm novalidate><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': savedFiltersReviewForm.name.$invalid && (savedFiltersReviewForm.name.$touched || workTypeForm.saveAttempt)}\" accessibility><p><em class=text-info>{{::\'savedFilters.review.instructions\' | translate}}</em></p><label for=name>{{::\'savedFilters.review.name\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=name required maxlength=50 class=form-control placeholder=\"\" ng-model=savedFiltersReview.filtersToSave.name focus-on=true><p class=text-danger ng-messages=savedFiltersReviewForm.name.$error ng-if=\"savedFiltersReviewForm.name.$touched || workTypeForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div></ng-form></div></panel-body></sliding-panel>");
$templateCache.put("app/components/filter-bar/sliding-filter-panel/sliding-filter-panel.html","<sliding-panel button-functions=slidingFilterPanel.slidingButtons cancel-button=true open-when=slidingFilterPanel.openWhen random-panel-name=slidingFilterPanel.randomPanelName><panel-header><div class=row><div class=\"col-xs-8 col-sm-10\"><h4 class=\"sliding-panel-title sliding-panel-header-text truncate\">{{::\'slidingFilterPanel.title\' | translate}}<results-message ng-if=slidingFilterPanel.displayResultsCount class=\"sliding-panel-subtitle sliding-panel-header-text\" total=slidingFilterPanel.filterState.totalCount></results-message></h4></div><div class=\"col-xs-4 col-sm-2\"><button type=button class=\"btn btn-sm btn-inverse pull-right\" ng-disabled=\"!(slidingFilterPanel.filters | badges: slidingFilterPanel.filterState.ignoreForBadge)\" ng-click=slidingFilterPanel.clearFunction()>{{::\'slidingFilterPanel.clearFilters\' | translate}}</button></div></div><h3 ng-if=slidingFilterPanel.filterState.activeSavedFilter class=\"sliding-panel-subheader sliding-panel-subtitle truncate\">{{::slidingFilterPanel.filterState.activeSavedFilter.name}}</h3></panel-header><panel-body><div class=panel-form-content ng-class=\"{\'subheader-present\' : slidingFilterPanel.filterState.activeSavedFilter}\"><div class=row><div class=col-xs-12><div class=form-group><filter-panel name=\"\'reportFiltersForm\'\" clear-filters=slidingFilterPanel.clearFilters() hide-header=true><ng-transclude></ng-transclude></filter-panel></div></div></div></div></panel-body><panel-footer><apply-split-button buttons=slidingFilterPanel.myFiltersSlidingButtons.panelOne.splitButtons></apply-split-button><button class=\"btn btn-link\" ng-click=slidingFilterPanel.myFiltersSlidingButtons.panelOne.cancelButton.handler()>{{::slidingFilterPanel.myFiltersSlidingButtons.panelOne.cancelButton.label}}</button></panel-footer></sliding-panel><saved-filters-review ng-if=!slidingFilterPanel.disableMyFilters is-new-filter=slidingFilterPanel.savedFiltersReviewNew open-when=slidingFilterPanel.savedFiltersReviewOpen filters=slidingFilterPanel.filters buttons=slidingFilterPanel.myFiltersSlidingButtons.panelTwo></saved-filters-review>");
$templateCache.put("app/components/settingsForm/accountAlertSettings/accountAlertSettings.html","<div class=\"row sub-header-container\"><div class=col-xs-12><h5 id=accountAlertSection scroll-spy-on spies=accountAlertSettings.spies spy-text=\"{{\'settingsForm.spies.alerts\' | translate}}\" spy-position=accountAlertSettings.spyPosition>{{:: \'accountAlertSettings.sectionTitle\' | translate}}</h5></div></div><div class=\"content-section account-alert-section\"><div class=\"margin-bottom-sm pull-left\"><em class=text-info>{{::\'accountAlertSettings.helperText\' | translate }}</em></div><button type=button class=\"btn btn-default pull-right\" ng-if=\"!accountAlertSettings.alertIsActive && !accountAlertSettings.isEditing\" ng-click=\"accountAlertSettings.isEditing = true\" aria-label=\"{{::\'accountAlertSettings.buttons.create\' | translate}}\">{{::\'accountAlertSettings.buttons.create\' | translate}}</button><div class=clearfix></div><form name=accountAlertSettingsForm novalidate><div class=row ng-if=\"accountAlertSettings.alertIsActive || accountAlertSettings.isEditing\"><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': accountAlertSettingsForm.alertMessage.$invalid && (accountAlertSettingsForm.alertMessage.$touched || accountAlertSettings.saveAttempt)}\"><label for=alertMessage>{{::\'accountAlertSettings.message.label\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><text-area id=alertMessage textarea-name=alertMessage ng-model=accountAlertSettings.accountAlert.message maxlength=350 is-required=true ng-if=accountAlertSettings.isEditing></text-area><p ng-if=\"accountAlertSettings.alertIsActive && !accountAlertSettings.isEditing\">{{accountAlertSettings.accountAlert.message}}</p></div></div></div><div class=row ng-if=\"accountAlertSettings.alertIsActive || accountAlertSettings.isEditing\"><div class=\"col-xs-12 col-md-6\"><div class=form-group ng-class=\"{\'has-error\': accountAlertSettingsForm.roles.$invalid && (accountAlertSettingsForm.roles.$touched || accountAlertSettings.saveAttempt)}\"><label for=alertRoles>{{::\'accountAlertSettings.roles.label\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><roles-typeahead id=alertRoles ng-model=accountAlertSettings.accountAlert.roles product-id=accountAlertSettings.productId multi-select=true ng-required=true exclude-items=accountAlertSettings.excludeItems ng-if=accountAlertSettings.isEditing></roles-typeahead><p ng-if=\"accountAlertSettings.alertIsActive && !accountAlertSettings.isEditing\">{{ accountAlertSettings.mapJoinRoles() }}</p></div></div></div></form><div class=row><div class=col-xs-12><save-button class=\"btn-link pull-left\" form=accountAlertSettingsForm click-function=accountAlertSettings.post() save-attempt=accountAlertSettings.saveAttempt ng-if=accountAlertSettings.isEditing aria-label=\"{{::\'accountAlertSettings.buttons.post\' | translate}}\" text=accountAlertSettings.postText></save-button><button type=button class=\"btn btn-link pull-left\" ng-click=accountAlertSettings.cancelEdit() ng-if=accountAlertSettings.isEditing aria-label=\"{{::\'general.actions.cancel\' | translate}}\">{{::\'general.actions.cancel\' | translate}}</button> <button type=button class=\"btn btn-sm btn-default pull-right account-alert-delete-button\" ng-click=accountAlertSettings.delete() ng-if=\"accountAlertSettings.alertIsActive && !accountAlertSettings.isEditing\" aria-label=\"{{::\'general.actions.delete\' | translate}}\"><i class=\"fa fa-trash-o\" aria-hidden=true></i></button> <button type=button class=\"btn btn-sm btn-default pull-right\" ng-click=accountAlertSettings.edit() ng-if=\"accountAlertSettings.alertIsActive && !accountAlertSettings.isEditing\" aria-label=\"{{::\'general.actions.edit\' | translate}}\"><i class=\"fa fa-pencil\" aria-hidden=true></i></button></div></div></div>");
$templateCache.put("app/components/settingsForm/accountAlertSettings/deleteConfirmModal.html","<div class=delete-alert-modal><div class=modal-header><h4><span class=title>{{::\'accountAlertSettings.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'accountAlertSettings.deleteModal.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=confirmModalController.ok()>{{::\'accountAlertSettings.buttons.delete\' | translate}}</button> <button class=\"btn btn-link\" ng-click=confirmModalController.close()>{{::\'general.actions.cancel\' | translate}}</button></div></div>");
$templateCache.put("app/components/settingsForm/registrationLink/deleteConfirmModal.html","<div class=delete-web-link-modal><div class=modal-header><h4><span class=title>{{::\'registrationLink.requesterRegistration.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'registrationLink.requesterRegistration.deleteModal.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=confirmModalController.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=confirmModalController.close()>{{::\'general.actions.no\' | translate}}</button></div></div>");
$templateCache.put("app/components/settingsForm/registrationLink/generateNewConfirmModal.html","<div class=delete-web-link-modal><div class=modal-header><h4><span class=title>{{::\'registrationLink.requesterRegistration.regenerateModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'registrationLink.requesterRegistration.regenerateModal.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=confirmModalController.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=confirmModalController.close()>{{::\'general.actions.no\' | translate}}</button></div></div>");
$templateCache.put("app/components/settingsForm/registrationLink/registrationLink.html","<div class=\"content-section registration-link\"><div class=margin-bottom-sm><em class=text-info>{{::\'registrationLink.requesterRegistration.helperText\' | translate }}</em></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=\"col-xs-1 media-left\"><div class=circle><h5>A</h5></div></div><div class=col-xs-11><strong class=media-heading>{{::\'registrationLink.requesterRegistration.share.label\' | translate }}</strong><div class=margin-bottom-sm>{{::\'registrationLink.requesterRegistration.share.subLabel\' | translate }}</div><div class=margin-bottom-sm><input disabled ng-model=registrationLink.guid class=\"box truncate\"></div><div><button class=\"btn btn-primary\" ng-click=registrationLink.copyLink() ng-if=registrationLink.guid ngclipboard data-clipboard-action=copy data-clipboard-text={{registrationLink.guid}}>{{::\'registrationLink.requesterRegistration.share.copyButton\' | translate}}</button> <button class=\"btn btn-link\" ng-click=\"registrationLink.guid ? registrationLink.regenerateGuid() : registrationLink.generateGuid()\">{{::\'registrationLink.requesterRegistration.share.generateButton\' | translate}}</button></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"col-xs-1 media-left\"><div class=circle><h5>B</h5></div></div><div class=col-xs-11><strong class=media-heading>{{::\'registrationLink.requesterRegistration.send.label\' | translate }}</strong><div>{{::\'registrationLink.requesterRegistration.send.subLabel\' | translate }}</div><div class=\"margin-bottom-sm email-text-area\"><text-area id=emails textarea-name=emails ng-model=registrationLink.emails maxlength=2000 maxlines=20></text-area><p class=text-danger ng-if=\"registrationLink.badEmails.length > 0\"><span>{{::\'registrationLink.requesterRegistration.error.emails\' | translate }}{{ registrationLink.badEmails.join(\', \') }}</span></p></div><div><button class=\"btn btn-primary\" ng-click=registrationLink.sendEmail() ng-disabled=\"registrationLink.emails.length === 0 || registrationLink.guid == \'\'\" ngclipboard data-clipboard-action=copy data-clipboard-text={{registrationLink.guid}}>{{::\'registrationLink.requesterRegistration.send.emailButton\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/components/webLinkSection/webLinkSlidingPanel/webLinkSlidingPanel.html","<sliding-panel button-functions=webLinkSlidingPanel.buttonFunctions open-when=webLinkSlidingPanel.openWhen titles=webLinkSlidingPanel.titles form=webLinkSlidingPanel.form save-attempt=webLinkSlidingPanel.saveAttempt show-navigation-warning=true><panel-body><div class=\"panel-form-content form-group web-link-sliding-panel\"><div class=row><div class=col-xs-12><em class=text-info>{{::\'webLinkSlidingPanel.formDescription\' | translate}}{{::webLinkSlidingPanel.translatedEntity}}</em></div></div><ng-form name=webLinkSlidingPanel.form><div class=row><div class=col-xs-12 ng-class=\"{\'has-error\': webLinkSlidingPanel.form.url.$invalid && (webLinkSlidingPanel.form.url.$touched || webLinkSlidingPanel.form.saveAttempt)}\"><div class=\"form-group url-input\"><label for=url>{{::\'webLinkSlidingPanel.url\' | translate}}</label><input id=url class=form-control name=url required focus-on=webLinkSlidingPanel.focusOnUrl type=text maxlength=512 ng-model=webLinkSlidingPanel.link.url ng-blur=webLinkSlidingPanel.refreshMetadata(false) ng-disabled=webLinkSlidingPanel.refreshingMetadata ng-change=webLinkSlidingPanel.updatedUrl()><p class=text-danger ng-messages=webLinkSlidingPanel.form.url.$error ng-if=\"webLinkSlidingPanel.form.url.$touched || webLinkSlidingPanel.form.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=urlValidationError>{{::\'webLinkSlidingPanel.validation.url\' | translate }}</span></p></div></div></div><hr><div class=row><div class=col-xs-12><div class=\"row container-fluid refresh-row\"><div class=\"col-xs-8 refresh-message\"><em ng-if=webLinkSlidingPanel.noDataFromUrl class=text-info>{{::\'webLinkSlidingPanel.updateData\' | translate}}</em></div><div class=\"col-xs-4 refresh-button\"><button ng-disabled=\"!webLinkSlidingPanel.link.url || webLinkSlidingPanel.invalidUrl || webLinkSlidingPanel.refreshingMetadata\" type=button ng-click=webLinkSlidingPanel.refreshMetadata(true) class=\"btn btn-default pull-right\"><i class=\"fa fa-refresh\" aria-hidden=true></i> {{::\'webLinkSlidingPanel.refresh\' | translate}}</button></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=linkname>{{::\'webLinkSlidingPanel.name\' | translate}}</label><input id=linkname class=form-control name=linkname maxlength=255 type=text focus-on=webLinkSlidingPanel.focusOnName ng-disabled=webLinkSlidingPanel.refreshingMetadata ng-model=webLinkSlidingPanel.link.title></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=linkdescription>{{::\'webLinkSlidingPanel.description\' | translate}}</label><text-area id=linkdescription textarea-name=linkdescription maxlength=512 maxlines=10 is-disabled=webLinkSlidingPanel.refreshingMetadata ng-model=webLinkSlidingPanel.link.description></text-area></div></div></div><div class=row><div class=col-xs-12><div class=\"form-group relative-position\"><label for=thumbnail>{{::\'webLinkSlidingPanel.thumbnail\' | translate}}</label><button ng-disabled=!webLinkSlidingPanel.link.thumbnail type=button class=\"btn btn-link pull-right\" ng-click=webLinkSlidingPanel.clearThumbnail()>{{::\'webLinkSlidingPanel.clear\' | translate}}</button><div><img alt={{webLinkSlidingPanel.link.title}} class=link-thumbnail ng-if=\"webLinkSlidingPanel.link.title && webLinkSlidingPanel.link.thumbnail\" ng-src={{webLinkSlidingPanel.link.thumbnail}}> <img alt=\"{{::\'webLinkSlidingPanel.altDefaultPrefix\' | translate}}{{webLinkSlidingPanel.link.thumbnail}}\" class=link-thumbnail ng-if=\"!webLinkSlidingPanel.link.title && webLinkSlidingPanel.link.thumbnail\" ng-src={{webLinkSlidingPanel.link.thumbnail}}></div><div class=\"no-thumbnail text-muted\" ng-if=\"!webLinkSlidingPanel.link.thumbnail && !webLinkSlidingPanel.link.url\">{{::\'webLinkSlidingPanel.noThumbnail\' | translate}}</div><div class=\"no-thumbnail text-muted\" ng-if=\"!webLinkSlidingPanel.link.thumbnail && webLinkSlidingPanel.link.url\">{{::\'webLinkSlidingPanel.refreshForThumbnail\' | translate}}</div></div></div></div></ng-form></div></panel-body></sliding-panel>");
$templateCache.put("app/components/workOrderForm/completion/workOrderCompletion.html","<ng-form name=completionForm><div class=\"row sub-header-container\" id=completionSection scroll-spy-on spy-text=\"{{:: \'workOrderForm.completion\' | translate}}\" spies=workOrderCompletion.spies spy-position=3><div class=col-xs-12><h5>{{::\'workOrderForm.completion\' | translate}}</h5></div></div><div class=content-section><div class=row><div class=col-xs-12><div class=form-group><label for=actionTaken>{{::\'workOrderForm.actionTaken\' | translate}}</label><text-area id=actionTaken name=actionTaken ng-model=workOrderCompletion.workOrder.actionTaken maxlength=2000 maxlines=5></text-area></div></div></div><div class=row has-markets=\"workOrderCompletion.market.mfg, workOrderCompletion.market.club, workOrderCompletion.market.other, workOrderCompletion.market.gov\"><div class=col-sm-6><label>{{::\'workOrderForm.downtime.text\' | translate}}</label><div class=row><div class=\"col-xs-6 col-sm-4\" ng-class=\"{\'has-error\': completionForm.hours.$invalid && (completionForm.hours.$touched || workOrderCompletion.saveAttempt)}\"><div class=input-group><div class=input-group-addon><span>{{::\'workOrderForm.downtime.hours\' | translate}}</span></div><number-field min=0 max=9999 name=hours ng-model=workOrderCompletion.workOrder.downtimeTracking.hours places=0 ignore-default=true></number-field></div></div><div class=\"col-xs-6 col-sm-4\" ng-class=\"{\'has-error\': completionForm.minutes.$invalid && (completionForm.minutes.$touched || workOrderCompletion.saveAttempt)}\"><div class=input-group><div class=input-group-addon><span>{{::\'workOrderForm.downtime.minutes\' | translate}}</span></div><number-field min=0 max=59 name=minutes ng-model=workOrderCompletion.workOrder.downtimeTracking.minutes places=0 ignore-default=true></number-field></div></div><div class=\"col-xs-12 visible-xs outside-validation\"><p class=text-danger ng-messages=completionForm.hours.$error ng-if=\"completionForm.hours.$touched || workOrderCompletion.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.downtime.hours.max\' | translate}} </span><span ng-message=minimum>{{::\'workOrderForm.validation.downtime.hours.min\' | translate}}</span></p><p class=text-danger ng-messages=completionForm.minutes.$error ng-if=\"completionForm.minutes.$touched || workOrderCompletion.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.downtime.minutes.max\' | translate}} </span><span ng-message=minimum>{{::\'workOrderForm.validation.downtime.minutes.min\' | translate }}</span></p></div><div class=col-sm-4 ng-class=\"{\'has-error\': completionForm.cost.$invalid && (completionForm.cost.$touched || workOrderCompletion.saveAttempt)}\"><div class=input-group><div class=input-group-addon><span>{{::\'workOrderForm.downtime.cost\' | translate}}</span></div><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i><number-field min=0 max=100000000 name=cost ng-model=workOrderCompletion.workOrder.downtimeTracking.cost places=2 ignore-default=true></number-field></div></div><div class=\"visible-xs outside-validation\"><p class=\"text-danger visible-xs\" ng-messages=completionForm.cost.$error ng-if=\"completionForm.cost.$touched || workOrderCompletion.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.downtime.cost.max\' | translate}} </span><span ng-message=minimum>{{::\'workOrderForm.validation.downtime.cost.min\' | translate}}</span></p></div></div></div><div class=\"hidden-xs outside-validation\"><p class=text-danger ng-messages=completionForm.hours.$error ng-if=\"completionForm.hours.$touched || workOrderCompletion.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.downtime.hours.max\' | translate }} </span><span ng-message=minimum>{{::\'workOrderForm.validation.downtime.hours.min\' | translate }}</span></p><p class=text-danger ng-messages=completionForm.minutes.$error ng-if=\"completionForm.minutes.$touched || workOrderCompletion.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.downtime.minutes.max\' | translate }} </span><span ng-message=minimum>{{::\'workOrderForm.validation.downtime.minutes.min\' | translate }}</span></p><p class=text-danger ng-messages=completionForm.cost.$error ng-if=\"completionForm.cost.$touched || workOrderCompletion.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.downtime.cost.max\' | translate }} </span><span ng-message=minimum>{{::\'workOrderForm.validation.downtime.cost.min\' | translate }}</span></p></div></div><div class=col-sm-6><div class=form-group><label>{{::\'workOrderForm.failureReason\' | translate}}</label><failure-reasons-dropdown ng-model=workOrderCompletion.workOrder.downtimeTracking.failureReason></failure-reasons-dropdown></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': completionForm.completionDate.$invalid}\"><label for=completionDate>{{:: \'workOrderForm.completionDate\' | translate}}</label><span class=\"label label-default\" ng-if=\"workOrderCompletion.workOrder.status == workOrderCompletion.status.complete\">{{::\'general.required\' | translate}}</span><date-time id=completionDate name=completionDate min-date=workOrderCompletion.workOrder.requestDateTime ng-model=workOrderCompletion.workOrder.completionDateTime ng-required=\"workOrderCompletion.workOrder.status == workOrderCompletion.status.complete\"></date-time><p class=text-danger ng-messages=completionForm.completionDate.$error><span ng-message=required>{{::\'general.validation.required\' | translate}}</span> <span ng-message=timeEmpty>{{::\'general.validation.timeEmpty\' | translate}}</span> <span ng-message=dateTimeBeforeMin>{{::\'workOrderForm.validation.completionDateBeforeMin\' | translate}}</span></p></div></div></div></div></ng-form>");
$templateCache.put("app/components/workOrderForm/details/statusChangeConfirmModal.html","<div class=modal-header><h4 class=title>{{::\'workOrderForm.statusChange.title\' | translate}}</h4></div><div class=modal-body><div class=error-container><p>{{::\'workOrderForm.statusChange.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=statusChangeModalController.ok()>{{::\'general.actions.ok\' | translate}}</button> <button class=\"btn btn-link\" ng-click=statusChangeModalController.close()>{{::\'general.actions.cancel\' | translate}}</button></div>");
$templateCache.put("app/components/workOrderForm/details/workOrderDetails.html","<ng-form name=detailsForm><div class=content-section><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': detailsForm.description.$invalid && (detailsForm.description.$touched || workOrderDetails.saveAttempt)}\"><label for=description>{{::\'workOrderForm.description\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><text-area id=description textarea-name=description ng-model=workOrderDetails.workOrder.description maxlength=2000 maxlines=10 is-required=true is-focused=true></text-area><p class=text-danger ng-messages=detailsForm.description.$error ng-if=\"detailsForm.description.$touched || workOrderDetails.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div><div class=row><div class=col-sm-12><div ng-if=\"workOrderDetails.workOrder.pmSchedule && workOrderDetails.workOrder.businessAsset\"><label>{{::\'workOrderForm.locationOrEquipment\' | translate}}</label><div class=read-only><span class=bulk-spacer>{{::workOrderDetails.workOrder.businessAsset.name}}</span><div class=asset-bread-crumbs-space><span class=text-muted ng-if=workOrderDetails.workOrder.businessAsset.ancestorIdPath><bread-crumbs path=\"\" root=\"\" asset=workOrderDetails.workOrder.businessAsset no-links=true inline=true></bread-crumbs></span></div></div></div><div class=form-group><div ng-if=\"!workOrderDetails.workOrder.pmSchedule || !workOrderDetails.workOrder.businessAsset\" ng-class=\"{\'has-error\': detailsForm.assets.$invalid && (detailsForm.assets.$touched || workOrderDetails.saveAttempt)}\"><label for=asset>{{::\'workOrderForm.locationOrEquipment\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><assets-typeahead ng-model=workOrderDetails.workOrder.businessAsset multi-select=false ng-required=true modal-type=workOrderDetails.modalType additional-filters=\"{isWorkOrderAsset: true}\" apply-additional-filters-to=workOrderDetails.applyAdditionalFiltersTo.dropdown browse-options=workOrderDetails.assetBrowseOptions></assets-typeahead></div><div><a ng-if=workOrderDetails.workOrder.businessAsset target=_blank ui-sref=\"secure.assetEdit({ id: workOrderDetails.workOrder.businessAsset.id })\">{{::\'workOrderForm.assetViewDetails\' | translate}} </a><span ng-if=workOrderDetails.workOrder.businessAsset.isMetered><span class=warranty-pipe>|</span> <a ng-click=workOrderDetails.openAssetMeterPanel() class=cursor-pointer><span>{{::\'workOrderForm.assetRecordUsage\' | translate}}</span> </a></span><span ng-if=\"workOrderDetails.workOrder.businessAsset && workOrderDetails.warranty\"><span class=warranty-pipe>|</span> <i class=\"fa fa-exclamation-circle text-warning\" aria-hidden=true></i> <span>{{::\'workOrderForm.assetInWarranty\' | translate}}</span></span><p class=text-danger ng-messages=detailsForm.assets.$error ng-if=\"detailsForm.assets.$touched || workOrderDetails.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div></div></div><div class=row><div class=col-sm-6 has-markets=\"workOrderDetails.market.k12, workOrderDetails.market.he, workOrderDetails.market.ips\" ng-if=!workOrderDetails.workOrder.pmSchedule><div class=form-group><label for=locationDescription>{{::\'workOrderForm.areaRoomNumber\' | translate}}</label><input id=locationDescription name=locationDescription class=form-control maxlength=50 ng-model=workOrderDetails.workOrder.locationDescription></div></div></div><hr><div class=row><div class=col-sm-6><div class=form-group><label for=status>{{::\'workOrderForm.status.text\' | translate}}</label><select id=status name=status class=form-control ng-model=workOrderDetails.workOrder.status><option value={{::workOrderDetails.status.newRequest}}>{{::\'workOrderForm.status.newRequest\' | translate}}</option><option value={{::workOrderDetails.status.workInProgress}}>{{::\'workOrderForm.status.inProgress\' | translate}}</option><option value={{::workOrderDetails.status.complete}}>{{::\'workOrderForm.status.complete\' | translate}}</option><option value={{::workOrderDetails.status.onHold}}>{{::\'workOrderForm.status.onHold\' | translate}}</option><option value={{::workOrderDetails.status.void}}>{{::\'workOrderForm.status.void\' | translate}}</option></select></div></div><div class=col-sm-6><div class=form-group><label for=priority>{{:: \'workOrderForm.priority.text\' | translate}}</label><select id=priority name=priority class=form-control ng-model=workOrderDetails.workOrder.priority><option value={{::workOrderDetails.priority.low}}>{{::\'workOrderForm.priority.low\' | translate}}</option><option value={{::workOrderDetails.priority.medium}}>{{::\'workOrderForm.priority.medium\' | translate}}</option><option value={{::workOrderDetails.priority.high}}>{{::\'workOrderForm.priority.high\' | translate}}</option><option value={{::workOrderDetails.priority.emergency}}>{{::\'workOrderForm.priority.emergency\' | translate}}</option></select></div></div></div><div class=row><div class=col-sm-6 has-markets=\"workOrderDetails.market.k12, workOrderDetails.market.he, workOrderDetails.market.ips\"><div class=form-group ng-class=\"{\'has-error\': detailsForm.workTypes.$invalid && (detailsForm.workTypes.$touched || workOrderDetails.saveAttempt)}\" accessibility><label for=workType>{{::\'workOrderForm.workType\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><work-types-dropdown ng-model=workOrderDetails.workOrder.workType filters=\"{hasParent: true, orderBy: \'Name asc\', isActive: \'true\'}\" ng-required=true></work-types-dropdown><p class=text-danger ng-messages=detailsForm.workTypes.$error ng-if=\"detailsForm.workTypes.$touched || workOrderDetails.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div></div><div class=col-sm-6><div class=form-group><label>{{::\'workOrderForm.purpose\' | translate}}</label><purposes-dropdown ng-model=workOrderDetails.workOrder.purpose></purposes-dropdown></div></div><div class=col-sm-6 has-markets=\"workOrderDetails.market.mfg, workOrderDetails.market.club, workOrderDetails.market.other, workOrderDetails.market.gov\"><div class=form-group><label>{{::\'workOrderForm.project\' | translate}}</label><projects-dropdown ng-model=workOrderDetails.workOrder.project></projects-dropdown></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label>{{::\'workOrderForm.assignedTo\' | translate}}</label><users-typeahead ng-model=workOrderDetails.workOrder.assignees multi-select=true roles=workOrderDetails.rolesNoRequester></users-typeahead></div></div><div class=\"col-xs-12 col-sm-6\" has-markets=\"workOrderDetails.market.mfg, workOrderDetails.market.club, workOrderDetails.market.other, workOrderDetails.market.gov\"><div class=form-group><label>{{::\'workOrderForm.trade\' | translate}}</label><trades-dropdown ng-model=workOrderDetails.workOrder.trade></trades-dropdown></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': detailsForm.requestDate.$invalid}\"><label for=requestDate>{{::\'workOrderForm.requestDate\' | translate}}</label><span class=\"label label-default hidden-print\">{{::\'general.required\' | translate}}</span><date-time id=requestDate name=requestDate max-date=\"workOrderDetails.workOrder.scheduledStartDate || workOrderDetails.workOrder.completionDateTime\" ng-model=workOrderDetails.workOrder.requestDateTime ng-required=true></date-time><p class=text-danger ng-messages=detailsForm.requestDate.$error><span ng-message=required>{{::\'general.validation.required\' | translate }}</span> <span ng-message=timeEmpty>{{::\'general.validation.timeEmpty\' | translate }}</span> <span ng-message=dateTimeBeforeMax>{{::\'workOrderForm.validation.requestDateAfterMax\' | translate}}</span></p></div></div><div class=col-sm-6><div class=form-group><label>{{::\'workOrderForm.requestedBy\' | translate}}</label><users-typeahead ng-model=workOrderDetails.workOrder.requestedBy multi-select=false roles=workOrderDetails.allRoles></users-typeahead></div></div></div><div class=row ng-if=!workOrderDetails.isNew><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>{{::\'workOrderForm.createdBy\' | translate}}</label><p class=read-only><span ng-if=workOrderDetails.createdBy>{{::workOrderDetails.createdBy}}</span> <span ng-if=!workOrderDetails.createdBy>{{::\'workOrderForm.systemGenerated\' | translate}}</span></p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label>{{::\'workOrderForm.createdTimeLabel\' | translate}}</label><p class=read-only><span>{{::workOrderDetails.createdTime}}</span></p></div></div></div></div></ng-form><meter-reading open-when=workOrderDetails.assetMeterPanelOpen asset=workOrderDetails.workOrder.businessAsset></meter-reading>");
$templateCache.put("app/components/workOrderForm/planning/workOrderPlanning.html","<ng-form name=planningForm><div class=\"row sub-header-container\" id=planningSection scroll-spy-on spy-text=\"{{::\'workOrderForm.planning\' | translate}}\" spies=workOrderPlanning.spies spy-position=2 ng-if=\"!workOrderPlanning.isTechnician || !workOrderPlanning.isNew\"><div class=col-xs-12><h5>{{::\'workOrderForm.planning\' | translate}}</h5></div></div><div class=content-section ng-if=\"!workOrderPlanning.isTechnician || !workOrderPlanning.isNew\"><div class=row><div class=col-sm-6 ng-class=\"{\'has-error\': planningForm.estimatedHours.$invalid && (planningForm.estimatedHours.$touched || workOrderPlanning.saveAttempt)}\"><div class=form-group><label for=estimatedHours>{{::\'workOrderForm.estimatedHours\' | translate}}</label><number-field ng-model=workOrderPlanning.workOrder.estimatedHours places=2 max=999.99 min=0 name=estimatedHours ng-if=!workOrderPlanning.isTechnician></number-field><p class=read-only ng-if=workOrderPlanning.isTechnician><span>{{::workOrderPlanning.workOrder.estimatedHours | number:2}}</span></p><p class=text-danger ng-messages=planningForm.estimatedHours.$error ng-if=\"planningForm.estimatedHours.$touched || workOrderPlanning.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.estimatedHours.max\' | translate}} </span><span ng-message=minimum>{{::\'workOrderForm.validation.estimatedHours.min\' | translate}}</span></p></div></div><div class=col-sm-6 ng-class=\"{\'has-error\': planningForm.estimatedCost.$invalid && (planningForm.estimatedCost.$touched || workOrderPlanning.saveAttempt)}\"><div class=form-group><label for=estimatedCost>{{::\'workOrderForm.estimatedCost\' | translate}}</label><div class=input-icon-begin><i class=\"fa fa-usd\" aria-hidden=true></i><number-field ng-model=workOrderPlanning.workOrder.estimatedCost max=100000000 min=0 name=estimatedCost places=2 ng-if=!workOrderPlanning.isTechnician></number-field><p class=read-only ng-if=workOrderPlanning.isTechnician><span>{{::workOrderPlanning.workOrder.estimatedCost | number:2}}</span></p></div><p class=text-danger ng-messages=planningForm.estimatedCost.$error ng-if=\"planningForm.estimatedCost.$touched || workOrderPlanning.saveAttempt\"><span ng-message=maximum>{{::\'workOrderForm.validation.estimatedCost.max\' | translate}} </span><span ng-message=minimum>{{::\'workOrderForm.validation.estimatedCost.min\' | translate}}</span></p></div></div></div><div class=row><div class=col-sm-6><div class=form-group ng-if=workOrderPlanning.canAddDueDate><label for=scheduledStart>{{::\'workOrderForm.scheduledStart\' | translate}}</label><calendar id=scheduledStart name=scheduledStart min-date=workOrderPlanning.workOrder.requestDateTime max-date=workOrderPlanning.workOrder.dueDateTime end-of-day=true allow-update=true ng-model=workOrderPlanning.workOrder.scheduledStartDate></calendar></div><div class=form-group ng-if=\"!workOrderPlanning.canAddDueDate && !workOrderPlanning.isNew\"><label>{{::\'workOrderForm.scheduledStart\' | translate}}</label><p class=read-only><span>{{workOrderPlanning.workOrder.scheduledStartDate | date: \'MM/dd/yyyy\'}}</span></p></div></div><div class=col-sm-6><div class=form-group ng-if=workOrderPlanning.canAddDueDate><label for=dueDate>{{::\'workOrderForm.dueDate\' | translate}}</label><calendar id=dueDate name=dueDate min-date=\"workOrderPlanning.workOrder.scheduledStartDate || workOrderPlanning.workOrder.requestDateTime\" end-of-day=true ng-model=workOrderPlanning.workOrder.dueDateTime></calendar></div><div class=form-group ng-if=\"!workOrderPlanning.canAddDueDate && !workOrderPlanning.isNew\"><label>{{::\'workOrderForm.dueDate\' | translate}}</label><p class=read-only><span>{{::workOrderPlanning.workOrder.dueDateTime | date: \'MM/dd/yyyy\'}}</span></p></div></div></div></div></ng-form>");
$templateCache.put("app/components/workOrderHistoryList/workOrderHistorySummary/workOrderHistorySummary.html","<div class=work-order-history-summary><div class=\"card-header hidden-xs\"><h4>{{::\'workOrderHistorySummary.workOrderID\' | translate}} {{workOrderHistorySummary.workOrder.displayId}}</h4><button class=\"btn btn-default btn-inverse text-right\" ng-click=workOrderHistorySummary.goToWorkOrder()>{{::\'workOrderHistorySummary.viewWorkOrder\' | translate}}</button></div><div class=card-body><div class=\"row visible-xs\"><div class=col-xs-12><div class=row><div class=col-xs-12><strong>{{::\'workOrderHistorySummary.user\' | translate}}</strong></div></div><div class=row><div class=col-xs-12><div ng-if=workOrderHistorySummary.activeChange.impersonatedByUser>{{::\'general.cscUser\' | translate}}</div><div ng-if=!workOrderHistorySummary.activeChange.impersonatedByUser>{{::workOrderHistorySummary.activeChange.user.firstName}} {{::workOrderHistorySummary.activeChange.user.lastName}}</div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=col-xs-12><strong>{{::\'workOrderHistorySummary.locationEquipment\' | translate}}</strong></div></div><div class=row><div class=col-xs-12>{{workOrderHistorySummary.workOrder.businessAsset.name}}</div></div><div class=row><div class=col-xs-12><bread-crumbs asset=workOrderHistorySummary.workOrder.businessAsset show-ellipsis=true></bread-crumbs></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=row><div class=col-xs-12><strong>{{::\'workOrderHistorySummary.description\' | translate}}</strong></div></div><div class=row><div class=\"col-xs-12 truncate\">{{workOrderHistorySummary.workOrder.description}}</div></div></div></div></div></div>");
$templateCache.put("app/components/workTypeList/workTypeFormPanel/workTypeDeleteConfirmModal.html","<div class=modal-header><h4><span class=title>{{::\'workTypePanel.deleteConfirm.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><p>{{::\'workTypePanel.deleteConfirm.message\' | translate}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=deleteModal.ok()>{{::\'general.actions.yes\' | translate}}</button> <button class=\"btn btn-link\" ng-click=deleteModal.close()>{{::\'general.actions.no\' | translate}}</button></div>");
$templateCache.put("app/components/workTypeList/workTypeFormPanel/workTypeDeleteWarningModal.html","<div class=modal-header><h4><span class=title>{{::\'workTypePanel.deleteModal.title\' | translate}}</span></h4></div><div class=modal-body><div class=error-container><div ng-if=\"deleteModal.workOrderCount > 0 && deleteModal.workOrderTemplateCount === 0\"><p>{{::\'workTypePanel.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{::deleteModal.workOrderCount}}&nbsp;{{::\'workTypePanel.deleteModal.workOrders\' | translate}}</strong>.</p><p>{{::\'workTypePanel.deleteModal.reassignMessageWorkOrders\' | translate}}.</p></div><div ng-if=\"deleteModal.workOrderTemplateCount > 0 && deleteModal.workOrderCount === 0\"><p>{{::\'workTypePanel.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{::deleteModal.workOrderTemplateCount}}&nbsp;{{::\'workTypePanel.deleteModal.pmSchedules\' | translate}}</strong>.</p><p>{{::\'workTypePanel.deleteModal.reassignMessagePmSchedules\' | translate}}.</p></div><div ng-if=\"deleteModal.workOrderTemplateCount > 0 && deleteModal.workOrderCount > 0\"><p>{{::\'workTypePanel.deleteModal.cannotDeleteMessage\' | translate}}<strong>{{::deleteModal.workOrderTemplateCount}}&nbsp;{{::\'workTypePanel.deleteModal.pmSchedules\' | translate}}</strong> &nbsp;{{::\'workTypePanel.deleteModal.and\' | translate}}<strong>&nbsp;{{::deleteModal.workOrderCount}}&nbsp;{{::\'workTypePanel.deleteModal.workOrders\' | translate}}</strong>.</p><p>{{::\'workTypePanel.deleteModal.reassignMessage\' | translate}}.</p></div></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=deleteModal.close()>{{::\'general.actions.ok\' | translate}}</button></div>");
$templateCache.put("app/components/workTypeList/workTypeFormPanel/workTypeFormPanel.html","<sliding-panel open-when=workTypeForm.panelOpen titles=workTypeForm.panelTitles button-functions=workTypeForm.panelFunctions save-attempt=workTypeForm.saveAttempt><panel-body><div class=panel-form-content><ng-form name=workTypePanelForm novalidate><div class=row><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': workTypePanelForm.name.$invalid && (workTypePanelForm.name.$touched || workTypeForm.saveAttempt)}\" accessibility><label for=name>{{::\'workTypeList.name\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span> <input type=text id=name name=name required maxlength=50 class=form-control placeholder=\"\" ng-model=workTypeForm.workType.name focus-on=true><p class=text-danger ng-messages=workTypePanelForm.name.$error ng-if=\"workTypePanelForm.name.$touched || workTypeForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div><div class=form-group ng-class=\"{\'has-error\': workTypePanelForm.workTypes.$invalid && (workTypePanelForm.workTypes.$touched || workTypeForm.saveAttempt)}\"><label for=category>{{::\'workTypeList.category\' | translate}}</label><span class=\"label label-default text-capitalize\">{{::\'general.validation.required\' | translate}}</span><work-types-dropdown ng-model=workTypeForm.workType.parent filters=\"{hasParent: false, orderBy: \'Parent/Name asc\'}\" ng-required=true></work-types-dropdown><p class=text-danger ng-messages=workTypePanelForm.workTypes.$error ng-if=\"workTypePanelForm.workTypes.$touched || workTypeForm.saveAttempt\"><span ng-message=required>{{::\'general.validation.required\' | translate }}</span></p></div><div class=checkbox><label><input type=checkbox name=active id=active ng-model=workTypeForm.workType.isActive pm-association-validator=workTypeForm.associations> {{::\'workTypePanel.isActive\' | translate}}</label></div><p class=text-danger ng-messages=workTypePanelForm.active.$error><span ng-message=pmAssociation>{{workTypeForm.associationsValidation}}</span></p></div></div></ng-form></div></panel-body></sliding-panel>");}]);